import { CdkTableModule } from '@angular/cdk/table';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { ComponentPortal } from '@angular/cdk/portal';
import { Overlay } from '@angular/cdk/overlay';
import { DonutGradientOrigin, DonutWidth, NgxChartsWebModule } from '@atom-platform/ngx-charts-web';
import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { DateAdapter as DateAdapter$1, MAT_DATE_FORMATS as MAT_DATE_FORMATS$1, MAT_DATE_LOCALE as MAT_DATE_LOCALE$1 } from '@angular/material/core';
import { Subject, of, BehaviorSubject } from 'rxjs';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatPaginator as MatPaginator$1 } from '@angular/material/paginator';
import { MatTableDataSource as MatTableDataSource$1 } from '@angular/material/table';
import { __values, __spread } from 'tslib';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatPaginator, MatSort, MatTableDataSource, DateAdapter as DateAdapter$2, MAT_DATE_FORMATS as MAT_DATE_FORMATS$2, MAT_DATE_LOCALE as MAT_DATE_LOCALE$2, MatTreeFlatDataSource, MatTreeFlattener, MatPaginatorIntl, MatAutocompleteModule, MatButtonModule, MatButtonToggleModule, MatCardModule, MatCheckboxModule, MatChipsModule, MatDatepickerModule, MatDialogModule, MatDividerModule, MatExpansionModule, MatFormFieldModule, MatGridListModule, MatIconModule, MatInputModule, MatListModule, MatMenuModule, MatNativeDateModule, MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule, MatRippleModule, MatSelectModule, MatSidenavModule, MatSliderModule, MatSlideToggleModule, MatSnackBarModule, MatSortModule, MatStepperModule, MatTableModule, MatTabsModule, MatToolbarModule, MatTooltipModule, MatTreeModule } from '@angular/material';
import { DatePipe, formatDate, CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders, HttpRequest, HttpEventType } from '@angular/common/http';
import { RutPipe, RutValidator, Ng2Rut } from 'ng2-rut';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, SatDatepickerModule, SatNativeDateModule } from 'saturn-datepicker';
import { Component, Inject, Injectable, NgModule, ViewChild, Pipe, Directive, ElementRef, HostListener, defineInjectable, inject } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ModuloAdquirienteWebComponent = /** @class */ (function () {
    function ModuloAdquirienteWebComponent() {
    }
    /**
     * @return {?}
     */
    ModuloAdquirienteWebComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    ModuloAdquirienteWebComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-modulo-adquiriente-web',
                    template: "<section id=\"hero-adquiriente\">\r\n  <div class=\"container\">\r\n    <div class=\"logo text-center\"></div>\r\n  </div>\r\n</section>\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-nav gestion\">\r\n      <ul class=\"nav nav-pills nav-justified\">\r\n        <li class=\"nav-item\">\r\n          <a class=\"nav-link\" [routerLink]=\"['facturacion']\" [routerLinkActive]=\"['active']\"> Facturaci\u00F3n</a>\r\n        </li>\r\n        <li class=\"nav-item\">\r\n          <a class=\"nav-link\" [routerLink]=\"['descargasList']\" [routerLinkActive]=\"['active']\"> Descargas</a>\r\n        </li>\r\n        <li class=\"nav-item disabled\">\r\n          <a class=\"nav-link\" [routerLink]=\"['cobrosList']\" [routerLinkActive]=\"['active']\"> Reporte de cobros</a>\r\n        </li>\r\n        <li class=\"nav-item disabled\">\r\n          <a class=\"nav-link\" [routerLink]=\"['empresas']\" [routerLinkActive]=\"['active']\">Admin. empresas</a>\r\n        </li>\r\n        <li class=\"nav-item\">\r\n          <a class=\"nav-link\" [routerLink]=\"['adminProcesos']\" [routerLinkActive]=\"['active']\">Report. procesos</a>\r\n        </li>\r\n        <li class=\"nav-item\">\r\n          <a class=\"nav-link\" [routerLink]=\"['convenios']\" [routerLinkActive]=\"['active']\">Admin. convenios</a>\r\n        </li>\r\n        <li class=\"nav-item disabled\">\r\n          <a class=\"nav-link disabled\" [routerLink]=\"['autorizaciones']\" [routerLinkActive]=\"['active']\">Autorizaciones</a>\r\n        </li>\r\n        <li class=\"nav-item \">\r\n          <a class=\"nav-link \" [routerLink]=\"['mandatosList']\" [routerLinkActive]=\"['active']\"> Mandatos</a>\r\n        </li>\r\n        <li class=\"nav-item \">\r\n          <a class=\"nav-link\" [routerLink]=\"['activaMandatos']\" [routerLinkActive]=\"['active']\"> Activaci\u00F3n de mandatos</a>\r\n        </li>\r\n        <li class=\"nav-item \">\r\n          <a class=\"nav-link\" [routerLink]=\"['usuarios']\" [routerLinkActive]=\"['active']\"> Usuarios</a>\r\n        </li>\r\n        <li class=\"nav-item \">\r\n          <a class=\"nav-link\" [routerLink]=\"['usuariosEmp']\" [routerLinkActive]=\"['active']\"> Usuarios Emp.</a>\r\n        </li>\r\n        <li class=\"nav-item \">\r\n          <a class=\"nav-link\" [routerLink]=\"['segList']\" [routerLinkActive]=\"['active']\"> Seguimiento de mandatos</a>\r\n        </li>\r\n        <li class=\"nav-item disabled\">\r\n          <a class=\"nav-link\" [routerLink]=\"['reportePagos']\" [routerLinkActive]=\"['active']\"> Reporte de pagos</a>\r\n        </li>\r\n        <li class=\"nav-item \">\r\n          <a class=\"nav-link \" [routerLink]=\"['dashboard']\" [routerLinkActive]=\"['active']\"> Dashboard</a>\r\n        </li>\r\n        <li class=\"nav-item \">\r\n          <a class=\"nav-link \" [routerLink]=\"['dashboardAdquirente']\" [routerLinkActive]=\"['active']\"> Dashboard</a>\r\n        </li>\r\n        <li class=\"nav-item \">\r\n          <a class=\"nav-link \" [routerLink]=\"['auditoria']\" [routerLinkActive]=\"['active']\">Auditor\u00EDa</a>\r\n        </li>\r\n        <li class=\"nav-item \">\r\n          <a class=\"nav-link \" [routerLink]=\"['politica']\" [routerLinkActive]=\"['active']\">Pol\u00EDtica</a>\r\n        </li>\r\n        <li class=\"nav-item \">\r\n          <a class=\"nav-link \" [routerLink]=\"['perfil']\" [routerLinkActive]=\"['active']\">Perfiles</a>\r\n        </li>\r\n        <li class=\"nav-item \">\r\n          <a class=\"nav-link \" [routerLink]=\"['perfilEmp']\" [routerLinkActive]=\"['active']\">Perfiles Emp.</a>\r\n        </li>\r\n        <li class=\"nav-item \">\r\n          <a class=\"nav-link \" [routerLink]=\"['susComercio']\" [routerLinkActive]=\"['active']\">Inicio de Suscripcion</a>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n    <router-outlet></router-outlet>\r\n  </div>\r\n</section>",
                    styles: ['./modulo-adquiriente-web.component.css']
                }] }
    ];
    /** @nocollapse */
    ModuloAdquirienteWebComponent.ctorParameters = function () { return []; };
    return ModuloAdquirienteWebComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmpresaResult = /** @class */ (function () {
    function EmpresaResult() {
        this.idEmpresa = 0;
        this.idFacturador = 0;
        this.codFacturador = '';
        this.nomFacturador = '';
        this.codTipoDocumento = '';
        this.descTipoDocumento = '';
        this.docFacturador = '';
        this.codRubro = '';
        this.descRubro = '';
        this.codEstadoConvenio = '';
        this.descEstadoConvenio = '';
        this.codEstadoEmpresa = '';
        this.descEstadoEmpresa = '';
        this.terminalId = '';
        this.sucursalId = '';
        this.codMastercard = '';
        this.userEmbedded = '';
        this.passEmbedded = '';
        this.idConvenio = '';
        this.descConvenio = '';
        this.emailOperador = '';
        this.razonSocial = '';
        this.orgUnitId3DS = '';
        this.apiIdentifier3DS = '';
        this.apiKey3DS = '';
        this.leyImpuesto = 0;
        this.cantMaxComTokenSuscripcion = 0;
        this.inicioSusApi = '';
    }
    return EmpresaResult;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmpresasPeticion = /** @class */ (function () {
    function EmpresasPeticion() {
        this.codCliente = '';
        this.codFacturador = '-1';
        this.nomFacturador = '-1';
        this.docEmpresa = '-1';
        this.idFacturador = -1;
        this.codEstadoConvenio = '-1';
        this.codEstadoEmpresa = '-1';
        this.codRubro = '-1';
        this.idUser = '-1';
        this.withCliente = '';
        this.filtros = [];
        this.tipoCobro = '-1';
    }
    return EmpresasPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EstadoArchivosResult = /** @class */ (function () {
    function EstadoArchivosResult() {
        this.idEstado = '';
        this.descripcion = '';
        this.codigo = '';
    }
    return EstadoArchivosResult;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AdminProcesosPeticion = /** @class */ (function () {
    function AdminProcesosPeticion() {
        this.fechaInicioIngreso = '01/01/2000';
        this.fechaFinIngreso = '01/01/2000';
        this.fechaInicioProceso = '01/01/2000';
        this.fechaFinProceso = '01/01/2000';
        this.estadoFacturacion = '-1';
        this.codtipoArchivo = '-1';
        this.idFacturador = '-1';
        this.idConvenio = '-1';
        this.codTpoPortal = '-1';
        this.codCliente = '-1';
        this.filtros = [];
    }
    return AdminProcesosPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListTipoProcesosPeticion = /** @class */ (function () {
    function ListTipoProcesosPeticion() {
        this.codigoProceso = '-1';
    }
    return ListTipoProcesosPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TipoProceso = /** @class */ (function () {
    function TipoProceso() {
        this.idProceso = "";
        this.codigoProceso = "";
        this.nombre = "";
    }
    return TipoProceso;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DescargaExcelPdfFileService = /** @class */ (function () {
    function DescargaExcelPdfFileService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlAmbiente = '';
        this.urlAmbiente = this.environment.urlAmbiente;
    }
    /**
     * @param {?} params
     * @param {?} url
     * @return {?}
     */
    DescargaExcelPdfFileService.prototype.downloadReportService = /**
     * @param {?} params
     * @param {?} url
     * @return {?}
     */
    function (params, url) {
        return this.http.request(new HttpRequest('POST', this.urlAmbiente + url, params, {
            reportProgress: true,
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Access-Control-Allow-Methods': '*',
                'Access-Control-Allow-Origin': '*'
            })
        }));
    };
    DescargaExcelPdfFileService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    DescargaExcelPdfFileService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    /** @nocollapse */ DescargaExcelPdfFileService.ngInjectableDef = defineInjectable({ factory: function DescargaExcelPdfFileService_Factory() { return new DescargaExcelPdfFileService(inject(HttpClient), inject("env")); }, token: DescargaExcelPdfFileService, providedIn: "root" });
    return DescargaExcelPdfFileService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};
var EmpresasService = /** @class */ (function () {
    function EmpresasService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlEmpresa = this.environment.urlAmbiente + '/apiEmpresaMT/listarEmpresa';
        this.urlSelectEmpresas = this.environment.urlAmbiente + '/apiEmpresaMT/selectEmpresas';
        this.urlEmpresaRubro = this.environment.urlAmbiente + '/apiEmpresaMT/listarRubro';
        this.urlEmpresaRubroByEmpresa = this.environment.urlAmbiente + '/apiEmpresaMT/listarRubroByEmpresa';
        this.urlEmpresaAgregar = this.environment.urlAmbiente + '/apiEmpresaMT/empresaAgregar';
        this.urlListaEstadosConvenios = this.environment.urlAmbiente + '/apiEmpresaMT/listarEstadosConvenio';
        this.urlListaEstadosEmpresa = this.environment.urlAmbiente + '/apiEmpresaMT/listarEstadosEmpresa';
        this.urlEmpresaActualizar = this.environment.urlAmbiente + '/apiEmpresaMT/empresaActualizar';
        this.urlEmpresaValidarConvenio = this.environment.urlAmbiente + '/apiConvenioMT/validCnv';
    }
    /**
     * @param {?} params
     * @return {?}
     */
    EmpresasService.prototype.postRubrosReport = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlEmpresaRubro, params, httpOptions);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    EmpresasService.prototype.postRubrosByEmpresaReport = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlEmpresaRubroByEmpresa, params, httpOptions);
    };
    /**
     * @return {?}
     */
    EmpresasService.prototype.postListarEstadosConvenios = /**
     * @return {?}
     */
    function () {
        return this.http.post(this.urlListaEstadosConvenios, null, httpOptions);
    };
    /**
     * @return {?}
     */
    EmpresasService.prototype.postListarEstadosEmpresa = /**
     * @return {?}
     */
    function () {
        return this.http.post(this.urlListaEstadosEmpresa, null, httpOptions);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    EmpresasService.prototype.postListarEmpresas = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlEmpresa, params, httpOptions);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    EmpresasService.prototype.postListarSelectEmpresas = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlSelectEmpresas, params, httpOptions);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    EmpresasService.prototype.postEmpresaAgregar = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlEmpresaAgregar, params, httpOptions);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    EmpresasService.prototype.postEmpresaActualizar = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlEmpresaActualizar, params, httpOptions);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    EmpresasService.prototype.postEmpresaValidarCnv = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlEmpresaValidarConvenio, params, httpOptions);
    };
    EmpresasService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    EmpresasService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    /** @nocollapse */ EmpresasService.ngInjectableDef = defineInjectable({ factory: function EmpresasService_Factory() { return new EmpresasService(inject(HttpClient), inject("env")); }, token: EmpresasService, providedIn: "root" });
    return EmpresasService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var httpOptions$1 = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};
var FacturacionHistorialService = /** @class */ (function () {
    function FacturacionHistorialService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlEstadoArchivo = this.environment.urlAmbiente + '/apiFacturasMT/estadoArchivos';
        this.urlHistorialArchivo = this.environment.urlAmbiente + '/apiFacturasMT/historialArchivos';
        this.urlAnularFactura = this.environment.urlAmbiente + '/apiFacturasMT/anularFactura';
        this.urlReutilizarTemp = this.environment.urlAmbiente + '/apiFacturasMT/listReutilizarFact';
        this.urlListReutilizarArchivos = this.environment.urlAmbiente + '/apiFacturasMT/listReutilizarArchivos';
        this.urlReutilizarDelete = this.environment.urlAmbiente + '/apiFacturasMT/reutilizarDelete';
        this.urlEstadoFacturacion = this.environment.urlAmbiente + '/apiFacturasMT/estadoFacturacion';
        this.urlEstadoCobro = this.environment.urlAmbiente + '/apiFacturasMT/estadoCobro';
        this.urlHistorialDetalle = this.environment.urlAmbiente + '/apiFacturasMT/historialDetalle';
        this.urlListaCobro = this.environment.urlAmbiente + '/apiFacturasMT/listaCobro';
        this.urlAnularCobro = this.environment.urlAmbiente + '/apiFacturasMT/anularCobro';
        this.urlApiListArchivo = this.environment.urlAmbiente + '/apiFacturasMT/listaArchivo';
        this.urlReutilizarAgregar = this.environment.urlAmbiente + '/apiFacturasMT/agregarReutilizarFact';
        this.urlListReutilizarFactDetalle = this.environment.urlAmbiente + '/apiFacturasMT/listReutilizarFactDetalle';
        this.urlCargaAddAuditoria = this.environment.urlAmbiente + '/apiFacturasMT/cargaAddAuditoria';
    }
    /**
     * @return {?}
     */
    FacturacionHistorialService.prototype.postListarEstadoArchivos = /**
     * @return {?}
     */
    function () {
        return this.http.post(this.urlEstadoArchivo, '', httpOptions$1);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionHistorialService.prototype.postHistorialArchivos = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        return this.http.post(this.urlHistorialArchivo, body, httpOptions$1);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionHistorialService.prototype.postAnularFactura = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        return this.http.post(this.urlAnularFactura, body, httpOptions$1);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionHistorialService.prototype.postReutilizarTemp = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        return this.http.post(this.urlReutilizarTemp, body, httpOptions$1);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionHistorialService.prototype.postListReutilizarArchivos = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        return this.http.post(this.urlListReutilizarArchivos, body, httpOptions$1);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionHistorialService.prototype.postReutilizarDelete = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        return this.http.post(this.urlReutilizarDelete, body, httpOptions$1);
    };
    /**
     * @return {?}
     */
    FacturacionHistorialService.prototype.postListarEstadoFacturacion = /**
     * @return {?}
     */
    function () {
        return this.http.post(this.urlEstadoFacturacion, '', httpOptions$1);
    };
    /**
     * @return {?}
     */
    FacturacionHistorialService.prototype.postListarEstadoCobro = /**
     * @return {?}
     */
    function () {
        return this.http.post(this.urlEstadoCobro, '', httpOptions$1);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionHistorialService.prototype.postHistorialDetalle = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        return this.http.post(this.urlHistorialDetalle, body, httpOptions$1);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionHistorialService.prototype.postListaCobros = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        return this.http.post(this.urlListaCobro, body, httpOptions$1);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionHistorialService.prototype.postAnularCobro = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        return this.http.post(this.urlAnularCobro, body, httpOptions$1);
    };
    /**
     * @param {?} _body
     * @return {?}
     */
    FacturacionHistorialService.prototype.postListarArchivos = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlApiListArchivo, _body, httpOptions$1);
    };
    // Reutilizar
    // Reutilizar
    /**
     * @param {?} _body
     * @return {?}
     */
    FacturacionHistorialService.prototype.postReutilizarAgregar = 
    // Reutilizar
    /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlReutilizarAgregar, _body, httpOptions$1);
    };
    /**
     * @param {?} _body
     * @return {?}
     */
    FacturacionHistorialService.prototype.postListReutilizarFactDetalle = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlListReutilizarFactDetalle, _body, httpOptions$1);
    };
    // Escribe en Log Auditoria la carga de facturacion 
    // Escribe en Log Auditoria la carga de facturacion 
    /**
     * @param {?} _body
     * @return {?}
     */
    FacturacionHistorialService.prototype.postCargaAddAuditoria = 
    // Escribe en Log Auditoria la carga de facturacion 
    /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlCargaAddAuditoria, _body, httpOptions$1);
    };
    FacturacionHistorialService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    FacturacionHistorialService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    /** @nocollapse */ FacturacionHistorialService.ngInjectableDef = defineInjectable({ factory: function FacturacionHistorialService_Factory() { return new FacturacionHistorialService(inject(HttpClient), inject("env")); }, token: FacturacionHistorialService, providedIn: "root" });
    return FacturacionHistorialService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var httpOptions$2 = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};
var AdminProcesosService = /** @class */ (function () {
    function AdminProcesosService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlListProcesos = this.environment.urlAmbiente + '/apiProcesoMT/listProcesos';
        this.urlListTipoProcesos = this.environment.urlAmbiente + '/apiProcesoMT/listTipoProcesos';
    }
    /**
     * @param {?} _body
     * @return {?}
     */
    AdminProcesosService.prototype.postListProcesos = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlListProcesos, _body, httpOptions$2);
    };
    /**
     * @param {?} _body
     * @return {?}
     */
    AdminProcesosService.prototype.postListTipoProceso = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlListTipoProcesos, _body, httpOptions$2);
    };
    AdminProcesosService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AdminProcesosService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return AdminProcesosService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoadingBaseComponent = /** @class */ (function () {
    function LoadingBaseComponent() {
    }
    /**
     * @return {?}
     */
    LoadingBaseComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    LoadingBaseComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-loading-base',
                    template: "<div class=\"custom-loader\">\r\n  <div class=\"overlay\">\r\n    <mat-progress-spinner [mode]=\"'indeterminate'\"></mat-progress-spinner>\r\n  </div>\r\n</div>\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    LoadingBaseComponent.ctorParameters = function () { return []; };
    return LoadingBaseComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoaderBaseService = /** @class */ (function () {
    function LoaderBaseService(overlay) {
        this.overlay = overlay;
        this.overlayRef = null;
    }
    /**
     * @param {?=} message
     * @return {?}
     */
    LoaderBaseService.prototype.show = /**
     * @param {?=} message
     * @return {?}
     */
    function (message) {
        // Returns an OverlayRef (which is a PortalHost)
        if (message === void 0) { message = ''; }
        if (!this.overlayRef) {
            this.overlayRef = this.overlay.create();
        }
        // Create ComponentPortal that can be attached to a PortalHost
        /** @type {?} */
        var spinnerOverlayPortal = new ComponentPortal(LoadingBaseComponent);
        /** @type {?} */
        var component = this.overlayRef.attach(spinnerOverlayPortal);
    };
    /**
     * @return {?}
     */
    LoaderBaseService.prototype.hide = /**
     * @return {?}
     */
    function () {
        if (!!this.overlayRef) {
            this.overlayRef.detach();
        }
    };
    LoaderBaseService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    LoaderBaseService.ctorParameters = function () { return [
        { type: Overlay }
    ]; };
    /** @nocollapse */ LoaderBaseService.ngInjectableDef = defineInjectable({ factory: function LoaderBaseService_Factory() { return new LoaderBaseService(inject(Overlay)); }, token: LoaderBaseService, providedIn: "root" });
    return LoaderBaseService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DialogBaseComponent = /** @class */ (function () {
    function DialogBaseComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    /**
     * @return {?}
     */
    DialogBaseComponent.prototype.onNoClick = /**
     * @return {?}
     */
    function () {
        this.dialogRef.close();
    };
    DialogBaseComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-dialog-base',
                    template: "<div class=\"custom-modals\">\r\n  <div class=\"modal-body\">\r\n    \r\n    <button class=\"close\" aria-label=\"Close\" *ngIf=\"data.showBtnCancel\" [mat-dialog-close]=\"false\">\r\n    <!--   <span aria-hidden=\"true\"><i class=\"str-icon-cerrar\"></i></span> -->\r\n    </button>\r\n     \r\n    <span class=\"icono-info\"><i class=\"str-icon-info\"></i></span>\r\n    <h3>{{data.title}}</h3>\r\n    <h4 [innerHTML]=\"data.content\"></h4>\r\n    <div class=\"buttons-container\">\r\n      <button [mat-dialog-close]=\"false\" *ngIf=\"data.showBtnCancel\" class=\"btn secundario\">Cancelar</button>&nbsp;\r\n      <button [mat-dialog-close]=\"true\" class=\"btn main\">Aceptar</button>\r\n  </div>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    DialogBaseComponent.ctorParameters = function () { return [
        { type: MatDialogRef },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
    ]; };
    return DialogBaseComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FormatoMonedaUtil = /** @class */ (function () {
    function FormatoMonedaUtil() {
    }
    //Necesita un object con tipoMoneda y Monto
    //Necesita un object con tipoMoneda y Monto
    /**
     * @param {?} result
     * @return {?}
     */
    FormatoMonedaUtil.formatearMonto = 
    //Necesita un object con tipoMoneda y Monto
    /**
     * @param {?} result
     * @return {?}
     */
    function (result) {
        /** @type {?} */
        var monto;
        //Normalizacion de lenguaje para el monto
        if (result.montoPagado) {
            monto = result.montoPagado;
        }
        if (result.montoArchivo) {
            monto = result.montoArchivo;
        }
        if (result.monto) {
            monto = result.monto;
        }
        if (result.limite) {
            monto = result.limite;
        }
        if (result.monto_cargo) {
            monto = result.monto_cargo;
        }
        if (result.tipoMoneda == 'UYU') {
            return 'UYU $' + this.separadorMiles(Math.trunc(monto / 100) + "");
        }
        if (result.tipoMoneda == 'USD') {
            if (monto == 0) {
                return 'USD $0';
            }
            monto += "";
            /** @type {?} */
            var parteEntera = monto.substring(0, monto.length - 2);
            /** @type {?} */
            var parteDecimal = monto.substring(monto.length - 2, monto.length);
            return 'USD $' + this.separadorMiles(parteEntera) + "," + parteDecimal;
        }
        return '0';
    };
    /**
     * @param {?} monto
     * @param {?} tipoMoneda
     * @return {?}
     */
    FormatoMonedaUtil.formatearMontoParam = /**
     * @param {?} monto
     * @param {?} tipoMoneda
     * @return {?}
     */
    function (monto, tipoMoneda) {
        if (tipoMoneda == 'UYU') {
            return 'UYU $' + this.separadorMiles(Math.trunc(monto / 100) + "");
        }
        if (tipoMoneda == 'USD') {
            if (monto == 0) {
                return 'USD $0';
            }
            /** @type {?} */
            var montoS = monto + "";
            /** @type {?} */
            var parteEntera = montoS.substring(0, montoS.length - 2);
            /** @type {?} */
            var parteDecimal = montoS.substring(montoS.length - 2, montoS.length);
            if (monto < 100) {
                return 'USD $0,' + monto;
            }
            return 'USD $' + this.separadorMiles(parteEntera) + "," + parteDecimal;
        }
        return "";
    };
    /**
     * @param {?} monto
     * @param {?} tipoMoneda
     * @return {?}
     */
    FormatoMonedaUtil.montoFormato = /**
     * @param {?} monto
     * @param {?} tipoMoneda
     * @return {?}
     */
    function (monto, tipoMoneda) {
        if (tipoMoneda == 'UYU') {
            if (monto == 0) {
                return '0';
            }
            return this.separadorMiles(Math.trunc(monto / 100) + "");
        }
        if (tipoMoneda == 'USD') {
            if (monto == 0) {
                return '0';
            }
            /** @type {?} */
            var montoS = monto + "";
            /** @type {?} */
            var parteEntera = montoS.substring(0, montoS.length - 2);
            /** @type {?} */
            var parteDecimal = montoS.substring(montoS.length - 2, montoS.length);
            if (monto < 100) {
                return monto;
            }
            return this.separadorMiles(parteEntera) + "," + parteDecimal;
        }
        return "";
    };
    /**
     * @param {?} num
     * @return {?}
     */
    FormatoMonedaUtil.separadorMiles = /**
     * @param {?} num
     * @return {?}
     */
    function (num) {
        /** @type {?} */
        var ret = "";
        /** @type {?} */
        var pos = num.length;
        if (pos <= 3)
            return num;
        for (var i = pos; i > 0; i -= 3) {
            ret = num.substring(i - 3, i) + "." + ret;
        }
        ret = ret.substring(0, ret.length - 1);
        return ret;
    };
    return FormatoMonedaUtil;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Globals = /** @class */ (function () {
    function Globals() {
    }
    /**
     * @param {?} codRubro
     * @return {?}
     */
    Globals.prototype.getClassRubroIcon = /**
     * @param {?} codRubro
     * @return {?}
     */
    function (codRubro) {
        /** @type {?} */
        var arrayIconClass = [
            { codRubro: 'CLUBDEPGYM', textClass: 'icon-clubes_deportivos_gimnasios' },
            { codRubro: 'EDUCACION', textClass: 'icon-educacion' },
            { codRubro: 'INMGASTCOM', textClass: 'icon-inmobiliarias_gastos_comunes' },
            { codRubro: 'INTENDENCI', textClass: 'icon-intendencias' },
            { codRubro: 'OTROS', textClass: 'icon-otros' },
            { codRubro: 'PRESTINMOB', textClass: 'icon-prestamos_inmobiliarios' },
            { codRubro: 'SALUD', textClass: 'icon-salud' },
            { codRubro: 'SEGURIDAD', textClass: 'icon-seguridad' },
            { codRubro: 'SEGUROS', textClass: 'icon-seguros' },
            { codRubro: 'SERVFUNEB', textClass: 'icon-servicios_funebres' },
            { codRubro: 'SERVPUBLI', textClass: 'icon-servicios_publicos' },
            { codRubro: 'TELEFONIA', textClass: 'icon-telefonia' },
            { codRubro: 'TVYCABLE', textClass: 'icon-icono_television_cables' }
        ];
        /** @type {?} */
        var obj = arrayIconClass.find((/**
         * @param {?} data
         * @return {?}
         */
        function (data) { return data.codRubro === codRubro; }));
        return (obj != undefined) ? obj.textClass : 'icon-otros';
    };
    /**
     * @param {?} key
     * @return {?}
     */
    Globals.prototype.getClassTarjetaIcon = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        /** @type {?} */
        var arrayIconClass = [
            { key: 'VISA', textClass: 'icon-visa' },
            { key: 'MASTERCARD', textClass: 'icon-mastercard' },
            { key: 'AMEX', textClass: 'icon-amex' },
            { key: 'MAESTRO', textClass: 'icon-maestro' }
        ];
        /** @type {?} */
        var obj = arrayIconClass.find((/**
         * @param {?} data
         * @return {?}
         */
        function (data) { return data.key === key; }));
        return (obj != undefined) ? obj.textClass : 'icon-tarjeta-unknow';
    };
    Globals.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ Globals.ngInjectableDef = defineInjectable({ factory: function Globals_Factory() { return new Globals(); }, token: Globals, providedIn: "root" });
    return Globals;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0 = MAT_MOMENT_DATE_FORMATS;
//declare var $: any;
var AdminProcesosComponent = /** @class */ (function () {
    function AdminProcesosComponent(phttp, fachistservice, phttpe, globals, phttpd, loader, dialog, formBuilder, datepipe, environment) {
        this.phttp = phttp;
        this.fachistservice = fachistservice;
        this.phttpe = phttpe;
        this.globals = globals;
        this.phttpd = phttpd;
        this.loader = loader;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.datepipe = datepipe;
        this.environment = environment;
        //calendar{
        //selectedProcessLabel: string = '';
        //selectedResponseLabel: string = '';
        //Proceso
        this.fechaInicioProceso = '01/01/2000';
        this.fechaFinProceso = '01/01/2000';
        //Respuesta
        this.fechaInicioRespuesta = '01/01/2000';
        this.fechaFinRespuesta = '01/01/2000';
        //modalItem: String = "";
        //modalTarget: String = "";
        //inlineDate: any;
        //inlineDateTime: any;
        this.filtroFechaI = null;
        this.vistaIdProceso = 'Todos';
        this.vistaEmpresa = 'Todos';
        this.vistaEstado = 'Todos';
        this.size = 0;
        this.peticionReport = new AdminProcesosPeticion();
        this.peticionTipoProceso = new ListTipoProcesosPeticion();
        this.resultadoEstado = [];
        this.resultadoEmpresa = [];
        this.peticionEmpresa = new EmpresasPeticion();
        this.comboComercio = false;
        this.mensajeError = -1;
        this.isCollapsed = false;
        this.consulta = -1;
        this.hashCaminoMiga = [];
        /** @type {?} */
        var fecha = new Date();
        /** @type {?} */
        var mañana = fecha.setDate(fecha.getDate() + 1);
        /** @type {?} */
        var fechaFormat = this.datepipe.transform(mañana, 'yyyy-MM-dd');
        this.unavailabilityForm = this.formBuilder.group({
            endDate: [fechaFormat + 'T00:00:00.000Z']
        });
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idEmpresaPac = this.userPerfil.empresa.idEmpresaPac;
        /* this.codTpoPortal = 'ADQUIRENTE';
        this.idEmpresaPac = '0'; */
    }
    /**
     * @return {?}
     */
    AdminProcesosComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (sessionStorage.getItem('componenteHijo') != 'adminProcesosDetalles') {
            sessionStorage.removeItem('indice');
        }
        this.fechaInicioProceso = '01/01/2000';
        this.fechaFinProceso = '01/01/2000';
        this.formGroup = new FormGroup({
            codigoProceso: new FormControl('-1'),
            estadoProceso: new FormControl('-1'),
            idFacturador: new FormControl('-1' + ',' + '-1'),
            fechaProceso: new FormControl()
        });
        if (this.codTpoPortal == 'COMERCIO') {
            this.comboComercio = false;
            this.displayedColumns = ['fechaProceso', 'idArchivo', 'dscTipoArchivo', 'nombreArchivo', 'cantidadRegistros', 'montoArchivo', 'fec_respuesta', 'dscEstado', 'detalle'];
            this.peticionReport.idFacturador = this.idEmpresaPac;
        }
        else {
            this.comboComercio = true;
            this.displayedColumns = ['fechaProceso', 'idArchivo', 'dscTipoArchivo', 'nombreFacturador', 'nombreArchivo', 'cantidadRegistros', 'montoArchivo', 'fec_respuesta', 'dscEstado', 'detalle'];
            this.peticionReport.idFacturador = '-1';
            this.peticionEmpresa.codCliente = this.environment.codCliente;
            this.peticionEmpresa.codEstadoConvenio = 'HBL';
            this.postSentEmpresaServices(this.peticionEmpresa);
            //this.postSentSelectEmpresaServices(this.peticionEmpresa);
        }
        this.consulta = -1;
        this.postSentEstadoServices();
        this.peticionTipoProceso.codigoProceso = '-1';
        this.postListTipoProcesoService(this.peticionTipoProceso);
        if (sessionStorage.getItem('componenteHijo') == 'adminProcesosDetalles') {
            this.consulta = 0;
            /** @type {?} */
            var llamadaPadre = JSON.parse(sessionStorage.getItem('llamadaPadre'));
            console.log('llamadaPadre: ', llamadaPadre);
            // Llena los filtros
            this.formGroup.controls['fechaProceso'].setValue(llamadaPadre.filtroFechaI);
            console.log(this.formGroup.get('fechaProceso').value);
            this.fechaInicioProceso = llamadaPadre.fechaInicioProceso;
            this.fechaFinProceso = llamadaPadre.fechaFinProceso;
            this.formGroup.controls['codigoProceso'].setValue(llamadaPadre.codtipoArchivo);
            this.formGroup.controls['estadoProceso'].setValue(llamadaPadre.estadoFacturacion);
            this.formGroup.controls['idFacturador'].setValue(llamadaPadre.idFacturador + ',' + llamadaPadre.idConvenio);
            // Llena camino de migas
            /** @type {?} */
            var migasPadre = JSON.parse(sessionStorage.getItem('migasPadre'));
            this.vistaIdProceso = migasPadre.codigoProceso;
            this.vistaEstado = migasPadre.estadoProceso;
            this.hashCaminoMiga[0] = { title: 'Fecha Proceso', text: migasPadre.fechaProceso };
            this.hashCaminoMiga[1] = { title: 'Procesos', text: migasPadre.codigoProceso };
            this.hashCaminoMiga[2] = { title: 'Estado', text: migasPadre.estadoProceso };
            if (this.codTpoPortal != 'COMERCIO') {
                this.vistaEmpresa = migasPadre.facturador;
                this.hashCaminoMiga[3] = { title: 'Empresa', text: migasPadre.facturador };
            }
            // Llama al servicio
            this.peticionReport.codTpoPortal = llamadaPadre.codTpoPortal;
            this.peticionReport.fechaInicioProceso = llamadaPadre.fechaInicioProceso;
            this.peticionReport.fechaFinProceso = llamadaPadre.fechaFinProceso;
            this.peticionReport.fechaInicioIngreso = llamadaPadre.fechaInicioIngreso;
            this.peticionReport.fechaFinIngreso = llamadaPadre.fechaFinIngreso;
            this.peticionReport.codtipoArchivo = llamadaPadre.codtipoArchivo;
            this.peticionReport.estadoFacturacion = llamadaPadre.estadoFacturacion;
            this.peticionReport.idFacturador = llamadaPadre.idFacturador;
            this.peticionReport.idConvenio = llamadaPadre.idConvenio;
            this.peticionReport.codCliente = this.environment.codCliente;
            this.postListProcesosServices(this.peticionReport);
        }
        else {
            this.setInitialBreadcrumbs();
        }
    };
    /**
     * @return {?}
     */
    AdminProcesosComponent.prototype.setInitialBreadcrumbs = /**
     * @return {?}
     */
    function () {
        this.hashCaminoMiga[0] = { title: 'Fecha Proceso', text: 'Todos' };
        this.hashCaminoMiga[1] = { title: 'Procesos', text: 'Todos' };
        this.hashCaminoMiga[2] = { title: 'Estado', text: 'Todos' };
        if (this.codTpoPortal != 'COMERCIO') {
            this.hashCaminoMiga[3] = { title: 'Empresa', text: 'Todas' };
        }
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    AdminProcesosComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.consulta = 0;
        this.peticionReport.codTpoPortal = this.codTpoPortal;
        /*  this.peticionReport.fechaInicioProceso = this.fechaInicioProceso;
         this.peticionReport.fechaFinProceso = this.fechaFinProceso;
         this.peticionReport.fechaInicioIngreso = this.fechaInicioRespuesta;
         this.peticionReport.fechaFinIngreso = this.fechaFinRespuesta;
     
         if (this.selectedProcessLabel == null || this.selectedProcessLabel == '') {
           this.hashCaminoMiga[0] = { title: 'Fecha Proceso', text: 'Todos' };
         } else {
           this.hashCaminoMiga[0] = { title: 'Fecha Proceso', text: this.selectedProcessLabel };
         } */
        this.filtroFechaI = this.formGroup.get('fechaProceso').value;
        console.log(this.filtroFechaI);
        if (this.formGroup.get('fechaProceso').value != null) {
            this.peticionReport.fechaInicioProceso = formatDate(this.filtroFechaI.begin, 'dd/MM/yyyy', 'en-US');
            this.peticionReport.fechaFinProceso = formatDate(this.filtroFechaI.end, 'dd/MM/yyyy', 'en-US');
            this.hashCaminoMiga[0] = { title: 'Fecha Proceso', text: this.fechaInicioProceso + ' - ' + this.fechaFinProceso };
        }
        else {
            this.hashCaminoMiga[0] = { title: 'Fecha Proceso', text: 'Todos' };
            this.peticionReport.fechaInicioProceso = this.fechaInicioProceso;
            this.peticionReport.fechaFinProceso = this.fechaFinProceso;
        }
        if (this.formGroup.get('codigoProceso').value == '-1') {
            this.peticionReport.codtipoArchivo = '-1';
            this.hashCaminoMiga[1] = { title: 'Proceso', text: 'Todos' };
        }
        else {
            this.peticionReport.codtipoArchivo = this.formGroup.get('codigoProceso').value;
            this.hashCaminoMiga[1] = { title: 'Proceso', text: this.vistaIdProceso };
        }
        if (this.formGroup.get('estadoProceso').value == '-1') {
            this.peticionReport.estadoFacturacion = '-1';
            this.hashCaminoMiga[2] = { title: 'Estado', text: 'Todos' };
        }
        else {
            this.peticionReport.estadoFacturacion = this.formGroup.get('estadoProceso').value;
            this.hashCaminoMiga[2] = { title: 'Estado', text: this.vistaEstado };
        }
        if (this.codTpoPortal == 'COMERCIO') {
            this.peticionReport.idFacturador = this.idEmpresaPac;
        }
        else {
            /** @type {?} */
            var idFacturador = this.formGroup.get('idFacturador').value.split(",")[0];
            if (idFacturador == null || idFacturador == '' || idFacturador == -1) {
                this.peticionReport.idFacturador = '-1';
                this.peticionReport.idConvenio = '-1';
                this.hashCaminoMiga[3] = { title: 'Empresa', text: 'Todas' };
            }
            else {
                this.peticionReport.idFacturador = this.formGroup.get('idFacturador').value.split(",")[0];
                this.peticionReport.idConvenio = this.formGroup.get('idFacturador').value.split(",")[1];
                this.hashCaminoMiga[3] = { title: 'Empresa', text: this.vistaEmpresa };
            }
        }
        console.log(this.peticionReport);
        sessionStorage.setItem('llamadaPadre', JSON.stringify({
            codTpoPortal: this.peticionReport.codTpoPortal,
            fechaInicioProceso: this.peticionReport.fechaInicioProceso,
            fechaFinProceso: this.peticionReport.fechaFinProceso,
            fechaInicioIngreso: this.peticionReport.fechaInicioIngreso,
            fechaFinIngreso: this.peticionReport.fechaFinIngreso,
            codtipoArchivo: this.peticionReport.codtipoArchivo,
            estadoFacturacion: this.peticionReport.estadoFacturacion,
            idFacturador: this.peticionReport.idFacturador,
            idConvenio: this.peticionReport.idConvenio,
            filtroFechaI: this.filtroFechaI
        }));
        sessionStorage.setItem('migasPadre', JSON.stringify({
            fechaProceso: this.hashCaminoMiga[0].text,
            codigoProceso: this.hashCaminoMiga[1].text,
            estadoProceso: this.hashCaminoMiga[2].text,
            facturador: (this.codTpoPortal != 'COMERCIO' ? this.hashCaminoMiga[3].text : '')
        }));
        if (tipo == 'excel' || tipo == 'pdf') {
            this.peticionReport.filtros = this.hashCaminoMiga;
            this.postDownloadReportFile(this.peticionReport, tipo);
        }
        else {
            this.peticionReport.codCliente = this.environment.codCliente;
            this.postListProcesosServices(this.peticionReport);
        }
    };
    /* ngDoCheck() {
      if(this.dataSource != null){
        console.log('Total Páginas: ', this.dataSource.paginator.getNumberOfPages() -1);
        console.log('Página actual: ', this.dataSource.paginator.pageIndex);
      }
    } */
    /* ngDoCheck() {
        if(this.dataSource != null){
          console.log('Total Páginas: ', this.dataSource.paginator.getNumberOfPages() -1);
          console.log('Página actual: ', this.dataSource.paginator.pageIndex);
        }
      } */
    /**
     * @param {?} event
     * @return {?}
     */
    AdminProcesosComponent.prototype.onPaginateChange = /* ngDoCheck() {
        if(this.dataSource != null){
          console.log('Total Páginas: ', this.dataSource.paginator.getNumberOfPages() -1);
          console.log('Página actual: ', this.dataSource.paginator.pageIndex);
        }
      } */
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var indice = this.paginator.pageIndex;
        sessionStorage.setItem('indice', indice);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    AdminProcesosComponent.prototype.postListProcesosServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.show = true;
        this.phttp.postListProcesos(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.size = data.resultado.length;
                if (_this.paginator != undefined && sessionStorage.getItem('componenteHijo') == 'adminProcesosDetalles') {
                    _this.paginator.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indice')))));
                }
                else if (_this.paginator != undefined) {
                    _this.paginator.pageIndex = 0;
                    sessionStorage.removeItem("indice");
                }
                sessionStorage.removeItem('componenteHijo');
                _this.dataSource = new MatTableDataSource(data.resultado);
                _this.dataSource.paginator = _this.paginator;
                _this.dataSource.sort = _this.sort;
                /* if (sessionStorage.getItem('componenteHijo') == 'adminProcesosDetalles') {
                  if(this.dataSource != null){
                    var componenteHijoIndex = sessionStorage.getItem('componenteHijoIndex');
                    let index: number = this.dataSource.data.findIndex(d => d['idArchivo'] == componenteHijoIndex);
                    console.log((Math.trunc((index) / 10)));
                    this.dataSource.paginator.pageIndex = (Math.trunc((index) / 10));
                  }
                } */
                if (_this.size == 0) {
                    _this.show = false;
                    _this.isCollapsed = false;
                }
                else {
                    _this.isCollapsed = true;
                }
                _this.mensajeError = 0;
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.loader.hide();
                _this.mensajeError = 1;
                console.log('Error: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            _this.loader.hide();
            _this.mensajeError = 1;
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    AdminProcesosComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.phttpe.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var emp = new EmpresaResult();
                emp.idFacturador = -1;
                emp.idConvenio = '-1';
                emp.nomFacturador = "Todas";
                data.resultado.splice(0, 0, emp);
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.error('Error postSentEmpresaServices', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postSentEmpresaServices', err);
        }));
    };
    // postSentSelectEmpresaServices(body: EmpresasPeticion) {
    //   this.phttpe.postListarSelectEmpresas(body).subscribe(data => {
    //     if (data.codret == '0') {
    //       let emp : EmpresaResult = new EmpresaResult();
    //       emp.nomFacturador="Todas";
    //       emp.idFacturador=-1;
    //       data.resultado.splice(0,0,emp);
    //       this.resultadoEmpresa = [];
    //       this.resultadoEmpresa = data.resultado;
    //     } else {
    //       console.log('Error: ', 'postListarSelectEmpresas ' + data.descret);
    //     }
    //   }, err => {
    //     console.error("Error postListarSelectEmpresas: ", err);
    //   });
    // }
    // postSentSelectEmpresaServices(body: EmpresasPeticion) {
    //   this.phttpe.postListarSelectEmpresas(body).subscribe(data => {
    //     if (data.codret == '0') {
    //       let emp : EmpresaResult = new EmpresaResult();
    //       emp.nomFacturador="Todas";
    //       emp.idFacturador=-1;
    //       data.resultado.splice(0,0,emp);
    //       this.resultadoEmpresa = [];
    //       this.resultadoEmpresa = data.resultado;
    //     } else {
    //       console.log('Error: ', 'postListarSelectEmpresas ' + data.descret);
    //     }
    //   }, err => {
    //     console.error("Error postListarSelectEmpresas: ", err);
    //   });
    // }
    /**
     * @param {?} body
     * @return {?}
     */
    AdminProcesosComponent.prototype.postListTipoProcesoService = 
    // postSentSelectEmpresaServices(body: EmpresasPeticion) {
    //   this.phttpe.postListarSelectEmpresas(body).subscribe(data => {
    //     if (data.codret == '0') {
    //       let emp : EmpresaResult = new EmpresaResult();
    //       emp.nomFacturador="Todas";
    //       emp.idFacturador=-1;
    //       data.resultado.splice(0,0,emp);
    //       this.resultadoEmpresa = [];
    //       this.resultadoEmpresa = data.resultado;
    //     } else {
    //       console.log('Error: ', 'postListarSelectEmpresas ' + data.descret);
    //     }
    //   }, err => {
    //     console.error("Error postListarSelectEmpresas: ", err);
    //   });
    // }
    /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.phttp.postListTipoProceso(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var tipoProceso = new TipoProceso();
                tipoProceso.idProceso = "-1";
                tipoProceso.codigoProceso = '-1';
                tipoProceso.nombre = "Todos";
                data.resultado.splice(0, 0, tipoProceso);
                _this.resultadoTipoProceso = [];
                _this.resultadoTipoProceso.push(data.resultado);
            }
            else {
                console.error('Error postListTipoProcesoService', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postListTipoProcesoService', err);
        }));
    };
    /**
     * @return {?}
     */
    AdminProcesosComponent.prototype.postSentEstadoServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.fachistservice.postListarEstadoArchivos().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var starchivos = new EstadoArchivosResult();
                starchivos.codigo = '-1';
                starchivos.descripcion = 'Todos';
                starchivos.idEstado = '-1';
                data.resultado.splice(0, 0, starchivos);
                _this.resultadoEstado = data.resultado;
            }
            else {
                console.error('Error postSentEstadoServices', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postSentEstadoServices', err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AdminProcesosComponent.prototype.onIdProcesoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaIdProceso = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AdminProcesosComponent.prototype.onEmpresaSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEmpresa = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AdminProcesosComponent.prototype.onEstadoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEstado = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    AdminProcesosComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiProcesoMT/listProcesos/' + tipo;
        this.phttpd.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'reporteProcesos' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'reporteProcesos' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /* showModal(item: any, modal: any): void {
      if (item) {
        this.modalItem = item;
      }
      this.modalTarget = modal.getAttribute('data-target');
      $(this.modalTarget).modal('show');
    }
   */
    /* hideModal(): void {
      $(this.modalTarget).modal('hide');
    } */
    /* choosedDateP(e) {
      this.inlineDate = e;
      this.selectedProcessLabel = this.inlineDate.chosenLabel;
      this.fechaInicioProceso = this.inlineDate.startDate.format('DD/MM/YYYY');
      this.fechaFinProceso = this.inlineDate.endDate.format('DD/MM/YYYY');
    }
  
    choosedDateR(e) {
      this.inlineDateTime = e;
      this.selectedResponseLabel = this.inlineDateTime.chosenLabel;
      this.fechaInicioRespuesta = this.inlineDateTime.startDate.format('DD/MM/YYYY');
      this.fechaFinRespuesta = this.inlineDateTime.endDate.format('DD/MM/YYYY');
    } */
    /* showModal(item: any, modal: any): void {
        if (item) {
          this.modalItem = item;
        }
        this.modalTarget = modal.getAttribute('data-target');
        $(this.modalTarget).modal('show');
      }
     */
    /* hideModal(): void {
        $(this.modalTarget).modal('hide');
      } */
    /* choosedDateP(e) {
        this.inlineDate = e;
        this.selectedProcessLabel = this.inlineDate.chosenLabel;
        this.fechaInicioProceso = this.inlineDate.startDate.format('DD/MM/YYYY');
        this.fechaFinProceso = this.inlineDate.endDate.format('DD/MM/YYYY');
      }
    
      choosedDateR(e) {
        this.inlineDateTime = e;
        this.selectedResponseLabel = this.inlineDateTime.chosenLabel;
        this.fechaInicioRespuesta = this.inlineDateTime.startDate.format('DD/MM/YYYY');
        this.fechaFinRespuesta = this.inlineDateTime.endDate.format('DD/MM/YYYY');
      } */
    /**
     * @return {?}
     */
    AdminProcesosComponent.prototype.limpiar = /* showModal(item: any, modal: any): void {
        if (item) {
          this.modalItem = item;
        }
        this.modalTarget = modal.getAttribute('data-target');
        $(this.modalTarget).modal('show');
      }
     */
    /* hideModal(): void {
        $(this.modalTarget).modal('hide');
      } */
    /* choosedDateP(e) {
        this.inlineDate = e;
        this.selectedProcessLabel = this.inlineDate.chosenLabel;
        this.fechaInicioProceso = this.inlineDate.startDate.format('DD/MM/YYYY');
        this.fechaFinProceso = this.inlineDate.endDate.format('DD/MM/YYYY');
      }
    
      choosedDateR(e) {
        this.inlineDateTime = e;
        this.selectedResponseLabel = this.inlineDateTime.chosenLabel;
        this.fechaInicioRespuesta = this.inlineDateTime.startDate.format('DD/MM/YYYY');
        this.fechaFinRespuesta = this.inlineDateTime.endDate.format('DD/MM/YYYY');
      } */
    /**
     * @return {?}
     */
    function () {
        this.peticionReport.codtipoArchivo = '-1';
        this.peticionReport.estadoFacturacion = '-1';
        //this.selectedProcessLabel = ""; //span
        //this.selectedResponseLabel = ""; //span
        //Proceso
        this.fechaInicioProceso = '01/01/2000';
        this.fechaFinProceso = '01/01/2000';
        this.peticionReport.idFacturador = '-1';
        this.peticionReport.idConvenio = '-1';
        //Respuesta
        this.fechaInicioRespuesta = '01/01/2000';
        this.fechaFinRespuesta = '01/01/2000';
        this.formGroup.get('fechaProceso').setValue(null);
        this.filtroFechaI = null;
        this.formGroup.controls.estadoProceso.setValue('-1');
        this.formGroup.controls.idFacturador.reset('-1' + ',' + '-1');
        this.formGroup.controls.codigoProceso.setValue('-1');
        this.dataSource = new MatTableDataSource([]);
        this.setInitialBreadcrumbs();
        this.show = false;
        this.size = 0;
        this.mensajeError = -1;
        this.consulta = -1;
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    AdminProcesosComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AdminProcesosComponent.prototype.selectFecha = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.fechaInicioProceso = formatDate(event.value.begin, 'dd/MM/yyyy', 'en-US');
        this.fechaFinProceso = formatDate(event.value.end, 'dd/MM/yyyy', 'en-US');
    };
    /**
     * @return {?}
     */
    AdminProcesosComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.onSubmit('');
        }
    };
    /**
     * @param {?} resul
     * @return {?}
     */
    AdminProcesosComponent.prototype.formateandoMonto = /**
     * @param {?} resul
     * @return {?}
     */
    function (resul) {
        return FormatoMonedaUtil.formatearMonto(resul);
    };
    /**
     * @return {?}
     */
    AdminProcesosComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('componenteHijo');
    };
    /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    AdminProcesosComponent.prototype.getEmpresaConvenio = /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    function (nomFacturador, descConvenio) {
        return descConvenio != "" ? nomFacturador + ": " + descConvenio : nomFacturador;
    };
    AdminProcesosComponent.decorators = [
        { type: Component, args: [{
                    selector: 'adminProcesos',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <!--h3 class=\"titulo-seccion\">Reporte de cobros</h3-->\r\n    <div class=\"modulo-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n      </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"formGroup\" autocomplete=\"off\">\r\n              <div class=\"form-row align-left\">\r\n                <div class=\"col-md-6\">\r\n                  <div class=\"filtro-fecha\">\r\n                    <button type=\"button\" class=\"btn fecha\" (click)=\"picker2.open()\"><i class=\"str-icon-calendario\"></i> Buscar por fecha de proceso\r\n                      <ng-container *ngIf=\"this.formGroup.get('fechaProceso').value != null && this.fechaInicioProceso != '01/01/2000'\">\r\n                        <span>{{ this.fechaInicioProceso + ' - ' + this.fechaFinProceso }}</span>\r\n                      </ng-container>\r\n                    </button>\r\n                    <mat-form-field style=\"display: none;\">\r\n                      <input matInput placeholder=\"Fecha\" [max]=\"unavailabilityForm.controls.endDate.value\" [satDatepicker]=\"picker2\" formControlName=\"fechaProceso\" (dateInput)=\"selectFecha($event)\">\r\n                      <sat-datepicker-toggle matSuffix [for]=\"picker2\"></sat-datepicker-toggle>\r\n                      <sat-datepicker touchUi #picker2 [rangeMode]=\"true\" [selectFirstDateOnClose]=\"true\"></sat-datepicker>\r\n                    </mat-form-field>\r\n                    <!-- <div class=\"btn fecha\" id=\"selectorFecha\" data-toggle=\"modal\" data-target=\"#fechaProcesoModal\" #fechaProcesoModal (click)=\"showModal('', fechaProcesoModal)\">\r\n                      <i class=\"str-icon-calendario\"></i>\r\n                      <ng-container *ngIf=\"selectedProcessLabel !== null && selectedProcessLabel !== ''; else noSelectedProcessLabel\">\r\n                        <span>: {{ selectedProcessLabel }}</span>\r\n                      </ng-container>\r\n                      <ng-template #noSelectedProcessLabel>\r\n                        <span> Buscar por fecha de proceso</span>\r\n                      </ng-template>\r\n                    </div> -->\r\n                  </div>\r\n                </div>\r\n                <!-- <div class=\"col-md-6\">\r\n                  <div class=\"filtro-fecha\">\r\n                    <div class=\"btn fecha\" id=\"selectorFecha\" data-toggle=\"modal\" data-target=\"#fechaRespuestaModal\"\r\n                      #fechaRespuestaModal (click)=\"showModal('',fechaRespuestaModal)\">\r\n                      <i class=\"str-icon-calendario\"></i>\r\n                      <ng-container\r\n                        *ngIf=\"selectedResponseLabel !== null && selectedResponseLabel !== ''; else noSelectedResponseLabel\">\r\n                        <span>: {{ selectedResponseLabel }}</span>\r\n                      </ng-container>\r\n                      <ng-template #noSelectedResponseLabel>\r\n                        <span> Buscar por fecha de respuesta</span>\r\n                      </ng-template>\r\n                    </div>\r\n                  </div>\r\n                </div> -->\r\n              </div>\r\n              <div class=\"form-row\">\r\n                <div class=\"form-group col-sm\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Proceso\" formControlName=\"codigoProceso\" (selectionChange)=\"onIdProcesoSelect($event)\">\r\n                      <section *ngFor=\"let resp of resultadoTipoProceso\">\r\n                        <mat-option *ngFor=\"let proceso of resp\" [value]=\"proceso.codigoProceso\">{{proceso.nombre}}</mat-option>\r\n                      </section>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-sm\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Estado de Proceso\" formControlName=\"estadoProceso\" (selectionChange)=\"onEstadoSelect($event)\">\r\n                      <mat-option *ngFor=\"let estado of resultadoEstado\" [value]=\"estado.codigo\">{{estado.descripcion}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-sm-4\" *ngIf=\"comboComercio\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"idFacturador\" (selectionChange)=\"onEmpresaSelect($event)\">\r\n                      <mat-option class=\"multiline-mat-option\" *ngFor=\"let comercio of resultadoEmpresa\" [value]=\"comercio.idFacturador + ',' + comercio.idConvenio\"> {{getEmpresaConvenio(comercio.nomFacturador, comercio.descConvenio)}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"actions\">\r\n                <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\" (click)=\"validarForm()\">Filtrar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"resultados-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-10\">\r\n          <div class=\"tags row\">\r\n            <div *ngFor=\"let entry of hashCaminoMiga\" class=\"item\">{{entry.title}}: {{entry.text}}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n          <div class=\"numero-resultados\">\r\n            <strong>{{ (size == 1) ? ( size + \" Resultado\") : size + \" Resultados\" }}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-container table-responsive-md\">\r\n        <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n          <ng-container matColumnDef=\"idArchivo\">\r\n            <th mat-header-cell *matHeaderCellDef>ID Proceso</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.idArchivo}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"dscTipoArchivo\">\r\n            <th mat-header-cell *matHeaderCellDef>Proceso</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.dscTipoArchivo}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"nombreFacturador\" *ngIf=\"comboComercio\">\r\n            <th mat-header-cell *matHeaderCellDef>Empresa</th>\r\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\"> {{ (resultado.nombreFacturador !== '-') ? (getEmpresaConvenio(resultado.nombreFacturador, resultado.cnvDescrip)) : '-'}}</td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"nombreArchivo\">\r\n            <th mat-header-cell *matHeaderCellDef>Nombre</th>\r\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\"> {{resultado.nombreArchivo}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"cantidadRegistros\">\r\n            <th mat-header-cell *matHeaderCellDef>Cant. Registros</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.cantidadRegistros}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"montoArchivo\">\r\n            <th mat-header-cell *matHeaderCellDef>Monto</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">{{formateandoMonto(resultado)}}</td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fechaProceso\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha Ingreso</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              {{ (resultado.fechaIngreso != null) ? (resultado.fechaIngreso | date: 'dd/MM/yyyy') : \"-\" }} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fec_respuesta\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha Proceso</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              {{ (resultado.fechaProceso != null) ? (resultado.fechaProceso | date: 'dd/MM/yyyy') : \"-\" }} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"dscEstado\">\r\n            <th mat-header-cell *matHeaderCellDef>Estado</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.dscEstado}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"detalle\">\r\n            <th mat-header-cell *matHeaderCellDef>Detalle</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a [routerLink]=\"['../adminProcesosDetalles']\" [queryParams]=\"{\r\n                    'p':resultado.idArchivo,\r\n                    'c':resultado.cantidadRegistros,\r\n                    'n':resultado.nombreArchivo,\r\n                    'fi':resultado.fechaIngreso,\r\n                    'fp':resultado.fechaProceso,\r\n                    'de':resultado.dscEstado,\r\n                    'acv':resultado.arcCanVal,\r\n                    'acu':resultado.arcCanUpd,\r\n                    'ace':resultado.arcCanErr,\r\n                    'dta':resultado.codTipoArchivo\r\n                  }\"><i class=\"str-icon-flecha-derecha\"></i></a>\r\n            </td>\r\n          </ng-container>\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n        </table>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" (page)=\"onPaginateChange($event)\" showFirstLastButtons></mat-paginator>\r\n      </div>\r\n      <div class=\"box-actions\" *ngIf=\"size > 0\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6 item\">\r\n            <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n          </div>\r\n          <div class=\"col-md-6 item-right\">\r\n            <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </section>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"mensajeError == 0 && size == 0\">\r\n      <span>\r\n        No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.\r\n      </span>\r\n    </div>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"consulta == -1\">\r\n      <span>\r\n        Establezca sus criterios de b&uacute;squeda.\r\n      </span>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- MODALS -->\r\n  <!--  <div class=\"fecha-modals\">\r\n    <div class=\"modal fade\" id=\"fechaProcesoModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"fechaProcesoModalTitle\" aria-hidden=\"true\">\r\n      <div class=\"modal-dialog modal-dialog-centered\" role=\"document\">\r\n        <div class=\"modal-content\">\r\n          <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\r\n            <span aria-hidden=\"true\"><i class=\"str-icon-cerrar\"></i></span>\r\n          </button>\r\n          <div class=\"modal-header\">\r\n            <p class=\"modal-title\">Buscar por fecha de proceso</p>\r\n          </div>\r\n          <div class=\"modal-body\">\r\n            <ngx-daterangepicker-material (choosedDate)=\"choosedDateP($event)\" [autoApply]=\"true\" [locale]=\"locale\">\r\n            </ngx-daterangepicker-material>\r\n            <div class=\"buttons-container\">\r\n              <button type=\"submit\" class=\"btn main\" (click)=\"hideModal()\">Aceptar</button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"modal fade\" id=\"fechaRespuestaModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"fechaRespuestaModalTitle\" aria-hidden=\"true\">\r\n      <div class=\"modal-dialog modal-dialog-centered\" role=\"document\">\r\n        <div class=\"modal-content\">\r\n          <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\r\n            <span aria-hidden=\"true\"><i class=\"str-icon-cerrar\"></i></span>\r\n          </button>\r\n          <div class=\"modal-header\">\r\n            <p class=\"modal-title\">Buscar por fecha de respuesta</p>\r\n          </div>\r\n          <div class=\"modal-body\">\r\n            <ngx-daterangepicker-material (choosedDate)=\"choosedDateR($event)\" [autoApply]=\"true\" [locale]=\"locale\">\r\n            </ngx-daterangepicker-material>\r\n            <div class=\"buttons-container\">\r\n              <button type=\"submit\" class=\"btn main\" (click)=\"hideModal()\">Aceptar</button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div> -->\r\n\r\n</section>\r\n\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div *ngIf=\"mensajeError == 1\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" id=\"modal-basic-title\" style=\"color:#ec0000;font-weight: bold\">Error</h3>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <p>Servicio temporalmente no disponible.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [DescargaExcelPdfFileService, AdminProcesosService, EmpresasService,
                        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
                        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
                        { provide: MAT_DATE_FORMATS, useValue: ɵ0 }]
                }] }
    ];
    /** @nocollapse */
    AdminProcesosComponent.ctorParameters = function () { return [
        { type: AdminProcesosService },
        { type: FacturacionHistorialService },
        { type: EmpresasService },
        { type: Globals },
        { type: DescargaExcelPdfFileService },
        { type: LoaderBaseService },
        { type: MatDialog },
        { type: FormBuilder },
        { type: DatePipe },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    AdminProcesosComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator,] }],
        sort: [{ type: ViewChild, args: [MatSort,] }]
    };
    return AdminProcesosComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AdminProcesosDetallesComponent = /** @class */ (function () {
    function AdminProcesosDetallesComponent(route) {
        this.route = route;
    }
    /**
     * @return {?}
     */
    AdminProcesosDetallesComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.route.queryParams.subscribe((/**
         * @param {?} params
         * @return {?}
         */
        function (params) {
            _this.panelIdArchivo = params['p'],
                _this.panelCantidadReg = params['c'],
                _this.panelNombreArchivo = params['n'],
                _this.panelFechaIngreso = (params['fi']) ? params['fi'] : null,
                _this.panelFechaProceso = (params['fp']) ? params['fp'] : null,
                _this.panelDscEstado = params['de'],
                _this.panelCantVal = params['acv'],
                _this.panelCantUpd = params['acu'],
                _this.panelCantErr = params['ace'],
                _this.panelCodTipoArchivo = params['dta'];
        }));
        sessionStorage.setItem('componenteHijo', 'adminProcesosDetalles');
    };
    AdminProcesosDetallesComponent.decorators = [
        { type: Component, args: [{
                    selector: 'adminProcesosDetalles',
                    template: "<section id=\"portal-comercio\">\r\n    <div class=\"container\">\r\n        <div class=\"modulo-cuentas detalle\">\r\n            <div class=\"row\">\r\n                <div class=\"col\">\r\n                    <a [routerLink]=\"['../adminProcesos']\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-row\">\r\n                <div class=\"col-2 order-1 order-md-1 col-md-1 icon\">\r\n                    <!-- <i class=\"str-icon-recargar\"></i> -->\r\n                </div>\r\n                <div class=\"col-12 order-12 order-md-2 col-md-10 datos\">\r\n                    <div class=\"form-row\">\r\n                        <div class=\"item col-4 col-sm-3 col-md-2\">\r\n                            <h5>ID Proceso</h5>\r\n                            <p>{{panelIdArchivo}}</p>\r\n                        </div>\r\n                        <div class=\"item col-4 col-sm-3 col-md-2\">\r\n                            <h5>Registros</h5>\r\n                            <p>{{panelCantidadReg}}</p>\r\n                        </div>\r\n                        <div class=\"item col-4 col-sm-3 col-md-3\">\r\n                            <h5>Fecha Ingreso</h5>\r\n                            <p>{{ (panelFechaIngreso !== null) ? (panelFechaIngreso | date: 'dd/MM/yyyy') : \"-\" }}</p>\r\n                        </div>\r\n                        <div class=\"item col-4 col-sm-3 col-md-3\">\r\n                            <h5>Fecha Proceso</h5>\r\n                            <p>{{ (panelFechaProceso !== null) ? (panelFechaProceso | date: 'dd/MM/yyyy') : \"-\" }}</p>\r\n                        </div>\r\n                        <div class=\"item col-4 col-sm-3 col-md-2\">\r\n                            <h5>Estado</h5>\r\n                            <p>{{panelDscEstado}}</p>\r\n                            <!--span class=\"databar aprobado\">Aprobada</span-->\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"form-row\" *ngIf=\"panelCodTipoArchivo != 'RABU'\">\r\n                        <div class=\"item col-6 col-sm-5 col-md-4\">\r\n                            <h5>Nombre</h5>\r\n                            <p>{{panelNombreArchivo}}</p>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"form-row\" *ngIf=\"panelCodTipoArchivo == 'RABU'\">\r\n                        <div class=\"item col-5 col-sm-4 col-md-3\">\r\n                            <h5>Nombre</h5>\r\n                            <p class=\"text-breakword\">{{panelNombreArchivo}}</p>\r\n                        </div>\r\n                        <div class=\"item col-5 col-sm-4 col-md-3\">\r\n                            <h5>Cantidad que mantiene</h5>\r\n                            <p>{{panelCantVal}}</p>\r\n                        </div>\r\n                        <div class=\"item col-5 col-sm-4 col-md-3\">\r\n                            <h5>Cantidad de Actualizaciones</h5>\r\n                            <p>{{panelCantUpd}}</p>\r\n                        </div>\r\n                        <div class=\"item col-5 col-sm-4 col-md-3\">\r\n                            <h5>Cantidad de Errores</h5>\r\n                            <p>{{panelCantErr}}</p>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</section>"
                }] }
    ];
    /** @nocollapse */
    AdminProcesosDetallesComponent.ctorParameters = function () { return [
        { type: ActivatedRoute }
    ]; };
    return AdminProcesosDetallesComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuditoriaCategoria = /** @class */ (function () {
    function AuditoriaCategoria() {
        this.idCategoria = "";
        this.codCategoria = "";
        this.descCategoria = "";
        this.fechaCategoria = "";
    }
    return AuditoriaCategoria;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuditoriaEvento = /** @class */ (function () {
    function AuditoriaEvento() {
        this.idEvento = "";
        this.idCategoria = "";
        this.codEvento = "";
        this.descEvento = "";
        this.fechaEvento = "";
    }
    return AuditoriaEvento;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuditoriaPortal = /** @class */ (function () {
    function AuditoriaPortal() {
        this.idPortal = "";
        this.codPortal = "";
        this.descPortal = "";
    }
    return AuditoriaPortal;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuditoriaPeticion = /** @class */ (function () {
    function AuditoriaPeticion() {
        //idLog: string = '-1';
        this.logCategoria = '-1';
        this.logEvento = '-1';
        this.logIdCliente = '-1';
        this.logIdEmpresa = '-1';
        this.logIdTpoPortal = '-1';
        this.logFechaInicio = '01/01/2000';
        this.logFechaTermino = '01/01/2000';
        this.codTpoPortal = '-1';
        this.filtros = [];
    }
    return AuditoriaPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EventoPeticion = /** @class */ (function () {
    function EventoPeticion() {
        this.codCategoria = '-1';
    }
    return EventoPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var httpOptions$3 = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};
var AuditoriaService = /** @class */ (function () {
    function AuditoriaService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlAuditoria = this.environment.urlAmbiente + '/apiAuditoriaMT/listaAuditoria';
        this.urlAuditoriaDetalle = this.environment.urlAmbiente + '/apiAuditoriaMT/auditoriaDetalle';
        this.urlCategoria = this.environment.urlAmbiente + '/apiAuditoriaMT/listaCategoria';
        this.urlEvento = this.environment.urlAmbiente + '/apiAuditoriaMT/listaEvento';
        this.urlTipoPortal = this.environment.urlAmbiente + '/apiAuditoriaMT/listaTipoPortal';
    }
    /**
     * @param {?} _body
     * @return {?}
     */
    AuditoriaService.prototype.postRespuestaReport = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlAuditoria, _body, httpOptions$3);
    };
    /**
     * @param {?} _body
     * @return {?}
     */
    AuditoriaService.prototype.postRespuestaDetalle = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlAuditoriaDetalle, _body, httpOptions$3);
    };
    /**
     * @return {?}
     */
    AuditoriaService.prototype.postCategoria = /**
     * @return {?}
     */
    function () {
        return this.http.post(this.urlCategoria, null, httpOptions$3);
    };
    /**
     * @param {?} _body
     * @return {?}
     */
    AuditoriaService.prototype.postEvento = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlEvento, _body, httpOptions$3);
    };
    /**
     * @return {?}
     */
    AuditoriaService.prototype.postTipoPortal = /**
     * @return {?}
     */
    function () {
        return this.http.post(this.urlTipoPortal, null, httpOptions$3);
    };
    AuditoriaService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AuditoriaService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return AuditoriaService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$1 = MAT_MOMENT_DATE_FORMATS;
var AuditoriaComponent = /** @class */ (function () {
    function AuditoriaComponent(phttpe, phttp, phttpd, loader, formBuilder, datepipe, environment, dialog) {
        this.phttpe = phttpe;
        this.phttp = phttp;
        this.phttpd = phttpd;
        this.loader = loader;
        this.formBuilder = formBuilder;
        this.datepipe = datepipe;
        this.environment = environment;
        this.dialog = dialog;
        this.size = 0;
        this.logFechaInicio = '01/01/2000';
        this.logFechaTermino = '01/01/2000';
        //vistas
        this.vistaCategoria = 'Todos';
        this.vistaEvento = 'Todos';
        this.vistaTipoPortal = 'Todos';
        this.vistaEmpresa = 'Todos';
        this.hashCaminoMiga = [];
        this.peticionReport = new AuditoriaPeticion();
        this.peticionEvento = new EventoPeticion();
        this.peticionEmpresa = new EmpresasPeticion();
        this.resultadoEmpresa = [];
        this.mensajeError = -1;
        this.isCollapsed = false;
        this.consulta = -1;
        /** @type {?} */
        var fecha = new Date();
        /** @type {?} */
        var mañana = fecha.setDate(fecha.getDate() + 1);
        /** @type {?} */
        var fechaFormat = this.datepipe.transform(mañana, 'yyyy-MM-dd');
        this.unavailabilityForm = this.formBuilder.group({
            endDate: [fechaFormat + 'T00:00:00.000Z']
        });
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        //this.codTpoPortal = 'ADQUIRENTE';
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
        //this.docEmpresa = '97036000K';
    }
    /**
     * @return {?}
     */
    AuditoriaComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formGroup = new FormGroup({
            categoria: new FormControl('-1'),
            evento: new FormControl('-1'),
            tipoPortal: new FormControl('-1'),
            empresa: new FormControl('-1'),
            fechaRegistro: new FormControl()
        });
        this.peticionReport.logCategoria = '-1';
        this.peticionReport.logEvento = '-1';
        this.peticionReport.logIdCliente = this.environment.codCliente;
        this.peticionReport.logFechaInicio = '01/01/2000';
        this.peticionReport.logFechaTermino = '01/01/2000';
        if (this.formGroup.controls['categoria'].value == '-1') {
            this.formGroup.controls['evento'].disable();
            this.formGroup.controls.evento.setValue('-1');
        }
        if (this.codTpoPortal == 'COMERCIO') {
            this.comboComercio = false;
            this.peticionReport.logIdEmpresa = this.docEmpresa;
            this.peticionReport.logIdTpoPortal = '-1';
            this.formGroup.controls['empresa'].disable();
            this.displayedColumns = ['logFechaAdd', 'logCat', 'logEvt', 'logUsrEmp', 'logDetalle'];
        }
        else {
            this.comboComercio = true;
            this.peticionReport.logIdEmpresa = '-1';
            this.peticionReport.logIdTpoPortal = '-1';
            this.formGroup.controls['empresa'].enable();
            this.displayedColumns = ['logFechaAdd', 'logCat', 'logEvt', 'logEmp', 'logPortal', 'logUsrEmp', 'logDetalle'];
            this.peticionEmpresa.codCliente = this.environment.codCliente;
            //this.peticionEmpresa.codEstadoConvenio = 'HBL';
            this.peticionEmpresa.withCliente = 'true';
            //this.postSentEmpresaServices(this.peticionEmpresa);
            this.postSentSelectEmpresaServices(this.peticionEmpresa);
        }
        this.consulta = -1;
        this.postCategoriaServices();
        this.postTipoPortalServices();
        if (sessionStorage.getItem('componenteHijo') == 'app-auditoriaDetalle') {
            this.consulta = 0;
            /** @type {?} */
            var llamadaPadre = JSON.parse(sessionStorage.getItem('llamadaPadre'));
            // Llena los filtros
            this.formGroup.controls['fechaRegistro'].setValue(llamadaPadre.filtroFechaRegistroI);
            this.logFechaInicio = llamadaPadre.logFechaInicio;
            this.logFechaTermino = llamadaPadre.logFechaTermino;
            this.formGroup.controls['categoria'].setValue(llamadaPadre.logCategoria);
            if (this.formGroup.get('categoria').value != '-1') {
                this.peticionEvento.codCategoria = llamadaPadre.logCategoria;
                this.formGroup.controls['evento'].reset();
                this.postEventoServices(this.peticionEvento);
                this.formGroup.controls['evento'].enable();
            }
            this.formGroup.controls['evento'].setValue(llamadaPadre.logEvento);
            this.formGroup.controls['tipoPortal'].setValue(llamadaPadre.logIdTpoPortal);
            this.formGroup.controls['empresa'].setValue(llamadaPadre.logIdEmpresa);
            // Llena camino de migas
            /** @type {?} */
            var migasPadre = JSON.parse(sessionStorage.getItem('migasPadre'));
            this.vistaCategoria = migasPadre.logCategoria;
            this.vistaEvento = migasPadre.logEvento;
            this.hashCaminoMiga[0] = { title: 'Fecha Registro', text: migasPadre.fechaRegistro };
            this.hashCaminoMiga[1] = { title: 'Categoría', text: migasPadre.logCategoria };
            this.hashCaminoMiga[2] = { title: 'Evento', text: migasPadre.logEvento };
            if (this.codTpoPortal != 'COMERCIO') {
                this.vistaTipoPortal = migasPadre.logIdTpoPortal;
                this.vistaEmpresa = migasPadre.logIdEmpresa;
                this.hashCaminoMiga[3] = { title: 'Tipo Portal', text: migasPadre.logIdTpoPortal };
                this.hashCaminoMiga[4] = { title: 'Empresa', text: migasPadre.logIdEmpresa };
            }
            // Llama al servicio
            this.peticionReport.codTpoPortal = llamadaPadre.codTpoPortal;
            this.peticionReport.logFechaInicio = llamadaPadre.logFechaInicio;
            this.peticionReport.logFechaTermino = llamadaPadre.logFechaTermino;
            this.peticionReport.logCategoria = llamadaPadre.logCategoria;
            this.peticionReport.logEvento = llamadaPadre.logEvento;
            this.peticionReport.logIdTpoPortal = llamadaPadre.logIdTpoPortal;
            this.peticionReport.logIdEmpresa = llamadaPadre.logIdEmpresa;
            this.postSentReportServices(this.peticionReport);
        }
        else {
            this.setInitialBreadcrumbs();
        }
    };
    /**
     * @return {?}
     */
    AuditoriaComponent.prototype.setInitialBreadcrumbs = /**
     * @return {?}
     */
    function () {
        this.hashCaminoMiga[0] = { title: 'Fecha Registro', text: 'Todos' };
        this.hashCaminoMiga[1] = { title: 'Categoría', text: 'Todas' };
        this.hashCaminoMiga[2] = { title: 'Evento', text: 'Todos' };
        if (this.codTpoPortal != 'COMERCIO') {
            this.hashCaminoMiga[3] = { title: 'Tipo Portal', text: 'Todos' };
            this.hashCaminoMiga[4] = { title: 'Empresa', text: 'Todas' };
        }
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    AuditoriaComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        if (sessionStorage.getItem('componenteHijo') != 'app-auditoriaDetalle') {
            sessionStorage.removeItem('indice');
        }
        this.consulta = 0;
        this.peticionReport.codTpoPortal = this.codTpoPortal;
        this.peticionReport.logIdCliente = this.environment.codCliente;
        this.filtroFechaRegistroI = this.formGroup.get('fechaRegistro').value;
        if (this.formGroup.get('fechaRegistro').value != null) {
            this.peticionReport.logFechaInicio = formatDate(this.filtroFechaRegistroI.begin, 'dd/MM/yyyy', 'en-US');
            this.peticionReport.logFechaTermino = formatDate(this.filtroFechaRegistroI.end, 'dd/MM/yyyy', 'en-US');
            this.hashCaminoMiga[0] = { title: 'Fecha Registro', text: this.logFechaInicio + ' - ' + this.logFechaTermino };
        }
        else {
            this.hashCaminoMiga[0] = { title: 'Fecha Registro', text: 'Todos' };
            this.peticionReport.logFechaInicio = this.logFechaInicio;
            this.peticionReport.logFechaTermino = this.logFechaTermino;
        }
        if (this.formGroup.get('categoria').value == '-1') {
            this.peticionReport.logCategoria = '-1';
            this.hashCaminoMiga[1] = { title: 'Categoría', text: 'Todos' };
        }
        else {
            this.peticionReport.logCategoria = this.formGroup.get('categoria').value;
            this.hashCaminoMiga[1] = { title: 'Categoría', text: this.vistaCategoria };
        }
        if (this.formGroup.get('evento').value == '-1') {
            this.peticionReport.logEvento = '-1';
            this.hashCaminoMiga[2] = { title: 'Evento', text: 'Todos' };
        }
        else {
            this.peticionReport.logEvento = this.formGroup.get('evento').value;
            this.hashCaminoMiga[2] = { title: 'Evento', text: this.vistaEvento };
        }
        if (this.codTpoPortal == 'COMERCIO') {
            this.peticionReport.logIdTpoPortal = '-1';
        }
        else {
            if (this.formGroup.get('tipoPortal').value == '-1') {
                this.peticionReport.logIdTpoPortal = '-1';
                this.hashCaminoMiga[3] = { title: 'Tipo Portal', text: 'Todos' };
            }
            else {
                this.peticionReport.logIdTpoPortal = this.formGroup.get('tipoPortal').value;
                this.hashCaminoMiga[3] = { title: 'Tipo Portal', text: this.vistaTipoPortal };
            }
        }
        if (this.codTpoPortal == 'COMERCIO') {
            this.peticionReport.logIdEmpresa = this.docEmpresa;
        }
        else {
            if (this.formGroup.get('empresa').value == '-1') {
                this.peticionReport.logIdEmpresa = '-1';
                this.hashCaminoMiga[4] = { title: 'Empresa', text: 'Todos' };
            }
            else {
                this.peticionReport.logIdEmpresa = this.formGroup.get('empresa').value;
                this.hashCaminoMiga[4] = { title: 'Empresa', text: this.vistaEmpresa };
            }
        }
        sessionStorage.setItem('llamadaPadre', JSON.stringify({
            codTpoPortal: this.peticionReport.codTpoPortal,
            logFechaInicio: this.peticionReport.logFechaInicio,
            logFechaTermino: this.peticionReport.logFechaTermino,
            logCategoria: this.peticionReport.logCategoria,
            logEvento: this.peticionReport.logEvento,
            logIdTpoPortal: this.peticionReport.logIdTpoPortal,
            logIdEmpresa: this.peticionReport.logIdEmpresa,
            filtroFechaRegistroI: this.filtroFechaRegistroI
        }));
        sessionStorage.setItem('migasPadre', JSON.stringify({
            fechaRegistro: this.hashCaminoMiga[0].text,
            logCategoria: this.hashCaminoMiga[1].text,
            logEvento: this.hashCaminoMiga[2].text,
            logIdTpoPortal: (this.codTpoPortal != 'COMERCIO' ? this.hashCaminoMiga[3].text : ''),
            logIdEmpresa: (this.codTpoPortal != 'COMERCIO' ? this.hashCaminoMiga[4].text : '')
        }));
        if (tipo == 'excel' || tipo == 'pdf') {
            this.peticionReport.filtros = this.hashCaminoMiga;
            this.postDownloadReportFile(this.peticionReport, tipo);
        }
        else {
            this.postSentReportServices(this.peticionReport);
        }
    };
    /**
     * @return {?}
     */
    AuditoriaComponent.prototype.postCategoriaServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.phttp.postCategoria().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var categoria = new AuditoriaCategoria();
                categoria.codCategoria = '-1';
                categoria.descCategoria = "Todas";
                data.resultado.splice(0, 0, categoria);
                _this.resultadoCategoria = [];
                _this.resultadoCategoria.push(data);
            }
            else {
                console.error('Error: postCategoria: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error: postCategoria: ', err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    AuditoriaComponent.prototype.postEventoServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.phttp.postEvento(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var evento = new AuditoriaEvento();
                evento.codEvento = "-1";
                evento.descEvento = "Todos";
                data.resultado.splice(0, 0, evento);
                _this.resultadoEvento = [];
                _this.resultadoEvento.push(data);
            }
            else {
                console.error('Error: postEvento:', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error: postEvento: ', err);
        }));
    };
    /**
     * @return {?}
     */
    AuditoriaComponent.prototype.postTipoPortalServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.phttp.postTipoPortal().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var portal = new AuditoriaPortal();
                portal.codPortal = '-1';
                portal.descPortal = "Todos";
                data.resultado.splice(0, 0, portal);
                _this.resultadoTipoPortal = [];
                _this.resultadoTipoPortal.push(data);
            }
            else {
                console.error('Error: postTipoPortal: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error: postTipoPortal: ', err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    AuditoriaComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.phttpe.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var emp = new EmpresaResult();
                emp.idFacturador = -1;
                emp.docFacturador = "-1";
                emp.nomFacturador = "Todas";
                data.resultado.splice(0, 0, emp);
                _this.resultadoEmpresa = [];
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.error('Error: postListarEmpresas: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error: postListarEmpresas: ', err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    AuditoriaComponent.prototype.postSentSelectEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        body.withCliente = "true";
        this.phttpe.postListarSelectEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var emp = new EmpresaResult();
                emp.idFacturador = -1;
                emp.docFacturador = "-1";
                emp.nomFacturador = "Todas";
                data.resultado.splice(0, 0, emp);
                _this.resultadoEmpresa = [];
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.log('Error: ', 'postListarSelectEmpresas ' + data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error("Error postListarSelectEmpresas: ", err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AuditoriaComponent.prototype.onPaginateChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var indice = this.paginator.pageIndex;
        sessionStorage.setItem('indice', indice);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    AuditoriaComponent.prototype.postSentReportServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.show = true;
        this.phttp.postRespuestaReport(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.size = data.resultado.length;
                if (_this.paginator != undefined && sessionStorage.getItem('componenteHijo') == 'app-auditoriaDetalle') {
                    _this.paginator.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indice')))));
                }
                else if (_this.paginator != undefined) {
                    _this.paginator.pageIndex = 0;
                }
                sessionStorage.removeItem('componenteHijo');
                _this.dataSource = new MatTableDataSource(data.resultado);
                _this.dataSource.paginator = _this.paginator;
                _this.dataSource.sort = _this.sort;
                if (_this.size == 0) {
                    _this.show = false;
                    _this.isCollapsed = false;
                }
                else {
                    _this.isCollapsed = true;
                }
                _this.mensajeError = 0;
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.loader.hide();
                _this.mensajeError = 1;
                console.error('Error: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            _this.loader.hide();
            _this.mensajeError = 1;
            console.error('Error: ', err);
        }));
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    AuditoriaComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiAuditoriaMT/listaAuditoria/' + tipo;
        this.phttpd.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'reporteAuditoria' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'reporteAuditoria' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AuditoriaComponent.prototype.onCategoriaSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event != null || event != '-1') {
            this.peticionEvento.codCategoria = event.value;
            this.formGroup.controls['evento'].reset();
            this.postEventoServices(this.peticionEvento);
            this.formGroup.controls.evento.setValue('-1');
            this.formGroup.controls['evento'].enable();
            this.vistaCategoria = event.source.selected._element.nativeElement.innerText.trim();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AuditoriaComponent.prototype.onEventoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEvento = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AuditoriaComponent.prototype.onTipoPortalSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaTipoPortal = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AuditoriaComponent.prototype.onComercioSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEmpresa = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @return {?}
     */
    AuditoriaComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.formGroup.controls['evento'].disable();
        this.logFechaInicio = '01/01/2000';
        this.logFechaTermino = '01/01/2000';
        this.peticionReport.logCategoria = '-1';
        this.peticionReport.logEvento = '-1';
        this.peticionReport.logIdCliente = '-1';
        this.peticionReport.logIdEmpresa = '-1';
        this.peticionReport.logIdTpoPortal = '-1';
        this.peticionReport.logFechaInicio = '01/01/2000';
        this.peticionReport.logFechaTermino = '01/01/2000';
        this.formGroup.controls.categoria.setValue('-1');
        this.formGroup.controls.evento.setValue('-1');
        this.formGroup.controls.tipoPortal.setValue('-1');
        this.formGroup.controls.empresa.setValue('-1');
        this.formGroup.get('fechaRegistro').setValue(null);
        this.dataSource = new MatTableDataSource([]);
        this.mensajeError = -1;
        this.show = false;
        this.size = 0;
        this.consulta = -1;
        this.setInitialBreadcrumbs();
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    AuditoriaComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AuditoriaComponent.prototype.selectfechaRegistro = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.logFechaInicio = formatDate(event.value.begin, 'dd/MM/yyyy', 'en-US');
        this.logFechaTermino = formatDate(event.value.end, 'dd/MM/yyyy', 'en-US');
    };
    /**
     * @return {?}
     */
    AuditoriaComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.onSubmit('');
        }
    };
    /**
     * @return {?}
     */
    AuditoriaComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('componenteHijo');
    };
    AuditoriaComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-auditoria',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <!-- <h3 class=\"titulo-seccion\">Log de auditor\u00EDa</h3> -->\r\n    <div class=\"modulo-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n      </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"formGroup\" autocomplete=\"off\">\r\n              <div class=\"form-row align-left\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"filtro-fecha\">\r\n                    <button type=\"button\" class=\"btn fecha\" (click)=\"picker1.open()\"><i class=\"str-icon-calendario\"></i> Buscar por fecha de registro\r\n                      <ng-container *ngIf=\"this.formGroup.get('fechaRegistro').value != null && this.logFechaInicio != '01/01/2000'\">\r\n                        <span>{{ this.logFechaInicio + ' - ' + this.logFechaTermino }}</span>\r\n                      </ng-container>\r\n                    </button>\r\n                    <mat-form-field style=\"display: none;\">\r\n                      <input matInput placeholder=\"Fecha\" [max]=\"unavailabilityForm.controls.endDate.value\" [satDatepicker]=\"picker1\" formControlName=\"fechaRegistro\" (dateInput)=\"selectfechaRegistro($event)\">\r\n                      <sat-datepicker-toggle matSuffix [for]=\"picker1\"></sat-datepicker-toggle>\r\n                      <sat-datepicker touchUi #picker1 [rangeMode]=\"true\" [selectFirstDateOnClose]=\"true\"></sat-datepicker>\r\n                    </mat-form-field>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-row\">\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Categor\u00EDa\" formControlName=\"categoria\" (selectionChange)=\"onCategoriaSelect($event)\">\r\n                      <section *ngFor=\"let resp of resultadoCategoria\">\r\n                        <ng-container *ngFor=\"let cat of resp.resultado\">\r\n                          <mat-option *ngIf=\"(codTpoPortal == 'ADQUIRENTE') || (codTpoPortal == 'COMERCIO' && cat.codCategoria != 'CATEMPRESA' && cat.codCategoria != 'CATCONVENI' && cat.codCategoria != 'CATPOLI')\" [value]=\"cat.codCategoria\">{{cat.descCategoria}}</mat-option>\r\n                        </ng-container>\r\n                      </section>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Evento\" formControlName=\"evento\" (selectionChange)=\"onEventoSelect($event)\">\r\n                      <section *ngFor=\"let resp of resultadoEvento\">\r\n                        <mat-option *ngFor=\"let eve of resp.resultado\" [value]=\"eve.codEvento\">{{eve.descEvento}}\r\n                        </mat-option>\r\n                      </section>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-4\" *ngIf=\"comboComercio\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Tipo Portal\" formControlName=\"tipoPortal\" (selectionChange)=\"onTipoPortalSelect($event)\">\r\n                      <section *ngFor=\"let resp of resultadoTipoPortal\">\r\n                        <mat-option *ngFor=\"let tpo of resp.resultado\" [value]=\"tpo.codPortal\">{{tpo.descPortal}}\r\n                        </mat-option>\r\n                      </section>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-row\" *ngIf=\"comboComercio\">\r\n                <div class=\"col-md-6\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"empresa\" (selectionChange)=\"onComercioSelect($event)\">\r\n                      <mat-option *ngFor=\"let comercio of resultadoEmpresa\" [value]=\"comercio.docFacturador\"> {{comercio.nomFacturador}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"actions\">\r\n                <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\" (click)=\"validarForm()\">Filtrar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"resultados-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-10\">\r\n          <div class=\"tags row\">\r\n            <div *ngFor=\"let entry of hashCaminoMiga\" class=\"item\">{{entry.title}}: {{entry.text}}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n          <div class=\"numero-resultados\">\r\n            <strong>{{ (size == 1) ? ( size + \" Resultado\") : size + \" Resultados\" }}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-container table-responsive-md\">\r\n        <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n          <ng-container matColumnDef=\"logCat\">\r\n            <th mat-header-cell *matHeaderCellDef>Categor\u00EDa</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.logCat}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"logEvt\">\r\n            <th mat-header-cell *matHeaderCellDef>Evento</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.logEvt}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"logEmp\" *ngIf=\"comboComercio\">\r\n            <th mat-header-cell *matHeaderCellDef>Empresa</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.logEmp}}</td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"logPortal\" *ngIf=\"comboComercio\">\r\n            <th mat-header-cell *matHeaderCellDef>Portal</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.logPortal}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"logUsrEmp\">\r\n            <th mat-header-cell *matHeaderCellDef>Usuario Responsable</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.logNomUserEmp}} {{resultado.logPatUserEmp}}</td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"logFechaAdd\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha Registro</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              {{ (resultado.logFechaAdd !== 'null') ? (resultado.logFechaAdd | date: 'dd/MM/yyyy HH:mm:ss') : \"-\" }}\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"logDetalle\">\r\n            <th mat-header-cell *matHeaderCellDef>Detalle</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a [routerLink]=\"['../detalle']\" [queryParams]=\"{\r\n                    'il':resultado.idLog,\r\n                    'ev':resultado.logEvt\r\n                  }\"><i class=\"str-icon-flecha-derecha\"></i></a>\r\n            </td>\r\n          </ng-container>\r\n\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n        </table>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" (page)=\"onPaginateChange($event)\" showFirstLastButtons></mat-paginator>\r\n      </div>\r\n      <div class=\"box-actions\" *ngIf=\"size > 0\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6 item\">\r\n            <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n          </div>\r\n          <div class=\"col-md-6 item-right\">\r\n            <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </section>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"mensajeError == 0 && size == 0\">\r\n      <span>\r\n        No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.\r\n      </span>\r\n    </div>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"consulta == -1\">\r\n      <span>\r\n        Establezca sus criterios de b&uacute;squeda.\r\n      </span>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div *ngIf=\"mensajeError == 1\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" id=\"modal-basic-title\" style=\"color:#ec0000;font-weight: bold\">Error</h3>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <p>Servicio temporalmente no disponible.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [AuditoriaService, DescargaExcelPdfFileService,
                        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
                        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
                        { provide: MAT_DATE_FORMATS, useValue: ɵ0$1 }]
                }] }
    ];
    /** @nocollapse */
    AuditoriaComponent.ctorParameters = function () { return [
        { type: EmpresasService },
        { type: AuditoriaService },
        { type: DescargaExcelPdfFileService },
        { type: LoaderBaseService },
        { type: FormBuilder },
        { type: DatePipe },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] },
        { type: MatDialog }
    ]; };
    AuditoriaComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator,] }],
        sort: [{ type: ViewChild, args: [MatSort,] }]
    };
    return AuditoriaComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuditoriaDetallePeticion = /** @class */ (function () {
    function AuditoriaDetallePeticion() {
        this.idLog = "-1";
        this.filtros = [];
    }
    return AuditoriaDetallePeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuditoriaDetalleComponent = /** @class */ (function () {
    function AuditoriaDetalleComponent(router, activatedRoute, phttp, phttpd, dialog, loader) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.phttp = phttp;
        this.phttpd = phttpd;
        this.dialog = dialog;
        this.loader = loader;
        this.peticionReport = new AuditoriaDetallePeticion();
        this.vistaCantidad = 0;
        this.hashCaminoMiga = [];
        this.vistaEstado = 'Todos';
        this.displayedColumns = ['llave', 'valor'];
    }
    /**
     * @return {?}
     */
    AuditoriaDetalleComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        sessionStorage.setItem('componenteHijo', 'app-auditoriaDetalle');
        this.activatedRoute.queryParams.subscribe((/**
         * @param {?} params
         * @return {?}
         */
        function (params) {
            _this.idLog = params['il'],
                _this.logEvento = params['ev'];
        }));
        this.peticionReport.idLog = this.idLog;
        this.postSentReportServices(this.peticionReport);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    AuditoriaDetalleComponent.prototype.postSentReportServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.phttp.postRespuestaDetalle(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.vistaCantidad = data.resultado.length;
                _this.dataSource = new MatTableDataSource(data.resultado);
                _this.dataSource.paginator = _this.paginator;
                _this.dataSource.sort = _this.sort;
                _this.loader.hide();
            }
            else {
                _this.loader.hide();
                console.error('Error: ', data.descret);
                _this.showDialogFail('Error', 'Servicio temporalmente no disponible.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            console.error('Error: ', err);
            _this.showDialogFail('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    AuditoriaDetalleComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.hashCaminoMiga[0] = { title: 'ID Log', text: this.idLog };
        this.hashCaminoMiga[1] = { title: 'Evento', text: this.logEvento };
        this.peticionReport.idLog = this.idLog;
        if (tipo == 'excel' || tipo == 'pdf') {
            this.peticionReport.filtros = this.hashCaminoMiga;
            console.log(this.peticionReport.filtros);
            this.postDownloadReportFile(this.peticionReport, tipo);
        }
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    AuditoriaDetalleComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiAuditoriaMT/auditoriaDetalle/' + tipo;
        this.phttpd.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'reporteAuditoriaDetalle' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'reporteAuditoriaDetalle' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    AuditoriaDetalleComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    AuditoriaDetalleComponent.prototype.showDialogFail = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            _this.router.navigate(['../auditoria'], { relativeTo: _this.activatedRoute });
        }));
    };
    AuditoriaDetalleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-auditoriaDetalle',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <!-- <h3 class=\"titulo-seccion\">Log de auditor\u00EDa (detalle)</h3> -->\r\n    <div class=\"modulo-cuentas detalle\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a [routerLink]=\"['../auditoria']\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col-2 order-1 order-md-1 col-md-1 icon\">\r\n          <!-- <i class=\"str-icon-recargar\"></i> -->\r\n        </div>\r\n        <div class=\"col-12 order-12 order-md-2 col-md-10 datos\">\r\n          <div class=\"row\">\r\n            <div class=\"item col-4 col-sm-3 col-md-4\">\r\n              <h5>ID Log.</h5>\r\n              <p>{{ idLog }}</p>\r\n            </div>\r\n            <div class=\"item col-4 col-sm-4 col-md-4\">\r\n              <h5>Evento</h5>\r\n              <p>{{ logEvento }}</p>\r\n            </div>\r\n          </div>\r\n          <div class=\"table-container detalle table-responsive-lg\">\r\n            <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n              <ng-container matColumnDef=\"llave\">\r\n                <th mat-header-cell *matHeaderCellDef>Campo</th>\r\n                <td mat-cell *matCellDef=\"let resultado\"> {{resultado.logLlave}} </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"valor\">\r\n                <th mat-header-cell *matHeaderCellDef>Dato</th>\r\n                <td mat-cell *matCellDef=\"let resultado\"> {{resultado.logValor}} </td>\r\n              </ng-container>\r\n\r\n              <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n              <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n            </table>\r\n            <!-- <mat-paginator [pageSizeOptions]=\"[10]\" showFirstLastButtons></mat-paginator> -->\r\n          </div>\r\n\r\n          <div class=\"box-actions\" *ngIf=\"vistaCantidad > 0\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-6 item\">\r\n                <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar\r\n                  Excel</a>\r\n              </div>\r\n              <div class=\"col-md-6 item-right\">\r\n                <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [AuditoriaService, DescargaExcelPdfFileService]
                }] }
    ];
    /** @nocollapse */
    AuditoriaDetalleComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: AuditoriaService },
        { type: DescargaExcelPdfFileService },
        { type: MatDialog },
        { type: LoaderBaseService }
    ]; };
    AuditoriaDetalleComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator,] }],
        sort: [{ type: ViewChild, args: [MatSort,] }]
    };
    return AuditoriaDetalleComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AutorizacionesService = /** @class */ (function () {
    function AutorizacionesService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlListaAutorizaciones = this.environment.urlAmbiente + '/apiAutorizacionesMT/listaAutorizaciones';
        this.urlGetAutorizacionDetalle = this.environment.urlAmbiente + '/apiAutorizacionesMT/getAutorizacionDetalle';
        this.urlCambiaEstadoAutorizacion = this.environment.urlAmbiente + '/apiAutorizacionesMT/cambiaEstadoAutorizacion';
        this.urlListaEstadosAutorizacion = this.environment.urlAmbiente + '/apiAutorizacionesMT/listaEstadosAutorizacion';
        this.urlListaConfigAutorizaciones = this.environment.urlAmbiente + '/apiAutorizacionesMT/listaConfigAutorizaciones';
        this.urlAgregaConfigAutorizacion = this.environment.urlAmbiente + '/apiAutorizacionesMT/agregaConfigAutorizacion';
        this.urlCambiaConfigAutorizacion = this.environment.urlAmbiente + '/apiAutorizacionesMT/cambiaConfigAutorizacion';
        this.urlListaEventosAutorizacion = this.environment.urlAmbiente + '/apiAutorizacionesMT/listaEventosAutorizacion';
        this.urlListaAutorizadores = this.environment.urlAmbiente + '/apiAutorizacionesMT/listaAutorizadores';
        this.urlListaUsuarios = this.environment.urlAmbiente + '/apiAutorizacionesMT/listaUsuarios';
        this.urlCambiaAutorizador = this.environment.urlAmbiente + '/apiAutorizacionesMT/cambiaAutorizador';
        this.urlAgregarAutorizador = this.environment.urlAmbiente + '/apiAutorizacionesMT/agregarAutorizador';
        this.urlListaTiposAutorizador = this.environment.urlAmbiente + '/apiAutorizacionesMT/listaTiposAutorizador';
        this.urlListaEstadosConfiguracion = this.environment.urlAmbiente + '/apiAutorizacionesMT/listaEstadosConfiguracion';
        this.urlListaEstadosAutorizadores = this.environment.urlAmbiente + '/apiAutorizacionesMT/listaEstadosAutorizadores';
    }
    /**
     * @param {?} params
     * @return {?}
     */
    AutorizacionesService.prototype.postListaAutorizaciones = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlListaAutorizaciones, params, httpOptions$4);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    AutorizacionesService.prototype.postGetAutorizacionDetalle = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlGetAutorizacionDetalle, params, httpOptions$4);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    AutorizacionesService.prototype.postCambiaEstadoAutorizacion = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlCambiaEstadoAutorizacion, params, httpOptions$4);
    };
    /**
     * @return {?}
     */
    AutorizacionesService.prototype.postListaEstadosAutorizacion = /**
     * @return {?}
     */
    function () {
        return this.http.post(this.urlListaEstadosAutorizacion, httpOptions$4);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    AutorizacionesService.prototype.postListaConfigAutorizaciones = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlListaConfigAutorizaciones, params, httpOptions$4);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    AutorizacionesService.prototype.postAgregaConfigAutorizacion = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlAgregaConfigAutorizacion, params, httpOptions$4);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    AutorizacionesService.prototype.postCambiaConfigAutorizacion = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlCambiaConfigAutorizacion, params, httpOptions$4);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    AutorizacionesService.prototype.postListaEventosAutorizacion = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlListaEventosAutorizacion, params, httpOptions$4);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    AutorizacionesService.prototype.postCambiaAutorizador = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlCambiaAutorizador, params, httpOptions$4);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    AutorizacionesService.prototype.postListaAutorizadores = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlListaAutorizadores, params, httpOptions$4);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    AutorizacionesService.prototype.postListaUsuarios = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlListaUsuarios, params, httpOptions$4);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    AutorizacionesService.prototype.postAgregarAutorizador = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlAgregarAutorizador, params, httpOptions$4);
    };
    /**
     * @return {?}
     */
    AutorizacionesService.prototype.postListaTiposAutorizador = /**
     * @return {?}
     */
    function () {
        return this.http.post(this.urlListaTiposAutorizador, httpOptions$4);
    };
    /**
     * @return {?}
     */
    AutorizacionesService.prototype.postListaEstadosConfiguraciones = /**
     * @return {?}
     */
    function () {
        return this.http.post(this.urlListaEstadosConfiguracion, httpOptions$4);
    };
    /**
     * @return {?}
     */
    AutorizacionesService.prototype.postListaEstadosAutorizadores = /**
     * @return {?}
     */
    function () {
        return this.http.post(this.urlListaEstadosAutorizadores, httpOptions$4);
    };
    AutorizacionesService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    AutorizacionesService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    /** @nocollapse */ AutorizacionesService.ngInjectableDef = defineInjectable({ factory: function AutorizacionesService_Factory() { return new AutorizacionesService(inject(HttpClient), inject("env")); }, token: AutorizacionesService, providedIn: "root" });
    return AutorizacionesService;
}());
/** @type {?} */
var httpOptions$4 = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EstadoAutorizacion = /** @class */ (function () {
    function EstadoAutorizacion() {
    }
    return EstadoAutorizacion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListaAutorizacionesPeticion = /** @class */ (function () {
    function ListaAutorizacionesPeticion() {
        this.codCliente = "";
        this.docEmpresa = "";
        this.codAutStd = "";
        this.fecAddAut = "";
        this.filtros = [];
        this.codTpoPortal = "";
    }
    return ListaAutorizacionesPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EstadoAutorizacionPeticion = /** @class */ (function () {
    function EstadoAutorizacionPeticion() {
        this.codCliente = "";
        this.docEmpresa = "";
        this.idAutorizador = 0;
        this.idAut = 0;
        this.codEstadoAut = "";
    }
    return EstadoAutorizacionPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AutorizadoresPeticion = /** @class */ (function () {
    function AutorizadoresPeticion() {
        this.codCliente = '';
        this.docEmpresa = '';
        this.codTipoAutorizador = '';
        this.codEstado = '';
        this.docUsrEmp = '';
        this.codTipoPortal = '';
        this.filtros = [];
    }
    return AutorizadoresPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AutorizacionDetalle = /** @class */ (function () {
    function AutorizacionDetalle() {
        this.idAuth = 0;
        this.CodCliente = "";
        this.docEmpresa = "";
        /* Paginacion */
        this.paginacion = 0;
        this.hijo = false;
        /* Filtros */
        this.fecha = "";
        this.emp = "";
        this.estado = "";
    }
    /**
     * @return {?}
     */
    AutorizacionDetalle.prototype.setNull = /**
     * @return {?}
     */
    function () {
        this.fecha = "";
        this.emp = "";
        this.estado = "";
        this.paginacion = 0;
        this.hijo = false;
    };
    AutorizacionDetalle.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root',
                },] }
    ];
    /** @nocollapse */ AutorizacionDetalle.ngInjectableDef = defineInjectable({ factory: function AutorizacionDetalle_Factory() { return new AutorizacionDetalle(); }, token: AutorizacionDetalle, providedIn: "root" });
    return AutorizacionDetalle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$2 = MAT_MOMENT_DATE_FORMATS;
var AutorizacionesComponent = /** @class */ (function () {
    function AutorizacionesComponent(empresaService, autorizacionDetalle, service, serviceEmpresas, dialog, loader, router, route, formBuilder, datepipe, phttpd, environment) {
        this.empresaService = empresaService;
        this.autorizacionDetalle = autorizacionDetalle;
        this.service = service;
        this.serviceEmpresas = serviceEmpresas;
        this.dialog = dialog;
        this.loader = loader;
        this.router = router;
        this.route = route;
        this.formBuilder = formBuilder;
        this.datepipe = datepipe;
        this.phttpd = phttpd;
        this.environment = environment;
        this.firstFormGroup = new FormGroup({
            fechaAdd: new FormControl(''),
            estado: new FormControl('-1'),
            empresa: new FormControl('-1')
        });
        this.logFechaEscogida = '01/01/2000';
        this.estadosAutorizacion = [];
        this.resultadoEmpresas = [];
        this.resultadoAut = [];
        this.docUsrEmp = '';
        this.show = false;
        this.isCollapsed = false;
        this.codTpoPortal = '';
        this.codTipoAutorizador = '';
        this.filtros = [];
        this.empresaSelectedText = 'Todas';
        this.estadoSelectedText = 'Todos';
        this.displayedColumns = [];
        /** @type {?} */
        var fecha = new Date();
        /** @type {?} */
        var mañana = fecha.setDate(fecha.getDate() + 1);
        /** @type {?} */
        var fechaFormat = this.datepipe.transform(mañana, 'yyyy-MM-dd');
        this.unavailabilityForm = this.formBuilder.group({
            endDate: [fechaFormat + 'T00:00:00.000Z']
        });
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
        this.docUsrEmp = this.userPerfil.usuario.docUsuario;
    }
    /**
     * @return {?}
     */
    AutorizacionesComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.codTpoPortal == 'COMERCIO') {
            this.codTipoAutorizador = 'NIVEL1';
            this.displayedColumns = ['idAut', 'dscEvento', 'idEntidad', 'nomUsuarioAut', 'fecAddAut', 'dscAutStd', 'detalle'];
        }
        else {
            this.codTipoAutorizador = 'NIVEL2';
            this.displayedColumns = ['idAut', 'razSocialEmpresa', 'dscEvento', 'idEntidad', 'nomUsuarioAut', 'fecAddAut', 'dscAutStd', 'detalle'];
        }
        this.loadParameter();
    };
    /**
     * @return {?}
     */
    AutorizacionesComponent.prototype.loadParameter = /**
     * @return {?}
     */
    function () {
        if (this.autorizacionDetalle.hijo == true) {
            this.firstFormGroup.get('fechaAdd').setValue(this.autorizacionDetalle.fecha);
            this.callEstadosAutorizacion(this.autorizacionDetalle.estado);
            this.callListaEmpresas(this.autorizacionDetalle.emp);
            this.callListaAutorizaciones();
        }
        else {
            this.callEstadosAutorizacion('-1');
            this.callListaEmpresas('-1');
        }
        this.callValidaAutorizador();
    };
    /**
     * @param {?} docEmpresaSelected
     * @return {?}
     */
    AutorizacionesComponent.prototype.callListaEmpresas = /**
     * @param {?} docEmpresaSelected
     * @return {?}
     */
    function (docEmpresaSelected) {
        /** @type {?} */
        var params = new EmpresasPeticion();
        params.codCliente = this.environment.codCliente;
        params.codEstadoConvenio = 'HBL';
        params.withCliente = "true";
        this.postSentSelectempresaServices(params, docEmpresaSelected);
        // this.serviceEmpresas.postListarEmpresas(params).subscribe(data => {
        //   if (data.codret == '0') {
        //     this.resultadoEmpresas = data.resultado;
        //     //Se agregar el TODAS
        //     let empresaTodas: EmpresaResult = new EmpresaResult();
        //     empresaTodas.docFacturador = '-1';
        //     empresaTodas.nomFacturador = 'Todas';
        //     this.resultadoEmpresas.splice(0, 0, empresaTodas);
        //     this.firstFormGroup.get('empresa').setValue(docEmpresaSelected);
        //     this.setSelectedText('empresa', this.resultadoEmpresas.find(e => e.docFacturador === docEmpresaSelected).nomFacturador);
        //   } else {
        //     console.error('Error en servicio listar empresas.', data.descret);
        //   }
        // }, err => {
        //   console.error('Error al llamar servicio listar empresas', err);
        // });
    };
    /**
     * @param {?} body
     * @param {?} docEmpresaSelected
     * @return {?}
     */
    AutorizacionesComponent.prototype.postSentSelectempresaServices = /**
     * @param {?} body
     * @param {?} docEmpresaSelected
     * @return {?}
     */
    function (body, docEmpresaSelected) {
        var _this = this;
        body.withCliente = 'true';
        this.empresaService.postListarSelectEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEmpresas = data.resultado;
                //Se agregar el TODAS
                /** @type {?} */
                var empresaTodas = new EmpresaResult();
                empresaTodas.docFacturador = '-1';
                empresaTodas.nomFacturador = 'Todas';
                _this.resultadoEmpresas.splice(0, 0, empresaTodas);
                _this.firstFormGroup.get('empresa').setValue(docEmpresaSelected);
                _this.setSelectedText('empresa', _this.resultadoEmpresas.find((/**
                 * @param {?} e
                 * @return {?}
                 */
                function (e) { return e.docFacturador === docEmpresaSelected; })).nomFacturador);
            }
            else {
                console.error('Error en servicio listar empresas.', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error("Error postSentSelectempresaServices: ", err);
        }));
    };
    /**
     * @param {?} codEstadoSelected
     * @return {?}
     */
    AutorizacionesComponent.prototype.callEstadosAutorizacion = /**
     * @param {?} codEstadoSelected
     * @return {?}
     */
    function (codEstadoSelected) {
        var _this = this;
        this.service.postListaEstadosAutorizacion().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.estadosAutorizacion = data.estados;
                /** @type {?} */
                var estadoTodos = new EstadoAutorizacion();
                estadoTodos.codEstado = '-1';
                estadoTodos.dscEstado = 'Todos';
                _this.estadosAutorizacion.splice(0, 0, estadoTodos);
                _this.firstFormGroup.get('estado').setValue(codEstadoSelected);
                _this.setSelectedText('estado', _this.estadosAutorizacion.find((/**
                 * @param {?} e
                 * @return {?}
                 */
                function (e) { return e.codEstado === codEstadoSelected; })).dscEstado);
            }
            else {
                console.error('Error al buscar listado de estados autorizacion', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en servicio listado de estados autorizacion', err);
        }));
    };
    /**
     * @return {?}
     */
    AutorizacionesComponent.prototype.callValidaAutorizador = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new AutorizadoresPeticion();
        params.codCliente = this.environment.codCliente;
        params.docEmpresa = (this.codTpoPortal == 'COMERCIO') ? this.docEmpresa : '-1';
        params.codTipoAutorizador = (this.codTpoPortal == 'COMERCIO') ? this.codTipoAutorizador : '-1';
        params.codEstado = 'ACT';
        params.docUsrEmp = this.docUsrEmp;
        this.service.postListaAutorizadores(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                if (data.autorizadores.length > 0) {
                    //Solo si es autorizador se muestran las columnas
                    _this.displayedColumns.push('rechazar', 'aprobar');
                }
                else {
                    console.error('El usuario no es autorizador', data);
                }
            }
            else {
                console.error('Error al buscar autorizador', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en servicio listado de autorizadores', err);
        }));
    };
    /**
     * @return {?}
     */
    AutorizacionesComponent.prototype.setParams = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var params = new ListaAutorizacionesPeticion();
        params.codCliente = this.environment.codCliente;
        if (this.codTpoPortal == 'COMERCIO') {
            params.docEmpresa = this.docEmpresa;
        }
        else {
            /** @type {?} */
            var codFacturador = this.firstFormGroup.get('empresa').value;
            params.docEmpresa = (codFacturador != null && codFacturador.trim().length > 0) ? codFacturador : '-1';
        }
        /** @type {?} */
        var fechaAdd = this.firstFormGroup.get('fechaAdd').value;
        params.fecAddAut = (fechaAdd == null || fechaAdd.trim().length == 0) ? '-1' : fechaAdd;
        /** @type {?} */
        var codEstado = this.firstFormGroup.get('estado').value;
        params.codAutStd = (codEstado == null || codEstado.trim().length == 0) ? '-1' : codEstado;
        params.filtros = this.filtros;
        params.codTpoPortal = this.codTpoPortal;
        return params;
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    AutorizacionesComponent.prototype.postDownloadReportFile = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        /** @type {?} */
        var url = '/apiAutorizacionesMT/listaAutorizaciones/' + tipo;
        /** @type {?} */
        var params = this.setParams();
        this.phttpd.downloadReportService(params, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'listadoAutorizaciones' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'listadoAutorizaciones' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            //this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @return {?}
     */
    AutorizacionesComponent.prototype.callListaAutorizaciones = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = this.setParams();
        this.show = true;
        this.service.postListaAutorizaciones(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                if (data.autorizaciones.length > 0) {
                    _this.isCollapsed = true;
                    _this.paginator.pageIndex = _this.autorizacionDetalle.paginacion;
                    _this.dataSource = new MatTableDataSource(data.autorizaciones);
                    _this.dataSource.paginator = _this.paginator;
                }
                else {
                    console.error('Resultado sin autorizaciones');
                    _this.isCollapsed = false;
                    _this.show = false;
                }
            }
            else {
                console.error('Error al buscar listado de autorizaciones', data.descret);
                _this.show = false;
            }
            _this.autorizacionDetalle.setNull();
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en servicio listado de autorizaciones', err);
            _this.show = false;
        }));
    };
    /**
     * @param {?} control
     * @param {?} texto
     * @return {?}
     */
    AutorizacionesComponent.prototype.setSelectedText = /**
     * @param {?} control
     * @param {?} texto
     * @return {?}
     */
    function (control, texto) {
        if (control == 'empresa') {
            this.empresaSelectedText = texto;
        }
        if (control == 'estado') {
            this.estadoSelectedText = texto;
        }
    };
    /**
     * @return {?}
     */
    AutorizacionesComponent.prototype.addFiltros = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var filtrofecha = this.firstFormGroup.get('fechaAdd').value;
        this.filtros = [];
        if (filtrofecha != '-1' && filtrofecha !== undefined && filtrofecha != null) {
            this.filtros.push({ title: 'Fecha', text: this.firstFormGroup.get('fechaAdd').value });
        }
        else {
            this.filtros.push({ title: 'Fecha', text: '' });
        }
        this.filtros.push({ title: 'Empresa', text: this.empresaSelectedText });
        this.filtros.push({ title: 'Estado', text: this.estadoSelectedText });
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    AutorizacionesComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        if (tipo == 'pdf' || tipo == 'excel') {
            this.addFiltros();
            this.postDownloadReportFile(tipo);
        }
        else {
            this.callListaAutorizaciones();
        }
    };
    /**
     * @return {?}
     */
    AutorizacionesComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.firstFormGroup.get('fechaAdd').setValue('');
        this.firstFormGroup.get('estado').setValue('-1');
        this.firstFormGroup.get('empresa').setValue('-1');
        this.logFechaEscogida = '';
        this.setSelectedText('empresa', 'Todas');
        this.setSelectedText('estado', 'Todos');
        this.dataSource = new MatTableDataSource([]);
        this.isCollapsed = false;
        this.show = false;
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    AutorizacionesComponent.prototype.showDialogInformativo = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('Dialog informativo', result);
        }));
    };
    /**
     * @param {?} idAut
     * @return {?}
     */
    AutorizacionesComponent.prototype.viewDetalle = /**
     * @param {?} idAut
     * @return {?}
     */
    function (idAut) {
        console.log("Id autorizacion", idAut);
        console.log("Pagina " + this.autorizacionDetalle);
        this.autorizacionDetalle.idAuth = idAut;
        this.autorizacionDetalle.CodCliente = this.environment.codCliente;
        this.autorizacionDetalle.paginacion = this.paginator.pageIndex;
        this.autorizacionDetalle.emp = this.firstFormGroup.get('empresa').value;
        this.autorizacionDetalle.fecha = this.firstFormGroup.get('fechaAdd').value;
        this.autorizacionDetalle.estado = this.firstFormGroup.get('estado').value;
        this.autorizacionDetalle.docEmpresa = (this.preLogin.codTpoPortal == 'ADQUIRENTE') ? '-1' : this.docEmpresa;
        this.router.navigate(['../detalle'], { relativeTo: this.route });
    };
    /**
     * @param {?} idAut
     * @param {?} docEmpresa
     * @return {?}
     */
    AutorizacionesComponent.prototype.viewAprobar = /**
     * @param {?} idAut
     * @param {?} docEmpresa
     * @return {?}
     */
    function (idAut, docEmpresa) {
        console.log("viewAprobar autorizacion", idAut, docEmpresa);
        this.idAutorizacion = idAut;
        this.codEmpresaAut = docEmpresa;
        this.showDialogAprobar('Autorización', 'Esta seguro que desea aprobar la autorización ' + idAut + '?', true, true);
    };
    /**
     * @param {?} idAut
     * @param {?} docEmpresa
     * @return {?}
     */
    AutorizacionesComponent.prototype.viewRechazar = /**
     * @param {?} idAut
     * @param {?} docEmpresa
     * @return {?}
     */
    function (idAut, docEmpresa) {
        console.log("viewRechazar autorizacion", idAut, docEmpresa);
        this.idAutorizacion = idAut;
        this.codEmpresaAut = docEmpresa;
        this.showDialogAprobar('Autorización', 'Esta seguro que desea rechazar la autorización ' + idAut + '?', true, false);
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} isAprobar
     * @return {?}
     */
    AutorizacionesComponent.prototype.showDialogAprobar = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} isAprobar
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel, isAprobar) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            if (result) {
                if (isAprobar) {
                    _this.callAprobarAutorizacion(_this.idAutorizacion, 'AUTORIZADA', _this.codEmpresaAut);
                }
                else {
                    _this.callAprobarAutorizacion(_this.idAutorizacion, 'RECHAZADA', _this.codEmpresaAut);
                }
            }
        }));
    };
    /**
     * @param {?} idAutorizacion
     * @param {?} estadoAutorizacion
     * @param {?} codFacturador
     * @return {?}
     */
    AutorizacionesComponent.prototype.callAprobarAutorizacion = /**
     * @param {?} idAutorizacion
     * @param {?} estadoAutorizacion
     * @param {?} codFacturador
     * @return {?}
     */
    function (idAutorizacion, estadoAutorizacion, codFacturador) {
        var _this = this;
        /** @type {?} */
        var params = new EstadoAutorizacionPeticion();
        params.codCliente = this.environment.codCliente;
        params.codEstadoAut = estadoAutorizacion;
        params.idAut = idAutorizacion;
        params.idAutorizador = this.userPerfil.usuario.idUsuario;
        params.docEmpresa = codFacturador;
        this.loader.show();
        this.service.postCambiaEstadoAutorizacion(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.showDialogInformativo('Autorización', 'Autorización modificada con éxito', false);
                _this.callListaAutorizaciones();
            }
            else {
                console.error('Error al cambiar estado de autorización', data.descret);
                _this.showDialogInformativo('Error', 'Error al tratar de modificar la autorización, intente nuevamente.<br>' + data.descret, false);
            }
            _this.loader.hide();
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en servicio cambia estado autorización', err);
            _this.showDialogInformativo('Error', 'Error en servicio para modificar la autorización, contáctese con administrador.', false);
            _this.loader.hide();
        }));
    };
    /**
     * @return {?}
     */
    AutorizacionesComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        this.onSubmit('');
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AutorizacionesComponent.prototype.selectfechaRegistro = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.logFechaEscogida = formatDate(event.value, 'dd/MM/yyyy', 'en-US');
        this.firstFormGroup.get('fechaAdd').setValue(this.logFechaEscogida);
    };
    AutorizacionesComponent.decorators = [
        { type: Component, args: [{
                    selector: 'solicitudes',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"modulo-filtros\">\r\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n     </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"firstFormGroup\" (ngSubmit)=\"validarForm()\" autocomplete=\"off\">\r\n              <div class=\"form-row align-left\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"filtro-fecha\">\r\n                    <button type=\"button\" class=\"btn fecha\" (click)=\"picker1.open()\"><i class=\"str-icon-calendario\"></i> Buscar por fecha de registro\r\n                      <ng-container *ngIf=\"this.firstFormGroup.get('fechaAdd').value != null && logFechaEscogida != '01/01/2000'\">\r\n                        <span>{{ logFechaEscogida }}</span>\r\n                      </ng-container>\r\n                    </button>\r\n                    <mat-form-field style=\"display: none;\">\r\n                      <input matInput placeholder=\"Fecha\" [max]=\"unavailabilityForm.controls.endDate.value\"  [satDatepicker]=\"picker1\" formControlName=\"fechaAdd\" (dateInput)=\"selectfechaRegistro($event)\">\r\n                      <sat-datepicker-toggle matSuffix [for]=\"picker1\"></sat-datepicker-toggle>\r\n                      <sat-datepicker touchUi #picker1 [rangeMode]=\"false\" [selectFirstDateOnClose]=\"true\"></sat-datepicker>\r\n                    </mat-form-field>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-row\">\r\n                <div class=\"form-group col-md-6\" *ngIf=\"codTpoPortal != 'COMERCIO'\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"empresa\">\r\n                      <mat-option *ngFor=\"let empresa of resultadoEmpresas\" [value]=\"empresa.docFacturador\" (click)=\"setSelectedText('empresa', empresa.nomFacturador)\">{{empresa.nomFacturador}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-md-6\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Estados\" formControlName=\"estado\">\r\n                      <mat-option *ngFor=\"let est of estadosAutorizacion\" [value]=\"est.codEstado\" (click)=\"setSelectedText('estado', est.dscEstado)\">{{est.dscEstado}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"actions\">\r\n                <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\">Filtrar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-container table-responsive-md\">\r\n        <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n          <ng-container matColumnDef=\"idAut\">\r\n            <th mat-header-cell *matHeaderCellDef>Id</th>\r\n            <td mat-cell *matCellDef=\"let element\"> {{element.idAut}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"razSocialEmpresa\">\r\n            <th mat-header-cell *matHeaderCellDef>Empresa</th>\r\n            <td mat-cell *matCellDef=\"let element\"> {{element.razSocialEmpresa}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"dscEvento\">\r\n            <th mat-header-cell *matHeaderCellDef>Evento</th>\r\n            <td mat-cell *matCellDef=\"let element\"> {{element.dscEvento}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"idEntidad\">\r\n            <th mat-header-cell *matHeaderCellDef>Id Entidad</th>\r\n            <td mat-cell *matCellDef=\"let element\"> {{element.idEntidad}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"nomUsuarioAut\">\r\n            <th mat-header-cell *matHeaderCellDef>Nombre Autorizador</th>\r\n            <td mat-cell *matCellDef=\"let element\"> {{element.nomUsuarioAut}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fecAddAut\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha</th>\r\n            <td mat-cell *matCellDef=\"let element\"> {{element.fecAddAut}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"dscAutStd\">\r\n            <th mat-header-cell *matHeaderCellDef>Estado</th>\r\n            <td mat-cell *matCellDef=\"let element\"> {{element.dscAutStd}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"detalle\">\r\n            <th mat-header-cell *matHeaderCellDef>Ver</th>\r\n            <td mat-cell *matCellDef=\"let element\"><span matTooltip=\"Ver detalle\" matTooltipPosition=\"above\" (click)=\"viewDetalle(element.idAut)\" class=\"material-icons\">info</span></td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"rechazar\">\r\n            <th mat-header-cell *matHeaderCellDef>Rechazar</th>\r\n            <td mat-cell *matCellDef=\"let element\"><span *ngIf=\"element.codAutStd == 'PENDIENTE'\" matTooltip=\"Rechazar\" matTooltipPosition=\"above\" (click)=\"viewRechazar(element.idAut, element.docEmpresa)\" class=\"material-icons\">close</span></td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"aprobar\">\r\n            <th mat-header-cell *matHeaderCellDef>Aprobar</th>\r\n            <td mat-cell *matCellDef=\"let element\"><span *ngIf=\"element.codAutStd == 'PENDIENTE'\" matTooltip=\"Aprobar\" matTooltipPosition=\"above\" (click)=\"viewAprobar(element.idAut, element.docEmpresa)\" class=\"material-icons\">check</span></td>\r\n          </ng-container>\r\n\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\">\r\n          </tr>\r\n        </table>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" showFirstLastButtons></mat-paginator>\r\n      </div>\r\n\r\n      <div class=\"box-actions\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6 item\">\r\n            <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n          </div>\r\n          <div class=\"col-md-6 item-right\">\r\n            <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </section>\r\n\r\n    <div class=\"modulo-cuentas\" *ngIf=\"!show\">\r\n      <span>No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.</span>\r\n    </div>\r\n\r\n  </div>\r\n</section>",
                    providers: [{ provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
                        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
                        { provide: MAT_DATE_FORMATS, useValue: ɵ0$2 }]
                }] }
    ];
    /** @nocollapse */
    AutorizacionesComponent.ctorParameters = function () { return [
        { type: EmpresasService },
        { type: AutorizacionDetalle },
        { type: AutorizacionesService },
        { type: EmpresasService },
        { type: MatDialog },
        { type: LoaderBaseService },
        { type: Router },
        { type: ActivatedRoute },
        { type: FormBuilder },
        { type: DatePipe },
        { type: DescargaExcelPdfFileService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    AutorizacionesComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator,] }]
    };
    return AutorizacionesComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AutorizacionMenuComponent = /** @class */ (function () {
    function AutorizacionMenuComponent() {
    }
    /**
     * @return {?}
     */
    AutorizacionMenuComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    AutorizacionMenuComponent.decorators = [
        { type: Component, args: [{
                    selector: 'autorizacion-solicitudes',
                    template: "<section id=\"portal-comercio\" style=\"padding-bottom: 0px; padding-top: 0px;\">\r\n    <div class=\"container\">\r\n        <h3 class=\"titulo-seccion\" style=\"padding: 0 0 8px 8px;\">Autorizaciones</h3>\r\n        <div class=\"menu-pills\">\r\n            <div [routerLink]=\"['solicitudes']\" [routerLinkActive]=\"['active']\" class=\"item first\">Solicitudes</div>\r\n            <div [routerLink]=\"['configuracion']\" [routerLinkActive]=\"['active']\" class=\"item\">Configuraci&oacute;n</div>\r\n            <div [routerLink]=\"['autorizadores']\" [routerLinkActive]=\"['active']\" class=\"item last\">Autorizadores</div>\r\n        </div>\r\n    </div>\r\n</section>\r\n<router-outlet></router-outlet>"
                }] }
    ];
    /** @nocollapse */
    AutorizacionMenuComponent.ctorParameters = function () { return []; };
    return AutorizacionMenuComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConfiguracionesAutorizacionPeticion = /** @class */ (function () {
    function ConfiguracionesAutorizacionPeticion() {
        this.codCliente = '';
        this.docEmpresa = '';
        this.codEvento = '';
        this.codTipoPortal = '';
        this.idConfig = -1;
        this.codEstado = '';
        this.filtros = [];
    }
    return ConfiguracionesAutorizacionPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var empresaValidCnv = /** @class */ (function () {
    function empresaValidCnv() {
        this.docEmp = "";
    }
    return empresaValidCnv;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RubroRequest = /** @class */ (function () {
    function RubroRequest() {
        this.codEstadoConvenio = '-1';
        this.idUser = '-1';
    }
    return RubroRequest;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CustomValidators = /** @class */ (function () {
    function CustomValidators() {
    }
    /**
    * @description
    * Funcion para validar textos como nombres y apellidos
    * Acepta solamente:
    * - letras mayusculas y minusculas
    * - letras con tildes, incluida la enie
    * - espacios en blanco
    */
    /**
     * \@description
     * Funcion para validar textos como nombres y apellidos
     * Acepta solamente:
     * - letras mayusculas y minusculas
     * - letras con tildes, incluida la enie
     * - espacios en blanco
     * @param {?} control
     * @return {?}
     */
    CustomValidators.nameValidator = /**
     * \@description
     * Funcion para validar textos como nombres y apellidos
     * Acepta solamente:
     * - letras mayusculas y minusculas
     * - letras con tildes, incluida la enie
     * - espacios en blanco
     * @param {?} control
     * @return {?}
     */
    function (control) {
        /** @type {?} */
        var regex = new RegExp('[^\\u0041-\\u005A\\u0061-\\u007A\\u00C1\\u00C9\\u00CD\\u00D3\\u00DA\\u00F1\\u00D1\\u0020\\u00E1\\u00E9\\u00ED\\u00F3\\u00FA]');
        /** @type {?} */
        var texto = control.value;
        if (texto == null || texto == 'null' || texto == undefined) {
            return null;
        }
        if (texto.length === 0) {
            return null;
        }
        /** @type {?} */
        var validacion = true;
        if (texto.trim().length === 0) {
            validacion = false;
        }
        else if (regex.test(control.value)) {
            validacion = false;
        }
        //console.log('nameValidator texto', texto, 'validacion', validacion);
        return validacion ? null : { 'nameError': { value: control.value } };
    };
    /**
     * @description
     * Funcion para validar textos como descripciones
     * Acepta solamente:
     * - letras mayusculas y minusculas
     * - numeros., letras con tildes, incluida la enie
     * - espacios en blanco
     * - puntos, comas, signo de suma y resta
     * - guion bajo, ampersand y dos puntos
     * - Parentesis normales
     */
    /**
     * \@description
     * Funcion para validar textos como descripciones
     * Acepta solamente:
     * - letras mayusculas y minusculas
     * - numeros., letras con tildes, incluida la enie
     * - espacios en blanco
     * - puntos, comas, signo de suma y resta
     * - guion bajo, ampersand y dos puntos
     * - Parentesis normales
     * @param {?} control
     * @return {?}
     */
    CustomValidators.descriptionValidator = /**
     * \@description
     * Funcion para validar textos como descripciones
     * Acepta solamente:
     * - letras mayusculas y minusculas
     * - numeros., letras con tildes, incluida la enie
     * - espacios en blanco
     * - puntos, comas, signo de suma y resta
     * - guion bajo, ampersand y dos puntos
     * - Parentesis normales
     * @param {?} control
     * @return {?}
     */
    function (control) {
        /** @type {?} */
        var regex = new RegExp('[^\\u0030-\\u0039\\u0041-\\u005A\\u0061-\\u007A\\u00C1\\u00C9\\u00CD\\u00D3\\u00DA\\u00F1\\u00D1\\u002D\\u0020\\u002B\\u005F\\u00E1\\u00E9\\u00ED\\u00F3\\u00FA\\u002C\\u002E\\u0026\\u003A\\u0028\\u0029]');
        /** @type {?} */
        var texto = control.value;
        if (texto == null || texto == 'null' || texto == undefined) {
            return null;
        }
        if (texto.length === 0) {
            return null;
        }
        /** @type {?} */
        var validacion = true;
        if (texto.trim().length === 0) {
            validacion = false;
        }
        else if (regex.test(control.value)) {
            validacion = false;
        }
        //console.log('descriptionValidator texto', texto, 'validacion', validacion);
        return validacion ? null : { 'descriptionError': { value: control.value } };
    };
    /**
     * @description
     * Funcion para validar textos como identificador de servicio
     * Acepta solamente:
     * - letras mayusculas y minusculas
     * - numeros
     * - signo de resta y guion bajo
     */
    /**
     * \@description
     * Funcion para validar textos como identificador de servicio
     * Acepta solamente:
     * - letras mayusculas y minusculas
     * - numeros
     * - signo de resta y guion bajo
     * @param {?} control
     * @return {?}
     */
    CustomValidators.idServiceValidator = /**
     * \@description
     * Funcion para validar textos como identificador de servicio
     * Acepta solamente:
     * - letras mayusculas y minusculas
     * - numeros
     * - signo de resta y guion bajo
     * @param {?} control
     * @return {?}
     */
    function (control) {
        /** @type {?} */
        var regex = new RegExp('[^\\u0030-\\u0039\\u0041-\\u005A\\u0061-\\u007A\\u002D\\u005F]');
        /** @type {?} */
        var texto = control.value;
        if (texto == null || texto == 'null' || texto == undefined) {
            return null;
        }
        if (texto.length === 0) {
            return null;
        }
        /** @type {?} */
        var validacion = true;
        if (texto.trim().length === 0) {
            validacion = false;
        }
        else if (regex.test(control.value)) {
            validacion = false;
        }
        //console.log('idServiceValidator texto', texto, 'validacion', validacion);
        return validacion ? null : { 'idServiceError': { value: control.value } };
    };
    /**
     * @description
     * Funcion para validar marca de tarjeta de credito
    */
    /**
     * \@description
     * Funcion para validar marca de tarjeta de credito
     * @param {?} control
     * @return {?}
     */
    CustomValidators.cardNumberValidator = /**
     * \@description
     * Funcion para validar marca de tarjeta de credito
     * @param {?} control
     * @return {?}
     */
    function (control) {
        /** @type {?} */
        var validacion = false;
        /** @type {?} */
        var cardNumber = control.value;
        if (cardNumber == null || cardNumber == 'null' || cardNumber == undefined) {
            return null;
        }
        if (cardNumber.length === 0) {
            return null;
        }
        /** @type {?} */
        var bin6digits = cardNumber.substring(0, 6);
        /** @type {?} */
        var bin2digits = cardNumber.substring(0, 2);
        /** @type {?} */
        var bin1digits = cardNumber.substring(0, 1);
        if (cardNumber.length == 15 && (Number(bin2digits) == 34 || Number(bin2digits) == 37)) {
            //AMEX
            validacion = true;
        }
        else if (cardNumber.length == 16 && ((Number(bin6digits) >= 510000 && Number(bin6digits) <= 559999) || (Number(bin6digits) >= 222100 && Number(bin6digits) <= 272099))) {
            //MASTER
            validacion = true;
        }
        else if (cardNumber.length <= 19 && ((Number(bin2digits) == 50) || (Number(bin2digits) >= 56 && Number(bin2digits) <= 64) || (Number(bin2digits) >= 66 && Number(bin2digits) <= 69))) {
            //MAESTRO
            validacion = true;
        }
        else if (cardNumber.length <= 19 && (Number(bin1digits) == 4)) {
            //VISA
            validacion = true;
        }
        return validacion ? null : { 'cardNumberError': { value: control.value } };
    };
    /**
     * @description
     * Funcion para validar RUT Chileno
     */
    /**
     * \@description
     * Funcion para validar RUT Chileno
     * @param {?} control
     * @return {?}
     */
    CustomValidators.rutValidator = /**
     * \@description
     * Funcion para validar RUT Chileno
     * @param {?} control
     * @return {?}
     */
    function (control) {
        /** @type {?} */
        var rut = control.value;
        if (rut == '' || rut == 'null' || rut == undefined)
            return null;
        rut = rut.trim();
        rut = rut.replace('.', '').replace('-', '');
        /** @type {?} */
        var factor = 2;
        /** @type {?} */
        var suma = 0;
        /** @type {?} */
        var l = rut.length - 1;
        /** @type {?} */
        var digitoOriginal = rut.slice(-1).toLowerCase();
        /** @type {?} */
        var digitoCalculado;
        while (l--) {
            suma += +rut[l] * factor;
            factor = factor === 7 ? 2 : ++factor;
        }
        digitoCalculado = 11 - (suma % 11);
        digitoCalculado = digitoCalculado === 11 ? 0 : (digitoCalculado === 10 ? 'k' : digitoCalculado);
        if (digitoCalculado != digitoOriginal) {
            return { 'rutError': true };
        }
        else {
            return null;
        }
    };
    /**
     * @description
     * Funcion para validar Cedula Uruguaya
     */
    /**
     * \@description
     * Funcion para validar Cedula Uruguaya
     * @param {?} control
     * @return {?}
     */
    CustomValidators.validatorCedulaUY = /**
     * \@description
     * Funcion para validar Cedula Uruguaya
     * @param {?} control
     * @return {?}
     */
    function (control) {
        /** @type {?} */
        var cedula = control.value;
        if (cedula == '' || cedula == 'null' || cedula == undefined)
            return null;
        cedula = cedula.trim();
        cedula = cedula.replace('.', '').replace('-', '');
        /** @type {?} */
        var ret = 0;
        if (cedula.match(/^[0-9]+$/)) {
            //relleno 0 al inicio si la cedula es <= 6
            if (cedula.length <= 7) {
                for (var i = cedula.length; i < 8; i++) {
                    cedula = '0' + cedula;
                }
            }
            /** @type {?} */
            var numValidar = cedula.substring(0, cedula.length - 1);
            /** @type {?} */
            var digitoVerificador = parseInt(cedula.charAt(cedula.length - 1));
            /** @type {?} */
            var verificadores = [2, 9, 8, 7, 6, 3, 4];
            /** @type {?} */
            var sum = 0;
            for (var i = 0; i <= cedula.length - 2; i++) {
                sum += parseInt(numValidar.charAt(i)) * verificadores[i];
            }
            /** @type {?} */
            var verifica = (10 - (sum % 10)) % 10;
            if (digitoVerificador == verifica) {
                ret = 1;
            }
        }
        if (ret == 0) {
            return { 'cedulaError': true };
        }
        return null;
    };
    /**
     * @description
     * Funcion para validar Rut Uruguayo
     */
    /**
     * \@description
     * Funcion para validar Rut Uruguayo
     * @param {?} control
     * @return {?}
     */
    CustomValidators.rutValidatorUY = /**
     * \@description
     * Funcion para validar Rut Uruguayo
     * @param {?} control
     * @return {?}
     */
    function (control) {
        /** @type {?} */
        var rut = control.value;
        if (rut == '' || rut == 'null' || rut == undefined)
            return null;
        rut = rut.trim();
        rut = rut.replace('.', '').replace('-', '');
        if (rut.length != 12) {
            return { 'rutUYError': true };
        }
        if (!/^([0-9])*$/.test(rut)) {
            return null;
        }
        /** @type {?} */
        var dc = rut.charAt(rut.length - 1);
        rut = rut.substring(0, rut.length - 1);
        /** @type {?} */
        var total = 0;
        /** @type {?} */
        var factor = 2;
        for (var i = 10; i >= 0; i--) {
            total += (factor * parseInt(rut.charAt(i)));
            factor = (factor == 9) ? 2 : ++factor;
        }
        /** @type {?} */
        var dv = 11 - (total % 11);
        if (dv == 11) {
            dv = 0;
        }
        else if (dv == 10) {
            dv = 1;
        }
        if (dv != parseInt(dc)) {
            return { 'rutUYError': true };
        }
        return null;
    };
    /**
     * @private
     * @param {?} num
     * @param {?} digito
     * @return {?}
     */
    CustomValidators.validarDigitoVerificador = /**
     * @private
     * @param {?} num
     * @param {?} digito
     * @return {?}
     */
    function (num, digito) {
        /** @type {?} */
        var verificadores = [2, 9, 8, 7, 6, 3, 4];
        /** @type {?} */
        var sum = 0;
        for (var i = 0; i <= 6; i++) {
            /** @type {?} */
            var numero = parseInt(num[i]);
            sum += numero * verificadores[i];
        }
        if (digito == (10 - (sum % 10)) % 10) {
            return 1;
        }
        return 0;
    };
    /**
     * @description
     * Funcion para validar solo numeros
     */
    /**
     * \@description
     * Funcion para validar solo numeros
     * @param {?} control
     * @return {?}
     */
    CustomValidators.numberValidator = /**
     * \@description
     * Funcion para validar solo numeros
     * @param {?} control
     * @return {?}
     */
    function (control) {
        /** @type {?} */
        var regex = new RegExp('[^\\u0030-\\u0039]');
        /** @type {?} */
        var texto = '';
        texto = texto + control.value;
        if (texto == null || texto == 'null' || texto == undefined) {
            return null;
        }
        if (texto.length === 0) {
            return null;
        }
        /** @type {?} */
        var validacion = true;
        if (texto.trim().length === 0) {
            validacion = false;
        }
        else if (regex.test(control.value)) {
            validacion = false;
        }
        //console.log('numberValidator texto', texto, 'validacion', validacion);
        return validacion ? null : { 'numberError': { value: control.value } };
    };
    /**
    * @description
    * Funcion para validar solo numeros positivos (menos 0)
    */
    /**
     * \@description
     * Funcion para validar solo numeros positivos (menos 0)
     * @param {?} control
     * @return {?}
     */
    CustomValidators.numberValidatorNonZero = /**
     * \@description
     * Funcion para validar solo numeros positivos (menos 0)
     * @param {?} control
     * @return {?}
     */
    function (control) {
        /** @type {?} */
        var regex = new RegExp('[^\\u0030-\\u0039]');
        /** @type {?} */
        var texto = '';
        texto = texto + control.value;
        if (texto == null || texto == 'null' || texto == undefined) {
            return null;
        }
        if (texto.length === 0) {
            return null;
        }
        /** @type {?} */
        var validacion = true;
        if (texto.trim().length === 0) {
            validacion = false;
        }
        else if (regex.test(control.value)) {
            validacion = false;
        }
        if (texto == '0') {
            validacion = false;
        }
        //console.log('numberValidator texto', texto, 'validacion', validacion);
        return validacion ? null : { 'numberError': { value: control.value } };
    };
    /**
     * @description
     * Funcion para validar monto con punto de miles
     */
    /**
     * \@description
     * Funcion para validar monto con punto de miles
     * @param {?} control
     * @return {?}
     */
    CustomValidators.amountValidator = /**
     * \@description
     * Funcion para validar monto con punto de miles
     * @param {?} control
     * @return {?}
     */
    function (control) {
        /** @type {?} */
        var regex = new RegExp('[^\\u0030-\\u0039\\u002E\\u002C]');
        /** @type {?} */
        var texto = control.value;
        if (texto == null || texto.length === 0) {
            return null;
        }
        /** @type {?} */
        var validacion = true;
        if (texto.trim().length == 0) {
            validacion = false;
        }
        else if (regex.test(control.value)) {
            validacion = false;
        }
        //console.log('amountValidator texto', texto, 'validacion', validacion);
        return validacion ? null : { 'amountError': { value: control.value } };
    };
    /**
     * @param {?} control
     * @return {?}
     */
    CustomValidators.validaMes = /**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        /** @type {?} */
        var mes = control.get('mesMedioPago').value;
        if (mes == '' || mes == 'null' || mes == undefined)
            return null;
        /** @type {?} */
        var mesNumero = Number.parseInt(mes);
        /** @type {?} */
        var hoy = new Date();
        /** @type {?} */
        var mesHoy = hoy.getMonth() + 1;
        /** @type {?} */
        var anhoHoy = (hoy.getFullYear()).toString();
        /** @type {?} */
        var anhoHoyValue = Number.parseInt((anhoHoy + "").substr(2, 4));
        /** @type {?} */
        var anho = control.get('anioMedioPago').value;
        /** @type {?} */
        var anhoValue = Number.parseInt(anho);
        if (anho != '') {
            if (anhoValue == anhoHoyValue) {
                if (mesNumero < mesHoy) {
                    control.get('mesMedioPago').setErrors({ 'errorMes': true });
                    return { 'errorMes': true };
                }
                else {
                    return null;
                }
            }
            else {
                control.get('mesMedioPago').setErrors(null);
                return null;
            }
        }
        else {
            return null;
        }
    };
    /**
     * @param {?} control
     * @return {?}
     */
    CustomValidators.validaEmail = /**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        /** @type {?} */
        var regex = new RegExp('^(([^<>()[\\]\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$');
        /** @type {?} */
        var texto = control.value;
        if (texto == null || texto.length === 0) {
            return null;
        }
        /** @type {?} */
        var validacion = true;
        if (texto.trim().length === 0) {
            validacion = false;
        }
        else if (!regex.test(control.value)) {
            validacion = false;
        }
        // console.log('nameValidator texto', texto, 'validacion', validacion, 'control_value', control.value);
        return validacion ? null : { 'email': { value: control.value } };
    };
    /**
     * @description
     * Funcion que elimina los puntos decimales.
     */
    /**
     * \@description
     * Funcion que elimina los puntos decimales.
     * @param {?} str
     * @return {?}
     */
    CustomValidators.validaMonto = /**
     * \@description
     * Funcion que elimina los puntos decimales.
     * @param {?} str
     * @return {?}
     */
    function (str) {
        /** @type {?} */
        var newstr = (str).replace(/,/g, '').replace(/\./g, '');
        if (newstr) {
            newstr = (Number.parseInt(newstr)).toString();
        }
        return newstr;
    };
    return CustomValidators;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$3 = MAT_MOMENT_DATE_FORMATS;
var ConveniosAgregarComponent = /** @class */ (function () {
    function ConveniosAgregarComponent(phttp, environment, dialog, router, route, authServices) {
        this.phttp = phttp;
        this.environment = environment;
        this.dialog = dialog;
        this.router = router;
        this.route = route;
        this.authServices = authServices;
        this.formGroup = new FormGroup({
            identificadorEmpresa: new FormControl('', Validators.required),
            rubro: new FormControl('', Validators.required),
            empresa: new FormControl('', Validators.required),
            descripcionConvenio: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(65), CustomValidators.descriptionValidator])),
            inicioVigencia: new FormControl('', Validators.required),
            terminoVigencia: new FormControl(Validators.required),
            utilizaPromotor: new FormControl(false, Validators.required),
            etiquetaPromotor: new FormControl('')
        });
        this.resultadoRubros = [];
        this.peticionEmpresa = new EmpresasPeticion();
        this.minDate = new Date();
        this.etiquetaPromotor = '';
        this.utilizaPromotor = false;
        this.requiredAuth = false;
        this.convenioAgregar = JSON.parse(sessionStorage.getItem('convenioAgregar'));
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idUsuario = this.userPerfil.usuario.idUsuario;
        this.preLoginsLS = JSON.parse(sessionStorage.getItem('preLogin'));
    }
    /**
     * @return {?}
     */
    ConveniosAgregarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.postSentRubrosServices();
        this.formGroup.controls['identificadorEmpresa'].disable();
        this.formGroup.controls['empresa'].disable();
        if (this.convenioAgregar != null) {
            this.peticionEmpresa.codRubro = this.convenioAgregar.rubro.toString();
            this.peticionEmpresa.codCliente = this.environment.codCliente;
            this.postSentSelectEmpresaServices(this.peticionEmpresa);
            this.formGroup.controls['identificadorEmpresa'].setValue(this.convenioAgregar.identificadorEmpresa);
            this.formGroup.controls['rubro'].setValue(this.convenioAgregar.rubro);
            this.formGroup.controls['empresa'].enable();
            this.formGroup.controls['empresa'].setValue(this.convenioAgregar.empresa);
            this.formGroup.controls['descripcionConvenio'].setValue(this.convenioAgregar.descripcionConvenio);
            this.formGroup.controls['inicioVigencia'].setValue(this.convenioAgregar.inicioVigencia);
            this.formGroup.controls['terminoVigencia'].setValue(this.convenioAgregar.terminoVigencia);
            this.utilizaPromotor = this.convenioAgregar.etiquetaPromotor != '';
            this.formGroup.controls['utilizaPromotor'].setValue(this.utilizaPromotor);
            this.formGroup.controls['etiquetaPromotor'].setValue(this.convenioAgregar.etiquetaPromotor);
        }
        else {
            this.formGroup.controls['inicioVigencia'].setValue(new Date());
            this.formGroup.controls['terminoVigencia'].setValue(null);
        }
        this.validaAutorizacion();
    };
    /**
     * @return {?}
     */
    ConveniosAgregarComponent.prototype.postSentRubrosServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var param = new RubroRequest();
        param.codEstadoConvenio = '-1'; //Todos los rubros
        this.phttp.postRubrosReport(param).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoRubros = data.resultado;
            }
            else {
                console.error('Error postRubrosReport: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postRubrosReport: ', err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    ConveniosAgregarComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.phttp.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0' && data.resultado.length > 0) {
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.error('Error postListarEmpresas: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postListarEmpresas: ', err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    ConveniosAgregarComponent.prototype.postSentSelectEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.phttp.postListarSelectEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.error('Error postListarEmpresas: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postListarEmpresas: ', err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ConveniosAgregarComponent.prototype.onRubroSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event != null) {
            this.peticionEmpresa.codRubro = event.value;
            this.peticionEmpresa.codCliente = this.environment.codCliente;
            this.peticionEmpresa.codEstadoEmpresa = 'ACTIVO';
            this.formGroup.controls['empresa'].reset();
            this.formGroup.controls['identificadorEmpresa'].reset();
            this.postSentSelectEmpresaServices(this.peticionEmpresa);
            //this.postSentEmpresaServices(this.peticionEmpresa);
            this.formGroup.controls['empresa'].enable();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ConveniosAgregarComponent.prototype.onEmpresaSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /**
         * @param {?} empresa
         * @return {?}
         */
        function esEmpresa(empresa) {
            return empresa.idFacturador === event.value;
        }
        this.formGroup.controls['identificadorEmpresa'].setValue(this.resultadoEmpresa.find(esEmpresa)['docFacturador']);
        // this.validCnv(this.formGroup.controls['identificadorEmpresa'].value);
    };
    /**
     * @param {?} docEmp
     * @return {?}
     */
    ConveniosAgregarComponent.prototype.validCnv = /**
     * @param {?} docEmp
     * @return {?}
     */
    function (docEmp) {
        var _this = this;
        /** @type {?} */
        var cnv;
        /** @type {?} */
        var fac;
        /** @type {?} */
        var cod;
        console.log("Iniciando validacion " + docEmp);
        /** @type {?} */
        var empCnv = new empresaValidCnv();
        empCnv.docEmp = docEmp;
        this.phttp.postEmpresaValidarCnv(empCnv).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            cnv = data['cnv'];
            fac = data['fac'];
            cod = data['codret'];
            if (cod == 0) {
                _this.msgExistCnv(cnv, fac);
            }
        }));
    };
    /**
     * @param {?} cnv
     * @param {?} fac
     * @return {?}
     */
    ConveniosAgregarComponent.prototype.msgExistCnv = /**
     * @param {?} cnv
     * @param {?} fac
     * @return {?}
     */
    function (cnv, fac) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: "Convenio existente", content: "Esta empresa ya posee un convenio, ¿desea editarlo?", showBtnCancel: true },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result.toString());
            if (result == true) {
                _this.router.navigate(['../conveniosEditarAgregar'], { queryParams: { 'idc': cnv, 'idf': fac }, relativeTo: _this.route });
            }
        }));
    };
    /**
     * @return {?}
     */
    ConveniosAgregarComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var inicioVigencia;
        if (this.formGroup.get('inicioVigencia').valid) {
            inicioVigencia = this.formGroup.get('inicioVigencia').value;
        }
        /** @type {?} */
        var terminoVigencia;
        if (this.formGroup.get('terminoVigencia').valid) {
            terminoVigencia = this.formGroup.get('terminoVigencia').value;
        }
        if (!this.utilizaPromotor && this.etiquetaPromotor != "") {
            this.formGroup.controls['etiquetaPromotor'].setValue('');
        }
        if (terminoVigencia == null || (formatDate(terminoVigencia, 'yyyyMMdd', 'en-US') >= formatDate(inicioVigencia, 'yyyyMMdd', 'en-US'))) {
            sessionStorage.setItem('convenioAgregar', JSON.stringify({
                idUsuario: this.idUsuario,
                codCliente: this.environment.codCliente,
                docEmpresa: this.environment.docEmpresa,
                codTpoPortal: this.preLoginsLS.codTpoPortal,
                estadoConvenio: 'TRM',
                idConvenio: -1,
                identificadorEmpresa: this.formGroup.get('identificadorEmpresa').value,
                rubro: this.formGroup.get('rubro').value,
                empresa: this.formGroup.get('empresa').value,
                descripcionConvenio: this.formGroup.get('descripcionConvenio').value,
                inicioVigencia: inicioVigencia,
                terminoVigencia: terminoVigencia,
                etiquetaPromotor: this.formGroup.get('etiquetaPromotor').value
            }));
            this.router.navigate(['../conveniosPago'], { relativeTo: this.route });
        }
        else {
            this.showDialog('Información', 'Verifique las fechas de inicio y término de vigencia', false);
        }
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ConveniosAgregarComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result.toString());
        }));
    };
    /**
     * @return {?}
     */
    ConveniosAgregarComponent.prototype.validaAutorizacion = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new ConfiguracionesAutorizacionPeticion();
        params.codCliente = this.environment.codCliente;
        params.codEstado = 'ACTIVA';
        params.codEvento = 'ADDCNV';
        params.codTipoPortal = 'ADQUIRENTE';
        params.docEmpresa = '-1';
        this.authServices.postListaConfigAutorizaciones(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                if (data.configuraciones.length > 0) {
                    _this.requiredAuth = true;
                    sessionStorage.setItem('requiredAuth_ADDCNV', 'true');
                }
                else {
                    sessionStorage.setItem('requiredAuth_ADDCNV', 'false');
                }
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en postListaConfigAutorizaciones', err);
        }));
    };
    /**
     * @param {?} valor
     * @return {?}
     */
    ConveniosAgregarComponent.prototype.showUtilizaPromotor = /**
     * @param {?} valor
     * @return {?}
     */
    function (valor) {
        this.utilizaPromotor = valor;
        if (valor) {
            this.formGroup.controls['etiquetaPromotor'].setValidators([Validators.required]);
            this.formGroup.controls['etiquetaPromotor'].updateValueAndValidity();
        }
        else {
            this.formGroup.controls['etiquetaPromotor'].setValue('');
            this.formGroup.controls['etiquetaPromotor'].clearValidators();
            this.formGroup.controls['etiquetaPromotor'].updateValueAndValidity();
        }
    };
    /**
     * @return {?}
     */
    ConveniosAgregarComponent.prototype.onEtiquetaPromotorSelect = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var etiquetaPromotor = this.formGroup.get('etiquetaPromotor').value;
        if (this.utilizaPromotor && etiquetaPromotor.length == 0) {
            this.formGroup.controls['etiquetaPromotor'].setValidators([Validators.required]);
            this.formGroup.controls['etiquetaPromotor'].updateValueAndValidity();
        }
    };
    ConveniosAgregarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-convenios-agregar',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a [routerLink]=\"['../convenios']\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <h3>Agregar convenio <span style=\"color:#CC0000;font-size: 18px;\" *ngIf=\"requiredAuth\">(* Requiere autorizaci&oacute;n)</span></h3>\r\n          <div class=\"menu-pills\">\r\n            <a>\r\n              <div class=\"item first active\">Datos generales</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item\">Reglas de pago</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item\">Intercambio</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item last\">Gr\u00E1fica</div>\r\n            </a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <form [formGroup]=\"formGroup\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n        <div class=\"form-section\">\r\n          <h5>Informaci\u00F3n del comercio</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-4 col-md-3\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Rubro\" formControlName=\"rubro\" (selectionChange)=\"onRubroSelect($event)\">\r\n                  <mat-option *ngFor=\"let rubro of resultadoRubros\" [value]=\"rubro.codigo\">{{rubro.descripcion}}</mat-option>\r\n                </mat-select>\r\n                <mat-error *ngIf=\"formGroup.get('rubro').invalid\">Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-6\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"empresa\" (selectionChange)=\"onEmpresaSelect($event)\">\r\n                  <mat-option class=\"text-breakword\" *ngFor=\"let empresa of resultadoEmpresa\" [value]=\"empresa.idFacturador\">{{empresa.nomFacturador}}</mat-option>\r\n                </mat-select>\r\n                <mat-error *ngIf=\"formGroup.get('empresa').invalid\">Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-3\">\r\n              <mat-form-field>\r\n                <input matInput placeholder=\"RUT empresa\" soloRutUY formatRut formControlName=\"identificadorEmpresa\">\r\n                <mat-error *ngIf=\"formGroup.get('identificadorEmpresa').hasError('rutUYError')\">RUT <strong>incorrecto</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-section\">\r\n          <h5>Datos del convenio</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-12\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"65\" placeholder=\"Descripci\u00F3n del convenio\" formControlName=\"descripcionConvenio\">\r\n                <mat-error *ngIf=\"formGroup.get('descripcionConvenio').invalid\">Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row align-left\">\r\n            <div class=\"col-md-3\">\r\n              <div class=\"filtro-fecha\">\r\n                <mat-form-field>\r\n                  <input matInput [matDatepicker]=\"picker\" [min]=\"minDate\" placeholder=\"Inicio vigencia\" formControlName=\"inicioVigencia\"><!-- (dateChange)=\"onInicioVigenciaSelect($event)\" -->\r\n                  <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\r\n                  <mat-datepicker touchUi #picker></mat-datepicker>\r\n                  <mat-error *ngIf=\"formGroup.get('inicioVigencia').invalid\">Valor no v\u00E1lido.</mat-error>\r\n                </mat-form-field>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-3\">\r\n              <div class=\"filtro-fecha\">\r\n                <mat-form-field>\r\n                  <input matInput [matDatepicker]=\"pickerTermino\" [min]=\"minDate\" placeholder=\"T\u00E9rmino vigencia\" formControlName=\"terminoVigencia\">\r\n                  <mat-datepicker-toggle matSuffix [for]=\"pickerTermino\"></mat-datepicker-toggle>\r\n                  <mat-datepicker touchUi #pickerTermino></mat-datepicker>\r\n                  <mat-error *ngIf=\"formGroup.get('terminoVigencia').invalid\">Valor no v\u00E1lido.</mat-error>\r\n                </mat-form-field>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-3\" style=\"padding: 10px 5px;\">\r\n              <div class=\"form-check form-check-inline\">\r\n                <mat-checkbox class=\"example-margin\" formControlName=\"utilizaPromotor\" (change)=\"showUtilizaPromotor($event.checked)\">Utiliza Promotor</mat-checkbox>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"col-md-3\" *ngIf=\"utilizaPromotor\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"65\" placeholder=\"Etiqueta promotor\" formControlName=\"etiquetaPromotor\" (change)=\"onEtiquetaPromotorSelect()\">\r\n                <mat-error *ngIf=\"formGroup.get('etiquetaPromotor').invalid\">Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col align-left\">\r\n            <button class=\"btn text\" type=\"reset\" [routerLink]=\"['../convenios']\"><i class=\"str-icon-flecha-izquierda\"></i>CANCELAR</button>\r\n          </div>\r\n          <div class=\"col align-right\">\r\n            <button *ngIf=\"formGroup.invalid\" class=\"btn main\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i></button>\r\n            <button *ngIf=\"formGroup.valid\" class=\"btn main\" type=\"submit\" (click)=\"onSubmit()\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i></button><!-- [routerLink]=\"['../conveniosPago']\" -->\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [{ provide: MAT_DATE_LOCALE$1, useValue: 'es' },
                        { provide: DateAdapter$1, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE$1] },
                        { provide: MAT_DATE_FORMATS$1, useValue: ɵ0$3 }, EmpresasService]
                }] }
    ];
    /** @nocollapse */
    ConveniosAgregarComponent.ctorParameters = function () { return [
        { type: EmpresasService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] },
        { type: MatDialog },
        { type: Router },
        { type: ActivatedRoute },
        { type: AutorizacionesService }
    ]; };
    return ConveniosAgregarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConveniosPeticion = /** @class */ (function () {
    function ConveniosPeticion() {
        this.codigoConvenio = '-1';
        this.identificadorEmpresa = '-1';
        this.nombreEmpresa = '-1';
        this.estado = '-1';
        this.rubro = '-1';
        this.idConvenio = -1;
        this.codCliente = '-1';
        this.filtros = [];
    }
    return ConveniosPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var httpOptions$5 = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};
var ConveniosService = /** @class */ (function () {
    function ConveniosService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlConvenio = this.environment.urlAmbiente + '/apiConvenioMT/listarConvenio';
        this.urlConvenioEstado = this.environment.urlAmbiente + '/apiConvenioMT/convenioEstado';
        this.urlConvenioImagen = this.environment.urlAmbiente + '/apiConvenioMT/uploadImage';
        this.urlConvenioBuscarImagen = this.environment.urlAmbiente + '/apiConvenioMT/seekImage';
    }
    /**
     * @return {?}
     */
    ConveniosService.prototype.postConvenioEstado = /**
     * @return {?}
     */
    function () {
        return this.http.post(this.urlConvenioEstado, null, httpOptions$5);
    };
    /**
     * @param {?} _body
     * @return {?}
     */
    ConveniosService.prototype.postConveniosList = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlConvenio, _body, httpOptions$5);
    };
    /**
     * @param {?} imagen
     * @return {?}
     */
    ConveniosService.prototype.postConveniosImagen = /**
     * @param {?} imagen
     * @return {?}
     */
    function (imagen) {
        return this.http.post(this.urlConvenioImagen, imagen, httpOptions$5);
    };
    /**
     * @param {?} imagen
     * @return {?}
     */
    ConveniosService.prototype.postConveniosBuscarImagen = /**
     * @param {?} imagen
     * @return {?}
     */
    function (imagen) {
        return this.http.post(this.urlConvenioBuscarImagen, imagen, httpOptions$5);
    };
    ConveniosService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ConveniosService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return ConveniosService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$4 = MAT_MOMENT_DATE_FORMATS;
var ConveniosEditarAgregarComponent = /** @class */ (function () {
    function ConveniosEditarAgregarComponent(phttp, phttpc, route, environment, dialog, router, authServices) {
        this.phttp = phttp;
        this.phttpc = phttpc;
        this.route = route;
        this.environment = environment;
        this.dialog = dialog;
        this.router = router;
        this.authServices = authServices;
        this.formGroup = new FormGroup({
            identificadorEmpresa: new FormControl('', Validators.required),
            rubro: new FormControl('', Validators.required),
            empresa: new FormControl('', Validators.required),
            descripcionConvenio: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(65), CustomValidators.descriptionValidator])),
            inicioVigencia: new FormControl('', Validators.required),
            terminoVigencia: new FormControl(Validators.required),
            estado: new FormControl('', Validators.required),
            utilizaPromotor: new FormControl('', Validators.required),
            etiquetaPromotor: new FormControl('')
        });
        this.resultadoRubros = [];
        this.peticionEmpresa = new EmpresasPeticion();
        this.resultadoEmpresa = [];
        this.peticionReporte = new ConveniosPeticion();
        this.minDate = new Date();
        this.requiredAuth = false;
        this.etiquetaPromotor = '';
        this.utilizaPromotor = false;
        this.convenioAgregar = JSON.parse(sessionStorage.getItem('convenioAgregar'));
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idUsuario = this.userPerfil.usuario.idUsuario;
        this.preLoginsLS = JSON.parse(sessionStorage.getItem('preLogin'));
        //this.idUsuario = 2;
    }
    /**
     * @return {?}
     */
    ConveniosEditarAgregarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        sessionStorage.setItem('componenteHijo', 'lib-convenios-editar-agregar');
        if (this.convenioAgregar == null) {
            this.route.queryParams.subscribe((/**
             * @param {?} params
             * @return {?}
             */
            function (params) {
                _this.peticionReporte.idConvenio = params['idc'];
                _this.idConvenio = params['idc'];
                _this.idFacturador = params['idf'];
            }));
        }
        this.formGroup.controls['rubro'].disable();
        this.formGroup.controls['empresa'].disable();
        this.formGroup.controls['identificadorEmpresa'].disable();
        this.postSentRubrosServices();
        this.postConvenioEstadosServices();
        if (this.convenioAgregar == null) {
            this.postConveniosListServices(this.peticionReporte);
        }
        else {
            this.peticionEmpresa.codRubro = this.convenioAgregar.rubro.toString();
            this.peticionEmpresa.codCliente = this.environment.codCliente;
            this.postSentEmpresaServices(this.peticionEmpresa);
            this.formGroup.controls['estado'].setValue(this.convenioAgregar.estadoConvenio);
            this.formGroup.controls['identificadorEmpresa'].disable();
            this.formGroup.controls['identificadorEmpresa'].setValue(this.convenioAgregar.identificadorEmpresa);
            this.formGroup.controls['rubro'].setValue(this.convenioAgregar.rubro);
            if (this.formGroup.controls['rubro'].value == null) {
                this.formGroup.controls['empresa'].disable();
            }
            this.formGroup.controls['empresa'].setValue(this.convenioAgregar.empresa);
            this.formGroup.controls['descripcionConvenio'].setValue(this.convenioAgregar.descripcionConvenio);
            if (this.convenioAgregar.inicioVigencia == null) {
                this.formGroup.controls['inicioVigencia'].setValue(new Date());
            }
            else {
                this.formGroup.controls['inicioVigencia'].setValue(this.convenioAgregar.inicioVigencia);
                this.minDate = new Date(this.convenioAgregar.inicioVigencia);
            }
            this.formGroup.controls['terminoVigencia'].setValue(this.convenioAgregar.terminoVigencia);
            this.utilizaPromotor = this.convenioAgregar.etiquetaPromotor != '';
            this.formGroup.controls['utilizaPromotor'].setValue(this.utilizaPromotor);
            this.formGroup.controls['etiquetaPromotor'].setValue(this.convenioAgregar.etiquetaPromotor);
        }
        this.validaAutorizacion();
    };
    /**
     * @param {?} body
     * @return {?}
     */
    ConveniosEditarAgregarComponent.prototype.postConveniosListServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.phttpc.postConveniosList(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret = '0') {
                _this.resultadoReporte = [];
                _this.resultadoReporte.push(data);
                _this.formGroup.controls['estado'].setValue(data.resultado[0]['codEstado']);
                _this.formGroup.controls['identificadorEmpresa'].disable();
                _this.formGroup.controls['identificadorEmpresa'].setValue(data.resultado[0]['identificadorEmpresa']);
                _this.formGroup.controls['rubro'].setValue(data.resultado[0]['codRubro']);
                _this.formGroup.controls['empresa'].setValue(parseInt(data.resultado[0]['idFacturador']));
                _this.formGroup.controls['descripcionConvenio'].setValue(data.resultado[0]['descripcion']);
                _this.formGroup.controls['inicioVigencia'].setValue(data.resultado[0]['inicioVigencia']);
                _this.utilizaPromotor = data.resultado[0]['etiquetaPromotor'] ? true : false;
                _this.formGroup.controls['utilizaPromotor'].setValue(_this.utilizaPromotor);
                _this.formGroup.controls['etiquetaPromotor'].setValue(data.resultado[0]['etiquetaPromotor']);
                _this.minDate = data.resultado[0]['inicioVigencia'];
                _this.formGroup.controls['terminoVigencia'].setValue(data.resultado[0]['terminoVigencia']);
                _this.descripcion = data.resultado[0]['descripcionServicio'];
                _this.tipoRendicion = data.resultado[0]['tipoRendicion'];
                _this.tipoCargaFacturacion = data.resultado[0]['tipoCargaFacturacion'];
                _this.tipoCargaMandato = data.resultado[0]['tipoCargaMandato'];
                _this.tipoCargaRendicion = data.resultado[0]['tipoCargaRendicion'];
                _this.confIdFat = data.resultado[0]['confIdFat'];
                _this.confIdMan = data.resultado[0]['confIdMan'];
                _this.confIdRen = data.resultado[0]['confIdRen'];
                _this.peticionEmpresa.codRubro = data.resultado[0]['codRubro'];
                _this.peticionEmpresa.codCliente = _this.environment.codCliente;
                sessionStorage.setItem('dataConvenioE', JSON.stringify(data.resultado[0]));
                _this.postSentEmpresaServices(_this.peticionEmpresa);
            }
            else {
                _this.showDialogError('Error ', data.descret, false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialogError('Error ', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @return {?}
     */
    ConveniosEditarAgregarComponent.prototype.postSentRubrosServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var param = new RubroRequest();
        param.codEstadoConvenio = '-1'; //Todos los rubros
        this.phttp.postRubrosReport(param).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoRubros = data.resultado;
            }
            else {
                console.error('Error postRubrosReport: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postRubrosReport: ', err);
        }));
    };
    /**
     * @return {?}
     */
    ConveniosEditarAgregarComponent.prototype.postConvenioEstadosServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.phttpc.postConvenioEstado().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEstados = data.resultado;
            }
            else {
                console.error('Error en postConvenioEstado: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en postConvenioEstado: ', err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    ConveniosEditarAgregarComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.phttp.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0' && data.resultado.length > 0) {
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.error('Error postListarEmpresas: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postListarEmpresas: ', err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ConveniosEditarAgregarComponent.prototype.onRubroSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.peticionEmpresa.codRubro = event.value;
        this.peticionEmpresa.codCliente = this.environment.codCliente;
        this.formGroup.controls['empresa'].reset();
        this.formGroup.controls['identificadorEmpresa'].reset();
        this.postSentEmpresaServices(this.peticionEmpresa);
        this.formGroup.controls['empresa'].enable();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ConveniosEditarAgregarComponent.prototype.onEmpresaSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /**
         * @param {?} empresa
         * @return {?}
         */
        function esEmpresa(empresa) {
            return empresa.idFacturador === event.value;
        }
        this.formGroup.controls['identificadorEmpresa'].setValue(this.resultadoEmpresa.find(esEmpresa)['docFacturador']);
    };
    /**
     * @return {?}
     */
    ConveniosEditarAgregarComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        /* if (this.peticionAgregar.descripcion == null) {
          this.peticionAgregar.descripcion = this.descripcion;
        } */
        if (!this.utilizaPromotor && this.etiquetaPromotor != '') {
            this.formGroup.controls['etiquetaPromotor'].setValue('');
        }
        if (this.convenioAgregar == null) {
            sessionStorage.setItem('aReglasPagos', JSON.stringify({
                descripcion: this.descripcion,
                idFacturador: this.idFacturador
            }));
        }
        /** @type {?} */
        var inicioVigencia;
        if (this.formGroup.get('inicioVigencia').valid) {
            inicioVigencia = this.formGroup.get('inicioVigencia').value;
        }
        /** @type {?} */
        var terminoVigencia;
        if (this.formGroup.get('terminoVigencia').valid) {
            terminoVigencia = this.formGroup.get('terminoVigencia').value;
        }
        if (terminoVigencia == null || (formatDate(terminoVigencia, 'yyyyMMdd', 'en-US') >= formatDate(inicioVigencia, 'yyyyMMdd', 'en-US'))) {
            sessionStorage.setItem('convenioAgregar', JSON.stringify({
                idUsuario: this.idUsuario,
                codCliente: this.environment.codCliente,
                docEmpresa: this.environment.docEmpresa,
                codTpoPortal: this.preLoginsLS.codTpoPortal,
                //codTpoPortal: 'ADQUIRENTE',
                //idRecaudador: this.environment.codCliente,
                estadoConvenio: this.formGroup.get('estado').value,
                idConvenio: this.idConvenio,
                identificadorEmpresa: this.formGroup.get('identificadorEmpresa').value,
                rubro: this.formGroup.get('rubro').value,
                empresa: this.formGroup.get('empresa').value,
                descripcionConvenio: this.formGroup.get('descripcionConvenio').value,
                inicioVigencia: inicioVigencia,
                terminoVigencia: terminoVigencia,
                tipoRendicion: this.tipoRendicion,
                tipoCargaFacturacion: this.tipoCargaFacturacion,
                tipoCargaMandato: this.tipoCargaMandato,
                tipoCargaRendicion: this.tipoCargaRendicion,
                confIdFat: this.confIdFat,
                confIdMan: this.confIdMan,
                confIdRen: this.confIdRen,
                etiquetaPromotor: this.formGroup.get('etiquetaPromotor').value
            }));
            this.router.navigate(['../conveniosEditarPago'], { relativeTo: this.route });
        }
        else {
            this.showDialog('Información', 'Verifique las fechas de inicio y término de vigencia', false);
        }
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ConveniosEditarAgregarComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result.toString());
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ConveniosEditarAgregarComponent.prototype.showDialogError = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            _this.router.navigate(['../convenios'], { relativeTo: _this.route });
        }));
    };
    /**
     * @return {?}
     */
    ConveniosEditarAgregarComponent.prototype.validaAutorizacion = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new ConfiguracionesAutorizacionPeticion();
        params.codCliente = this.environment.codCliente;
        params.codEstado = 'ACTIVA';
        params.codEvento = 'UPDCNV';
        params.codTipoPortal = 'ADQUIRENTE';
        params.docEmpresa = '-1';
        this.authServices.postListaConfigAutorizaciones(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                if (data.configuraciones.length > 0) {
                    _this.requiredAuth = true;
                    sessionStorage.setItem('requiredAuth_UPDCNV', 'true');
                }
                else {
                    sessionStorage.setItem('requiredAuth_UPDCNV', 'false');
                }
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en postListaConfigAutorizaciones', err);
        }));
    };
    /**
     * @param {?} valor
     * @return {?}
     */
    ConveniosEditarAgregarComponent.prototype.showUtilizaPromotor = /**
     * @param {?} valor
     * @return {?}
     */
    function (valor) {
        this.utilizaPromotor = valor;
        if (valor) {
            this.formGroup.controls['etiquetaPromotor'].setValidators([Validators.required]);
            this.formGroup.controls['etiquetaPromotor'].updateValueAndValidity();
        }
        else {
            this.formGroup.controls['etiquetaPromotor'].setValue('');
            this.formGroup.controls['etiquetaPromotor'].clearValidators();
            this.formGroup.controls['etiquetaPromotor'].updateValueAndValidity();
        }
    };
    /**
     * @return {?}
     */
    ConveniosEditarAgregarComponent.prototype.onEtiquetaPromotorSelect = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var etiquetaPromotor = this.formGroup.get('etiquetaPromotor').value;
        if (this.utilizaPromotor && etiquetaPromotor.length == 0) {
            this.formGroup.controls['etiquetaPromotor'].setValidators([Validators.required]);
            this.formGroup.controls['etiquetaPromotor'].updateValueAndValidity();
        }
    };
    ConveniosEditarAgregarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-convenios-editar-agregar',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a [routerLink]=\"['../convenios']\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <h3>Editar convenio <span style=\"color:#CC0000;font-size: 18px;\" *ngIf=\"requiredAuth\">(* Requiere autorizaci&oacute;n)</span></h3>\r\n          <div class=\"menu-pills\">\r\n            <a>\r\n              <div class=\"item first active\">Datos generales</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item\">Reglas de pago</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item\">Intercambio</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item last\">Gr\u00E1fica</div>\r\n            </a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <form [formGroup]=\"formGroup\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n        <div class=\"form-section\">\r\n          <h5>Informaci\u00F3n del comercio</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-4 col-md-3\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Rubro\" formControlName=\"rubro\" (selectionChange)=\"onRubroSelect($event)\">\r\n                  <mat-option *ngFor=\"let rubro of resultadoRubros\" [value]=\"rubro.codigo\">{{rubro.descripcion}}</mat-option>\r\n                </mat-select>\r\n                <mat-error *ngIf=\"formGroup.get('rubro').invalid\">Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-6\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"empresa\" (selectionChange)=\"onEmpresaSelect($event)\">\r\n                  <mat-option class=\"text-breakword\" *ngFor=\"let empresa of resultadoEmpresa\" [value]=\"empresa.idFacturador\">{{empresa.nomFacturador}}</mat-option>\r\n                </mat-select>\r\n                <mat-error *ngIf=\"formGroup.get('empresa').invalid\">Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-3\">\r\n              <mat-form-field>\r\n                <input matInput placeholder=\"Rut empresa\" maxlength=\"12\" soloRutUY formatRut formControlName=\"identificadorEmpresa\">\r\n                <mat-error *ngIf=\"formGroup.get('identificadorEmpresa').hasError('rutUYError')\">Rut <strong>incorrecto</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-section\">\r\n          <h5>Datos del convenio</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-12\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"65\" placeholder=\"Descripci\u00F3n del convenio\" formControlName=\"descripcionConvenio\">\r\n                <mat-error *ngIf=\"formGroup.get('descripcionConvenio').invalid\">Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-3\">\r\n              <div class=\"filtro-fecha\">\r\n                <mat-form-field>\r\n                  <input matInput [matDatepicker]=\"picker\" [min]=\"minDate\" placeholder=\"Inicio vigencia\" formControlName=\"inicioVigencia\"><!-- (dateChange)=\"onInicioVigenciaSelect($event)\" -->\r\n                  <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\r\n                  <mat-datepicker touchUi #picker></mat-datepicker>\r\n                  <mat-error *ngIf=\"formGroup.get('inicioVigencia').invalid\">Valor no v\u00E1lido.</mat-error>\r\n                </mat-form-field>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-3\">\r\n              <div class=\"filtro-fecha\">\r\n                <mat-form-field>\r\n                  <input matInput [matDatepicker]=\"pickerTermino\" [min]=\"minDate\" placeholder=\"T\u00E9rmino vigencia\" formControlName=\"terminoVigencia\">\r\n                  <mat-datepicker-toggle matSuffix [for]=\"pickerTermino\"></mat-datepicker-toggle>\r\n                  <mat-datepicker touchUi #pickerTermino></mat-datepicker>\r\n                  <mat-error *ngIf=\"formGroup.get('terminoVigencia').invalid\">Valor no v\u00E1lido.</mat-error>\r\n                </mat-form-field>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estado\">\r\n                  <mat-option *ngFor=\"let estado of resultadoEstados\" [value]=\"estado.codigo\">{{estado.descripcion}}</mat-option>\r\n                </mat-select>\r\n                <mat-error *ngIf=\"formGroup.get('empresa').invalid\">Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-3\" style=\"padding: 10px 5px;\">\r\n              <div class=\"form-check form-check-inline\">\r\n                <mat-checkbox class=\"example-margin\" formControlName=\"utilizaPromotor\" (change)=\"showUtilizaPromotor($event.checked)\">Utiliza Promotor</mat-checkbox>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"col-md-3\" *ngIf=\"utilizaPromotor\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"65\" placeholder=\"Etiqueta promotor\" formControlName=\"etiquetaPromotor\" (change)=\"onEtiquetaPromotorSelect()\">\r\n                <mat-error *ngIf=\"formGroup.get('etiquetaPromotor').invalid\">Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col align-left\">\r\n            <button class=\"btn text\" type=\"reset\" [routerLink]=\"['../convenios']\"><i class=\"str-icon-flecha-izquierda\"></i>CANCELAR</button>\r\n          </div>\r\n          <div class=\"col align-right\">\r\n            <button *ngIf=\"formGroup.invalid\" class=\"btn main\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i></button>\r\n            <button *ngIf=\"formGroup.valid\" class=\"btn main\" type=\"submit\" (click)=\"onSubmit()\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i></button><!-- [routerLink]=\"['../conveniosEditarPago']\" -->\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [{ provide: MAT_DATE_LOCALE$1, useValue: 'es' },
                        { provide: DateAdapter$1, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE$1] },
                        { provide: MAT_DATE_FORMATS$1, useValue: ɵ0$4 }, EmpresasService, ConveniosService]
                }] }
    ];
    /** @nocollapse */
    ConveniosEditarAgregarComponent.ctorParameters = function () { return [
        { type: EmpresasService },
        { type: ConveniosService },
        { type: ActivatedRoute },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] },
        { type: MatDialog },
        { type: Router },
        { type: AutorizacionesService }
    ]; };
    return ConveniosEditarAgregarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var httpOptions$6 = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};
var ConveniosAgregarService = /** @class */ (function () {
    function ConveniosAgregarService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlConvenioInsertar = this.environment.urlAmbiente + '/apiConvenioMT/convenioInsertar';
        this.urlPacParametroListar = this.environment.urlAmbiente + '/apiConvenioMT/pacParametroListar';
        this.urlConfiguracionListar = this.environment.urlAmbiente + '/apiConvenioMT/configuracionesCarga';
        this.urlMonedasListar = this.environment.urlAmbiente + '/apiConvenioMT/monedasListar';
        /* this.convenioAgregar = JSON.parse(sessionStorage.getItem('convenioAgregar'));
        this.convenioPagoAgregar = JSON.parse(sessionStorage.getItem('convenioPagoAgregar')); */
    }
    /**
     * @return {?}
     */
    ConveniosAgregarService.prototype.postConvenioInsertarReport = /**
     * @return {?}
     */
    function () {
        this.convenioAgregar = JSON.parse(sessionStorage.getItem('convenioAgregar'));
        this.convenioPagoAgregar = JSON.parse(sessionStorage.getItem('convenioPagoAgregar'));
        this.dataConvenioE = JSON.parse(sessionStorage.getItem('dataConvenioE'));
        this.idConvenio = this.dataConvenioE != null ? this.dataConvenioE.idConvenio : this.convenioAgregar.idConvenio;
        this.convenioIntercambioAgregar = JSON.parse(sessionStorage.getItem('convenioIntercambioAgregar'));
        this.convenioGraficaAgregar = JSON.parse(sessionStorage.getItem('convenioGraficaAgregar'));
        /** @type {?} */
        var duplicidad = [];
        /** @type {?} */
        var diaCargo = [];
        /** @type {?} */
        var cantidadReintentos;
        if (this.convenioPagoAgregar.cantidadReintentos == null) {
            cantidadReintentos = "";
        }
        else {
            cantidadReintentos = this.convenioPagoAgregar.cantidadReintentos;
        }
        if (this.convenioPagoAgregar.criteriosDuplicidad) {
            /** @type {?} */
            var criteriosDuplicidad = "S";
            /** @type {?} */
            var duplicadosMarcaTodos = "N";
            /** @type {?} */
            var duplicadosRango = "N";
            /** @type {?} */
            var enviarTodoCobro = '0';
        }
        else {
            /** @type {?} */
            var criteriosDuplicidad = "N";
            /** @type {?} */
            var duplicadosMarcaTodos = "N";
            /** @type {?} */
            var duplicadosRango = "N";
            /** @type {?} */
            var enviarTodoCobro = '1';
        }
        if (this.convenioPagoAgregar.idServicio) {
            duplicidad.push("idServicio");
        }
        if (this.convenioPagoAgregar.montoPago) {
            duplicidad.push("montoFacturacion");
        }
        if (this.convenioPagoAgregar.fechaVencimiento) {
            duplicidad.push("fechaVencimiento");
        }
        if (this.convenioPagoAgregar.diaCargo1) {
            diaCargo.push("1");
        }
        if (this.convenioPagoAgregar.diaCargo2) {
            diaCargo.push("2");
        }
        if (this.convenioPagoAgregar.diaCargo3) {
            diaCargo.push("3");
        }
        if (this.convenioPagoAgregar.diaCargo4) {
            diaCargo.push("4");
        }
        if (this.convenioPagoAgregar.diaCargo5) {
            diaCargo.push("5");
        }
        if (this.convenioPagoAgregar.diaCargo6) {
            diaCargo.push("6");
        }
        if (this.convenioPagoAgregar.diaCargo7) {
            diaCargo.push("7");
        }
        if (this.convenioPagoAgregar.diaCargo8) {
            diaCargo.push("8");
        }
        if (this.convenioPagoAgregar.diaCargo9) {
            diaCargo.push("9");
        }
        if (this.convenioPagoAgregar.diaCargo10) {
            diaCargo.push("10");
        }
        if (this.convenioPagoAgregar.diaCargo11) {
            diaCargo.push("11");
        }
        if (this.convenioPagoAgregar.diaCargo12) {
            diaCargo.push("12");
        }
        if (this.convenioPagoAgregar.diaCargo13) {
            diaCargo.push("13");
        }
        if (this.convenioPagoAgregar.diaCargo14) {
            diaCargo.push("14");
        }
        if (this.convenioPagoAgregar.diaCargo15) {
            diaCargo.push("15");
        }
        if (this.convenioPagoAgregar.diaCargo16) {
            diaCargo.push("16");
        }
        if (this.convenioPagoAgregar.diaCargo17) {
            diaCargo.push("17");
        }
        if (this.convenioPagoAgregar.diaCargo18) {
            diaCargo.push("18");
        }
        if (this.convenioPagoAgregar.diaCargo19) {
            diaCargo.push("19");
        }
        if (this.convenioPagoAgregar.diaCargo20) {
            diaCargo.push("20");
        }
        if (this.convenioPagoAgregar.diaCargo21) {
            diaCargo.push("21");
        }
        if (this.convenioPagoAgregar.diaCargo22) {
            diaCargo.push("22");
        }
        if (this.convenioPagoAgregar.diaCargo23) {
            diaCargo.push("23");
        }
        if (this.convenioPagoAgregar.diaCargo24) {
            diaCargo.push("24");
        }
        if (this.convenioPagoAgregar.diaCargo25) {
            diaCargo.push("25");
        }
        if (this.convenioPagoAgregar.diaCargo26) {
            diaCargo.push("26");
        }
        if (this.convenioPagoAgregar.diaCargo27) {
            diaCargo.push("27");
        }
        if (this.convenioPagoAgregar.diaCargo28) {
            diaCargo.push("28");
        }
        if (this.convenioPagoAgregar.diaCargo29) {
            diaCargo.push("29");
        }
        if (this.convenioPagoAgregar.diaCargo30) {
            diaCargo.push("30");
        }
        if (this.convenioPagoAgregar.diaCargo31) {
            diaCargo.push("31");
        }
        /** @type {?} */
        var duplicidadString = duplicidad.join(',');
        /** @type {?} */
        var diaCargoString = diaCargo.join(',');
        /** @type {?} */
        var terminoVigenciaF;
        if (this.convenioAgregar.terminoVigencia != null) {
            terminoVigenciaF = formatDate(this.convenioAgregar.terminoVigencia, 'yyyyMMddHHmmss', 'en-US');
        }
        else {
            terminoVigenciaF = null;
        }
        /** @type {?} */
        var tipoMonedaAInsertar = (this.convenioPagoAgregar.tipoMoneda != null) ? this.convenioPagoAgregar.tipoMoneda : sessionStorage.getItem('monedaSelected');
        sessionStorage.removeItem('monedaSelected');
        return this.http.post(this.urlConvenioInsertar, {
            /* Agregar */
            estadoConvenio: this.convenioAgregar.estadoConvenio,
            identificadorEmpresa: this.convenioAgregar.identificadorEmpresa,
            rubro: this.convenioAgregar.rubro,
            empresa: this.convenioAgregar.empresa,
            descripcionConvenio: this.convenioAgregar.descripcionConvenio,
            inicioVigencia: formatDate(this.convenioAgregar.inicioVigencia, 'yyyyMMddHHmmss', 'en-US'),
            terminoVigencia: terminoVigenciaF,
            etiquetaPromotor: this.convenioAgregar.etiquetaPromotor,
            /* Pago */
            descripcion: this.convenioPagoAgregar.descripcion,
            idConvenio: this.idConvenio,
            tipoMoneda: tipoMonedaAInsertar,
            /* Portal */
            idUsuario: this.convenioAgregar.idUsuario,
            codCliente: this.convenioAgregar.codCliente,
            docEmpresa: this.convenioAgregar.docEmpresa,
            codTpoPortal: this.convenioAgregar.codTpoPortal,
            /* Pago */
            montoMinimo: this.convenioPagoAgregar.montoMinimo,
            montoMaximo: this.convenioPagoAgregar.montoMaximo,
            tipoCobro: this.convenioPagoAgregar.tipoCobro,
            activarMandato: this.convenioPagoAgregar.activarMandato,
            cantidadReintentos: cantidadReintentos,
            criteriosDuplicidad: criteriosDuplicidad,
            duplicidad: duplicidadString,
            enviarTodoCobro: enviarTodoCobro,
            duplicadosMarcaTodos: duplicadosMarcaTodos,
            duplicadosRango: duplicadosRango,
            diaCargo: diaCargoString,
            /* Intercambio */
            tolMandatos: this.convenioIntercambioAgregar.tolMandatos,
            conFact: this.convenioIntercambioAgregar.conFact,
            tipoRend: this.convenioIntercambioAgregar.tipoRend,
            confIdFat: this.convenioIntercambioAgregar.confIdFat,
            confIdMan: this.convenioIntercambioAgregar.confIdMan,
            confIdRen: this.convenioIntercambioAgregar.confIdRen,
            tipoCargaFacturacion: '',
            tipoCargaMandato: '',
            tipoCargaRendicion: '',
            mismoArchivo: (this.convenioIntercambioAgregar.mismoArchivo ? 'S' : 'N'),
            medioPagoMigracion: (this.convenioIntercambioAgregar.medioPagoMigracion ? 'S' : 'N'),
            /* Grafica */
            colorTextoPrincipal: this.convenioGraficaAgregar.colorTextoPrincipal,
            colorLineasDestacadas: this.convenioGraficaAgregar.colorLineasDestacadas,
            colorBotonNormal: this.convenioGraficaAgregar.colorBotonNormal,
            colorBotonHover: this.convenioGraficaAgregar.colorBotonHover,
            colorBotonPresionado: this.convenioGraficaAgregar.colorBotonPresionado,
            infoImagen: this.convenioGraficaAgregar.infoImagen
        }, httpOptions$6);
    };
    /**
     * @param {?} _body
     * @return {?}
     */
    ConveniosAgregarService.prototype.postPacParametroListar = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlPacParametroListar, _body, httpOptions$6);
    };
    /**
     * @param {?} _body
     * @return {?}
     */
    ConveniosAgregarService.prototype.postConfiguracionesCarga = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlConfiguracionListar, _body, httpOptions$6);
    };
    /**
     * @return {?}
     */
    ConveniosAgregarService.prototype.postMonedasListar = /**
     * @return {?}
     */
    function () {
        return this.http.post(this.urlMonedasListar, null, httpOptions$6);
    };
    ConveniosAgregarService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ConveniosAgregarService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return ConveniosAgregarService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConveniosBuscarImagen = /** @class */ (function () {
    function ConveniosBuscarImagen() {
        this.imgTpo = '';
        this.cnv = '';
        this.emp = '';
        this.clt = '';
    }
    return ConveniosBuscarImagen;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DialogImagenComponent = /** @class */ (function () {
    function DialogImagenComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    /**
     * @return {?}
     */
    DialogImagenComponent.prototype.onNoClick = /**
     * @return {?}
     */
    function () {
        this.dialogRef.close();
    };
    DialogImagenComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-dialog-imagen',
                    template: "<div class=\"custom-modals\">\r\n  <div class=\"modal-body\">\r\n    \r\n    <button class=\"close\" aria-label=\"Close\" *ngIf=\"data.showBtnCancel\" [mat-dialog-close]=\"false\">\r\n    <!--   <span aria-hidden=\"true\"><i class=\"str-icon-cerrar\"></i></span> -->\r\n    </button>\r\n     \r\n    <img [src]=\"data.content\" style=\"max-width: 80%; max-height: 80%;\" class=\"img-fluid rounded\"/>\r\n    <div class=\"buttons-container\">\r\n      <button [mat-dialog-close]=\"true\" class=\"btn main\">Cerrar</button>\r\n  </div>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    DialogImagenComponent.ctorParameters = function () { return [
        { type: MatDialogRef },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
    ]; };
    return DialogImagenComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$5 = MAT_MOMENT_DATE_FORMATS;
var ConveniosEditarGraficaComponent = /** @class */ (function () {
    function ConveniosEditarGraficaComponent(peticionAgregar, agregarImagen, router, route, domSanitizer, dialog) {
        this.peticionAgregar = peticionAgregar;
        this.agregarImagen = agregarImagen;
        this.router = router;
        this.route = route;
        this.domSanitizer = domSanitizer;
        this.dialog = dialog;
        this.imagenesArray = [];
        this.idImagenBoleta = '';
        this.idImagenPortada = '';
        this.buscarImagen = new ConveniosBuscarImagen();
        this.tieneImagen = false;
        this.tieneImagen2 = false;
        this.nuevaImagen = false;
        this.nuevaImagen2 = false;
        this.requiredAuth = false;
        this.convenioGraficaAgregar = JSON.parse(sessionStorage.getItem('convenioGraficaAgregar'));
        this.pacParametro = JSON.parse(sessionStorage.getItem('pacParametro'));
    }
    /**
     * @return {?}
     */
    ConveniosEditarGraficaComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formGroup = new FormGroup({
            colorTextoPrincipal: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(6), Validators.pattern('^[A-Fa-f0-9]+$')])),
            colorLineasDestacadas: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(6), Validators.pattern('^[A-Fa-f0-9]+$')])),
            colorBotonNormal: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(6), Validators.pattern('^[A-Fa-f0-9]+$')])),
            colorBotonHover: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(6), Validators.pattern('^[A-Fa-f0-9]+$')])),
            colorBotonPresionado: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(6), Validators.pattern('^[A-Fa-f0-9]+$')])),
            archivo: new FormControl(),
            archivo2: new FormControl()
        });
        if (this.convenioGraficaAgregar != null) {
            this.formGroup.controls['colorTextoPrincipal'].setValue(this.convenioGraficaAgregar.colorTextoPrincipal.substr(1));
            this.formGroup.controls['colorLineasDestacadas'].setValue(this.convenioGraficaAgregar.colorLineasDestacadas.substr(1));
            this.formGroup.controls['colorBotonNormal'].setValue(this.convenioGraficaAgregar.colorBotonNormal.substr(1));
            this.formGroup.controls['colorBotonHover'].setValue(this.convenioGraficaAgregar.colorBotonHover.substr(1));
            this.formGroup.controls['colorBotonPresionado'].setValue(this.convenioGraficaAgregar.colorBotonPresionado.substr(1));
        }
        else {
            for (var i = 0; i < this.pacParametro.length; i++) {
                if (this.pacParametro[i]['codigoParametro'] == "C_TEXTO_PRINCIPAL") {
                    this.formGroup.controls['colorTextoPrincipal'].setValue(this.pacParametro[i]['valorParametro'].substr(1));
                }
                if (this.pacParametro[i]['codigoParametro'] == "C_LINEAS_DESTACADAS") {
                    this.formGroup.controls['colorLineasDestacadas'].setValue(this.pacParametro[i]['valorParametro'].substr(1));
                }
                if (this.pacParametro[i]['codigoParametro'] == "C_BOTON_NORMAL") {
                    this.formGroup.controls['colorBotonNormal'].setValue(this.pacParametro[i]['valorParametro'].substr(1));
                }
                if (this.pacParametro[i]['codigoParametro'] == "C_BOTON_HOVER") {
                    this.formGroup.controls['colorBotonHover'].setValue(this.pacParametro[i]['valorParametro'].substr(1));
                }
                if (this.pacParametro[i]['codigoParametro'] == "C_BOTON_PRESIONADO") {
                    this.formGroup.controls['colorBotonPresionado'].setValue(this.pacParametro[i]['valorParametro'].substr(1));
                }
            }
        }
        this.buscarImagenes('boleta');
        this.buscarImagenes('portada');
        this.requiredAuth = ('true' === sessionStorage.getItem('requiredAuth_UPDCNV'));
    };
    /**
     * @return {?}
     */
    ConveniosEditarGraficaComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        this.graficaLocalStorage();
        this.showDialogPre('Información', 'Si realiza esta acción, editará el convenio.<br>¿Está seguro?', true);
    };
    /**
     * @return {?}
     */
    ConveniosEditarGraficaComponent.prototype.postConvenioInsertarServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.peticionAgregar.postConvenioInsertarReport().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            sessionStorage.setItem('pacConvenioInsertado', JSON.stringify(data));
            _this.pacConvenioInsertado = JSON.parse(sessionStorage.getItem('pacConvenioInsertado'));
            switch (_this.pacConvenioInsertado.codret) {
                case '0':
                    _this.showDialog('Información', 'Convenio editado de forma satisfactoria.', false);
                    break;
                case '1':
                    _this.showDialog('Información', 'Convenio modificado exitosamente pero requiere autorización.', false);
                    break;
                case '-7':
                    _this.showDialog('Error', 'Convenio tiene una autorización pendiente.', false);
                    break;
                default:
                    _this.showDialogFail('Error', 'No ha sido posible insertar el convenio.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialogFail('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @return {?}
     */
    ConveniosEditarGraficaComponent.prototype.graficaLocalStorage = /**
     * @return {?}
     */
    function () {
        if (this.idImagenBoleta != '')
            this.imagenesArray.push({ "tipoImagen": 'boleta', "idImagen": this.idImagenBoleta });
        if (this.idImagenPortada != '')
            this.imagenesArray.push({ "tipoImagen": 'portada', "idImagen": this.idImagenPortada });
        sessionStorage.setItem('convenioGraficaAgregar', JSON.stringify({
            colorTextoPrincipal: '#' + this.formGroup.get('colorTextoPrincipal').value,
            colorLineasDestacadas: '#' + this.formGroup.get('colorLineasDestacadas').value,
            colorBotonNormal: '#' + this.formGroup.get('colorBotonNormal').value,
            colorBotonHover: '#' + this.formGroup.get('colorBotonHover').value,
            colorBotonPresionado: '#' + this.formGroup.get('colorBotonPresionado').value,
            infoImagen: this.imagenesArray
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ConveniosEditarGraficaComponent.prototype.showDialogPre = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            if (result) {
                _this.postConvenioInsertarServices();
            }
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ConveniosEditarGraficaComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            _this.router.navigate(['../convenios'], { relativeTo: _this.route });
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ConveniosEditarGraficaComponent.prototype.showDialogFail = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ConveniosEditarGraficaComponent.prototype.showDialogImagen = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogImagenComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true,
            maxWidth: '500px'
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} event
     * @param {?} tipo
     * @return {?}
     */
    ConveniosEditarGraficaComponent.prototype.addToQueue = /**
     * @param {?} event
     * @param {?} tipo
     * @return {?}
     */
    function (event, tipo) {
        var _this = this;
        /** @type {?} */
        var type = this.setPitchfile(event);
        if (type == "image/png" || type == "image/jpeg" || type == "image/bmp") {
            /** @type {?} */
            var fileBrowser = event.srcElement.files[0];
            console.log(fileBrowser);
            /** @type {?} */
            var formData = new FormData();
            formData.append('imagen', fileBrowser);
            formData.append('tipoImagen', tipo);
            this.agregarImagen.postConveniosImagen(formData).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                console.log(data);
                if (data.codret == '0') {
                    if (tipo == 'boleta') {
                        _this.idImagenBoleta = data.idImg;
                        _this.imagenBoletaNueva = data.img64;
                        _this.nuevaImagen = true;
                    }
                    if (tipo == 'portada') {
                        _this.idImagenPortada = data.idImg;
                        _this.imagenPortadaNueva = data.img64;
                        _this.nuevaImagen2 = true;
                    }
                }
                else {
                    _this.showDialogFail('Error ', data.descret, false);
                }
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function (err) {
                console.log("error");
                console.log(err);
                _this.showDialogFail('Error ', 'Servicio temporalmente no disponible.', false);
            }));
        }
        else {
            this.showDialogFail('Error', 'El archivo no es válido.<br>Inténtelo con otro.', false);
            this.formGroup.get('archivo').reset();
        }
    };
    /**
     * @param {?} fileInput
     * @return {?}
     */
    ConveniosEditarGraficaComponent.prototype.setPitchfile = /**
     * @param {?} fileInput
     * @return {?}
     */
    function (fileInput) {
        for (var i = fileInput.target.files.length - 1; i >= 0; i--) {
            /** @type {?} */
            var file = fileInput.target.files[i];
            this.pitchfile = file;
        }
        console.log(this.pitchfile);
        return this.pitchfile['type'];
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    ConveniosEditarGraficaComponent.prototype.buscarImagenes = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        var _this = this;
        /** @type {?} */
        var convenioAgregar = JSON.parse(sessionStorage.getItem('convenioAgregar'));
        this.buscarImagen.imgTpo = tipo;
        this.buscarImagen.cnv = convenioAgregar.idConvenio;
        this.buscarImagen.emp = convenioAgregar.identificadorEmpresa;
        this.buscarImagen.clt = convenioAgregar.codCliente;
        this.agregarImagen.postConveniosBuscarImagen(this.buscarImagen).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                if (tipo == 'boleta') {
                    _this.tieneImagen = true;
                    _this.imagenBoleta = data.img64;
                    _this.formatoImagenBoleta = data.imgFormat;
                }
                if (tipo == 'portada') {
                    _this.tieneImagen2 = true;
                    _this.imagenPortada = data.img64;
                    _this.formatoImagenPortada = data.imgFormat;
                }
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.log("error");
            console.log(err);
        }));
    };
    /**
     * @param {?} tipoImagen
     * @param {?} tipo
     * @return {?}
     */
    ConveniosEditarGraficaComponent.prototype.verImagen = /**
     * @param {?} tipoImagen
     * @param {?} tipo
     * @return {?}
     */
    function (tipoImagen, tipo) {
        if (tipoImagen == 'boleta' && tipo == 'nueva') {
            this.base64Image = this.domSanitizer.bypassSecurityTrustResourceUrl('data:' + this.formatoImagenBoleta + ';base64,' + this.imagenBoletaNueva);
        }
        if (tipoImagen == 'portada' && tipo == 'nueva') {
            this.base64Image = this.domSanitizer.bypassSecurityTrustResourceUrl('data:' + this.formatoImagenPortada + ';base64,' + this.imagenPortadaNueva);
        }
        if (tipoImagen == 'boleta' && tipo == 'antes') {
            this.base64Image = this.domSanitizer.bypassSecurityTrustResourceUrl('data:' + this.formatoImagenBoleta + ';base64,' + this.imagenBoleta);
        }
        if (tipoImagen == 'portada' && tipo == 'antes') {
            this.base64Image = this.domSanitizer.bypassSecurityTrustResourceUrl('data:' + this.formatoImagenPortada + ';base64,' + this.imagenPortada);
        }
        this.showDialogImagen('Error ', this.base64Image, true);
    };
    ConveniosEditarGraficaComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-convenios-editar-grafica',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a [routerLink]=\"['../convenios']\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <h3>Editar convenio <span style=\"color:#CC0000;font-size: 18px;\" *ngIf=\"requiredAuth\">(* Requiere autorizaci&oacute;n)</span></h3>\r\n          <div class=\"menu-pills\">\r\n            <a>\r\n              <div class=\"item first\">Datos generales</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item\">Reglas de pago</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item\">Intercambio</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item last active\">Gr\u00E1fica</div>\r\n            </a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <form [formGroup]=\"formGroup\" autocomplete=\"off\">\r\n\r\n        <div class=\"form-section\">\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-5\">\r\n              <h5>Colores</h5>\r\n              <div class=\"row\">\r\n                <div class=\" col-md-4 color-box\">\r\n                  <span class=\"item\" [ngStyle]=\"{'background-color': '#'+formGroup.get('colorTextoPrincipal').value}\"></span>\r\n                </div>\r\n                <div>\r\n                  <mat-form-field>\r\n                    <span matPrefix>#</span>\r\n                    <input matInput maxlength=\"6\" placeholder=\"Color texto principal (HEX)\" formControlName=\"colorTextoPrincipal\">\r\n                    <mat-error *ngIf=\"formGroup.get('colorTextoPrincipal').invalid\">Este campo no es <strong>v\u00E1lido.</strong></mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"row\">\r\n                <div class=\"col-md-4 color-box\">\r\n                  <span class=\"item lineas\" [ngStyle]=\"{'border-color': '#'+formGroup.get('colorLineasDestacadas').value}\"></span>\r\n                </div>\r\n                <div>\r\n                  <mat-form-field>\r\n                    <span matPrefix>#</span>\r\n                    <input matInput maxlength=\"6\" placeholder=\"Color l\u00EDneas destacadas (HEX)\" formControlName=\"colorLineasDestacadas\">\r\n                    <mat-error *ngIf=\"formGroup.get('colorLineasDestacadas').invalid\">Este campo no es <strong>v\u00E1lido.</strong></mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"row\">\r\n                <div class=\"col-md-4 color-box\">\r\n                  <span class=\"item\" [ngStyle]=\"{'background-color': '#'+formGroup.get('colorBotonNormal').value}\">Texto del bot\u00F3n</span>\r\n                </div>\r\n                <div>\r\n                  <mat-form-field>\r\n                    <span matPrefix>#</span>\r\n                    <input matInput maxlength=\"6\" placeholder=\"Color bot\u00F3n normal (HEX)\" formControlName=\"colorBotonNormal\">\r\n                    <mat-error *ngIf=\"formGroup.get('colorBotonNormal').invalid\">Este campo no es <strong>v\u00E1lido.</strong></mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"row\">\r\n                <div class=\"col-md-4 color-box\">\r\n                  <span class=\"item\" [ngStyle]=\"{'background-color': '#'+formGroup.get('colorBotonHover').value}\">Texto del bot\u00F3n</span>\r\n                </div>\r\n                <div>\r\n                  <mat-form-field>\r\n                    <span matPrefix>#</span>\r\n                    <input matInput maxlength=\"6\" placeholder=\"Color bot\u00F3n estado Hover (HEX)\" formControlName=\"colorBotonHover\">\r\n                    <mat-error *ngIf=\"formGroup.get('colorBotonHover').invalid\">Este campo no es <strong>v\u00E1lido.</strong></mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"row\">\r\n                <div class=\"col-md-4 color-box\">\r\n                  <span class=\"item\" [ngStyle]=\"{'background-color': '#'+formGroup.get('colorBotonPresionado').value}\">Texto del bot\u00F3n</span>\r\n                </div>\r\n                <div>\r\n                  <mat-form-field>\r\n                    <span matPrefix>#</span>\r\n                    <input matInput maxlength=\"6\" placeholder=\"Color bot\u00F3n presionado (HEX)\" formControlName=\"colorBotonPresionado\">\r\n                    <mat-error *ngIf=\"formGroup.get('colorBotonPresionado').invalid\">Este campo no es <strong>v\u00E1lido.</strong></mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"col-md-6 offset-md-1\">\r\n              <h5>Imagen boleta</h5>\r\n              <div class=\"row\">\r\n                <button class=\"btn-small out\" (click)=\"fileInput.click()\"><i class=\"str-icon-nuevo-documento\"></i> Agregar imagen</button>\r\n                <input type=\"file\" style=\"display:none\" #fileInput (change)=\"addToQueue($event,'boleta')\" formControlName=\"archivo\" accept=\".jpg, .png\" />\r\n                <div *ngIf=\"nuevaImagen\">\r\n                  <button class=\"btn-small out\" (click)=\"verImagen('boleta', 'nueva')\"><i class=\"str-icon-nuevo-documento\"></i> Ver nueva imagen</button>\r\n                </div>\r\n                <div *ngIf=\"tieneImagen\">\r\n                  <button class=\"btn-small out\" (click)=\"verImagen('boleta', 'antes')\"><i class=\"str-icon-nuevo-documento\"></i> Ver imagen guardada</button>\r\n                </div>\r\n              </div>\r\n              <h5>Imagen bienvenida</h5>\r\n              <div class=\"row\">\r\n                <button class=\"btn-small out\" (click)=\"fileInput2.click()\"><i class=\"str-icon-nuevo-documento\"></i> Agregar archivo</button>\r\n                <input type=\"file\" style=\"display:none\" #fileInput2 (change)=\"addToQueue($event,'portada')\" formControlName=\"archivo2\" accept=\".jpg, .png\" />\r\n                <div *ngIf=\"nuevaImagen2\">\r\n                  <button class=\"btn-small out\" (click)=\"verImagen('portada', 'nueva')\"><i class=\"str-icon-nuevo-documento\"></i> Ver nueva imagen</button>\r\n                </div>\r\n                <div *ngIf=\"tieneImagen2\">\r\n                  <button class=\"btn-small out\" (click)=\"verImagen('portada', 'antes')\"><i class=\"str-icon-nuevo-documento\"></i> Ver imagen guardada</button>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col align-left\">\r\n            <button class=\"btn text\" type=\"submit\" [routerLink]=\"['../conveniosEditarIntercambio']\" (click)=\"graficaLocalStorage();\"><i class=\"str-icon-flecha-izquierda\"></i>ANTERIOR</button>\r\n          </div>\r\n          <div class=\"col align-right\">\r\n            <button *ngIf=\"formGroup.valid\" class=\"btn main\" type=\"submit\" (click)=\"onSubmit()\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n            <button *ngIf=\"formGroup.invalid\" class=\"btn main\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [ConveniosService, { provide: MAT_DATE_LOCALE$2, useValue: 'es' },
                        { provide: DateAdapter$2, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE$2] },
                        { provide: MAT_DATE_FORMATS$2, useValue: ɵ0$5 }, DatePipe],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ConveniosEditarGraficaComponent.ctorParameters = function () { return [
        { type: ConveniosAgregarService },
        { type: ConveniosService },
        { type: Router },
        { type: ActivatedRoute },
        { type: DomSanitizer },
        { type: MatDialog }
    ]; };
    ConveniosEditarGraficaComponent.propDecorators = {
        fileInput: [{ type: ViewChild, args: ['fileInput',] }],
        fileInput2: [{ type: ViewChild, args: ['fileInput2',] }]
    };
    return ConveniosEditarGraficaComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConfiguracionPeticion = /** @class */ (function () {
    function ConfiguracionPeticion() {
        this.codTipoArchivo = -1;
    }
    return ConfiguracionPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConveniosEditarIntercambioComponent = /** @class */ (function () {
    function ConveniosEditarIntercambioComponent(peticionAgregar) {
        this.peticionAgregar = peticionAgregar;
        this.conFactSelect = [
            { option: '0', value: '0' },
            { option: '1', value: '1' },
            { option: '2', value: '2' },
            { option: '3', value: '3' },
            { option: '4', value: '4' },
            { option: '5', value: '5' },
            { option: '6', value: '6' },
            { option: '7', value: '7' },
            { option: '8', value: '8' },
            { option: '9', value: '9' },
            { option: '10', value: '10' }
        ];
        this.tipoRendSelect = [
            { option: 'Cobro', value: 'C' },
            { option: 'Facturación', value: 'F' }
        ];
        this.tipoCargaFactSelect = [];
        this.tipoCargaMandSelect = [];
        this.tipoCargaRendSelect = [];
        this.tipoFacturacion = "";
        this.requiredAuth = false;
        this.convenioIntercambioAgregar = JSON.parse(sessionStorage.getItem('convenioIntercambioAgregar'));
        this.pacParametro = JSON.parse(sessionStorage.getItem('pacParametro'));
        this.cnvPago = JSON.parse(sessionStorage.getItem('convenioPagoAgregar'));
    }
    /**
     * @return {?}
     */
    ConveniosEditarIntercambioComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.postListarConfiguracionServices();
        this.formGroup = new FormGroup({
            tolMandatos: new FormControl('', Validators.compose([Validators.min(0), Validators.max(100), Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            conFact: new FormControl('', Validators.required),
            tipoRend: new FormControl('', Validators.required),
            confIdFat: new FormControl('', Validators.required),
            confIdMan: new FormControl('', Validators.required),
            confIdRen: new FormControl('', Validators.required),
            mismoArchivo: new FormControl(),
            medioPagoMigracion: new FormControl(true)
        });
        if (this.convenioIntercambioAgregar != null) {
            this.formGroup.controls['tolMandatos'].setValue(this.convenioIntercambioAgregar.tolMandatos);
            this.formGroup.controls['conFact'].setValue(this.convenioIntercambioAgregar.conFact);
            this.formGroup.controls['tipoRend'].setValue(this.convenioIntercambioAgregar.tipoRend);
            this.formGroup.controls['confIdFat'].setValue(this.convenioIntercambioAgregar.confIdFat);
            this.formGroup.controls['confIdMan'].setValue(this.convenioIntercambioAgregar.confIdMan);
            this.formGroup.controls['confIdRen'].setValue(this.convenioIntercambioAgregar.confIdRen);
            this.formGroup.controls['mismoArchivo'].setValue(this.convenioIntercambioAgregar.mismoArchivo);
            this.formGroup.controls['medioPagoMigracion'].setValue(this.convenioIntercambioAgregar.medioPagoMigracion);
        }
        else {
            //this.formGroup.controls['medioPagoMigracion'].setValue(true); //se agrega porque la funcionalidad se agregó despues de haber convenios en sistema.... si el conevenio no tiene configurada esta opcion por defecto se debe mostrar la tarjeta en el reporte de migracion de mandatos
            for (var i = 0; i < this.pacParametro.length; i++) {
                if (this.pacParametro[i]['codigoParametro'] == "TOL_ERROR_ACT_MAN") {
                    this.formGroup.controls['tolMandatos'].setValue(this.pacParametro[i]['valorParametro']);
                }
                if (this.pacParametro[i]['codigoParametro'] == "CONTROL_FACTURACION") {
                    this.formGroup.controls['conFact'].setValue(this.pacParametro[i]['valorParametro']);
                }
                if (this.pacParametro[i]['codigoParametro'] == "VALIDA_CHECKSUM") {
                    (this.pacParametro[i]['valorParametro'] == 'S') ? this.formGroup.controls['mismoArchivo'].setValue(true) : this.formGroup.controls['mismoArchivo'].setValue(false);
                }
                if (this.pacParametro[i]['codigoParametro'] == "MEDIO_PAGO_MIGRACION") {
                    (this.pacParametro[i]['valorParametro'] == 'S') ? this.formGroup.controls['medioPagoMigracion'].setValue(true) : this.formGroup.controls['medioPagoMigracion'].setValue(false);
                }
                /** @type {?} */
                var convenioAgregar = JSON.parse(sessionStorage.getItem('dataConvenioE'));
                this.formGroup.controls['tipoRend'].setValue(convenioAgregar.tipoRendicion);
                this.formGroup.controls['confIdFat'].setValue(parseInt(convenioAgregar.confIdFat));
                this.formGroup.controls['confIdMan'].setValue(parseInt(convenioAgregar.confIdMan));
                this.formGroup.controls['confIdRen'].setValue(parseInt(convenioAgregar.confIdRen));
                console.log("Si tiene " + convenioAgregar.confIdRen);
            }
        }
        this.tipoFacturacion = this.cnvPago['tipoCobro'];
        if (this.tipoFacturacion == 'F') {
            this.formGroup.controls.tolMandatos.setValue('0');
            this.formGroup.controls.conFact.setValue('0');
            this.formGroup.controls.confIdFat.reset('');
            this.formGroup.controls.mismoArchivo.reset();
            this.formGroup.controls.tolMandatos.disable();
            this.formGroup.controls.conFact.disable();
            this.formGroup.controls.confIdFat.disable();
            this.formGroup.controls.mismoArchivo.disable();
        }
        else {
            this.formGroup.controls.tolMandatos.enable();
            this.formGroup.controls.conFact.enable();
            this.formGroup.controls.confIdFat.enable();
            this.formGroup.controls.mismoArchivo.enable();
        }
        this.requiredAuth = ('true' === sessionStorage.getItem('requiredAuth_UPDCNV'));
    };
    /**
     * @return {?}
     */
    ConveniosEditarIntercambioComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        sessionStorage.setItem('convenioIntercambioAgregar', JSON.stringify({
            tolMandatos: this.formGroup.get('tolMandatos').value,
            conFact: this.formGroup.get('conFact').value,
            tipoRend: this.formGroup.get('tipoRend').value,
            confIdFat: this.formGroup.get('confIdFat').value,
            confIdMan: this.formGroup.get('confIdMan').value,
            confIdRen: this.formGroup.get('confIdRen').value,
            mismoArchivo: this.formGroup.get('mismoArchivo').value,
            medioPagoMigracion: this.formGroup.get('medioPagoMigracion').value
        }));
    };
    /**
     * @return {?}
     */
    ConveniosEditarIntercambioComponent.prototype.postListarConfiguracionServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new ConfiguracionPeticion();
        this.peticionAgregar.postConfiguracionesCarga(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.tipoCargaFactSelect = data.configuraciones.filter((/**
                 * @param {?} element
                 * @return {?}
                 */
                function (element) { return element.arcTipCod === 'FAT'; }));
                _this.tipoCargaMandSelect = data.configuraciones.filter((/**
                 * @param {?} element
                 * @return {?}
                 */
                function (element) { return element.arcTipCod === 'MAN'; }));
                _this.tipoCargaRendSelect = data.configuraciones.filter((/**
                 * @param {?} element
                 * @return {?}
                 */
                function (element) { return element.arcTipCod === 'REN'; }));
            }
            else {
                console.log('Error en postListarConfiguracionServices', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en postListarConfiguracionServices', err);
        }));
    };
    ConveniosEditarIntercambioComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-convenios-editar-intercambio',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a [routerLink]=\"['../convenios']\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <h3>Editar convenio <span style=\"color:#CC0000;font-size: 18px;\" *ngIf=\"requiredAuth\">(* Requiere autorizaci&oacute;n)</span></h3>\r\n          <div class=\"menu-pills\">\r\n            <a>\r\n              <div class=\"item first\">Datos generales</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item\">Reglas de pago</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item active\">Intercambio</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item last\">Gr&aacute;fica</div>\r\n            </a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <form [formGroup]=\"formGroup\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n        <div class=\"form-section\">\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-5\">\r\n              <h5>Tolerancia de errores (%)</h5>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                  <mat-form-field>\r\n                    <input matInput type=\"text\" digitOnly maxlength=\"3\" placeholder=\"Tolerancia Activaci&oacute;n de mandatos\" formControlName=\"tolMandatos\" min=\"0\" max=\"100\">\r\n                    <mat-error *ngIf=\"formGroup.get('tolMandatos').invalid\">Valor esperado entre 0 y 100.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-5 offset-md-1\">\r\n              <h5>Control facturaci&oacute;n</h5>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-5\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Control\" formControlName=\"conFact\">\r\n                      <mat-option *ngFor=\"let con of conFactSelect\" [value]=\"con.value\">{{con.option}}</mat-option>\r\n                    </mat-select>\r\n                    <mat-error *ngIf=\"formGroup.get('conFact').invalid\">Este campo es requerido.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-5\">\r\n              <h5>Comprobaci&oacute;n de archivos</h5>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-5\">\r\n                  <div class=\"form-check form-check-inline\">\r\n                    <mat-checkbox class=\"example-margin\" formControlName=\"mismoArchivo\">No permitir subir el mismo archivo de facturaci&oacute;n</mat-checkbox>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-5 offset-md-1\">\r\n              <h5>Tipo de rendici&oacute;n</h5>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-5\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Seleccione\" formControlName=\"tipoRend\">\r\n                      <mat-option *ngFor=\"let tipo of tipoRendSelect\" [value]=\"tipo.value\">{{tipo.option}}</mat-option>\r\n                    </mat-select>\r\n                    <mat-error *ngIf=\"formGroup.get('tipoRend').invalid\">Este campo es requerido.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-5\">\r\n              <h5>Tipo de Carga facturaci&oacute;n</h5>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-5\">\r\n                  <mat-form-field style=\"width: 20rem !important;\">\r\n                    <mat-select matNativeControl placeholder=\"Seleccione\" formControlName=\"confIdFat\">\r\n                      <mat-option *ngFor=\"let tipo of tipoCargaFactSelect\" [value]=\"tipo.arcConCarId\">{{tipo.descConfiguracion}}</mat-option>\r\n                    </mat-select>\r\n                    <mat-error *ngIf=\"formGroup.get('confIdFat').invalid\">Este campo es requerido.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-5 offset-md-1\">\r\n              <h5>Tipo de carga Mandatos</h5>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-5\">\r\n                  <mat-form-field style=\"width: 20rem !important;\">\r\n                    <mat-select matNativeControl placeholder=\"Seleccione\" formControlName=\"confIdMan\">\r\n                      <mat-option *ngFor=\"let tipo of tipoCargaMandSelect\" [value]=\"tipo.arcConCarId\">{{tipo.descConfiguracion}}</mat-option>\r\n                    </mat-select>\r\n                    <mat-error *ngIf=\"formGroup.get('confIdMan').invalid\">Este campo es requerido.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-5\">\r\n              <h5>Tipo de generaci&oacute;n de rendici&oacute;n</h5>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-5\">\r\n                  <mat-form-field style=\"width: 22rem !important;\">\r\n                    <mat-select matNativeControl placeholder=\"Seleccione\" formControlName=\"confIdRen\">\r\n                      <mat-option *ngFor=\"let tipo of tipoCargaRendSelect\" [value]=\"tipo.arcConCarId\">{{tipo.descConfiguracion}}</mat-option>\r\n                    </mat-select>\r\n                    <mat-error *ngIf=\"formGroup.get('confIdRen').invalid\">Este campo es requerido.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-5 offset-md-1\">\r\n              <h5>Archivo de respuesta Migraci&oacute;n de Mandatos</h5>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-5\">\r\n                  <div class=\"form-check form-check-inline\">\r\n                    <mat-checkbox class=\"example-margin\" formControlName=\"medioPagoMigracion\">Mostrar informaci&oacute;n asociada al medio de pago</mat-checkbox>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col align-left\">\r\n            <button class=\"btn text\" type=\"submit\" [routerLink]=\"['../conveniosEditarPago']\"><i class=\"str-icon-flecha-izquierda\"></i>ANTERIOR</button>\r\n          </div>\r\n          <div class=\"col align-right\">\r\n            <button *ngIf=\"formGroup.valid\" class=\"btn main\" type=\"submit\" [routerLink]=\"['../conveniosEditarGrafica']\" (click)=\"onSubmit()\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i></button>\r\n            <button *ngIf=\"formGroup.invalid\" class=\"btn main\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i></button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n\r\n  </div>\r\n</section>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ConveniosEditarIntercambioComponent.ctorParameters = function () { return [
        { type: ConveniosAgregarService }
    ]; };
    return ConveniosEditarIntercambioComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConveniosListParametrosPeticion = /** @class */ (function () {
    function ConveniosListParametrosPeticion() {
        this.idFacturador = -1;
        this.idConvenio = '-1';
    }
    return ConveniosListParametrosPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MonedaStr = /** @class */ (function () {
    function MonedaStr() {
    }
    /**
     * @param {?} value
     * @return {?}
     */
    MonedaStr.prototype.transform = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var newStr = "$" + value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        return newStr;
    };
    MonedaStr.decorators = [
        { type: Pipe, args: [{ name: 'moneda' },] }
    ];
    return MonedaStr;
}());
var CantidadStr = /** @class */ (function () {
    function CantidadStr() {
    }
    /**
     * @param {?} value
     * @return {?}
     */
    CantidadStr.prototype.transform = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var newStr = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        return newStr;
    };
    CantidadStr.decorators = [
        { type: Pipe, args: [{ name: 'cantidad' },] }
    ];
    return CantidadStr;
}());
var NumberMonedasStr = /** @class */ (function () {
    function NumberMonedasStr() {
    }
    /**
     * @param {?} val
     * @param {?} moneda
     * @return {?}
     */
    NumberMonedasStr.prototype.transform = /**
     * @param {?} val
     * @param {?} moneda
     * @return {?}
     */
    function (val, moneda) {
        if (val == "0") {
            return val;
        }
        if (val) {
            val = this.format_number(val.toString(), '', moneda);
        }
        return val;
    };
    /**
     * @param {?} number
     * @param {?} prefix
     * @param {?} tipoMoneda
     * @return {?}
     */
    NumberMonedasStr.prototype.format_number = /**
     * @param {?} number
     * @param {?} prefix
     * @param {?} tipoMoneda
     * @return {?}
     */
    function (number, prefix, tipoMoneda) {
        /** @type {?} */
        var decimales = "";
        /** @type {?} */
        var thousand_separator = '.';
        /** @type {?} */
        var decimal_separator = ',';
        /** @type {?} */
        var regexDecimal = new RegExp('[^' + decimal_separator + '\\d]', 'g');
        /** @type {?} */
        var regexMiles = new RegExp('[^' + thousand_separator + '\\d]', 'g');
        /** @type {?} */
        var number_string = number.replace(regexDecimal, '').replace(regexMiles, '');
        number_string = Number(number_string) + "";
        /** @type {?} */
        var lengNumber = number_string.length;
        if (tipoMoneda == 'USD') {
            if (lengNumber < 3) {
                return "0," + number_string;
            }
            decimales = number_string.substring(lengNumber - 2, lengNumber);
            number_string = number_string.substring(0, lengNumber - 2);
        }
        /** @type {?} */
        var split = number_string.split(decimal_separator);
        /** @type {?} */
        var rest = split[0].length % 3;
        /** @type {?} */
        var result = split[0].substr(0, rest);
        /** @type {?} */
        var thousands = split[0].substr(rest).match(/\d{3}/g);
        if (thousands) {
            /** @type {?} */
            var separator = rest ? thousand_separator : '';
            result += separator + thousands.join(thousand_separator);
        }
        result = split[1] != undefined ? result + decimal_separator + split[1] : result;
        /** @type {?} */
        var ret = prefix == undefined ? result : (result ? prefix + result : '');
        return decimales != "" ? ret + decimal_separator + decimales : ret;
    };
    NumberMonedasStr.decorators = [
        { type: Pipe, args: [{ name: 'numberMonedasPipe' },] }
    ];
    return NumberMonedasStr;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConveniosEditarPagoComponent = /** @class */ (function () {
    function ConveniosEditarPagoComponent(peticionAgregar, dialog, router, route) {
        this.peticionAgregar = peticionAgregar;
        this.dialog = dialog;
        this.router = router;
        this.route = route;
        this.tipoCobroSelect = [
            { option: 'Fijo', value: 'F' },
            { option: 'Variable', value: 'V' }
        ];
        this.cantidadReintentosSelect = [
            { option: '1', value: '1' },
            { option: '2', value: '2' },
            { option: '3', value: '3' },
            { option: '4', value: '4' }
        ];
        this.peticionReporte = new ConveniosListParametrosPeticion();
        this.montoMinimo = '0';
        this.montoMaximo = '0';
        this.activarMandato = 0;
        this.requiredAuth = false;
        this.lengthMontoXMoneda = 0;
        this.numberMonedaPipe = new NumberMonedasStr();
        this.aReglasPagos = JSON.parse(sessionStorage.getItem('aReglasPagos'));
        this.convenioPagoAgregar = JSON.parse(sessionStorage.getItem('convenioPagoAgregar'));
        this.tipoMonedaSelect = JSON.parse(sessionStorage.getItem('monedas'));
        this.dataConvenio = JSON.parse(sessionStorage.getItem('dataConvenioE'));
    }
    /**
     * @return {?}
     */
    ConveniosEditarPagoComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formGroup = new FormGroup({
            tipoMoneda: new FormControl('', Validators.required),
            montoMinimo: new FormControl('', Validators.compose([Validators.maxLength(this.lengthMontoXMoneda), CustomValidators.amountValidator])),
            montoMaximo: new FormControl('', Validators.compose([Validators.maxLength(this.lengthMontoXMoneda), CustomValidators.amountValidator])),
            tipoCobro: new FormControl('', Validators.required),
            activaMandato: new FormControl(),
            criteriosDuplicidad: new FormControl(),
            idServicio: new FormControl(),
            montoPago: new FormControl(),
            fechaVencimiento: new FormControl(),
            reintentos: new FormControl(),
            cantidadReintentos: new FormControl('', Validators.required),
            diaCargo1: new FormControl(),
            diaCargo2: new FormControl(),
            diaCargo3: new FormControl(),
            diaCargo4: new FormControl(),
            diaCargo5: new FormControl(),
            diaCargo6: new FormControl(),
            diaCargo7: new FormControl(),
            diaCargo8: new FormControl(),
            diaCargo9: new FormControl(),
            diaCargo10: new FormControl(),
            diaCargo11: new FormControl(),
            diaCargo12: new FormControl(),
            diaCargo13: new FormControl(),
            diaCargo14: new FormControl(),
            diaCargo15: new FormControl(),
            diaCargo16: new FormControl(),
            diaCargo17: new FormControl(),
            diaCargo18: new FormControl(),
            diaCargo19: new FormControl(),
            diaCargo20: new FormControl(),
            diaCargo21: new FormControl(),
            diaCargo22: new FormControl(),
            diaCargo23: new FormControl(),
            diaCargo24: new FormControl(),
            diaCargo25: new FormControl(),
            diaCargo26: new FormControl(),
            diaCargo27: new FormControl(),
            diaCargo28: new FormControl(),
            diaCargo29: new FormControl(),
            diaCargo30: new FormControl(),
            diaCargo31: new FormControl()
        });
        this.peticionReporte.idFacturador = this.aReglasPagos.idFacturador;
        this.peticionReporte.idConvenio = this.dataConvenio.idConvenio;
        if (this.convenioPagoAgregar != null) {
            /** @type {?} */
            var tipoMoneda = this.convenioPagoAgregar.tipoMoneda;
            if (tipoMoneda != '' || tipoMoneda != undefined || tipoMoneda != null) {
                this.formGroup.controls['tipoMoneda'].setValue(tipoMoneda);
                this.monedaPago = tipoMoneda;
                this.getLengthMontoXMoneda();
            }
            /** @type {?} */
            var mtoMinimo = this.convenioPagoAgregar.montoMinimo;
            /** @type {?} */
            var mtoMaximo = this.convenioPagoAgregar.montoMaximo;
            if (mtoMinimo != null && mtoMinimo != undefined && mtoMinimo != '') {
                this.formGroup.controls['montoMinimo'].setValue((tipoMoneda == 'UYU' ? (parseInt(mtoMinimo) / 100).toString() : mtoMinimo));
            }
            else {
                this.formGroup.controls['montoMinimo'].reset();
                this.montoMinimo = mtoMinimo;
            }
            if (mtoMaximo != null && mtoMaximo != undefined && mtoMaximo != '') {
                this.formGroup.controls['montoMaximo'].setValue((tipoMoneda == 'UYU' ? (parseInt(mtoMaximo) / 100).toString() : mtoMaximo));
            }
            else {
                this.formGroup.controls['montoMaximo'].reset();
                this.montoMaximo = mtoMaximo;
            }
            this.formGroup.controls['tipoCobro'].setValue(this.convenioPagoAgregar.tipoCobro);
            (this.convenioPagoAgregar.activarMandato == 1) ? this.formGroup.controls['activaMandato'].setValue(true) : this.formGroup.controls['activaMandato'].setValue(false);
            (this.convenioPagoAgregar.tipoCobro == 'F') ? this.formGroup.controls['activaMandato'].disable() : this.formGroup.controls['activaMandato'].enable();
            this.formGroup.controls['criteriosDuplicidad'].setValue(this.convenioPagoAgregar.criteriosDuplicidad);
            if (this.convenioPagoAgregar.criteriosDuplicidad) {
                this.formGroup.controls['idServicio'].enable();
                this.formGroup.controls['idServicio'].setValue(this.convenioPagoAgregar.idServicio);
                this.formGroup.controls['montoPago'].enable();
                this.formGroup.controls['montoPago'].setValue(this.convenioPagoAgregar.montoPago);
                this.formGroup.controls['fechaVencimiento'].enable();
                this.formGroup.controls['fechaVencimiento'].setValue(this.convenioPagoAgregar.fechaVencimiento);
            }
            else {
                this.formGroup.controls['idServicio'].setValue(false);
                this.formGroup.controls['idServicio'].disable();
                this.formGroup.controls['montoPago'].setValue(false);
                this.formGroup.controls['montoPago'].disable();
                this.formGroup.controls['fechaVencimiento'].setValue(false);
                this.formGroup.controls['fechaVencimiento'].disable();
            }
            this.formGroup.controls['reintentos'].setValue(this.convenioPagoAgregar.reintentos);
            if (this.convenioPagoAgregar.reintentos) {
                this.formGroup.controls['cantidadReintentos'].enable();
                this.formGroup.controls['cantidadReintentos'].setValue(this.convenioPagoAgregar.cantidadReintentos);
            }
            else {
                this.formGroup.controls['cantidadReintentos'].setValue('');
                this.formGroup.controls['cantidadReintentos'].disable();
            }
            this.formGroup.controls['diaCargo1'].setValue(this.convenioPagoAgregar.diaCargo1);
            this.formGroup.controls['diaCargo2'].setValue(this.convenioPagoAgregar.diaCargo2);
            this.formGroup.controls['diaCargo3'].setValue(this.convenioPagoAgregar.diaCargo3);
            this.formGroup.controls['diaCargo4'].setValue(this.convenioPagoAgregar.diaCargo4);
            this.formGroup.controls['diaCargo5'].setValue(this.convenioPagoAgregar.diaCargo5);
            this.formGroup.controls['diaCargo6'].setValue(this.convenioPagoAgregar.diaCargo6);
            this.formGroup.controls['diaCargo7'].setValue(this.convenioPagoAgregar.diaCargo7);
            this.formGroup.controls['diaCargo8'].setValue(this.convenioPagoAgregar.diaCargo8);
            this.formGroup.controls['diaCargo9'].setValue(this.convenioPagoAgregar.diaCargo9);
            this.formGroup.controls['diaCargo10'].setValue(this.convenioPagoAgregar.diaCargo10);
            this.formGroup.controls['diaCargo11'].setValue(this.convenioPagoAgregar.diaCargo11);
            this.formGroup.controls['diaCargo12'].setValue(this.convenioPagoAgregar.diaCargo12);
            this.formGroup.controls['diaCargo13'].setValue(this.convenioPagoAgregar.diaCargo13);
            this.formGroup.controls['diaCargo14'].setValue(this.convenioPagoAgregar.diaCargo14);
            this.formGroup.controls['diaCargo15'].setValue(this.convenioPagoAgregar.diaCargo15);
            this.formGroup.controls['diaCargo16'].setValue(this.convenioPagoAgregar.diaCargo16);
            this.formGroup.controls['diaCargo17'].setValue(this.convenioPagoAgregar.diaCargo17);
            this.formGroup.controls['diaCargo18'].setValue(this.convenioPagoAgregar.diaCargo18);
            this.formGroup.controls['diaCargo19'].setValue(this.convenioPagoAgregar.diaCargo19);
            this.formGroup.controls['diaCargo20'].setValue(this.convenioPagoAgregar.diaCargo20);
            this.formGroup.controls['diaCargo21'].setValue(this.convenioPagoAgregar.diaCargo21);
            this.formGroup.controls['diaCargo22'].setValue(this.convenioPagoAgregar.diaCargo22);
            this.formGroup.controls['diaCargo23'].setValue(this.convenioPagoAgregar.diaCargo23);
            this.formGroup.controls['diaCargo24'].setValue(this.convenioPagoAgregar.diaCargo24);
            this.formGroup.controls['diaCargo25'].setValue(this.convenioPagoAgregar.diaCargo25);
            this.formGroup.controls['diaCargo26'].setValue(this.convenioPagoAgregar.diaCargo26);
            this.formGroup.controls['diaCargo27'].setValue(this.convenioPagoAgregar.diaCargo27);
            this.formGroup.controls['diaCargo28'].setValue(this.convenioPagoAgregar.diaCargo28);
            this.formGroup.controls['diaCargo29'].setValue(this.convenioPagoAgregar.diaCargo29);
            this.formGroup.controls['diaCargo30'].setValue(this.convenioPagoAgregar.diaCargo30);
            this.formGroup.controls['diaCargo31'].setValue(this.convenioPagoAgregar.diaCargo31);
        }
        else {
            //Editar Convenio
            this.postPacParametroListarService(this.peticionReporte);
        }
        this.requiredAuth = ('true' === sessionStorage.getItem('requiredAuth_UPDCNV'));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    ConveniosEditarPagoComponent.prototype.postPacParametroListarService = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.peticionAgregar.postPacParametroListar(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                console.log(data);
                _this.resultadoReporte = [];
                _this.resultadoReporte.push(data);
                sessionStorage.setItem('pacParametro', JSON.stringify(data.resultado));
                _this.formGroup.controls['tipoMoneda'].setValue(_this.dataConvenio.moneda);
                _this.monedaPago = _this.dataConvenio.moneda;
                _this.getLengthMontoXMoneda();
                for (var i = 0; i < data.resultado.length; i++) {
                    if (data.resultado[i]['codigoParametro'] == "MONTO_MINIMO") {
                        if (data.resultado[i]['valorParametro'] != '') {
                            _this.formGroup.controls['montoMinimo'].setValue((_this.monedaPago == 'UYU' ? (parseInt(data.resultado[i]['valorParametro']) / 100).toString() : data.resultado[i]['valorParametro']));
                        }
                    }
                    if (data.resultado[i]['codigoParametro'] == "MONTO_MAXIMO") {
                        if (data.resultado[i]['valorParametro'] != '') {
                            _this.formGroup.controls['montoMaximo'].setValue((_this.monedaPago == 'UYU' ? (parseInt(data.resultado[i]['valorParametro']) / 100).toString() : data.resultado[i]['valorParametro']));
                        }
                    }
                    if (data.resultado[i]['codigoParametro'] == "ACT_AUT_MAND") {
                        (data.resultado[i]['valorParametro'] == 1) ? _this.formGroup.controls['activaMandato'].setValue(true) : _this.formGroup.controls['activaMandato'].setValue(false);
                    }
                    if (data.resultado[i]['codigoParametro'] == "COBRO_REINTENTO") {
                        if (data.resultado[i]['valorParametro'] != '') {
                            _this.formGroup.controls['cantidadReintentos'].setValue(data.resultado[i]['valorParametro']);
                            _this.formGroup.controls['cantidadReintentos'].enable();
                            _this.formGroup.controls['reintentos'].setValue(true);
                        }
                        else {
                            _this.formGroup.controls['cantidadReintentos'].disable();
                        }
                    }
                    if (data.resultado[i]['codigoParametro'] == "VALIDA_DUPLICADOS_CRITERIO") {
                        if (data.resultado[i]['valorParametro'] != '') {
                            //this.formGroup.controls['tipoCobro'].setValue('V');
                            _this.formGroup.controls['criteriosDuplicidad'].setValue(true);
                            /** @type {?} */
                            var valorParametroStrring = data.resultado[i]['valorParametro'];
                            /** @type {?} */
                            var valorParametroLista = valorParametroStrring.split(",");
                            for (var i_1 = 0; i_1 < valorParametroLista.length; i_1++) {
                                if (valorParametroLista[i_1] == "idServicio") {
                                    _this.formGroup.controls['idServicio'].setValue(true);
                                }
                                else {
                                    if (valorParametroLista[i_1] == "montoFacturacion") {
                                        _this.formGroup.controls['montoPago'].setValue(true);
                                    }
                                    else {
                                        if (valorParametroLista[i_1] == "fechaVencimiento") {
                                            _this.formGroup.controls['fechaVencimiento'].setValue(true);
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            //this.formGroup.controls['tipoCobro'].setValue('F');
                            _this.formGroup.controls['idServicio'].disable();
                            _this.formGroup.controls['montoPago'].disable();
                            _this.formGroup.controls['fechaVencimiento'].disable();
                            _this.formGroup.controls['idServicio'].setValue(false);
                            _this.formGroup.controls['montoPago'].setValue(false);
                            _this.formGroup.controls['fechaVencimiento'].setValue(false);
                            _this.formGroup.controls['criteriosDuplicidad'].setValue(false);
                        }
                    }
                    if (data.resultado[i]['codigoParametro'] == "DIAS_CARGO") {
                        if (data.resultado[i]['valorParametro'] != '') {
                            _this.formGroup.controls['tipoCobro'].setValue('F');
                            _this.formGroup.controls['activaMandato'].disable();
                            /** @type {?} */
                            var valorParametroStrring = data.resultado[i]['valorParametro'];
                            /** @type {?} */
                            var valorParametroLista = valorParametroStrring.split(",");
                            for (var i_2 = 0; i_2 < valorParametroLista.length; i_2++) {
                                switch (valorParametroLista[i_2]) {
                                    case '1':
                                        _this.formGroup.controls['diaCargo1'].setValue(true);
                                        break;
                                    case '2':
                                        _this.formGroup.controls['diaCargo2'].setValue(true);
                                        break;
                                    case '3':
                                        _this.formGroup.controls['diaCargo3'].setValue(true);
                                        break;
                                    case '4':
                                        _this.formGroup.controls['diaCargo4'].setValue(true);
                                        break;
                                    case '5':
                                        _this.formGroup.controls['diaCargo5'].setValue(true);
                                        break;
                                    case '6':
                                        _this.formGroup.controls['diaCargo6'].setValue(true);
                                        break;
                                    case '7':
                                        _this.formGroup.controls['diaCargo7'].setValue(true);
                                        break;
                                    case '8':
                                        _this.formGroup.controls['diaCargo8'].setValue(true);
                                        break;
                                    case '9':
                                        _this.formGroup.controls['diaCargo9'].setValue(true);
                                        break;
                                    case '10':
                                        _this.formGroup.controls['diaCargo10'].setValue(true);
                                        break;
                                    case '11':
                                        _this.formGroup.controls['diaCargo11'].setValue(true);
                                        break;
                                    case '12':
                                        _this.formGroup.controls['diaCargo12'].setValue(true);
                                        break;
                                    case '13':
                                        _this.formGroup.controls['diaCargo13'].setValue(true);
                                        break;
                                    case '14':
                                        _this.formGroup.controls['diaCargo14'].setValue(true);
                                        break;
                                    case '15':
                                        _this.formGroup.controls['diaCargo15'].setValue(true);
                                        break;
                                    case '16':
                                        _this.formGroup.controls['diaCargo16'].setValue(true);
                                        break;
                                    case '17':
                                        _this.formGroup.controls['diaCargo17'].setValue(true);
                                        break;
                                    case '18':
                                        _this.formGroup.controls['diaCargo18'].setValue(true);
                                        break;
                                    case '19':
                                        _this.formGroup.controls['diaCargo19'].setValue(true);
                                        break;
                                    case '20':
                                        _this.formGroup.controls['diaCargo20'].setValue(true);
                                        break;
                                    case '21':
                                        _this.formGroup.controls['diaCargo21'].setValue(true);
                                        break;
                                    case '22':
                                        _this.formGroup.controls['diaCargo22'].setValue(true);
                                        break;
                                    case '23':
                                        _this.formGroup.controls['diaCargo23'].setValue(true);
                                        break;
                                    case '24':
                                        _this.formGroup.controls['diaCargo24'].setValue(true);
                                        break;
                                    case '25':
                                        _this.formGroup.controls['diaCargo25'].setValue(true);
                                        break;
                                    case '26':
                                        _this.formGroup.controls['diaCargo26'].setValue(true);
                                        break;
                                    case '27':
                                        _this.formGroup.controls['diaCargo27'].setValue(true);
                                        break;
                                    case '28':
                                        _this.formGroup.controls['diaCargo28'].setValue(true);
                                        break;
                                    case '29':
                                        _this.formGroup.controls['diaCargo29'].setValue(true);
                                        break;
                                    case '30':
                                        _this.formGroup.controls['diaCargo30'].setValue(true);
                                        break;
                                    case '31':
                                        _this.formGroup.controls['diaCargo31'].setValue(true);
                                        break;
                                    default:
                                }
                            }
                        }
                        else {
                            _this.formGroup.controls['tipoCobro'].setValue('V');
                        }
                    }
                }
            }
            else {
                _this.showDialogError('Error ', data.descret, false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialogError('Error ', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @return {?}
     */
    ConveniosEditarPagoComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var tpoMoneda = this.formGroup.get('tipoMoneda').value;
        /** @type {?} */
        var mtoMinimo = this.formGroup.get('montoMinimo').value;
        mtoMinimo = (mtoMinimo != null && mtoMinimo != '' && mtoMinimo != undefined ? CustomValidators.validaMonto(mtoMinimo) : '');
        /** @type {?} */
        var mtoMaximo = this.formGroup.get('montoMaximo').value;
        mtoMaximo = (mtoMaximo != null && mtoMaximo != '' && mtoMaximo != undefined ? CustomValidators.validaMonto(mtoMaximo) : '');
        if (mtoMinimo != '') {
            this.montoMinimo = (tpoMoneda == 'UYU' ? (parseInt(mtoMinimo) * 100).toString() : mtoMinimo);
        }
        else {
            this.formGroup.controls['montoMinimo'].reset();
            this.montoMinimo = mtoMinimo;
        }
        if (mtoMaximo != '') {
            this.montoMaximo = (tpoMoneda == 'UYU' ? (parseInt(mtoMaximo) * 100).toString() : mtoMaximo);
        }
        else {
            this.formGroup.controls['montoMaximo'].reset();
            this.montoMaximo = mtoMaximo;
        }
        (this.formGroup.get('activaMandato').value) ? this.activarMandato = 1 : this.activarMandato = 0;
        if (this.montoMaximo == '' || (this.montoMinimo == '' || (parseInt(this.montoMaximo) >= parseInt(this.montoMinimo)))) {
            sessionStorage.setItem('convenioPagoAgregar', JSON.stringify({
                idFacturador: this.aReglasPagos.idFacturador,
                descripcion: '',
                tipoMoneda: tpoMoneda,
                montoMinimo: this.montoMinimo,
                montoMaximo: this.montoMaximo,
                tipoCobro: this.formGroup.get('tipoCobro').value,
                activarMandato: this.activarMandato,
                criteriosDuplicidad: this.formGroup.get('criteriosDuplicidad').value,
                idServicio: this.formGroup.get('idServicio').value,
                montoPago: this.formGroup.get('montoPago').value,
                fechaVencimiento: this.formGroup.get('fechaVencimiento').value,
                reintentos: this.formGroup.get('reintentos').value,
                cantidadReintentos: this.formGroup.get('cantidadReintentos').value,
                diaCargo1: this.formGroup.get('diaCargo1').value,
                diaCargo2: this.formGroup.get('diaCargo2').value,
                diaCargo3: this.formGroup.get('diaCargo3').value,
                diaCargo4: this.formGroup.get('diaCargo4').value,
                diaCargo5: this.formGroup.get('diaCargo5').value,
                diaCargo6: this.formGroup.get('diaCargo6').value,
                diaCargo7: this.formGroup.get('diaCargo7').value,
                diaCargo8: this.formGroup.get('diaCargo8').value,
                diaCargo9: this.formGroup.get('diaCargo9').value,
                diaCargo10: this.formGroup.get('diaCargo10').value,
                diaCargo11: this.formGroup.get('diaCargo11').value,
                diaCargo12: this.formGroup.get('diaCargo12').value,
                diaCargo13: this.formGroup.get('diaCargo13').value,
                diaCargo14: this.formGroup.get('diaCargo14').value,
                diaCargo15: this.formGroup.get('diaCargo15').value,
                diaCargo16: this.formGroup.get('diaCargo16').value,
                diaCargo17: this.formGroup.get('diaCargo17').value,
                diaCargo18: this.formGroup.get('diaCargo18').value,
                diaCargo19: this.formGroup.get('diaCargo19').value,
                diaCargo20: this.formGroup.get('diaCargo20').value,
                diaCargo21: this.formGroup.get('diaCargo21').value,
                diaCargo22: this.formGroup.get('diaCargo22').value,
                diaCargo23: this.formGroup.get('diaCargo23').value,
                diaCargo24: this.formGroup.get('diaCargo24').value,
                diaCargo25: this.formGroup.get('diaCargo25').value,
                diaCargo26: this.formGroup.get('diaCargo26').value,
                diaCargo27: this.formGroup.get('diaCargo27').value,
                diaCargo28: this.formGroup.get('diaCargo28').value,
                diaCargo29: this.formGroup.get('diaCargo29').value,
                diaCargo30: this.formGroup.get('diaCargo30').value,
                diaCargo31: this.formGroup.get('diaCargo31').value
            }));
            this.router.navigate(['../conveniosEditarIntercambio'], { relativeTo: this.route });
            console.log(JSON.parse(sessionStorage.getItem('convenioPagoAgregar')));
        }
        else {
            this.showDialog('Info', 'Verifique los montos mínimos y máximos', false);
        }
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ConveniosEditarPagoComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result.toString());
        }));
    };
    /**
     * @return {?}
     */
    ConveniosEditarPagoComponent.prototype.checkValue = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.get('criteriosDuplicidad').value) {
            this.formGroup.controls['idServicio'].enable();
            this.formGroup.controls['montoPago'].enable();
            this.formGroup.controls['fechaVencimiento'].enable();
        }
        else {
            this.formGroup.controls['idServicio'].setValue(false);
            this.formGroup.controls['idServicio'].disable();
            this.formGroup.controls['montoPago'].setValue(false);
            this.formGroup.controls['montoPago'].disable();
            this.formGroup.controls['fechaVencimiento'].setValue(false);
            this.formGroup.controls['fechaVencimiento'].disable();
        }
    };
    /**
     * @return {?}
     */
    ConveniosEditarPagoComponent.prototype.checkValueReintentos = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.get('reintentos').value) {
            this.formGroup.controls['cantidadReintentos'].enable();
        }
        else {
            this.formGroup.controls['cantidadReintentos'].setValue(null);
            this.formGroup.controls['cantidadReintentos'].disable();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ConveniosEditarPagoComponent.prototype.onTipoCobroSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.value == 'F') {
            this.formGroup.controls['activaMandato'].setValue(true);
            this.formGroup.controls['activaMandato'].disable();
            this.formGroup.controls['criteriosDuplicidad'].setValue(false);
            this.checkValue();
        }
        else {
            this.formGroup.controls['activaMandato'].setValue(false);
            this.formGroup.controls['activaMandato'].enable();
            this.formGroup.controls['diaCargo1'].setValue(false);
            this.formGroup.controls['diaCargo2'].setValue(false);
            this.formGroup.controls['diaCargo3'].setValue(false);
            this.formGroup.controls['diaCargo4'].setValue(false);
            this.formGroup.controls['diaCargo5'].setValue(false);
            this.formGroup.controls['diaCargo6'].setValue(false);
            this.formGroup.controls['diaCargo7'].setValue(false);
            this.formGroup.controls['diaCargo8'].setValue(false);
            this.formGroup.controls['diaCargo9'].setValue(false);
            this.formGroup.controls['diaCargo10'].setValue(false);
            this.formGroup.controls['diaCargo11'].setValue(false);
            this.formGroup.controls['diaCargo12'].setValue(false);
            this.formGroup.controls['diaCargo13'].setValue(false);
            this.formGroup.controls['diaCargo14'].setValue(false);
            this.formGroup.controls['diaCargo15'].setValue(false);
            this.formGroup.controls['diaCargo16'].setValue(false);
            this.formGroup.controls['diaCargo17'].setValue(false);
            this.formGroup.controls['diaCargo18'].setValue(false);
            this.formGroup.controls['diaCargo19'].setValue(false);
            this.formGroup.controls['diaCargo20'].setValue(false);
            this.formGroup.controls['diaCargo21'].setValue(false);
            this.formGroup.controls['diaCargo22'].setValue(false);
            this.formGroup.controls['diaCargo23'].setValue(false);
            this.formGroup.controls['diaCargo24'].setValue(false);
            this.formGroup.controls['diaCargo25'].setValue(false);
            this.formGroup.controls['diaCargo26'].setValue(false);
            this.formGroup.controls['diaCargo27'].setValue(false);
            this.formGroup.controls['diaCargo28'].setValue(false);
            this.formGroup.controls['diaCargo29'].setValue(false);
            this.formGroup.controls['diaCargo30'].setValue(false);
            this.formGroup.controls['diaCargo31'].setValue(false);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ConveniosEditarPagoComponent.prototype.onTipoMonedaSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        //sessionStorage.setItem('monedaSelected' , event.value);
        this.formGroup.get('montoMinimo').setValue('');
        this.formGroup.get('montoMaximo').setValue('');
        this.monedaPago = event.value;
        this.getLengthMontoXMoneda();
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ConveniosEditarPagoComponent.prototype.showDialogError = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            _this.router.navigate(['../convenios'], { relativeTo: _this.route });
        }));
    };
    /* transformAmount(event){
      console.log(event.target.value);
      var dato = event.target.value;
      console.log(this.pipe.transform(dato));
      this.formGroup.controls['montoMinimo'].setValue(this.pipe.transform(dato));
    } */
    /* transformAmount(event){
        console.log(event.target.value);
        var dato = event.target.value;
        console.log(this.pipe.transform(dato));
        this.formGroup.controls['montoMinimo'].setValue(this.pipe.transform(dato));
      } */
    /**
     * @return {?}
     */
    ConveniosEditarPagoComponent.prototype.getLengthMontoXMoneda = /* transformAmount(event){
        console.log(event.target.value);
        var dato = event.target.value;
        console.log(this.pipe.transform(dato));
        this.formGroup.controls['montoMinimo'].setValue(this.pipe.transform(dato));
      } */
    /**
     * @return {?}
     */
    function () {
        this.lengthMontoXMoneda = this.monedaPago == 'USD' ? 13 : 10;
        this.formGroup.get('montoMinimo').setValidators(Validators.compose([Validators.maxLength(this.lengthMontoXMoneda), CustomValidators.amountValidator]));
        this.formGroup.get('montoMaximo').setValidators(Validators.compose([Validators.maxLength(this.lengthMontoXMoneda), CustomValidators.amountValidator]));
    };
    ConveniosEditarPagoComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-convenios-editar-pago',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a [routerLink]=\"['../convenios']\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <h3>Editar convenio <span style=\"color:#CC0000;font-size: 18px;\" *ngIf=\"requiredAuth\">(* Requiere autorizaci&oacute;n)</span></h3>\r\n          <div class=\"menu-pills\">\r\n            <a>\r\n              <div class=\"item first\">Datos generales</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item active\">Reglas de pago</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item\">Intercambio</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item last\">Gr\u00E1fica</div>\r\n            </a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <form [formGroup]=\"formGroup\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n        <div class=\"form-section\">          \r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Tipo de moneda\" formControlName=\"tipoMoneda\" (selectionChange)=\"onTipoMonedaSelect($event)\">\r\n                  <mat-option *ngFor=\"let moneda of tipoMonedaSelect\" [value]=\"moneda.codigo\">{{moneda.divisa}}</mat-option>\r\n                </mat-select>\r\n                <mat-error *ngIf=\"formGroup.get('tipoMoneda').invalid\">Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4\">\r\n              <mat-form-field>\r\n                <span matPrefix>{{monedaPago}} $&nbsp;</span>\r\n                <input matInput digitOnly placeholder=\"Monto m&iacute;nimo (Opcional)\" formControlName=\"montoMinimo\" [maxlength]=\"lengthMontoXMoneda\" [value]=\"numberMonedaPipe.transform(formGroup.get('montoMinimo').value, monedaPago)\">\r\n                <mat-error *ngIf=\"formGroup.get('montoMinimo').hasError('amountError')\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4\">\r\n              <mat-form-field>\r\n                <span matPrefix>{{monedaPago}} $&nbsp;</span>\r\n                <input matInput digitOnly placeholder=\"Monto m&aacute;ximo (Opcional)\" formControlName=\"montoMaximo\" [maxlength]=\"lengthMontoXMoneda\" [value]=\"numberMonedaPipe.transform(formGroup.get('montoMaximo').value, monedaPago)\">\r\n                <mat-error *ngIf=\"formGroup.get('montoMaximo').hasError('amountError')\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Tipo de cobro\" formControlName=\"tipoCobro\" (selectionChange)=\"onTipoCobroSelect($event)\">\r\n                  <mat-option *ngFor=\"let pos of tipoCobroSelect\" [value]=\"pos.value\">{{pos.option}}</mat-option>\r\n                </mat-select>\r\n                <mat-error *ngIf=\"formGroup.get('tipoCobro').invalid\">Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-8\" style=\"padding: 20px 5px;\">\r\n              <div class=\"form-check form-check-inline\">\r\n                <mat-checkbox class=\"example-margin\" formControlName=\"activaMandato\">Activaci&oacute;n autom&aacute;tica de mandato.</mat-checkbox>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-section\" *ngIf=\"formGroup.get('tipoCobro').value == 'F'\">\r\n          <h5>D\u00EDas de cargo</h5>\r\n          <small class=\"form-text text-muted mb-1\">Seleccione los d&iacute;as del mes v&aacute;lidos para realizar los cobros.</small>\r\n          <div class=\"dias-cargo\">\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo1\" formControlName=\"diaCargo1\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo1\"><span class=\"etiqueta\">1</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo2\" formControlName=\"diaCargo2\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo2\"><span class=\"etiqueta\">2</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo3\" formControlName=\"diaCargo3\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo3\"><span class=\"etiqueta\">3</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo4\" formControlName=\"diaCargo4\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo4\"><span class=\"etiqueta\">4</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo5\" formControlName=\"diaCargo5\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo5\"><span class=\"etiqueta\">5</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo6\" formControlName=\"diaCargo6\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo6\"><span class=\"etiqueta\">6</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo7\" formControlName=\"diaCargo7\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo7\"><span class=\"etiqueta\">7</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo8\" formControlName=\"diaCargo8\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo8\"><span class=\"etiqueta\">8</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo9\" formControlName=\"diaCargo9\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo9\"><span class=\"etiqueta\">9</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo10\" formControlName=\"diaCargo10\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo10\"><span class=\"etiqueta\">10</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo11\" formControlName=\"diaCargo11\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo11\"><span class=\"etiqueta\">11</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo12\" formControlName=\"diaCargo12\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo12\"><span class=\"etiqueta\">12</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo13\" formControlName=\"diaCargo13\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo13\"><span class=\"etiqueta\">13</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo14\" formControlName=\"diaCargo14\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo14\"><span class=\"etiqueta\">14</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo15\" formControlName=\"diaCargo15\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo15\"><span class=\"etiqueta\">15</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo16\" formControlName=\"diaCargo16\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo16\"><span class=\"etiqueta\">16</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo17\" formControlName=\"diaCargo17\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo17\"><span class=\"etiqueta\">17</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo18\" formControlName=\"diaCargo18\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo18\"><span class=\"etiqueta\">18</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo19\" formControlName=\"diaCargo19\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo19\"><span class=\"etiqueta\">19</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo20\" formControlName=\"diaCargo20\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo20\"><span class=\"etiqueta\">20</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo21\" formControlName=\"diaCargo21\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo21\"><span class=\"etiqueta\">21</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo22\" formControlName=\"diaCargo22\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo22\"><span class=\"etiqueta\">22</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo23\" formControlName=\"diaCargo23\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo23\"><span class=\"etiqueta\">23</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo24\" formControlName=\"diaCargo24\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo24\"><span class=\"etiqueta\">24</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo25\" formControlName=\"diaCargo25\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo25\"><span class=\"etiqueta\">25</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo26\" formControlName=\"diaCargo26\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo26\"><span class=\"etiqueta\">26</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo27\" formControlName=\"diaCargo27\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo27\"><span class=\"etiqueta\">27</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo28\" formControlName=\"diaCargo28\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo28\"><span class=\"etiqueta\">28</span></label>\r\n            </div>\r\n\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo29\" formControlName=\"diaCargo29\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo29\"><span class=\"etiqueta\">29</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo30\" formControlName=\"diaCargo30\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo30\"><span class=\"etiqueta\">30</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo31\" formControlName=\"diaCargo31\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo31\"><span class=\"etiqueta\">31</span></label>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-section\">\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-5\">\r\n              <h5>Reintentos</h5>\r\n              <div class=\"switch-box float-right\">\r\n                <mat-slide-toggle (change)=\"checkValueReintentos()\" formControlName=\"reintentos\"></mat-slide-toggle>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-9\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Cantidad de reintentos\" formControlName=\"cantidadReintentos\">\r\n                      <mat-option *ngFor=\"let reintentos of cantidadReintentosSelect\" [value]=\"reintentos.value\">\r\n                        {{reintentos.option}}</mat-option>\r\n                    </mat-select>\r\n                    <mat-error *ngIf=\"formGroup.get('cantidadReintentos').invalid\">Este campo es requerido.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"col-md-5 offset-md-1\" *ngIf=\"formGroup.get('tipoCobro').value == 'V'\">\r\n              <h5>Criterios de duplicidad</h5>\r\n              <div class=\"switch-box float-right\">\r\n                <mat-slide-toggle (change)=\"checkValue()\" formControlName=\"criteriosDuplicidad\"></mat-slide-toggle>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class=\"col\">\r\n                  <div class=\"form-check form-check-inline\">\r\n                    <mat-checkbox class=\"example-margin\" formControlName=\"idServicio\">ID Servicio</mat-checkbox>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class=\"col\">\r\n                  <div class=\"form-check form-check-inline\">\r\n                    <mat-checkbox class=\"example-margin\" formControlName=\"montoPago\">Monto de pago</mat-checkbox>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class=\"col\">\r\n                  <div class=\"form-check form-check-inline\">\r\n                    <mat-checkbox class=\"example-margin\" formControlName=\"fechaVencimiento\">Fecha de vencimiento\r\n                    </mat-checkbox>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col align-left\">\r\n            <button class=\"btn text\" type=\"submit\" [routerLink]=\"['../conveniosEditarAgregar']\"><i class=\"str-icon-flecha-izquierda\"></i>ANTERIOR</button>\r\n          </div>\r\n          <div class=\"col align-right\">\r\n            <button *ngIf=\"formGroup.valid && (formGroup.get('criteriosDuplicidad').value == true && (formGroup.get('idServicio').value == false && formGroup.get('montoPago').value == false && formGroup.get('fechaVencimiento').value == false))\" disabled class=\"btn main\" type=\"submit\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i></button>\r\n            <button *ngIf=\"formGroup.valid && (formGroup.get('criteriosDuplicidad').value == true && (formGroup.get('idServicio').value == true || formGroup.get('montoPago').value == true || formGroup.get('fechaVencimiento').value == true))\" class=\"btn main\" type=\"submit\" (click)=\"onSubmit()\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i></button><!-- [routerLink]=\"['../conveniosEditarIntercambio']\" -->\r\n            <button *ngIf=\"formGroup.valid && formGroup.get('criteriosDuplicidad').value == false && formGroup.get('tipoCobro').value == 'V'\" class=\"btn main\" type=\"submit\" (click)=\"onSubmit()\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i></button><!-- [routerLink]=\"['../conveniosEditarIntercambio']\" -->\r\n            <button *ngIf=\"formGroup.invalid\" class=\"btn main\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i></button>\r\n            <button *ngIf=\"formGroup.valid && (formGroup.get('tipoCobro').value == 'F' && (formGroup.get('diaCargo1').value != true && formGroup.get('diaCargo2').value != true && formGroup.get('diaCargo3').value != true && formGroup.get('diaCargo4').value != true && formGroup.get('diaCargo5').value != true && formGroup.get('diaCargo6').value != true && formGroup.get('diaCargo7').value != true && formGroup.get('diaCargo8').value != true && formGroup.get('diaCargo9').value != true && formGroup.get('diaCargo10').value != true && formGroup.get('diaCargo11').value != true && formGroup.get('diaCargo12').value != true && formGroup.get('diaCargo13').value != true\r\n            && formGroup.get('diaCargo14').value != true && formGroup.get('diaCargo15').value != true && formGroup.get('diaCargo16').value != true && formGroup.get('diaCargo17').value != true && formGroup.get('diaCargo18').value != true && formGroup.get('diaCargo19').value != true && formGroup.get('diaCargo20').value != true && formGroup.get('diaCargo21').value != true && formGroup.get('diaCargo22').value != true && formGroup.get('diaCargo23').value != true && formGroup.get('diaCargo24').value != true\r\n            && formGroup.get('diaCargo25').value != true && formGroup.get('diaCargo26').value != true && formGroup.get('diaCargo27').value != true && formGroup.get('diaCargo28').value != true && formGroup.get('diaCargo29').value != true && formGroup.get('diaCargo30').value != true && formGroup.get('diaCargo31').value != true))\" disabled class=\"btn main\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i>\r\n            </button>\r\n            <button *ngIf=\"formGroup.valid && (formGroup.get('tipoCobro').value == 'F' && (formGroup.get('diaCargo1').value == true || formGroup.get('diaCargo2').value == true || formGroup.get('diaCargo3').value == true || formGroup.get('diaCargo4').value == true || formGroup.get('diaCargo5').value == true || formGroup.get('diaCargo6').value == true || formGroup.get('diaCargo7').value == true || formGroup.get('diaCargo8').value == true || formGroup.get('diaCargo9').value == true || formGroup.get('diaCargo10').value == true || formGroup.get('diaCargo11').value == true || formGroup.get('diaCargo12').value == true || formGroup.get('diaCargo13').value == true || \r\n            formGroup.get('diaCargo14').value == true || formGroup.get('diaCargo15').value == true || formGroup.get('diaCargo16').value == true || formGroup.get('diaCargo17').value == true || formGroup.get('diaCargo18').value == true || formGroup.get('diaCargo19').value == true || formGroup.get('diaCargo20').value == true || formGroup.get('diaCargo21').value == true || formGroup.get('diaCargo22').value == true || formGroup.get('diaCargo23').value == true || formGroup.get('diaCargo24').value == true ||\r\n            formGroup.get('diaCargo25').value == true || formGroup.get('diaCargo26').value == true || formGroup.get('diaCargo27').value == true || formGroup.get('diaCargo28').value == true || formGroup.get('diaCargo29').value == true || formGroup.get('diaCargo30').value == true || formGroup.get('diaCargo31').value == true))\" class=\"btn main\" type=\"submit\" (click)=\"onSubmit()\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i><!-- [routerLink]=\"['../conveniosEditarIntercambio']\" -->\r\n            </button>\r\n          </div>\r\n        </div>\r\n\r\n      </form>\r\n    </div>\r\n\r\n  </div>\r\n</section>",
                    styles: [".example-radio-button{margin:5px}"]
                }] }
    ];
    /** @nocollapse */
    ConveniosEditarPagoComponent.ctorParameters = function () { return [
        { type: ConveniosAgregarService },
        { type: MatDialog },
        { type: Router },
        { type: ActivatedRoute }
    ]; };
    return ConveniosEditarPagoComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$6 = MAT_MOMENT_DATE_FORMATS;
var ConveniosGraficaComponent = /** @class */ (function () {
    function ConveniosGraficaComponent(peticionAgregar, agregarImagen, router, route, domSanitizer, dialog) {
        this.peticionAgregar = peticionAgregar;
        this.agregarImagen = agregarImagen;
        this.router = router;
        this.route = route;
        this.domSanitizer = domSanitizer;
        this.dialog = dialog;
        this.imagenesArray = [];
        this.idImagenBoleta = '';
        this.idImagenPortada = '';
        this.buscarImagen = new ConveniosBuscarImagen();
        this.tieneImagen = false;
        this.tieneImagen2 = false;
        this.nuevaImagen = false;
        this.nuevaImagen2 = false;
        this.requiredAuth = false;
        this.convenioGraficaAgregar = JSON.parse(sessionStorage.getItem('convenioGraficaAgregar'));
    }
    /**
     * @return {?}
     */
    ConveniosGraficaComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formGroup = new FormGroup({
            colorTextoPrincipal: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(6), Validators.pattern('^[A-Fa-f0-9]+$')])),
            colorLineasDestacadas: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(6), Validators.pattern('^[A-Fa-f0-9]+$')])),
            colorBotonNormal: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(6), Validators.pattern('^[A-Fa-f0-9]+$')])),
            colorBotonHover: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(6), Validators.pattern('^[A-Fa-f0-9]+$')])),
            colorBotonPresionado: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(6), Validators.pattern('^[A-Fa-f0-9]+$')])),
            archivo: new FormControl(),
            archivo2: new FormControl()
        });
        if (this.convenioGraficaAgregar != null) {
            this.formGroup.controls['colorTextoPrincipal'].setValue(this.convenioGraficaAgregar.colorTextoPrincipal.substr(1));
            this.formGroup.controls['colorLineasDestacadas'].setValue(this.convenioGraficaAgregar.colorLineasDestacadas.substr(1));
            this.formGroup.controls['colorBotonNormal'].setValue(this.convenioGraficaAgregar.colorBotonNormal.substr(1));
            this.formGroup.controls['colorBotonHover'].setValue(this.convenioGraficaAgregar.colorBotonHover.substr(1));
            this.formGroup.controls['colorBotonPresionado'].setValue(this.convenioGraficaAgregar.colorBotonPresionado.substr(1));
        }
        else {
            this.formGroup.controls['colorTextoPrincipal'].setValue('401b68');
            this.formGroup.controls['colorLineasDestacadas'].setValue('401b68');
            this.formGroup.controls['colorBotonNormal'].setValue('6a1978');
            this.formGroup.controls['colorBotonHover'].setValue('51015f');
            this.formGroup.controls['colorBotonPresionado'].setValue('33003c');
        }
        this.requiredAuth = ('true' === sessionStorage.getItem('requiredAuth_ADDCNV'));
    };
    /**
     * @return {?}
     */
    ConveniosGraficaComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        this.graficaLocalStorage();
        this.showDialogPre('Información', 'Si realiza esta acción, agregará un nuevo convenio.<br>¿Está seguro?', true);
    };
    /**
     * @return {?}
     */
    ConveniosGraficaComponent.prototype.postConvenioInsertarServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.peticionAgregar.postConvenioInsertarReport().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            sessionStorage.setItem('pacConvenioInsertado', JSON.stringify(data));
            _this.pacConvenioInsertado = JSON.parse(sessionStorage.getItem('pacConvenioInsertado'));
            switch (_this.pacConvenioInsertado.codret) {
                case '0':
                    _this.showDialog('Información', 'Convenio agregado de forma satisfactoria.', false);
                    break;
                case '1':
                    _this.showDialog('Información', 'Convenio agregado exitosamente pero requiere autorización.', false);
                    break;
                case '-2':
                    _this.showDialogFail('Error', 'No ha sido posible insertar el convenio.<br>La Empresa seleccionada ya tiene un Convenio asociado.', false);
                    break;
                case '-7':
                    _this.showDialogFail('Error', 'Existe una autorización pendiente para el convenio.', false);
                    break;
                default:
                    _this.showDialogFail('Error', 'No ha sido posible insertar el convenio.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialogFail('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @return {?}
     */
    ConveniosGraficaComponent.prototype.graficaLocalStorage = /**
     * @return {?}
     */
    function () {
        if (this.idImagenBoleta != '')
            this.imagenesArray.push({ "tipoImagen": 'boleta', "idImagen": this.idImagenBoleta });
        if (this.idImagenPortada != '')
            this.imagenesArray.push({ "tipoImagen": 'portada', "idImagen": this.idImagenPortada });
        sessionStorage.setItem('convenioGraficaAgregar', JSON.stringify({
            colorTextoPrincipal: '#' + this.formGroup.get('colorTextoPrincipal').value,
            colorLineasDestacadas: '#' + this.formGroup.get('colorLineasDestacadas').value,
            colorBotonNormal: '#' + this.formGroup.get('colorBotonNormal').value,
            colorBotonHover: '#' + this.formGroup.get('colorBotonHover').value,
            colorBotonPresionado: '#' + this.formGroup.get('colorBotonPresionado').value,
            infoImagen: this.imagenesArray
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ConveniosGraficaComponent.prototype.showDialogPre = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            if (result) {
                _this.postConvenioInsertarServices();
            }
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ConveniosGraficaComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            _this.router.navigate(['../convenios'], { relativeTo: _this.route });
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ConveniosGraficaComponent.prototype.showDialogFail = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ConveniosGraficaComponent.prototype.showDialogImagen = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogImagenComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true,
            maxWidth: '500px'
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} event
     * @param {?} tipo
     * @return {?}
     */
    ConveniosGraficaComponent.prototype.addToQueue = /**
     * @param {?} event
     * @param {?} tipo
     * @return {?}
     */
    function (event, tipo) {
        var _this = this;
        /** @type {?} */
        var type = this.setPitchfile(event);
        if (type == "image/png" || type == "image/jpeg" || type == "image/bmp") {
            /** @type {?} */
            var fileBrowser = event.srcElement.files[0];
            console.log(fileBrowser);
            /** @type {?} */
            var formData = new FormData();
            formData.append('imagen', fileBrowser);
            formData.append('tipoImagen', tipo);
            this.agregarImagen.postConveniosImagen(formData).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                console.log(data);
                if (data.codret == '0') {
                    if (tipo == 'boleta') {
                        _this.idImagenBoleta = data.idImg;
                        _this.imagenBoletaNueva = data.img64;
                        _this.nuevaImagen = true;
                    }
                    if (tipo == 'portada') {
                        _this.idImagenPortada = data.idImg;
                        _this.imagenPortadaNueva = data.img64;
                        _this.nuevaImagen2 = true;
                    }
                }
                else {
                    _this.showDialogFail('Error ', data.descret, false);
                }
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function (err) {
                console.log("error");
                console.log(err);
                _this.showDialogFail('Error ', 'Servicio temporalmente no disponible.', false);
            }));
        }
        else {
            this.showDialogFail('Error', 'El archivo no es válido.<br>Inténtelo con otro.', false);
            this.formGroup.get('archivo').reset();
        }
    };
    /**
     * @param {?} fileInput
     * @return {?}
     */
    ConveniosGraficaComponent.prototype.setPitchfile = /**
     * @param {?} fileInput
     * @return {?}
     */
    function (fileInput) {
        for (var i = fileInput.target.files.length - 1; i >= 0; i--) {
            /** @type {?} */
            var file = fileInput.target.files[i];
            this.pitchfile = file;
        }
        return this.pitchfile['type'];
    };
    /**
     * @param {?} tipoImagen
     * @return {?}
     */
    ConveniosGraficaComponent.prototype.verImagen = /**
     * @param {?} tipoImagen
     * @return {?}
     */
    function (tipoImagen) {
        if (tipoImagen == 'boleta') {
            this.base64Image = this.domSanitizer.bypassSecurityTrustResourceUrl('data:' + this.formatoImagenBoleta + ';base64,' + this.imagenBoletaNueva);
        }
        if (tipoImagen == 'portada') {
            this.base64Image = this.domSanitizer.bypassSecurityTrustResourceUrl('data:' + this.formatoImagenPortada + ';base64,' + this.imagenPortadaNueva);
        }
        this.showDialogImagen('Error ', this.base64Image, true);
    };
    ConveniosGraficaComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-convenios-grafica',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a [routerLink]=\"['../convenios']\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <h3>Agregar convenio <span style=\"color:#CC0000;font-size: 18px;\" *ngIf=\"requiredAuth\">(* Requiere autorizaci&oacute;n)</span></h3>\r\n          <div class=\"menu-pills\">\r\n            <a>\r\n              <div class=\"item first\">Datos generales</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item\">Reglas de pago</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item\">Intercambio</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item last active\">Gr\u00E1fica</div>\r\n            </a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <form [formGroup]=\"formGroup\" autocomplete=\"off\">\r\n        <!-- <div class=\"form-section\">\r\n          <h5>Im\u00E1genes</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-7\">\r\n              <div class=\"grafica-box\">\r\n                <div class=\"item form-row\">\r\n                  <div class=\"col-8\">Logotipo del comercio (100 x 100 p\u00EDxeles)</div>\r\n                  <div class=\"col-4 text-right\"><a><i class=\"icon str-icon-trash\"></i> Borrar archivo</a></div>\r\n                </div>\r\n                <div class=\"form-row imagen logo-comercio\">\r\n                  <img>\r\n                </div>\r\n              </div>\r\n              <div class=\"grafica-box\">\r\n                <div class=\"item form-row\">\r\n                  <div class=\"col-8\">Imagen de bienvenida (315 x 300 p\u00EDxeles)</div>\r\n                  <div class=\"col-4 text-right\"><a><i class=\"icon str-icon-trash\"></i> Borrar archivo</a></div>\r\n                </div>\r\n                <div class=\"form-row imagen bienvenida\">\r\n                  <img>\r\n                </div>\r\n              </div>\r\n              <div class=\"grafica-box\">\r\n                <div class=\"item form-row\">\r\n                  <div class=\"col-8\">Documento del comercio (500 x 250 p\u00EDxeles)</div>\r\n                  <div class=\"col-4 text-right\"><a><i class=\"icon str-icon-trash\"></i> Borrar archivo</a></div>\r\n                </div>\r\n                <div class=\"form-row imagen documento-comercio\">\r\n                  <img>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div> -->\r\n\r\n        <div class=\"form-section\">\r\n          \r\n\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-5\">\r\n              <h5>Colores</h5>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-4 color-box\">\r\n                  <span class=\"item\" [ngStyle]=\"{'background-color': '#'+formGroup.get('colorTextoPrincipal').value}\"></span>\r\n                </div>\r\n                <div>\r\n                  <mat-form-field>\r\n                    <span matPrefix>#</span>\r\n                    <input matInput maxlength=\"6\" placeholder=\"Color texto principal (HEX)\" formControlName=\"colorTextoPrincipal\">\r\n                    <mat-error *ngIf=\"formGroup.get('colorTextoPrincipal').invalid\">Este campo no es <strong>v\u00E1lido.</strong></mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"row\">\r\n                <div class=\"col-md-4 color-box\">\r\n                  <span class=\"item lineas\" [ngStyle]=\"{'border-color': '#'+formGroup.get('colorLineasDestacadas').value}\"></span>\r\n                </div>\r\n                <div>\r\n                  <mat-form-field>\r\n                    <span matPrefix>#</span>\r\n                    <input matInput maxlength=\"6\" placeholder=\"Color l\u00EDneas destacadas (HEX)\" formControlName=\"colorLineasDestacadas\">\r\n                    <mat-error *ngIf=\"formGroup.get('colorLineasDestacadas').invalid\">Este campo no es <strong>v\u00E1lido.</strong></mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"row\">\r\n                <div class=\"col-md-4 color-box\">\r\n                  <span class=\"item\" [ngStyle]=\"{'background-color': '#'+formGroup.get('colorBotonNormal').value}\">Texto del bot\u00F3n</span>\r\n                </div>\r\n                <div >\r\n                  <mat-form-field>\r\n                    <span matPrefix>#</span>\r\n                    <input matInput maxlength=\"6\" placeholder=\"Color bot\u00F3n normal (HEX)\" formControlName=\"colorBotonNormal\">\r\n                    <mat-error *ngIf=\"formGroup.get('colorBotonNormal').invalid\">Este campo no es <strong>v\u00E1lido.</strong></mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"row\">\r\n                <div class=\"col-md-4 color-box\">\r\n                  <span class=\"item\" [ngStyle]=\"{'background-color': '#'+formGroup.get('colorBotonHover').value}\">Texto del bot\u00F3n</span>\r\n                </div>\r\n                <div>\r\n                  <mat-form-field>\r\n                    <span matPrefix>#</span>\r\n                    <input matInput maxlength=\"6\" placeholder=\"Color bot\u00F3n estado Hover (HEX)\" formControlName=\"colorBotonHover\">\r\n                    <mat-error *ngIf=\"formGroup.get('colorBotonHover').invalid\">Este campo no es <strong>v\u00E1lido.</strong></mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"row\">\r\n                <div class=\"col-md-4 color-box\">\r\n                  <span class=\"item\" [ngStyle]=\"{'background-color': '#'+formGroup.get('colorBotonPresionado').value}\">Texto del bot\u00F3n</span>\r\n                </div>\r\n                <div>\r\n                  <mat-form-field>\r\n                    <span matPrefix>#</span>\r\n                    <input matInput maxlength=\"6\" placeholder=\"Color bot\u00F3n presionado (HEX)\" formControlName=\"colorBotonPresionado\">\r\n                    <mat-error *ngIf=\"formGroup.get('colorBotonPresionado').invalid\">Este campo no es <strong>v\u00E1lido.</strong></mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n\r\n            <div class=\"col-md-5 offset-md-1\">\r\n              <h5>Imagen boleta</h5>\r\n              <div class=\"row\">\r\n                <button class=\"btn-small out\" (click)=\"fileInput.click()\"><i class=\"str-icon-nuevo-documento\"></i> Agregar imagen</button>\r\n                <input type=\"file\" style=\"display:none\" #fileInput (change)=\"addToQueue($event,'boleta')\" formControlName=\"archivo\" accept=\".jpg, .png\" />\r\n                <div *ngIf=\"nuevaImagen\">\r\n                  <button class=\"btn-small out\" (click)=\"verImagen('boleta')\"><i class=\"str-icon-nuevo-documento\"></i> Ver nueva imagen</button>\r\n                </div>\r\n              </div>\r\n              <h5>Imagen bienvenida</h5>\r\n              <div class=\"row\">\r\n                <button class=\"btn-small out\" (click)=\"fileInput2.click()\"><i class=\"str-icon-nuevo-documento\"></i> Agregar archivo</button>\r\n                <input type=\"file\" style=\"display:none\" #fileInput2 (change)=\"addToQueue($event,'portada')\" formControlName=\"archivo2\" accept=\".jpg, .png\" />\r\n                <div *ngIf=\"nuevaImagen2\">\r\n                  <button class=\"btn-small out\" (click)=\"verImagen('portada')\"><i class=\"str-icon-nuevo-documento\"></i> Ver nueva imagen</button>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col align-left\">\r\n            <button class=\"btn text\" type=\"submit\" [routerLink]=\"['../conveniosIntercambio']\" (click)=\"graficaLocalStorage()\"><i class=\"str-icon-flecha-izquierda\"></i>ANTERIOR</button>\r\n          </div>\r\n          <div class=\"col align-right\">\r\n            <!-- <button class=\"btn secundario\" type=\"button\">Guardar</button> -->\r\n            <button *ngIf=\"formGroup.valid\" class=\"btn main\" type=\"submit\" (click)=\"onSubmit()\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n            <button *ngIf=\"formGroup.invalid\" class=\"btn main\" type=\"submit\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [ConveniosService, { provide: MAT_DATE_LOCALE$2, useValue: 'es' },
                        { provide: DateAdapter$2, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE$2] },
                        { provide: MAT_DATE_FORMATS$2, useValue: ɵ0$6 }, DatePipe],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ConveniosGraficaComponent.ctorParameters = function () { return [
        { type: ConveniosAgregarService },
        { type: ConveniosService },
        { type: Router },
        { type: ActivatedRoute },
        { type: DomSanitizer },
        { type: MatDialog }
    ]; };
    ConveniosGraficaComponent.propDecorators = {
        fileInput: [{ type: ViewChild, args: ['fileInput',] }],
        fileInput2: [{ type: ViewChild, args: ['fileInput2',] }]
    };
    return ConveniosGraficaComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConveniosIntercambioComponent = /** @class */ (function () {
    function ConveniosIntercambioComponent(peticionAgregar) {
        this.peticionAgregar = peticionAgregar;
        this.conFactSelect = [
            { option: '0', value: '0' },
            { option: '1', value: '1' },
            { option: '2', value: '2' },
            { option: '3', value: '3' },
            { option: '4', value: '4' },
            { option: '5', value: '5' },
            { option: '6', value: '6' },
            { option: '7', value: '7' },
            { option: '8', value: '8' },
            { option: '9', value: '9' },
            { option: '10', value: '10' }
        ];
        this.tipoRendSelect = [
            { option: 'Cobro', value: 'C' },
            { option: 'Facturación', value: 'F' }
        ];
        this.tipoCargaFactSelect = [];
        this.tipoCargaMandSelect = [];
        this.tipoCargaRendSelect = [];
        this.tipoFacturacion = "";
        this.requiredAuth = false;
        this.convenioIntercambioAgregar = JSON.parse(sessionStorage.getItem('convenioIntercambioAgregar'));
        this.cnvPago = JSON.parse(sessionStorage.getItem('convenioPagoAgregar'));
    }
    /**
     * @return {?}
     */
    ConveniosIntercambioComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.postListarConfiguracionServices();
        this.formGroup = new FormGroup({
            tolMandatos: new FormControl('', Validators.compose([Validators.min(0), Validators.max(100), Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            conFact: new FormControl('', Validators.required),
            tipoRend: new FormControl('', Validators.required),
            confIdFat: new FormControl('', Validators.required),
            confIdMan: new FormControl('', Validators.required),
            confIdRen: new FormControl('', Validators.required),
            mismoArchivo: new FormControl(),
            medioPagoMigracion: new FormControl()
        });
        if (this.convenioIntercambioAgregar != null) {
            this.formGroup.controls['tolMandatos'].setValue(this.convenioIntercambioAgregar.tolMandatos);
            this.formGroup.controls['conFact'].setValue(this.convenioIntercambioAgregar.conFact);
            this.formGroup.controls['tipoRend'].setValue(this.convenioIntercambioAgregar.tipoRend);
            this.formGroup.controls['confIdFat'].setValue(this.convenioIntercambioAgregar.confIdFat);
            this.formGroup.controls['confIdMan'].setValue(this.convenioIntercambioAgregar.confIdMan);
            this.formGroup.controls['confIdRen'].setValue(this.convenioIntercambioAgregar.confIdRen);
            this.formGroup.controls['mismoArchivo'].setValue(this.convenioIntercambioAgregar.mismoArchivo);
            this.formGroup.controls['medioPagoMigracion'].setValue(this.convenioIntercambioAgregar.medioPagoMigracion);
        }
        else {
            this.formGroup.controls['tolMandatos'].setValue(0);
            this.formGroup.controls['conFact'].reset();
            this.formGroup.controls['tipoRend'].reset();
            this.formGroup.controls['confIdFat'].reset();
            this.formGroup.controls['confIdMan'].reset();
            this.formGroup.controls['confIdRen'].reset();
            this.formGroup.controls['mismoArchivo'].setValue(false);
            this.formGroup.controls['medioPagoMigracion'].setValue(true);
        }
        this.requiredAuth = ('true' === sessionStorage.getItem('requiredAuth_ADDCNV'));
        this.tipoFacturacion = this.cnvPago['tipoCobro'];
        if (this.tipoFacturacion == 'F') {
            this.formGroup.controls.tolMandatos.setValue('0');
            this.formGroup.controls.conFact.setValue('0');
            this.formGroup.controls.confIdFat.reset('');
            this.formGroup.controls.mismoArchivo.reset();
            this.formGroup.controls.tolMandatos.disable();
            this.formGroup.controls.conFact.disable();
            this.formGroup.controls.confIdFat.disable();
            this.formGroup.controls.mismoArchivo.disable();
        }
        else {
            this.formGroup.controls.tolMandatos.enable();
            this.formGroup.controls.conFact.enable();
            this.formGroup.controls.confIdFat.enable();
            this.formGroup.controls.mismoArchivo.enable();
        }
    };
    /**
     * @return {?}
     */
    ConveniosIntercambioComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        sessionStorage.setItem('convenioIntercambioAgregar', JSON.stringify({
            tolMandatos: this.formGroup.get('tolMandatos').value,
            conFact: this.formGroup.get('conFact').value,
            tipoRend: this.formGroup.get('tipoRend').value,
            confIdFat: this.formGroup.get('confIdFat').value,
            confIdMan: this.formGroup.get('confIdMan').value,
            confIdRen: this.formGroup.get('confIdRen').value,
            mismoArchivo: this.formGroup.get('mismoArchivo').value,
            medioPagoMigracion: this.formGroup.get('medioPagoMigracion').value
        }));
    };
    /**
     * @return {?}
     */
    ConveniosIntercambioComponent.prototype.postListarConfiguracionServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new ConfiguracionPeticion();
        this.peticionAgregar.postConfiguracionesCarga(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.tipoCargaFactSelect = data.configuraciones.filter((/**
                 * @param {?} element
                 * @return {?}
                 */
                function (element) { return element.arcTipCod === 'FAT'; }));
                _this.tipoCargaMandSelect = data.configuraciones.filter((/**
                 * @param {?} element
                 * @return {?}
                 */
                function (element) { return element.arcTipCod === 'MAN'; }));
                _this.tipoCargaRendSelect = data.configuraciones.filter((/**
                 * @param {?} element
                 * @return {?}
                 */
                function (element) { return element.arcTipCod === 'REN'; }));
            }
            else {
                console.log('Error en postListarConfiguracionServices', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en postListarConfiguracionServices', err);
        }));
    };
    ConveniosIntercambioComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-convenios-intercambio',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a [routerLink]=\"['../convenios']\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <h3>Agregar convenio <span style=\"color:#CC0000;font-size: 18px;\" *ngIf=\"requiredAuth\">(* Requiere autorizaci&oacute;n)</span></h3>\r\n          <div class=\"menu-pills\">\r\n            <a>\r\n              <div class=\"item first\">Datos generales</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item\">Reglas de pago</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item active\">Intercambio</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item last\">Gr&aacute;fica</div>\r\n            </a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <form [formGroup]=\"formGroup\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n        <div class=\"form-section\">\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-5\">\r\n              <h5>Tolerancia de errores (%)</h5>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                  <mat-form-field>\r\n                    <input matInput type=\"text\" digitOnly maxlength=\"3\" placeholder=\"Tolerancia Activaci&oacute;n de mandatos\" formControlName=\"tolMandatos\" min=\"0\" max=\"100\">\r\n                    <mat-error *ngIf=\"formGroup.get('tolMandatos').invalid\">Valor esperado entre 0 y 100.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-5 offset-md-1\">\r\n              <h5>Control facturaci&oacute;n</h5>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-5\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Control\" formControlName=\"conFact\">\r\n                      <mat-option *ngFor=\"let con of conFactSelect\" [value]=\"con.value\">{{con.option}}</mat-option>\r\n                    </mat-select>\r\n                    <mat-error *ngIf=\"formGroup.get('conFact').invalid\">Este campo es requerido.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-5\">\r\n              <h5>Comprobaci&oacute;n de archivos</h5>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-5\">\r\n                  <div class=\"form-check form-check-inline\">\r\n                    <mat-checkbox class=\"example-margin\" formControlName=\"mismoArchivo\">No permitir subir el mismo archivo de facturaci&oacute;n</mat-checkbox>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-5 offset-md-1\">\r\n              <h5>Tipo de rendici&oacute;n</h5>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-5\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Seleccione\" formControlName=\"tipoRend\">\r\n                      <mat-option *ngFor=\"let tipo of tipoRendSelect\" [value]=\"tipo.value\">{{tipo.option}}</mat-option>\r\n                    </mat-select>\r\n                    <mat-error *ngIf=\"formGroup.get('tipoRend').invalid\">Este campo es requerido.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-5\">\r\n              <h5>Tipo carga facturaci&oacute;n</h5>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-5\">\r\n                  <mat-form-field style=\"width: 20rem !important;\">\r\n                    <mat-select matNativeControl placeholder=\"Seleccione\" formControlName=\"confIdFat\">\r\n                      <mat-option *ngFor=\"let tipo of tipoCargaFactSelect\" [value]=\"tipo.arcConCarId\">{{tipo.descConfiguracion}}</mat-option>\r\n                    </mat-select>\r\n                    <mat-error *ngIf=\"formGroup.get('confIdFat').invalid\">Este campo es requerido.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-5 offset-md-1\">\r\n              <h5>Tipo intercambio mandatos</h5>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-5\">\r\n                  <mat-form-field style=\"width: 20rem !important;\">\r\n                    <mat-select matNativeControl placeholder=\"Seleccione\" formControlName=\"confIdMan\">\r\n                      <mat-option *ngFor=\"let tipo of tipoCargaMandSelect\" [value]=\"tipo.arcConCarId\">{{tipo.descConfiguracion}}</mat-option>\r\n                    </mat-select>\r\n                    <mat-error *ngIf=\"formGroup.get('confIdMan').invalid\">Este campo es requerido.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-5\">\r\n              <h5>Tipo generaci&oacute;n rendici&oacute;n</h5>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-5\">\r\n                  <mat-form-field style=\"width: 22rem !important;\">\r\n                    <mat-select matNativeControl placeholder=\"Seleccione\" formControlName=\"confIdRen\">\r\n                      <mat-option *ngFor=\"let tipo of tipoCargaRendSelect\" [value]=\"tipo.arcConCarId\">{{tipo.descConfiguracion}}</mat-option>\r\n                    </mat-select>\r\n                    <mat-error *ngIf=\"formGroup.get('confIdRen').invalid\">Este campo es requerido.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-5 offset-md-1\">\r\n              <h5>Archivo de respuesta Migraci&oacute;n de Mandatos</h5>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-5\">\r\n                  <div class=\"form-check form-check-inline\">\r\n                    <mat-checkbox class=\"example-margin\" formControlName=\"medioPagoMigracion\">Mostrar informaci&oacute;n asociada al medio de pago</mat-checkbox>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col align-left\">\r\n            <button class=\"btn text\" type=\"submit\" [routerLink]=\"['../conveniosPago']\"><i class=\"str-icon-flecha-izquierda\"></i>ANTERIOR</button>\r\n          </div>\r\n          <div class=\"col align-right\">\r\n            <button *ngIf=\"formGroup.valid\" class=\"btn main\" type=\"submit\" [routerLink]=\"['../conveniosGrafica']\" (click)=\"onSubmit()\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i></button>\r\n            <button *ngIf=\"formGroup.invalid\" class=\"btn main\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i></button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ConveniosIntercambioComponent.ctorParameters = function () { return [
        { type: ConveniosAgregarService }
    ]; };
    return ConveniosIntercambioComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConveniosPagoComponent = /** @class */ (function () {
    function ConveniosPagoComponent(dialog, router, route) {
        this.dialog = dialog;
        this.router = router;
        this.route = route;
        this.tipoCobroSelect = [
            { option: 'Fijo', value: 'F' },
            { option: 'Variable', value: 'V' }
        ];
        this.cantidadReintentosSelect = [
            { option: '1', value: '1' },
            { option: '2', value: '2' },
            { option: '3', value: '3' },
            { option: '4', value: '4' }
        ];
        this.montoMinimo = '0';
        this.montoMaximo = '0';
        this.activarMandato = 0;
        this.requiredAuth = false;
        this.lengthMontoXMoneda = 0;
        this.numberMonedaPipe = new NumberMonedasStr();
        this.convenioPagoAgregar = JSON.parse(sessionStorage.getItem('convenioPagoAgregar'));
        this.tipoMonedaSelect = JSON.parse(sessionStorage.getItem('monedas'));
    }
    /**
     * @return {?}
     */
    ConveniosPagoComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formGroup = new FormGroup({
            //      descripcion: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(100), CustomValidators.descriptionValidator])),
            tipoMoneda: new FormControl('', Validators.required),
            montoMinimo: new FormControl('', Validators.compose([Validators.maxLength(this.lengthMontoXMoneda), CustomValidators.amountValidator])),
            //CustomValidators.numberValidator
            montoMaximo: new FormControl('', Validators.compose([Validators.maxLength(this.lengthMontoXMoneda), CustomValidators.amountValidator])),
            //CustomValidators.numberValidatorNonZero
            tipoCobro: new FormControl('', Validators.required),
            activaMandato: new FormControl(),
            criteriosDuplicidad: new FormControl(),
            idServicio: new FormControl(),
            montoPago: new FormControl(),
            fechaVencimiento: new FormControl(),
            reintentos: new FormControl(),
            cantidadReintentos: new FormControl('', Validators.required),
            diaCargo1: new FormControl(),
            diaCargo2: new FormControl(),
            diaCargo3: new FormControl(),
            diaCargo4: new FormControl(),
            diaCargo5: new FormControl(),
            diaCargo6: new FormControl(),
            diaCargo7: new FormControl(),
            diaCargo8: new FormControl(),
            diaCargo9: new FormControl(),
            diaCargo10: new FormControl(),
            diaCargo11: new FormControl(),
            diaCargo12: new FormControl(),
            diaCargo13: new FormControl(),
            diaCargo14: new FormControl(),
            diaCargo15: new FormControl(),
            diaCargo16: new FormControl(),
            diaCargo17: new FormControl(),
            diaCargo18: new FormControl(),
            diaCargo19: new FormControl(),
            diaCargo20: new FormControl(),
            diaCargo21: new FormControl(),
            diaCargo22: new FormControl(),
            diaCargo23: new FormControl(),
            diaCargo24: new FormControl(),
            diaCargo25: new FormControl(),
            diaCargo26: new FormControl(),
            diaCargo27: new FormControl(),
            diaCargo28: new FormControl(),
            diaCargo29: new FormControl(),
            diaCargo30: new FormControl(),
            diaCargo31: new FormControl()
        });
        if (this.convenioPagoAgregar != null) {
            //      this.formGroup.controls['descripcion'].setValue(this.convenioPagoAgregar.descripcion);
            /** @type {?} */
            var tipoMoneda = this.convenioPagoAgregar.tipoMoneda;
            if (tipoMoneda != '' || tipoMoneda != undefined || tipoMoneda != null) {
                this.formGroup.controls['tipoMoneda'].setValue(tipoMoneda);
                this.monedaPago = tipoMoneda;
                this.getLengthMontoXMoneda();
            }
            /** @type {?} */
            var mtoMinimo = this.convenioPagoAgregar.montoMinimo;
            /** @type {?} */
            var mtoMaximo = this.convenioPagoAgregar.montoMaximo;
            if (mtoMinimo != null && mtoMinimo != undefined && mtoMinimo != '') {
                this.formGroup.controls['montoMinimo'].setValue((tipoMoneda == 'UYU' ? (parseInt(mtoMinimo) / 100).toString() : mtoMinimo));
            }
            else {
                this.formGroup.controls['montoMinimo'].reset();
                this.montoMinimo = mtoMinimo;
            }
            if (mtoMaximo != null && mtoMaximo != undefined && mtoMaximo != '') {
                this.formGroup.controls['montoMaximo'].setValue((tipoMoneda == 'UYU' ? (parseInt(mtoMaximo) / 100).toString() : mtoMaximo));
            }
            else {
                this.formGroup.controls['montoMaximo'].reset();
                this.montoMaximo = mtoMaximo;
            }
            this.formGroup.controls['tipoCobro'].setValue(this.convenioPagoAgregar.tipoCobro);
            (this.convenioPagoAgregar.activarMandato == 1) ? this.formGroup.controls['activaMandato'].setValue(true) : this.formGroup.controls['activaMandato'].setValue(false);
            (this.convenioPagoAgregar.tipoCobro == 'F') ? this.formGroup.controls['activaMandato'].disable() : this.formGroup.controls['activaMandato'].enable();
            this.formGroup.controls['criteriosDuplicidad'].setValue(this.convenioPagoAgregar.criteriosDuplicidad);
            if (this.convenioPagoAgregar.criteriosDuplicidad) {
                this.formGroup.controls['idServicio'].enable();
                this.formGroup.controls['idServicio'].setValue(this.convenioPagoAgregar.idServicio);
                this.formGroup.controls['montoPago'].enable();
                this.formGroup.controls['montoPago'].setValue(this.convenioPagoAgregar.montoPago);
                this.formGroup.controls['fechaVencimiento'].enable();
                this.formGroup.controls['fechaVencimiento'].setValue(this.convenioPagoAgregar.fechaVencimiento);
            }
            else {
                this.formGroup.controls['idServicio'].setValue(false);
                this.formGroup.controls['idServicio'].disable();
                this.formGroup.controls['montoPago'].setValue(false);
                this.formGroup.controls['montoPago'].disable();
                this.formGroup.controls['fechaVencimiento'].setValue(false);
                this.formGroup.controls['fechaVencimiento'].disable();
            }
            this.formGroup.controls['reintentos'].setValue(this.convenioPagoAgregar.reintentos);
            if (this.convenioPagoAgregar.reintentos) {
                this.formGroup.controls['cantidadReintentos'].enable();
                this.formGroup.controls['cantidadReintentos'].setValue(this.convenioPagoAgregar.cantidadReintentos);
            }
            else {
                this.formGroup.controls['cantidadReintentos'].setValue('');
                this.formGroup.controls['cantidadReintentos'].disable();
            }
            this.formGroup.controls['diaCargo1'].setValue(this.convenioPagoAgregar.diaCargo1);
            this.formGroup.controls['diaCargo2'].setValue(this.convenioPagoAgregar.diaCargo2);
            this.formGroup.controls['diaCargo3'].setValue(this.convenioPagoAgregar.diaCargo3);
            this.formGroup.controls['diaCargo4'].setValue(this.convenioPagoAgregar.diaCargo4);
            this.formGroup.controls['diaCargo5'].setValue(this.convenioPagoAgregar.diaCargo5);
            this.formGroup.controls['diaCargo6'].setValue(this.convenioPagoAgregar.diaCargo6);
            this.formGroup.controls['diaCargo7'].setValue(this.convenioPagoAgregar.diaCargo7);
            this.formGroup.controls['diaCargo8'].setValue(this.convenioPagoAgregar.diaCargo8);
            this.formGroup.controls['diaCargo9'].setValue(this.convenioPagoAgregar.diaCargo9);
            this.formGroup.controls['diaCargo10'].setValue(this.convenioPagoAgregar.diaCargo10);
            this.formGroup.controls['diaCargo11'].setValue(this.convenioPagoAgregar.diaCargo11);
            this.formGroup.controls['diaCargo12'].setValue(this.convenioPagoAgregar.diaCargo12);
            this.formGroup.controls['diaCargo13'].setValue(this.convenioPagoAgregar.diaCargo13);
            this.formGroup.controls['diaCargo14'].setValue(this.convenioPagoAgregar.diaCargo14);
            this.formGroup.controls['diaCargo15'].setValue(this.convenioPagoAgregar.diaCargo15);
            this.formGroup.controls['diaCargo16'].setValue(this.convenioPagoAgregar.diaCargo16);
            this.formGroup.controls['diaCargo17'].setValue(this.convenioPagoAgregar.diaCargo17);
            this.formGroup.controls['diaCargo18'].setValue(this.convenioPagoAgregar.diaCargo18);
            this.formGroup.controls['diaCargo19'].setValue(this.convenioPagoAgregar.diaCargo19);
            this.formGroup.controls['diaCargo20'].setValue(this.convenioPagoAgregar.diaCargo20);
            this.formGroup.controls['diaCargo21'].setValue(this.convenioPagoAgregar.diaCargo21);
            this.formGroup.controls['diaCargo22'].setValue(this.convenioPagoAgregar.diaCargo22);
            this.formGroup.controls['diaCargo23'].setValue(this.convenioPagoAgregar.diaCargo23);
            this.formGroup.controls['diaCargo24'].setValue(this.convenioPagoAgregar.diaCargo24);
            this.formGroup.controls['diaCargo25'].setValue(this.convenioPagoAgregar.diaCargo25);
            this.formGroup.controls['diaCargo26'].setValue(this.convenioPagoAgregar.diaCargo26);
            this.formGroup.controls['diaCargo27'].setValue(this.convenioPagoAgregar.diaCargo27);
            this.formGroup.controls['diaCargo28'].setValue(this.convenioPagoAgregar.diaCargo28);
            this.formGroup.controls['diaCargo29'].setValue(this.convenioPagoAgregar.diaCargo29);
            this.formGroup.controls['diaCargo30'].setValue(this.convenioPagoAgregar.diaCargo30);
            this.formGroup.controls['diaCargo31'].setValue(this.convenioPagoAgregar.diaCargo31);
        }
        else {
            this.formGroup.controls['criteriosDuplicidad'].setValue(false);
            this.formGroup.controls['idServicio'].setValue(false);
            this.formGroup.controls['idServicio'].disable();
            this.formGroup.controls['montoPago'].setValue(false);
            this.formGroup.controls['montoPago'].disable();
            this.formGroup.controls['fechaVencimiento'].setValue(false);
            this.formGroup.controls['fechaVencimiento'].disable();
            this.formGroup.controls['reintentos'].setValue(false);
            this.formGroup.controls['cantidadReintentos'].setValue('');
            this.formGroup.controls['cantidadReintentos'].disable();
            this.formGroup.controls['montoMinimo'].disable();
            this.formGroup.controls['montoMaximo'].disable();
        }
        this.requiredAuth = ('true' === sessionStorage.getItem('requiredAuth_ADDCNV'));
    };
    /**
     * @return {?}
     */
    ConveniosPagoComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var tpoMoneda = this.formGroup.get('tipoMoneda').value;
        /** @type {?} */
        var mtoMinimo = this.formGroup.get('montoMinimo').value;
        mtoMinimo = (mtoMinimo != null && mtoMinimo != '' && mtoMinimo != undefined ? CustomValidators.validaMonto(mtoMinimo) : '');
        /** @type {?} */
        var mtoMaximo = this.formGroup.get('montoMaximo').value;
        mtoMaximo = (mtoMaximo != null && mtoMaximo != '' && mtoMaximo != undefined ? CustomValidators.validaMonto(mtoMaximo) : '');
        if (mtoMinimo != '') {
            this.montoMinimo = (tpoMoneda == 'UYU' ? (parseInt(mtoMinimo) * 100).toString() : mtoMinimo);
        }
        else {
            this.formGroup.controls['montoMinimo'].reset();
            this.montoMinimo = mtoMinimo;
        }
        if (mtoMaximo != '') {
            this.montoMaximo = (tpoMoneda == 'UYU' ? (parseInt(mtoMaximo) * 100).toString() : mtoMaximo);
        }
        else {
            this.formGroup.controls['montoMaximo'].reset();
            this.montoMaximo = mtoMaximo;
        }
        (this.formGroup.get('activaMandato').value) ? this.activarMandato = 1 : this.activarMandato = 0;
        if (this.montoMaximo == '' || (this.montoMinimo == '' || (parseInt(this.montoMaximo) >= parseInt(this.montoMinimo)))) {
            sessionStorage.setItem('convenioPagoAgregar', JSON.stringify({
                //idFacturador: -1,
                tipoMoneda: tpoMoneda,
                descripcion: '',
                //this.formGroup.get('descripcion').value,
                montoMinimo: this.montoMinimo,
                montoMaximo: this.montoMaximo,
                tipoCobro: this.formGroup.get('tipoCobro').value,
                activarMandato: this.activarMandato,
                criteriosDuplicidad: this.formGroup.get('criteriosDuplicidad').value,
                idServicio: this.formGroup.get('idServicio').value,
                montoPago: this.formGroup.get('montoPago').value,
                fechaVencimiento: this.formGroup.get('fechaVencimiento').value,
                reintentos: this.formGroup.get('reintentos').value,
                cantidadReintentos: this.formGroup.get('cantidadReintentos').value,
                diaCargo1: this.formGroup.get('diaCargo1').value,
                diaCargo2: this.formGroup.get('diaCargo2').value,
                diaCargo3: this.formGroup.get('diaCargo3').value,
                diaCargo4: this.formGroup.get('diaCargo4').value,
                diaCargo5: this.formGroup.get('diaCargo5').value,
                diaCargo6: this.formGroup.get('diaCargo6').value,
                diaCargo7: this.formGroup.get('diaCargo7').value,
                diaCargo8: this.formGroup.get('diaCargo8').value,
                diaCargo9: this.formGroup.get('diaCargo9').value,
                diaCargo10: this.formGroup.get('diaCargo10').value,
                diaCargo11: this.formGroup.get('diaCargo11').value,
                diaCargo12: this.formGroup.get('diaCargo12').value,
                diaCargo13: this.formGroup.get('diaCargo13').value,
                diaCargo14: this.formGroup.get('diaCargo14').value,
                diaCargo15: this.formGroup.get('diaCargo15').value,
                diaCargo16: this.formGroup.get('diaCargo16').value,
                diaCargo17: this.formGroup.get('diaCargo17').value,
                diaCargo18: this.formGroup.get('diaCargo18').value,
                diaCargo19: this.formGroup.get('diaCargo19').value,
                diaCargo20: this.formGroup.get('diaCargo20').value,
                diaCargo21: this.formGroup.get('diaCargo21').value,
                diaCargo22: this.formGroup.get('diaCargo22').value,
                diaCargo23: this.formGroup.get('diaCargo23').value,
                diaCargo24: this.formGroup.get('diaCargo24').value,
                diaCargo25: this.formGroup.get('diaCargo25').value,
                diaCargo26: this.formGroup.get('diaCargo26').value,
                diaCargo27: this.formGroup.get('diaCargo27').value,
                diaCargo28: this.formGroup.get('diaCargo28').value,
                diaCargo29: this.formGroup.get('diaCargo29').value,
                diaCargo30: this.formGroup.get('diaCargo30').value,
                diaCargo31: this.formGroup.get('diaCargo31').value
            }));
            this.router.navigate(['../conveniosIntercambio'], { relativeTo: this.route });
            console.log(JSON.parse(sessionStorage.getItem('convenioPagoAgregar')));
        }
        else {
            this.showDialog('Info', 'Verifique los montos mínimos y máximos', false);
        }
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ConveniosPagoComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result.toString());
        }));
    };
    /**
     * @return {?}
     */
    ConveniosPagoComponent.prototype.checkValue = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.get('criteriosDuplicidad').value) {
            this.formGroup.controls['idServicio'].enable();
            this.formGroup.controls['montoPago'].enable();
            this.formGroup.controls['fechaVencimiento'].enable();
        }
        else {
            this.formGroup.controls['idServicio'].setValue(false);
            this.formGroup.controls['idServicio'].disable();
            this.formGroup.controls['montoPago'].setValue(false);
            this.formGroup.controls['montoPago'].disable();
            this.formGroup.controls['fechaVencimiento'].setValue(false);
            this.formGroup.controls['fechaVencimiento'].disable();
        }
    };
    /**
     * @return {?}
     */
    ConveniosPagoComponent.prototype.checkValueReintentos = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.get('reintentos').value) {
            this.formGroup.controls['cantidadReintentos'].enable();
        }
        else {
            this.formGroup.controls['cantidadReintentos'].setValue(null);
            this.formGroup.controls['cantidadReintentos'].disable();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ConveniosPagoComponent.prototype.onTipoMonedaSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.formGroup.controls['montoMinimo'].enable();
        this.formGroup.controls['montoMaximo'].enable();
        this.formGroup.get('montoMinimo').setValue('');
        this.formGroup.get('montoMaximo').setValue('');
        this.monedaPago = event.value;
        this.getLengthMontoXMoneda();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ConveniosPagoComponent.prototype.onTipoCobroSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        console.log("cobro select " + event.value + "criterio duplicidad" + this.formGroup.get('criteriosDuplicidad').value);
        if (event.value == 'F') {
            this.formGroup.controls['activaMandato'].setValue(true);
            this.formGroup.controls['activaMandato'].disable();
            this.formGroup.controls['criteriosDuplicidad'].setValue(false);
            this.checkValue();
        }
        else {
            this.formGroup.controls['activaMandato'].setValue(false);
            this.formGroup.controls['activaMandato'].enable();
            this.formGroup.controls['diaCargo1'].setValue(false);
            this.formGroup.controls['diaCargo2'].setValue(false);
            this.formGroup.controls['diaCargo3'].setValue(false);
            this.formGroup.controls['diaCargo4'].setValue(false);
            this.formGroup.controls['diaCargo5'].setValue(false);
            this.formGroup.controls['diaCargo6'].setValue(false);
            this.formGroup.controls['diaCargo7'].setValue(false);
            this.formGroup.controls['diaCargo8'].setValue(false);
            this.formGroup.controls['diaCargo9'].setValue(false);
            this.formGroup.controls['diaCargo10'].setValue(false);
            this.formGroup.controls['diaCargo11'].setValue(false);
            this.formGroup.controls['diaCargo12'].setValue(false);
            this.formGroup.controls['diaCargo13'].setValue(false);
            this.formGroup.controls['diaCargo14'].setValue(false);
            this.formGroup.controls['diaCargo15'].setValue(false);
            this.formGroup.controls['diaCargo16'].setValue(false);
            this.formGroup.controls['diaCargo17'].setValue(false);
            this.formGroup.controls['diaCargo18'].setValue(false);
            this.formGroup.controls['diaCargo19'].setValue(false);
            this.formGroup.controls['diaCargo20'].setValue(false);
            this.formGroup.controls['diaCargo21'].setValue(false);
            this.formGroup.controls['diaCargo22'].setValue(false);
            this.formGroup.controls['diaCargo23'].setValue(false);
            this.formGroup.controls['diaCargo24'].setValue(false);
            this.formGroup.controls['diaCargo25'].setValue(false);
            this.formGroup.controls['diaCargo26'].setValue(false);
            this.formGroup.controls['diaCargo27'].setValue(false);
            this.formGroup.controls['diaCargo28'].setValue(false);
            this.formGroup.controls['diaCargo29'].setValue(false);
            this.formGroup.controls['diaCargo30'].setValue(false);
            this.formGroup.controls['diaCargo31'].setValue(false);
        }
    };
    /**
     * @return {?}
     */
    ConveniosPagoComponent.prototype.getLengthMontoXMoneda = /**
     * @return {?}
     */
    function () {
        this.lengthMontoXMoneda = this.monedaPago == 'USD' ? 13 : 10;
        this.formGroup.get('montoMinimo').setValidators(Validators.compose([Validators.maxLength(this.lengthMontoXMoneda), CustomValidators.amountValidator]));
        this.formGroup.get('montoMaximo').setValidators(Validators.compose([Validators.maxLength(this.lengthMontoXMoneda), CustomValidators.amountValidator]));
    };
    ConveniosPagoComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-convenios-pago',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a [routerLink]=\"['../convenios']\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <h3>Agregar convenio <span style=\"color:#CC0000;font-size: 18px;\" *ngIf=\"requiredAuth\">(* Requiere autorizaci&oacute;n)</span></h3>\r\n          <div class=\"menu-pills\">\r\n            <a>\r\n              <div class=\"item first\">Datos generales</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item active\">Reglas de pago</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item\">Intercambio</div>\r\n            </a>\r\n            <a>\r\n              <div class=\"item last\">Gr\u00E1fica</div>\r\n            </a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <form [formGroup]=\"formGroup\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n        <div class=\"form-section\">\r\n          <div class=\"form-row\">\r\n            <!--div class=\"col-md-12\">\r\n              <mat-form-field>\r\n                <input matInput #input maxlength=\"100\" placeholder=\"Descripci\u00F3n\" formControlName=\"descripcion\">\r\n                <mat-hint align=\"end\">{{input.value?.length || 0}}/100</mat-hint>\r\n                <mat-error *ngIf=\"formGroup.get('descripcion').invalid\">Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div-->\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Tipo de moneda\" formControlName=\"tipoMoneda\" (selectionChange)=\"onTipoMonedaSelect($event)\">\r\n                  <mat-option *ngFor=\"let moneda of tipoMonedaSelect\" [value]=\"moneda.codigo\">{{moneda.divisa}}</mat-option>\r\n                </mat-select>\r\n                <mat-error *ngIf=\"formGroup.get('tipoMoneda').invalid\">Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n\r\n            <div class=\"col-sm-4\">\r\n              <mat-form-field>\r\n                <span matPrefix>{{monedaPago}} $&nbsp;</span>\r\n                <input matInput digitOnly placeholder=\"Monto m&iacute;nimo (Opcional)\" formControlName=\"montoMinimo\" [maxlength]=\"lengthMontoXMoneda\" [value]=\"numberMonedaPipe.transform(formGroup.get('montoMinimo').value, monedaPago)\">\r\n                <mat-error *ngIf=\"formGroup.get('montoMinimo').hasError('amountError')\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4\">\r\n              <mat-form-field>\r\n                <span matPrefix>{{monedaPago}} $&nbsp;</span>\r\n                <input matInput digitOnly placeholder=\"Monto m&aacute;ximo (Opcional)\" formControlName=\"montoMaximo\" [maxlength]=\"lengthMontoXMoneda\" [value]=\"numberMonedaPipe.transform(formGroup.get('montoMaximo').value, monedaPago)\">\r\n                <mat-error *ngIf=\"formGroup.get('montoMaximo').hasError('amountError')\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Tipo de cobro\" formControlName=\"tipoCobro\" (selectionChange)=\"onTipoCobroSelect($event)\">\r\n                  <mat-option *ngFor=\"let pos of tipoCobroSelect\" [value]=\"pos.value\">{{pos.option}}</mat-option>\r\n                </mat-select>\r\n                <mat-error *ngIf=\"formGroup.get('tipoCobro').invalid\">Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-8\" style=\"padding: 20px 5px;\">\r\n              <div class=\"form-check form-check-inline\">\r\n                <mat-checkbox class=\"example-margin\" formControlName=\"activaMandato\">Activaci&oacute;n autom&aacute;tica de mandato.</mat-checkbox>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-section\" *ngIf=\"formGroup.get('tipoCobro').value == 'F'\">\r\n          <h5>D\u00EDas de cargo</h5>\r\n          <small class=\"form-text text-muted mb-1\">Seleccione los d&iacute;as del mes v&aacute;lidos para realizar los cobros.</small>\r\n          <div class=\"dias-cargo\">\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo1\" formControlName=\"diaCargo1\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo1\"><span class=\"etiqueta\">1</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo2\" formControlName=\"diaCargo2\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo2\"><span class=\"etiqueta\">2</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo3\" formControlName=\"diaCargo3\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo3\"><span class=\"etiqueta\">3</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo4\" formControlName=\"diaCargo4\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo4\"><span class=\"etiqueta\">4</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo5\" formControlName=\"diaCargo5\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo5\"><span class=\"etiqueta\">5</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo6\" formControlName=\"diaCargo6\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo6\"><span class=\"etiqueta\">6</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo7\" formControlName=\"diaCargo7\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo7\"><span class=\"etiqueta\">7</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo8\" formControlName=\"diaCargo8\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo8\"><span class=\"etiqueta\">8</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo9\" formControlName=\"diaCargo9\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo9\"><span class=\"etiqueta\">9</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo10\" formControlName=\"diaCargo10\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo10\"><span class=\"etiqueta\">10</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo11\" formControlName=\"diaCargo11\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo11\"><span class=\"etiqueta\">11</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo12\" formControlName=\"diaCargo12\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo12\"><span class=\"etiqueta\">12</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo13\" formControlName=\"diaCargo13\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo13\"><span class=\"etiqueta\">13</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo14\" formControlName=\"diaCargo14\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo14\"><span class=\"etiqueta\">14</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo15\" formControlName=\"diaCargo15\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo15\"><span class=\"etiqueta\">15</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo16\" formControlName=\"diaCargo16\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo16\"><span class=\"etiqueta\">16</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo17\" formControlName=\"diaCargo17\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo17\"><span class=\"etiqueta\">17</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo18\" formControlName=\"diaCargo18\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo18\"><span class=\"etiqueta\">18</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo19\" formControlName=\"diaCargo19\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo19\"><span class=\"etiqueta\">19</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo20\" formControlName=\"diaCargo20\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo20\"><span class=\"etiqueta\">20</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo21\" formControlName=\"diaCargo21\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo21\"><span class=\"etiqueta\">21</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo22\" formControlName=\"diaCargo22\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo22\"><span class=\"etiqueta\">22</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo23\" formControlName=\"diaCargo23\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo23\"><span class=\"etiqueta\">23</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo24\" formControlName=\"diaCargo24\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo24\"><span class=\"etiqueta\">24</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo25\" formControlName=\"diaCargo25\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo25\"><span class=\"etiqueta\">25</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo26\" formControlName=\"diaCargo26\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo26\"><span class=\"etiqueta\">26</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo27\" formControlName=\"diaCargo27\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo27\"><span class=\"etiqueta\">27</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo28\" formControlName=\"diaCargo28\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo28\"><span class=\"etiqueta\">28</span></label>\r\n            </div>\r\n\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo29\" formControlName=\"diaCargo29\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo29\"><span class=\"etiqueta\">29</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo30\" formControlName=\"diaCargo30\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo30\"><span class=\"etiqueta\">30</span></label>\r\n            </div>\r\n            <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n              <input type=\"checkbox\" class=\"custom-control-input\" id=\"diaCargo31\" formControlName=\"diaCargo31\">\r\n              <label class=\"custom-control-label\" for=\"diaCargo31\"><span class=\"etiqueta\">31</span></label>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-section\">\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-5\">\r\n              <!-- offset-md-1 -->\r\n              <h5>Reintentos</h5>\r\n              <div class=\"switch-box float-right\">\r\n                <mat-slide-toggle (change)=\"checkValueReintentos()\" formControlName=\"reintentos\"></mat-slide-toggle>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-9\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Cantidad de reintentos\" formControlName=\"cantidadReintentos\">\r\n                      <mat-option *ngFor=\"let reintentos of cantidadReintentosSelect\" [value]=\"reintentos.value\">\r\n                        {{reintentos.option}}</mat-option>\r\n                    </mat-select>\r\n                    <mat-error *ngIf=\"formGroup.get('cantidadReintentos').invalid\">Este campo es requerido.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"col-md-5 offset-md-1\" *ngIf=\"formGroup.get('tipoCobro').value == 'V'\">\r\n              <h5>Criterios de duplicidad</h5>\r\n              <div class=\"switch-box float-right\">\r\n                <mat-slide-toggle (change)=\"checkValue()\" formControlName=\"criteriosDuplicidad\"></mat-slide-toggle>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class=\"col\">\r\n                  <div class=\"form-check form-check-inline\">\r\n                    <mat-checkbox class=\"example-margin\" formControlName=\"idServicio\">ID Servicio</mat-checkbox>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class=\"col\">\r\n                  <div class=\"form-check form-check-inline\">\r\n                    <mat-checkbox class=\"example-margin\" formControlName=\"montoPago\">Monto de pago</mat-checkbox>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class=\"col\">\r\n                  <div class=\"form-check form-check-inline\">\r\n                    <mat-checkbox class=\"example-margin\" formControlName=\"fechaVencimiento\">Fecha de vencimiento\r\n                    </mat-checkbox>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col align-left\">\r\n            <button class=\"btn text\" type=\"submit\" [routerLink]=\"['../conveniosAgregar']\"><i class=\"str-icon-flecha-izquierda\"></i>ANTERIOR</button>\r\n          </div>\r\n          <div class=\"col align-right\">\r\n            <button *ngIf=\"formGroup.valid && (formGroup.get('criteriosDuplicidad').value == true && (formGroup.get('idServicio').value == false && formGroup.get('montoPago').value == false && formGroup.get('fechaVencimiento').value == false))\" disabled class=\"btn main\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i></button>\r\n            <button *ngIf=\"formGroup.valid && (formGroup.get('criteriosDuplicidad').value == true && (formGroup.get('idServicio').value == true || formGroup.get('montoPago').value == true || formGroup.get('fechaVencimiento').value == true))\" class=\"btn main\" type=\"submit\" (click)=\"onSubmit()\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i></button><!-- [routerLink]=\"['../conveniosIntercambio']\" -->\r\n            <button *ngIf=\"formGroup.valid && formGroup.get('criteriosDuplicidad').value == false && formGroup.get('tipoCobro').value == 'V'\" class=\"btn main\" type=\"submit\" (click)=\"onSubmit()\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i></button><!-- [routerLink]=\"['../conveniosIntercambio']\" -->\r\n            <button *ngIf=\"formGroup.invalid\" class=\"btn main\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i></button>\r\n            <button *ngIf=\"formGroup.valid && (formGroup.get('tipoCobro').value == 'F' && (formGroup.get('diaCargo1').value != true && formGroup.get('diaCargo2').value != true && formGroup.get('diaCargo3').value != true && formGroup.get('diaCargo4').value != true && formGroup.get('diaCargo5').value != true && formGroup.get('diaCargo6').value != true && formGroup.get('diaCargo7').value != true && formGroup.get('diaCargo8').value != true && formGroup.get('diaCargo9').value != true && formGroup.get('diaCargo10').value != true && formGroup.get('diaCargo11').value != true && formGroup.get('diaCargo12').value != true && formGroup.get('diaCargo13').value != true\r\n            && formGroup.get('diaCargo14').value != true && formGroup.get('diaCargo15').value != true && formGroup.get('diaCargo16').value != true && formGroup.get('diaCargo17').value != true && formGroup.get('diaCargo18').value != true && formGroup.get('diaCargo19').value != true && formGroup.get('diaCargo20').value != true && formGroup.get('diaCargo21').value != true && formGroup.get('diaCargo22').value != true && formGroup.get('diaCargo23').value != true && formGroup.get('diaCargo24').value != true\r\n            && formGroup.get('diaCargo25').value != true && formGroup.get('diaCargo26').value != true && formGroup.get('diaCargo27').value != true && formGroup.get('diaCargo28').value != true && formGroup.get('diaCargo29').value != true && formGroup.get('diaCargo30').value != true && formGroup.get('diaCargo31').value != true))\" disabled class=\"btn main\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i>\r\n            </button>\r\n            <button *ngIf=\"formGroup.valid && (formGroup.get('tipoCobro').value == 'F' && (formGroup.get('diaCargo1').value == true || formGroup.get('diaCargo2').value == true || formGroup.get('diaCargo3').value == true || formGroup.get('diaCargo4').value == true || formGroup.get('diaCargo5').value == true || formGroup.get('diaCargo6').value == true || formGroup.get('diaCargo7').value == true || formGroup.get('diaCargo8').value == true || formGroup.get('diaCargo9').value == true || formGroup.get('diaCargo10').value == true || formGroup.get('diaCargo11').value == true || formGroup.get('diaCargo12').value == true || formGroup.get('diaCargo13').value == true || \r\n              formGroup.get('diaCargo14').value == true || formGroup.get('diaCargo15').value == true || formGroup.get('diaCargo16').value == true || formGroup.get('diaCargo17').value == true || formGroup.get('diaCargo18').value == true || formGroup.get('diaCargo19').value == true || formGroup.get('diaCargo20').value == true || formGroup.get('diaCargo21').value == true || formGroup.get('diaCargo22').value == true || formGroup.get('diaCargo23').value == true || formGroup.get('diaCargo24').value == true ||\r\n              formGroup.get('diaCargo25').value == true || formGroup.get('diaCargo26').value == true || formGroup.get('diaCargo27').value == true || formGroup.get('diaCargo28').value == true || formGroup.get('diaCargo29').value == true || formGroup.get('diaCargo30').value == true || formGroup.get('diaCargo31').value == true))\" class=\"btn main\" type=\"submit\" (click)=\"onSubmit()\">SIGUIENTE<i class=\"str-icon-flecha-derecha\"></i><!-- [routerLink]=\"['../conveniosIntercambio']\" -->\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n\r\n  </div>\r\n</section>",
                    styles: [".example-radio-button{margin:5px}"]
                }] }
    ];
    /** @nocollapse */
    ConveniosPagoComponent.ctorParameters = function () { return [
        { type: MatDialog },
        { type: Router },
        { type: ActivatedRoute }
    ]; };
    return ConveniosPagoComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConveniosEstadosResult = /** @class */ (function () {
    function ConveniosEstadosResult() {
        this.idEstado = '';
        this.descripcion = '';
        this.codigo = '';
    }
    return ConveniosEstadosResult;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RubroResult = /** @class */ (function () {
    function RubroResult() {
        this.codigo = '';
        this.descripcion = '';
    }
    return RubroResult;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ServicesBaseService = /** @class */ (function () {
    function ServicesBaseService() {
    }
    /**
     * @param {?} menu
     * @return {?}
     */
    ServicesBaseService.prototype.validaAccesoMenu = /**
     * @param {?} menu
     * @return {?}
     */
    function (menu) {
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.lstModulos = this.userPerfil.perfil.modulos;
        for (var index = 0; index < this.lstModulos.length; index++) {
            /** @type {?} */
            var modulo = this.lstModulos[index];
            if (this.listaMenus(modulo, menu)) {
                return true;
            }
        }
        return false;
    };
    /**
     * @param {?} element
     * @param {?} url
     * @return {?}
     */
    ServicesBaseService.prototype.listaMenus = /**
     * @param {?} element
     * @param {?} url
     * @return {?}
     */
    function (element, url) {
        if (url == element.url) {
            return true;
        }
        else {
            /** @type {?} */
            var menus = element.menus;
            if (menus != null && menus.length > 0) {
                for (var index = 0; index < menus.length; index++) {
                    if (this.listaMenus(menus[index], url)) {
                        return true;
                    }
                }
            }
            else {
                return false;
            }
        }
    };
    ServicesBaseService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ServicesBaseService.ctorParameters = function () { return []; };
    return ServicesBaseService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConveniosComponent = /** @class */ (function () {
    function ConveniosComponent(phttp, peticionAgregar, phttpr, phttpd, loader, dialog, serviceBaseService, environment) {
        this.phttp = phttp;
        this.peticionAgregar = peticionAgregar;
        this.phttpr = phttpr;
        this.phttpd = phttpd;
        this.loader = loader;
        this.dialog = dialog;
        this.serviceBaseService = serviceBaseService;
        this.environment = environment;
        this.rutPipe = new RutPipe();
        this.formGroup = new FormGroup({
            codigoConvenio: new FormControl(),
            identificadorEmpresa: new FormControl('', CustomValidators.rutValidatorUY),
            nombreEmpresa: new FormControl(),
            estado: new FormControl('-1'),
            rubro: new FormControl('-1'),
        });
        /* Vistas variables */
        this.vistaCantidad = 0;
        this.vistaEstado = 'Todos';
        this.vistaRubro = 'Todos';
        this.hashCaminoMiga = [];
        this.peticionReporte = new ConveniosPeticion();
        this.resultadoRubros = [];
        this.mensajeError = -1;
        this.consulta = -1;
        this.isCollapsed = false;
    }
    /**
     * @return {?}
     */
    ConveniosComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.peticionAgregar.postMonedasListar().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            sessionStorage.setItem('monedas', JSON.stringify(data.monedas));
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en postMonedasServices', err);
        }));
        if (sessionStorage.getItem('componenteHijo') != 'lib-convenios-editar-agregar') {
            sessionStorage.removeItem('indice');
        }
        this.viewAgregar = this.serviceBaseService.validaAccesoMenu('conveniosAgregar');
        this.viewEditar = this.serviceBaseService.validaAccesoMenu('conveniosEditarAgregar');
        this.displayedColumns = ['codigoConvenio', 'descripcion', 'identificadorEmpresa', 'nombreEmpresa',
            'rubro', 'inicioVigencia', 'terminoVigencia', 'fechaCreacion', 'modificacion', 'estado'];
        if (this.viewEditar) {
            this.displayedColumns.push('editar');
        }
        this.consulta = -1;
        sessionStorage.removeItem('dataConvenioE');
        sessionStorage.removeItem('convenioAgregar');
        sessionStorage.removeItem('convenioPagoAgregar');
        sessionStorage.removeItem('aReglasPagos');
        sessionStorage.removeItem('pacParametro');
        sessionStorage.removeItem('convenioIntercambioAgregar');
        sessionStorage.removeItem('convenioGraficaAgregar');
        if (sessionStorage.getItem('componenteHijo') == 'lib-convenios-editar-agregar') {
            this.consulta = 0;
            /** @type {?} */
            var llamadaPadre = JSON.parse(sessionStorage.getItem('llamadaPadre'));
            // Llena los filtros
            this.formGroup.controls['codigoConvenio'].setValue((llamadaPadre.codigoConvenio != '-1' ? llamadaPadre.codigoConvenio : ''));
            this.formGroup.controls['identificadorEmpresa'].setValue((llamadaPadre.identificadorEmpresa != '-1' ? llamadaPadre.identificadorEmpresa : ''));
            this.formGroup.controls['nombreEmpresa'].setValue((llamadaPadre.nombreEmpresa != '-1' ? llamadaPadre.nombreEmpresa : ''));
            //      this.formGroup.controls['estado'].setValue(llamadaPadre.estado);
            //      this.formGroup.controls['rubro'].setValue(llamadaPadre.rubro);
            // Llena camino de migas
            /** @type {?} */
            var migasPadre = JSON.parse(sessionStorage.getItem('migasPadre'));
            this.vistaEstado = migasPadre.estado;
            this.vistaRubro = migasPadre.rubro;
            this.hashCaminoMiga[0] = { title: 'Código', text: migasPadre.codigoConvenio };
            this.hashCaminoMiga[1] = { title: 'Rut', text: migasPadre.identificadorEmpresa };
            this.hashCaminoMiga[2] = { title: 'Nombre empresa', text: migasPadre.nombreEmpresa };
            this.hashCaminoMiga[3] = { title: 'Estado', text: migasPadre.estado };
            this.hashCaminoMiga[4] = { title: 'Rubro', text: migasPadre.rubro };
            // Llama al servicio
            this.peticionReporte.codCliente = llamadaPadre.codCliente;
            this.peticionReporte.codigoConvenio = llamadaPadre.codigoConvenio;
            this.peticionReporte.identificadorEmpresa = llamadaPadre.identificadorEmpresa;
            this.peticionReporte.nombreEmpresa = llamadaPadre.nombreEmpresa;
            this.peticionReporte.estado = llamadaPadre.estado;
            this.peticionReporte.rubro = llamadaPadre.rubro;
            this.postConvenioEstadosServices(llamadaPadre.estado);
            this.postSentRubrosServices(llamadaPadre.rubro);
            this.postConveniosListServices(this.peticionReporte);
        }
        else {
            this.postConvenioEstadosServices('-1');
            this.postSentRubrosServices('-1');
            this.setInitialBreadcrumbs();
        }
    };
    /**
     * @return {?}
     */
    ConveniosComponent.prototype.setInitialBreadcrumbs = /**
     * @return {?}
     */
    function () {
        this.hashCaminoMiga[0] = { title: 'Código', text: '' };
        this.hashCaminoMiga[1] = { title: 'Rut', text: '' };
        this.hashCaminoMiga[2] = { title: 'Nombre empresa', text: '' };
        this.hashCaminoMiga[3] = { title: 'Estado', text: 'Todos' };
        this.hashCaminoMiga[4] = { title: 'Rubro', text: 'Todos' };
    };
    /**
     * @param {?} codEstadoSelected
     * @return {?}
     */
    ConveniosComponent.prototype.postConvenioEstadosServices = /**
     * @param {?} codEstadoSelected
     * @return {?}
     */
    function (codEstadoSelected) {
        var _this = this;
        this.phttp.postConvenioEstado().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEstados = data.resultado;
                /** @type {?} */
                var estadoTodos = new ConveniosEstadosResult();
                estadoTodos.idEstado = '-1';
                estadoTodos.codigo = '-1';
                estadoTodos.descripcion = 'Todos';
                _this.resultadoEstados.splice(0, 0, estadoTodos);
                _this.formGroup.get('estado').setValue(codEstadoSelected);
            }
            else {
                console.log('Error en postConvenioEstadosServices', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.log('Error en postConvenioEstadosServices', err);
        }));
    };
    /**
     * @param {?} codRubroSelected
     * @return {?}
     */
    ConveniosComponent.prototype.postSentRubrosServices = /**
     * @param {?} codRubroSelected
     * @return {?}
     */
    function (codRubroSelected) {
        var _this = this;
        /** @type {?} */
        var params = new RubroRequest();
        params.codEstadoConvenio = '-1';
        this.phttpr.postRubrosReport(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoRubros = data.resultado;
                /** @type {?} */
                var rubroTodos = new RubroResult();
                rubroTodos.codigo = '-1';
                rubroTodos.descripcion = 'Todos';
                _this.resultadoRubros.splice(0, 0, rubroTodos);
                _this.formGroup.get('rubro').setValue(codRubroSelected);
            }
            else {
                console.log('Error en postSentRubrosServices', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en postSentRubrosServices', err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ConveniosComponent.prototype.onEstadoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEstado = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ConveniosComponent.prototype.onRubroSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaRubro = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    ConveniosComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.consulta = 0;
        this.peticionReporte.codCliente = this.environment.codCliente;
        if (this.formGroup.get('codigoConvenio').value == null || this.formGroup.get('codigoConvenio').value == '') {
            this.peticionReporte.codigoConvenio = '-1';
            this.hashCaminoMiga[0] = { title: 'Código', text: '' };
        }
        else {
            this.peticionReporte.codigoConvenio = this.formGroup.get('codigoConvenio').value;
            this.hashCaminoMiga[0] = { title: 'Código', text: this.formGroup.get('codigoConvenio').value };
        }
        if (this.formGroup.get('identificadorEmpresa').value == null || this.formGroup.get('identificadorEmpresa').value == '') {
            this.peticionReporte.identificadorEmpresa = '-1';
            this.hashCaminoMiga[1] = { title: 'Rut', text: '' };
        }
        else {
            this.peticionReporte.identificadorEmpresa = this.formGroup.get('identificadorEmpresa').value;
            this.hashCaminoMiga[1] = { title: 'Rut', text: this.rutPipe.transform(this.formGroup.get('identificadorEmpresa').value) };
        }
        if (this.formGroup.get('nombreEmpresa').value == null || this.formGroup.get('nombreEmpresa').value == '') {
            this.peticionReporte.nombreEmpresa = '-1';
            this.hashCaminoMiga[2] = { title: 'Nombre empresa', text: '' };
        }
        else {
            this.peticionReporte.nombreEmpresa = this.formGroup.get('nombreEmpresa').value;
            this.hashCaminoMiga[2] = { title: 'Nombre empresa', text: this.formGroup.get('nombreEmpresa').value };
        }
        if (this.formGroup.get('estado').value == null) {
            this.peticionReporte.estado = '-1';
            this.hashCaminoMiga[3] = { title: 'Estado', text: 'Todos' };
        }
        else {
            this.peticionReporte.estado = this.formGroup.get('estado').value;
            this.hashCaminoMiga[3] = { title: 'Estado', text: this.vistaEstado };
        }
        if (this.formGroup.get('rubro').value == null) {
            this.peticionReporte.rubro = '-1';
            this.hashCaminoMiga[4] = { title: 'Rubro', text: 'Todos' };
        }
        else {
            this.peticionReporte.rubro = this.formGroup.get('rubro').value;
            this.hashCaminoMiga[4] = { title: 'Rubro', text: this.vistaRubro };
        }
        sessionStorage.setItem('llamadaPadre', JSON.stringify({
            codCliente: this.peticionReporte.codCliente,
            codigoConvenio: this.peticionReporte.codigoConvenio,
            identificadorEmpresa: this.peticionReporte.identificadorEmpresa,
            nombreEmpresa: this.peticionReporte.nombreEmpresa,
            estado: this.peticionReporte.estado,
            rubro: this.peticionReporte.rubro
        }));
        sessionStorage.setItem('migasPadre', JSON.stringify({
            codigoConvenio: this.hashCaminoMiga[0].text,
            identificadorEmpresa: this.hashCaminoMiga[1].text,
            nombreEmpresa: this.hashCaminoMiga[2].text,
            estado: this.hashCaminoMiga[3].text,
            rubro: this.hashCaminoMiga[4].text
        }));
        if (tipo == 'excel' || tipo == 'pdf') {
            this.peticionReporte.filtros = this.hashCaminoMiga;
            this.postDownloadReportFile(this.peticionReporte, tipo);
        }
        else {
            this.postConveniosListServices(this.peticionReporte);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ConveniosComponent.prototype.onPaginateChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var indice = this.paginator.pageIndex;
        sessionStorage.setItem('indice', indice);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    ConveniosComponent.prototype.postConveniosListServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.show = true;
        this.phttp.postConveniosList(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoReporte = [];
                _this.resultadoReporte.push(data);
                //sessionStorage.setItem('dataConvenioE' , JSON.stringify( data.resultado[0] ) );
                _this.vistaCantidad = data.resultado.length;
                if (_this.paginator != undefined && sessionStorage.getItem('componenteHijo') == 'lib-convenios-editar-agregar') {
                    _this.paginator.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indice')))));
                }
                else if (_this.paginator != undefined) {
                    _this.paginator.pageIndex = 0;
                    sessionStorage.removeItem("indice");
                }
                sessionStorage.removeItem('componenteHijo');
                _this.dataSource = new MatTableDataSource$1(data.resultado);
                _this.dataSource.paginator = _this.paginator;
                _this.dataSource.sort = _this.sort;
                if (_this.vistaCantidad == 0) {
                    _this.show = false;
                    _this.isCollapsed = false;
                }
                else {
                    _this.isCollapsed = true;
                }
                _this.mensajeError = 0;
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.mensajeError = 1;
                _this.loader.hide();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            _this.mensajeError = 1;
            _this.loader.hide();
        }));
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    ConveniosComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiConvenioMT/listarConvenio/' + tipo;
        this.phttpd.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'listadoConvenios' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'listadoConvenios' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @return {?}
     */
    ConveniosComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.peticionReporte.codigoConvenio = '-1';
        this.peticionReporte.identificadorEmpresa = '-1';
        this.peticionReporte.nombreEmpresa = '-1';
        this.peticionReporte.estado = '-1';
        this.peticionReporte.rubro = '-1';
        this.formGroup.get('codigoConvenio').setValue('');
        this.formGroup.get('identificadorEmpresa').setValue('');
        this.formGroup.get('nombreEmpresa').setValue('');
        this.formGroup.get('estado').setValue('-1');
        this.formGroup.get('rubro').setValue('-1');
        this.setInitialBreadcrumbs();
        this.vistaEstado = 'Todos';
        this.vistaRubro = 'Todos';
        this.vistaCantidad = 0;
        this.dataSource = new MatTableDataSource$1([]);
        this.isCollapsed = false;
        this.show = false;
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ConveniosComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @return {?}
     */
    ConveniosComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.onSubmit('');
        }
    };
    /**
     * @return {?}
     */
    ConveniosComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('componenteHijo');
    };
    ConveniosComponent.decorators = [
        { type: Component, args: [{
                    selector: 'convenios',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"seccion-titulo-boton\">\r\n      <div class=\"row\">\r\n        <div class=\"col\" *ngIf=\"viewAgregar && mensajeError != 1\">\r\n          <a class=\"boton-seccion btn-small main\" [routerLink]=\"['../conveniosAgregar']\"><i class=\"str-icon-mas\"></i>\r\n            Agregar convenio</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"modulo-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n      </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"formGroup\" (ngSubmit)=\"validarForm()\" autocomplete=\"off\">\r\n              <div class=\"form-row\">\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <input noCaracEsp matInput maxlength=\"10\" placeholder=\"C&oacute;digo convenio\" formControlName=\"codigoConvenio\">\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <input formatRut soloRutUY matInput maxlength=\"12\" placeholder=\"Rut empresa\" formControlName=\"identificadorEmpresa\">\r\n                    <mat-error *ngIf=\"formGroup.get('identificadorEmpresa').hasError('rutUYError')\">Rut <strong>incorrecto</strong>.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <input noCaracEsp matInput maxlength=\"20\" placeholder=\"Nombre empresa\" formControlName=\"nombreEmpresa\">\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-row\">\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estado\" (selectionChange)=\"onEstadoSelect($event)\">\r\n                      <mat-option *ngFor=\"let estado of resultadoEstados\" [value]=\"estado.idEstado\">{{estado.descripcion}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Rubro\" formControlName=\"rubro\" (selectionChange)=\"onRubroSelect($event)\">\r\n                      <mat-option *ngFor=\"let rubro of resultadoRubros\" [value]=\"rubro.codigo\">{{rubro.descripcion}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"actions\">\r\n                <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\">Filtrar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"resultados-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-10\">\r\n          <div class=\"tags row\">\r\n            <div *ngFor=\"let entry of hashCaminoMiga\" class=\"item\">{{entry.title}}: {{entry.text}}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n          <div class=\"numero-resultados\">\r\n            <strong>{{ (vistaCantidad == 1) ? ( vistaCantidad + \" Resultado\") : vistaCantidad + \" Resultados\" }}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-container table-responsive-md\">\r\n        <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n          <ng-container matColumnDef=\"codigoConvenio\">\r\n            <th mat-header-cell *matHeaderCellDef>C&oacute;digo</th> <!-- mat-sort-header -->\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.codigoConvenio}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"descripcion\">\r\n            <th mat-header-cell *matHeaderCellDef>Descripci&oacute;n</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.descripcion}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"identificadorEmpresa\">\r\n            <th mat-header-cell *matHeaderCellDef>Rut empresa</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{rutPipe.transform(resultado.identificadorEmpresa)}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"nombreEmpresa\">\r\n            <th mat-header-cell *matHeaderCellDef>Nombre empresa</th>\r\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\"> {{resultado.nombreEmpresa}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"rubro\">\r\n            <th mat-header-cell *matHeaderCellDef>Rubro</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.rubro}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"inicioVigencia\">\r\n            <th mat-header-cell *matHeaderCellDef>Inicio vigencia</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.inicioVigencia == null; else inicioVigencia\">-</span>\r\n              <ng-template #inicioVigencia>{{resultado.inicioVigencia | date:'dd/MM/yyyy'}}</ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"terminoVigencia\">\r\n            <th mat-header-cell *matHeaderCellDef>T&eacute;rmino vigencia</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.terminoVigencia == null; else terminoVigencia\">-</span>\r\n              <ng-template #terminoVigencia>{{resultado.terminoVigencia | date:'dd/MM/yyyy'}}</ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fechaCreacion\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha creaci&oacute;n</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.fechaCreacion == null; else fechaCreacion\">-</span>\r\n              <ng-template #fechaCreacion>{{resultado.fechaCreacion | date:'dd/MM/yyyy'}}</ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"modificacion\">\r\n            <th mat-header-cell *matHeaderCellDef>\u00DAltima modificaci&oacute;n</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.modificacion == null; else modificacion\">-</span>\r\n              <ng-template #modificacion>{{resultado.modificacion | date:'dd/MM/yyyy'}}</ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"estado\">\r\n            <th mat-header-cell *matHeaderCellDef>Estado</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.codEstado == 'TRM'\" class=\"databar tramite\">{{resultado.estado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'HBL'\" class=\"databar habilitado\">{{resultado.estado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'ELM'\" class=\"databar eliminado\">{{resultado.estado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'PND'\" class=\"databar pendiente\">{{resultado.estado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'RCH'\" class=\"databar eliminado\">{{resultado.estado}}</span>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"viewEditar\" matColumnDef=\"editar\">\r\n            <th mat-header-cell *matHeaderCellDef>Editar</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a matTooltip=\"Editar convenio\" matTooltipPosition=\"above\" Style=\"cursor: pointer;\" [routerLink]=\"['../conveniosEditarAgregar']\" [queryParams]=\"{'idc':resultado.idConvenio,'idf':resultado.idFacturador}\"><i class=\"icon str-icon-lapiz\"></i></a>\r\n            </td>\r\n          </ng-container>\r\n\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n        </table>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" (page)=\"onPaginateChange($event)\"  showFirstLastButtons></mat-paginator>\r\n      </div>\r\n    </section>\r\n\r\n    <div class=\"box-actions\" *ngIf=\"vistaCantidad > 0\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6 item\">\r\n          <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n        </div>\r\n        <div class=\"col-md-6 item-right\">\r\n          <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"modulo-cuentas\" *ngIf=\"mensajeError == 0 && vistaCantidad == 0\">\r\n      <span>\r\n        No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.\r\n      </span>\r\n    </div>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"consulta == -1\">\r\n      <span>\r\n        Establezca sus criterios de b&uacute;squeda.\r\n      </span>\r\n    </div>\r\n\r\n  </div>\r\n</section>\r\n\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div *ngIf=\"mensajeError == 1\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" id=\"modal-basic-title\" style=\"color:#ec0000;font-weight: bold\">Error</h3>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <p>Servicio temporalmente no disponible.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [ConveniosService, EmpresasService, DescargaExcelPdfFileService]
                }] }
    ];
    /** @nocollapse */
    ConveniosComponent.ctorParameters = function () { return [
        { type: ConveniosService },
        { type: ConveniosAgregarService },
        { type: EmpresasService },
        { type: DescargaExcelPdfFileService },
        { type: LoaderBaseService },
        { type: MatDialog },
        { type: ServicesBaseService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    ConveniosComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator$1,] }],
        sort: [{ type: ViewChild, args: [MatSort,] }]
    };
    return ConveniosComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DialogToUserEmpComponent = /** @class */ (function () {
    function DialogToUserEmpComponent(dialogRef, data, empresasService, environment) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.empresasService = empresasService;
        this.environment = environment;
        this.resultadoRubros = [];
        this.peticionEmpresa = new EmpresasPeticion();
    }
    /**
     * @return {?}
     */
    DialogToUserEmpComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formGroup = new FormGroup({
            rubro: new FormControl('', Validators.required),
            empresa: new FormControl('', Validators.required)
        });
        this.formGroup.controls['empresa'].disable();
        this.postSentRubrosServices();
    };
    /**
     * @return {?}
     */
    DialogToUserEmpComponent.prototype.postSentRubrosServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var param = new RubroRequest();
        param.codEstadoConvenio = 'HBL';
        this.empresasService.postRubrosReport(param).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoRubros = data.resultado;
            }
            else {
                console.error('Error postSentRubrosServices: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postSentRubrosServices: ', err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    DialogToUserEmpComponent.prototype.onRubroSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event != null) {
            this.peticionEmpresa.codRubro = event.value;
            this.peticionEmpresa.codCliente = this.environment.codCliente;
            this.peticionEmpresa.codEstadoConvenio = 'HBL';
            this.formGroup.controls['empresa'].reset();
            //this.postSentEmpresaServices(this.peticionEmpresa);
            this.postSentSelectEmpresaServices(this.peticionEmpresa);
            this.formGroup.controls['empresa'].enable();
        }
    };
    /**
     * @param {?} body
     * @return {?}
     */
    DialogToUserEmpComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.empresasService.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.error('Error postListarEmpresas: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postListarEmpresas: ', err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    DialogToUserEmpComponent.prototype.postSentSelectEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.empresasService.postListarSelectEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.error('Error postListarEmpresas: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error("Error postListarSelectEmpresas: ", err);
        }));
    };
    /**
     * @return {?}
     */
    DialogToUserEmpComponent.prototype.onNoClick = /**
     * @return {?}
     */
    function () {
        this.dialogRef.close();
    };
    DialogToUserEmpComponent.decorators = [
        { type: Component, args: [{
                    selector: 'dialog-toUserEmp',
                    template: "<div class=\"custom-modals\">\r\n  <div class=\"modal-body\">\r\n      \r\n    <button class=\"close\" aria-label=\"Close\" *ngIf=\"data.showBtnCancel\" [mat-dialog-close]=\"false\">\r\n     <!-- <span aria-hidden=\"true\"><i class=\"str-icon-cerrar\"></i></span> -->\r\n    </button>\r\n    \r\n    <h3>{{data.title}}</h3>\r\n    <h4 [innerHTML]=\"data.content\"></h4>\r\n    <form [formGroup]=\"formGroup\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n      <div class=\"form-section\">\r\n        <div class=\"form-row\">\r\n          <div class=\"col-md-4\">\r\n            <mat-form-field>\r\n              <mat-select matNativeControl placeholder=\"Rubro\" formControlName=\"rubro\" (selectionChange)=\"onRubroSelect($event)\">\r\n                <mat-option class=\"text-breakword\" *ngFor=\"let rubro of resultadoRubros\" [value]=\"rubro.codigo\">{{rubro.descripcion}}</mat-option>\r\n              </mat-select>\r\n              <mat-error *ngIf=\"formGroup.get('rubro').invalid\">Este campo es requerido.</mat-error>\r\n            </mat-form-field>\r\n          </div>\r\n          <div class=\"col-md-8\">\r\n            <mat-form-field>\r\n              <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"empresa\">\r\n                <mat-option class=\"text-breakword\" *ngFor=\"let empresa of resultadoEmpresa\" [value]=\"empresa.docFacturador\">{{empresa.nomFacturador}}</mat-option>\r\n              </mat-select>\r\n              <mat-error *ngIf=\"formGroup.get('empresa').invalid\">Este campo es requerido.</mat-error>\r\n            </mat-form-field>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"buttons-container\">\r\n          <button [mat-dialog-close]=\"false\" *ngIf=\"data.showBtnCancel\" class=\"btn secundario\">Cancelar</button>\r\n          <button [mat-dialog-close]=\"true\" *ngIf=\"formGroup.get('empresa').valid\" class=\"btn main\">Aceptar</button>\r\n          <button *ngIf=\"formGroup.get('empresa').invalid || formGroup.get('empresa').disabled\" class=\"btn main\">Aceptar</button>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </div>\r\n</div>\r\n",
                    providers: [EmpresasService]
                }] }
    ];
    /** @nocollapse */
    DialogToUserEmpComponent.ctorParameters = function () { return [
        { type: MatDialogRef },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] },
        { type: EmpresasService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return DialogToUserEmpComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmpresaAgregarPeticion = /** @class */ (function () {
    function EmpresaAgregarPeticion() {
        this.codCliente = '';
        this.codTpoPortal = '';
        this.docEmpresa = '';
        this.idUsuario = 0;
        this.codFacturador = '';
        this.nombreEmpresa = '';
        this.documento = '';
        this.codRubro = '';
        this.codEstadoEmpresa = '';
        this.terminalId = '';
        this.sucursalId = '';
        this.codMastercard = '';
        this.userEmbedded = '';
        this.passEmbedded = '';
        this.emailOperador = '';
        this.razonSocial = '';
        this.orgUnitId3DS = '';
        this.apiIdentifier3DS = '';
        this.apiKey3DS = '';
        this.leyImpuestos = 0;
        this.cantMaxComTokenSuscripcion = 0;
        this.inicioSusApi = '';
    }
    return EmpresaAgregarPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmpresaParams = /** @class */ (function () {
    function EmpresaParams() {
        this.docEmpresa = '';
    }
    return EmpresaParams;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmpresasAgregarComponent = /** @class */ (function () {
    function EmpresasAgregarComponent(phttp, router, route, dialog, loader, empresaParams, environment) {
        this.phttp = phttp;
        this.router = router;
        this.route = route;
        this.dialog = dialog;
        this.loader = loader;
        this.empresaParams = empresaParams;
        this.environment = environment;
        this.resultadoRubros = [];
        this.resultadoEstados = [];
        this.resultadoLeyImpuestos = [];
        this.peticionReporte = new EmpresasPeticion();
        this.inicioSusApiList = [
            { option: 'SI', value: 'S' },
            { option: 'NO', value: 'N' }
        ];
        //Codigos entregados por PAYA Getnet Uruguay (PAYS en Chile)
        this.resultadoLeyImpuestos[0] = { codigo: 0, descripcion: 'No aplica' };
        this.resultadoLeyImpuestos[1] = { codigo: 1, descripcion: 'Ley 17934' };
        this.resultadoLeyImpuestos[2] = { codigo: 2, descripcion: 'Ley 18083' };
        this.resultadoLeyImpuestos[3] = { codigo: 3, descripcion: 'Ley 18910' };
        this.resultadoLeyImpuestos[4] = { codigo: 4, descripcion: 'Ley 18999' };
        this.resultadoLeyImpuestos[5] = { codigo: 6, descripcion: 'Ley 19210' };
    }
    /**
     * @return {?}
     */
    EmpresasAgregarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idUsuario = +(this.userPerfil.usuario.idUsuario);
        this.preLoginsLS = JSON.parse(sessionStorage.getItem('preLogin'));
        this.agregarFormGroup = new FormGroup({
            codigoEmpresa: new FormControl('', Validators.compose([Validators.pattern('^[0-9a-zA-ZáéíóúñÁÉÍÓÚÑ]{1,15}$'), Validators.required])),
            nombreEmpresa: new FormControl('', Validators.compose([Validators.maxLength(100), Validators.required, CustomValidators.descriptionValidator])),
            documento: new FormControl('', Validators.compose([CustomValidators.rutValidatorUY, Validators.required])),
            rubro: new FormControl('', Validators.required),
            estado: new FormControl('', Validators.required),
            terminalId: new FormControl('10000001', Validators.compose([Validators.required, CustomValidators.descriptionValidator])),
            sucursalId: new FormControl('', Validators.compose([Validators.required, CustomValidators.descriptionValidator])),
            codMastercard: new FormControl('', Validators.compose([Validators.required, CustomValidators.descriptionValidator])),
            userEmbedded: new FormControl('', Validators.compose([CustomValidators.descriptionValidator])),
            passEmbedded: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.required, CustomValidators.descriptionValidator])),
            emailOperador: new FormControl('', Validators.compose([Validators.required, Validators.email])),
            razonSocial: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(100), CustomValidators.descriptionValidator])),
            orgUnitId: new FormControl('', Validators.compose([CustomValidators.descriptionValidator])),
            apiIdentifier: new FormControl('', Validators.compose([CustomValidators.descriptionValidator])),
            apiKey: new FormControl('', Validators.compose([CustomValidators.descriptionValidator])),
            leyImpuesto: new FormControl('0', Validators.required),
            cantMaxComTokenSuscripcion: new FormControl('30', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required, Validators.min(1), Validators.maxLength(3)])),
            inicioSusApi: new FormControl('', Validators.required)
        });
        this.postSentRubrosServices();
        this.postListarEstadosEmpresa();
    };
    /**
     * @return {?}
     */
    EmpresasAgregarComponent.prototype.postSentRubrosServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new RubroRequest();
        params.codEstadoConvenio = '-1'; //Todos los rubros
        this.phttp.postRubrosReport(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoRubros = data.resultado;
            }
            else {
                console.error('Error al buscar lista de rubros', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postRubrosReport', err);
        }));
    };
    /**
     * @return {?}
     */
    EmpresasAgregarComponent.prototype.postListarEstadosEmpresa = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.phttp.postListarEstadosEmpresa().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEstados = data.resultado;
            }
            else {
                console.error('Error al buscar lista de estados', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postListarEstadosEmpresa', err);
        }));
    };
    /**
     * @return {?}
     */
    EmpresasAgregarComponent.prototype.validarEmpresa = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.agregarFormGroup.get('documento').valid) {
            this.peticionReporte.codCliente = this.environment.codCliente;
            this.peticionReporte.codFacturador = "-1";
            this.peticionReporte.nomFacturador = "-1";
            this.peticionReporte.docEmpresa = this.agregarFormGroup.get('documento').value;
            this.peticionReporte.codRubro = "-1";
            this.peticionReporte.codEstadoEmpresa = "-1";
            this.phttp.postListarEmpresas(this.peticionReporte).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                if (data.codret == '0') {
                    console.log(data);
                    /** @type {?} */
                    var vistaCantidad = data.resultado.length;
                    if (vistaCantidad == 0) {
                        console.log("No existe informacion que tratar");
                    }
                    else {
                        //Revisar 
                        _this.msgExistEmp(_this.peticionReporte.docEmpresa);
                    }
                }
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function (err) {
                console.log("Hubo un problema al validar la empresa");
            }));
        }
        else {
            console.log("No es valido el documento empresa.");
        }
    };
    /**
     * @param {?} docEmp
     * @return {?}
     */
    EmpresasAgregarComponent.prototype.msgExistEmp = /**
     * @param {?} docEmp
     * @return {?}
     */
    function (docEmp) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: "Empresa existente", content: "Este identificador de empresa ya existe.<br>¿Desea editarlo?", showBtnCancel: true },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result.toString());
            if (result == true) {
                _this.empresaParams.docEmpresa = docEmp;
                _this.router.navigate(['../empresasEditar'], { relativeTo: _this.route });
            }
        }));
    };
    /**
     * @return {?}
     */
    EmpresasAgregarComponent.prototype.postEmpresaAgregarService = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new EmpresaAgregarPeticion();
        params.codCliente = this.environment.codCliente;
        params.codTpoPortal = this.preLoginsLS.codTpoPortal;
        params.docEmpresa = this.environment.docEmpresa;
        params.idUsuario = this.idUsuario;
        params.codFacturador = this.agregarFormGroup.get('codigoEmpresa').value;
        params.nombreEmpresa = this.agregarFormGroup.get('nombreEmpresa').value;
        params.codRubro = this.agregarFormGroup.get('rubro').value;
        params.codEstadoEmpresa = this.agregarFormGroup.get('estado').value;
        params.documento = this.agregarFormGroup.get('documento').value;
        params.terminalId = this.agregarFormGroup.get('terminalId').value;
        params.sucursalId = this.agregarFormGroup.get('sucursalId').value;
        params.codMastercard = this.agregarFormGroup.get('codMastercard').value;
        params.userEmbedded = this.agregarFormGroup.get('userEmbedded').value;
        params.passEmbedded = this.agregarFormGroup.get('passEmbedded').value;
        params.emailOperador = this.agregarFormGroup.get('emailOperador').value;
        params.razonSocial = this.agregarFormGroup.controls.razonSocial.value;
        params.orgUnitId3DS = this.agregarFormGroup.get('orgUnitId').value;
        params.apiIdentifier3DS = this.agregarFormGroup.get('apiIdentifier').value;
        params.apiKey3DS = this.agregarFormGroup.get('apiKey').value;
        params.leyImpuestos = this.agregarFormGroup.get('leyImpuesto').value;
        params.cantMaxComTokenSuscripcion = this.agregarFormGroup.get('cantMaxComTokenSuscripcion').value;
        params.inicioSusApi = this.agregarFormGroup.get('inicioSusApi').value;
        this.loader.show();
        this.phttp.postEmpresaAgregar(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.loader.hide();
                _this.showDialog('Información', 'Empresa agregada exitosamente.', false, 'dialogExito');
            }
            else {
                _this.loader.hide();
                _this.showDialog('Error', 'Error al tratar de crear la empresa.<br>' + data.descret, false, null);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            _this.showDialog('Error', 'Error al crear la empresa, intente más tarde o contáctese con administrador de sistema.', false, null);
        }));
    };
    /**
     * @return {?}
     */
    EmpresasAgregarComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        if (this.agregarFormGroup.valid) {
            this.showDialogPre('Información', '¿Está seguro de guardar la empresa?', true);
        }
        else {
            this.showDialog('Error', 'Ingrese los datos requeridos', false, null);
        }
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    EmpresasAgregarComponent.prototype.showDialogPre = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            if (result) {
                _this.postEmpresaAgregarService();
            }
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} dialogName
     * @return {?}
     */
    EmpresasAgregarComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} dialogName
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel, dialogName) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            if (result && dialogName == 'dialogExito') {
                _this.callListarEmpresas();
            }
        }));
    };
    /**
     * @return {?}
     */
    EmpresasAgregarComponent.prototype.callListarEmpresas = /**
     * @return {?}
     */
    function () {
        this.router.navigate(['../'], { relativeTo: this.route });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    EmpresasAgregarComponent.prototype.cambioUserEmb = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var valor = event.target.value;
        if (valor.trim() != '') {
            this.agregarFormGroup.controls['passEmbedded'].enable();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    EmpresasAgregarComponent.prototype.disabledPass = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var valor = event.target.value;
        if (valor.trim() == '') {
            this.agregarFormGroup.get('passEmbedded').setValue('');
            this.agregarFormGroup.controls['passEmbedded'].disable();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    EmpresasAgregarComponent.prototype.changeRequiredData = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var valor = event.target.value;
        /** @type {?} */
        var valorOrgUnitId = this.agregarFormGroup.get('orgUnitId').value;
        /** @type {?} */
        var valorApiIdentifier = this.agregarFormGroup.get('apiIdentifier').value;
        /** @type {?} */
        var valorApiKey = this.agregarFormGroup.get('apiKey').value;
        if (valor.trim() != '') {
            this.agregarFormGroup.get('orgUnitId').setValidators([Validators.required, CustomValidators.descriptionValidator]);
            this.agregarFormGroup.get('apiIdentifier').setValidators([Validators.required, CustomValidators.descriptionValidator]);
            this.agregarFormGroup.get('apiKey').setValidators([Validators.required, CustomValidators.descriptionValidator]);
        }
        else {
            if (valorOrgUnitId.trim() == '' && valorApiIdentifier.trim() == '' && valorApiKey.trim() == '') {
                this.agregarFormGroup.get('orgUnitId').clearValidators();
                this.agregarFormGroup.get('apiIdentifier').clearValidators();
                this.agregarFormGroup.get('apiKey').clearValidators();
                this.agregarFormGroup.get('orgUnitId').setValidators([CustomValidators.descriptionValidator]);
                this.agregarFormGroup.get('apiIdentifier').setValidators([CustomValidators.descriptionValidator]);
                this.agregarFormGroup.get('apiKey').setValidators([CustomValidators.descriptionValidator]);
            }
        }
        this.agregarFormGroup.get('orgUnitId').updateValueAndValidity();
        this.agregarFormGroup.get('apiIdentifier').updateValueAndValidity();
        this.agregarFormGroup.get('apiKey').updateValueAndValidity();
    };
    EmpresasAgregarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'empresas-agregar',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a (click)=\"callListarEmpresas()\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <form [formGroup]=\"agregarFormGroup\" (ngSubmit)=\"onSubmit()\" autocomplete=\"off\">\r\n        <h3>Agregar empresa</h3>\r\n        <div class=\"form-section\">\r\n          <h5>Datos</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"15\" placeholder=\"C&oacute;digo\" formControlName=\"codigoEmpresa\">\r\n                <mat-error>Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-8 col-md-8\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"100\" placeholder=\"Nombre fantas\u00EDa\" formControlName=\"nombreEmpresa\">\r\n                <mat-error>Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"12\" soloRutUY formatRut placeholder=\"Rut empresa\" (blur)=\"validarEmpresa()\" formControlName=\"documento\">\r\n                <mat-error>Rut <strong>incorrecto</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"100\" placeholder=\"Raz\u00F3n social\" formControlName=\"razonSocial\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Ley de impuestos\" formControlName=\"leyImpuesto\">\r\n                  <mat-option *ngFor=\"let ley of resultadoLeyImpuestos\" [value]=\"ley.codigo\">{{ley.descripcion}}</mat-option>\r\n                </mat-select>\r\n                <mat-error>Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Rubro\" formControlName=\"rubro\">\r\n                  <mat-option *ngFor=\"let rubro of resultadoRubros\" [value]=\"rubro.codigo\">{{rubro.descripcion}}</mat-option>\r\n                </mat-select>\r\n                <mat-error>Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estado\">\r\n                  <mat-option *ngFor=\"let estado of resultadoEstados\" [value]=\"estado.codigo\">{{estado.descripcion}}</mat-option>\r\n                </mat-select>\r\n                <mat-error>Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"100\" placeholder=\"Email Operador\" formControlName=\"emailOperador\">\r\n                <mat-error>Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field hintLabel=\"Terminal por defecto es 10000001\">\r\n                <input matInput maxlength=\"50\" placeholder=\"C&oacute;digo de terminal\" formControlName=\"terminalId\">\r\n                <mat-error>Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"15\" placeholder=\"C&oacute;digo de sucursal\" formControlName=\"sucursalId\">\r\n                <mat-error>Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"15\" placeholder=\"C&oacute;digo de MasterCard\" formControlName=\"codMastercard\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <br/>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput digitOnly maxlength=\"3\" placeholder=\"Cantidad de minutos m&aacute;ximo token suscripci&oacute;n\" formControlName=\"cantMaxComTokenSuscripcion\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Habilitar inicio suscripci&oacute;n por API\" formControlName=\"inicioSusApi\">\r\n                  <mat-option *ngFor=\"let sus of inicioSusApiList\" [value]=\"sus.value\">{{sus.option}}</mat-option>\r\n                </mat-select>\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <br/>\r\n          <h5>Usuario portal embebido (Opcional)</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-6 col-md-6\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"20\" placeholder=\"Usuario\" formControlName=\"userEmbedded\" (keypress)=\"cambioUserEmb($event)\" (change)=\"disabledPass($event)\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-6 col-md-6\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"20\" [type]=\"'password'\" placeholder=\"Contrase&ntilde;a\" formControlName=\"passEmbedded\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <br/>\r\n          <h5>Datos conexi&oacute;n 3DS (Opcional)</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"512\" placeholder=\"Key 1\" formControlName=\"orgUnitId\" (change)=\"changeRequiredData($event)\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"512\" placeholder=\"Key 2\" formControlName=\"apiIdentifier\" (change)=\"changeRequiredData($event)\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"512\" placeholder=\"Key 3\" formControlName=\"apiKey\" (change)=\"changeRequiredData($event)\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col align-right\">\r\n            <button type=\"button\" class=\"btn text\" (click)=\"callListarEmpresas()\">Cancelar</button>\r\n            <button type=\"submit\" class=\"btn main\">Guardar</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>"
                }] }
    ];
    /** @nocollapse */
    EmpresasAgregarComponent.ctorParameters = function () { return [
        { type: EmpresasService },
        { type: Router },
        { type: ActivatedRoute },
        { type: MatDialog },
        { type: LoaderBaseService },
        { type: EmpresaParams },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return EmpresasAgregarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmpresasEditarComponent = /** @class */ (function () {
    function EmpresasEditarComponent(empresaParams, phttp, router, route, dialog, loader, environment) {
        this.empresaParams = empresaParams;
        this.phttp = phttp;
        this.router = router;
        this.route = route;
        this.dialog = dialog;
        this.loader = loader;
        this.environment = environment;
        this.pipeRut = new RutPipe();
        this.editarEmpFormGroup = new FormGroup({
            codigoEmpresa: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.required, CustomValidators.descriptionValidator])),
            nombreEmpresa: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(100), CustomValidators.descriptionValidator])),
            documento: new FormControl({ value: '', disabled: true }, Validators.compose([CustomValidators.rutValidatorUY, Validators.required])),
            rubro: new FormControl('', Validators.required),
            estado: new FormControl('', Validators.required),
            terminalId: new FormControl('', Validators.compose([Validators.required, CustomValidators.descriptionValidator])),
            sucursalId: new FormControl('', Validators.compose([Validators.required, CustomValidators.descriptionValidator])),
            codMastercard: new FormControl('', Validators.compose([Validators.required, CustomValidators.descriptionValidator])),
            userEmbedded: new FormControl('', Validators.compose([CustomValidators.descriptionValidator])),
            passEmbedded: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.required, CustomValidators.descriptionValidator])),
            emailOperador: new FormControl('', Validators.compose([Validators.required, Validators.email])),
            razonSocial: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(100), CustomValidators.descriptionValidator])),
            orgUnitId: new FormControl('', Validators.compose([CustomValidators.descriptionValidator])),
            apiIdentifier: new FormControl('', Validators.compose([CustomValidators.descriptionValidator])),
            apiKey: new FormControl('', Validators.compose([CustomValidators.descriptionValidator])),
            leyImpuesto: new FormControl('0', Validators.required),
            cantMaxComTokenSuscripcion: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required, Validators.min(1), Validators.maxLength(3)])),
            inicioSusApi: new FormControl('', Validators.required)
        });
        this.resultadoRubros = [];
        this.resultadoEstados = [];
        this.peticionListarEmpresas = new EmpresasPeticion();
        this.resultadoLeyImpuestos = [];
        this.isAdquirente = false;
        this.inicioSusApiList = [
            { option: 'SI', value: 'S' },
            { option: 'NO', value: 'N' }
        ];
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idUsuario = +(this.userPerfil.usuario.idUsuario);
        this.preLoginsLS = JSON.parse(sessionStorage.getItem('preLogin'));
        //Codigos entregados por PAYA Getnet Uruguay (PAYS en Chile)
        this.resultadoLeyImpuestos[0] = { codigo: 0, descripcion: 'No aplica' };
        this.resultadoLeyImpuestos[1] = { codigo: 1, descripcion: 'Ley 17934' };
        this.resultadoLeyImpuestos[2] = { codigo: 2, descripcion: 'Ley 18083' };
        this.resultadoLeyImpuestos[3] = { codigo: 3, descripcion: 'Ley 18910' };
        this.resultadoLeyImpuestos[4] = { codigo: 4, descripcion: 'Ley 18999' };
        this.resultadoLeyImpuestos[5] = { codigo: 6, descripcion: 'Ley 19210' };
    }
    /**
     * @return {?}
     */
    EmpresasEditarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        sessionStorage.setItem('componenteHijo', 'empresas-editar');
        if (this.empresaParams.docEmpresa == '') {
            this.router.navigate(['../'], { relativeTo: this.route });
            return;
        }
        this.peticionListarEmpresas.docEmpresa = this.empresaParams.docEmpresa;
        this.isAdquirente = (this.empresaParams.docEmpresa == this.environment.docEmpresa) ? true : false;
        this.postSentRubrosServices();
        this.postListarEstadosEmpresa();
        this.postBuscaEmpresaServices(this.peticionListarEmpresas);
    };
    /**
     * @return {?}
     */
    EmpresasEditarComponent.prototype.postSentRubrosServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new RubroRequest();
        params.codEstadoConvenio = '-1'; //Todos los rubros
        this.phttp.postRubrosReport(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoRubros = data.resultado;
            }
            else {
                console.error('Error al buscar lista de rubros', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postRubrosReport', err);
        }));
    };
    /**
     * @return {?}
     */
    EmpresasEditarComponent.prototype.postListarEstadosEmpresa = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.phttp.postListarEstadosEmpresa().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEstados = data.resultado;
            }
            else {
                console.error('Error al buscar lista de estados', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postListarEstadosEmpresa', err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    EmpresasEditarComponent.prototype.postBuscaEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        body.codCliente = this.environment.codCliente;
        this.phttp.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.loader.hide();
            if (data.codret == '0') {
                /** @type {?} */
                var empresa = data.resultado[0];
                _this.editarEmpFormGroup.get('codigoEmpresa').setValue(empresa.codFacturador);
                _this.editarEmpFormGroup.get('nombreEmpresa').setValue(empresa.nomFacturador);
                _this.editarEmpFormGroup.get('documento').setValue(empresa.docFacturador);
                _this.editarEmpFormGroup.get('rubro').setValue(empresa.codRubro);
                _this.editarEmpFormGroup.get('estado').setValue(empresa.codEstadoEmpresa);
                _this.editarEmpFormGroup.get('terminalId').setValue(empresa.terminalId);
                _this.editarEmpFormGroup.get('sucursalId').setValue(empresa.sucursalId);
                _this.editarEmpFormGroup.get('codMastercard').setValue(empresa.codMastercard);
                _this.editarEmpFormGroup.get('emailOperador').setValue(empresa.emailOperador);
                _this.editarEmpFormGroup.controls.razonSocial.setValue(empresa.razonSocial);
                _this.editarEmpFormGroup.get('orgUnitId').setValue(empresa.orgUnitId3DS);
                _this.editarEmpFormGroup.get('apiIdentifier').setValue(empresa.apiIdentifier3DS);
                _this.editarEmpFormGroup.get('apiKey').setValue(empresa.apiKey3DS);
                _this.editarEmpFormGroup.get('leyImpuesto').setValue(empresa.leyImpuesto);
                _this.editarEmpFormGroup.get('cantMaxComTokenSuscripcion').setValue(empresa.cantMaxComTokenSuscripcion);
                _this.editarEmpFormGroup.get('inicioSusApi').setValue(empresa.inicioSusApi);
                if (empresa.userEmbedded != '') {
                    _this.editarEmpFormGroup.controls['passEmbedded'].enable();
                    _this.editarEmpFormGroup.get('userEmbedded').setValue(empresa.userEmbedded);
                    _this.editarEmpFormGroup.get('passEmbedded').setValue(empresa.passEmbedded);
                }
                if (_this.isAdquirente) {
                    _this.editarEmpFormGroup.get('rubro').disable();
                    _this.editarEmpFormGroup.get('estado').disable();
                    _this.editarEmpFormGroup.get('terminalId').disable();
                    _this.editarEmpFormGroup.get('sucursalId').disable();
                    _this.editarEmpFormGroup.get('codMastercard').disable();
                    _this.editarEmpFormGroup.get('userEmbedded').disable();
                    _this.editarEmpFormGroup.get('passEmbedded').disable();
                }
            }
            else {
                console.error('Error al buscar empresa', data.descret);
                _this.showDialog('Error', 'Error al buscar la empresa.<br>' + data.descret, false, null);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            console.error('Error postListarEmpresas', err);
        }));
    };
    /**
     * @return {?}
     */
    EmpresasEditarComponent.prototype.postUpdateEmpresaServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new EmpresaAgregarPeticion();
        params.codCliente = this.environment.codCliente;
        params.codTpoPortal = this.preLoginsLS.codTpoPortal;
        params.docEmpresa = this.environment.docEmpresa;
        params.idUsuario = this.idUsuario;
        params.codFacturador = this.editarEmpFormGroup.get('codigoEmpresa').value;
        params.nombreEmpresa = this.editarEmpFormGroup.get('nombreEmpresa').value;
        params.documento = this.editarEmpFormGroup.get('documento').value;
        params.codRubro = this.editarEmpFormGroup.get('rubro').value;
        params.codEstadoEmpresa = this.editarEmpFormGroup.get('estado').value;
        params.terminalId = this.editarEmpFormGroup.get('terminalId').value;
        params.sucursalId = this.editarEmpFormGroup.get('sucursalId').value;
        params.codMastercard = this.editarEmpFormGroup.get('codMastercard').value;
        params.userEmbedded = this.editarEmpFormGroup.get('userEmbedded').value;
        params.passEmbedded = this.editarEmpFormGroup.get('passEmbedded').value;
        params.emailOperador = this.editarEmpFormGroup.get('emailOperador').value;
        params.razonSocial = this.editarEmpFormGroup.controls.razonSocial.value;
        params.orgUnitId3DS = this.editarEmpFormGroup.get('orgUnitId').value;
        params.apiIdentifier3DS = this.editarEmpFormGroup.get('apiIdentifier').value;
        params.apiKey3DS = this.editarEmpFormGroup.get('apiKey').value;
        params.leyImpuestos = this.editarEmpFormGroup.get('leyImpuesto').value;
        params.cantMaxComTokenSuscripcion = this.editarEmpFormGroup.get('cantMaxComTokenSuscripcion').value;
        params.inicioSusApi = this.editarEmpFormGroup.get('inicioSusApi').value;
        if (this.isAdquirente) {
            params.codRubro = '0';
            params.codFacturador = '0';
            params.terminalId = '0';
            params.sucursalId = '0';
            params.codMastercard = '0';
        }
        this.loader.show();
        this.phttp.postEmpresaActualizar(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.loader.hide();
            if (data.codret == '0') {
                _this.showDialog('Información', 'Empresa editada exitosamente.', false, 'dialogExito');
            }
            else {
                _this.showDialog('Error', 'Error al tratar de editar la empresa.<br>' + data.descret, false, null);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            _this.showDialog('Error', 'Error al editar la empresa, intente más tarde o contáctese con administrador de sistema.', false, null);
        }));
    };
    /**
     * @return {?}
     */
    EmpresasEditarComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        if (this.editarEmpFormGroup.valid) {
            this.showDialogPre('Información', '¿Está seguro de editar la empresa?', true);
        }
        else {
            this.showDialog('Error', 'Ingrese los datos requeridos', false, null);
        }
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    EmpresasEditarComponent.prototype.showDialogPre = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            if (result) {
                _this.postUpdateEmpresaServices();
            }
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} dialogName
     * @return {?}
     */
    EmpresasEditarComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} dialogName
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel, dialogName) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            if (result && dialogName == 'dialogExito') {
                _this.callListarEmpresas();
            }
        }));
    };
    /**
     * @return {?}
     */
    EmpresasEditarComponent.prototype.callListarEmpresas = /**
     * @return {?}
     */
    function () {
        this.router.navigate(['../'], { relativeTo: this.route });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    EmpresasEditarComponent.prototype.cambioUserEmb = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var valor = event.target.value;
        if (valor.trim() != '') {
            this.editarEmpFormGroup.controls['passEmbedded'].enable();
        }
        else {
            this.editarEmpFormGroup.controls['passEmbedded'].disable();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    EmpresasEditarComponent.prototype.disabledPass = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var valor = event.target.value;
        if (valor.trim() == '') {
            this.editarEmpFormGroup.get('passEmbedded').setValue('');
            this.editarEmpFormGroup.controls['passEmbedded'].disable();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    EmpresasEditarComponent.prototype.changeRequiredData = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var valor = event.target.value;
        /** @type {?} */
        var valorOrgUnitId = this.editarEmpFormGroup.get('orgUnitId').value;
        /** @type {?} */
        var valorApiIdentifier = this.editarEmpFormGroup.get('apiIdentifier').value;
        /** @type {?} */
        var valorApiKey = this.editarEmpFormGroup.get('apiKey').value;
        if (valor.trim() != '') {
            this.editarEmpFormGroup.get('orgUnitId').setValidators([Validators.required, CustomValidators.descriptionValidator]);
            this.editarEmpFormGroup.get('apiIdentifier').setValidators([Validators.required, CustomValidators.descriptionValidator]);
            this.editarEmpFormGroup.get('apiKey').setValidators([Validators.required, CustomValidators.descriptionValidator]);
        }
        else {
            if (valorOrgUnitId.trim() == '' && valorApiIdentifier.trim() == '' && valorApiKey.trim() == '') {
                this.editarEmpFormGroup.get('orgUnitId').clearValidators();
                this.editarEmpFormGroup.get('apiIdentifier').clearValidators();
                this.editarEmpFormGroup.get('apiKey').clearValidators();
                this.editarEmpFormGroup.get('orgUnitId').setValidators([CustomValidators.descriptionValidator]);
                this.editarEmpFormGroup.get('apiIdentifier').setValidators([CustomValidators.descriptionValidator]);
                this.editarEmpFormGroup.get('apiKey').setValidators([CustomValidators.descriptionValidator]);
            }
        }
        this.editarEmpFormGroup.get('orgUnitId').updateValueAndValidity();
        this.editarEmpFormGroup.get('apiIdentifier').updateValueAndValidity();
        this.editarEmpFormGroup.get('apiKey').updateValueAndValidity();
    };
    EmpresasEditarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'empresas-editar',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a (click)=\"callListarEmpresas()\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <form [formGroup]=\"editarEmpFormGroup\" (ngSubmit)=\"onSubmit()\" autocomplete=\"off\">\r\n       <h3>Editar empresa</h3>\r\n        <div class=\"form-section\">\r\n          <h5>Datos</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput placeholder=\"C&oacute;digo\" formControlName=\"codigoEmpresa\">\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-8 col-md-8\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"100\" placeholder=\"Nombre fantas\u00EDa\" formControlName=\"nombreEmpresa\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"12\" soloRutUY formatRut placeholder=\"Rut empresa\" formControlName=\"documento\">\r\n                <mat-error *ngIf=\"editarEmpFormGroup.get('documento').hasError('rutUYError')\">Rut <strong>incorrecto</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"100\" placeholder=\"Raz\u00F3n social\" formControlName=\"razonSocial\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Ley de impuestos\" formControlName=\"leyImpuesto\">\r\n                    <mat-option *ngFor=\"let ley of resultadoLeyImpuestos\" [value]=\"ley.codigo\">{{ley.descripcion}}</mat-option>\r\n                </mat-select>\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Rubro\" formControlName=\"rubro\">\r\n                    <mat-option *ngFor=\"let rubro of resultadoRubros\" [value]=\"rubro.codigo\">{{rubro.descripcion}}</mat-option>\r\n                </mat-select>\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estado\">\r\n                    <mat-option *ngFor=\"let estado of resultadoEstados\" [value]=\"estado.codigo\">{{estado.descripcion}}</mat-option>\r\n                </mat-select>\r\n                <mat-error >Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"100\" placeholder=\"Email Operador\" formControlName=\"emailOperador\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field hintLabel=\"Terminal por defecto es 10000001\">\r\n                <input matInput maxlength=\"50\" placeholder=\"C&oacute;digo de terminal\" formControlName=\"terminalId\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"15\" placeholder=\"C&oacute;digo de sucursal\" formControlName=\"sucursalId\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"15\" placeholder=\"C&oacute;digo de MasterCard\" formControlName=\"codMastercard\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <br/>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput digitOnly maxlength=\"3\" placeholder=\"Cantidad de minutos m&aacute;ximo token suscripci&oacute;n\" formControlName=\"cantMaxComTokenSuscripcion\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Habilitar inicio suscripci&oacute;n por API\" formControlName=\"inicioSusApi\">\r\n                  <mat-option *ngFor=\"let sus of inicioSusApiList\" [value]=\"sus.value\">{{sus.option}}</mat-option>\r\n                </mat-select>\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <br/>\r\n          <h5>Usuario portal embebido (Opcional)</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"20\" placeholder=\"Usuario\" formControlName=\"userEmbedded\" (keypress)=\"cambioUserEmb($event)\" (change)=\"disabledPass($event)\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"20\" [type]=\"'password'\" placeholder=\"Contrase&ntilde;a\" formControlName=\"passEmbedded\" (click)=\"$event.target.select()\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <h5>Datos conexi&oacute;n 3DS (Opcional)</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"512\" placeholder=\"Key 1\" formControlName=\"orgUnitId\" (change)=\"changeRequiredData($event)\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"512\" placeholder=\"Key 2\" formControlName=\"apiIdentifier\" (change)=\"changeRequiredData($event)\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-sm-4 col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"512\" placeholder=\"Key 3\" formControlName=\"apiKey\" (change)=\"changeRequiredData($event)\">\r\n                <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col align-right\">\r\n            <button type=\"button\" class=\"btn text\" (click)=\"callListarEmpresas()\">Cancelar</button>\r\n            <button type=\"submit\" class=\"btn main\">Editar</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>"
                }] }
    ];
    /** @nocollapse */
    EmpresasEditarComponent.ctorParameters = function () { return [
        { type: EmpresaParams },
        { type: EmpresasService },
        { type: Router },
        { type: ActivatedRoute },
        { type: MatDialog },
        { type: LoaderBaseService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return EmpresasEditarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmpresasListarComponent = /** @class */ (function () {
    function EmpresasListarComponent(phttp, phttpd, dialog, loader, empresaParams, router, route, serviceBaseService, environment) {
        this.phttp = phttp;
        this.phttpd = phttpd;
        this.dialog = dialog;
        this.loader = loader;
        this.empresaParams = empresaParams;
        this.router = router;
        this.route = route;
        this.serviceBaseService = serviceBaseService;
        this.environment = environment;
        this.pipeRut = new RutPipe();
        // Vistas variables
        this.vistaCantidad = 0;
        this.vistaRubro = 'Todos';
        this.vistaEstado = 'Todos';
        this.peticionReporte = new EmpresasPeticion();
        this.resultadoRubros = [];
        this.resultadoEstados = [];
        this.consulta = -1;
        this.isCollapsed = false;
        this.hashCaminoMiga = [];
    }
    /**
     * @return {?}
     */
    EmpresasListarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (sessionStorage.getItem('componenteHijo') != 'empresas-editar') {
            sessionStorage.removeItem('indice');
        }
        this.formGroup = new FormGroup({
            codigoEmpresa: new FormControl(),
            nombreEmpresa: new FormControl(),
            documento: new FormControl('', CustomValidators.rutValidatorUY),
            rubro: new FormControl('-1'),
            estado: new FormControl('-1')
        });
        this.viewAgregar = this.serviceBaseService.validaAccesoMenu('empresasAgregar');
        this.viewEditar = this.serviceBaseService.validaAccesoMenu('empresasEditar');
        if (this.viewEditar) {
            this.displayedColumns = ['nombre', 'codigoFacturador', 'documento', 'rubro', 'estado', 'editar'];
        }
        else {
            this.displayedColumns = ['nombre', 'codigoFacturador', 'documento', 'rubro', 'estado'];
        }
        this.postSentRubrosServices();
        this.postListarEstadosEmpresa();
        if (sessionStorage.getItem('componenteHijo') == 'empresas-editar') {
            /** @type {?} */
            var llamadaPadre = JSON.parse(sessionStorage.getItem('llamadaPadre'));
            // Llena los filtros
            this.formGroup.controls['codigoEmpresa'].setValue((llamadaPadre.codFacturador != '-1' ? llamadaPadre.codFacturador : ''));
            this.formGroup.controls['nombreEmpresa'].setValue((llamadaPadre.nomFacturador != '-1' ? llamadaPadre.nomFacturador : ''));
            this.formGroup.controls['documento'].setValue((llamadaPadre.docEmpresa != '-1' ? llamadaPadre.docEmpresa : ''));
            this.formGroup.controls['rubro'].setValue(llamadaPadre.codRubro);
            this.formGroup.controls['estado'].setValue(llamadaPadre.codEstadoEmpresa);
            // Llena camino de migas
            /** @type {?} */
            var migasPadre = JSON.parse(sessionStorage.getItem('migasPadre'));
            this.vistaEstado = migasPadre.codEstadoEmpresa;
            this.vistaRubro = migasPadre.codRubro;
            this.hashCaminoMiga[0] = { title: 'Nombre', text: migasPadre.nomFacturador };
            this.hashCaminoMiga[1] = { title: 'Código', text: migasPadre.codFacturador };
            this.hashCaminoMiga[2] = { title: 'Rut empresa', text: migasPadre.docEmpresa };
            this.hashCaminoMiga[3] = { title: 'Rubro', text: migasPadre.codRubro };
            this.hashCaminoMiga[4] = { title: 'Estado', text: migasPadre.codEstadoEmpresa };
            // Llama al servicio
            this.peticionReporte.codCliente = llamadaPadre.codCliente;
            this.peticionReporte.codFacturador = llamadaPadre.codFacturador;
            this.peticionReporte.nomFacturador = llamadaPadre.nomFacturador;
            this.peticionReporte.docEmpresa = llamadaPadre.docEmpresa;
            this.peticionReporte.codRubro = llamadaPadre.codRubro;
            this.peticionReporte.codEstadoEmpresa = llamadaPadre.codEstadoEmpresa;
            this.postSentReportServices(this.peticionReporte);
        }
        else {
            this.setInitialBreadcrumbs();
        }
    };
    /**
     * @return {?}
     */
    EmpresasListarComponent.prototype.setInitialBreadcrumbs = /**
     * @return {?}
     */
    function () {
        this.hashCaminoMiga[0] = { title: 'Nombre fantasía', text: '' };
        this.hashCaminoMiga[1] = { title: 'Código', text: '' };
        this.hashCaminoMiga[2] = { title: 'Rut empresa', text: '' };
        this.hashCaminoMiga[3] = { title: 'Rubro', text: 'Todos' };
        this.hashCaminoMiga[4] = { title: 'Estado', text: 'Todos' };
    };
    /**
     * @param {?} event
     * @return {?}
     */
    EmpresasListarComponent.prototype.onPaginateChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var indice = this.paginator.pageIndex;
        sessionStorage.setItem('indice', indice);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    EmpresasListarComponent.prototype.postSentReportServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.show = true;
        this.consulta == 1;
        body.withCliente = "true";
        this.phttp.postListarSelectEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.vistaCantidad = data.resultado.length;
                if (_this.paginator != undefined && sessionStorage.getItem('componenteHijo') == 'empresas-editar') {
                    _this.paginator.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indice')))));
                }
                else if (_this.paginator != undefined) {
                    _this.paginator.pageIndex = 0;
                    sessionStorage.removeItem("indice");
                }
                sessionStorage.removeItem('componenteHijo');
                _this.dataSource = new MatTableDataSource(data.resultado);
                _this.dataSource.paginator = _this.paginator;
                _this.dataSource.sort = _this.sort;
                if (_this.vistaCantidad == 0) {
                    _this.show = false;
                    _this.isCollapsed = false;
                }
                else {
                    _this.isCollapsed = true;
                }
                _this.loader.hide();
            }
            else {
                _this.show = false;
                console.error('Error al listar empresas', data.descret);
                _this.loader.hide();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            console.error('Error postListarEmpresas', err);
            _this.loader.hide();
        }));
        // this.phttp.postListarEmpresas(body).subscribe(data => {
        //   if (data.codret == '0') {          
        //     this.vistaCantidad = data.resultado.length;
        //     if(this.paginator != undefined &&  sessionStorage.getItem('componenteHijo') == 'empresas-editar'){            
        //       this.paginator.pageIndex= <number><unknown>sessionStorage.getItem('indice');
        //     }else if(this.paginator != undefined){
        //       this.paginator.pageIndex=0;
        //       sessionStorage.removeItem("indice");
        //     }
        //     sessionStorage.removeItem('componenteHijo');
        //     this.dataSource = new MatTableDataSource(data.resultado);
        //     this.dataSource.paginator = this.paginator;
        //     this.dataSource.sort = this.sort;
        //     if (this.vistaCantidad == 0) {
        //       this.show = false;
        //       this.isCollapsed = false;
        //     } else {
        //       this.isCollapsed = true;
        //     }
        //     this.loader.hide();
        //   } else {
        //     this.show = false;
        //     console.error('Error al listar empresas', data.descret);
        //     this.loader.hide();
        //   }
        // }, err => {
        //   this.show = false;
        //   console.error('Error postListarEmpresas', err);
        //   this.loader.hide();
        // });
    };
    /**
     * @return {?}
     */
    EmpresasListarComponent.prototype.postSentRubrosServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new RubroRequest();
        params.codEstadoConvenio = '-1'; //Todos los rubros
        this.phttp.postRubrosReport(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var rubro = new RubroResult();
                rubro.codigo = "-1";
                rubro.descripcion = "Todos";
                data.resultado.splice(0, 0, rubro);
                _this.resultadoRubros = data.resultado;
            }
            else {
                console.error('Error al buscar lista de rubros', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postRubrosReport', err);
        }));
    };
    /**
     * @return {?}
     */
    EmpresasListarComponent.prototype.postListarEstadosEmpresa = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.phttp.postListarEstadosEmpresa().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var estadoEmp = new RubroResult();
                estadoEmp.codigo = "-1";
                estadoEmp.descripcion = "Todos";
                data.resultado.splice(0, 0, estadoEmp);
                _this.resultadoEstados = data.resultado;
            }
            else {
                console.error('Error al buscar lista de estados', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postListarEstadosEmpresa', err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    EmpresasListarComponent.prototype.onRubroSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaRubro = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    EmpresasListarComponent.prototype.onEstadoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEstado = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    EmpresasListarComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.peticionReporte.codCliente = this.environment.codCliente;
        if (this.formGroup.get('nombreEmpresa').value == null || this.formGroup.get('nombreEmpresa').value == "") {
            this.peticionReporte.nomFacturador = "-1";
            this.hashCaminoMiga[0] = { title: 'Nombre fantasía', text: '' };
        }
        else {
            this.peticionReporte.nomFacturador = this.formGroup.get('nombreEmpresa').value;
            this.hashCaminoMiga[0] = { title: 'Nombre fantasía', text: this.formGroup.get('nombreEmpresa').value };
        }
        if (this.formGroup.get('codigoEmpresa').value == null || this.formGroup.get('codigoEmpresa').value == "") {
            this.peticionReporte.codFacturador = "-1";
            this.hashCaminoMiga[1] = { title: 'Código', text: '' };
        }
        else {
            this.peticionReporte.codFacturador = this.formGroup.get('codigoEmpresa').value;
            this.hashCaminoMiga[1] = { title: 'Código', text: this.formGroup.get('codigoEmpresa').value };
        }
        if (this.formGroup.get('documento').value == null || this.formGroup.get('documento').value == "") {
            this.peticionReporte.docEmpresa = "-1";
            this.hashCaminoMiga[2] = { title: 'Rut empresa', text: '' };
        }
        else {
            this.peticionReporte.docEmpresa = this.formGroup.get('documento').value;
            this.hashCaminoMiga[2] = { title: 'Rut empresa', text: this.pipeRut.transform(this.formGroup.get('documento').value) };
        }
        if (this.formGroup.get('rubro').value == null || this.formGroup.get('rubro').value == '' || this.formGroup.get('rubro').value == '-1') {
            this.peticionReporte.codRubro = "-1";
            this.hashCaminoMiga[3] = { title: 'Rubro', text: 'Todos' };
        }
        else {
            this.peticionReporte.codRubro = this.formGroup.get('rubro').value;
            this.hashCaminoMiga[3] = { title: 'Rubro', text: this.vistaRubro };
        }
        if (this.formGroup.get('estado').value == null || this.formGroup.get('estado').value == '' || this.formGroup.get('estado').value == '-1') {
            this.peticionReporte.codEstadoEmpresa = "-1";
            this.hashCaminoMiga[4] = { title: 'Estado', text: 'Todos' };
        }
        else {
            this.peticionReporte.codEstadoEmpresa = this.formGroup.get('estado').value;
            this.hashCaminoMiga[4] = { title: 'Estado', text: this.vistaEstado };
        }
        sessionStorage.setItem('llamadaPadre', JSON.stringify({
            codCliente: this.peticionReporte.codCliente,
            codFacturador: this.peticionReporte.codFacturador,
            nomFacturador: this.peticionReporte.nomFacturador,
            docEmpresa: this.peticionReporte.docEmpresa,
            codRubro: this.peticionReporte.codRubro,
            codEstadoEmpresa: this.peticionReporte.codEstadoEmpresa
        }));
        sessionStorage.setItem('migasPadre', JSON.stringify({
            nomFacturador: this.hashCaminoMiga[0].text,
            codFacturador: this.hashCaminoMiga[1].text,
            docEmpresa: this.hashCaminoMiga[2].text,
            codRubro: this.hashCaminoMiga[3].text,
            codEstadoEmpresa: this.hashCaminoMiga[4].text
        }));
        if (tipo == 'excel' || tipo == 'pdf') {
            this.peticionReporte.filtros = this.hashCaminoMiga;
            this.postDownloadReportFile(this.peticionReporte, tipo);
        }
        else {
            if (this.paginator != undefined) {
                this.paginator.pageIndex = 0;
            }
            this.postSentReportServices(this.peticionReporte);
        }
        this.consulta = 1;
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    EmpresasListarComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        //let url: string = '/apiEmpresaMT/listarEmpresa/' + tipo;
        /** @type {?} */
        var url = '/apiEmpresaMT/selectEmpresas/' + tipo;
        this.phttpd.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'listadoEmpresas' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'listadoEmpresas' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @return {?}
     */
    EmpresasListarComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.formGroup.controls.codigoEmpresa.setValue('');
        this.formGroup.controls.documento.setValue('');
        this.formGroup.controls.nombreEmpresa.setValue('');
        this.dataSource = new MatTableDataSource([]);
        this.show = false;
        this.vistaCantidad = 0;
        this.formGroup.controls.rubro.setValue('-1');
        this.formGroup.controls.estado.setValue('-1');
        this.consulta = -1;
        this.setInitialBreadcrumbs();
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    EmpresasListarComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} docEmpresa
     * @return {?}
     */
    EmpresasListarComponent.prototype.callEditarEmpresa = /**
     * @param {?} docEmpresa
     * @return {?}
     */
    function (docEmpresa) {
        this.empresaParams.docEmpresa = docEmpresa;
        this.router.navigate(['../empresasEditar'], { relativeTo: this.route });
    };
    /**
     * @return {?}
     */
    EmpresasListarComponent.prototype.callAgregarEmpresa = /**
     * @return {?}
     */
    function () {
        this.router.navigate(['../empresasAgregar'], { relativeTo: this.route });
    };
    /**
     * @return {?}
     */
    EmpresasListarComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.onSubmit('');
        }
    };
    /**
     * @return {?}
     */
    EmpresasListarComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('componenteHijo');
    };
    EmpresasListarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-empresas-listar',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"seccion-titulo-boton\">\r\n      <div class=\"row\">\r\n        <div class=\"col\" *ngIf=\"viewAgregar\">\r\n          <a class=\"boton-seccion btn-small main\" (click)=\"callAgregarEmpresa()\"><i class=\"str-icon-mas\"></i>Agregar empresa</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"modulo-filtros\">\r\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n      </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"formGroup\" (ngSubmit)=\"validarForm()\" autocomplete=\"off\">\r\n              <div class=\"form-row\">\r\n                <div class=\"col-md-8\">\r\n                  <mat-form-field>\r\n                    <input noCaracEsp matInput maxlength=\"100\" placeholder=\"Nombre fantas\u00EDa\" formControlName=\"nombreEmpresa\">\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <input noCaracEsp matInput maxlength=\"15\" placeholder=\"C&oacute;digo\" formControlName=\"codigoEmpresa\">\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-row\">\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <input formatRut soloRutUY matInput maxlength=\"12\" placeholder=\"Rut empresa\" formControlName=\"documento\">\r\n                    <mat-error *ngIf=\"formGroup.get('documento').hasError('rutUYError')\">Rut <strong>incorrecto</strong>.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Rubro\" formControlName=\"rubro\" (selectionChange)=\"onRubroSelect($event)\">\r\n                      <mat-option *ngFor=\"let rubro of resultadoRubros\" [value]=\"rubro.codigo\">{{rubro.descripcion}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estado\" (selectionChange)=\"onEstadoSelect($event)\">\r\n                      <mat-option *ngFor=\"let estado of resultadoEstados\" [value]=\"estado.codigo\">{{estado.descripcion}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"actions\">\r\n                <button type=\"button\" (click)=\"limpiar()\" class=\"btn text\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\">Filtrar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"resultados-filtros\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-10\">\r\n          <div class=\"tags row\">\r\n            <div *ngFor=\"let entry of hashCaminoMiga\" class=\"item\">{{entry.title}}: {{entry.text}}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n          <div class=\"numero-resultados\">\r\n            <strong>{{ (vistaCantidad == 1) ? ( vistaCantidad + \" Resultado\") : vistaCantidad + \" Resultados\" }}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-container table-responsive-md\">\r\n        <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n          <ng-container matColumnDef=\"nombre\">\r\n            <th mat-header-cell *matHeaderCellDef>Nombre fantas\u00EDa</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.nomFacturador}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"codigoFacturador\">\r\n            <th mat-header-cell *matHeaderCellDef>C&oacute;digo</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.codFacturador}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"documento\">\r\n            <th mat-header-cell *matHeaderCellDef>Rut empresa</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{pipeRut.transform(resultado.docFacturador)}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"rubro\">\r\n            <th mat-header-cell *matHeaderCellDef>Rubro</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.descRubro}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"estado\">\r\n            <th mat-header-cell *matHeaderCellDef>Estado</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.descEstadoEmpresa}} </td>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"viewEditar\" matColumnDef=\"editar\">\r\n            <th mat-header-cell *matHeaderCellDef>Editar</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a matTooltip=\"Editar empresa\" matTooltipPosition=\"above\" Style=\"cursor: pointer;\" (click)=\"callEditarEmpresa(resultado.docFacturador)\"><i class=\"icon str-icon-lapiz\"></i></a>\r\n            </td>\r\n          </ng-container>\r\n\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n        </table>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" (page)=\"onPaginateChange($event)\" showFirstLastButtons></mat-paginator>\r\n      </div>\r\n\r\n      <div class=\"box-actions\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6 item\">\r\n            <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n          </div>\r\n          <div class=\"col-md-6 item-right\">\r\n            <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </section>\r\n\r\n    <div class=\"modulo-cuentas\" *ngIf=\"vistaCantidad == 0 && consulta != -1\">\r\n      <span>No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.</span>\r\n    </div>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"consulta == -1\">\r\n      <span>\r\n        Establezca sus criterios de b&uacute;squeda.\r\n      </span>\r\n    </div>\r\n\r\n  </div>\r\n</section>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    EmpresasListarComponent.ctorParameters = function () { return [
        { type: EmpresasService },
        { type: DescargaExcelPdfFileService },
        { type: MatDialog },
        { type: LoaderBaseService },
        { type: EmpresaParams },
        { type: Router },
        { type: ActivatedRoute },
        { type: ServicesBaseService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    EmpresasListarComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator,] }],
        sort: [{ type: ViewChild, args: [MatSort,] }]
    };
    return EmpresasListarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FacturacionPeticion = /** @class */ (function () {
    function FacturacionPeticion() {
        this.codCliente = '-1';
        this.idUsuario = '-1';
        this.docEmpresa = '-1';
        this.codTpoPortal = '-1';
        this.codConvenio = '-1';
        this.nombreArchivo = '-1';
        this.nomEmpresaCargo = '-1';
        this.tipoCarga = '-1';
    }
    return FacturacionPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FileUploadService = /** @class */ (function () {
    function FileUploadService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlArchivo = this.environment.urlAmbiente + '/UploadFile';
    }
    /**
     * @param {?} params
     * @return {?}
     */
    FileUploadService.prototype.postFile = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        /** @type {?} */
        var httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'multipart/form-data',
                'enctype': 'multipart/form-data',
                'Accept': 'application/json',
                'Access-Control-Allow-Methods': '*',
                'Access-Control-Allow-Origin': '*'
            })
        };
        /** @type {?} */
        var formData = new FormData();
        formData.append('archivoEnviado', params.file);
        formData.append('archivoNombre', params.fileName);
        formData.append('codEmpresa', params.codEmpresa);
        formData.append('tipoArchivo', params.tipoArchivo);
        formData.append('codCliente', params.codCliente);
        formData.append('docEmpresa', params.docEmpresa);
        formData.append('codTipoPortal', params.codTipoPortal);
        formData.append('codConvenio', params.codConvenio);
        return this.http.post(this.urlArchivo, formData, httpOptions);
    };
    FileUploadService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    FileUploadService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    /** @nocollapse */ FileUploadService.ngInjectableDef = defineInjectable({ factory: function FileUploadService_Factory() { return new FileUploadService(inject(HttpClient), inject("env")); }, token: FileUploadService, providedIn: "root" });
    return FileUploadService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FileUploadParams = /** @class */ (function () {
    function FileUploadParams() {
        this.fileName = '';
        this.codEmpresa = '';
        this.tipoArchivo = '';
        this.codCliente = '';
        this.docEmpresa = '';
        this.codTipoPortal = '';
        this.codConvenio = '';
    }
    return FileUploadParams;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var Encoding = require('encoding-japanese');
var ɵ0$7 = MAT_MOMENT_DATE_FORMATS;
var FacturacionComponent = /** @class */ (function () {
    function FacturacionComponent(peticionAgregar, uploader, dialog, loader, datepipe, facturacionService, environment) {
        this.peticionAgregar = peticionAgregar;
        this.uploader = uploader;
        this.dialog = dialog;
        this.loader = loader;
        this.datepipe = datepipe;
        this.facturacionService = facturacionService;
        this.environment = environment;
        this.firstFormGroup = new FormGroup({
            archivo: new FormControl('', Validators.required),
            comercio: new FormControl('', Validators.required),
            convenio: new FormControl('', Validators.required)
        });
        this.fileUploadParams = new FileUploadParams();
        this.codEstado = '';
        this.colapse = 1;
        this.peticionEmpresa = new EmpresasPeticion();
        this.resultadoEmpresa = [];
        this.resultadoSelectEmpresa = [];
        this.comercioValido = 0;
        this.comboComercio = false;
        this.mensajeError = -1;
        this.peticionCargaAddAuditoria = new FacturacionPeticion();
        this.isDisableAgregarArchivo = true;
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.codEmpresaPac = this.userPerfil.empresa.codEmpresaPac;
        this.idUsuario = this.userPerfil.usuario.idUsuario;
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
        this.codCliente = this.environment.codCliente;
    }
    /**
     * @return {?}
     */
    FacturacionComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.codTpoPortal == 'COMERCIO') {
            this.comercioValido = 1;
            this.comboComercio = false;
            this.firstFormGroup.controls['comercio'].disable();
            this.firstFormGroup.controls['convenio'].enable();
            this.peticionEmpresa.codFacturador = this.codEmpresaPac;
        }
        else {
            this.comboComercio = true;
            this.firstFormGroup.controls['comercio'].enable();
            this.firstFormGroup.controls['convenio'].disable();
        }
        this.peticionEmpresa.codCliente = this.environment.codCliente;
        this.peticionEmpresa.codEstadoConvenio = 'HBL';
        this.peticionEmpresa.tipoCobro = "V";
        this.postSentEmpresaServices(this.peticionEmpresa);
        this.firstFormGroup.controls['archivo'].disable();
        //this.postSentSelectEmpresaServices(this.peticionEmpresa);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionComponent.prototype.postSentSelectEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.peticionAgregar.postListarSelectEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0' && data.resultado.length > 0) {
                _this.resultadoSelectEmpresa = data.resultado;
            }
            else {
                console.error('Error postListarEmpresas: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postListarEmpresas: ', err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.peticionAgregar.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEmpresa = data.resultado;
                _this.show = true;
                _this.mensajeError = 0;
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.mensajeError = 1;
                _this.loader.hide();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            _this.mensajeError = 1;
            _this.loader.hide();
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FacturacionComponent.prototype.onComercioSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.value != null) {
            this.comercioValido = 1;
        }
        this.idConvenioSelect = event.value.split(",")[1];
        this.docEmpresaSelect = event.value.split(',')[2];
        this.nomEmpresaCargo = event.source.selected._element.nativeElement.innerText.trim();
        this.firstFormGroup.controls['archivo'].enable();
        this.isDisableAgregarArchivo = false;
        //Paso el idConvenio
        //this.fileUploadParams.codConvenio = event.value;
    };
    /**
     * @param {?} files
     * @return {?}
     */
    FacturacionComponent.prototype.addToQueue = /**
     * @param {?} files
     * @return {?}
     */
    function (files) {
        var _this = this;
        /** @type {?} */
        var type = files[0].type;
        /** @type {?} */
        var fileSize = files[0].size;
        console.log('File type', type);
        console.log('File size', fileSize);
        this.detectEncoding(files[0]).subscribe((/**
         * @param {?} encoding
         * @return {?}
         */
        function (encoding) {
            //Continuar con la validacion de datos del archivo
            console.log('Encoding del archivo', encoding);
            _this.addFile(files[0], encoding);
        }));
    };
    /**
     * @param {?} file
     * @param {?} encoding
     * @return {?}
     */
    FacturacionComponent.prototype.addFile = /**
     * @param {?} file
     * @param {?} encoding
     * @return {?}
     */
    function (file, encoding) {
        console.log('Encoding a validar', encoding);
        if (encoding != 'UTF8') {
            this.showDialog('Error', 'La codificación del archivo debe ser UTF-8 y su archivo es ' + encoding + '.<br>Cámbie la codificación e intente nuevamente.', false);
            this.resetForm();
            return;
        }
        if (file.type == "text/plain" || file.type == "application/vnd.ms-excel" || file.type == 'text/csv') {
            this.fileUploadParams.tipoArchivo = 'FAT';
            this.fileUploadParams.codCliente = this.codCliente;
            this.fileUploadParams.docEmpresa = this.docEmpresa;
            this.fileUploadParams.codTipoPortal = this.codTpoPortal;
            if (this.codTpoPortal == 'COMERCIO') {
                this.fileUploadParams.codEmpresa = this.codEmpresaPac;
                this.fileUploadParams.codConvenio = this.idConvenioSelect;
            }
            else {
                this.fileUploadParams.codEmpresa = this.firstFormGroup.get('comercio').value.split(',')[0];
                this.fileUploadParams.codConvenio = this.firstFormGroup.get('comercio').value.split(',')[1];
            }
            console.log("CodEmpresa " + this.fileUploadParams.codEmpresa + " codConvenio " + this.fileUploadParams.codConvenio);
            this.fileUploadParams.file = file;
            this.fileUploadParams.fileName = file.name;
            this.colapse = 1;
        }
        else {
            this.showDialog('Error', 'El archivo no es válido.<br>Inténtelo con otro.', false);
            this.resetForm();
        }
    };
    /**
     * @return {?}
     */
    FacturacionComponent.prototype.uploadAll = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.firstFormGroup.valid) {
            this.loader.show();
            this.fileUploadParams.codConvenio = this.idConvenioSelect;
            this.uploader.postFile(this.fileUploadParams).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                if (data.codret == '0' || data.codret == '12') {
                    _this.loader.hide();
                    _this.colapse = 0;
                    _this.nombreArchivo = data.nombreArchivo;
                    _this.fechaIngreso = data.fechaIngreso;
                    _this.codEstado = data.codEstado;
                    _this.resetForm();
                    if (_this.codTpoPortal != 'COMERCIO') {
                        _this.comercioValido = 0;
                    }
                    sessionStorage.setItem('componenteHijo', 'facturacionHistorialDetalle');
                    sessionStorage.setItem('cargaFactToHistorial', JSON.stringify({
                        nombreArchivo: _this.nombreArchivo
                    }));
                    _this.peticionCargaAddAuditoria.codCliente = _this.codCliente;
                    _this.peticionCargaAddAuditoria.idUsuario = _this.idUsuario;
                    _this.peticionCargaAddAuditoria.docEmpresa = _this.docEmpresaSelect;
                    _this.peticionCargaAddAuditoria.codTpoPortal = _this.codTpoPortal;
                    _this.peticionCargaAddAuditoria.nombreArchivo = _this.nombreArchivo;
                    _this.peticionCargaAddAuditoria.nomEmpresaCargo = _this.nomEmpresaCargo;
                    _this.peticionCargaAddAuditoria.tipoCarga = 'FAT';
                    _this.postCargaAddAuditoriaServices(_this.peticionCargaAddAuditoria);
                    _this.showDialog('Información', data.descret, false);
                }
                else {
                    _this.loader.hide();
                    _this.colapse = 1;
                    _this.resetForm();
                    _this.showDialog('Error', data.descret + '<br>Inténtelo nuevamente.', false);
                }
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function (err) {
                _this.loader.hide();
                console.log('Error: ', err);
                _this.showDialog('Error', 'Ocurrió un error en servicio al subir archivo.<br>Inténtelo más tarde.', false);
            }));
        }
        else {
            if (this.codTpoPortal != 'COMERCIO') {
                this.showDialog('Error', 'Seleccione una Empresa y agrege un archivo antes de cargar.', false);
            }
            else {
                this.showDialog('Error', 'Seleccione un Convenio y agrege un archivo antes de cargar.', false);
            }
        }
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionComponent.prototype.postCargaAddAuditoriaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        this.facturacionService.postCargaAddAuditoria(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                console.log('Información: ', data.descret);
            }
            else {
                console.log('Error: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.log('Error: ', err);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    FacturacionComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @return {?}
     */
    FacturacionComponent.prototype.resetForm = /**
     * @return {?}
     */
    function () {
        this.firstFormGroup.get('archivo').reset();
        this.fileUploadParams = new FileUploadParams();
    };
    /**
     * @private
     * @param {?} file
     * @return {?}
     */
    FacturacionComponent.prototype.detectEncoding = /**
     * @private
     * @param {?} file
     * @return {?}
     */
    function (file) {
        /** @type {?} */
        var result = new Subject();
        /** @type {?} */
        var reader = new FileReader();
        reader.onloadend = (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            /** @type {?} */
            var codes = new Uint8Array((/** @type {?} */ (reader.result)));
            /** @type {?} */
            var detectedEncoding = Encoding.detect(codes);
            result.next(detectedEncoding);
        });
        reader.readAsArrayBuffer(file);
        return result.asObservable();
    };
    FacturacionComponent.decorators = [
        { type: Component, args: [{
                    selector: 'carga',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-main\" *ngIf=\"show\">\r\n      <form [formGroup]=\"firstFormGroup\" method=\"post\" autocomplete=\"off\">\r\n        <div class=\"form-row\">\r\n          <div class=\"col-md-6\">\r\n            <mat-form-field *ngIf=\"comboComercio\">\r\n              <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"comercio\" (selectionChange)=\"onComercioSelect($event)\">\r\n                <mat-option class=\"multiline-mat-option\" *ngFor=\"let comercio of resultadoEmpresa\" [value]=\"comercio.codFacturador + ',' + comercio.idConvenio + ',' + comercio.docFacturador\">{{comercio.nomFacturador}}: {{comercio.descConvenio}}</mat-option>\r\n              </mat-select>\r\n              <mat-error *ngIf=\"firstFormGroup.get('comercio').invalid\">Este campo es requerido.</mat-error>\r\n            </mat-form-field>\r\n            <mat-form-field *ngIf=\"!comboComercio\">\r\n              <mat-select matNativeControl placeholder=\"Convenio\" formControlName=\"convenio\" (selectionChange)=\"onComercioSelect($event)\">\r\n                <mat-option *ngFor=\"let comercio of resultadoEmpresa\" [value]=\"comercio.codFacturador + ',' + comercio.idConvenio + ',' + comercio.docFacturador\">{{comercio.nomFacturador}}: {{comercio.descConvenio}}</mat-option>\r\n              </mat-select>\r\n              <mat-error *ngIf=\"firstFormGroup.get('comercio').invalid\">Este campo es requerido.</mat-error>\r\n            </mat-form-field>\r\n          </div>\r\n          <div class=\"col-md-6 subir-archivos align-right\">\r\n            <button class=\" btn out btn-small out\"  [disabled]=\"isDisableAgregarArchivo\" (click)=\"fileInput.click()\"><i class=\"str-icon-nuevo-documento\"></i> Agregar archivo</button>\r\n            <input type=\"file\" style=\"display:none\" #fileInput (change)=\"addToQueue($event.target.files)\" formControlName=\"archivo\" accept=\".txt, .csv\" />\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"table-container table-responsive-md\">\r\n          <table class=\"table\">\r\n            <thead>\r\n              <tr>\r\n                <th scope=\"col\">Archivo de facturaci&oacute;n</th>\r\n                <th scope=\"col\"></th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <tr>\r\n                <td>{{ fileUploadParams.fileName }}</td>\r\n                <td class=\"text-right\">\r\n                  <a tooltip=\"Eliminar archivo\" (click)=\"resetForm()\">\r\n                    <i class=\"icon str-icon-trash\" style=\"cursor: pointer;\"></i>\r\n                  </a>\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col align-right\">\r\n            <button class=\"btn main\" type=\"button\" data-toggle=\"collapse\" data-target=\"#historiall\" (click)=\"uploadAll()\">Cargar Archivo</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n\r\n    <div *ngIf=\"colapse == 0\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"archivos-cargados\">\r\n        <div class=\"table-container table-responsive-md\">\r\n          <div class=\"mensaje-box\">\r\n            <div class=\"aviso-carga\">\r\n              <div class=\"row\">\r\n                <div class=\"col-md-8 align-left\">\r\n                  <i class=\"icon str-icon-ok\"></i>\r\n                  <span class=\"valign\" style=\"font-weight: bold;\">Archivo(s) agregado(s). Ver estado de procesamiento en pesta\u00F1a Historial.</span>\r\n                </div>\r\n                <div class=\"col-md-4 align-right\">\r\n                  <a [routerLink]=\"['../historial']\" [queryParams]=\"{busqueda:'true'}\" class=\"btn-small secundario\">Ir a Historial</a>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <table class=\"table\">\r\n            <thead>\r\n              <tr>\r\n                <th scope=\"col\">Estado</th>\r\n                <th scope=\"col\">Nombre</th>\r\n                <th scope=\"col\">Fecha de ingreso</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <tr>\r\n                <td>\r\n                    <span *ngIf=\"codEstado == 'ING' \"class=\"databar ingresado\">Ingresado</span>\r\n                    <span *ngIf=\"codEstado == 'AUT' \"class=\"databar pendiente\">En autorizaci&oacute;n</span>\r\n                </td>\r\n                <td>{{nombreArchivo}}</td>\r\n                <td>{{fechaIngreso | date:'dd/MM/yyyy HH:mm'}}</td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div *ngIf=\"mensajeError == 1\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" id=\"modal-basic-title\" style=\"color:#ec0000;font-weight: bold\">Error</h3>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <p>Servicio temporalmente no disponible.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [{ provide: MAT_DATE_LOCALE$2, useValue: 'es-ES' },
                        { provide: DateAdapter$2, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE$2] },
                        { provide: MAT_DATE_FORMATS$2, useValue: ɵ0$7 }, DatePipe]
                }] }
    ];
    /** @nocollapse */
    FacturacionComponent.ctorParameters = function () { return [
        { type: EmpresasService },
        { type: FileUploadService },
        { type: MatDialog },
        { type: LoaderBaseService },
        { type: DatePipe },
        { type: FacturacionHistorialService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return FacturacionComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AnulacionPeticionReporte = /** @class */ (function () {
    function AnulacionPeticionReporte() {
        this.idArchivo = '';
        this.tipoArchivo = '';
        this.codCliente = '';
        this.idUsuario = '';
        this.docEmpresa = '';
        this.codTpoPortal = '';
    }
    return AnulacionPeticionReporte;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FacturacionHistorialPeticion = /** @class */ (function () {
    function FacturacionHistorialPeticion() {
        this.fechaInicioIngreso = '01/01/2000';
        this.fechaFinIngreso = '01/01/2000';
        this.fechaInicioProceso = '01/01/2000';
        this.fechaFinProceso = '01/01/2000';
        this.estadoFacturacion = '-1';
        this.keyWord = '-1';
        this.idFacturador = '-1';
        this.codtipoArchivo = 'FAT';
        this.codTpoPortal = '-1';
        this.idConvenio = '-1';
        this.codCliente = '-1';
        this.filtros = [];
    }
    return FacturacionHistorialPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$8 = MAT_MOMENT_DATE_FORMATS;
var FacturacionHistorialComponent = /** @class */ (function () {
    function FacturacionHistorialComponent(loader, empresasService, facturacionHistorialService, descargaExcelPdfFileService, dialog, formBuilder, datepipe, route, environment) {
        this.loader = loader;
        this.empresasService = empresasService;
        this.facturacionHistorialService = facturacionHistorialService;
        this.descargaExcelPdfFileService = descargaExcelPdfFileService;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.datepipe = datepipe;
        this.route = route;
        this.environment = environment;
        this.fechaInicioIngreso = '01/01/2000';
        this.fechaFinIngreso = '01/01/2000';
        this.fechaInicioProceso = '01/01/2000';
        this.fechaFinProceso = '01/01/2000';
        // Vistas variables
        this.vistaCantidad = 0;
        this.vistaComercio = 'Todos';
        this.vistaEstado = 'Todos';
        this.hashCaminoMiga = [];
        this.peticionReporte = new FacturacionHistorialPeticion();
        this.peticionEmpresa = new EmpresasPeticion();
        this.resultadoEmpresa = [];
        this.resultadoEstado = [];
        this.comboComercio = false;
        this.peticionAnulacion = new AnulacionPeticionReporte();
        this.mensajeError = -1;
        this.isCollapsed = false;
        this.consulta = -1;
        /** @type {?} */
        var fecha = new Date();
        /** @type {?} */
        var manhana = fecha.setDate(fecha.getDate() + 1);
        /** @type {?} */
        var fechaFormat = this.datepipe.transform(manhana, 'yyyy-MM-dd');
        this.unavailabilityForm = this.formBuilder.group({
            endDate: [fechaFormat + 'T00:00:00.000Z']
        });
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        //this.codTpoPortal = 'ADQUIRENTE';
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idEmpresaPac = this.userPerfil.empresa.idEmpresaPac;
        //this.idEmpresaPac = 0;
        this.idUsuario = this.userPerfil.usuario.idUsuario;
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
        this.codCliente = this.environment.codCliente;
    }
    /**
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (sessionStorage.getItem('componenteHijo') != 'facturacionHistorialDetalle' && sessionStorage.getItem('facanular') != 'true') {
            sessionStorage.removeItem('indice');
        }
        this.peticionReporte.fechaInicioIngreso = '01/01/2000';
        this.peticionReporte.fechaFinIngreso = '01/01/2000';
        this.peticionReporte.fechaInicioProceso = '01/01/2000';
        this.peticionReporte.fechaFinProceso = '01/01/2000';
        this.peticionReporte.keyWord = '-1';
        this.peticionReporte.codtipoArchivo = 'FAT';
        this.peticionReporte.idConvenio = '-1';
        this.formGroup = new FormGroup({
            keyWord: new FormControl(),
            estado: new FormControl('-1'),
            fechaIngreso: new FormControl(),
            fechaProceso: new FormControl(),
            comercio: new FormControl('-1' + ',' + '-1')
        });
        if (this.codTpoPortal == 'COMERCIO') {
            this.comboComercio = false;
            this.formGroup.controls['comercio'].disable();
            this.peticionReporte.idFacturador = this.idEmpresaPac;
            this.displayedColumns = ['fechaIngreso', 'fechaProceso', 'nombreArchivo', 'cantidadRegistros', 'montoArchivo', 'dscEstado', 'detalle', 'anular'];
        }
        else {
            this.comboComercio = true;
            this.formGroup.controls['comercio'].enable();
            this.peticionReporte.idFacturador = "-1";
            this.displayedColumns = ['fechaIngreso', 'fechaProceso', 'nombreArchivo', 'nombreFacturador', 'cantidadRegistros', 'montoArchivo', 'dscEstado', 'detalle', 'anular'];
            this.peticionEmpresa.codCliente = this.environment.codCliente;
            this.peticionEmpresa.codEstadoConvenio = 'HBL';
            this.postSentEmpresaServices(this.peticionEmpresa);
            //this.postSentSelectEmpresasServices(this.peticionEmpresa);
        }
        this.postSentEstadoServices();
        this.consulta = -1;
        if (sessionStorage.getItem('componenteHijo') == 'facturacionHistorialDetalle') {
            this.consulta = 0;
            //Solo cuando se carga el archivo de facturación y despues se va al historial
            if (sessionStorage.getItem('cargaFactToHistorial')) {
                /** @type {?} */
                var cargaFactToHistorial = JSON.parse(sessionStorage.getItem('cargaFactToHistorial'));
                this.formGroup.controls['keyWord'].setValue(cargaFactToHistorial.nombreArchivo);
                this.onSubmit('');
            }
            else {
                // Cuando se regresa del detalle de la facturación
                /** @type {?} */
                var llamadaPadre = JSON.parse(sessionStorage.getItem('llamadaPadre'));
                // Llena los filtros
                this.formGroup.controls['fechaIngreso'].setValue(llamadaPadre.filtroIngresoI);
                this.formGroup.controls['fechaProceso'].setValue(llamadaPadre.filtroProcesoD);
                this.fechaInicioIngreso = llamadaPadre.fechaInicioIngreso;
                this.fechaFinIngreso = llamadaPadre.fechaFinIngreso;
                this.fechaInicioProceso = llamadaPadre.fechaInicioProceso;
                this.fechaFinProceso = llamadaPadre.fechaFinProceso;
                this.formGroup.controls['estado'].setValue(llamadaPadre.estadoFacturacion);
                this.formGroup.controls['keyWord'].setValue((llamadaPadre.keyWord != '-1' ? llamadaPadre.keyWord : ''));
                this.formGroup.controls['comercio'].setValue(llamadaPadre.idFacturador + ',' + llamadaPadre.idConvenio);
                // Llena camino de migas
                /** @type {?} */
                var migasPadre = JSON.parse(sessionStorage.getItem('migasPadre'));
                this.vistaEstado = migasPadre.estadoFacturacion;
                this.hashCaminoMiga[0] = { title: 'Fecha Ingreso', text: migasPadre.fechaIngreso };
                this.hashCaminoMiga[1] = { title: 'Fecha Proceso', text: migasPadre.fechaProceso };
                this.hashCaminoMiga[2] = { title: 'Estado', text: migasPadre.estadoFacturacion };
                this.hashCaminoMiga[3] = { title: 'Nombre', text: migasPadre.keyWord };
                if (this.codTpoPortal != 'COMERCIO') {
                    this.vistaComercio = migasPadre.facturador;
                    this.hashCaminoMiga[4] = { title: 'Empresa', text: migasPadre.facturador };
                }
                // Llama al servicio
                this.peticionReporte.codTpoPortal = llamadaPadre.codTpoPortal;
                this.peticionReporte.fechaInicioIngreso = llamadaPadre.fechaInicioIngreso;
                this.peticionReporte.fechaFinIngreso = llamadaPadre.fechaFinIngreso;
                this.peticionReporte.fechaInicioProceso = llamadaPadre.fechaInicioProceso;
                this.peticionReporte.fechaFinProceso = llamadaPadre.fechaFinProceso;
                this.peticionReporte.estadoFacturacion = llamadaPadre.estadoFacturacion;
                this.peticionReporte.keyWord = llamadaPadre.keyWord;
                this.peticionReporte.idFacturador = llamadaPadre.idFacturador;
                this.peticionReporte.idConvenio = llamadaPadre.idConvenio;
                this.postSentReportServices(this.peticionReporte);
            }
        }
        else {
            this.setInitialBreadcrumbs();
        }
    };
    /**
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.setInitialBreadcrumbs = /**
     * @return {?}
     */
    function () {
        this.hashCaminoMiga[0] = { title: 'Fecha Ingreso', text: 'Todos' };
        this.hashCaminoMiga[1] = { title: 'Fecha Proceso', text: 'Todos' };
        this.hashCaminoMiga[2] = { title: 'Estado', text: 'Todos' };
        this.hashCaminoMiga[3] = { title: 'Nombre', text: '' };
        if (this.codTpoPortal != 'COMERCIO') {
            this.hashCaminoMiga[4] = { title: 'Empresa', text: 'Todas' };
        }
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.consulta = 0;
        this.peticionReporte.codTpoPortal = this.codTpoPortal;
        this.filtroIngresoI = this.formGroup.get('fechaIngreso').value;
        if (this.filtroIngresoI != null) {
            this.peticionReporte.fechaInicioIngreso = formatDate(this.filtroIngresoI.begin, 'dd/MM/yyyy', 'en-US');
            this.peticionReporte.fechaFinIngreso = formatDate(this.filtroIngresoI.end, 'dd/MM/yyyy', 'en-US');
            this.hashCaminoMiga[0] = { title: 'Fecha Ingreso', text: this.fechaInicioIngreso + ' - ' + this.fechaFinIngreso };
        }
        else {
            this.hashCaminoMiga[0] = { title: 'Fecha Ingreso', text: 'Todos' };
            this.peticionReporte.fechaInicioIngreso = this.fechaInicioIngreso;
            this.peticionReporte.fechaFinIngreso = this.fechaFinIngreso;
        }
        this.filtroProcesoD = this.formGroup.get('fechaProceso').value;
        if (this.filtroProcesoD != null) {
            this.peticionReporte.fechaInicioProceso = formatDate(this.filtroProcesoD.begin, 'dd/MM/yyyy', 'en-US');
            this.peticionReporte.fechaFinProceso = formatDate(this.filtroProcesoD.end, 'dd/MM/yyyy', 'en-US');
            this.hashCaminoMiga[1] = { title: 'Fecha Proceso', text: this.fechaInicioProceso + ' - ' + this.fechaFinProceso };
        }
        else {
            this.hashCaminoMiga[1] = { title: 'Fecha Proceso', text: 'Todos' };
            this.peticionReporte.fechaInicioProceso = this.fechaInicioProceso;
            this.peticionReporte.fechaFinProceso = this.fechaFinProceso;
        }
        if (this.formGroup.get('estado').value == null) {
            this.peticionReporte.estadoFacturacion = '-1';
            this.hashCaminoMiga[2] = { title: 'Estado', text: 'Todos' };
        }
        else {
            this.peticionReporte.estadoFacturacion = this.formGroup.get('estado').value;
            this.hashCaminoMiga[2] = { title: 'Estado', text: this.vistaEstado };
        }
        if (this.formGroup.get('keyWord').value == null) {
            this.peticionReporte.keyWord = '-1';
            this.hashCaminoMiga[3] = { title: 'Nombre', text: '' };
        }
        else {
            this.peticionReporte.keyWord = this.formGroup.get('keyWord').value;
            this.hashCaminoMiga[3] = { title: 'Nombre', text: this.formGroup.get('keyWord').value };
        }
        if (this.codTpoPortal == 'COMERCIO') {
            this.peticionReporte.idFacturador = this.idEmpresaPac;
        }
        else {
            /** @type {?} */
            var idFacturador = this.formGroup.get('comercio').value.split(",")[0];
            if (idFacturador == null || idFacturador == '' || idFacturador == -1) {
                this.peticionReporte.idFacturador = '-1';
                this.peticionReporte.idConvenio = '-1';
                this.hashCaminoMiga[4] = { title: 'Empresa', text: 'Todas' };
            }
            else {
                this.peticionReporte.idFacturador = this.formGroup.get('comercio').value.split(",")[0];
                this.peticionReporte.idConvenio = this.formGroup.get('comercio').value.split(",")[1];
                this.hashCaminoMiga[4] = { title: 'Empresa', text: this.vistaComercio };
            }
        }
        sessionStorage.setItem('llamadaPadre', JSON.stringify({
            codTpoPortal: this.peticionReporte.codTpoPortal,
            fechaInicioIngreso: this.peticionReporte.fechaInicioIngreso,
            fechaFinIngreso: this.peticionReporte.fechaFinIngreso,
            fechaInicioProceso: this.peticionReporte.fechaInicioProceso,
            fechaFinProceso: this.peticionReporte.fechaFinProceso,
            estadoFacturacion: this.peticionReporte.estadoFacturacion,
            keyWord: this.peticionReporte.keyWord,
            idFacturador: this.peticionReporte.idFacturador,
            idConvenio: this.peticionReporte.idConvenio,
            filtroIngresoI: this.filtroIngresoI,
            filtroProcesoD: this.filtroProcesoD
        }));
        sessionStorage.setItem('migasPadre', JSON.stringify({
            fechaIngreso: this.hashCaminoMiga[0].text,
            fechaProceso: this.hashCaminoMiga[1].text,
            estadoFacturacion: this.hashCaminoMiga[2].text,
            keyWord: this.hashCaminoMiga[3].text,
            facturador: (this.codTpoPortal != 'COMERCIO' ? this.hashCaminoMiga[4].text : '')
        }));
        if (tipo == 'excel' || tipo == 'pdf') {
            this.peticionReporte.filtros = this.hashCaminoMiga;
            this.peticionReporte.codCliente = this.environment.codCliente;
            this.postDownloadReportFile(this.peticionReporte, tipo);
        }
        else {
            this.postSentReportServices(this.peticionReporte);
        }
        // //Busqueda del parametro para hacer una busqueda
        // this.route.queryParams.subscribe(parametro =>{
        //   if(parametro.busqueda=='true')
        //   {
        //     this.onSubmit('');
        //   }
        // });
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiFacturasMT/historialArchivos/' + tipo;
        this.descargaExcelPdfFileService.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'historialFacturacion' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'historialFacturacion' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.onPaginateChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var indice = this.paginator.pageIndex;
        sessionStorage.setItem('indice', indice);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.postSentReportServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.show = true;
        this.facturacionHistorialService.postHistorialArchivos(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.vistaCantidad = data.resultado.length;
                if (_this.paginator != undefined && sessionStorage.getItem('componenteHijo') == 'facturacionHistorialDetalle') {
                    _this.paginator.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indice')))));
                }
                else if (_this.paginator != undefined && sessionStorage.getItem('facanular') == 'true') {
                    _this.paginator.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indice')))));
                }
                else if (_this.paginator != undefined) {
                    _this.paginator.pageIndex = 0;
                    sessionStorage.removeItem("indice");
                }
                sessionStorage.removeItem('facanular');
                sessionStorage.removeItem('componenteHijo');
                _this.dataSource = new MatTableDataSource$1(data.resultado);
                _this.dataSource.paginator = _this.paginator;
                if (_this.vistaCantidad == 0) {
                    _this.show = false;
                    _this.isCollapsed = false;
                }
                else {
                    _this.isCollapsed = true;
                }
                _this.mensajeError = 0;
                _this.loader.hide();
            }
            else {
                console.error('Error HistorialFacturacion', data.descret);
                _this.show = false;
                _this.mensajeError = 1;
                _this.loader.hide();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            _this.mensajeError = 1;
            _this.loader.hide();
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.empresasService.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var emp = new EmpresaResult();
                emp.docFacturador = '-1';
                emp.idFacturador = -1;
                emp.idConvenio = '-1';
                emp.nomFacturador = 'Todas';
                data.resultado.splice(0, 0, emp);
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.error('Error postSentEmpresaServices', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postSentEmpresaServices', err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.postSentSelectEmpresasServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.empresasService.postListarSelectEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var emp = new EmpresaResult();
                emp.nomFacturador = "Todas";
                emp.idFacturador = -1;
                data.resultado.splice(0, 0, emp);
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.error('Error postSentSelectEmpresasServices', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postSentSelectEmpresasServices', err);
        }));
    };
    /**
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.postSentEstadoServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.facturacionHistorialService.postListarEstadoArchivos().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var estado = new EstadoArchivosResult();
                estado.codigo = "-1";
                estado.descripcion = "Todos";
                data.resultado.splice(0, 0, estado);
                _this.resultadoEstado = data.resultado;
            }
            else {
                console.error('Error postSentEstadoServices', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postSentEstadoServices', err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.onEstadoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEstado = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.onComercioSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaComercio = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} idArchivo
     * @param {?} docEmpresa
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.anularFactura = /**
     * @param {?} idArchivo
     * @param {?} docEmpresa
     * @return {?}
     */
    function (idArchivo, docEmpresa) {
        this.peticionAnulacion.codCliente = this.codCliente;
        this.peticionAnulacion.idUsuario = this.idUsuario;
        this.peticionAnulacion.docEmpresa = docEmpresa;
        this.peticionAnulacion.codTpoPortal = this.codTpoPortal;
        this.peticionAnulacion.idArchivo = idArchivo;
        this.peticionAnulacion.tipoArchivo = 'FAT';
        this.showDialogAnular('Información', 'Si realiza esta acción, se anulará el proceso.<br>¿Está seguro de esta acción?', true);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.postAnularFacturaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.facturacionHistorialService.postAnularFactura(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.showDialog('Información', 'El proceso se ha anulado de forma satisfactoria.', false);
                _this.onSubmit('');
            }
            else {
                _this.showDialog('Error', 'No ha sido posible anular el proceso.<br>Inténtelo nuevamente.', false);
                console.error('Error postAnularFacturaServices', data.descret);
            }
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
            console.error('Error postAnularFacturaServices', error);
        }));
    };
    /**
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        //Ingreso
        this.fechaInicioIngreso = '01/01/2000';
        this.fechaFinIngreso = '01/01/2000';
        //Proceso
        this.fechaInicioProceso = '01/01/2000';
        this.fechaFinProceso = '01/01/2000';
        this.peticionReporte.estadoFacturacion = '-1';
        this.peticionReporte.keyWord = '-1';
        this.peticionReporte.idConvenio = '-1';
        this.formGroup.get('fechaIngreso').setValue(null);
        this.formGroup.get('fechaProceso').setValue(null);
        this.formGroup.get('keyWord').setValue('');
        this.dataSource = new MatTableDataSource$1([]);
        this.show = false;
        this.vistaCantidad = 0;
        this.mensajeError = -1;
        this.consulta = -1;
        this.formGroup.controls.estado.setValue('-1');
        this.formGroup.controls.comercio.reset('-1' + ',' + '-1');
        this.setInitialBreadcrumbs();
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.showDialogAnular = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            if (result) {
                sessionStorage.setItem('facanular', 'true');
                _this.postAnularFacturaServices(_this.peticionAnulacion);
            }
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.selectFechaIngreso = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.fechaInicioIngreso = formatDate(event.value.begin, 'dd/MM/yyyy', 'en-US');
        this.fechaFinIngreso = formatDate(event.value.end, 'dd/MM/yyyy', 'en-US');
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.selectFechaProceso = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.fechaInicioProceso = formatDate(event.value.begin, 'dd/MM/yyyy', 'en-US');
        this.fechaFinProceso = formatDate(event.value.end, 'dd/MM/yyyy', 'en-US');
    };
    /**
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.onSubmit('');
        }
    };
    /**
     * @param {?} param1
     * @param {?} param2
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.valorSelectEmpresa = /**
     * @param {?} param1
     * @param {?} param2
     * @return {?}
     */
    function (param1, param2) {
        return param2 == "" ? param1 : param1 + ": " + param2;
    };
    /**
     * @param {?} resul
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.formateandoMonto = /**
     * @param {?} resul
     * @return {?}
     */
    function (resul) {
        return FormatoMonedaUtil.formatearMonto(resul);
    };
    /**
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('componenteHijo');
        sessionStorage.removeItem('cargaFactToHistorial');
    };
    /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    FacturacionHistorialComponent.prototype.getEmpresaConvenio = /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    function (nomFacturador, descConvenio) {
        return descConvenio != "" ? nomFacturador + ": " + descConvenio : nomFacturador;
    };
    FacturacionHistorialComponent.decorators = [
        { type: Component, args: [{
                    selector: 'facturacionHistorial',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"modulo-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n      </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"formGroup\" autocomplete=\"off\">\r\n              <div class=\"form-row align-left\">\r\n                <div class=\"col-md-6\">\r\n                  <div class=\"filtro-fecha\">\r\n                    <button type=\"button\" class=\"btn fecha\" (click)=\"picker1.open()\"><i class=\"str-icon-calendario\"></i> Buscar por fecha de ingreso\r\n                      <ng-container *ngIf=\"this.formGroup.get('fechaIngreso').value != null && this.fechaInicioIngreso != '01/01/2000'\">\r\n                        <span>{{ this.fechaInicioIngreso + ' - ' + this.fechaFinIngreso }}</span>\r\n                      </ng-container>\r\n                    </button>\r\n                    <mat-form-field style=\"display: none;\">\r\n                      <input matInput placeholder=\"Fecha\" [max]=\"unavailabilityForm.controls.endDate.value\" [satDatepicker]=\"picker1\" formControlName=\"fechaIngreso\" (dateInput)=\"selectFechaIngreso($event)\">\r\n                      <sat-datepicker-toggle matSuffix [for]=\"picker1\"></sat-datepicker-toggle>\r\n                      <sat-datepicker touchUi #picker1 [rangeMode]=\"true\" [selectFirstDateOnClose]=\"true\"></sat-datepicker>\r\n                    </mat-form-field>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                  <div class=\"filtro-fecha\">\r\n                    <button type=\"button\" class=\"btn fecha\" (click)=\"picker2.open()\"><i class=\"str-icon-calendario\"></i> Buscar por fecha de proceso\r\n                      <ng-container *ngIf=\"this.formGroup.get('fechaProceso').value != null && this.fechaInicioProceso != '01/01/2000' \">\r\n                        <span>{{ this.fechaInicioProceso + ' - ' + this.fechaFinProceso }}</span>\r\n                      </ng-container>\r\n                    </button>\r\n                    <mat-form-field style=\"display: none;\">\r\n                      <input matInput placeholder=\"Fecha\" [max]=\"unavailabilityForm.controls.endDate.value\" [satDatepicker]=\"picker2\" formControlName=\"fechaProceso\" (dateInput)=\"selectFechaProceso($event)\">\r\n                      <sat-datepicker-toggle matSuffix [for]=\"picker2\"></sat-datepicker-toggle>\r\n                      <sat-datepicker touchUi #picker2 [rangeMode]=\"true\" [selectFirstDateOnClose]=\"true\"></sat-datepicker>\r\n                    </mat-form-field>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-row\">\r\n                <div class=\"form-group col-sm-3\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estado\" (selectionChange)=\"onEstadoSelect($event)\">\r\n                      <mat-option *ngFor=\"let estado of resultadoEstado\" [value]=\"estado.codigo\">{{estado.descripcion}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-sm-5\">\r\n                  <mat-form-field>\r\n                    <input noCaracEsp matInput maxlength=\"50\" placeholder=\"Nombre\" formControlName=\"keyWord\">\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-sm-4\" *ngIf=\"comboComercio\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"comercio\" (selectionChange)=\"onComercioSelect($event)\">\r\n                      <mat-option class=\"multiline-mat-option\" *ngFor=\"let comercio of resultadoEmpresa\" [value]=\"comercio.idFacturador + ',' + comercio.idConvenio\">{{getEmpresaConvenio(comercio.nomFacturador, comercio.descConvenio)}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"actions\">\r\n                <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\" (click)=\"validarForm()\">Filtrar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"resultados-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-10\">\r\n          <div class=\"tags row\">\r\n            <div *ngFor=\"let entry of hashCaminoMiga\" class=\"item\">{{entry.title}}: {{entry.text}}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n          <div class=\"numero-resultados\">\r\n            <strong>{{ (vistaCantidad == 1) ? ( vistaCantidad + \" Resultado\") : vistaCantidad + \" Resultados\" }}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-container table-responsive-md\">\r\n        <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n          <ng-container matColumnDef=\"dscEstado\">\r\n            <th mat-header-cell *matHeaderCellDef>Estado</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.codEstado == 'ING'\" class=\"databar ingresado\">{{resultado.dscEstado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'COB'\" class=\"databar encobro\">{{resultado.dscEstado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'PRO'\" class=\"databar procesado\">{{resultado.dscEstado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'RCH'\" class=\"databar rechazado\">{{resultado.dscEstado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'RAU'\" class=\"databar rechazado\">{{resultado.dscEstado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'ANL'\" class=\"databar eliminado\">{{resultado.dscEstado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'AUT'\" class=\"databar pendiente\">{{resultado.dscEstado}}</span>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"nombreArchivo\">\r\n            <th mat-header-cell *matHeaderCellDef>Nombre</th>\r\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\"> {{resultado.nombreArchivo}}\r\n              <br>\r\n              <span *ngIf=\"resultado.codEstado == 'RCH' && resultado.idMotivo != ''\" style=\"font-size: smaller;font-weight: bold;\">Motivo rechazo: {{resultado.descMotivo}}</span>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"nombreFacturador\" *ngIf=\"comboComercio\">\r\n            <th mat-header-cell *matHeaderCellDef>Empresa</th>\r\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\">{{resultado.nombreFacturador}}: {{resultado.descConvenio}}</td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"cantidadRegistros\">\r\n            <th mat-header-cell *matHeaderCellDef>N\u00B0 de registros</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.cantidadRegistros | cantidad}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"montoArchivo\">\r\n            <th mat-header-cell *matHeaderCellDef>Monto</th>\r\n            <td mat-cell *matCellDef=\"let resultado\" style=\"text-align: right;\" >{{formateandoMonto(resultado)}}</td>            \r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fechaIngreso\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha de ingreso</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.fechaIngreso == ''; else elseBlock\">(Pendiente)</span>\r\n              <ng-template #elseBlock>{{resultado.fechaIngreso | date:'dd/MM/yyyy HH:mm'}}</ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fechaProceso\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha de proceso</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.fechaProceso == ''; else elseBlock\">(Pendiente)</span>\r\n              <ng-template #elseBlock>{{resultado.fechaProceso | date:'dd/MM/yyyy'}}</ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"detalle\">\r\n            <th mat-header-cell *matHeaderCellDef>Detalle</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a *ngIf=\"resultado.codEstado != 'ING' && resultado.codEstado != 'RCH'; else noPro\" [routerLink]=\"['../detalle']\" [queryParams]=\"{'a':resultado.idArchivo,'c':resultado.cantidadRegistros,'m':resultado.montoArchivo,'fi':resultado.fechaIngreso,'fp':resultado.fechaProceso,'de':resultado.dscEstado,'cod':resultado.codEstado}\"><i class=\"str-icon-flecha-derecha\"></i></a>\r\n              <ng-template #noPro> - </ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"anular\">\r\n            <th mat-header-cell *matHeaderCellDef>Anular</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a *ngIf=\"resultado.codEstado == 'PRO' && resultado.cobrosRealizados == '0'; else noAnl\" role=\"button\" class=\"item\" (click)=\"anularFactura(resultado.idArchivo, resultado.docEmpresa)\"><i class='icon str-icon-trash' style=\"cursor: pointer;\"></i></a>\r\n              <ng-template #noAnl> - </ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n        </table>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" (page)=\"onPaginateChange($event)\" showFirstLastButtons></mat-paginator>\r\n      </div>\r\n      <div class=\"box-actions\" *ngIf=\"vistaCantidad > 0\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6 item\">\r\n            <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n          </div>\r\n          <div class=\"col-md-6 item-right\">\r\n            <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </section>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"mensajeError == 0 && vistaCantidad == 0\">\r\n      <span>\r\n        No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.\r\n      </span>\r\n    </div>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"consulta == -1\">\r\n      <span>\r\n        Establezca sus criterios de b&uacute;squeda.\r\n      </span>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div *ngIf=\"mensajeError == 1\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" id=\"modal-basic-title\" style=\"color:#ec0000;font-weight: bold\">Error</h3>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <p>Servicio temporalmente no disponible.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [EmpresasService, DescargaExcelPdfFileService,
                        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
                        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
                        { provide: MAT_DATE_FORMATS, useValue: ɵ0$8 }]
                }] }
    ];
    /** @nocollapse */
    FacturacionHistorialComponent.ctorParameters = function () { return [
        { type: LoaderBaseService },
        { type: EmpresasService },
        { type: FacturacionHistorialService },
        { type: DescargaExcelPdfFileService },
        { type: MatDialog },
        { type: FormBuilder },
        { type: DatePipe },
        { type: ActivatedRoute },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    FacturacionHistorialComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator$1,] }]
    };
    return FacturacionHistorialComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FacturacionEstados = /** @class */ (function () {
    function FacturacionEstados() {
        this.idEstado = "";
        this.descripcion = "";
    }
    return FacturacionEstados;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FacturacionHistorialDetallePeticion = /** @class */ (function () {
    function FacturacionHistorialDetallePeticion() {
        this.idArchivo = '-1';
        this.idServicio = '-1';
        this.estadoFacturacion = '-1';
        this.pagina = '0';
        this.codCliente = '';
        this.filtros = [];
    }
    return FacturacionHistorialDetallePeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FacturacionHistorialDetalleComponent = /** @class */ (function () {
    function FacturacionHistorialDetalleComponent(fachisservice, router, route, phttpd, dialog, loader, environment) {
        this.fachisservice = fachisservice;
        this.router = router;
        this.route = route;
        this.phttpd = phttpd;
        this.dialog = dialog;
        this.loader = loader;
        this.environment = environment;
        this.indice = 0;
        this.cantidadRegistros = 0;
        this.peticionReporte = new FacturacionHistorialDetallePeticion();
        this.vistaCantidad = 0;
        this.checkAdicional1 = '';
        this.checkAdicional2 = 'none';
        this.checkAdicional3 = 'none';
        this.checkAdicional4 = 'none';
        this.checkAdicional5 = 'none';
        this.checkAdicional6 = 'none';
        this.checkAdicional7 = 'none';
        this.hashCaminoMiga = [];
        this.vistaEstado = 'Todos';
        this.displayedColumns = ['idServicio', 'montoFacturacion', 'fechaFacturacion', 'estadoFacturacion',
            'descripcion', 'datoAdicional1', 'datoAdicional2', 'datoAdicional3', 'datoAdicional4', 'datoAdicional5', 'datoAdicional6', 'datoAdicional7', 'config'];
    }
    /**
     * @return {?}
     */
    FacturacionHistorialDetalleComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        sessionStorage.setItem('componenteHijo', 'facturacionHistorialDetalle');
        this.route.queryParams.subscribe((/**
         * @param {?} params
         * @return {?}
         */
        function (params) {
            _this.peticionReporte.idArchivo = params['a'];
            _this.idArchivo = params['a'],
                _this.cantidad = params['c'],
                _this.monto = params['m'],
                _this.fechaIngreso = params['fi'],
                _this.fechaProceso = params['fp'],
                _this.descEstado = params['de'],
                _this.codEstado = params['cod'];
        }));
        this.peticionReporte.idServicio = "-1";
        this.peticionReporte.estadoFacturacion = "-1";
        this.firstFormGroup = new FormGroup({
            idServicio: new FormControl(),
            estadoFacturacion: new FormControl('-1'),
        });
        this.postSentEstadoServices();
        this.peticionReporte.codCliente = this.environment.codCliente;
        this.postSentReportServices(this.peticionReporte);
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    FacturacionHistorialDetalleComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.peticionReporte.idArchivo = this.idArchivo;
        if (this.firstFormGroup.get('idServicio').value == null) {
            this.peticionReporte.idServicio = '-1';
            this.hashCaminoMiga[0] = { title: 'ID Servicio', text: '' };
        }
        else {
            /** @type {?} */
            var servicio = this.firstFormGroup.get('idServicio').value;
            this.peticionReporte.idServicio = servicio;
            this.hashCaminoMiga[0] = { title: 'ID Servicio', text: servicio };
        }
        if (this.firstFormGroup.get('estadoFacturacion').value == null) {
            this.peticionReporte.estadoFacturacion = '-1';
            this.hashCaminoMiga[1] = { title: 'Estado', text: 'Todos' };
        }
        else {
            this.peticionReporte.estadoFacturacion = this.firstFormGroup.get('estadoFacturacion').value;
            this.hashCaminoMiga[1] = { title: 'Estado', text: this.vistaEstado };
        }
        if (tipo == 'excel' || tipo == 'pdf') {
            this.peticionReporte.filtros = this.hashCaminoMiga;
            this.postDownloadReportFile(this.peticionReporte, tipo);
        }
        else {
            if (this.paginator != undefined) {
                this.paginator.pageIndex = 0;
            }
            this.peticionReporte.codCliente = this.environment.codCliente;
            this.postSentReportServices(this.peticionReporte);
        }
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionHistorialDetalleComponent.prototype.postSentReportServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        body.pagina = this.indice + 1;
        this.fachisservice.postHistorialDetalle(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoReporte = [];
                _this.resultadoReporte.push(data);
                _this.vistaCantidad = data.resultado.length;
                _this.cantidadRegistros = Number(data.cantRegistros);
                if (_this.cantidadRegistros == 0) {
                    _this.indice = 0;
                }
                if (data.resultado.length > 0) {
                    _this.monto = FormatoMonedaUtil.formatearMonto(data.resultado[0]);
                }
                _this.dataSource = new MatTableDataSource$1(data.resultado);
                _this.loader.hide();
            }
            else {
                _this.loader.hide();
                console.log('Error: ', data.descret);
                _this.showDialogFail('Error', 'Servicio temporalmente no disponible.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            console.log('Error: ', err);
            _this.showDialogFail('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @return {?}
     */
    FacturacionHistorialDetalleComponent.prototype.postSentEstadoServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.fachisservice.postListarEstadoFacturacion().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            console.log(data);
            if (data.codret == '0') {
                /** @type {?} */
                var estados = new FacturacionEstados();
                estados.idEstado = "-1";
                estados.descripcion = "Todos";
                data.resultado.splice(0, 0, estados);
                _this.resultadoEstado = [];
                _this.resultadoEstado.push(data);
            }
            else {
                console.error('Error postSentEstadoServices', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postSentEstadoServices', err);
        }));
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    FacturacionHistorialDetalleComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiFacturasMT/historialDetalle/' + tipo;
        filtro.pagina = "-1";
        this.phttpd.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'historialFacturacionDetalle' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'historialFacturacionDetalle' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @return {?}
     */
    FacturacionHistorialDetalleComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.peticionReporte.idServicio = '-1';
        this.peticionReporte.estadoFacturacion = '-1';
        this.firstFormGroup.controls.estadoFacturacion.setValue('-1');
        this.firstFormGroup.controls.idServicio.setValue('');
        this.indice = 0;
        this.onSubmit('');
    };
    /**
     * @param {?} strField
     * @return {?}
     */
    FacturacionHistorialDetalleComponent.prototype.checkColum = /**
     * @param {?} strField
     * @return {?}
     */
    function (strField) {
        if (strField == 'checkAdicional1') {
            this.checkAdicional1 = (this.checkAdicional1 == 'none') ? '' : 'none';
        }
        if (strField == 'checkAdicional2') {
            this.checkAdicional2 = (this.checkAdicional2 == 'none') ? '' : 'none';
        }
        if (strField == 'checkAdicional3') {
            this.checkAdicional3 = (this.checkAdicional3 == 'none') ? '' : 'none';
        }
        if (strField == 'checkAdicional4') {
            this.checkAdicional4 = (this.checkAdicional4 == 'none') ? '' : 'none';
        }
        if (strField == 'checkAdicional5') {
            this.checkAdicional5 = (this.checkAdicional5 == 'none') ? '' : 'none';
        }
        if (strField == 'checkAdicional6') {
            this.checkAdicional6 = (this.checkAdicional6 == 'none') ? '' : 'none';
        }
        if (strField == 'checkAdicional7') {
            this.checkAdicional7 = (this.checkAdicional7 == 'none') ? '' : 'none';
        }
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    FacturacionHistorialDetalleComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    FacturacionHistorialDetalleComponent.prototype.showDialogFail = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            _this.router.navigate(['../historial'], { relativeTo: _this.route });
        }));
    };
    /**
     * @return {?}
     */
    FacturacionHistorialDetalleComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.firstFormGroup.valid) {
            this.onSubmit('');
        }
    };
    /**
     * @param {?} resul
     * @return {?}
     */
    FacturacionHistorialDetalleComponent.prototype.formateandoMonto = /**
     * @param {?} resul
     * @return {?}
     */
    function (resul) {
        //resul.montoArchivo = resul.montoFacturacion; //Es una trampa para que metodo no se confunda con el monto total    
        return FormatoMonedaUtil.formatearMontoParam(resul.montoFacturacion, resul.tipoMoneda);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FacturacionHistorialDetalleComponent.prototype.onPaginateChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.indice = this.paginator.pageIndex;
        this.onSubmit('');
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FacturacionHistorialDetalleComponent.prototype.onEstadoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEstado = event.source.selected._element.nativeElement.innerText.trim();
    };
    FacturacionHistorialDetalleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'facturacionHistorialDetalle',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"modulo-cuentas detalle\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a [routerLink]=\"['../historial']\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col-2 order-1 order-md-1 col-md-1 icon\">\r\n          <!-- <i class=\"str-icon-recargar\"></i> -->\r\n        </div>\r\n        <div class=\"col-12 order-12 order-md-2 col-md-10 datos\">\r\n          <div class=\"row\">\r\n            <div class=\"item col-4 col-sm-3 col-md-2\">\r\n              <h5>ID Proceso:</h5>\r\n              <p>{{idArchivo}}</p>\r\n            </div>\r\n            <div class=\"item col-4 col-sm-3 col-md-2\">\r\n              <h5>Cantidad:</h5>\r\n              <p>{{cantidad | cantidad}}</p>\r\n            </div>\r\n            <div class=\"item col-4 col-sm-3 col-md-2\">\r\n              <h5>Monto:</h5>\r\n              <p>{{monto}}</p>\r\n            </div>\r\n            <div class=\"item col-4 col-sm-3 col-md-2\">\r\n              <h5>Fecha de ingreso:</h5>\r\n              <p>{{fechaIngreso | date:'dd/MM/yyyy'}}</p>\r\n            </div>\r\n            <div class=\"item col-4 col-sm-3 col-md-2\">\r\n              <h5>Fecha de proceso:</h5>\r\n              <p>{{fechaProceso | date:'dd/MM/yyyy'}}</p>\r\n            </div>\r\n            <div class=\"item col-4 col-sm-3 col-md-2\">\r\n              <h5>Estado del proceso:</h5>\r\n              <span *ngIf=\"codEstado == 'ING'\" class=\"databar ingresado\">{{descEstado}}</span>\r\n              <span *ngIf=\"codEstado == 'COB'\" class=\"databar encobro\">{{descEstado}}</span>\r\n              <span *ngIf=\"codEstado == 'PRO'\" class=\"databar procesado\">{{descEstado}}</span>\r\n              <span *ngIf=\"codEstado == 'RCH'\" class=\"databar rechazado\">{{descEstado}}</span>\r\n              <span *ngIf=\"codEstado == 'RAU'\" class=\"databar rechazado\">{{descEstado}}</span>\r\n              <span *ngIf=\"codEstado == 'ANL'\" class=\"databar eliminado\">{{descEstado}}</span>\r\n              <span *ngIf=\"codEstado == 'AUT'\" class=\"databar pendiente\">{{descEstado}}</span>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"filtros-detalle\">\r\n            <div class=\"box-filtros\">\r\n              <form [formGroup]=\"firstFormGroup\" (ngSubmit)=\"validarForm();\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n                <div class=\"form-row d-flex align-items-center\">\r\n                  <div class=\"col-md-3\">\r\n                    <mat-form-field>\r\n                      <input matInput maxlength=\"20\" placeholder=\"ID Servicio\" formControlName=\"idServicio\">\r\n                    </mat-form-field>\r\n                  </div>\r\n                  <div class=\"col-md-3\">\r\n                    <mat-form-field>\r\n                      <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estadoFacturacion\" (selectionChange)=\"onEstadoSelect($event)\">\r\n                        <section *ngFor=\"let resp of resultadoEstado\">\r\n                          <mat-option *ngFor=\"let estado of resp.resultado\" [value]=\"estado.idEstado\">\r\n                            {{estado.descripcion}}</mat-option>\r\n                        </section>\r\n                      </mat-select>\r\n                    </mat-form-field>\r\n                  </div>\r\n                  <div class=\"col-md-6 align-right\">\r\n                    <div class=\"actions\">\r\n                      <button type=\"button\" class=\"btn-small text\" (click)=\"limpiar()\">Limpiar</button>\r\n                      <button type=\"submit\" class=\"btn-small main\">Filtrar</button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </form>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"table-container detalle table-responsive-lg\" style=\"overflow-x: auto;\">\r\n            <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n              <ng-container matColumnDef=\"idServicio\">\r\n                <th mat-header-cell *matHeaderCellDef>ID Servicio</th>\r\n                <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\"> {{resultado.idServicio}} </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"montoFacturacion\">\r\n                <th mat-header-cell *matHeaderCellDef>Monto</th>\r\n                <td  mat-cell *matCellDef=\"let resultado\">{{formateandoMonto(resultado)}}</td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"fechaFacturacion\">\r\n                <th mat-header-cell *matHeaderCellDef>Fecha para cobro</th>\r\n                <td mat-cell *matCellDef=\"let resultado\">\r\n                  <span *ngIf=\"resultado.fechaFacturacion == null; else elseBlockFecha\"></span>\r\n                  <ng-template #elseBlockFecha>{{resultado.fechaFacturacion | date:'dd/MM/yyyy'}}</ng-template>\r\n                </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"estadoFacturacion\">\r\n                <th mat-header-cell *matHeaderCellDef>Estado del cobro</th>\r\n                <td mat-cell *matCellDef=\"let resultado\"> {{resultado.estadoFacturacion}} </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"descripcion\">\r\n                <th mat-header-cell *matHeaderCellDef>Descripci\u00F3n</th>\r\n                <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\">\r\n                  <span *ngIf=\"resultado.descripcion == 'null'; else elseBlockDesc\">-</span>\r\n                  <ng-template #elseBlockDesc>{{resultado.descripcion}}</ng-template>\r\n                </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"datoAdicional1\">\r\n                <th mat-header-cell *matHeaderCellDef [style.display]=\"checkAdicional1\">Dato Adic.1</th>\r\n                <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\" [style.display]=\"checkAdicional1\">\r\n                  <span *ngIf=\"resultado.datoAdicional1 == 'null' || resultado.datoAdicional1 == null; else elseBlockAdic\">-</span>\r\n                  <ng-template #elseBlockAdic>{{resultado.datoAdicional1}}</ng-template>\r\n                </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"datoAdicional2\">\r\n                <th mat-header-cell *matHeaderCellDef [style.display]=\"checkAdicional2\">Dato Adic.2</th>\r\n                <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\" [style.display]=\"checkAdicional2\">\r\n                  <span *ngIf=\"resultado.datoAdicional2 == 'null' || resultado.datoAdicional2 == null; else elseBlockAdic2\">-</span>\r\n                  <ng-template #elseBlockAdic2>{{resultado.datoAdicional2}}</ng-template>\r\n                </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"datoAdicional3\">\r\n                <th mat-header-cell *matHeaderCellDef [style.display]=\"checkAdicional3\">Dato Adic.3</th>\r\n                <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\" [style.display]=\"checkAdicional3\"><span *ngIf=\"resultado.datoAdicional3 == 'null' || resultado.datoAdicional3 == null; else elseBlockAdic3\">-</span>\r\n                  <ng-template #elseBlockAdic3>{{resultado.datoAdicional3}}</ng-template>\r\n                </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"datoAdicional4\">\r\n                <th mat-header-cell *matHeaderCellDef [style.display]=\"checkAdicional4\">Dato Adic.4</th>\r\n                <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\" [style.display]=\"checkAdicional4\"><span *ngIf=\"resultado.datoAdicional4 == 'null' || resultado.datoAdicional4 == null; else elseBlockAdic4\">-</span>\r\n                  <ng-template #elseBlockAdic4>{{resultado.datoAdicional4}}</ng-template>\r\n                </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"datoAdicional5\">\r\n                <th mat-header-cell *matHeaderCellDef [style.display]=\"checkAdicional5\">Dato Adic.5</th>\r\n                <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\" [style.display]=\"checkAdicional5\"><span *ngIf=\"resultado.datoAdicional5 == 'null' || resultado.datoAdicional5 == null; else elseBlockAdic5\">-</span>\r\n                  <ng-template #elseBlockAdic5>{{resultado.datoAdicional5}}</ng-template>\r\n                </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"datoAdicional6\">\r\n                <th mat-header-cell *matHeaderCellDef [style.display]=\"checkAdicional6\">Dato Adic.6</th>\r\n                <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\" [style.display]=\"checkAdicional6\"><span *ngIf=\"resultado.datoAdicional6 == 'null' || resultado.datoAdicional6 == null; else elseBlockAdic6\">-</span>\r\n                  <ng-template #elseBlockAdic6>{{resultado.datoAdicional6}}</ng-template>\r\n                </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"datoAdicional7\">\r\n                <th mat-header-cell *matHeaderCellDef [style.display]=\"checkAdicional7\">Dato Adic.7</th>\r\n                <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\" [style.display]=\"checkAdicional7\"><span *ngIf=\"resultado.datoAdicional7 == 'null' || resultado.datoAdicional7 == null; else elseBlockAdic7\">-</span>\r\n                  <ng-template #elseBlockAdic7>{{resultado.datoAdicional7}}</ng-template>\r\n                </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"config\">\r\n                <th class=\"field-selector\" mat-header-cell *matHeaderCellDef>\r\n                  <div class=\"col\">\r\n                    <ng-template #popContent>\r\n                      <strong><span>Columnas<br></span></strong>\r\n                      <div class=\"dropdown-divider\"></div>\r\n                      <div class=\"form-check form-check-inline\">\r\n                        <mat-checkbox class=\"example-margin\" [checked]=\"true\" [disabled]=\"true\">Servicio</mat-checkbox>\r\n                      </div>\r\n                      <div class=\"form-check form-check-inline\">\r\n                        <mat-checkbox class=\"example-margin\" (click)=\"checkColum('checkAdicional1')\" [checked]=\"checkAdicional1 == ''\">Dato Adic.1</mat-checkbox>\r\n                      </div>\r\n                      <div class=\"form-check form-check-inline\">\r\n                        <mat-checkbox class=\"example-margin\" (click)=\"checkColum('checkAdicional2')\" [checked]=\"checkAdicional2 == ''\">Dato Adic.2</mat-checkbox>\r\n                      </div>\r\n                      <div class=\"form-check form-check-inline\">\r\n                        <mat-checkbox class=\"example-margin\" (click)=\"checkColum('checkAdicional3')\" [checked]=\"checkAdicional3 == ''\">Dato Adic.3</mat-checkbox>\r\n                      </div>\r\n                      <div class=\"form-check form-check-inline\">\r\n                        <mat-checkbox class=\"example-margin\" (click)=\"checkColum('checkAdicional4')\" [checked]=\"checkAdicional4 == ''\">Dato Adic.4</mat-checkbox>\r\n                      </div>\r\n                      <div class=\"form-check form-check-inline\">\r\n                        <mat-checkbox class=\"example-margin\" (click)=\"checkColum('checkAdicional5')\" [checked]=\"checkAdicional5 == ''\">Dato Adic.5</mat-checkbox>\r\n                      </div>\r\n                      <div class=\"form-check form-check-inline\">\r\n                        <mat-checkbox class=\"example-margin\" (click)=\"checkColum('checkAdicional6')\" [checked]=\"checkAdicional6 == ''\">Dato Adic.6</mat-checkbox>\r\n                      </div>\r\n                      <div class=\"form-check form-check-inline\">\r\n                        <mat-checkbox class=\"example-margin\" (click)=\"checkColum('checkAdicional7')\" [checked]=\"checkAdicional7 == ''\">Dato Adic.7</mat-checkbox>\r\n                      </div>\r\n                    </ng-template>\r\n                    <a type=\"button\" class=\"field-config\" data-toggle=\"popover\" data-trigger=\"focus\" data-placement=\"bottom-right\" data-html=\"true\" [ngbPopover]=\"popContent\"><i class=\"icon str-icon-configurar\"></i></a>\r\n                  </div>\r\n                </th>\r\n                <td mat-cell *matCellDef=\"let resultado\">\r\n                </td>\r\n              </ng-container>\r\n\r\n              <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n              <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n            </table>\r\n            <mat-paginator [pageSizeOptions]=\"[10]\" [length]=\"cantidadRegistros\" [pageIndex]=\"indice\"  (page)=\"onPaginateChange($event)\" showFirstLastButtons></mat-paginator>\r\n          </div>\r\n\r\n          <div class=\"box-actions\" *ngIf=\"vistaCantidad > 0\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-6 item\">\r\n                <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n              </div>\r\n              <div class=\"col-md-6 item-right\">\r\n                <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n              </div>\r\n\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</section>"
                }] }
    ];
    /** @nocollapse */
    FacturacionHistorialDetalleComponent.ctorParameters = function () { return [
        { type: FacturacionHistorialService },
        { type: Router },
        { type: ActivatedRoute },
        { type: DescargaExcelPdfFileService },
        { type: MatDialog },
        { type: LoaderBaseService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    FacturacionHistorialDetalleComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator$1,] }]
    };
    return FacturacionHistorialDetalleComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FacturacionMenuComponent = /** @class */ (function () {
    function FacturacionMenuComponent() {
    }
    /**
     * @return {?}
     */
    FacturacionMenuComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    FacturacionMenuComponent.decorators = [
        { type: Component, args: [{
                    selector: 'facturacion-carga',
                    template: "<section id=\"portal-comercio\">\r\n    <div class=\"container\">\r\n        <!--h3 class=\"titulo-seccion\">Facturaci\u00F3n</h3-->\r\n        <div class=\"menu-pills\">\r\n            <div [routerLink]=\"['carga']\" [routerLinkActive]=\"['active']\" class=\"item first\">Carga de facturas</div>\r\n            <div [routerLink]=\"['historial']\" [routerLinkActive]=\"['active']\" class=\"item\">Historial</div>\r\n            <div [routerLink]=\"['reutilizar']\" [routerLinkActive]=\"['active']\" class=\"item last\">Reutilizar</div>\r\n        </div>\r\n    </div>\r\n</section>\r\n<router-outlet></router-outlet>"
                }] }
    ];
    /** @nocollapse */
    FacturacionMenuComponent.ctorParameters = function () { return []; };
    return FacturacionMenuComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FacturacionReutilizarBorradorDeletePeticion = /** @class */ (function () {
    function FacturacionReutilizarBorradorDeletePeticion() {
        this.idReutilizar = '-1';
    }
    return FacturacionReutilizarBorradorDeletePeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FacturacionReutilizarParams = /** @class */ (function () {
    function FacturacionReutilizarParams() {
        this.idReutilizar = -1;
        this.idArchivo = -1;
        this.idFacturador = -1;
        this.nombreFacturador = '';
        this.tipoMoneda = '';
        //Para los filtros
        this.indexReutilizar = 0;
        this.indexArchivos = 0;
        this.fechaIngreso = null;
        this.fechaProceso = null;
        this.estado = '';
        this.keyWord = '';
        this.comercio = '';
    }
    /**
     * @return {?}
     */
    FacturacionReutilizarParams.prototype.isNull = /**
     * @return {?}
     */
    function () {
        if (this.idReutilizar === -1 && this.idArchivo === -1 && this.idFacturador === -1 && this.indexArchivos === 0 && this.indexReutilizar === 0 && this.fechaIngreso === null && this.fechaProceso === null
            && this.estado === '' && this.keyWord === '' && this.comercio === '') {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * @return {?}
     */
    FacturacionReutilizarParams.prototype.setNull = /**
     * @return {?}
     */
    function () {
        this.idReutilizar = -1;
        this.idArchivo = -1;
        this.idFacturador = -1;
        this.indexReutilizar = 0;
        this.indexArchivos = 0;
        this.fechaIngreso = null;
        this.fechaProceso = null;
        this.estado = '';
        this.keyWord = '';
        this.comercio = '';
    };
    FacturacionReutilizarParams.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ FacturacionReutilizarParams.ngInjectableDef = defineInjectable({ factory: function FacturacionReutilizarParams_Factory() { return new FacturacionReutilizarParams(); }, token: FacturacionReutilizarParams, providedIn: "root" });
    return FacturacionReutilizarParams;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FacturacionreutilizarTempPeticion = /** @class */ (function () {
    function FacturacionreutilizarTempPeticion() {
        this.idReutilizar = '-1';
        this.idFacturador = '-1';
    }
    return FacturacionreutilizarTempPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$9 = MAT_MOMENT_DATE_FORMATS;
var FacturacionReutilizarComponent = /** @class */ (function () {
    function FacturacionReutilizarComponent(phttpe, fachistservice, phttpd, loader, dialog, formBuilder, datepipe, reutilizarParams, router, route, environment) {
        this.phttpe = phttpe;
        this.fachistservice = fachistservice;
        this.phttpd = phttpd;
        this.loader = loader;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.datepipe = datepipe;
        this.reutilizarParams = reutilizarParams;
        this.router = router;
        this.route = route;
        this.environment = environment;
        this.formGroup = new FormGroup({
            keyWord: new FormControl(''),
            estado: new FormControl('-1'),
            fechaIngreso: new FormControl(),
            fechaProceso: new FormControl(),
            comercio: new FormControl('-1' + ',' + '-1')
        });
        this.fechaInicioIngreso = '01/01/2000';
        this.fechaFinIngreso = '01/01/2000';
        this.fechaInicioProceso = '01/01/2000';
        this.fechaFinProceso = '01/01/2000';
        // Vistas variables
        this.vistaCantidad = 0;
        this.vistaComercio = 'Todos';
        this.vistaEstado = 'Todos';
        this.vistaCantidadBor = 0;
        this.hashCaminoMiga = [];
        this.peticionReporte = new FacturacionHistorialPeticion();
        this.peticionEmpresa = new EmpresasPeticion();
        this.resultadoEmpresa = [];
        this.resultadoEstado = [];
        this.comboComercio = false;
        this.mensajeError = -1;
        this.showBor = false;
        this.peticionReutilizarTemp = new FacturacionreutilizarTempPeticion();
        this.peticionReutilizarDelete = new FacturacionReutilizarBorradorDeletePeticion();
        this.isCollapsed = false;
        this.consulta = -1;
        /** @type {?} */
        var fecha = new Date();
        /** @type {?} */
        var mañana = fecha.setDate(fecha.getDate() + 1);
        /** @type {?} */
        var fechaFormat = this.datepipe.transform(mañana, 'yyyy-MM-dd');
        this.unavailabilityForm = this.formBuilder.group({
            endDate: [fechaFormat + 'T00:00:00.000Z']
        });
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idEmpresaPac = this.userPerfil.empresa.idEmpresaPac;
    }
    /**
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.consulta = -1;
        this.peticionReporte.fechaInicioIngreso = '01/01/2000';
        this.peticionReporte.fechaFinIngreso = '01/01/2000';
        this.peticionReporte.fechaInicioProceso = '01/01/2000';
        this.peticionReporte.fechaFinProceso = '01/01/2000';
        this.peticionReporte.keyWord = '-1';
        this.peticionReporte.codtipoArchivo = 'FAT';
        this.peticionReporte.idConvenio = '-1';
        if (this.codTpoPortal == 'COMERCIO') {
            this.comboComercio = false;
            this.formGroup.get('comercio').disable();
            this.peticionReporte.idFacturador = this.idEmpresaPac;
            this.displayedColumns = ['fechaIngreso', 'fechaProceso', 'nombreArchivo', 'cantidadRegistros', 'montoArchivo', 'dscEstado', 'reutilizar'];
            this.displayedColumnsReu = ['fechaIngreso', 'nombreReu', 'cantidad', 'monto', 'estado', 'editar', 'eliminar'];
            this.postReutilizarTempServices(this.idEmpresaPac, -1);
        }
        else {
            this.comboComercio = true;
            this.formGroup.get('comercio').enable();
            this.peticionReporte.idFacturador = "-1";
            this.displayedColumns = ['fechaIngreso', 'fechaProceso', 'nombreArchivo', 'nombreFacturador', 'cantidadRegistros', 'montoArchivo', 'dscEstado', 'reutilizar'];
            this.displayedColumnsReu = ['fechaIngreso', 'nombreReu', 'nomFacturador', 'cantidad', 'monto', 'estado', 'editar', 'eliminar'];
            this.peticionEmpresa.codCliente = this.environment.codCliente;
            this.peticionEmpresa.codEstadoConvenio = 'HBL';
            this.postSentEmpresaServices(this.peticionEmpresa);
            this.postReutilizarTempServices(-1, -1);
        }
        if (!this.reutilizarParams.isNull()) {
            this.consulta = 0;
            // Llena los filtros listado de archivos
            this.formGroup.get('fechaIngreso').setValue(this.reutilizarParams.fechaIngreso);
            this.formGroup.get('fechaProceso').setValue(this.reutilizarParams.fechaProceso);
            this.formGroup.get('keyWord').setValue((this.reutilizarParams.keyWord == '-1') ? '' : this.reutilizarParams.keyWord);
            this.formGroup.get('comercio').setValue(this.reutilizarParams.idFacturador);
            this.formGroup.get('estado').setValue(this.reutilizarParams.estado);
            // Llama al servicio
            this.postSentEstadoServices(this.reutilizarParams.estado);
            this.onSubmit('form');
        }
        else {
            this.postSentEstadoServices('-1');
            this.setInitialBreadcrumbs();
        }
    };
    /**
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.setInitialBreadcrumbs = /**
     * @return {?}
     */
    function () {
        this.hashCaminoMiga[0] = { title: 'Fecha Ingreso', text: 'Todos' };
        this.hashCaminoMiga[1] = { title: 'Fecha Proceso', text: 'Todos' };
        this.hashCaminoMiga[2] = { title: 'Estado', text: 'Todos' };
        this.hashCaminoMiga[3] = { title: 'Nombre', text: '' };
        if (this.codTpoPortal != 'COMERCIO') {
            this.hashCaminoMiga[4] = { title: 'Empresa', text: 'Todas' };
        }
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.consulta = 0;
        this.peticionReporte.codTpoPortal = this.codTpoPortal;
        this.filtroIngresoI = this.formGroup.get('fechaIngreso').value;
        if (this.formGroup.get('fechaIngreso').value != null) {
            this.peticionReporte.fechaInicioIngreso = formatDate(this.filtroIngresoI.begin, 'dd/MM/yyyy', 'en-US');
            this.peticionReporte.fechaFinIngreso = formatDate(this.filtroIngresoI.end, 'dd/MM/yyyy', 'en-US');
            this.hashCaminoMiga[0] = { title: 'Fecha Ingreso', text: this.fechaInicioIngreso + ' - ' + this.fechaFinIngreso };
        }
        else {
            this.hashCaminoMiga[0] = { title: 'Fecha Ingreso', text: 'Todos' };
            this.peticionReporte.fechaInicioIngreso = this.fechaInicioIngreso;
            this.peticionReporte.fechaFinIngreso = this.fechaFinIngreso;
        }
        this.filtroProcesoD = this.formGroup.get('fechaProceso').value;
        if (this.filtroProcesoD != null) {
            this.peticionReporte.fechaInicioProceso = formatDate(this.filtroProcesoD.begin, 'dd/MM/yyyy', 'en-US');
            this.peticionReporte.fechaFinProceso = formatDate(this.filtroProcesoD.end, 'dd/MM/yyyy', 'en-US');
            this.hashCaminoMiga[1] = { title: 'Fecha Proceso', text: this.fechaInicioProceso + ' - ' + this.fechaFinProceso };
        }
        else {
            this.hashCaminoMiga[1] = { title: 'Fecha Proceso', text: 'Todos' };
            this.peticionReporte.fechaInicioProceso = this.fechaInicioProceso;
            this.peticionReporte.fechaFinProceso = this.fechaFinProceso;
        }
        if (this.formGroup.get('estado').value == '-1') {
            this.peticionReporte.estadoFacturacion = '-1';
            this.hashCaminoMiga[2] = { title: 'Estado', text: 'Todos' };
        }
        else {
            this.peticionReporte.estadoFacturacion = this.formGroup.get('estado').value;
            this.hashCaminoMiga[2] = { title: 'Estado', text: this.vistaEstado };
        }
        if (this.formGroup.get('keyWord').value == '') {
            this.peticionReporte.keyWord = '-1';
            this.hashCaminoMiga[3] = { title: 'Nombre', text: '' };
        }
        else {
            this.peticionReporte.keyWord = this.formGroup.get('keyWord').value;
            this.hashCaminoMiga[3] = { title: 'Nombre', text: this.formGroup.get('keyWord').value };
        }
        if (this.codTpoPortal == 'COMERCIO') {
            this.peticionReporte.idFacturador = this.idEmpresaPac;
        }
        else {
            /** @type {?} */
            var idFacturador = this.formGroup.get('comercio').value.split(",")[0];
            if (idFacturador == null || idFacturador == '' || idFacturador == -1) {
                this.peticionReporte.idFacturador = '-1';
                this.peticionReporte.idConvenio = '-1';
                this.hashCaminoMiga[4] = { title: 'Empresa', text: 'Todas' };
            }
            else {
                this.peticionReporte.idFacturador = this.formGroup.get('comercio').value.split(",")[0];
                this.peticionReporte.idConvenio = this.formGroup.get('comercio').value.split(",")[1];
                this.hashCaminoMiga[4] = { title: 'Empresa', text: this.vistaComercio };
            }
        }
        if (tipo == 'excel' || tipo == 'pdf') {
            this.peticionReporte.filtros = this.hashCaminoMiga;
            this.postDownloadReportFile(this.peticionReporte, tipo);
        }
        else {
            this.postSentReportServices(this.peticionReporte);
        }
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiFacturasMT/historialArchivos/' + tipo;
        this.phttpd.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'historialFacturacion' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'historialFacturacion' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.onPaginateChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.reutilizarParams.indexArchivos = this.paginator.pageIndex;
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.postSentReportServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.show = true;
        this.fachistservice.postListReutilizarArchivos(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var reutilizar_1 = [];
                data.resultado.forEach((/**
                 * @param {?} item
                 * @return {?}
                 */
                function (item) {
                    if (item.codEstado != 'RCH' && item.codEstado != 'ING') {
                        reutilizar_1.push(item);
                    }
                }));
                if (!_this.reutilizarParams.isNull()) {
                    _this.paginator.pageIndex = _this.reutilizarParams.indexArchivos;
                }
                _this.vistaCantidad = reutilizar_1.length;
                _this.dataSource = new MatTableDataSource$1(reutilizar_1);
                _this.dataSource.paginator = _this.paginator;
                if (_this.vistaCantidad == 0) {
                    _this.show = false;
                    _this.isCollapsed = false;
                }
                else {
                    _this.isCollapsed = true;
                }
                _this.mensajeError = 0;
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.mensajeError = 1;
                _this.loader.hide();
                console.error('Error al listar Facturación', data.descret);
            }
            _this.reutilizarParams.setNull();
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            _this.mensajeError = 1;
            _this.loader.hide();
            console.error('Error: ', err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.phttpe.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var empresa = new EmpresaResult();
                empresa.docFacturador = '-1';
                empresa.idFacturador = -1;
                empresa.idConvenio = '-1';
                empresa.nomFacturador = 'Todas';
                data.resultado.splice(0, 0, empresa);
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.error('Error postListarEmpresas', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postListarEmpresas', err);
        }));
    };
    /**
     * @param {?} codEstadoSelected
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.postSentEstadoServices = /**
     * @param {?} codEstadoSelected
     * @return {?}
     */
    function (codEstadoSelected) {
        var _this = this;
        this.fachistservice.postListarEstadoArchivos().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                data.resultado.forEach((/**
                 * @param {?} item
                 * @return {?}
                 */
                function (item) {
                    if (item.codigo != 'AUT' && item.codigo != 'RAU') {
                        _this.resultadoEstado.push(item);
                    }
                }));
                /** @type {?} */
                var estado = new EstadoArchivosResult();
                estado.codigo = '-1';
                estado.descripcion = 'Todos';
                _this.resultadoEstado.splice(0, 0, estado);
                _this.formGroup.get('estado').setValue(codEstadoSelected);
                _this.vistaEstado = 'Todos';
            }
            else {
                console.error('Error postSentEstadoServices', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postSentEstadoServices', err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.onEstadoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEstado = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.onComercioSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaComercio = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.peticionReporte.estadoFacturacion = '-1';
        this.peticionReporte.keyWord = '-1';
        this.fechaInicioIngreso = '01/01/2000';
        this.fechaFinIngreso = '01/01/2000';
        this.fechaInicioProceso = '01/01/2000';
        this.fechaFinProceso = '01/01/2000';
        this.peticionReporte.idConvenio = '-1';
        this.filtroIngresoI = null;
        this.filtroProcesoD = null;
        this.formGroup.get('keyWord').setValue('');
        this.formGroup.get('fechaIngreso').setValue(null);
        this.formGroup.get('fechaProceso').setValue(null);
        this.formGroup.controls.comercio.reset('-1' + ',' + '-1');
        this.formGroup.controls.estado.setValue('-1');
        this.vistaCantidad = 0;
        this.show = false;
        this.mensajeError = -1;
        this.consulta = -1;
        this.dataSource = new MatTableDataSource$1([]);
        this.setInitialBreadcrumbs();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.onPaginateChangeReu = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.reutilizarParams.indexReutilizar = this.paginatorReu.pageIndex;
    };
    /**
     * @param {?} idFacturador
     * @param {?} idReutilizar
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.postReutilizarTempServices = /**
     * @param {?} idFacturador
     * @param {?} idReutilizar
     * @return {?}
     */
    function (idFacturador, idReutilizar) {
        var _this = this;
        /** @type {?} */
        var body = new FacturacionreutilizarTempPeticion();
        body.idFacturador = idFacturador.toString();
        body.idReutilizar = idReutilizar.toString();
        this.showBor = true;
        this.fachistservice.postReutilizarTemp(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                sessionStorage.setItem('borrarReu', 'true');
                if (_this.paginatorReu != undefined && sessionStorage.getItem('componenteHijo') == 'facturacion-reutilizar-detalle') {
                    _this.paginatorReu.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indiceReu')))));
                }
                else if (_this.paginatorReu != undefined && sessionStorage.getItem('borrarReu') == 'true') {
                    _this.paginatorReu.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indiceReu')))));
                }
                else if (_this.paginatorReu != undefined) {
                    _this.paginatorReu.pageIndex = 0;
                }
                sessionStorage.removeItem('borrarReu');
                _this.dataSourceReutilizarTemp = new MatTableDataSource$1(data.resultado);
                _this.dataSourceReutilizarTemp.paginator = _this.paginatorReu;
                _this.vistaCantidadBor = data.resultado.length;
                if (_this.vistaCantidadBor <= 0) {
                    _this.showBor = false;
                }
                _this.mensajeError = 0;
            }
            else {
                _this.showBor = false;
                console.error('Error al listar Borrador de facturación', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showBor = false;
            console.error('Error: ' + err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.postReutilizarDeleteServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.fachistservice.postReutilizarDelete(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == 0) {
                _this.showDialog('Información', 'Borrador eliminado exitosamente.', false);
                _this.postReutilizarTempServices(((_this.codTpoPortal == 'COMERCIO') ? body.idFacturador : -1), -1);
            }
            else {
                _this.showDialog('Error', 'Ha ocurrido un error al eliminar el borrador.<br>Inténtelo nuevamente.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al eliminar el borrador.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @param {?} idReu
     * @param {?} idFacturador
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.deleteReuFact = /**
     * @param {?} idReu
     * @param {?} idFacturador
     * @return {?}
     */
    function (idReu, idFacturador) {
        this.peticionReutilizarDelete.idReutilizar = idReu;
        this.peticionReutilizarDelete.idFacturador = idFacturador;
        this.showDialogDeleteBorrador('Información', 'La factura se encuentra en borrador.<br>¿Está seguro de eliminarla?', true);
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.showDialogDeleteBorrador = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            if (result) {
                _this.postReutilizarDeleteServices(_this.peticionReutilizarDelete);
            }
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.selectFechaIngreso = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.fechaInicioIngreso = formatDate(event.value.begin, 'dd/MM/yyyy', 'en-US');
        this.fechaFinIngreso = formatDate(event.value.end, 'dd/MM/yyyy', 'en-US');
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.selectFechaProceso = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.fechaInicioProceso = formatDate(event.value.begin, 'dd/MM/yyyy', 'en-US');
        this.fechaFinProceso = formatDate(event.value.end, 'dd/MM/yyyy', 'en-US');
    };
    /**
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.onSubmit('');
        }
    };
    /**
     * @param {?} resul
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.formateandoMonto = /**
     * @param {?} resul
     * @return {?}
     */
    function (resul) {
        return FormatoMonedaUtil.formatearMonto(resul);
    };
    /**
     * @param {?} param1
     * @param {?} param2
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.valorSelectEmpresa = /**
     * @param {?} param1
     * @param {?} param2
     * @return {?}
     */
    function (param1, param2) {
        return param2 == "" ? param1 : param1 + ": " + param2;
    };
    /**
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('componenteHijo');
    };
    /**
     * @param {?} idReutilizar
     * @param {?} idArchivo
     * @param {?} idFacturador
     * @param {?} idConvenio
     * @param {?} nombreFacturador
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.callBorradorDetalle = /**
     * @param {?} idReutilizar
     * @param {?} idArchivo
     * @param {?} idFacturador
     * @param {?} idConvenio
     * @param {?} nombreFacturador
     * @return {?}
     */
    function (idReutilizar, idArchivo, idFacturador, idConvenio, nombreFacturador) {
        this.reutilizarParams.setNull();
        this.reutilizarParams.idReutilizar = idReutilizar;
        this.reutilizarParams.idArchivo = idArchivo;
        this.reutilizarParams.idFacturador = idFacturador;
        this.reutilizarParams.nombreFacturador = nombreFacturador;
        this.reutilizarParams.idConvenio = idConvenio;
        this.reutilizarParams.fechaIngreso = this.formGroup.get('fechaIngreso').value;
        this.reutilizarParams.fechaProceso = this.formGroup.get('fechaProceso').value;
        this.reutilizarParams.estado = this.formGroup.get('estado').value;
        this.reutilizarParams.comercio = this.formGroup.get('comercio').value;
        this.reutilizarParams.keyWord = this.formGroup.get('keyWord').value;
        this.router.navigate(['../reutilizarDetalle'], { relativeTo: this.route });
    };
    /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    FacturacionReutilizarComponent.prototype.getEmpresaConvenio = /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    function (nomFacturador, descConvenio) {
        return descConvenio != "" ? nomFacturador + ": " + descConvenio : nomFacturador;
    };
    FacturacionReutilizarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'facturacion-reutilizar',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <section *ngIf=\"showBor\">\r\n      <div class=\"table-container table-responsive-md\">\r\n        <table class=\"table\" mat-table [dataSource]=\"dataSourceReutilizarTemp\">\r\n          <ng-container matColumnDef=\"estado\">\r\n            <th mat-header-cell *matHeaderCellDef>Estado</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.codEstado == 'AUTORIZAR'\" class=\"databar pendiente\">{{resultado.estado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'BORRADOR'\" class=\"databar procesado\">{{resultado.estado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'RECHAZAR'\" class=\"databar rechazado\">{{resultado.estado}}</span>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"nombreReu\">\r\n            <th mat-header-cell *matHeaderCellDef>Nombre</th>\r\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\"> {{resultado.nombreReu}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"nomFacturador\" *ngIf=\"comboComercio\">\r\n            <th mat-header-cell *matHeaderCellDef>Empresa</th>\r\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\">{{resultado.nomFacturador}}: {{resultado.descConvenio}}</td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"cantidad\">\r\n            <th mat-header-cell *matHeaderCellDef>N\u00B0 de registros</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.cantidad | cantidad}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"monto\">\r\n            <th mat-header-cell *matHeaderCellDef>Monto</th>\r\n            <td mat-cell *matCellDef=\"let resultado\" style=\"text-align: right\">{{formateandoMonto(resultado)}}</td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fechaIngreso\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha de ingreso</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.fechaIngreso == null; else elseBlock\">(Pendiente)</span>\r\n              <ng-template #elseBlock>{{resultado.fechaIngreso | date:'dd/MM/yyyy'}}</ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"editar\">\r\n            <th mat-header-cell *matHeaderCellDef>Editar</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a *ngIf=\"resultado.codEstado != 'AUTORIZAR'\" (click) = \"callBorradorDetalle(resultado.idReu, -1, resultado.idFacturador, resultado.idConvenio, resultado.nomFacturador)\"><i class=\"icon str-icon-lapiz\"></i></a>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"eliminar\">\r\n            <th mat-header-cell *matHeaderCellDef>Eliminar</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a *ngIf=\"resultado.codEstado != 'AUTORIZAR'\" (click)=\"deleteReuFact(resultado.idReu,resultado.idFacturador)\"><i class=\"icon str-icon-trash\"></i></a>\r\n            </td>\r\n          </ng-container>\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumnsReu\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumnsReu;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n        </table>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" (page)=\"onPaginateChangeReu($event)\"  showFirstLastButtons #paginatorReu=\"matPaginator\"></mat-paginator>\r\n      </div>\r\n    </section>\r\n\r\n    <div *ngIf=\"mensajeError == 0 && vistaCantidadBor == 0\" class=\"table-container table-responsive-md borradores\">\r\n      <table class=\"table\">\r\n        <thead>\r\n          <tr>\r\n            <th scope=\"col\">Estado</th>\r\n            <th scope=\"col\">Nombre</th>\r\n            <th scope=\"col\" *ngIf=\"comboComercio\">Comercio</th>\r\n            <th scope=\"col\">N\u00B0 de registros</th>\r\n            <th scope=\"col\">Monto</th>\r\n            <th scope=\"col\">Fecha de ingreso</th>\r\n            <th scope=\"col\">Editar</th>\r\n            <th scope=\"col\">Eliminar</th>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <tr>\r\n            <td *ngIf=\"comboComercio\" colspan=\"8\" class=\"aviso-confirmacion\">\r\n              <i class=\"icon str-icon-info\"></i>\r\n              <span class=\"valign\">La bandeja Borradores est&aacute; vac&iacute;a. Aqu&iacute; se mostrar&aacute;n los archivos de facturaci&oacute;n en proceso de ser reutilizados.</span>\r\n            </td>\r\n            <td *ngIf=\"!comboComercio\" colspan=\"7\" class=\"aviso-confirmacion\">\r\n              <i class=\"icon str-icon-info\"></i>\r\n              <span class=\"valign\">La bandeja Borradores est&aacute; vac&iacute;a. Aqu&iacute; se mostrar&aacute;n los archivos de facturaci&oacute;n en proceso de ser reutilizados.</span>\r\n            </td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n    </div>\r\n\r\n  </div>\r\n</section>\r\n\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"seccion-titulo-boton\" *ngIf=\"mensajeError != 1\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <h4 class=\"titulo-seccion\">Archivos de facturaci&oacute;n</h4>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"modulo-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n      </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"formGroup\" autocomplete=\"off\">\r\n              <div class=\"form-row align-left\">\r\n                <div class=\"col-md-6\">\r\n                  <div class=\"filtro-fecha\">\r\n                    <button type=\"button\" class=\"btn fecha\" (click)=\"picker1.open()\"><i class=\"str-icon-calendario\"></i> Buscar por fecha de ingreso\r\n                      <ng-container *ngIf=\"this.formGroup.get('fechaIngreso').value != null && this.fechaInicioIngreso != '01/01/2000'\">\r\n                        <span>{{ this.fechaInicioIngreso + ' - ' + this.fechaFinIngreso }}</span>\r\n                      </ng-container>\r\n                    </button>\r\n                    <mat-form-field style=\"display: none;\">\r\n                      <input matInput placeholder=\"Fecha\" [max]=\"unavailabilityForm.controls.endDate.value\" [satDatepicker]=\"picker1\" formControlName=\"fechaIngreso\" (dateInput)=\"selectFechaIngreso($event)\">\r\n                      <sat-datepicker-toggle matSuffix [for]=\"picker1\"></sat-datepicker-toggle>\r\n                      <sat-datepicker touchUi #picker1 [rangeMode]=\"true\" [selectFirstDateOnClose]=\"true\"></sat-datepicker>\r\n                    </mat-form-field>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                  <div class=\"filtro-fecha\">\r\n                    <button type=\"button\" class=\"btn fecha\" (click)=\"picker2.open()\"><i class=\"str-icon-calendario\"></i> Buscar por fecha de proceso\r\n                      <ng-container *ngIf=\"this.formGroup.get('fechaProceso').value != null && this.fechaInicioProceso != '01/01/2000'\">\r\n                        <span>{{ this.fechaInicioProceso + ' - ' + this.fechaFinProceso }}</span>\r\n                      </ng-container>\r\n                    </button>\r\n                    <mat-form-field style=\"display: none;\">\r\n                      <input matInput placeholder=\"Fecha\" [max]=\"unavailabilityForm.controls.endDate.value\" [satDatepicker]=\"picker2\" formControlName=\"fechaProceso\" (dateInput)=\"selectFechaProceso($event)\">\r\n                      <sat-datepicker-toggle matSuffix [for]=\"picker2\"></sat-datepicker-toggle>\r\n                      <sat-datepicker touchUi #picker2 [rangeMode]=\"true\" [selectFirstDateOnClose]=\"true\"></sat-datepicker>\r\n                    </mat-form-field>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-row\">\r\n                <div class=\"form-group col-sm-3\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estado\" (selectionChange)=\"onEstadoSelect($event)\">\r\n                      <mat-option *ngFor=\"let estado of resultadoEstado\" [value]=\"estado.codigo\">{{estado.descripcion}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-sm-5\">\r\n                  <mat-form-field>\r\n                    <input matInput maxlength=\"50\" placeholder=\"Nombre\" formControlName=\"keyWord\">\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-sm-4\" *ngIf=\"comboComercio\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"comercio\" (selectionChange)=\"onComercioSelect($event)\">\r\n                      <mat-option class=\"multiline-mat-option\" *ngFor=\"let empresa of resultadoEmpresa\" [value]=\"empresa.idFacturador + ',' + empresa.idConvenio\">{{getEmpresaConvenio(empresa.nomFacturador, empresa.descConvenio)}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"actions\">\r\n                <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\" (click)=\"validarForm()\">Filtrar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"resultados-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-10\">\r\n          <div class=\"tags row\">\r\n            <div *ngFor=\"let entry of hashCaminoMiga\" class=\"item\">{{entry.title}}: {{entry.text}}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n          <div class=\"numero-resultados\">\r\n            <strong>{{ (vistaCantidad == 1) ? ( vistaCantidad + \" Resultado\") : vistaCantidad + \" Resultados\" }}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-container table-responsive-md\">\r\n        <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n          <ng-container matColumnDef=\"dscEstado\">\r\n            <th mat-header-cell *matHeaderCellDef>Estado</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.codEstado == 'ING'\" class=\"databar ingresado\">{{resultado.dscEstado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'COB'\" class=\"databar encobro\">{{resultado.dscEstado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'PRO'\" class=\"databar procesado\">{{resultado.dscEstado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'RCH'\" class=\"databar rechazado\">{{resultado.dscEstado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'RAU'\" class=\"databar rechazado\">{{resultado.dscEstado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'ANL'\" class=\"databar eliminado\">{{resultado.dscEstado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'AUT'\" class=\"databar pendiente\">{{resultado.dscEstado}}</span>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"nombreArchivo\">\r\n            <th mat-header-cell *matHeaderCellDef>Nombre</th>\r\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\"> {{resultado.nombreArchivo}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"nombreFacturador\" *ngIf=\"comboComercio\">\r\n            <th mat-header-cell *matHeaderCellDef>Empresa</th>\r\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\">{{resultado.nombreFacturador}}: {{resultado.descConvenio}}</td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"cantidadRegistros\">\r\n            <th mat-header-cell *matHeaderCellDef>N\u00B0 de registros</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.cantidadRegistros | cantidad}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"montoArchivo\">\r\n            <th mat-header-cell *matHeaderCellDef>Monto</th>\r\n            <td mat-cell *matCellDef=\"let resultado\" style=\"text-align: right\">{{formateandoMonto(resultado)}}</td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fechaIngreso\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha de ingreso</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.fechaIngreso == null; else elseBlock\">(Pendiente)</span>\r\n              <ng-template #elseBlock>{{resultado.fechaIngreso | date:'dd/MM/yyyy HH:mm'}}</ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fechaProceso\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha de proceso</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.fechaProceso == null; else elseBlock\">(Pendiente)</span>\r\n              <ng-template #elseBlock>{{resultado.fechaProceso | date:'dd/MM/yyyy'}}</ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"reutilizar\">\r\n            <th mat-header-cell *matHeaderCellDef>Reutilizar</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a (click) = \"callBorradorDetalle(-1, resultado.idArchivo, resultado.idFacturador, resultado.idConvenio, resultado.nombreFacturador)\"><i class=\"icon str-icon-renovar\"></i></a>\r\n            </td>\r\n          </ng-container>\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n        </table>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" (page)=\"onPaginateChange($event)\" showFirstLastButtons #paginator=\"matPaginator\"></mat-paginator>\r\n      </div>\r\n    </section>\r\n\r\n    <div class=\"modulo-cuentas\" *ngIf=\"mensajeError == 0 && vistaCantidad == 0 && consulta == 0\">\r\n      <span>\r\n        No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.\r\n      </span>\r\n    </div>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"consulta == -1\">\r\n      <span>\r\n        Establezca sus criterios de b&uacute;squeda.\r\n      </span>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div *ngIf=\"mensajeError == 1\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" id=\"modal-basic-title\" style=\"color:#ec0000;font-weight: bold\">Error</h3>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <p>Servicio temporalmente no disponible.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [EmpresasService, DescargaExcelPdfFileService,
                        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
                        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
                        { provide: MAT_DATE_FORMATS, useValue: ɵ0$9 }]
                }] }
    ];
    /** @nocollapse */
    FacturacionReutilizarComponent.ctorParameters = function () { return [
        { type: EmpresasService },
        { type: FacturacionHistorialService },
        { type: DescargaExcelPdfFileService },
        { type: LoaderBaseService },
        { type: MatDialog },
        { type: FormBuilder },
        { type: DatePipe },
        { type: FacturacionReutilizarParams },
        { type: Router },
        { type: ActivatedRoute },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    FacturacionReutilizarComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: ['paginator',] }],
        paginatorReu: [{ type: ViewChild, args: ['paginatorReu',] }]
    };
    return FacturacionReutilizarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FacturacionReutilizarAgregarPeticion = /** @class */ (function () {
    function FacturacionReutilizarAgregarPeticion() {
        this.codCliente = '';
        this.idUsuario = '';
        this.docEmpresa = '';
        this.codTpoPortal = '';
        this.idProceso = 0;
        this.cantRegistros = 0;
        this.monto = 0;
        this.tipoMoneda = '';
        this.idFacturador = 0;
        this.idReutilizar = '-1';
        this.listReutilizar = [];
    }
    return FacturacionReutilizarAgregarPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FacturacionReutilizarBorradorDetallePeticion = /** @class */ (function () {
    function FacturacionReutilizarBorradorDetallePeticion() {
        this.idReutilizar = '-1';
        this.idFacturador = '-1';
    }
    return FacturacionReutilizarBorradorDetallePeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ReutilizarFacturacionView = /** @class */ (function () {
    function ReutilizarFacturacionView() {
        this.idFacturador = 0;
        this.nombre = '';
        this.cantidad = 0;
        this.monto = 0;
        this.tipoMoneda = '';
        this.fechaCreacion = '';
        this.estado = '';
        this.detalles = [];
    }
    return ReutilizarFacturacionView;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ReutilizarFacturacionDetalleView = /** @class */ (function () {
    function ReutilizarFacturacionDetalleView() {
        this.idServicio = '';
        this.monto = 0;
        this.tipoMoneda = '';
        this.fechaCobro = '';
        this.adicional1 = '';
        this.adicional2 = '';
        this.adicional3 = '';
        this.adicional4 = '';
        this.adicional5 = '';
        this.adicional6 = '';
        this.adicional7 = '';
    }
    return ReutilizarFacturacionDetalleView;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var MY_FORMATS = {
    parse: {
        dateInput: 'LL'
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'YYYY'
    }
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$a = MY_FORMATS;
var DialogReutilizarFacturaComponent = /** @class */ (function () {
    function DialogReutilizarFacturaComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.minDate = new Date();
        this.numberMonedaPipe = new NumberMonedasStr();
        this.lengthMontoXMoneda = 0;
        this.formGroupEditar = new FormGroup({
            idServicio: new FormControl('', Validators.compose([Validators.required, CustomValidators.idServiceValidator])),
            monto: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(this.lengthMontoXMoneda), CustomValidators.amountValidator])),
            fechaCobro: new FormControl({ value: '', disabled: true }, Validators.required),
            adicional1: new FormControl('', Validators.maxLength(100)),
            adicional2: new FormControl('', Validators.maxLength(100)),
            adicional3: new FormControl('', Validators.maxLength(100)),
            adicional4: new FormControl('', Validators.maxLength(100)),
            adicional5: new FormControl('', Validators.maxLength(100)),
            adicional6: new FormControl('', Validators.maxLength(100)),
            adicional7: new FormControl('', Validators.maxLength(100))
        });
    }
    /**
     * @return {?}
     */
    DialogReutilizarFacturaComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.tipoMoneda = this.data.reutilizar.tipoMoneda;
        this.formGroupEditar.get('idServicio').setValue(this.data.reutilizar.idServicio);
        /** @type {?} */
        var montoRegistro = this.data.reutilizar.monto;
        this.formGroupEditar.get('monto').setValue((this.tipoMoneda == 'UYU' ? (montoRegistro / 100).toString() : montoRegistro.toString()));
        this.formGroupEditar.get('fechaCobro').setValue(this.data.reutilizar.fechaCobro);
        this.formGroupEditar.get('adicional1').setValue(this.data.reutilizar.adicional1);
        this.formGroupEditar.get('adicional2').setValue(this.data.reutilizar.adicional2);
        this.formGroupEditar.get('adicional3').setValue(this.data.reutilizar.adicional3);
        this.formGroupEditar.get('adicional4').setValue(this.data.reutilizar.adicional4);
        this.formGroupEditar.get('adicional5').setValue(this.data.reutilizar.adicional5);
        this.formGroupEditar.get('adicional6').setValue(this.data.reutilizar.adicional6);
        this.formGroupEditar.get('adicional7').setValue(this.data.reutilizar.adicional7);
        this.getLengthMontoXMoneda();
    };
    /**
     * @return {?}
     */
    DialogReutilizarFacturaComponent.prototype.getLengthMontoXMoneda = /**
     * @return {?}
     */
    function () {
        this.lengthMontoXMoneda = this.tipoMoneda == 'USD' ? 13 : 10;
        this.formGroupEditar.get('monto').setValidators(Validators.compose([Validators.required, Validators.maxLength(this.lengthMontoXMoneda), CustomValidators.amountValidator]));
    };
    /**
     * @return {?}
     */
    DialogReutilizarFacturaComponent.prototype.save = /**
     * @return {?}
     */
    function () {
        if (this.formGroupEditar.valid) {
            /** @type {?} */
            var result = new ReutilizarFacturacionDetalleView();
            result.tipoMoneda = this.tipoMoneda;
            result.idServicio = this.formGroupEditar.get('idServicio').value;
            /** @type {?} */
            var montoRegistro = CustomValidators.validaMonto(this.formGroupEditar.get('monto').value);
            result.monto = (this.tipoMoneda == 'UYU' ? (parseInt(montoRegistro) * 100) : parseInt(montoRegistro));
            result.fechaCobro = this.formGroupEditar.get('fechaCobro').value;
            result.adicional1 = this.formGroupEditar.get('adicional1').value;
            result.adicional2 = this.formGroupEditar.get('adicional2').value;
            result.adicional3 = this.formGroupEditar.get('adicional3').value;
            result.adicional4 = this.formGroupEditar.get('adicional4').value;
            result.adicional5 = this.formGroupEditar.get('adicional5').value;
            result.adicional6 = this.formGroupEditar.get('adicional6').value;
            result.adicional7 = this.formGroupEditar.get('adicional7').value;
            this.dialogRef.close(result);
        }
    };
    /**
     * @return {?}
     */
    DialogReutilizarFacturaComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        this.dialogRef.close();
    };
    DialogReutilizarFacturaComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-dialog-reutlizar-factura',
                    template: "<div class=\"custom-modals\">\r\n  <div style=\"padding: 18px;\">\r\n    <h5 style=\"margin: 0px 0px 20px 0px;\">{{data.title}}</h5>\r\n    <form [formGroup]=\"formGroupEditar\" autocomplete=\"off\">\r\n      <div class=\"form-section\">\r\n        <div class=\"form-row\">\r\n          <div class=\"col-sm-4 col-md-4\">\r\n            <mat-form-field>\r\n              <input matInput maxlength=\"20\" placeholder=\"ID Servicio\" formControlName=\"idServicio\">\r\n              <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n            </mat-form-field>\r\n          </div>\r\n          <div class=\"col-sm-4 col-md-4\">\r\n            <mat-form-field>\r\n              <span matPrefix>{{tipoMoneda}} $&nbsp;</span>\r\n              <input matInput digitOnly placeholder=\"Monto\" formControlName=\"monto\" [maxlength]=\"lengthMontoXMoneda\" [value]=\"numberMonedaPipe.transform(formGroupEditar.get('monto').value, tipoMoneda)\">\r\n              <mat-error>Este campo es <strong>requerido</strong>.</mat-error>\r\n            </mat-form-field>\r\n          </div>\r\n          <div class=\"col-sm-4 col-md-4\">\r\n            <mat-form-field>\r\n              <input matInput [matDatepicker]=\"pickFechaCobro\" [min]=\"minDate\" placeholder=\"Fecha para cobro\" formControlName=\"fechaCobro\">\r\n              <mat-datepicker-toggle matSuffix [for]=\"pickFechaCobro\"></mat-datepicker-toggle>\r\n              <mat-datepicker touchUi #pickFechaCobro disabled=\"false\"></mat-datepicker>\r\n              <mat-error>Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n            </mat-form-field>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-row\">\r\n          <div class=\"col-6\">\r\n            <mat-form-field>\r\n              <input matInput maxlength=\"100\" formControlName=\"adicional1\" placeholder=\"Dato Adicional 1\">\r\n            </mat-form-field>\r\n          </div>\r\n          <div class=\"col-6\">\r\n            <mat-form-field>\r\n              <input matInput maxlength=\"100\" formControlName=\"adicional2\" placeholder=\"Dato Adicional 2\">\r\n            </mat-form-field>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-row\">\r\n          <div class=\"col-6\">\r\n            <mat-form-field>\r\n              <input matInput maxlength=\"100\" formControlName=\"adicional3\" placeholder=\"Dato Adicional 3\">\r\n            </mat-form-field>\r\n          </div>\r\n          <div class=\"col-6\">\r\n            <mat-form-field>\r\n              <input matInput maxlength=\"100\" formControlName=\"adicional4\" placeholder=\"Dato Adicional 4\">\r\n            </mat-form-field>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-row\">\r\n          <div class=\"col-6\">\r\n            <mat-form-field>\r\n              <input matInput maxlength=\"100\" formControlName=\"adicional5\" placeholder=\"Dato Adicional 5\">\r\n            </mat-form-field>\r\n          </div>\r\n          <div class=\"col-6\">\r\n            <mat-form-field>\r\n              <input matInput maxlength=\"100\" formControlName=\"adicional6\" placeholder=\"Dato Adicional 6\">\r\n            </mat-form-field>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-row\">\r\n          <div class=\"col-6\">\r\n            <mat-form-field>\r\n              <input matInput maxlength=\"100\" formControlName=\"adicional7\" placeholder=\"Dato Adicional 7\">\r\n            </mat-form-field>\r\n          </div>\r\n          <div class=\"col-6\">&nbsp;</div>\r\n        </div>\r\n      </div>\r\n    </form>\r\n\r\n    <div class=\"buttons-container\" style=\"margin: 10px 0px 0px 0;\">\r\n      <button class=\"btn secundario\" (click)=\"close()\">Cancelar</button>\r\n      <button class=\"btn main\" (click)=\"save()\">Aceptar</button>\r\n    </div>\r\n</div>",
                    providers: [
                        { provide: DateAdapter$2, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE$2] },
                        { provide: MAT_DATE_FORMATS$2, useValue: ɵ0$a }
                    ]
                }] }
    ];
    /** @nocollapse */
    DialogReutilizarFacturaComponent.ctorParameters = function () { return [
        { type: MatDialogRef },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
    ]; };
    return DialogReutilizarFacturaComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$b = MY_FORMATS;
var FacturacionReutilizarDetalleComponent = /** @class */ (function () {
    function FacturacionReutilizarDetalleComponent(facturacionHistorialService, router, route, dialog, loader, reutilizarParams, environment) {
        this.facturacionHistorialService = facturacionHistorialService;
        this.router = router;
        this.route = route;
        this.dialog = dialog;
        this.loader = loader;
        this.reutilizarParams = reutilizarParams;
        this.environment = environment;
        this.formGroupAgregar = new FormGroup({
            updateFechaPaCobro: new FormControl()
        });
        //Datos del listado
        this.idReutilizar = '';
        this.idFacturador = '';
        this.minDate = new Date();
        this.reutilizarFacturacionView = new ReutilizarFacturacionView();
        this.montoFormateado = '';
        this.dataSource = new MatTableDataSource$1([]);
        this.selection = new SelectionModel(true, []);
        // Columnas que pueden ser mostradas o no
        this.viewColMonto = true;
        this.viewColFechaCobro = true;
        this.viewColAdicional1 = true;
        this.viewColAdicional2 = false;
        this.viewColAdicional3 = false;
        this.viewColAdicional4 = false;
        this.viewColAdicional5 = false;
        this.viewColAdicional6 = false;
        this.viewColAdicional7 = false;
        this.displayedColumns = ['select', 'idServicio', 'montoFacturacion', 'fechaFacturacion', 'datoAdicional1', 'datoAdicional2', 'datoAdicional3', 'datoAdicional4', 'datoAdicional5', 'datoAdicional6', 'datoAdicional7', 'editar', 'config'];
        this.columnsToDisplay = this.displayedColumns.slice();
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idUsuario = this.userPerfil.usuario.idUsuario;
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
        this.codCliente = this.environment.codCliente;
    }
    /**
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        sessionStorage.setItem('componenteHijo', 'facturacion-reutilizar-detalle');
        if (this.reutilizarParams.idArchivo == -1) {
            //Viene de borradores
            this.postReutilizarServices(this.reutilizarParams.idReutilizar, this.reutilizarParams.idFacturador);
        }
        else {
            //viene de historial de archivos
            this.postArchivoDetalleServices(this.reutilizarParams.idArchivo, this.reutilizarParams.idFacturador);
        }
    };
    /**
     * @param {?} idReutilizar
     * @param {?} idFacturador
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.postReutilizarServices = /**
     * @param {?} idReutilizar
     * @param {?} idFacturador
     * @return {?}
     */
    function (idReutilizar, idFacturador) {
        var _this = this;
        /** @type {?} */
        var params = new FacturacionreutilizarTempPeticion();
        params.idReutilizar = idReutilizar.toString();
        params.idFacturador = idFacturador.toString();
        this.loader.show();
        this.facturacionHistorialService.postReutilizarTemp(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                if (data.resultado != null) {
                    _this.loader.hide();
                    _this.loadDetalleReutilizar(idReutilizar, idFacturador, data.resultado[0]);
                }
                else {
                    _this.loader.hide();
                    _this.showDialog('Error', 'No se encontraron datos para mostrar, intente nuevamente.', false);
                }
            }
            else {
                _this.loader.hide();
                console.error('Error al listar borrador a reutilizar', data.descret);
                _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            console.error('Error: ', err);
            _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @param {?} idReutilizar
     * @param {?} idFacturador
     * @param {?} dataReutilizar
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.loadDetalleReutilizar = /**
     * @param {?} idReutilizar
     * @param {?} idFacturador
     * @param {?} dataReutilizar
     * @return {?}
     */
    function (idReutilizar, idFacturador, dataReutilizar) {
        this.reutilizarFacturacionView.monto = parseInt(dataReutilizar.monto);
        this.montoFormateado = FormatoMonedaUtil.formatearMonto(dataReutilizar);
        this.reutilizarFacturacionView.fechaCreacion = dataReutilizar.fechaIngreso;
        this.reutilizarFacturacionView.estado = dataReutilizar.estado;
        this.reutilizarFacturacionView.idFacturador = this.reutilizarParams.idFacturador;
        this.reutilizarFacturacionView.nombre = dataReutilizar.nombreReu;
        this.reutilizarFacturacionView.cantidad = parseInt(dataReutilizar.cantidad);
        this.reutilizarFacturacionView.tipoMoneda = dataReutilizar.tipoMoneda;
        this.postReutilizarDetalleServices(idReutilizar, idFacturador);
    };
    /**
     * @param {?} idReutilizar
     * @param {?} idFacturador
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.postReutilizarDetalleServices = /**
     * @param {?} idReutilizar
     * @param {?} idFacturador
     * @return {?}
     */
    function (idReutilizar, idFacturador) {
        var _this = this;
        /** @type {?} */
        var params = new FacturacionReutilizarBorradorDetallePeticion();
        params.idReutilizar = idReutilizar.toString();
        params.idFacturador = idFacturador.toString();
        this.loader.show();
        this.facturacionHistorialService.postListReutilizarFactDetalle(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                if (data.resultado != null) {
                    data.resultado.forEach((/**
                     * @param {?} item
                     * @return {?}
                     */
                    function (item) {
                        /** @type {?} */
                        var detalle = new ReutilizarFacturacionDetalleView();
                        detalle.monto = parseInt(item.montoCobro);
                        //            detalle.idDetalle = item.idDetalle;
                        detalle.idServicio = item.idServicio;
                        detalle.fechaCobro = item.fechaCobro;
                        detalle.adicional1 = item.datoAdicional1;
                        detalle.adicional2 = item.datoAdicional2;
                        detalle.adicional3 = item.datoAdicional3;
                        detalle.adicional4 = item.datoAdicional4;
                        detalle.adicional5 = item.datoAdicional5;
                        detalle.adicional6 = item.datoAdicional6;
                        detalle.adicional7 = item.datoAdicional7;
                        detalle.tipoMoneda = item.tipoMoneda;
                        _this.reutilizarFacturacionView.detalles.push(detalle);
                    }));
                    _this.dataSource = new MatTableDataSource$1(_this.reutilizarFacturacionView.detalles);
                    _this.dataSource.paginator = _this.paginator;
                }
                else {
                    console.error('Error detalle reutilizar', data.descret);
                    _this.showDialog('Error', 'No se encontrador datos para mostrar, intente nuevamente.', false);
                }
                _this.loader.hide();
            }
            else {
                _this.loader.hide();
                console.error('Error detalle reutilizar', data.descret);
                _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            console.error('Error: ', err);
            _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @param {?} idArchivo
     * @param {?} idFacturador
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.postArchivoDetalleServices = /**
     * @param {?} idArchivo
     * @param {?} idFacturador
     * @return {?}
     */
    function (idArchivo, idFacturador) {
        var _this = this;
        /** @type {?} */
        var params = new FacturacionHistorialDetallePeticion();
        params.idArchivo = idArchivo.toString();
        params.idServicio = '-1';
        params.estadoFacturacion = '-1';
        params.filtros = [];
        params.pagina = '-1';
        this.loader.show();
        this.facturacionHistorialService.postHistorialDetalle(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                if (data.resultado != null && data.resultado.length > 0) {
                    _this.reutilizarFacturacionView.cantidad = parseInt(data.cantRegistros);
                    _this.reutilizarFacturacionView.fechaCreacion = _this.minDate.toISOString();
                    _this.reutilizarFacturacionView.estado = 'Borrador';
                    _this.reutilizarFacturacionView.idFacturador = idFacturador;
                    _this.reutilizarFacturacionView.nombre = 'RE_' + data.resultado[0].nombreArchivo;
                    _this.reutilizarFacturacionView.tipoMoneda = data.resultado[0].tipoMoneda;
                    data.resultado.forEach((/**
                     * @param {?} item
                     * @return {?}
                     */
                    function (item) {
                        /** @type {?} */
                        var detalle = new ReutilizarFacturacionDetalleView();
                        detalle.monto = parseInt(item.montoFacturacion);
                        detalle.idServicio = item.idServicio;
                        detalle.fechaCobro = _this.minDate.toISOString();
                        detalle.adicional1 = item.datoAdicional1;
                        detalle.adicional2 = item.datoAdicional2;
                        detalle.adicional3 = item.datoAdicional3;
                        detalle.adicional4 = item.datoAdicional4;
                        detalle.adicional5 = item.datoAdicional5;
                        detalle.adicional6 = item.datoAdicional6;
                        detalle.adicional7 = item.datoAdicional7;
                        detalle.tipoMoneda = item.tipoMoneda;
                        _this.reutilizarFacturacionView.detalles.push(detalle);
                    }));
                    _this.refreshDataSource();
                }
                _this.loader.hide();
            }
            else {
                _this.loader.hide();
                console.log('Error: ', data.descret);
                _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            console.error('Error: ' + err);
            _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @param {?} paramsArchivo
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.loadDataReutilizarArchivo = /**
     * @param {?} paramsArchivo
     * @return {?}
     */
    function (paramsArchivo) {
        for (var i = 0; i < paramsArchivo.length; i++) {
            /** @type {?} */
            var detalle = new ReutilizarFacturacionDetalleView();
            detalle.idServicio = paramsArchivo[i].idServicio;
            detalle.monto = parseInt(paramsArchivo[i].montoFacturacion);
            detalle.fechaCobro = new Date().toISOString();
            detalle.adicional1 = paramsArchivo[i].datoAdicional1;
            detalle.adicional2 = paramsArchivo[i].datoAdicional2;
            detalle.adicional3 = paramsArchivo[i].datoAdicional3;
            detalle.adicional4 = paramsArchivo[i].datoAdicional4;
            detalle.adicional5 = paramsArchivo[i].datoAdicional5;
            detalle.adicional6 = paramsArchivo[i].datoAdicional6;
            detalle.adicional7 = paramsArchivo[i].datoAdicional7;
            detalle.tipoMoneda = paramsArchivo[i].tipoMoneda;
            this.reutilizarFacturacionView.detalles.push(detalle);
        }
        this.reutilizarFacturacionView.monto = parseInt(paramsArchivo[0].montoFacturacion);
        this.montoFormateado = FormatoMonedaUtil.formatearMonto(paramsArchivo);
        this.reutilizarFacturacionView.tipoMoneda = paramsArchivo[0].tipoMoneda;
        this.reutilizarFacturacionView.fechaCreacion = new Date().toLocaleString();
        this.reutilizarFacturacionView.estado = paramsArchivo[0].estadoFacturacion;
        this.reutilizarFacturacionView.idFacturador = this.reutilizarParams.idFacturador;
        this.reutilizarFacturacionView.nombre = 'RE_' + paramsArchivo[0].descripcion;
    };
    /* Si el número de elementos seleccionados coincide con el número total de filas. */
    /* Si el número de elementos seleccionados coincide con el número total de filas. */
    /**
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.isAllSelected = /* Si el número de elementos seleccionados coincide con el número total de filas. */
    /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var numSelected = this.selection.selected.length;
        /** @type {?} */
        var numRows = this.dataSource.data.length;
        return numSelected === numRows;
    };
    /* Selecciona todas las filas si no están todas seleccionadas; de lo contrario limpia. */
    /* Selecciona todas las filas si no están todas seleccionadas; de lo contrario limpia. */
    /**
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.masterToggle = /* Selecciona todas las filas si no están todas seleccionadas; de lo contrario limpia. */
    /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.isAllSelected() ?
            this.selection.clear() :
            this.dataSource.data.forEach((/**
             * @param {?} row
             * @return {?}
             */
            function (row) { return _this.selection.select(row); }));
    };
    /* La etiqueta de la casilla de verificación en la fila pasada */
    /* La etiqueta de la casilla de verificación en la fila pasada */
    /**
     * @param {?=} row
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.checkboxLabel = /* La etiqueta de la casilla de verificación en la fila pasada */
    /**
     * @param {?=} row
     * @return {?}
     */
    function (row) {
        if (!row) {
            return (this.isAllSelected() ? 'select' : 'deselect') + " all";
        }
        return (this.selection.isSelected(row) ? 'deselect' : 'select') + " row " + (row.index + 1);
    };
    /**
     * @param {?} tipo
     * @param {?} titulo
     * @param {?} detalle
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.showDialogEditar = /**
     * @param {?} tipo
     * @param {?} titulo
     * @param {?} detalle
     * @return {?}
     */
    function (tipo, titulo, detalle) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogReutilizarFacturaComponent, {
            data: { title: titulo, reutilizar: detalle },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            if (result != null) {
                if (tipo == 'AGREGAR') {
                    /** @type {?} */
                    var newDetalle = new ReutilizarFacturacionDetalleView();
                    newDetalle.idServicio = result['idServicio'];
                    newDetalle.monto = parseInt(result['monto']);
                    newDetalle.fechaCobro = result['fechaCobro'];
                    newDetalle.adicional1 = result['adicional1'];
                    newDetalle.adicional2 = result['adicional2'];
                    newDetalle.adicional3 = result['adicional3'];
                    newDetalle.adicional4 = result['adicional4'];
                    newDetalle.adicional5 = result['adicional5'];
                    newDetalle.adicional6 = result['adicional6'];
                    newDetalle.adicional7 = result['adicional7'];
                    newDetalle.tipoMoneda = result['tipoMoneda'];
                    _this.reutilizarFacturacionView.detalles.push(newDetalle);
                }
                else {
                    detalle.idServicio = result['idServicio'];
                    detalle.monto = parseInt(result['monto']);
                    detalle.fechaCobro = result['fechaCobro'];
                    detalle.adicional1 = result['adicional1'];
                    detalle.adicional2 = result['adicional2'];
                    detalle.adicional3 = result['adicional3'];
                    detalle.adicional4 = result['adicional4'];
                    detalle.adicional5 = result['adicional5'];
                    detalle.adicional6 = result['adicional6'];
                    detalle.adicional7 = result['adicional7'];
                    detalle.tipoMoneda = result['tipoMoneda'];
                }
                _this.refreshDataSource();
            }
        }));
    };
    /**
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.refreshDataSource = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var montoTotal = 0;
        this.reutilizarFacturacionView.cantidad = this.reutilizarFacturacionView.detalles.length;
        this.reutilizarFacturacionView.detalles.forEach((/**
         * @param {?} detalle
         * @return {?}
         */
        function (detalle) { return montoTotal += detalle.monto; }));
        this.reutilizarFacturacionView.monto = montoTotal;
        this.montoFormateado = FormatoMonedaUtil.formatearMontoParam(montoTotal, this.reutilizarFacturacionView.tipoMoneda);
        this.dataSource = new MatTableDataSource$1(this.reutilizarFacturacionView.detalles);
        this.dataSource.paginator = this.paginator;
    };
    /**
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.showModalAgregarLinea = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var newDetalleView = new ReutilizarFacturacionDetalleView();
        newDetalleView.fechaCobro = new Date().toISOString();
        newDetalleView.tipoMoneda = this.reutilizarFacturacionView.tipoMoneda;
        this.showDialogEditar('AGREGAR', 'Agregar línea', newDetalleView);
    };
    /**
     * @param {?} detalle
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.showModalEditar = /**
     * @param {?} detalle
     * @return {?}
     */
    function (detalle) {
        this.showDialogEditar('EDITAR', 'Editar línea', detalle);
    };
    /**
     * @param {?} tipoVentana
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.showSalirModal = /**
     * @param {?} tipoVentana
     * @return {?}
     */
    function (tipoVentana) {
        if (tipoVentana == 'CANCELAR') {
            this.showAccionReutilizar('Alerta', '¿Desea cancelar los cambios realizados?', true, tipoVentana);
        }
        if (tipoVentana == 'GUARDAR') {
            this.showAccionReutilizar('Alerta', '¿Desea guardar los cambios realizados?', true, tipoVentana);
        }
        if (tipoVentana == 'Finalizar') {
            this.showAccionReutilizar('Alerta', '¿Desea dejar la reutilización disponible para ser enviado a cobro?', true, tipoVentana);
        }
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} tipoVentana
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.showAccionReutilizar = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} tipoVentana
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel, tipoVentana) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            if ('CANCELAR' == tipoVentana) {
                if (result) {
                    _this.toReutilizar();
                }
            }
            if ('GUARDAR' == tipoVentana) {
                if (result) {
                    _this.saveReuTemp(false);
                }
            }
            if ('Finalizar' == tipoVentana) {
                if (result) {
                    _this.saveReuTemp(true);
                }
            }
        }));
    };
    /**
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.preRemove = /**
     * @return {?}
     */
    function () {
        this.showDialogPre('Información', '¿Está seguro de eliminar los elementos selecionados?', true);
    };
    /**
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.removeSelectedRows = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.selection.selected.forEach((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            /** @type {?} */
            var index = _this.reutilizarFacturacionView.detalles.findIndex((/**
             * @param {?} d
             * @return {?}
             */
            function (d) { return d === item; }));
            _this.reutilizarFacturacionView.detalles.splice(index, 1);
        }));
        this.refreshDataSource();
        this.selection = new SelectionModel(true, []);
    };
    /**
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.toReutilizar = /**
     * @return {?}
     */
    function () {
        this.router.navigate(['../reutilizar'], { relativeTo: this.route });
    };
    /**
     * @param {?} toFacturacion
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.saveReuTemp = /**
     * @param {?} toFacturacion
     * @return {?}
     */
    function (toFacturacion) {
        var _this = this;
        /** @type {?} */
        var cantNulos = 0;
        this.reutilizarFacturacionView.detalles.forEach((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            if (item.idServicio == null || item.idServicio == '' || item.monto == 0) {
                cantNulos += 1;
            }
        }));
        if (cantNulos > 0) {
            this.showDialogDetalle('Información', ' Algunos campos en los registros contienen valores no válidos.', false);
        }
        else {
            /** @type {?} */
            var paramsReutilizarAgregar_1 = new FacturacionReutilizarAgregarPeticion();
            paramsReutilizarAgregar_1.codCliente = this.codCliente;
            paramsReutilizarAgregar_1.idUsuario = this.idUsuario;
            paramsReutilizarAgregar_1.docEmpresa = this.docEmpresa;
            paramsReutilizarAgregar_1.codTpoPortal = this.codTpoPortal;
            paramsReutilizarAgregar_1.nomFacturador = this.reutilizarParams.nombreFacturador;
            paramsReutilizarAgregar_1.idConvenio = this.reutilizarParams.idConvenio;
            if (toFacturacion) {
                paramsReutilizarAgregar_1.toFacturacion = true;
            }
            else {
                paramsReutilizarAgregar_1.toFacturacion = false;
            }
            paramsReutilizarAgregar_1.idReutilizar = this.reutilizarParams.idReutilizar.toString();
            paramsReutilizarAgregar_1.idProceso = 0;
            paramsReutilizarAgregar_1.cantRegistros = this.reutilizarFacturacionView.detalles.length;
            paramsReutilizarAgregar_1.monto = this.reutilizarFacturacionView.monto;
            paramsReutilizarAgregar_1.tipoMoneda = this.reutilizarFacturacionView.tipoMoneda;
            paramsReutilizarAgregar_1.fechaIngreso = this.reutilizarFacturacionView.fechaCreacion;
            paramsReutilizarAgregar_1.idFacturador = this.reutilizarFacturacionView.idFacturador;
            paramsReutilizarAgregar_1.nomArchivo = this.reutilizarFacturacionView.nombre;
            /** @type {?} */
            var countFecha_1 = 0;
            this.reutilizarFacturacionView.detalles.forEach((/**
             * @param {?} detalle
             * @return {?}
             */
            function (detalle) {
                if (new Date(detalle.fechaCobro) < _this.addDays(-1)) {
                    countFecha_1++;
                }
                /** @type {?} */
                var detalleFinal = new ReutilizarFacturacionDetalleView();
                detalleFinal.idServicio = detalle.idServicio;
                detalleFinal.monto = detalle.monto;
                detalleFinal.fechaCobro = detalle.fechaCobro;
                detalleFinal.adicional1 = detalle.adicional1;
                detalleFinal.adicional2 = detalle.adicional2;
                detalleFinal.adicional3 = detalle.adicional3;
                detalleFinal.adicional4 = detalle.adicional4;
                detalleFinal.adicional5 = detalle.adicional5;
                detalleFinal.adicional6 = detalle.adicional6;
                detalleFinal.adicional7 = detalle.adicional7;
                detalleFinal.tipoMoneda = detalle.tipoMoneda;
                paramsReutilizarAgregar_1.listReutilizar.push(detalleFinal);
            }));
            if (toFacturacion && paramsReutilizarAgregar_1.listReutilizar.length == 0) {
                this.showDialogDetalle('Información', 'Agregue registros e inténtelo nuevamente.', false);
            }
            else if (toFacturacion && countFecha_1 > 0) {
                this.showDialogDetalle('Información', 'Algunos registros tienen fecha de cobro anterior a hoy.', false);
            }
            else {
                this.postReutilizarAgregarServices(paramsReutilizarAgregar_1);
            }
        }
    };
    /**
     * @param {?} days
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.addDays = /**
     * @param {?} days
     * @return {?}
     */
    function (days) {
        /** @type {?} */
        var futureDate = this.minDate;
        futureDate.setDate(futureDate.getDate() + days);
        return futureDate;
    };
    /**
     * @param {?} body
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.postReutilizarAgregarServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.facturacionHistorialService.postReutilizarAgregar(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.loader.hide();
                if (body.toFacturacion) {
                    _this.showDialog('Información', 'El borrador reutilizado se ha procesado correctamente.', false);
                }
                else {
                    _this.showDialog('Información', 'El borrador se ha guardado correctamente.', false);
                }
            }
            else if (data.codret == '1') {
                _this.loader.hide();
                _this.showDialog('Información', 'El borrador reutilizado se ha procesado correctamente, pero requiere autorización.', false);
            }
            else {
                _this.loader.hide();
                _this.showDialogDetalle('Error', data.descret, false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            _this.showDialogDetalle('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.updateFecha = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.reutilizarFacturacionView.detalles.forEach((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            item.fechaCobro = (event.value).toISOString();
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.showDialogPre = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            if (result) {
                _this.removeSelectedRows();
            }
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            _this.toReutilizar();
        }));
    };
    /**
     * @param {?} monto
     * @param {?} moneda
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.formateandoMonto = /**
     * @param {?} monto
     * @param {?} moneda
     * @return {?}
     */
    function (monto, moneda) {
        return FormatoMonedaUtil.formatearMontoParam(parseInt(monto), moneda);
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    FacturacionReutilizarDetalleComponent.prototype.showDialogDetalle = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
        }));
    };
    FacturacionReutilizarDetalleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'facturacion-reutilizar-detalle',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"row\" style=\"margin-bottom: 10px;\">\r\n      <div class=\"col-12 text-right\">\r\n        <button class=\"btn-small secundario\" (click)=\"showSalirModal('CANCELAR')\">Cancelar</button>\r\n        <button class=\"btn-small secundario\" (click)=\"showSalirModal('GUARDAR')\">Guardar borrador</button>\r\n        <button type=\"submit\" class=\"btn-small main\" (click)=\"showSalirModal('Finalizar')\"><i class=\"str-icon-ok mr-1\"></i> Finalizar</button>\r\n      </div>\r\n    </div>\r\n    <div class=\"modulo-cuentas detalle\">\r\n      <div class=\"row\" style=\"margin-bottom: 10px;\">\r\n        <div class=\"col-12\"><h5>Nombre: {{reutilizarFacturacionView.nombre}}</h5></div>\r\n      </div>\r\n      <div class=\"row\" style=\"margin-bottom: 10px;\">\r\n        <div class=\"col-3\" style=\"margin: auto;\">Cantidad registros: {{reutilizarFacturacionView.cantidad}}</div>\r\n        <div class=\"col-3\" style=\"margin: auto;\">Monto total: {{montoFormateado}}</div>\r\n        <div class=\"col-3\" style=\"margin: auto;\">Fecha de creaci&oacute;n: {{reutilizarFacturacionView.fechaCreacion | date:'dd/MM/yyyy'}}</div>\r\n        <div class=\"col-3\" style=\"margin: auto;\">Estado del proceso: <span class=\"databar ingresado\">{{reutilizarFacturacionView.estado}}</span></div>\r\n      </div>\r\n      <div class=\"row\" style=\"margin-bottom: 10px;\">\r\n        <div class=\"col-12\">\r\n          <form [formGroup]=\"formGroupAgregar\" autocomplete=\"off\">\r\n            <button *ngIf=\"selection.hasValue()\" class=\"btn-small secundario\" (click)=\"preRemove()\"><i class=\"str-icon-trash\"></i> Eliminar</button>\r\n            <button class=\"btn-small secundario\" (click)=\"showModalAgregarLinea()\"><i class=\"str-icon-mas\"></i>Agregar l\u00EDnea</button>\r\n            <button class=\"btn-small secundario\" (click)=\"pickerFechaTotal.open()\"><i class=\"str-icon-calendario\"></i> Actualizar fechas de cobro</button>\r\n            <mat-form-field style=\"display: none;\">\r\n              <input matInput [matDatepicker]=\"pickerFechaTotal\" [min]=\"minDate\" placeholder=\"Fecha para cobro\" formControlName=\"updateFechaPaCobro\" (dateInput)=\"updateFecha($event)\">\r\n              <mat-datepicker-toggle matSuffix [for]=\"pickerFechaTotal\"></mat-datepicker-toggle>\r\n              <mat-datepicker touchUi #pickerFechaTotal></mat-datepicker>\r\n            </mat-form-field>\r\n          </form>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col-12\">\r\n          <div class=\"table-container detalle table-responsive-lg\">\r\n            <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n              <ng-container matColumnDef=\"select\">\r\n                <th mat-header-cell *matHeaderCellDef>\r\n                  <mat-checkbox (change)=\"$event ? masterToggle() : null\"\r\n                    [checked]=\"selection.hasValue() && isAllSelected()\"\r\n                    [indeterminate]=\"selection.hasValue() && !isAllSelected()\" [aria-label]=\"checkboxLabel()\">\r\n                  </mat-checkbox>\r\n                </th>\r\n                <td mat-cell *matCellDef=\"let row\">\r\n                  <mat-checkbox (click)=\"$event.stopPropagation()\" (change)=\"$event ? selection.toggle(row) : null\"\r\n                    [checked]=\"selection.isSelected(row)\" [aria-label]=\"checkboxLabel(row)\">\r\n                  </mat-checkbox>\r\n                </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"idServicio\">\r\n                <th mat-header-cell *matHeaderCellDef>ID Servicio</th>\r\n                <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\">{{resultado.idServicio}}</td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"montoFacturacion\">\r\n                <th mat-header-cell *matHeaderCellDef [style.display]=\"viewColMonto ? '' : 'none'\">Monto</th>\r\n                <td mat-cell *matCellDef=\"let resultado\" [style.display]=\"viewColMonto ? '' : 'none'\">{{formateandoMonto(resultado.monto, resultado.tipoMoneda)}}</td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"fechaFacturacion\">\r\n                <th mat-header-cell *matHeaderCellDef [style.display]=\"viewColFechaCobro ? '' : 'none'\">Fecha para cobro</th>\r\n                <td mat-cell *matCellDef=\"let resultado\" [style.display]=\"viewColFechaCobro ? '' : 'none'\">{{resultado.fechaCobro | date:'dd/MM/yyyy'}}</td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"datoAdicional1\">\r\n                <th mat-header-cell *matHeaderCellDef [style.display]=\"viewColAdicional1 ? '' : 'none'\">Dato Adic.1</th>\r\n                <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\" [style.display]=\"viewColAdicional1 ? '' : 'none'\">{{resultado.adicional1}}</td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"datoAdicional2\">\r\n                <th mat-header-cell *matHeaderCellDef [style.display]=\"viewColAdicional2 ? '' : 'none'\">Dato Adic.2</th>\r\n                <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\" [style.display]=\"viewColAdicional2 ? '' : 'none'\">{{resultado.adicional2}}</td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"datoAdicional3\">\r\n                <th mat-header-cell *matHeaderCellDef [style.display]=\"viewColAdicional3 ? '' : 'none'\">Dato Adic.3</th>\r\n                <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\" [style.display]=\"viewColAdicional3 ? '' : 'none'\">{{resultado.adicional3}}</td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"datoAdicional4\">\r\n                <th mat-header-cell *matHeaderCellDef [style.display]=\"viewColAdicional4 ? '' : 'none'\">Dato Adic.4</th>\r\n                <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\" [style.display]=\"viewColAdicional4 ? '' : 'none'\">{{resultado.adicional4}}</td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"datoAdicional5\">\r\n                <th mat-header-cell *matHeaderCellDef [style.display]=\"viewColAdicional5 ? '' : 'none'\">Dato Adic.5</th>\r\n                <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\" [style.display]=\"viewColAdicional5 ? '' : 'none'\">{{resultado.adicional5}}</td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"datoAdicional6\">\r\n                <th mat-header-cell *matHeaderCellDef [style.display]=\"viewColAdicional6 ? '' : 'none'\">Dato Adic.6</th>\r\n                <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\" [style.display]=\"viewColAdicional6 ? '' : 'none'\">{{resultado.adicional6}}</td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"datoAdicional7\">\r\n                <th mat-header-cell *matHeaderCellDef [style.display]=\"viewColAdicional7 ? '' : 'none'\">Dato Adic.7</th>\r\n                <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\" [style.display]=\"viewColAdicional7 ? '' : 'none'\">{{resultado.adicional7}}</td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"editar\">\r\n                <th mat-header-cell *matHeaderCellDef>Editar</th>\r\n                <td mat-cell *matCellDef=\"let resultado\">\r\n                  <a (click)=\"showModalEditar(resultado)\"><i class=\"icon str-icon-editar\"></i></a>\r\n                </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"config\">\r\n                <th class=\"field-selector\" mat-header-cell *matHeaderCellDef>\r\n                  <div class=\"col\">\r\n                    <ng-template #popContent>\r\n                      <strong><span>Visualizaci&oacute;n de columnas<br></span></strong>\r\n                      <div class=\"dropdown-divider\"></div>\r\n                      <div class=\"form-check form-check-inline\">\r\n                        <mat-checkbox class=\"example-margin\" [(ngModel)]=\"viewColMonto\">Monto</mat-checkbox>\r\n                      </div>\r\n                      <div class=\"form-check form-check-inline\">\r\n                        <mat-checkbox class=\"example-margin\" [(ngModel)]=\"viewColFechaCobro\">Fecha para Cobro</mat-checkbox>\r\n                      </div>\r\n                      <div class=\"form-check form-check-inline\">\r\n                        <mat-checkbox class=\"example-margin\" [(ngModel)]=\"viewColAdicional1\">Dato Adic.1</mat-checkbox>\r\n                      </div>\r\n                      <div class=\"form-check form-check-inline\">\r\n                        <mat-checkbox class=\"example-margin\" [(ngModel)]=\"viewColAdicional2\">Dato Adic.2</mat-checkbox>\r\n                      </div>\r\n                      <div class=\"form-check form-check-inline\">\r\n                        <mat-checkbox class=\"example-margin\" [(ngModel)]=\"viewColAdicional3\">Dato Adic.3</mat-checkbox>\r\n                      </div>\r\n                      <div class=\"form-check form-check-inline\">\r\n                        <mat-checkbox class=\"example-margin\" [(ngModel)]=\"viewColAdicional4\">Dato Adic.4</mat-checkbox>\r\n                      </div>\r\n                      <div class=\"form-check form-check-inline\">\r\n                        <mat-checkbox class=\"example-margin\" [(ngModel)]=\"viewColAdicional5\">Dato Adic.5</mat-checkbox>\r\n                      </div>\r\n                      <div class=\"form-check form-check-inline\">\r\n                        <mat-checkbox class=\"example-margin\" [(ngModel)]=\"viewColAdicional6\">Dato Adic.6</mat-checkbox>\r\n                      </div>\r\n                      <div class=\"form-check form-check-inline\">\r\n                        <mat-checkbox class=\"example-margin\" [(ngModel)]=\"viewColAdicional7\">Dato Adic.7</mat-checkbox>\r\n                      </div>\r\n                    </ng-template>\r\n                    <a type=\"button\" class=\"field-config\" data-toggle=\"popover\" data-trigger=\"focus\"\r\n                      data-placement=\"bottom-right\" data-html=\"true\" [ngbPopover]=\"popContent\"><i\r\n                        class=\"icon str-icon-configurar\"></i></a>\r\n                  </div>\r\n                </th>\r\n                <td mat-cell *matCellDef=\"let resultado\">\r\n                </td>\r\n              </ng-container>\r\n              <tr mat-header-row *matHeaderRowDef=\"columnsToDisplay\"></tr>\r\n              <tr mat-row *matRowDef=\"let row; columns: columnsToDisplay;\"\r\n                [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\"\r\n                (mouseout)=\"row.hovered = false\" (click)=\"selection.toggle(row)\"></tr>\r\n            </table>\r\n            <mat-paginator [pageSizeOptions]=\"[10]\" showFirstLastButtons></mat-paginator>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [
                        { provide: DateAdapter$2, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE$2] },
                        { provide: MAT_DATE_FORMATS$2, useValue: ɵ0$b }
                    ]
                }] }
    ];
    /** @nocollapse */
    FacturacionReutilizarDetalleComponent.ctorParameters = function () { return [
        { type: FacturacionHistorialService },
        { type: Router },
        { type: ActivatedRoute },
        { type: MatDialog },
        { type: LoaderBaseService },
        { type: FacturacionReutilizarParams },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    FacturacionReutilizarDetalleComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator$1,] }]
    };
    return FacturacionReutilizarDetalleComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DasboardPeticion = /** @class */ (function () {
    function DasboardPeticion() {
        this.idFacturador = '-1';
        /* Cantidad de mandatos activos */
        this.estadoMandato = '-1';
        /* Monto recaudado por PAR en el último mes */
        this.estadoFacturacion = '-1';
        /* Monto enviado a cobro en el último mes */
        this.estadoFacturacion1 = '-1';
        this.estadoFacturacion2 = '-1';
        this.estadoFacturacion3 = '-1';
        /* Mandatos con cobro aceptado (último mes) */
        this.estadoCobroAceptado = '-1';
        /* Mandatos con cobro rechazado (último mes) */
        this.estadoCobroRechazado = '-1';
        /* Distribución */
        this.estadoMandatoIngresado = '-1';
        this.estadoMandatoRechazado = '-1';
        this.estadoMandatoEliminado = '-1';
    }
    return DasboardPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var httpOptions$7 = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};
var DashboardService = /** @class */ (function () {
    function DashboardService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlDashboard = this.environment.urlAmbiente + '/apiIndicadoresMT/dashboard';
        this.urlDashboardAdquirente = this.environment.urlAmbiente + '/apiIndicadoresMT/dashboardAdquirente';
    }
    /**
     * @param {?} _body
     * @return {?}
     */
    DashboardService.prototype.postDashboard = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlDashboard, _body, httpOptions$7);
    };
    /**
     * @param {?} _body
     * @return {?}
     */
    DashboardService.prototype.postDashboardAdquirente = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlDashboardAdquirente, _body, httpOptions$7);
    };
    DashboardService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    DashboardService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return DashboardService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//import es from '@angular/common/locales/es';
//registerLocaleData(es);
var DashboardComponent = /** @class */ (function () {
    function DashboardComponent(phttp, loader) {
        this.phttp = phttp;
        this.loader = loader;
        this.chartValue1 = 0;
        this.chartValue2 = 0;
        this.chartValue3 = 0;
        this.view = [150, 150];
        this.colorScheme = { domain: ['#cc0000'] };
        this.data = [];
        this.colorScheme2 = { domain: ['#f5aa2e', '#cc0000', '#32a197', '#444', '#146eb2'] };
        this.single = [];
        this.mandatoIngresado = 0;
        this.mandatoRechazado = 0;
        this.mandatoActivo = 0;
        this.mandatoEliminado = 0;
        this.mandatoSuspendido = 0;
        this.distMandatoTotal = 0;
        this.ingresado = 0;
        this.rechazado = 0;
        this.aceptado = 0;
        this.eliminado = 0;
        this.suspendidos = 0;
        /* mandatoSinCobroMes1 = 0;
          mandatoSinCobroMes2 = 0;
          mandatoSinCobroMes3 = 0; */
        this.peticionDashboard = new DasboardPeticion();
        this.mensajeError = 0;
        this.chartOverride1 = {
            strokeWidth: DonutWidth.Thick,
            gradientColors: ['#146eb2'],
            baseColor: '#dae5c9',
            textColor: '#146eb2',
            gradientDirection: DonutGradientOrigin.BottomLeft,
            label: '',
            title: 'Efectividad de recaudación',
        };
        this.chartOverride2 = {
            strokeWidth: DonutWidth.Thick,
            gradientColors: ['#32a197'],
            baseColor: '#dae5c9',
            textColor: '#32a197',
            gradientDirection: DonutGradientOrigin.BottomLeft,
            label: '',
            title: 'Mandatos con cobro aceptado (último mes)'
        };
        this.chartOverride3 = {
            strokeWidth: DonutWidth.Thick,
            gradientColors: ['#cc0000'],
            baseColor: '#dae5c9',
            textColor: '#cc0000',
            gradientDirection: DonutGradientOrigin.BottomLeft,
            label: '',
            title: 'Mandatos con cobro rechazado (último mes)'
        };
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idEmpresaPac = this.userPerfil.empresa.idEmpresaPac;
        //this.idEmpresaPac = '324';
    }
    /**
     * @return {?}
     */
    DashboardComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        //this.calculoFechas();
        this.peticionDashboard.idFacturador = this.idEmpresaPac;
        this.peticionDashboard.estadoMandato = '3';
        this.peticionDashboard.estadoFacturacion = '0';
        this.peticionDashboard.estadoFacturacion1 = '1';
        this.peticionDashboard.estadoFacturacion2 = '2';
        this.peticionDashboard.estadoFacturacion3 = '3';
        this.peticionDashboard.estadoCobroAceptado = '0';
        this.peticionDashboard.estadoCobroRechazado = '1';
        this.peticionDashboard.estadoMandatoIngresado = '1';
        this.peticionDashboard.estadoMandatoRechazado = '2';
        this.peticionDashboard.estadoMandatoEliminado = '4';
        this.postSentDashboardServices(this.peticionDashboard);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    DashboardComponent.prototype.postSentDashboardServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.phttp.postDashboard(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                console.log(data);
                _this.resultadoDashboard = [];
                _this.resultadoDashboard.push(data);
                sessionStorage.setItem('dasboardComercio', JSON.stringify(data));
                _this.dasboardComercio = JSON.parse(sessionStorage.getItem('dasboardComercio'));
                _this.mes = _this.dasboardComercio.mes;
                _this.mes1 = _this.dasboardComercio.mes1;
                _this.mes2 = _this.dasboardComercio.mes2;
                _this.mes3 = _this.dasboardComercio.mes3;
                /** @type {?} */
                var mandatoCobroTotal = _this.dasboardComercio.resultado[0].mandatoCobroTotal;
                /** @type {?} */
                var mandatoCobroAceptado = _this.dasboardComercio.resultado[0].mandatoCobroAceptado;
                /** @type {?} */
                var mandatoCobroRechazado = _this.dasboardComercio.resultado[0].mandatoCobroRechazado;
                if (mandatoCobroTotal > 0) {
                    _this.chartValue2 = ((mandatoCobroAceptado * 100) / mandatoCobroTotal) / 100;
                    _this.chartValue3 = ((mandatoCobroRechazado * 100) / mandatoCobroTotal) / 100;
                }
                else {
                    _this.chartValue2 = 0;
                    _this.chartValue3 = 0;
                }
                if (_this.dasboardComercio.resultado[0].cantidadACobro > 0) {
                    _this.chartValue1 = ((_this.dasboardComercio.resultado[0].cantidadRecaudadoPat * 100) / _this.dasboardComercio.resultado[0].cantidadACobro) / 100;
                }
                else {
                    _this.chartValue1 = 0;
                }
                /* Distribución de mandatos */
                _this.mandatoIngresado = _this.dasboardComercio.resultado[0].mandatoIngresado;
                _this.mandatoRechazado = _this.dasboardComercio.resultado[0].mandatoRechazado;
                _this.mandatoActivo = _this.dasboardComercio.resultado[0].mandatosActivos;
                _this.mandatoEliminado = _this.dasboardComercio.resultado[0].mandatoEliminado;
                _this.mandatoSuspendido = _this.dasboardComercio.resultado[0].mandatoSuspendido;
                _this.distMandatoTotal = _this.dasboardComercio.resultado[0].distMandatoTotal;
                _this.totalMandatos = 'Total: ' + _this.distMandatoTotal;
                if (_this.distMandatoTotal > 0) {
                    _this.ingresado = Math.round((_this.mandatoIngresado * 100) / _this.distMandatoTotal);
                    _this.rechazado = Math.round((_this.mandatoRechazado * 100) / _this.distMandatoTotal);
                    _this.aceptado = Math.round((_this.mandatoActivo * 100) / _this.distMandatoTotal);
                    _this.eliminado = Math.round((_this.mandatoEliminado * 100) / _this.distMandatoTotal);
                    _this.suspendidos = Math.round((_this.mandatoSuspendido * 100) / _this.distMandatoTotal);
                }
                else {
                    _this.ingresado = 0;
                    _this.rechazado = 0;
                    _this.aceptado = 0;
                    _this.eliminado = 0;
                }
                /* this.mandatoSinCobroMes1 = this.dasboardComercio.resultado[0].mandatoSinCobroMes1;
                this.mandatoSinCobroMes2 = this.dasboardComercio.resultado[0].mandatoSinCobroMes2;
                this.mandatoSinCobroMes3 = this.dasboardComercio.resultado[0].mandatoSinCobroMes3; */
                _this.data = [
                    {
                        'name': 'Cantidad',
                        'series': [
                            {
                                'value': _this.dasboardComercio.resultado[0].mandatoSinCobroMes1,
                                'name': 'últimos 3 meses'
                            },
                            {
                                'value': _this.dasboardComercio.resultado[0].mandatoSinCobroMes2,
                                'name': 'entre 4 a 6 meses'
                            },
                            {
                                'value': _this.dasboardComercio.resultado[0].mandatoSinCobroMes3,
                                'name': 'más de 6 meses'
                            }
                        ]
                    }
                ];
                _this.single = [
                    {
                        'name': 'Ingresados',
                        'value': _this.mandatoIngresado
                    },
                    {
                        'name': 'Rechazados',
                        'value': _this.mandatoRechazado
                    },
                    {
                        'name': 'Activos',
                        'value': _this.mandatoActivo
                    },
                    {
                        'name': 'Eliminados',
                        'value': _this.mandatoEliminado
                    },
                    {
                        'name': 'Suspendidos',
                        'value': _this.mandatoSuspendido
                    }
                ];
                _this.loader.hide();
            }
            else {
                console.log('Error: ', 'No se pudo mostrar el Dashboard ' + data.descret);
                _this.mensajeError = 1;
                _this.loader.hide();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.log('Error: ', 'No se pudo mostrar el Dashboard ' + err);
            _this.mensajeError = 1;
            _this.loader.hide();
        }));
    };
    /**
     * @param {?} monto
     * @param {?} moneda
     * @return {?}
     */
    DashboardComponent.prototype.montoFormato = /**
     * @param {?} monto
     * @param {?} moneda
     * @return {?}
     */
    function (monto, moneda) {
        return FormatoMonedaUtil.montoFormato(monto, moneda);
    };
    /**
     * @return {?}
     */
    DashboardComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('dasboardComercio');
        sessionStorage.removeItem('componenteHijo');
    };
    DashboardComponent.decorators = [
        { type: Component, args: [{
                    selector: 'dashboard',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\" *ngFor=\"let resultados of resultadoDashboard\">\r\n    <!-- <h3 class=\"titulo-seccion\">Indicadores de recaudaci\u00F3n PAR</h3> -->\r\n    <div class=\"dashboard-gestion\" *ngFor=\"let dato of resultados.resultado\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-4\">\r\n          <div class=\"modulo-dashboard box-small\">\r\n            <h3 style=\"line-height: normal;\">Cantidad de mandatos activos</h3>\r\n            <h2 class=\"blue\"><i class=\"icon str-icon-pac\"></i> {{dato.mandatosActivos | cantidad}}</h2>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-4\">\r\n          <div class=\"modulo-dashboard box-small\">\r\n            <h3 style=\"line-height: normal;\">Monto recaudado por PAR</h3>\r\n            <div class=\"doble-valor small\">\r\n              <span style=\"font-weight:bold;font-size: 10px;\">Mes Anterior ({{mes1}})</span>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                  <h2 class=\"green\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">UYU {{montoFormato(dato.montoRecaudadoPat, 'UYU')}}</h2>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                  <h2 class=\"green\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">USD {{montoFormato(dato.montoRecaudadoPatDolar, 'USD')}}</h2>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"doble-valor small\">\r\n              <span style=\"font-weight:bold;font-size: 10px;\">Mes en curso ({{mes}})</span>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                  <h2 class=\"green\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">UYU {{montoFormato(dato.montoRecaudadoPatMesActual, 'UYU')}}</h2>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                  <h2 class=\"green\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">USD {{montoFormato(dato.montoRecaudadoPatMesActualDolar, 'USD')}}</h2>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-4\">\r\n          <div class=\"modulo-dashboard box-small\">\r\n            <h3 style=\"line-height: normal;\">Monto enviado a cobro</h3>\r\n            <div class=\"doble-valor small\">\r\n              <span style=\"font-weight:bold;font-size: 10px;\">Mes Anterior ({{mes1}})</span>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                  <h2 class=\"yellow\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">UYU {{montoFormato(dato.montoACobro, 'UYU')}}</h2>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                  <h2 class=\"yellow\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">USD {{montoFormato(dato.montoACobroDolar, 'USD')}}</h2>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"doble-valor small\">\r\n              <span style=\"font-weight:bold;font-size: 10px;\">Mes en curso ({{mes}})</span>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                  <h2 class=\"yellow\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">UYU {{montoFormato(dato.montoACobroMesActual, 'UYU')}}</h2>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                  <h2 class=\"yellow\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">USD {{montoFormato(dato.montoACobroMesActualDolar, 'USD')}}</h2>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-md-4\">\r\n          <div class=\"modulo-dashboard box-medium\">\r\n            <h3 style=\"line-height: normal;\">Efectividad de recaudaci&oacute;n (Mes anterior)</h3>\r\n            <div class=\"donut-gauge-demo\">\r\n              <div class='donut-gauge-demo__small'>\r\n                <ngx-donut-gauge [value]=chartValue1 [config]=chartOverride1></ngx-donut-gauge>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <!-- <button class=\"demo-page__button demo-page__button--large\" (click)=\"changeValue()\">Change Value</button> -->\r\n        </div>\r\n        <div class=\"col-md-4\">\r\n          <div class=\"modulo-dashboard box-medium\">\r\n            <h3 style=\"line-height: normal;\">Mandatos con cobro aceptado (Mes anterior)</h3>\r\n            <div class=\"row align-items-center\">\r\n              <div class=\"col-md-12 col-lg-6 chart\">\r\n                <div class=\"donut-gauge-demo\">\r\n                  <div class='donut-gauge-demo__small'>\r\n                    <ngx-donut-gauge [value]=chartValue2 [config]=chartOverride2></ngx-donut-gauge>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-md-12 col-lg-6 cifras\">\r\n                <h4 class=\"green\">{{dato.mandatoCobroAceptado | cantidad}}</h4>\r\n                <span class=\"total\"><strong>/ {{dato.mandatoCobroTotal | cantidad}}</strong></span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-4\">\r\n          <div class=\"modulo-dashboard box-medium\">\r\n            <h3 style=\"line-height: normal;\">Mandatos con cobro rechazado (Mes anterior)</h3>\r\n            <div class=\"row align-items-center\">\r\n              <div class=\"col-md-12 col-lg-6 chart\">\r\n                <div class=\"donut-gauge-demo\">\r\n                  <div class='donut-gauge-demo__small'>\r\n                    <ngx-donut-gauge [value]=chartValue3 [config]=chartOverride3></ngx-donut-gauge>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-md-12 col-lg-6 cifras\">\r\n                <h4 class=\"red\">{{dato.mandatoCobroRechazado | cantidad}}</h4>\r\n                <span class=\"total\"><strong>/ {{dato.mandatoCobroTotal | cantidad}}</strong></span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-md-8\">\r\n\r\n          <div class=\"modulo-dashboard box-medium\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-6\">\r\n                <h3 style=\"line-height: normal;\">Monto recaudado (&uacute;ltimos meses)</h3>\r\n                <div class=\"doble-valor small\">\r\n                  <span style=\"font-weight:bold;font-size: 10px;\">Mes: ({{mes3}})</span>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                      <h2 class=\"green\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">UYU {{montoFormato(dato.montoRecaudadoMes3, 'UYU')}}</h2>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                      <h2 class=\"green\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">USD {{montoFormato(dato.montoRecaudadoDolarMes3, 'USD')}}</h2>\r\n                    </div>\r\n                  </div>\r\n                  <span style=\"font-weight:bold;font-size: 10px;\">Mes: ({{mes2}})</span>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                      <h2 class=\"green\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">UYU {{montoFormato(dato.montoRecaudadoMes2, 'UYU')}}</h2>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                      <h2 class=\"green\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">USD {{montoFormato(dato.montoRecaudadoDolarMes2, 'USD')}}</h2>\r\n                    </div>\r\n                  </div>\r\n                  <span style=\"font-weight:bold;font-size: 10px;\">Mes: ({{mes1}})</span>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                      <h2 class=\"green\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">UYU {{montoFormato(dato.montoRecaudadoMes1, 'UYU')}}</h2>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                      <h2 class=\"green\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">USD {{montoFormato(dato.montoRecaudadoDolarMes1, 'USD')}}</h2>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-md-6\">\r\n                <h3 style=\"line-height: normal;\">Monto enviado a cobro (&uacute;ltimos meses)</h3>\r\n                <div class=\"doble-valor small\">\r\n                  <span style=\"font-weight:bold;font-size: 10px;\">Mes: ({{mes3}})</span>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                      <h2 class=\"green\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">UYU {{montoFormato(dato.montoACobroMes3, 'UYU')}}</h2>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                      <h2 class=\"green\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">USD {{montoFormato(dato.montoACobroDolarMes3, 'USD')}}</h2>\r\n                    </div>\r\n                  </div>\r\n                  <span style=\"font-weight:bold;font-size: 10px;\">Mes: ({{mes2}})</span>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                      <h2 class=\"green\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">UYU {{montoFormato(dato.montoACobroMes2, 'UYU')}}</h2>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                      <h2 class=\"green\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">USD {{montoFormato(dato.montoACobroDolarMes2, 'USD')}}</h2>\r\n                    </div>\r\n                  </div>\r\n                  <span style=\"font-weight:bold;font-size: 10px;\">Mes: ({{mes1}})</span>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                      <h2 class=\"green\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">UYU {{montoFormato(dato.montoACobroMes1, 'UYU')}}</h2>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                      <h2 class=\"green\" style=\"line-height: normal;font-size: 15px;margin-top: 0;\">USD {{montoFormato(dato.montoACobroDolarMes1, 'USD')}}</h2>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\" col-md-12 modulo-dashboard box-large\">\r\n            <h3 style=\"line-height: normal;\">Cantidad de mandatos activos sin cobro (&uacute;ltimos meses)</h3>\r\n            <div class=\"chart mt-3\">\r\n              <div style=\"position: absolute; width: 90%; height: 400px; left: 5%; top: 15%; right: 5%; bottom: 0\">\r\n                <ngx-charts-line-chart style=\"position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)\" [scheme]=\"colorScheme\" [results]=\"data\" [xAxis]=\"true\" [showXAxisLabel]=\"true\" xAxisLabel=\"Meses anteriores\" [yAxis]=\"true\" [showYAxisLabel]=\"true\" yAxisLabel=\"Cantidad\" [roundDomains]=\"true\" [autoScale]=\"false\" [timeline]=\"true\">\r\n                </ngx-charts-line-chart>\r\n              </div>\r\n              <div style=\"height: 400px\"></div>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"col-md-4\">\r\n          <div class=\"modulo-dashboard box-medium\">\r\n            <h3 style=\"line-height: normal;\">Distribuci&oacute;n de mandatos</h3>\r\n            <div class=\"row align-items-center\">\r\n              <div class=\"col-lg-7 chart\">\r\n                <!-- [view]=\"view\" -->\r\n                <ngx-charts-pie-chart [scheme]=\"colorScheme2\" [results]=\"single\" [legend]=\"false\" [doughnut]=\"true\" [title]=\"totalMandatos\" [gradient]=\"true\" [animations]=\"true\">\r\n                </ngx-charts-pie-chart>\r\n              </div>\r\n              <div class=\"col-lg-5 cifras\">\r\n                <h4 class=\"yellow\"> {{ingresado}}%</h4>\r\n                <small><strong>Ingresados</strong></small>\r\n\r\n                <h4 class=\"red mt-2\"> {{rechazado}}%</h4>\r\n                <small><strong>Rechazados</strong></small>\r\n\r\n                <h4 class=\"green\"> {{aceptado}}%</h4>\r\n                <small><strong>Activos</strong></small>\r\n\r\n                <h4 class=\"eliminado\"> {{eliminado}}%</h4>\r\n                <small><strong>Eliminados</strong></small>\r\n\r\n                <h4 class=\"blue\"> {{suspendidos}}%</h4>\r\n                <small><strong>Suspendidos</strong></small>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n\r\n\r\n  </div>\r\n</section>\r\n\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div *ngIf=\"mensajeError == 1\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" id=\"modal-basic-title\" style=\"color:#ec0000;font-weight: bold\">Error</h3>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <p>Servicio temporalmente no disponible.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [DashboardService],
                    styles: ['./dashboard.component.css']
                }] }
    ];
    /** @nocollapse */
    DashboardComponent.ctorParameters = function () { return [
        { type: DashboardService },
        { type: LoaderBaseService }
    ]; };
    return DashboardComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DasboardAdquirentePeticion = /** @class */ (function () {
    function DasboardAdquirentePeticion() {
        this.estadoMandatoActivo = '-1';
        this.estadoFacturacionPagada = '-1';
        this.estadoMandatoEliminado = '-1';
        this.estadoFacturacionRechazada = '-1';
        this.estadoFacturacionEnCurso = '-1';
        this.estadoFacturacionReintento = '-1';
        this.estadoFacturacionIngresada = '-1';
        this.codCliente = '-1';
        this.codEstadoConvenio = '-1';
    }
    return DasboardAdquirentePeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DashboardAdquirenteComponent = /** @class */ (function () {
    function DashboardAdquirenteComponent(phttp, loader, cnvService, environment) {
        this.phttp = phttp;
        this.loader = loader;
        this.cnvService = cnvService;
        this.environment = environment;
        this.canMandatosActivos = 0;
        this.mandatosSinFacturacion = 0;
        this.comerciosActivos = 0;
        this.montoCobradoPatAnteriorPesos = 0;
        this.montoCobradoPatAnteriorDolar = 0;
        this.montoCobradoPatCursoPesos = 0;
        this.montoCobradoPatCursoDolar = 0;
        this.leyendaTrx = '';
        this.leyendaRechazo = '';
        this.leyendaVariacionMandato = '';
        this.leyendaVariacionMandatoFin = '';
        this.leyendaVariacionCobro = '';
        this.transaccion = [];
        this.monto = [];
        this.tasaRechazo = [];
        this.peticionDashboardAdquirente = new DasboardAdquirentePeticion();
        this.tiposMonedas = [];
        this.mensajeError = -1;
        this.variacionFactCobro = [];
        this.variacionMandatos = [];
    }
    /**
     * @return {?}
     */
    DashboardAdquirenteComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.FormGroup = new FormGroup({
            volumenTransaccional: new FormControl('transaccion'),
            monedaSeleted: new FormControl('USD')
        });
        this.volumenTransaccional = 'transaccion';
        this.monedaSeleted = 'USD';
        sessionStorage.setItem('xMontoMonedaSeleted', this.monedaSeleted);
        this.cnvService.postMonedasListar().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.tiposMonedas = data.monedas;
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en postMonedasServices', err);
        }));
        this.peticionDashboardAdquirente.estadoMandatoActivo = '3';
        this.peticionDashboardAdquirente.estadoMandatoEliminado = '4';
        this.peticionDashboardAdquirente.estadoFacturacionPagada = '0';
        this.peticionDashboardAdquirente.estadoFacturacionRechazada = '1';
        this.peticionDashboardAdquirente.estadoFacturacionEnCurso = '2';
        this.peticionDashboardAdquirente.estadoFacturacionReintento = '3';
        this.peticionDashboardAdquirente.estadoFacturacionIngresada = '4';
        this.peticionDashboardAdquirente.codCliente = this.environment.codCliente;
        this.peticionDashboardAdquirente.codEstadoConvenio = 'HBL';
        this.postSentDashboardServices(this.peticionDashboardAdquirente);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    DashboardAdquirenteComponent.prototype.postSentDashboardServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.phttp.postDashboardAdquirente(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                console.log(data);
                _this.mensajeError = 0;
                sessionStorage.setItem('dasboardAdquirente', JSON.stringify(data));
                _this.dasboardAdquirente = JSON.parse(sessionStorage.getItem('dasboardAdquirente'));
                _this.mes = _this.dasboardAdquirente.mes;
                _this.mes1 = _this.dasboardAdquirente.mes1;
                _this.canMandatosActivos = _this.dasboardAdquirente.canMandatosActivos;
                _this.mandatosSinFacturacion = _this.dasboardAdquirente.mandatosSinFacturacion;
                _this.comerciosActivos = _this.dasboardAdquirente.canComerciosActivos;
                _this.montoCobradoPatAnteriorPesos = _this.dasboardAdquirente.montoRecaudadoPatAnterior;
                _this.montoCobradoPatAnteriorDolar = _this.dasboardAdquirente.montoRecaudadoPatAnteriorDolar;
                _this.montoCobradoPatCursoPesos = _this.dasboardAdquirente.montoRecaudadoPatCurso;
                _this.montoCobradoPatCursoDolar = _this.dasboardAdquirente.montoRecaudadoPatCursoDolar;
                /* comercios de mayor volumen transaccional: por transacción */
                _this.leyendaTrx = _this.dasboardAdquirente.leyendaTrx;
                _this.leyendaRechazo = _this.dasboardAdquirente.leyendaRechazo;
                _this.leyendaVariacionMandato = _this.dasboardAdquirente.leyendaVariacionMandato;
                _this.leyendaVariacionMandatoFin = _this.dasboardAdquirente.leyendaVariacionMandatoFin;
                _this.leyendaVariacionCobro = _this.dasboardAdquirente.leyendaVariacionCobro;
                for (var index = 0; index < _this.dasboardAdquirente.transacciones.length; index++) {
                    _this.transaccion.push({
                        'name': _this.dasboardAdquirente.transacciones[index].mayorXTransaccionN,
                        'value': _this.dasboardAdquirente.transacciones[index].mayorXTransaccionV
                    });
                }
                if (_this.dasboardAdquirente.transacciones.length < 5) {
                    for (var index = _this.dasboardAdquirente.transacciones.length; index < 5; index++) {
                        /** @type {?} */
                        var strWhite = '     ';
                        _this.transaccion.push({ 'name': strWhite.substr(0, index), 'value': 0 });
                    }
                }
                /* comercios de mayor volumen transaccional: por monto */
                _this.setMonto(_this.dasboardAdquirente.montoDolar);
                /* comercios con mayor tasa de rechazo */
                for (var index = 0; index < _this.dasboardAdquirente.tasaRechazo.length; index++) {
                    if (_this.dasboardAdquirente.tasaRechazo[index].mayorTasaRechazoV != '0') {
                        _this.tasaRechazo.push({
                            'name': _this.dasboardAdquirente.tasaRechazo[index].mayorTasaRechazoN,
                            'value': parseFloat(_this.dasboardAdquirente.tasaRechazo[index].mayorTasaRechazoV).toFixed(1)
                        });
                    }
                }
                if (_this.dasboardAdquirente.tasaRechazo.length < 5) {
                    for (var index = _this.dasboardAdquirente.tasaRechazo.length; index < 5; index++) {
                        /** @type {?} */
                        var strWhite = '     ';
                        _this.tasaRechazo.push({ 'name': strWhite.substr(0, index), 'value': 0 });
                    }
                }
                /*  comercios con mayor variación de mandatos. (altas/bajas). */
                for (var index = 0; index < _this.dasboardAdquirente.variacionMandatos.length; index++) {
                    _this.variacionMandatos.push({
                        'name': _this.dasboardAdquirente.variacionMandatos[index].variacionMandatosN,
                        'series': [
                            {
                                'name': 'Alta',
                                'value': parseFloat(_this.dasboardAdquirente.variacionMandatos[index].variacionMandatosA).toFixed(1)
                            },
                            {
                                'name': 'Baja',
                                'value': parseFloat(_this.dasboardAdquirente.variacionMandatos[index].variacionMandatosB).toFixed(1)
                            }
                        ]
                    });
                }
                /* if (this.dasboardAdquirente.variacionMandatos.length < 5) {
                  for (let index = this.dasboardAdquirente.variacionMandatos.length; index < 5; index++) {
                    let strWhite = '     ';
                    this.variacionMandatos.push({ 'name': strWhite.substr(0, index), 'value': 0 });
                  }
                } */
                /*  comercios con mayor variación de facturación/cobro */
                for (var index = 0; index < _this.dasboardAdquirente.variacionFactCobro.length; index++) {
                    _this.variacionFactCobro.push({
                        'name': _this.dasboardAdquirente.variacionFactCobro[index].variacionFactCobroN,
                        'series': [
                            {
                                'name': 'Facturación',
                                'value': parseFloat(_this.dasboardAdquirente.variacionFactCobro[index].variacionFactCobroF).toFixed(1)
                            },
                            {
                                'name': 'Cobro',
                                'value': parseFloat(_this.dasboardAdquirente.variacionFactCobro[index].variacionFactCobroC).toFixed(1)
                            }
                        ]
                    });
                }
                /* if (this.dasboardAdquirente.variacionFactCobro.length < 5) {
                  for (let index = this.dasboardAdquirente.variacionFactCobro.length; index < 5; index++) {
                    let strWhite = '     ';
                    this.variacionFactCobro.push({ 'name': strWhite.substr(0, index), 'series': [{'name': '', 'value': '0' }]});
                  }
                } */
                _this.loader.hide();
            }
            else {
                console.log('Error: ', 'No se pudo mostrar el Dashboard ' + data.descret);
                _this.mensajeError = 1;
                _this.loader.hide();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.log('Error: ', 'No se pudo mostrar el Dashboard ' + err);
            _this.mensajeError = 1;
            _this.loader.hide();
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    DashboardAdquirenteComponent.prototype.onVolumenTransaccional = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.value == 'transaccion') {
            this.volumenTransaccional = 'transaccion';
        }
        else {
            this.volumenTransaccional = 'monto';
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    DashboardAdquirenteComponent.prototype.onMonedaSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.monedaSeleted = event.value;
        sessionStorage.setItem('xMontoMonedaSeleted', this.monedaSeleted);
        /** @type {?} */
        var dataSesionDasboard = JSON.parse(sessionStorage.getItem('dasboardAdquirente'));
        //Seleccionando la moneda debe mostrar los datos correspondientes en la Grafica
        if (this.monedaSeleted == 'UYU') {
            this.setMonto(dataSesionDasboard.monto);
        }
        if (this.monedaSeleted == 'USD') {
            this.setMonto(dataSesionDasboard.montoDolar);
        }
    };
    /**
     * @param {?} montoParam
     * @return {?}
     */
    DashboardAdquirenteComponent.prototype.setMonto = /**
     * @param {?} montoParam
     * @return {?}
     */
    function (montoParam) {
        this.monto = [];
        for (var index = 0; index < montoParam.length; index++) {
            this.monto.push({
                'name': montoParam[index].mayorXMontoN,
                'value': montoParam[index].mayorXMontoV
            });
        }
        if (this.monto.length < 5) {
            for (var index = montoParam.length; index < 5; index++) {
                /** @type {?} */
                var strWhite = '     ';
                this.monto.push({ 'name': strWhite.substr(0, index), 'value': 0 });
            }
        }
    };
    /**
     * @param {?} monto
     * @param {?} moneda
     * @return {?}
     */
    DashboardAdquirenteComponent.prototype.montoFormato = /**
     * @param {?} monto
     * @param {?} moneda
     * @return {?}
     */
    function (monto, moneda) {
        return FormatoMonedaUtil.montoFormato(monto, moneda);
    };
    /**
     * @param {?} input
     * @return {?}
     */
    DashboardAdquirenteComponent.prototype.formatNumber = /**
     * @param {?} input
     * @return {?}
     */
    function (input) {
        return (FormatoMonedaUtil.montoFormato(input, sessionStorage.getItem('xMontoMonedaSeleted')).toString());
    };
    /**
     * @return {?}
     */
    DashboardAdquirenteComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('dasboardAdquirente');
        sessionStorage.removeItem('componenteHijo');
        sessionStorage.removeItem('xMontoMonedaSeleted');
    };
    DashboardAdquirenteComponent.decorators = [
        { type: Component, args: [{
                    selector: 'dashboardAdquirente',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\" *ngIf=\"mensajeError == 0\">\r\n    <form [formGroup]=\"FormGroup\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n      <!--  <h3 class=\"titulo-seccion\">Indicadores</h3> -->\r\n      <div class=\"dashboard-gestion\">\r\n        <div class=\"row display-flex\">\r\n          <div class=\"col-xs-6 col-md-2\">\r\n            <div class=\"modulo-dashboard panel panel-default\">\r\n              <div class=\"panel-body\">\r\n                <div>\r\n                  <h3 style=\"line-height: normal;\">Mandatos activos en el sistema</h3>\r\n                </div>\r\n                <div>\r\n                  <h2 class=\"blue\" style=\"margin-top: 1rem;\"><i class=\"icon str-icon-pac\"></i>{{canMandatosActivos | cantidad}}</h2>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-xs-6 col-md-2\">\r\n            <div class=\"modulo-dashboard panel panel-default\">\r\n              <div class=\"panel-body\">\r\n                <div>\r\n                  <h3 style=\"line-height: normal;\">Mandatos sin facturaci\u00F3n asociada</h3>\r\n                </div>\r\n                <div>\r\n                  <h2 class=\"blue\" style=\"margin-top: .2rem;\"><i class=\"icon str-icon-supergiro-realizar\"></i>{{mandatosSinFacturacion | cantidad}}</h2>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-xs-6 col-md-2\">\r\n            <div class=\"modulo-dashboard panel panel-default\">\r\n              <div class=\"panel-body\">\r\n                <div>\r\n                  <h3 style=\"line-height: normal;\">Comercios activos</h3>\r\n                </div>\r\n                <div>\r\n                  <h2 class=\"red\" style=\"margin-top: 1.9rem;\"><i class=\"icon str-icon-icon-credito-hipotecario\"></i>{{comerciosActivos | cantidad}}</h2>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-xs-6 col-md-6\">\r\n            <div class=\"modulo-dashboard box-small\">\r\n              <h3 style=\"line-height: normal;\">Monto cobrado por PAR</h3>\r\n                <div class=\"doble-valor small\">\r\n                  <h6 style=\"line-height: normal;\">Mes Anterior ({{mes1}})</h6>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                      <h2 class=\"red\" style=\"line-height: normal;\">UYU {{montoFormato(montoCobradoPatAnteriorPesos, 'UYU')}}</h2>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                      <h2 class=\"red\" style=\"line-height: normal;\">USD {{montoFormato(montoCobradoPatAnteriorDolar, 'USD')}}</h2>\r\n                    </div>\r\n                 </div>\r\n                </div>\r\n                <div class=\"doble-valor small\">\r\n                  <h6 style=\"line-height: normal;\">Mes en curso ({{mes}})</h6>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                      <h2 class=\"red\" style=\"line-height: normal;\">UYU {{montoFormato(montoCobradoPatCursoPesos, 'UYU')}}</h2>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                     <h2 class=\"red\" style=\"line-height: normal;\">USD {{montoFormato(montoCobradoPatCursoDolar, 'USD')}}</h2>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-row\">\r\n          <div class=\"col-md-4\">\r\n            <mat-form-field>\r\n              <mat-select matNativeControl placeholder=\"Comercios con mayor volumen transaccional\"\r\n                formControlName=\"volumenTransaccional\" (selectionChange)=\"onVolumenTransaccional($event)\">\r\n                <mat-option value=\"transaccion\">Por transacci\u00F3n</mat-option>\r\n                <mat-option value=\"monto\">Por monto</mat-option>\r\n              </mat-select>\r\n            </mat-form-field>\r\n          </div>\r\n          <!-- Combo Moneda cuando se selecciona Opcion \"Por monto\" en anterior combo -->\r\n          <div class=\"col-md-4\">\r\n            <mat-form-field *ngIf=\"volumenTransaccional == 'monto'\">\r\n              <mat-select matNativeControl placeholder=\"Moneda\" formControlName=\"monedaSeleted\" (selectionChange)=\"onMonedaSelect($event)\">\r\n                <mat-option *ngFor=\"let moneda of tiposMonedas\" [value]=\"moneda.codigo\">{{moneda.divisa}}</mat-option>\r\n              </mat-select>\r\n            </mat-form-field>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6\" *ngIf=\"volumenTransaccional == 'transaccion'\">\r\n            <div class=\"modulo-dashboard box-small\">\r\n              <h3 style=\"line-height: normal;\">Comercios con mayor volumen transaccional (por transacci\u00F3n)</h3>\r\n              <div flex-gt-sm=\"50\">\r\n                <div class=\"pad\">\r\n                  <div [style.height.px]=\"300\">\r\n                    <ngx-charts-bar-vertical [results]=\"transaccion\"\r\n                      [scheme]=\"{ domain: [ '#30E07B', '#30E07B', '#30E07B', '#30E07B', '#30E07B']}\" [barPadding]=\"10\"\r\n                      [gradient]=\"true\" [xAxis]=\"true\" [yAxis]=\"true\" [legend]=\"false\" [legendTitle]=\"'Leyenda'\"\r\n                      [xAxisLabel]=\"'Comercios'\" [yAxisLabel]=\"'Transacciones'\" [showXAxisLabel]=\"true\"\r\n                      [showYAxisLabel]=\"true\">\r\n                    </ngx-charts-bar-vertical>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <span>* Informaci&oacute;n del mes {{leyendaTrx}}</span>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-md-6\" *ngIf=\"volumenTransaccional == 'monto'\">\r\n            <div class=\"modulo-dashboard box-small\">\r\n              <h3 style=\"line-height: normal;\">Comercios con mayor volumen transaccional (por monto)</h3>\r\n              <div flex-gt-sm=\"50\">\r\n                <div class=\"pad\">\r\n                  <div [style.height.px]=\"300\">\r\n                    <ngx-charts-bar-vertical\r\n                      [results]=\"monto\"\r\n                      [scheme]=\"{ domain: [ '#F56B52', '#F56B52', '#F56B52', '#F56B52', '#F56B52']}\"\r\n                      [barPadding]=\"10\"\r\n                      [gradient]=\"true\"\r\n                      [xAxis]=\"true\"\r\n                      [yAxis]=\"true\"\r\n                      [legend]=\"false\"\r\n                      [legendTitle]=\"'Leyenda'\"\r\n                      [showXAxisLabel]=\"true\"\r\n                      [showYAxisLabel]=\"true\"\r\n                      [xAxisLabel]=\"'Comercios'\"\r\n                      [yAxisLabel]=\"'Montos'\"\r\n                      [yAxisTickFormatting]=\"formatNumber\">\r\n                      <ng-template #tooltipTemplate let-model=\"model\">\r\n                        <div>\r\n                          <span> {{ model.name }}</span>\r\n                          <br>\r\n                          <span> {{ montoFormato(model.value, monedaSeleted)}}</span>\r\n                        </div>\r\n                      </ng-template>\r\n                    </ngx-charts-bar-vertical>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <span>* Informaci&oacute;n del mes {{leyendaTrx}}</span>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"col-md-6\">\r\n            <div class=\"modulo-dashboard box-small\">\r\n              <h3 style=\"line-height: normal;\">Comercios con mayor tasa de rechazo</h3>\r\n              <div flex-gt-sm=\"50\">\r\n                <div class=\"pad\">\r\n                  <div [style.height.px]=\"300\">\r\n                    <ngx-charts-bar-vertical [results]=\"tasaRechazo\"\r\n                      [scheme]=\"{ domain: [ '#f5aa2e', '#f5aa2e', '#f5aa2e', '#f5aa2e', '#f5aa2e']}\" [barPadding]=\"10\"\r\n                      [gradient]=\"true\" [xAxis]=\"true\" [yAxis]=\"true\" [legend]=\"false\" [legendTitle]=\"'Leyenda'\"\r\n                      [xAxisLabel]=\"'Comercios'\" [yAxisLabel]=\"'Tasa (%)'\" [showXAxisLabel]=\"true\"\r\n                      [showYAxisLabel]=\"true\"></ngx-charts-bar-vertical>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <span>* Informaci&oacute;n del mes {{leyendaRechazo}}</span>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6\">\r\n            <div class=\"modulo-dashboard box-small\">\r\n              <h3 style=\"line-height: normal;\">Comercios con mayor variaci\u00F3n (facturaci\u00F3n / cobro)</h3>\r\n              <div flex-gt-sm=\"50\">\r\n                <div class=\"pad\">\r\n                  <div [style.height.px]=\"300\">\r\n                    <ngx-charts-bar-vertical-2d #chart [scheme]=\"{ domain: [ '#9B59B6', '#5D6D7E']}\"\r\n                      [results]=\"variacionFactCobro\" [gradient]=\"true\" [xAxis]=\"true\" [yAxis]=\"true\" [legend]=\"false\"\r\n                      [showXAxisLabel]=\"true\" [showYAxisLabel]=\"true\" [xAxisLabel]=\"'Comercios'\"\r\n                      [yAxisLabel]=\"'Facturaci\u00F3n / Cobro (%)'\">\r\n                    </ngx-charts-bar-vertical-2d>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <span>* Informaci&oacute;n entre los meses {{leyendaVariacionCobro}}</span>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"col-md-6\">\r\n            <div class=\"modulo-dashboard box-small\">\r\n              <h3 style=\"line-height: normal;\">Comercios con mayor variaci\u00F3n de mandatos (altas / bajas)</h3>\r\n              <div flex-gt-sm=\"50\">\r\n                <div class=\"pad\">\r\n                  <div [style.height.px]=\"300\">\r\n                    <ngx-charts-bar-vertical-2d #chart [scheme]=\"{ domain: [ '#3498DB', '#E77D67  ']}\"\r\n                      [results]=\"variacionMandatos\" [gradient]=\"true\" [xAxis]=\"true\" [yAxis]=\"true\" [legend]=\"false\"\r\n                      [showXAxisLabel]=\"true\" [showYAxisLabel]=\"true\" [xAxisLabel]=\"'Comercios'\"\r\n                      [yAxisLabel]=\"'Altas / Bajas (%)'\">\r\n                    </ngx-charts-bar-vertical-2d>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <span>* Variaci&oacute;n mes {{leyendaVariacionMandato}} versus total hasta mes\r\n                {{leyendaVariacionMandatoFin}}.</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </div>\r\n</section>\r\n\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div *ngIf=\"mensajeError == 1\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" id=\"modal-basic-title\" style=\"color:#ec0000;font-weight: bold\">Error</h3>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <p>Servicio temporalmente no disponible.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [DashboardService],
                    styles: [".modulo-dashboard .doble-valor{margin-bottom:0}.modulo-dashboard .doble-valor h6{margin-top:.5rem;margin-bottom:0;font-size:.75rem}.modulo-dashboard .doble-valor h2{font-size:12px;margin-top:0}.modulo-dashboard{margin-bottom:1rem;padding-bottom:0}.row.display-flex{display:flex;flex-wrap:wrap}.row.display-flex>[class*=col-]{display:flex;flex-direction:column}.panel{height:89%}"]
                }] }
    ];
    /** @nocollapse */
    DashboardAdquirenteComponent.ctorParameters = function () { return [
        { type: DashboardService },
        { type: LoaderBaseService },
        { type: ConveniosAgregarService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return DashboardAdquirenteComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EstadoDetalle = /** @class */ (function () {
    function EstadoDetalle() {
        this.idEstado = "";
        this.descripcion = "";
    }
    return EstadoDetalle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListCobroDetallePeticion = /** @class */ (function () {
    function ListCobroDetallePeticion() {
        this.idFacturador = '-1';
        this.medioPago = '-1';
        this.keyWord = '-1';
        this.idMandante = '-1';
        this.idpago = '-1';
        this.rut = '-1';
        this.idProceso = '-1';
        this.servicio = '-1';
        this.estadoFacturacion = '-1';
        this.estadoCobro = '-1';
        this.codCliente = '-1';
        this.filtros = [];
    }
    return ListCobroDetallePeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var httpOptions$8 = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};
var listCobroDetalleService = /** @class */ (function () {
    function listCobroDetalleService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlReport = this.environment.urlAmbiente + '/apiMandatosMT/reportecobros';
    }
    /**
     * @param {?} body
     * @return {?}
     */
    listCobroDetalleService.prototype.postRespuestaReport = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        return this.http.post(this.urlReport, body, httpOptions$8);
    };
    listCobroDetalleService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    listCobroDetalleService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return listCobroDetalleService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListCobrosDetallesComponent = /** @class */ (function () {
    function ListCobrosDetallesComponent(facturacionHistorialService, router, route, phttp, globals, phttpd, dialog, loader, environment) {
        this.facturacionHistorialService = facturacionHistorialService;
        this.router = router;
        this.route = route;
        this.phttp = phttp;
        this.globals = globals;
        this.phttpd = phttpd;
        this.dialog = dialog;
        this.loader = loader;
        this.environment = environment;
        this.peticionListCobroDetalle = new ListCobroDetallePeticion();
        this.paramIdProceso = "";
        this.panelFechaProceso = '';
        this.panelFechaRespuesta = '';
        this.vistaCantidad = 0;
        this.hashCaminoMiga = [];
        this.vistaEstado = "";
        this.displayedColumns = ['id_pago', 'nro_servicio', 'medio_pago', 'monto_cargo', 'nro_intentos', 'desc_est_cobro', 'desc_cod_retorno'];
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        //this.codTpoPortal = 'ADQUIRENTE';
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idEmpresaPac = this.userPerfil.empresa.idEmpresaPac;
        //this.idEmpresaPac = 0;
    }
    /**
     * @return {?}
     */
    ListCobrosDetallesComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        sessionStorage.setItem('componenteHijo', 'list-cobros-detalles');
        this.route.queryParams.subscribe((/**
         * @param {?} params
         * @return {?}
         */
        function (params) {
            _this.paneIdProceso = params['p'],
                _this.panelCantidad = params['c'],
                _this.panelMonto = FormatoMonedaUtil.formatearMontoParam(params['m'], params['tm']),
                _this.panelFechaProceso = params['fp'],
                _this.panelFechaRespuesta = params['fr'],
                _this.panelEstado = params['ep'],
                _this.peticionListCobroDetalle.idProceso = params['p'],
                _this.paramIdProceso = params['p'];
        }));
        this.listDetalleFormGroup = new FormGroup({
            estadoCobro: new FormControl('-1'),
            servicio: new FormControl(),
        });
        if (this.codTpoPortal == 'COMERCIO') {
            this.peticionListCobroDetalle.idFacturador = this.idEmpresaPac;
        }
        else {
            this.peticionListCobroDetalle.idFacturador = '-1';
        }
        this.peticionListCobroDetalle.estadoCobro = '-1';
        this.peticionListCobroDetalle.servicio = '-1';
        this.postListEstadoCobroServices();
        this.postSentReportServices(this.peticionListCobroDetalle);
    };
    /**
     * @return {?}
     */
    ListCobrosDetallesComponent.prototype.postListEstadoCobroServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.facturacionHistorialService.postListarEstadoCobro().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var estado = new EstadoDetalle();
                estado.idEstado = '-1';
                estado.descripcion = "Todos";
                data.resultado.splice(0, 0, estado);
                _this.resultadoEstadoCobro = [];
                _this.resultadoEstadoCobro.push(data);
            }
            else {
                console.error('Error postListarEstadoCobro', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postListarEstadoCobro', err);
        }));
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    ListCobrosDetallesComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.peticionListCobroDetalle.idMandante = '-1';
        this.peticionListCobroDetalle.idProceso = this.paramIdProceso;
        if (this.codTpoPortal == 'COMERCIO') {
            this.peticionListCobroDetalle.idFacturador = this.idEmpresaPac;
        }
        else {
            this.peticionListCobroDetalle.idFacturador = '-1';
        }
        if (this.listDetalleFormGroup.get('servicio').value == null) {
            this.peticionListCobroDetalle.servicio = '-1';
            this.hashCaminoMiga[0] = { title: 'ID Servicio', text: '' };
        }
        else {
            this.peticionListCobroDetalle.servicio = this.listDetalleFormGroup.get('servicio').value;
            this.hashCaminoMiga[0] = { title: 'ID Servicio', text: this.peticionListCobroDetalle.servicio };
        }
        if (this.listDetalleFormGroup.get('estadoCobro').value == '-1') {
            this.peticionListCobroDetalle.estadoCobro = '-1';
            this.hashCaminoMiga[1] = { title: 'Estado', text: 'Todos' };
        }
        else {
            this.peticionListCobroDetalle.estadoCobro = this.listDetalleFormGroup.get('estadoCobro').value;
            this.hashCaminoMiga[1] = { title: 'Estado', text: this.vistaEstado };
        }
        if (tipo == 'excel' || tipo == 'pdf') {
            this.peticionListCobroDetalle.filtros = this.hashCaminoMiga;
            this.peticionListCobroDetalle.codCliente = this.environment.codCliente;
            this.postDownloadReportFile(this.peticionListCobroDetalle, tipo);
        }
        else {
            if (this.paginator != undefined) {
                this.paginator.pageIndex = 0;
            }
            this.postSentReportServices(this.peticionListCobroDetalle);
        }
    };
    /**
     * @param {?} body
     * @return {?}
     */
    ListCobrosDetallesComponent.prototype.postSentReportServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.phttp.postRespuestaReport(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.vistaCantidad = data.resultado.length;
                _this.dataSource = new MatTableDataSource(data.resultado);
                _this.dataSource.paginator = _this.paginator;
                _this.dataSource.sort = _this.sort;
                _this.loader.hide();
            }
            else {
                _this.loader.hide();
                console.log('Error: ', data.descret);
                _this.showDialogFail('Error', 'Servicio temporalmente no disponible.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            console.log('Error: ', err);
            _this.showDialogFail('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    ListCobrosDetallesComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiMandatosMT/cobrosdetalles/' + tipo;
        this.phttpd.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'reporteCobrosDetalle' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'reporteCobrosDetalle' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @return {?}
     */
    ListCobrosDetallesComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.peticionListCobroDetalle.estadoCobro = '-1';
        this.peticionListCobroDetalle.servicio = '-1';
        this.listDetalleFormGroup.controls.estadoCobro.setValue('-1');
        this.listDetalleFormGroup.controls.servicio.setValue('');
        this.onSubmit('');
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ListCobrosDetallesComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ListCobrosDetallesComponent.prototype.showDialogFail = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            _this.router.navigate(['../cobrosList'], { relativeTo: _this.route });
        }));
    };
    /**
     * @return {?}
     */
    ListCobrosDetallesComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.listDetalleFormGroup.valid) {
            this.onSubmit('');
        }
    };
    /**
     * @param {?} resul
     * @return {?}
     */
    ListCobrosDetallesComponent.prototype.formateandoMonto = /**
     * @param {?} resul
     * @return {?}
     */
    function (resul) {
        return FormatoMonedaUtil.formatearMonto(resul);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ListCobrosDetallesComponent.prototype.onEstadoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEstado = event.source.selected._element.nativeElement.innerText.trim();
    };
    ListCobrosDetallesComponent.decorators = [
        { type: Component, args: [{
                    selector: 'list-cobros-detalles',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <!-- <h3 class=\"titulo-seccion\">Reporte de cobros</h3> -->\r\n    <div class=\"modulo-cuentas detalle\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a [routerLink]=\"['../cobrosList']\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col-2 order-1 order-md-1 col-md-1 icon\">\r\n          <!-- <i class=\"str-icon-recargar\"></i> -->\r\n        </div>\r\n        <div class=\"col-12 order-12 order-md-2 col-md-10 datos\">\r\n          <div class=\"row\">\r\n            <div class=\"item col-4 col-sm-3 col-md-2\">\r\n              <h5>ID Proceso:</h5>\r\n              <p>{{ paneIdProceso }}</p>\r\n            </div>\r\n            <div class=\"item col-4 col-sm-3 col-md-2\">\r\n              <h5>Cantidad:</h5>\r\n              <p>{{ panelCantidad | cantidad}}</p>\r\n            </div>\r\n            <div class=\"item col-4 col-sm-3 col-md-2\">\r\n              <h5>Monto:</h5>\r\n              <p>{{panelMonto}}</p>\r\n            </div>\r\n            <div class=\"item col-4 col-sm-3 col-md-2\">\r\n              <h5>Fecha de proceso:</h5>\r\n              <p>{{ (panelFechaProceso != '') ? (panelFechaProceso | date: 'dd/MM/yyyy') : \"-\" }}</p>\r\n            </div>\r\n            <div class=\"item col-4 col-sm-3 col-md-2\">\r\n              <h5>Fecha de respuesta:</h5>\r\n              <p>{{ (panelFechaRespuesta != '') ? (panelFechaRespuesta | date: 'dd/MM/yyyy') : \"-\" }}</p>\r\n            </div>\r\n            <div class=\"item col-4 col-sm-3 col-md-2\">\r\n              <h5>Estado del proceso:</h5>\r\n              <p>{{ panelEstado }}</p>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"filtros-detalle\">\r\n            <div class=\"box-filtros\">\r\n\r\n              <form [formGroup]=\"listDetalleFormGroup\" (ngSubmit)=\" validarForm()\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n                <div class=\"form-row d-flex align-items-center\">\r\n                  <div class=\"col-md-3\">\r\n                    <mat-form-field>\r\n                      <input noCaracEsp matInput maxlength=\"20\" placeholder=\"ID Servicio\" formControlName=\"servicio\">\r\n                    </mat-form-field>\r\n                  </div>\r\n                  <div class=\"col-md-3\">\r\n                    <mat-form-field>\r\n                      <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estadoCobro\" (selectionChange)=\"onEstadoSelect($event)\">\r\n                        <!-- <mat-option *ngFor=\"let ep of estadoSelect\" [value]=\"ep.value\">{{ep.option}}</mat-option> -->\r\n                        <section *ngFor=\"let resp of resultadoEstadoCobro\">\r\n                          <mat-option *ngFor=\"let estado of resp.resultado\" [value]=\"estado.idEstado\">{{estado.descripcion}}</mat-option>\r\n                        </section>\r\n                      </mat-select>\r\n                    </mat-form-field>\r\n                  </div>\r\n                  <div class=\"col-md-6 align-right\">\r\n                    <div class=\"actions\">\r\n                      <button type=\"button\" class=\"btn-small text\" (click)=\"limpiar()\">Limpiar</button>\r\n                      <button type=\"submit\" class=\"btn-small main\" data-toggle=\"collapse\" data-target=\"#moduloFiltros\" (click)=\"peticionForm.ngSubmit.emit();\">Filtrar</button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </form>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"table-container detalle table-responsive-lg\">\r\n            <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n              <ng-container matColumnDef=\"id_pago\">\r\n                <th mat-header-cell *matHeaderCellDef>ID Cobro</th>\r\n                <td mat-cell *matCellDef=\"let resultado\"> {{resultado.id_pago}} </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"nro_servicio\">\r\n                <th mat-header-cell *matHeaderCellDef>ID Servicio</th>\r\n                <td mat-cell *matCellDef=\"let resultado\"> {{resultado.nro_servicio}} </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"medio_pago\">\r\n                <th mat-header-cell *matHeaderCellDef>Medio de pago</th>\r\n                <td mat-cell *matCellDef=\"let resultado\"> {{(resultado.medio_pago !== '') ? (resultado.medio_pago) : \"-\" }} </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"monto_cargo\">\r\n                <th mat-header-cell *matHeaderCellDef>Monto</th>\r\n                <td mat-cell *matCellDef=\"let resultado\">{{formateandoMonto(resultado)}}</td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"nro_intentos\">\r\n                <th mat-header-cell *matHeaderCellDef>N\u00B0 de intentos</th>\r\n                <td mat-cell *matCellDef=\"let resultado\"> {{ (resultado.nro_intentos !== 'null') ? (resultado.nro_intentos | cantidad) : \"0\" }} </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"desc_est_cobro\">\r\n                <th mat-header-cell *matHeaderCellDef>Estado del cobro</th>\r\n                <td mat-cell *matCellDef=\"let resultado\">\r\n                  <span *ngIf=\"resultado.est_cobro == '0' \" class=\"databar aceptado\">{{resultado.desc_est_cobro}}</span>\r\n                  <span *ngIf=\"resultado.est_cobro == '1' \" class=\"databar rechazado\">{{resultado.desc_est_cobro}}</span>\r\n                  <span *ngIf=\"resultado.est_cobro == '2' \" class=\"databar proceso\">{{resultado.desc_est_cobro}}</span>\r\n                  <span *ngIf=\"resultado.est_cobro == '3' \" class=\"databar pendiente\">{{resultado.desc_est_cobro}}</span>\r\n                  <span *ngIf=\"resultado.est_cobro == '4' \" class=\"databar eliminado\">{{resultado.desc_est_cobro}}</span>\r\n                  <span *ngIf=\"resultado.est_cobro == '5' \" class=\"databar rechazado\">{{resultado.desc_est_cobro}}</span>\r\n                </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"desc_cod_retorno\">\r\n                <th mat-header-cell *matHeaderCellDef>Descripci\u00F3n</th>\r\n                <td mat-cell *matCellDef=\"let resultado\">{{ (resultado.desc_cod_retorno !== 'null') ? (resultado.desc_cod_retorno) : \"-\" }}</td>\r\n              </ng-container>\r\n\r\n              <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n              <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n            </table>\r\n            <mat-paginator [pageSizeOptions]=\"[10]\" showFirstLastButtons></mat-paginator>\r\n          </div>\r\n\r\n          <div class=\"box-actions\" *ngIf=\"vistaCantidad > 0\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-6 item\">\r\n                <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n              </div>\r\n              <div class=\"col-md-6 item-right\">\r\n                <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [listCobroDetalleService, DescargaExcelPdfFileService]
                }] }
    ];
    /** @nocollapse */
    ListCobrosDetallesComponent.ctorParameters = function () { return [
        { type: FacturacionHistorialService },
        { type: Router },
        { type: ActivatedRoute },
        { type: listCobroDetalleService },
        { type: Globals },
        { type: DescargaExcelPdfFileService },
        { type: MatDialog },
        { type: LoaderBaseService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    ListCobrosDetallesComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator,] }],
        sort: [{ type: ViewChild, args: [MatSort,] }]
    };
    return ListCobrosDetallesComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AnulacionPeticion = /** @class */ (function () {
    function AnulacionPeticion() {
        this.idProceso = '';
        this.tipoArchivo = '';
        this.codCliente = '';
        this.idUsuario = '';
        this.docEmpresa = '';
        this.codTpoPortal = '';
    }
    return AnulacionPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListCobrosPeticionReporte = /** @class */ (function () {
    function ListCobrosPeticionReporte() {
        this.idProceso = '-1';
        this.estadoProceso = '-1';
        this.idFacturador = '-1';
        this.idConvenio = '-1';
        this.fechaInicioProceso = '01/01/2000';
        this.fechaFinProceso = '01/01/2000';
        this.fechaInicioRespuesta = '01/01/2000';
        this.fechaFinRespuesta = '01/01/2000';
        this.codTpoPortal = '-1';
        this.codCliente = '';
        this.filtros = [];
    }
    return ListCobrosPeticionReporte;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$c = MAT_MOMENT_DATE_FORMATS;
var LstCobrosComponent = /** @class */ (function () {
    function LstCobrosComponent(fachistservice, facturacionHistorialService, globals, phttpd, loader, dialog, empresasService, formBuilder, datepipe, environment) {
        this.fachistservice = fachistservice;
        this.facturacionHistorialService = facturacionHistorialService;
        this.globals = globals;
        this.phttpd = phttpd;
        this.loader = loader;
        this.dialog = dialog;
        this.empresasService = empresasService;
        this.formBuilder = formBuilder;
        this.datepipe = datepipe;
        this.environment = environment;
        this.fechaInicioProceso = '01/01/2000';
        this.fechaFinProceso = '01/01/2000';
        this.fechaInicioRespuesta = '01/01/2000';
        this.fechaFinRespuesta = '01/01/2000';
        this.vistaEstado = 'Todos';
        this.vistaComercio = 'Todos';
        this.hashCaminoMiga = [];
        this.size = 0;
        this.peticionReport = new ListCobrosPeticionReporte();
        this.peticionAnulacion = new AnulacionPeticion();
        this.mensajeError = -1;
        this.isCollapsed = false;
        this.consulta = -1;
        this.resultadoEstado = [];
        this.comboComercio = false;
        this.peticionEmpresa = new EmpresasPeticion();
        this.resultadoEmpresa = [];
        this.displayedColumns = [];
        /** @type {?} */
        var fecha = new Date();
        /** @type {?} */
        var manhana = fecha.setDate(fecha.getDate() + 1);
        /** @type {?} */
        var fechaFormat = this.datepipe.transform(manhana, 'yyyy-MM-dd');
        this.unavailabilityForm = this.formBuilder.group({
            endDate: [fechaFormat + 'T00:00:00.000Z']
        });
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        //this.codTpoPortal = 'ADQUIRENTE';
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idEmpresaPac = this.userPerfil.empresa.idEmpresaPac;
        //this.idEmpresaPac = 324;
        this.idUsuario = this.userPerfil.usuario.idUsuario;
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
        this.codCliente = this.environment.codCliente;
    }
    /**
     * @return {?}
     */
    LstCobrosComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (sessionStorage.getItem('componenteHijo') != 'list-cobros-detalles' && sessionStorage.getItem('anularcobro') != 'true') {
            sessionStorage.removeItem('indice');
        }
        this.formGroup = new FormGroup({
            idProceso: new FormControl(),
            estadoProceso: new FormControl('-1'),
            idFacturador: new FormControl('-1' + ',' + '-1'),
            fechaProceso: new FormControl(),
            fechaRespuesta: new FormControl()
        });
        this.peticionReport.idProceso = '-1';
        this.peticionReport.estadoProceso = '-1';
        if (this.codTpoPortal == 'COMERCIO') {
            this.comboComercio = false;
            this.displayedColumns = ['id_proceso', 'cantidad', 'monto', 'fec_proceso', 'fec_respuesta', 'estado_proceso_desc', 'detalle'];
            this.formGroup.controls['idFacturador'].disable();
            this.peticionReport.idFacturador = this.idEmpresaPac;
        }
        else {
            this.comboComercio = true;
            this.displayedColumns = ['id_proceso', 'empresa', 'cantidad', 'monto', 'fec_proceso', 'fec_respuesta', 'estado_proceso_desc', 'detalle', 'anular'];
            this.peticionReport.idFacturador = '-1';
            this.peticionEmpresa.codCliente = this.environment.codCliente;
            this.peticionEmpresa.codEstadoConvenio = 'HBL';
            this.postSentEmpresaServices(this.peticionEmpresa);
            //this.postSentSelectEmpresaServices(this.peticionEmpresa);
        }
        this.consulta = -1;
        this.postSentEstadoServices();
        if (sessionStorage.getItem('componenteHijo') == 'list-cobros-detalles') {
            this.consulta = 0;
            /** @type {?} */
            var llamadaPadre = JSON.parse(sessionStorage.getItem('llamadaPadre'));
            // Llena los filtros
            this.formGroup.controls['fechaProceso'].setValue(llamadaPadre.filtroProcesoI);
            this.formGroup.controls['fechaRespuesta'].setValue(llamadaPadre.filtroRespuestaD);
            this.fechaInicioProceso = llamadaPadre.fechaInicioProceso;
            this.fechaFinProceso = llamadaPadre.fechaFinProceso;
            this.fechaInicioRespuesta = llamadaPadre.fechaInicioRespuesta;
            this.fechaFinRespuesta = llamadaPadre.fechaFinRespuesta;
            this.formGroup.controls['idProceso'].setValue((llamadaPadre.idProceso != '-1' ? llamadaPadre.idProceso : ''));
            this.formGroup.controls['estadoProceso'].setValue(llamadaPadre.estadoProceso);
            this.formGroup.controls['idFacturador'].setValue(llamadaPadre.idFacturador + ',' + llamadaPadre.idConvenio);
            // Llena camino de migas
            /** @type {?} */
            var migasPadre = JSON.parse(sessionStorage.getItem('migasPadre'));
            this.vistaEstado = migasPadre.estado;
            this.hashCaminoMiga[0] = { title: 'Fecha Proceso', text: migasPadre.fechaProceso };
            this.hashCaminoMiga[1] = { title: 'Fecha Respuesta', text: migasPadre.fechaRespuesta };
            this.hashCaminoMiga[2] = { title: 'ID Proceso', text: migasPadre.idProceso };
            this.hashCaminoMiga[3] = { title: 'Estado', text: migasPadre.estado };
            if (this.codTpoPortal != 'COMERCIO') {
                this.vistaComercio = migasPadre.facturador;
                this.hashCaminoMiga[4] = { title: 'Empresa', text: migasPadre.facturador };
            }
            // Llama al servicio
            this.peticionReport.codTpoPortal = llamadaPadre.codTpoPortal;
            this.peticionReport.fechaInicioProceso = llamadaPadre.fechaInicioProceso;
            this.peticionReport.fechaFinProceso = llamadaPadre.fechaFinProceso;
            this.peticionReport.fechaInicioRespuesta = llamadaPadre.fechaInicioRespuesta;
            this.peticionReport.fechaFinRespuesta = llamadaPadre.fechaFinRespuesta;
            this.peticionReport.idProceso = llamadaPadre.idProceso;
            this.peticionReport.estadoProceso = llamadaPadre.estadoProceso;
            this.peticionReport.idFacturador = llamadaPadre.idFacturador;
            this.peticionReport.idConvenio = llamadaPadre.idConvenio;
            this.postListaCobrosServices(this.peticionReport);
        }
        else {
            this.setInitialBreadcrumbs();
        }
    };
    /**
     * @return {?}
     */
    LstCobrosComponent.prototype.setInitialBreadcrumbs = /**
     * @return {?}
     */
    function () {
        this.hashCaminoMiga[0] = { title: 'Fecha Proceso', text: 'Todos' };
        this.hashCaminoMiga[1] = { title: 'Fecha Respuesta', text: 'Todos' };
        this.hashCaminoMiga[2] = { title: 'ID Proceso', text: '' };
        this.hashCaminoMiga[3] = { title: 'Estado', text: 'Todos' };
        if (this.codTpoPortal != 'COMERCIO') {
            this.hashCaminoMiga[4] = { title: 'Empresa', text: 'Todas' };
        }
    };
    /**
     * @param {?} body
     * @return {?}
     */
    LstCobrosComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.empresasService.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var emp = new EmpresaResult();
                emp.idFacturador = -1;
                emp.idConvenio = '-1';
                emp.nomFacturador = "Todas";
                data.resultado.splice(0, 0, emp);
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.error('Error postSentEmpresaServices', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postSentEmpresaServices', err);
        }));
    };
    // postSentSelectEmpresaServices(body: EmpresasPeticion) {
    //   this.empresasService.postListarSelectEmpresas(body).subscribe(data => {
    //     if (data.codret == '0') {
    //       let empresa : EmpresaResult = new EmpresaResult();
    //       empresa.idFacturador=-1;
    //       empresa.nomFacturador="Todas";
    //       data.resultado.splice(0,0,empresa);
    //       this.resultadoEmpresa = [];
    //       this.resultadoEmpresa = data.resultado;
    //     } else {
    //       console.log('Error: ', 'postListarSelectEmpresas ' + data.descret);
    //     }
    //   }, err => {
    //     console.error("Error postListarSelectEmpresas: ", err);
    //   });
    // }
    // postSentSelectEmpresaServices(body: EmpresasPeticion) {
    //   this.empresasService.postListarSelectEmpresas(body).subscribe(data => {
    //     if (data.codret == '0') {
    //       let empresa : EmpresaResult = new EmpresaResult();
    //       empresa.idFacturador=-1;
    //       empresa.nomFacturador="Todas";
    //       data.resultado.splice(0,0,empresa);
    //       this.resultadoEmpresa = [];
    //       this.resultadoEmpresa = data.resultado;
    //     } else {
    //       console.log('Error: ', 'postListarSelectEmpresas ' + data.descret);
    //     }
    //   }, err => {
    //     console.error("Error postListarSelectEmpresas: ", err);
    //   });
    // }
    /**
     * @return {?}
     */
    LstCobrosComponent.prototype.postSentEstadoServices = 
    // postSentSelectEmpresaServices(body: EmpresasPeticion) {
    //   this.empresasService.postListarSelectEmpresas(body).subscribe(data => {
    //     if (data.codret == '0') {
    //       let empresa : EmpresaResult = new EmpresaResult();
    //       empresa.idFacturador=-1;
    //       empresa.nomFacturador="Todas";
    //       data.resultado.splice(0,0,empresa);
    //       this.resultadoEmpresa = [];
    //       this.resultadoEmpresa = data.resultado;
    //     } else {
    //       console.log('Error: ', 'postListarSelectEmpresas ' + data.descret);
    //     }
    //   }, err => {
    //     console.error("Error postListarSelectEmpresas: ", err);
    //   });
    // }
    /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.fachistservice.postListarEstadoArchivos().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var estados = new EstadoArchivosResult();
                estados.descripcion = "Todos";
                estados.codigo = "-1";
                data.resultado.splice(0, 0, estados);
                _this.resultadoEstado = data.resultado;
            }
            else {
                console.error('Error postListarEstadoArchivos: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postListarEstadoArchivos: ', err);
        }));
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    LstCobrosComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.consulta = 0;
        this.peticionReport.codTpoPortal = this.codTpoPortal;
        this.filtroProcesoI = this.formGroup.get('fechaProceso').value;
        if (this.formGroup.get('fechaProceso').value != null) {
            this.peticionReport.fechaInicioProceso = formatDate(this.filtroProcesoI.begin, 'dd/MM/yyyy', 'en-US');
            this.peticionReport.fechaFinProceso = formatDate(this.filtroProcesoI.end, 'dd/MM/yyyy', 'en-US');
            this.hashCaminoMiga[0] = { title: 'Fecha Proceso', text: this.fechaInicioProceso + ' - ' + this.fechaFinProceso };
        }
        else {
            this.hashCaminoMiga[0] = { title: 'Fecha Proceso', text: 'Todos' };
            this.peticionReport.fechaInicioProceso = this.fechaInicioProceso;
            this.peticionReport.fechaFinProceso = this.fechaFinProceso;
        }
        this.filtroRespuestaD = this.formGroup.get('fechaRespuesta').value;
        if (this.formGroup.get('fechaRespuesta').value != null) {
            this.peticionReport.fechaInicioRespuesta = formatDate(this.filtroRespuestaD.begin, 'dd/MM/yyyy', 'en-US');
            this.peticionReport.fechaFinRespuesta = formatDate(this.filtroRespuestaD.end, 'dd/MM/yyyy', 'en-US');
            this.hashCaminoMiga[1] = { title: 'Fecha Respuesta', text: this.fechaInicioRespuesta + ' - ' + this.fechaFinRespuesta };
        }
        else {
            this.hashCaminoMiga[1] = { title: 'Fecha Respuesta', text: 'Todos' };
            this.peticionReport.fechaInicioRespuesta = this.fechaInicioRespuesta;
            this.peticionReport.fechaFinRespuesta = this.fechaFinRespuesta;
        }
        if (this.formGroup.get('idProceso').value == null || this.formGroup.get('idProceso').value == '') {
            this.peticionReport.idProceso = '-1';
            this.hashCaminoMiga[2] = { title: 'ID Proceso', text: '' };
        }
        else {
            this.peticionReport.idProceso = this.formGroup.get('idProceso').value;
            this.hashCaminoMiga[2] = { title: 'ID Proceso', text: this.formGroup.get('idProceso').value };
        }
        if (this.formGroup.get('estadoProceso').value == null) {
            this.peticionReport.estadoProceso = '-1';
            this.hashCaminoMiga[3] = { title: 'Estado', text: 'Todos' };
        }
        else {
            this.peticionReport.estadoProceso = this.formGroup.get('estadoProceso').value;
            this.hashCaminoMiga[3] = { title: 'Estado', text: this.vistaEstado };
        }
        if (this.codTpoPortal == 'COMERCIO') {
            this.peticionReport.idFacturador = this.idEmpresaPac;
        }
        else {
            /** @type {?} */
            var idFacturador = this.formGroup.get('idFacturador').value.split(",")[0];
            if (idFacturador == null || idFacturador == '' || idFacturador == -1) {
                this.peticionReport.idFacturador = '-1';
                this.peticionReport.idConvenio = '-1';
                this.hashCaminoMiga[4] = { title: 'Empresa', text: 'Todas' };
            }
            else {
                this.peticionReport.idFacturador = this.formGroup.get('idFacturador').value.split(",")[0];
                this.peticionReport.idConvenio = this.formGroup.get('idFacturador').value.split(",")[1];
                this.hashCaminoMiga[4] = { title: 'Empresa', text: this.vistaComercio };
            }
        }
        sessionStorage.setItem('llamadaPadre', JSON.stringify({
            codTpoPortal: this.peticionReport.codTpoPortal,
            fechaInicioProceso: this.peticionReport.fechaInicioProceso,
            fechaFinProceso: this.peticionReport.fechaFinProceso,
            fechaInicioRespuesta: this.peticionReport.fechaInicioRespuesta,
            fechaFinRespuesta: this.peticionReport.fechaFinRespuesta,
            idProceso: this.peticionReport.idProceso,
            estadoProceso: this.peticionReport.estadoProceso,
            idFacturador: this.peticionReport.idFacturador,
            idConvenio: this.peticionReport.idConvenio,
            filtroProcesoI: this.filtroProcesoI,
            filtroRespuestaD: this.filtroRespuestaD
        }));
        sessionStorage.setItem('migasPadre', JSON.stringify({
            fechaProceso: this.hashCaminoMiga[0].text,
            fechaRespuesta: this.hashCaminoMiga[1].text,
            idProceso: this.hashCaminoMiga[2].text,
            estado: this.hashCaminoMiga[3].text,
            facturador: (this.codTpoPortal != 'COMERCIO' ? this.hashCaminoMiga[4].text : '')
        }));
        if (tipo == 'excel' || tipo == 'pdf') {
            this.peticionReport.filtros = this.hashCaminoMiga;
            //this.peticionReport.codCliente = this.codCliente;
            this.postDownloadReportFile(this.peticionReport, tipo);
        }
        else {
            this.postListaCobrosServices(this.peticionReport);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstCobrosComponent.prototype.onEstadoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEstado = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstCobrosComponent.prototype.onEmpresaSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaComercio = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstCobrosComponent.prototype.onPaginateChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var indice = this.paginator.pageIndex;
        sessionStorage.setItem('indice', indice);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    LstCobrosComponent.prototype.postListaCobrosServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.show = true;
        body.codCliente = this.codCliente;
        this.facturacionHistorialService.postListaCobros(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                console.log(data);
                if (_this.paginator != undefined && sessionStorage.getItem('componenteHijo') == 'list-cobros-detalles') {
                    _this.paginator.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indice')))));
                }
                else if (_this.paginator != undefined && sessionStorage.getItem('anularcobro') == 'true') {
                    _this.paginator.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indice')))));
                }
                else if (_this.paginator != undefined) {
                    _this.paginator.pageIndex = 0;
                    sessionStorage.removeItem("indice");
                }
                sessionStorage.removeItem('anularcobro');
                sessionStorage.removeItem('componenteHijo');
                _this.size = data.resultado.length;
                _this.dataSource = new MatTableDataSource(data.resultado);
                _this.dataSource.paginator = _this.paginator;
                _this.dataSource.sort = _this.sort;
                if (_this.size == 0) {
                    _this.show = false;
                    _this.isCollapsed = false;
                }
                else {
                    _this.isCollapsed = true;
                }
                _this.mensajeError = 0;
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.loader.hide();
                _this.mensajeError = 1;
                console.error('Error al listar Reporte de Cobros', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            _this.loader.hide();
            _this.mensajeError = 1;
            console.error('Error: ', err);
        }));
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    LstCobrosComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiFacturasMT/listaCobro/' + tipo;
        this.phttpd.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'reporteCobros' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'reporteCobros' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @param {?} idProceso
     * @return {?}
     */
    LstCobrosComponent.prototype.anulaCobro = /**
     * @param {?} idProceso
     * @return {?}
     */
    function (idProceso) {
        this.peticionAnulacion.codCliente = this.codCliente;
        this.peticionAnulacion.idUsuario = this.idUsuario;
        this.peticionAnulacion.docEmpresa = this.docEmpresa;
        this.peticionAnulacion.codTpoPortal = this.codTpoPortal;
        this.peticionAnulacion.idProceso = idProceso;
        this.peticionAnulacion.tipoArchivo = 'COB';
        this.showDialogAnular('Información', 'Si realiza esta acción, se anulará el proceso de Cobro.<br>¿Está seguro de esta acción?', true);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    LstCobrosComponent.prototype.postAnularCobroServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.facturacionHistorialService.postAnularCobro(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.showDialog('Información', 'El proceso se ha anulado de forma satisfactoria.', false);
                _this.onSubmit('');
            }
            else {
                _this.showDialog('Error', 'No ha sido posible anular el proceso.<br>Inténtelo nuevamente.', false);
                console.error('Error postAnularCobroServices', data.descret);
            }
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
            console.error('Error postAnularCobroServices', error);
        }));
    };
    /**
     * @return {?}
     */
    LstCobrosComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.peticionReport.idProceso = '-1';
        this.peticionReport.estadoProceso = '-1';
        this.peticionReport.idFacturador = '-1';
        this.peticionReport.idConvenio = '-1';
        this.fechaInicioProceso = '01/01/2000';
        this.fechaFinProceso = '01/01/2000';
        this.fechaInicioRespuesta = '01/01/2000';
        this.fechaFinRespuesta = '01/01/2000';
        this.filtroProcesoI = null;
        this.filtroRespuestaD = null;
        this.formGroup.get('fechaProceso').setValue(null);
        this.formGroup.get('fechaRespuesta').setValue(null);
        this.formGroup.get('idProceso').setValue('');
        this.formGroup.controls.idFacturador.reset('-1' + ',' + '-1');
        this.formGroup.controls.estadoProceso.setValue('-1');
        this.dataSource = new MatTableDataSource([]);
        this.mensajeError = -1;
        this.size = 0;
        this.consulta = -1;
        this.show = false;
        this.setInitialBreadcrumbs();
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    LstCobrosComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    LstCobrosComponent.prototype.showDialogAnular = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            if (result) {
                sessionStorage.setItem('anularcobro', 'true');
                _this.postAnularCobroServices(_this.peticionAnulacion);
            }
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstCobrosComponent.prototype.selectFechaProceso = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.fechaInicioProceso = formatDate(event.value.begin, 'dd/MM/yyyy', 'en-US');
        this.fechaFinProceso = formatDate(event.value.end, 'dd/MM/yyyy', 'en-US');
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstCobrosComponent.prototype.selectFechaRespuesta = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.fechaInicioRespuesta = formatDate(event.value.begin, 'dd/MM/yyyy', 'en-US');
        this.fechaFinRespuesta = formatDate(event.value.end, 'dd/MM/yyyy', 'en-US');
    };
    /**
     * @return {?}
     */
    LstCobrosComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.onSubmit('');
        }
    };
    /**
     * @param {?} resul
     * @return {?}
     */
    LstCobrosComponent.prototype.formateandoMonto = /**
     * @param {?} resul
     * @return {?}
     */
    function (resul) {
        return FormatoMonedaUtil.formatearMonto(resul);
    };
    /**
     * @return {?}
     */
    LstCobrosComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('componenteHijo');
    };
    /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    LstCobrosComponent.prototype.getEmpresaConvenio = /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    function (nomFacturador, descConvenio) {
        return descConvenio != "" ? nomFacturador + ": " + descConvenio : nomFacturador;
    };
    LstCobrosComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-list-cobros',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <!--h3 class=\"titulo-seccion\">Reporte de cobros</h3-->\r\n    <div class=\"modulo-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n      </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"formGroup\" autocomplete=\"off\">\r\n              <div class=\"form-row align-left\">\r\n                <div class=\"col-md-6\">\r\n                  <div class=\"filtro-fecha\">\r\n                    <button type=\"button\" class=\"btn fecha\" (click)=\"picker1.open()\"><i class=\"str-icon-calendario\"></i> Buscar por fecha de proceso\r\n                      <ng-container *ngIf=\"this.formGroup.get('fechaProceso').value != null && this.fechaInicioProceso != '01/01/2000'\">\r\n                        <span>{{ this.fechaInicioProceso + ' - ' + this.fechaFinProceso }}</span>\r\n                      </ng-container>\r\n                    </button>\r\n                    <mat-form-field style=\"display: none;\">\r\n                      <input matInput placeholder=\"Fecha\" [max]=\"unavailabilityForm.controls.endDate.value\" [satDatepicker]=\"picker1\" formControlName=\"fechaProceso\" (dateInput)=\"selectFechaProceso($event)\">\r\n                      <sat-datepicker-toggle matSuffix [for]=\"picker1\"></sat-datepicker-toggle>\r\n                      <sat-datepicker touchUi #picker1 [rangeMode]=\"true\" [selectFirstDateOnClose]=\"true\"></sat-datepicker>\r\n                    </mat-form-field>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                  <div class=\"filtro-fecha\">\r\n                    <button type=\"button\" class=\"btn fecha\" (click)=\"picker2.open()\"><i class=\"str-icon-calendario\"></i> Buscar por fecha de respuesta\r\n                      <ng-container *ngIf=\"this.formGroup.get('fechaRespuesta').value != null && this.fechaInicioRespuesta != '01/01/2000'\">\r\n                        <span>{{ this.fechaInicioRespuesta + ' - ' + this.fechaFinRespuesta }}</span>\r\n                      </ng-container>\r\n                    </button>\r\n                    <mat-form-field style=\"display: none;\">\r\n                      <input matInput placeholder=\"Fecha\" [max]=\"unavailabilityForm.controls.endDate.value\" [satDatepicker]=\"picker2\" formControlName=\"fechaRespuesta\" (dateInput)=\"selectFechaRespuesta($event)\">\r\n                      <sat-datepicker-toggle matSuffix [for]=\"picker2\"></sat-datepicker-toggle>\r\n                      <sat-datepicker touchUi #picker2 [rangeMode]=\"true\" [selectFirstDateOnClose]=\"true\"></sat-datepicker>\r\n                    </mat-form-field>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-row\">\r\n                <div class=\"form-group col-sm\">\r\n                  <mat-form-field>\r\n                    <input matInput placeholder=\"ID Proceso\" maxlength=\"9\" inputmode=\"numeric\" pattern=\"[0-9]*\" digitOnly formControlName=\"idProceso\">\r\n                  </mat-form-field>\r\n                </div>\r\n\r\n                <div class=\"form-group col-sm\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Estado de Proceso\" formControlName=\"estadoProceso\" (selectionChange)=\"onEstadoSelect($event)\">\r\n                      <mat-option *ngFor=\"let estado of resultadoEstado\" [value]=\"estado.codigo\">{{estado.descripcion}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n\r\n                <div class=\"form-group col-sm\" *ngIf=\"comboComercio\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"idFacturador\" (selectionChange)=\"onEmpresaSelect($event)\">\r\n                      <mat-option class=\"multiline-mat-option\" *ngFor=\"let comercio of resultadoEmpresa\" [value]=\"comercio.idFacturador +','+ comercio.idConvenio\">{{getEmpresaConvenio(comercio.nomFacturador, comercio.descConvenio)}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"actions\">\r\n                <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\" (click)=\"validarForm()\">Filtrar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"resultados-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-10\">\r\n          <div class=\"tags row\">\r\n            <div *ngFor=\"let entry of hashCaminoMiga\" class=\"item\">{{entry.title}}: {{entry.text}}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n          <div class=\"numero-resultados\">\r\n            <strong>{{ (size == 1) ? ( size + \" Resultado\") : size + \" Resultados\" }}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-container table-responsive-md\">\r\n        <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n          <ng-container matColumnDef=\"id_proceso\">\r\n            <th mat-header-cell *matHeaderCellDef>ID Proceso</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.id_proceso}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"empresa\" *ngIf=\"comboComercio\">\r\n            <th mat-header-cell *matHeaderCellDef>Empresa</th>\r\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\">{{resultado.nomFacturador}}: {{resultado.cnvDescrip}}</td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"cantidad\">\r\n            <th mat-header-cell *matHeaderCellDef>Cantidad</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.cantidad}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"monto\">\r\n            <th mat-header-cell *matHeaderCellDef>Monto</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">{{formateandoMonto(resultado)}}</td>\r\n            <!-- <td mat-cell *matCellDef=\"let resultado\">{{resultado.tipoMoneda}} {{resultado.monto /100 | moneda}} </td> -->\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fec_proceso\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha de proceso</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              {{ (resultado.fec_proceso !== null) ? (resultado.fec_proceso | date: 'dd/MM/yyyy') : \"-\" }} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fec_respuesta\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha de respuesta</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              {{ (resultado.fec_respuesta !== null) ? (resultado.fec_respuesta | date: 'dd/MM/yyyy') : \"-\" }} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"estado_proceso_desc\">\r\n            <th mat-header-cell *matHeaderCellDef>Estado del proceso</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.estado_proceso_desc}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"detalle\">\r\n            <th mat-header-cell *matHeaderCellDef>Detalle</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a [routerLink]=\"['../cobrosDetalle']\" [queryParams]=\"{\r\n                    'p':resultado.id_proceso,\r\n                    'c':resultado.cantidad,\r\n                    'm':resultado.monto,\r\n                    'fp':(resultado.fec_proceso != null ? resultado.fec_proceso : ''),\r\n                    'fr':(resultado.fec_respuesta != null ? resultado.fec_respuesta : ''),\r\n                    'ep':resultado.estado_proceso_desc,\r\n                    'tm':resultado.tipoMoneda\r\n                  }\"><i class=\"str-icon-flecha-derecha\"></i></a>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"anular\" *ngIf=\"comboComercio\">\r\n            <th mat-header-cell *matHeaderCellDef>Anular</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a *ngIf=\"resultado.cobrosPagados > 0; else noAnl\" role=\"button\" class=\"item\" (click)=\"anulaCobro(resultado.id_proceso)\"><i class='icon str-icon-trash' style=\"cursor: pointer;\"></i></a>\r\n              <ng-template #noAnl> - </ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n        </table>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" (page)=\"onPaginateChange($event)\"  showFirstLastButtons></mat-paginator>\r\n      </div>\r\n      <div class=\"box-actions\" *ngIf=\"size > 0\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6 item\">\r\n            <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n          </div>\r\n          <div class=\"col-md-6 item-right\">\r\n            <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </section>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"mensajeError == 0 && size == 0\">\r\n      <span>\r\n        No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.\r\n      </span>\r\n    </div>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"consulta == -1\">\r\n      <span>\r\n        Establezca sus criterios de b&uacute;squeda.\r\n      </span>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div *ngIf=\"mensajeError == 1\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" id=\"modal-basic-title\" style=\"color:#ec0000;font-weight: bold\">Error</h3>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <p>Servicio temporalmente no disponible.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [DescargaExcelPdfFileService,
                        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
                        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
                        { provide: MAT_DATE_FORMATS, useValue: ɵ0$c }]
                }] }
    ];
    /** @nocollapse */
    LstCobrosComponent.ctorParameters = function () { return [
        { type: FacturacionHistorialService },
        { type: FacturacionHistorialService },
        { type: Globals },
        { type: DescargaExcelPdfFileService },
        { type: LoaderBaseService },
        { type: MatDialog },
        { type: EmpresasService },
        { type: FormBuilder },
        { type: DatePipe },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    LstCobrosComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator,] }],
        sort: [{ type: ViewChild, args: [MatSort,] }]
    };
    return LstCobrosComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DownloadFilePeticion = /** @class */ (function () {
    function DownloadFilePeticion() {
        this.idArchivo = '-1';
        this.idFacturador = '-1';
    }
    return DownloadFilePeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var listDescargasPeticionReporte = /** @class */ (function () {
    function listDescargasPeticionReporte() {
        this.fechaInicioProceso = '01/01/2000';
        this.fechaFinProceso = '01/01/2000';
        this.tipoArchivo = '-1';
        this.estadoProceso = '-1';
        this.idFacturador = '-1';
        this.idConvenio = '-1';
        this.codTpoPortal = '-1';
        this.codCliente = '-1';
        this.filtros = [];
    }
    return listDescargasPeticionReporte;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Archivo = /** @class */ (function () {
    function Archivo(id, name) {
        this.id = id;
        this.name = name;
    }
    return Archivo;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EstadoArcvhivo = /** @class */ (function () {
    function EstadoArcvhivo(id, archivoid, nombre) {
        this.id = id;
        this.archivoid = archivoid;
        this.nombre = nombre;
    }
    return EstadoArcvhivo;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var listDescargaService = /** @class */ (function () {
    function listDescargaService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlDownloadArchivo = this.environment.urlAmbiente + '/DownloadFile';
    }
    /**
     * @param {?} file
     * @return {?}
     */
    listDescargaService.prototype.downloadService = /**
     * @param {?} file
     * @return {?}
     */
    function (file) {
        return this.http.request(new HttpRequest('POST', this.urlDownloadArchivo, file, {
            reportProgress: true,
            responseType: 'blob'
        }));
    };
    /**
     * @return {?}
     */
    listDescargaService.prototype.getArchivo = /**
     * @return {?}
     */
    function () {
        return [
            new Archivo('-1', 'Todos'),
            new Archivo('FAT', 'Facturación'),
            new Archivo('REN', 'Rendición'),
            new Archivo('MAN', 'Mandatos'),
            new Archivo('RPRMAN', 'Migración de Mandatos Respuesta')
        ];
    };
    /**
     * @return {?}
     */
    listDescargaService.prototype.getEstadoArchivo = /**
     * @return {?}
     */
    function () {
        return [
            new EstadoArcvhivo('1', '1', 'Ingresado'),
            new EstadoArcvhivo('2', '1', 'En Cobro'),
            new EstadoArcvhivo('3', '1', 'Procesada'),
            new EstadoArcvhivo('4', '1', 'Rechazada'),
            new EstadoArcvhivo('5', '2', 'Procesada'),
            new EstadoArcvhivo('6', '2', 'Rechazada'),
            new EstadoArcvhivo('7', '6', 'Procesada'),
            new EstadoArcvhivo('8', '6', 'Rechazada')
        ];
    };
    listDescargaService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    listDescargaService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return listDescargaService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$d = MAT_MOMENT_DATE_FORMATS;
var LstDescargaComponent = /** @class */ (function () {
    function LstDescargaComponent(phttp, phttpe, fachistservice, phttpd, loader, dialog, formBuilder, datepipe, environment) {
        this.phttp = phttp;
        this.phttpe = phttpe;
        this.fachistservice = fachistservice;
        this.phttpd = phttpd;
        this.loader = loader;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.datepipe = datepipe;
        this.environment = environment;
        this.fechaInicioProceso = '01/01/2000';
        this.fechaFinProceso = '01/01/2000';
        this.vistaTipoArchivo = 'Todos';
        this.vistaEstado = 'Todos';
        this.vistaRubro = 'Todos';
        this.vistaComercio = 'Todos';
        this.hashCaminoMiga = [];
        this.peticionReport = new listDescargasPeticionReporte();
        this.downloadFile = new DownloadFilePeticion();
        this.size = 0;
        this.resultadoEstado = [];
        this.mensajeError = -1;
        this.isCollapsed = false;
        this.consulta = -1;
        this.resultadoRubros = [];
        this.resultadoEmpresa = [];
        this.peticionEmpresa = new EmpresasPeticion();
        this.comboComercio = false;
        /** @type {?} */
        var fecha = new Date();
        /** @type {?} */
        var mañana = fecha.setDate(fecha.getDate() + 1);
        /** @type {?} */
        var fechaFormat = this.datepipe.transform(mañana, 'yyyy-MM-dd');
        this.unavailabilityForm = this.formBuilder.group({
            endDate: [fechaFormat + 'T00:00:00.000Z']
        });
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        //this.codTpoPortal = 'ADQUIRENTE';
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idEmpresaPac = this.userPerfil.empresa.idEmpresaPac;
        //this.idEmpresaPac = '0';
    }
    /**
     * @return {?}
     */
    LstDescargaComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        //this.peticionReport.idProceso = '-1';
        this.peticionReport.estadoProceso = '-1';
        this.peticionReport.idFacturador = '-1';
        this.peticionReport.idConvenio = '-1';
        this.peticionReport.tipoArchivo = '-1';
        //this.peticionReport.tipoReporte = 'descarga';
        this.archivos = this.phttp.getArchivo();
        this.listDescargasFormGroup = new FormGroup({
            tipoArchivo: new FormControl('-1'),
            estado: new FormControl('-1'),
            comercio: new FormControl(),
            idFacturador: new FormControl('-1' + ',' + '-1'),
            idRubro: new FormControl(),
            fechaProceso: new FormControl()
        });
        this.ArchivoDescargasFormGroup = new FormGroup({
            // archivo_id: new FormControl()
            radioGroupArcId: new FormControl()
        });
        if (this.codTpoPortal == 'COMERCIO') {
            this.comboComercio = false;
            this.peticionReport.idFacturador = this.idEmpresaPac;
            this.listDescargasFormGroup.controls['idFacturador'].disable();
            this.displayedColumns = ['checkbox', 'tipo_archivo', 'nombre', 'cantidad', 'monto', 'fec_proceso', 'estado_proceso_desc'];
        }
        else {
            this.comboComercio = true;
            this.peticionReport.idFacturador = "-1";
            this.peticionEmpresa.idFacturador = -1;
            this.listDescargasFormGroup.controls['idFacturador'].enable();
            this.displayedColumns = ['checkbox', 'empresa', 'tipo_archivo', 'nombre', 'cantidad', 'monto', 'fec_proceso', 'estado_proceso_desc'];
            this.peticionEmpresa.codCliente = this.environment.codCliente;
            this.peticionEmpresa.codEstadoConvenio = 'HBL';
            this.postSentEmpresaServices(this.peticionEmpresa);
            //this.postSentSelectEmpresaServices(this.peticionEmpresa);
        }
        this.consulta = -1;
        this.setInitialBreadcrumbs();
        this.postSentEstadoServices();
        //this.postSentReportServices(this.peticionReport);
    };
    /**
     * @return {?}
     */
    LstDescargaComponent.prototype.setInitialBreadcrumbs = /**
     * @return {?}
     */
    function () {
        this.hashCaminoMiga[0] = { title: 'Fecha Proceso', text: 'Todos' };
        this.hashCaminoMiga[1] = { title: 'Tipo Archivo', text: 'Todos' };
        this.hashCaminoMiga[2] = { title: 'Estado', text: 'Todos' };
        if (this.codTpoPortal != 'COMERCIO') {
            this.hashCaminoMiga[3] = { title: 'Empresa', text: 'Todas' };
        }
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    LstDescargaComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.consulta = 0;
        this.peticionReport.codTpoPortal = this.codTpoPortal;
        this.idArchivo = null;
        this.ArchivoDescargasFormGroup.controls.radioGroupArcId.reset();
        this.filtroFechaProcesoI = this.listDescargasFormGroup.get('fechaProceso').value;
        if (this.listDescargasFormGroup.get('fechaProceso').value != null) {
            this.peticionReport.fechaInicioProceso = formatDate(this.filtroFechaProcesoI.begin, 'dd/MM/yyyy', 'en-US');
            this.peticionReport.fechaFinProceso = formatDate(this.filtroFechaProcesoI.end, 'dd/MM/yyyy', 'en-US');
            this.hashCaminoMiga[0] = { title: 'Fecha Proceso', text: this.fechaInicioProceso + ' - ' + this.fechaFinProceso };
        }
        else {
            this.peticionReport.fechaInicioProceso = this.fechaInicioProceso;
            this.peticionReport.fechaFinProceso = this.fechaFinProceso;
            this.hashCaminoMiga[0] = { title: 'Fecha Proceso', text: 'Todos' };
        }
        if (this.listDescargasFormGroup.get('tipoArchivo').value == '-1') {
            this.peticionReport.tipoArchivo = '-1';
            this.hashCaminoMiga[1] = { title: 'Tipo Archivo', text: 'Todos' };
        }
        else {
            this.peticionReport.tipoArchivo = this.listDescargasFormGroup.get('tipoArchivo').value;
            this.hashCaminoMiga[1] = { title: 'Tipo Archivo', text: this.vistaTipoArchivo };
        }
        if (this.listDescargasFormGroup.get('estado').value == '-1') {
            this.peticionReport.estadoProceso = '-1';
            this.hashCaminoMiga[2] = { title: 'Estado', text: 'Todos' };
        }
        else {
            this.peticionReport.estadoProceso = this.listDescargasFormGroup.get('estado').value;
            this.hashCaminoMiga[2] = { title: 'Estado', text: this.vistaEstado };
        }
        if (this.codTpoPortal == 'COMERCIO') {
            this.peticionReport.idFacturador = this.idEmpresaPac;
        }
        else {
            /** @type {?} */
            var idFacturador = this.listDescargasFormGroup.get('idFacturador').value.split(",")[0];
            if (idFacturador == null || idFacturador == '' || idFacturador == -1) {
                this.peticionReport.idFacturador = '-1';
                this.peticionReport.idConvenio = '-1';
                this.hashCaminoMiga[3] = { title: 'Empresa', text: 'Todas' };
            }
            else {
                this.peticionReport.idFacturador = this.listDescargasFormGroup.get('idFacturador').value.split(",")[0];
                this.peticionReport.idConvenio = this.listDescargasFormGroup.get('idFacturador').value.split(",")[1];
                this.hashCaminoMiga[3] = { title: 'Empresa', text: this.vistaComercio };
            }
        }
        this.peticionReport.codCliente = this.environment.codCliente;
        if (tipo == 'excel' || tipo == 'pdf') {
            this.peticionReport.filtros = this.hashCaminoMiga;
            this.postDownloadReportFile(this.peticionReport, tipo);
        }
        else {
            if (this.paginator != undefined) {
                this.paginator.pageIndex = 0;
            }
            this.postSentReportServices(this.peticionReport);
        }
    };
    /**
     * @return {?}
     */
    LstDescargaComponent.prototype.onSubmitDescarga = /**
     * @return {?}
     */
    function () {
        if (this.idArchivo) {
            this.downloadFile.idArchivo = this.idArchivo;
            this.downloadFile.idFacturador = this.idFacturador;
            this.postDownloadFile(this.downloadFile);
        }
        else {
            this.showDialog('Información', 'Seleccione el archivo a descargar.', false);
        }
    };
    /**
     * @param {?} body
     * @return {?}
     */
    LstDescargaComponent.prototype.postSentReportServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.show = true;
        this.fachistservice.postListarArchivos(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.size = data.resultado.length;
                _this.resultadoReport = [];
                _this.resultadoReport.push(data);
                /* var listArchivos: String[] = [];
                for (let index = 0; index < data.resultado.length; index++) {
                  if (data.resultado[index]['codTpoPortal'] != this.COD_TPO_PORTAL) {
                    this.vistaCantidad += 1;
                    listArchivos.push(data.resultado[index]);
                  }
                } */
                _this.dataSource = new MatTableDataSource(data.resultado);
                _this.dataSource.paginator = _this.paginator;
                _this.dataSource.sort = _this.sort;
                if (_this.size == 0) {
                    _this.show = false;
                    _this.isCollapsed = false;
                }
                else {
                    _this.isCollapsed = true;
                }
                _this.mensajeError = 0;
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.loader.hide();
                _this.mensajeError = 1;
                console.log('Error: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            _this.loader.hide();
            _this.mensajeError = 1;
            console.log('Error: ', err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    LstDescargaComponent.prototype.postDownloadFile = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.phttp.downloadService(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = new Blob([data.body], { type: data.body.type });
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                a.download = _this.nombre;
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo más tarde.', false);
        }));
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    LstDescargaComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiFacturasMT/listaArchivo/' + tipo;
        this.phttpd.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'reporteArchivos' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'reporteArchivos' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @return {?}
     */
    LstDescargaComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        //this.listDescargasFormGroup.reset();
        this.fechaInicioProceso = '01/01/2000';
        this.fechaFinProceso = '01/01/2000';
        this.idArchivo = null;
        this.peticionReport.idFacturador = '-1';
        this.peticionReport.idConvenio = '-1';
        this.peticionReport.tipoArchivo = '-1';
        this.peticionReport.estadoProceso = '-1';
        this.ArchivoDescargasFormGroup.controls.radioGroupArcId.reset();
        this.listDescargasFormGroup.controls.tipoArchivo.setValue('-1');
        this.listDescargasFormGroup.controls.idFacturador.reset('-1' + ',' + '-1');
        this.listDescargasFormGroup.controls.estado.setValue('-1');
        this.listDescargasFormGroup.get('fechaProceso').setValue(null);
        this.dataSource = new MatTableDataSource([]);
        this.show = false;
        this.mensajeError = -1;
        this.consulta = -1;
        this.size = 0;
        this.setInitialBreadcrumbs();
        this.listDescargasFormGroup.get('fechaProceso').setValue(null);
    };
    /**
     * @param {?} event
     * @param {?} param
     * @param {?} idfacturador
     * @param {?} nombre
     * @return {?}
     */
    LstDescargaComponent.prototype.onCheckboxChange = /**
     * @param {?} event
     * @param {?} param
     * @param {?} idfacturador
     * @param {?} nombre
     * @return {?}
     */
    function (event, param, idfacturador, nombre) {
        this.idArchivo = param;
        this.idFacturador = idfacturador.toString();
        this.nombre = nombre;
    };
    /**
     * @param {?} body
     * @return {?}
     */
    LstDescargaComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.phttpe.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var emp = new EmpresaResult();
                emp.idFacturador = -1;
                emp.idConvenio = '-1';
                emp.nomFacturador = "Todas";
                data.resultado.splice(0, 0, emp);
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.error('Error postSentEmpresaServices', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postSentEmpresaServices', err);
        }));
    };
    // postSentSelectEmpresaServices(body: EmpresasPeticion) {
    //   this.phttpe.postListarSelectEmpresas(body).subscribe(data => {
    //     if (data.codret == '0') {
    //       let emp : EmpresaResult = new EmpresaResult();
    //       emp.nomFacturador="Todas";
    //       emp.idFacturador =-1;
    //       data.resultado.splice(0,0,emp);
    //       this.resultadoEmpresa = [];
    //       this.resultadoEmpresa = data.resultado;
    //     } else {
    //       console.log('Error: ', 'postListarSelectEmpresas ' + data.descret);
    //     }
    //   }, err => {
    //     console.error("Error postListarSelectEmpresas: ", err);
    //   });
    // }
    // postSentSelectEmpresaServices(body: EmpresasPeticion) {
    //   this.phttpe.postListarSelectEmpresas(body).subscribe(data => {
    //     if (data.codret == '0') {
    //       let emp : EmpresaResult = new EmpresaResult();
    //       emp.nomFacturador="Todas";
    //       emp.idFacturador =-1;
    //       data.resultado.splice(0,0,emp);
    //       this.resultadoEmpresa = [];
    //       this.resultadoEmpresa = data.resultado;
    //     } else {
    //       console.log('Error: ', 'postListarSelectEmpresas ' + data.descret);
    //     }
    //   }, err => {
    //     console.error("Error postListarSelectEmpresas: ", err);
    //   });
    // }
    /**
     * @param {?} event
     * @return {?}
     */
    LstDescargaComponent.prototype.onEmpresaSelect = 
    // postSentSelectEmpresaServices(body: EmpresasPeticion) {
    //   this.phttpe.postListarSelectEmpresas(body).subscribe(data => {
    //     if (data.codret == '0') {
    //       let emp : EmpresaResult = new EmpresaResult();
    //       emp.nomFacturador="Todas";
    //       emp.idFacturador =-1;
    //       data.resultado.splice(0,0,emp);
    //       this.resultadoEmpresa = [];
    //       this.resultadoEmpresa = data.resultado;
    //     } else {
    //       console.log('Error: ', 'postListarSelectEmpresas ' + data.descret);
    //     }
    //   }, err => {
    //     console.error("Error postListarSelectEmpresas: ", err);
    //   });
    // }
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaComercio = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstDescargaComponent.prototype.onEstadoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEstado = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstDescargaComponent.prototype.onTipoArchivoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaTipoArchivo = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @return {?}
     */
    LstDescargaComponent.prototype.postSentEstadoServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.fachistservice.postListarEstadoArchivos().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var estAr = new EstadoArchivosResult();
                estAr.codigo = '-1';
                estAr.descripcion = "Todos";
                estAr.idEstado = '-1';
                data.resultado.splice(0, 0, estAr);
                _this.resultadoEstado = data.resultado;
            }
            else {
                console.error('Error postListarEstadoArchivos: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postListarEstadoArchivos: ', err);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    LstDescargaComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstDescargaComponent.prototype.selectfechaProceso = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.fechaInicioProceso = formatDate(event.value.begin, 'dd/MM/yyyy', 'en-US');
        this.fechaFinProceso = formatDate(event.value.end, 'dd/MM/yyyy', 'en-US');
    };
    /**
     * @return {?}
     */
    LstDescargaComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.listDescargasFormGroup.valid) {
            this.onSubmit('');
        }
    };
    /**
     * @param {?} resul
     * @return {?}
     */
    LstDescargaComponent.prototype.formateandoMonto = /**
     * @param {?} resul
     * @return {?}
     */
    function (resul) {
        return FormatoMonedaUtil.formatearMonto(resul);
    };
    /**
     * @return {?}
     */
    LstDescargaComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('componenteHijo');
    };
    /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    LstDescargaComponent.prototype.getEmpresaConvenio = /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    function (nomFacturador, descConvenio) {
        return descConvenio != "" ? nomFacturador + ": " + descConvenio : nomFacturador;
    };
    LstDescargaComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-list-descargas',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <!--h3 class=\"titulo-seccion\">Descargas</h3-->\r\n    <div class=\"modulo-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n      </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"listDescargasFormGroup\" autocomplete=\"off\">\r\n              <div class=\"form-row align-left\">\r\n                <div class=\"col-md-6\">\r\n                  <div class=\"filtro-fecha\">\r\n                    <button type=\"button\" class=\"btn fecha\" (click)=\"picker1.open()\"><i class=\"str-icon-calendario\"></i> Buscar por fecha de proceso\r\n                      <ng-container *ngIf=\"this.listDescargasFormGroup.get('fechaProceso').value != null && this.fechaInicioProceso != '01/01/2000'\">\r\n                        <span>{{ this.fechaInicioProceso + ' - ' + this.fechaFinProceso }}</span>\r\n                      </ng-container>\r\n                    </button>\r\n                    <mat-form-field style=\"display: none;\">\r\n                      <input matInput placeholder=\"Fecha\" [max]=\"unavailabilityForm.controls.endDate.value\" [satDatepicker]=\"picker1\" formControlName=\"fechaProceso\" (dateInput)=\"selectfechaProceso($event)\">\r\n                      <sat-datepicker-toggle matSuffix [for]=\"picker1\"></sat-datepicker-toggle>\r\n                      <sat-datepicker touchUi #picker1 [rangeMode]=\"true\" [selectFirstDateOnClose]=\"true\"></sat-datepicker>\r\n                    </mat-form-field>\r\n                    <!-- <div class=\"btn fecha\" id=\"selectorFecha\" data-toggle=\"modal\" data-target=\"#fechaProcesoModal\" #fechaProcesoModal (click)=\"showModal('', fechaProcesoModal)\">\r\n                      <i class=\"str-icon-calendario\"></i>\r\n                      <ng-container *ngIf=\"selectedProcessLabel !== null && selectedProcessLabel !== ''; else noSelectedProcessLabel\">\r\n                        <span>: {{ selectedProcessLabel }}</span>\r\n                      </ng-container>\r\n                      <ng-template #noSelectedProcessLabel>\r\n                        <span> Buscar por fecha de proceso</span>\r\n                      </ng-template>\r\n                    </div> -->\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-row\">\r\n                <div class=\"form-group col-sm\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Tipo de Archivo\" formControlName=\"tipoArchivo\" (selectionChange)=\"onTipoArchivoSelect($event)\">\r\n                      <mat-option *ngFor=\"let arch of archivos\" [value]=\"arch.id\">{{arch.name}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-sm\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estado\" (selectionChange)=\"onEstadoSelect($event)\">\r\n                        <mat-option *ngFor=\"let estado of resultadoEstado\" [value]=\"estado.idEstado\">{{estado.descripcion}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n\r\n                <div class=\"form-group col-sm\" *ngIf=\"comboComercio\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"idFacturador\" (selectionChange)=\"onEmpresaSelect($event)\">\r\n                      <mat-option class=\"multiline-mat-option\" *ngFor=\"let comercio of resultadoEmpresa\" [value]=\"comercio.idFacturador +','+ comercio.idConvenio\"> {{getEmpresaConvenio(comercio.nomFacturador, comercio.descConvenio)}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n\r\n              </div>\r\n              <div class=\"actions\">\r\n                <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\" (click)=\"validarForm()\">Filtrar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"resultados-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-10\">\r\n          <div class=\"tags row\">\r\n            <div *ngFor=\"let entry of hashCaminoMiga\" class=\"item\">{{entry.title}}: {{entry.text}}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n          <div class=\"numero-resultados\">\r\n            <strong>{{ (size == 1) ? ( size + \" Resultado\") : size + \" Resultados\" }}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-container table-responsive-md\">\r\n        <form [formGroup]=\"ArchivoDescargasFormGroup\" (ngSubmit)=\"onSubmitDescarga();\" #ArchivoDescargasForm=\"ngForm\" autocomplete=\"off\">\r\n          <div class=\"table-container table-responsive-md\">\r\n            <div class=\"menu-descargas\">\r\n              <div class=\"form-row\">\r\n                <div class=\"form-group col-sm-6\">\r\n                  <!-- <br>\r\n                  <p style=\"font-weight: bold;font-size: small;\">Seleccione el elemento a descargar</p> -->\r\n                </div>\r\n                <div class=\"form-group col-sm-6 text-right\">\r\n                  <button type=\"submit\" class=\"btn main\">Descargar</button>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <mat-radio-group formControlName=\"radioGroupArcId\" name=\"radioGroupArcId\" class=\"example-radio-button\">\r\n              <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n                <ng-container matColumnDef=\"checkbox\">\r\n                  <th mat-header-cell *matHeaderCellDef></th>\r\n                  <td mat-cell *matCellDef=\"let resultado; let i = index\">\r\n                    <!-- <div class=\"custom-control custom-checkbox\">\r\n                  <mat-checkbox formControlName=\"archivo_id\" [value]=\"resultado.arc_id\" [id]=\"resultado.arc_id\" (change)=\"onCheckboxChange($event, resultado.arc_id, resultado.idFacturador, resultado.nombre)\"></mat-checkbox>\r\n                </div> -->\r\n                    <div class=\"form-row\">\r\n                      <mat-radio-button class=\"example-radio-button\" radioGroup=\"radioGroupArcId\" value=\"{{resultado.arc_id}}\" (change)=\"onCheckboxChange($event, resultado.arc_id, resultado.idFacturador, resultado.nombre)\">\r\n                      </mat-radio-button>\r\n                      <!-- <mat-radio-button class=\"example-radio-button\" *ngIf=\"(i!=0)\" radioGroup=\"radioGroupArcId\" value=\"{{resultado.arc_id}}\" (change)=\"onCheckboxChange($event, resultado.arc_id, resultado.idFacturador, resultado.nombre)\"></mat-radio-button> -->\r\n                    </div>\r\n                  </td>\r\n                </ng-container>\r\n                <ng-container matColumnDef=\"empresa\" *ngIf=\"comboComercio\">\r\n                  <th mat-header-cell *matHeaderCellDef>Empresa</th>\r\n                  <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\">{{resultado.nomFacturador}}: {{resultado.cnvDescrip}}</td>\r\n                </ng-container>\r\n                <ng-container matColumnDef=\"tipo_archivo\">\r\n                  <th mat-header-cell *matHeaderCellDef>Tipo de archivo</th>\r\n                  <td mat-cell *matCellDef=\"let resultado\">{{resultado.tipo_archivo}}</td>\r\n                </ng-container>\r\n                <ng-container matColumnDef=\"nombre\">\r\n                  <th mat-header-cell *matHeaderCellDef>Nombre</th>\r\n                  <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\">{{resultado.nombre}}</td>\r\n                </ng-container>\r\n                <ng-container matColumnDef=\"cantidad\">\r\n                  <th mat-header-cell *matHeaderCellDef>Registros</th>\r\n                  <td mat-cell *matCellDef=\"let resultado\">{{resultado.cantidad | cantidad}}</td>\r\n                </ng-container>\r\n                <ng-container matColumnDef=\"monto\">\r\n                  <th mat-header-cell *matHeaderCellDef>Monto</th>\r\n                  <td mat-cell *matCellDef=\"let resultado\">{{formateandoMonto(resultado)}}</td>\r\n                </ng-container>\r\n                <ng-container matColumnDef=\"fec_proceso\">\r\n                  <th mat-header-cell *matHeaderCellDef>Fecha de proceso</th>\r\n                  <td mat-cell *matCellDef=\"let resultado\">\r\n                    <span *ngIf=\"resultado.fec_proceso == null; else elseBlock\">-</span>\r\n                    <ng-template #elseBlock>{{resultado.fec_proceso | date:'dd/MM/yyyy'}}</ng-template>\r\n                  </td>\r\n                </ng-container>\r\n                <ng-container matColumnDef=\"estado_proceso_desc\">\r\n                  <th mat-header-cell *matHeaderCellDef>Estado</th>\r\n                  <td mat-cell *matCellDef=\"let resultado\">\r\n                    <span *ngIf=\"resultado.estado_proceso == 'ING' \" class=\"databar ingresado\">{{resultado.estado_proceso_desc}}</span>\r\n                    <span *ngIf=\"resultado.estado_proceso == 'RCH' \" class=\"databar rechazado\">{{resultado.estado_proceso_desc}}</span>\r\n                    <span *ngIf=\"resultado.estado_proceso == 'PRO' \" class=\"databar procesado\">{{resultado.estado_proceso_desc}}</span>\r\n                    <span *ngIf=\"resultado.estado_proceso == 'COB' \" class=\"databar proceso\">{{resultado.estado_proceso_desc}}</span>\r\n                    <span *ngIf=\"resultado.estado_proceso == 'ANL' \" class=\"databar eliminado\">{{resultado.estado_proceso_desc}}</span>\r\n                    <span *ngIf=\"resultado.estado_proceso == 'RAU' \" class=\"databar rechazado\">{{resultado.estado_proceso_desc}}</span>\r\n                    <span *ngIf=\"resultado.estado_proceso == 'AUT' \" class=\"databar pendiente\">{{resultado.estado_proceso_desc}}</span>\r\n                  </td>\r\n                </ng-container>\r\n                <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n                <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n              </table>\r\n            </mat-radio-group>\r\n            <mat-paginator [pageSizeOptions]=\"[10]\" showFirstLastButtons></mat-paginator>\r\n          </div>\r\n        </form>\r\n      </div>\r\n\r\n      <div class=\"box-actions\" *ngIf=\"size > 0\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6 item\">\r\n            <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n          </div>\r\n          <div class=\"col-md-6 item-right\">\r\n            <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </section>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"mensajeError == 0 && size == 0\">\r\n      <span>\r\n        No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.\r\n      </span>\r\n    </div>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"consulta == -1\">\r\n      <span>\r\n        Establezca sus criterios de b&uacute;squeda.\r\n      </span>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div *ngIf=\"mensajeError == 1\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" id=\"modal-basic-title\" style=\"color:#ec0000;font-weight: bold\">Error</h3>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <p>Servicio temporalmente no disponible.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [listDescargaService, EmpresasService, DescargaExcelPdfFileService,
                        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
                        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
                        { provide: MAT_DATE_FORMATS, useValue: ɵ0$d }]
                }] }
    ];
    /** @nocollapse */
    LstDescargaComponent.ctorParameters = function () { return [
        { type: listDescargaService },
        { type: EmpresasService },
        { type: FacturacionHistorialService },
        { type: DescargaExcelPdfFileService },
        { type: LoaderBaseService },
        { type: MatDialog },
        { type: FormBuilder },
        { type: DatePipe },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    LstDescargaComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator,] }],
        sort: [{ type: ViewChild, args: [MatSort,] }]
    };
    return LstDescargaComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListMedioPagoPeticion = /** @class */ (function () {
    function ListMedioPagoPeticion() {
        this.idUser = '-1';
    }
    return ListMedioPagoPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListMandatoPeticionReporte = /** @class */ (function () {
    function ListMandatoPeticionReporte() {
        this.fechaInicioSuscripcion = '01/01/2000';
        this.fechaFinSuscripcion = '01/01/2000';
        this.nivelUso = '-1';
        this.estadoMandato = '-1';
        this.idServicioEmp = '-1';
        this.idServicio = '-1';
        this.medioPago = '-1';
        this.keyWord = '-1';
        this.idFacturador = '-1';
        this.idConvenio = '-1';
        this.idMandante = '-1';
        this.idRecaudador = '-1';
        this.rubro = '-1';
        this.promotor = '-1';
        this.codTpoPortal = '-1';
        this.filtros = [];
    }
    return ListMandatoPeticionReporte;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var httpOptions$9 = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};
var listMandatoService = /** @class */ (function () {
    function listMandatoService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlApiListMandatos = this.environment.urlAmbiente + '/apiMandatosMT/listaMandatos';
    }
    /**
     * @param {?} _body
     * @return {?}
     */
    listMandatoService.prototype.postRespuestaReport = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlApiListMandatos, _body, httpOptions$9);
    };
    listMandatoService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    listMandatoService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return listMandatoService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var httpOptions$a = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};
var SegmandatosService = /** @class */ (function () {
    function SegmandatosService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlEmp = this.environment.urlAmbiente + '/apiMandatosMT/filtroempresa';
        this.urlSegReport = this.environment.urlAmbiente + '/apiMandatosMT/bitacoraMandatos';
        this.urlSegdetalle = this.environment.urlAmbiente + '/apiMandatosMT/bitacoraManDetalle';
        this.urlEstadoMandato = this.environment.urlAmbiente + '/apiMandatosMT/estadoMandato';
        this.urlMandatosHistorial = this.environment.urlAmbiente + '/apiMandatosMT/listActivaMandatoHistorial';
        this.urlMandatosHistorialDetalle = this.environment.urlAmbiente + '/apiMandatosMT/listActivaMandatoDetalle';
        this.urlListTipoMedioPago = this.environment.urlAmbiente + '/apiMandatosMT/listTipoMedioPago';
    }
    /**
     * @param {?} _body
     * @return {?}
     */
    SegmandatosService.prototype.postRespuesta = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlEmp, _body, httpOptions$a);
    };
    /**
     * @param {?} _body
     * @return {?}
     */
    SegmandatosService.prototype.postRespuestaReport = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlSegReport, _body, httpOptions$a);
    };
    /**
     * @param {?} _body
     * @return {?}
     */
    SegmandatosService.prototype.postRespuestaDetalle = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlSegdetalle, _body, httpOptions$a);
    };
    // Activacion de mandatos
    // Activacion de mandatos
    /**
     * @param {?} _body
     * @return {?}
     */
    SegmandatosService.prototype.postMandatosHistorial = 
    // Activacion de mandatos
    /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlMandatosHistorial, _body, httpOptions$a);
    };
    /**
     * @return {?}
     */
    SegmandatosService.prototype.postEstadoMandato = /**
     * @return {?}
     */
    function () {
        return this.http.post(this.urlEstadoMandato, null, httpOptions$a);
    };
    /**
     * @param {?} _body
     * @return {?}
     */
    SegmandatosService.prototype.postMandatosHistorialDetalle = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlMandatosHistorialDetalle, _body, httpOptions$a);
    };
    /**
     * @param {?} _body
     * @return {?}
     */
    SegmandatosService.prototype.postTipoMedioPago = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlListTipoMedioPago, _body, httpOptions$a);
    };
    SegmandatosService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    SegmandatosService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    /** @nocollapse */ SegmandatosService.ngInjectableDef = defineInjectable({ factory: function SegmandatosService_Factory() { return new SegmandatosService(inject(HttpClient), inject("env")); }, token: SegmandatosService, providedIn: "root" });
    return SegmandatosService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$e = MAT_MOMENT_DATE_FORMATS;
var LstMandatosComponent = /** @class */ (function () {
    function LstMandatosComponent(segmandatosService, phttp, empresaservice, globals, phttpd, loader, dialog, formBuilder, datepipe, environment) {
        this.segmandatosService = segmandatosService;
        this.phttp = phttp;
        this.empresaservice = empresaservice;
        this.globals = globals;
        this.phttpd = phttpd;
        this.loader = loader;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.datepipe = datepipe;
        this.environment = environment;
        this.fechaInicioSuscripcion = '01/01/2000';
        this.fechaFinSuscripcion = '01/01/2000';
        this.peticionReport = new ListMandatoPeticionReporte();
        this.vistaCantidad = 0;
        this.vistaComercio = 'Todos';
        this.vistaRubro = 'Todos';
        this.hashCaminoMiga = [];
        this.nivelUsoSelect = [
            { option: 'Todos', value: '-1' },
            { option: 'Cobros último mes', value: 'CUM' },
        ];
        this.ListMedioPagoPost = new ListMedioPagoPeticion();
        this.mensajeError = -1;
        this.isCollapsed = false;
        this.consulta = -1;
        this.resultadoRubros = [];
        this.resultadoEmpresa = [];
        this.peticionEmpresa = new EmpresasPeticion();
        this.comboComercio = false;
        this.displayedColumns = [];
        /** @type {?} */
        var fecha = new Date();
        /** @type {?} */
        var mañana = fecha.setDate(fecha.getDate() + 1);
        /** @type {?} */
        var fechaFormat = this.datepipe.transform(mañana, 'yyyy-MM-dd');
        this.unavailabilityForm = this.formBuilder.group({
            endDate: [fechaFormat + 'T00:00:00.000Z']
        });
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idEmpresaPac = this.userPerfil.empresa.idEmpresaPac;
    }
    /**
     * @return {?}
     */
    LstMandatosComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (sessionStorage.getItem('componenteHijo') != 'listMandatosDetalles') {
            sessionStorage.removeItem('indice');
        }
        this.peticionReport.estadoMandato = '-1';
        this.peticionReport.idServicio = '-1';
        this.peticionReport.medioPago = '-1';
        this.peticionReport.idMandante = '-1';
        this.peticionReport.idRecaudador = '-1';
        this.peticionReport.idConvenio = '-1';
        this.peticionReport.promotor = '-1';
        this.formGroup = new FormGroup({
            nivelUso: new FormControl('-1'),
            estadoMandato: new FormControl(),
            idServicio: new FormControl(),
            medioPago: new FormControl(),
            idRubro: new FormControl(),
            idFacturador: new FormControl('-1' + ',' + '-1'),
            fechaSuscripcion: new FormControl(),
            promotor: new FormControl()
        });
        if (this.codTpoPortal == 'COMERCIO') {
            this.displayedColumns = ['fec_suscripcion', 'ultima_pago', 'alias_mandato', 'est_mandato', 'nro_servicio', 'med_pago', 'promotor', 'detalle'];
            this.comboComercio = false;
            this.peticionReport.idFacturador = this.idEmpresaPac;
        }
        else {
            this.displayedColumns = ['fec_suscripcion', 'ultima_pago', 'alias_mandato', 'est_mandato', 'nro_servicio', 'factEmpresa', 'med_pago', 'promotor', 'detalle'];
            this.comboComercio = true;
            this.peticionReport.idFacturador = '-1';
            this.postSentRubrosServices();
        }
        this.consulta = -1;
        //this.formGroup.controls['idFacturador'].disable();
        this.postTipoMedioPagoServices();
        this.postEstadoMandatoServices();
        this.postEmpresas();
        this.formGroup.controls.estadoMandato.setValue('-1');
        this.formGroup.controls.idRubro.setValue('-1');
        this.formGroup.get('idFacturador').setValue('-1' + ',' + '-1');
        this.formGroup.controls.medioPago.setValue('-1');
        if (sessionStorage.getItem('componenteHijo') == 'listMandatosDetalles') {
            this.consulta = 0;
            /** @type {?} */
            var llamadaPadre = JSON.parse(sessionStorage.getItem('llamadaPadre'));
            // Llena los filtros
            this.formGroup.controls['fechaSuscripcion'].setValue(llamadaPadre.filtroSuscripcionI);
            this.fechaInicioSuscripcion = llamadaPadre.fechaInicioSuscripcion;
            this.fechaFinSuscripcion = llamadaPadre.fechaFinSuscripcion;
            this.formGroup.controls['nivelUso'].setValue(llamadaPadre.nivelUso);
            this.formGroup.controls['idServicio'].setValue((llamadaPadre.idServicio != '-1' ? llamadaPadre.idServicio : ''));
            this.formGroup.controls['estadoMandato'].setValue(llamadaPadre.estadoMandato);
            this.formGroup.controls['medioPago'].setValue(llamadaPadre.medioPago);
            this.formGroup.controls['idRubro'].setValue(llamadaPadre.rubro);
            this.formGroup.controls['promotor'].setValue((llamadaPadre.promotor != '-1' ? llamadaPadre.promotor : ''));
            if (this.formGroup.get('idRubro').value != '-1') {
                this.peticionEmpresa.codRubro = llamadaPadre.rubro;
                this.peticionEmpresa.codCliente = this.environment.codCliente;
                this.peticionEmpresa.codEstadoConvenio = 'HBL';
                //this.formGroup.controls['idFacturador'].reset('-1');
                this.postSentEmpresaServices(this.peticionEmpresa);
                //this.postSentSelectEmpresaServices(this.peticionEmpresa);
                //this.formGroup.controls['idFacturador'].enable();
                //this.formGroup.controls['idFacturador'].setValue('-1');
            }
            this.formGroup.controls['idFacturador'].setValue(llamadaPadre.idFacturador + ',' + llamadaPadre.idConvenio);
            // Llena camino de migas
            /** @type {?} */
            var migasPadre = JSON.parse(sessionStorage.getItem('migasPadre'));
            this.vistaUtimoMes = migasPadre.nivelUso;
            this.vistaEstado = migasPadre.estadoMandato;
            this.vistaMedioPago = migasPadre.medioPago;
            this.hashCaminoMiga[0] = { title: 'Fecha Suscripción', text: migasPadre.fechaSuscripcion };
            this.hashCaminoMiga[1] = { title: 'Nivel Uso', text: migasPadre.nivelUso };
            this.hashCaminoMiga[2] = { title: 'Estado', text: migasPadre.estadoMandato };
            this.hashCaminoMiga[3] = { title: 'ID Servicio', text: migasPadre.idServicio };
            this.hashCaminoMiga[4] = { title: 'Medio Pago', text: migasPadre.medioPago };
            this.hashCaminoMiga[5] = { title: 'Promotor', text: migasPadre.promotor };
            if (this.codTpoPortal != 'COMERCIO') {
                this.vistaRubro = migasPadre.rubro;
                this.vistaComercio = migasPadre.idFacturador;
                this.hashCaminoMiga[6] = { title: 'Rubro', text: migasPadre.rubro };
                this.hashCaminoMiga[7] = { title: 'Empresa', text: migasPadre.idFacturador };
            }
            // Llama al servicio
            this.peticionReport.fechaInicioSuscripcion = llamadaPadre.fechaInicioSuscripcion;
            this.peticionReport.fechaFinSuscripcion = llamadaPadre.fechaFinSuscripcion;
            this.peticionReport.nivelUso = llamadaPadre.nivelUso;
            this.peticionReport.estadoMandato = llamadaPadre.estadoMandato;
            this.peticionReport.idServicio = llamadaPadre.idServicio;
            this.peticionReport.medioPago = llamadaPadre.medioPago;
            this.peticionReport.rubro = llamadaPadre.rubro;
            this.peticionReport.idFacturador = llamadaPadre.idFacturador;
            this.peticionReport.idConvenio = llamadaPadre.idConvenio;
            this.peticionReport.promotor = llamadaPadre.promotor;
            this.postSentReportServices(this.peticionReport);
        }
        else {
            this.setInitialBreadcrumbs();
        }
    };
    /**
     * @return {?}
     */
    LstMandatosComponent.prototype.setInitialBreadcrumbs = /**
     * @return {?}
     */
    function () {
        this.hashCaminoMiga[0] = { title: 'Fecha Suscripción', text: 'Todos' };
        this.hashCaminoMiga[1] = { title: 'Nivel Uso', text: 'Todos' };
        this.hashCaminoMiga[2] = { title: 'Estado', text: 'Todos' };
        this.hashCaminoMiga[3] = { title: 'ID Servicio', text: '' };
        this.hashCaminoMiga[4] = { title: 'Medio Pago', text: 'Todos' };
        this.hashCaminoMiga[5] = { title: 'Promotor', text: '' };
        if (this.codTpoPortal != 'COMERCIO') {
            this.hashCaminoMiga[6] = { title: 'Rubro', text: 'Todos' };
            this.hashCaminoMiga[7] = { title: 'Empresa', text: 'Todas' };
        }
    };
    /**
     * @return {?}
     */
    LstMandatosComponent.prototype.postTipoMedioPagoServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.segmandatosService.postTipoMedioPago(this.ListMedioPagoPost).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoTipoMedioPago = [];
                /** @type {?} */
                var todos = JSON.parse('{"idTipoMedioPago":"-1","codigoTipoMedioPago":"-1","tipoMedioPago":"Todos","marcaMedioPago":"Todos"}');
                data.resultado.splice(0, 0, todos);
                _this.resultadoTipoMedioPago.push(data);
            }
            else {
                console.error('Error postTipoMedioPago: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postTipoMedioPago: ', err);
        }));
    };
    /**
     * @return {?}
     */
    LstMandatosComponent.prototype.postEstadoMandatoServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.segmandatosService.postEstadoMandato().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEstadoMandato = [];
                /** @type {?} */
                var todos = JSON.parse('{"idEstado":"-1","descripcion":"Todos"}');
                data.resultado.splice(0, 0, todos);
                _this.resultadoEstadoMandato.push(data);
            }
            else {
                console.error('Error postEstadoMandatoServices: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postEstadoMandatoServices: ', err);
        }));
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    LstMandatosComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.consulta = 0;
        this.peticionReport.codTpoPortal = this.codTpoPortal;
        this.peticionReport.idRecaudador = '-1';
        this.peticionReport.keyWord = '-1';
        this.filtroSuscripcionI = this.formGroup.get('fechaSuscripcion').value;
        if (this.filtroSuscripcionI != null) {
            this.peticionReport.fechaInicioSuscripcion = formatDate(this.filtroSuscripcionI.begin, 'dd/MM/yyyy', 'en-US');
            this.peticionReport.fechaFinSuscripcion = formatDate(this.filtroSuscripcionI.end, 'dd/MM/yyyy', 'en-US');
            this.hashCaminoMiga[0] = { title: 'Fecha Suscripción', text: this.fechaInicioSuscripcion + ' - ' + this.fechaFinSuscripcion };
        }
        else {
            this.hashCaminoMiga[0] = { title: 'Fecha Suscripción', text: 'Todos' };
            this.peticionReport.fechaInicioSuscripcion = this.fechaInicioSuscripcion;
            this.peticionReport.fechaFinSuscripcion = this.fechaFinSuscripcion;
        }
        if (this.formGroup.get('nivelUso').value == null) {
            this.peticionReport.nivelUso = '-1';
            this.hashCaminoMiga[1] = { title: 'Nivel Uso', text: 'Todos' };
        }
        else {
            this.peticionReport.nivelUso = this.formGroup.get('nivelUso').value;
            this.hashCaminoMiga[1] = { title: 'Nivel Uso', text: this.vistaUtimoMes };
        }
        if (this.formGroup.get('estadoMandato').value == null || this.formGroup.get('estadoMandato').value == '-1') {
            this.peticionReport.estadoMandato = '-1';
            this.hashCaminoMiga[2] = { title: 'Estado', text: 'Todos' };
        }
        else {
            this.peticionReport.estadoMandato = this.formGroup.get('estadoMandato').value;
            this.hashCaminoMiga[2] = { title: 'Estado', text: this.vistaEstado };
        }
        if (this.formGroup.get('idServicio').value == null || this.formGroup.get('idServicio').value == "") {
            this.peticionReport.idServicio = '-1';
            this.hashCaminoMiga[3] = { title: 'ID Servicio', text: '' };
        }
        else {
            this.peticionReport.idServicio = this.formGroup.get('idServicio').value;
            this.hashCaminoMiga[3] = { title: 'ID Servicio', text: this.formGroup.get('idServicio').value };
        }
        if (this.formGroup.get('medioPago').value == null || this.formGroup.get('medioPago').value == '-1') {
            this.peticionReport.medioPago = '-1';
            this.hashCaminoMiga[4] = { title: 'Medio Pago', text: 'Todos' };
        }
        else {
            this.peticionReport.medioPago = this.formGroup.get('medioPago').value;
            this.hashCaminoMiga[4] = { title: 'Medio Pago', text: this.vistaMedioPago };
        }
        if (this.formGroup.get('promotor').value == null || this.formGroup.get('promotor').value == '') {
            this.peticionReport.promotor = '-1';
            this.hashCaminoMiga[5] = { title: 'Promotor', text: '' };
        }
        else {
            this.peticionReport.promotor = this.formGroup.get('promotor').value;
            this.hashCaminoMiga[5] = { title: 'Promotor', text: this.formGroup.get('promotor').value };
        }
        if (this.codTpoPortal == 'COMERCIO') {
            this.peticionReport.idFacturador = this.idEmpresaPac;
        }
        else {
            if (this.formGroup.get('idRubro').value == null || this.formGroup.get('idRubro').value == '-1') {
                this.peticionReport.rubro = '-1';
                this.hashCaminoMiga[6] = { title: 'Rubro', text: 'Todos' };
            }
            else {
                this.peticionReport.rubro = this.formGroup.get('idRubro').value;
                this.hashCaminoMiga[6] = { title: 'Rubro', text: this.vistaRubro };
            }
            /** @type {?} */
            var idFacturador = this.formGroup.get('idFacturador').value.split(",")[0];
            if (idFacturador == null || idFacturador == '' || idFacturador == -1) {
                this.peticionReport.idFacturador = '-1';
                this.peticionReport.idConvenio = '-1';
                this.hashCaminoMiga[7] = { title: 'Empresa', text: 'Todas' };
            }
            else {
                this.peticionReport.idFacturador = this.formGroup.get('idFacturador').value.split(",")[0];
                this.peticionReport.idConvenio = this.formGroup.get('idFacturador').value.split(",")[1];
                this.hashCaminoMiga[7] = { title: 'Empresa', text: this.vistaComercio };
            }
        }
        sessionStorage.setItem('llamadaPadre', JSON.stringify({
            fechaInicioSuscripcion: this.peticionReport.fechaInicioSuscripcion,
            fechaFinSuscripcion: this.peticionReport.fechaFinSuscripcion,
            nivelUso: this.peticionReport.nivelUso,
            estadoMandato: this.peticionReport.estadoMandato,
            idServicio: this.peticionReport.idServicio,
            medioPago: this.peticionReport.medioPago,
            rubro: this.peticionReport.rubro,
            idFacturador: this.peticionReport.idFacturador,
            idConvenio: this.peticionReport.idConvenio,
            filtroSuscripcionI: this.filtroSuscripcionI,
            promotor: this.peticionReport.promotor
        }));
        sessionStorage.setItem('migasPadre', JSON.stringify({
            fechaSuscripcion: this.hashCaminoMiga[0].text,
            nivelUso: this.hashCaminoMiga[1].text,
            estadoMandato: this.hashCaminoMiga[2].text,
            idServicio: this.hashCaminoMiga[3].text,
            medioPago: this.hashCaminoMiga[4].text,
            promotor: this.hashCaminoMiga[5].text,
            rubro: (this.codTpoPortal != 'COMERCIO' ? this.hashCaminoMiga[6].text : ''),
            idFacturador: (this.codTpoPortal != 'COMERCIO' ? this.hashCaminoMiga[7].text : '')
        }));
        if (tipo == 'excel' || tipo == 'pdf') {
            this.peticionReport.filtros = this.hashCaminoMiga;
            this.postDownloadReportFile(this.peticionReport, tipo);
        }
        else {
            this.postSentReportServices(this.peticionReport);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstMandatosComponent.prototype.onPaginateChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var indice = this.paginator.pageIndex;
        sessionStorage.setItem('indice', indice);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    LstMandatosComponent.prototype.postSentReportServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.show = true;
        this.phttp.postRespuestaReport(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoReport = [];
                _this.resultadoReport.push(data);
                _this.vistaCantidad = data.resultado.length;
                if (_this.paginator != undefined && sessionStorage.getItem('componenteHijo') == 'listMandatosDetalles') {
                    _this.paginator.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indice')))));
                }
                else if (_this.paginator != undefined) {
                    _this.paginator.pageIndex = 0;
                    sessionStorage.removeItem("indice");
                }
                sessionStorage.removeItem('componenteHijo');
                _this.dataSource = new MatTableDataSource(data.resultado);
                _this.dataSource.paginator = _this.paginator;
                _this.dataSource.sort = _this.sort;
                if (_this.vistaCantidad == 0) {
                    _this.show = false;
                    _this.isCollapsed = false;
                }
                else {
                    _this.isCollapsed = true;
                }
                _this.mensajeError = 0;
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.mensajeError = 1;
                _this.loader.hide();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en postRespuestaReport', err);
            _this.show = false;
            _this.mensajeError = 1;
            _this.loader.hide();
        }));
    };
    /**
     * @return {?}
     */
    LstMandatosComponent.prototype.postSentRubrosServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new RubroRequest();
        params.codEstadoConvenio = 'HBL';
        this.empresaservice.postRubrosReport(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var rub = new RubroResult();
                rub.codigo = '-1';
                rub.descripcion = "Todos";
                data.resultado.splice(0, 0, rub);
                _this.resultadoRubros = data.resultado;
            }
            else {
                console.error('Error postRubrosReport: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postRubrosReport: ', err);
        }));
    };
    /**
     * @return {?}
     */
    LstMandatosComponent.prototype.postEmpresas = /**
     * @return {?}
     */
    function () {
        this.peticionEmpresa.codRubro = '-1';
        this.peticionEmpresa.codCliente = this.environment.codCliente;
        this.peticionEmpresa.codEstadoConvenio = 'HBL';
        this.postSentEmpresaServices(this.peticionEmpresa);
        //this.postSentSelectEmpresaServices(this.peticionEmpresa);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    LstMandatosComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.empresaservice.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var empresaResult = new EmpresaResult();
                empresaResult.idFacturador = -1;
                empresaResult.idConvenio = '-1';
                empresaResult.nomFacturador = 'Todas';
                data.resultado.splice(0, 0, empresaResult);
                _this.resultadoEmpresa = data.resultado;
                //this.formGroup.get('idFacturador').setValue(-1);
            }
            else {
                console.log('Error: ', 'postListarEmpresas ' + data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error :', 'postListarEmpresas ' + err);
        }));
    };
    // postSentSelectEmpresaServices(body: EmpresasPeticion) {
    //   this.empresaservice.postListarSelectEmpresas(body).subscribe(data => {
    //     if (data.codret == '0') {
    //       let empresaResult: EmpresaResult = new EmpresaResult();
    //       empresaResult.idFacturador = -1;
    //       empresaResult.nomFacturador = 'Todas';
    //       data.resultado.splice(0, 0, empresaResult);
    //       this.resultadoEmpresa = data.resultado;
    //     } else {
    //       console.log('Error: ', 'postListarSelectEmpresas ' + data.descret);
    //     }
    //   }, err => {
    //     console.error("Error postListarSelectEmpresas: ", err);
    //   });
    // }
    // postSentSelectEmpresaServices(body: EmpresasPeticion) {
    //   this.empresaservice.postListarSelectEmpresas(body).subscribe(data => {
    //     if (data.codret == '0') {
    //       let empresaResult: EmpresaResult = new EmpresaResult();
    //       empresaResult.idFacturador = -1;
    //       empresaResult.nomFacturador = 'Todas';
    //       data.resultado.splice(0, 0, empresaResult);
    //       this.resultadoEmpresa = data.resultado;
    //     } else {
    //       console.log('Error: ', 'postListarSelectEmpresas ' + data.descret);
    //     }
    //   }, err => {
    //     console.error("Error postListarSelectEmpresas: ", err);
    //   });
    // }
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    LstMandatosComponent.prototype.postDownloadReportFile = 
    // postSentSelectEmpresaServices(body: EmpresasPeticion) {
    //   this.empresaservice.postListarSelectEmpresas(body).subscribe(data => {
    //     if (data.codret == '0') {
    //       let empresaResult: EmpresaResult = new EmpresaResult();
    //       empresaResult.idFacturador = -1;
    //       empresaResult.nomFacturador = 'Todas';
    //       data.resultado.splice(0, 0, empresaResult);
    //       this.resultadoEmpresa = data.resultado;
    //     } else {
    //       console.log('Error: ', 'postListarSelectEmpresas ' + data.descret);
    //     }
    //   }, err => {
    //     console.error("Error postListarSelectEmpresas: ", err);
    //   });
    // }
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiMandatosMT/listaMandatos/' + tipo;
        this.phttpd.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'reporteMandatos' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'reporteMandatos' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstMandatosComponent.prototype.onRubroSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event != null) {
            this.vistaRubro = event.source.selected._element.nativeElement.innerText.trim();
            this.peticionEmpresa.codRubro = event.value;
            this.peticionEmpresa.codCliente = this.environment.codCliente;
            this.peticionEmpresa.codEstadoConvenio = 'HBL';
            this.formGroup.controls['idFacturador'].reset('-1' + ',' + '-1');
            this.postSentEmpresaServices(this.peticionEmpresa);
            //this.postSentSelectEmpresaServices(this.peticionEmpresa);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstMandatosComponent.prototype.onComercioSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaComercio = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstMandatosComponent.prototype.onEstadoMandato = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEstado = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstMandatosComponent.prototype.onNivelUsoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaUtimoMes = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstMandatosComponent.prototype.onMedioPagoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaMedioPago = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @return {?}
     */
    LstMandatosComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        //this.formGroup.controls['idFacturador'].disable();
        this.peticionReport.estadoMandato = '-1';
        this.peticionReport.idServicio = '-1';
        this.peticionReport.medioPago = '-1';
        this.peticionReport.nivelUso = '-1';
        this.peticionReport.rubro = '-1';
        this.peticionReport.idFacturador = '-1';
        this.peticionReport.idConvenio = '-1';
        this.peticionReport.promotor = '-1';
        this.postEmpresas();
        this.formGroup.controls.estadoMandato.setValue('-1');
        this.formGroup.controls.idRubro.setValue('-1');
        this.formGroup.get('idFacturador').setValue('-1' + ',' + '-1');
        this.formGroup.controls.medioPago.setValue('-1');
        this.formGroup.get('fechaSuscripcion').setValue(null);
        this.fechaInicioSuscripcion = '01/01/2000';
        this.fechaFinSuscripcion = '01/01/2000';
        this.setInitialBreadcrumbs();
        this.formGroup.controls.idServicio.setValue('');
        this.formGroup.controls.nivelUso.setValue('-1');
        this.formGroup.controls.promotor.setValue('');
        this.dataSource = new MatTableDataSource([]);
        this.consulta = -1;
        this.vistaCantidad = 0;
        this.isCollapsed = false;
        this.show = false;
        this.mensajeError = -1;
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    LstMandatosComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstMandatosComponent.prototype.selectfechaSuscripcion = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.fechaInicioSuscripcion = formatDate(event.value.begin, 'dd/MM/yyyy', 'en-US');
        this.fechaFinSuscripcion = formatDate(event.value.end, 'dd/MM/yyyy', 'en-US');
    };
    /**
     * @return {?}
     */
    LstMandatosComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.onSubmit('');
        }
    };
    /**
     * @return {?}
     */
    LstMandatosComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('componenteHijo');
    };
    /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    LstMandatosComponent.prototype.getEmpresaConvenio = /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    function (nomFacturador, descConvenio) {
        return descConvenio != "" ? nomFacturador + ": " + descConvenio : nomFacturador;
    };
    /**
     * @param {?} resul
     * @return {?}
     */
    LstMandatosComponent.prototype.formateandoMonto = /**
     * @param {?} resul
     * @return {?}
     */
    function (resul) {
        return FormatoMonedaUtil.formatearMonto(resul);
    };
    /**
     * @param {?} medioPago
     * @param {?} index
     * @return {?}
     */
    LstMandatosComponent.prototype.datoMedioPago = /**
     * @param {?} medioPago
     * @param {?} index
     * @return {?}
     */
    function (medioPago, index) {
        /** @type {?} */
        var dato = "";
        if (medioPago != "" || medioPago != null) {
            /** @type {?} */
            var arrMedioPago = medioPago.split(' ');
            dato = arrMedioPago[index];
        }
        return dato;
    };
    /**
     * @param {?} medioPago
     * @return {?}
     */
    LstMandatosComponent.prototype.getClassTarjetaIcon = /**
     * @param {?} medioPago
     * @return {?}
     */
    function (medioPago) {
        /** @type {?} */
        var marca = "";
        marca = this.datoMedioPago(medioPago, 0).toUpperCase();
        return this.globals.getClassTarjetaIcon(marca);
    };
    /**
     * @param {?} descripcion
     * @return {?}
     */
    LstMandatosComponent.prototype.descripcionCorta = /**
     * @param {?} descripcion
     * @return {?}
     */
    function (descripcion) {
        return descripcion.substring(0, 20);
    };
    LstMandatosComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-list-mandatos',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"modulo-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n      </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"formGroup\" autocomplete=\"off\">\r\n              <div class=\"form-row align-left\">\r\n                <div class=\"col-md-6\">\r\n                  <div class=\"filtro-fecha\">\r\n                    <button type=\"button\" class=\"btn fecha\" (click)=\"picker1.open()\"><i class=\"str-icon-calendario\"></i> Buscar por fecha de suscripci&oacute;n\r\n                      <ng-container *ngIf=\"this.formGroup.get('fechaSuscripcion').value != null && this.fechaFinSuscripcion != '01/01/2000' && this.fechaInicioSuscripcion != '01/01/2000'\">\r\n                        <span>{{ this.fechaInicioSuscripcion + ' - ' + this.fechaFinSuscripcion }}</span>\r\n                      </ng-container>\r\n                    </button>\r\n                    <mat-form-field style=\"display: none;\">\r\n                      <input matInput placeholder=\"Fecha\" [max]=\"unavailabilityForm.controls.endDate.value\" [satDatepicker]=\"picker1\" formControlName=\"fechaSuscripcion\" (dateInput)=\"selectfechaSuscripcion($event)\">\r\n                      <sat-datepicker-toggle matSuffix [for]=\"picker1\"></sat-datepicker-toggle>\r\n                      <sat-datepicker touchUi #picker1 [rangeMode]=\"true\" [selectFirstDateOnClose]=\"true\"></sat-datepicker>\r\n                    </mat-form-field>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-row\">\r\n                <div class=\"form-group col-md-3\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Nivel de Uso\" formControlName=\"nivelUso\" id=\"nivelUsoSelect\" (selectionChange)=\"onNivelUsoSelect($event)\">\r\n                      <mat-option *ngFor=\"let nu of nivelUsoSelect\" [value]=\"nu.value\">{{nu.option}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-3\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estadoMandato\" (selectionChange)=\"onEstadoMandato($event)\">\r\n                      <section *ngFor=\"let resp of resultadoEstadoMandato\">\r\n                        <mat-option *ngFor=\"let estado of resp.resultado\" [value]=\"estado.idEstado\">{{estado.descripcion}}</mat-option>\r\n                      </section>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-3\">\r\n                  <mat-form-field>\r\n                    <input matInput maxlength=\"20\" placeholder=\"ID Servicio\" formControlName=\"idServicio\">\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-md-3\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Medio de Pago\" formControlName=\"medioPago\" id=\"medioPagoSelect\" (selectionChange)=\"onMedioPagoSelect($event)\">\r\n                      <section *ngFor=\"let resp of resultadoTipoMedioPago\">\r\n                        <mat-option *ngFor=\"let tipo of resp.resultado\" [value]=\"tipo.codigoTipoMedioPago\">{{tipo.marcaMedioPago}}</mat-option>\r\n                      </section>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n\r\n                <div class=\"form-group col-sm\" *ngIf=\"comboComercio\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Rubro\" formControlName=\"idRubro\" (selectionChange)=\"onRubroSelect($event)\">\r\n                      <mat-option *ngFor=\"let rubro of resultadoRubros\" [value]=\"rubro.codigo\">{{rubro.descripcion}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n\r\n                <div class=\"form-group col-sm\" *ngIf=\"comboComercio\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"idFacturador\" (selectionChange)=\"onComercioSelect($event)\">\r\n                      <mat-option class=\"multiline-mat-option\" *ngFor=\"let empresa of resultadoEmpresa\" [value]=\"empresa.idFacturador +','+ empresa.idConvenio\">{{getEmpresaConvenio(empresa.nomFacturador, empresa.descConvenio)}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-md-3\">\r\n                  <mat-form-field>\r\n                    <input matInput maxlength=\"20\" placeholder=\"Promotor\" formControlName=\"promotor\">\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"actions\">\r\n                <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\" (click)=\"validarForm()\">Filtrar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"resultados-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-10\">\r\n          <div class=\"tags row\">\r\n            <div *ngFor=\"let entry of hashCaminoMiga\" class=\"item\">{{entry.title}}: {{entry.text}}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n          <div class=\"numero-resultados\">\r\n            <strong>{{ (vistaCantidad == 1) ? ( vistaCantidad + \" Resultado\") : vistaCantidad + \" Resultados\" }}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-container table-responsive-md\">\r\n        <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n          <ng-container matColumnDef=\"fec_suscripcion\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha suscripci\u00F3n</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.fec_suscripcion | date:'dd/MM/yyyy'}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"ultima_pago\">\r\n            <th mat-header-cell *matHeaderCellDef>&Uacute;ltimo pago</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              {{ (resultado.ultima_pago !== 'null') ? (resultado.ultima_pago | date: 'dd/MM/yyyy') : \"\" }} -\r\n              {{ (resultado.monto_cargo !== 'null') ? (formateandoMonto(resultado)) : \"\" }}</td>\r\n              <!-- {{ (resultado.monto_cargo !== 'null') ? (resultado.monto_cargo/100 | moneda) : \"\" }}  -->\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"alias_mandato\">\r\n            <th mat-header-cell *matHeaderCellDef>Descripci\u00F3n</th>\r\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\"> {{resultado.alias_mandato}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"est_mandato\">\r\n            <th mat-header-cell *matHeaderCellDef>Estado</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <ng-container *ngIf=\"resultado.idEstado_mandato === '2' || resultado.idEstado_mandato === '4'; else Ingresado_o_activo\">\r\n                <section *ngIf=\"resultado.idEstado_mandato == '4'\">{{resultado.est_mandato}}</section>\r\n                <section *ngIf=\"resultado.idEstado_mandato == '2'\">{{resultado.est_mandato}}</section>\r\n              </ng-container>\r\n              <ng-template #Ingresado_o_activo>\r\n                <ng-container *ngIf=\"resultado.ind_suspendido === '0'; else Suspendido\">\r\n                  <section *ngIf=\"resultado.idEstado_mandato == '3'\">{{resultado.est_mandato}}</section>\r\n                  <section *ngIf=\"resultado.idEstado_mandato == '1'\">{{resultado.est_mandato}}</section>\r\n                </ng-container>\r\n                <ng-template #Suspendido>\r\n                  <section>Suspendido</section>\r\n                </ng-template>\r\n              </ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"nro_servicio\">\r\n            <th mat-header-cell *matHeaderCellDef>ID Servicio</th>\r\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\"> {{resultado.nro_servicio}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"factEmpresa\" *ngIf=\"comboComercio\">\r\n            <th mat-header-cell *matHeaderCellDef>Empresa</th>\r\n            <td  mat-cell *matCellDef=\"let resultado\">\r\n              {{resultado.facturador}}\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"med_pago\">\r\n            <th mat-header-cell *matHeaderCellDef>Medio pago</th>\r\n            <td  mat-cell *matCellDef=\"let resultado\">\r\n              <div class=\"card-column\" ><i [class]=\"getClassTarjetaIcon(resultado.medio_pago)\"></i>{{datoMedioPago(resultado.medio_pago, 2)}}</div>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"promotor\">\r\n            <th mat-header-cell *matHeaderCellDef>Promotor</th>\r\n            <td  mat-cell *matCellDef=\"let resultado\" matTooltip=\"{{resultado.nomPromotor}}\" matTooltipPosition=\"above\" Style=\"cursor: pointer;\">{{descripcionCorta(resultado.nomPromotor)}}</td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"detalle\">\r\n            <th mat-header-cell *matHeaderCellDef>Detalle</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a [routerLink]=\"['../mandatoDetalle']\" [queryParams]=\"{\r\n                  'em':resultado.idEstado_mandato, \r\n                  'is':resultado.ind_suspendido,\r\n                  'id':resultado.idMandato,\r\n                  'a':resultado.alias_mandato,\r\n                  's':resultado.nro_servicio,\r\n                  'f':resultado.facturador,\r\n                  'p':resultado.ultima_pago, \r\n                  'mc':resultado.monto_cargo, \r\n                  'if':resultado.idFacturador,\r\n                  'r':resultado.desc_rubro\r\n                }\"><i class=\"str-icon-flecha-derecha\"></i></a>\r\n            </td>\r\n          </ng-container>\r\n\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n        </table>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" (page)=\"onPaginateChange($event)\" showFirstLastButtons></mat-paginator>\r\n      </div>\r\n      <div class=\"box-actions\" *ngIf=\"vistaCantidad > 0\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6 item\">\r\n            <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n          </div>\r\n          <div class=\"col-md-6 item-right\">\r\n            <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </section>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"mensajeError == 0 && vistaCantidad == 0\">\r\n      <span>\r\n        No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.\r\n      </span>\r\n    </div>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"consulta == -1\">\r\n      <span>\r\n        Establezca sus criterios de b&uacute;squeda.\r\n      </span>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div *ngIf=\"mensajeError == 1\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" id=\"modal-basic-title\" style=\"color:#ec0000;font-weight: bold\">Error</h3>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <p>Servicio temporalmente no disponible.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [listMandatoService, DescargaExcelPdfFileService, EmpresasService,
                        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
                        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
                        { provide: MAT_DATE_FORMATS, useValue: ɵ0$e }]
                }] }
    ];
    /** @nocollapse */
    LstMandatosComponent.ctorParameters = function () { return [
        { type: SegmandatosService },
        { type: listMandatoService },
        { type: EmpresasService },
        { type: Globals },
        { type: DescargaExcelPdfFileService },
        { type: LoaderBaseService },
        { type: MatDialog },
        { type: FormBuilder },
        { type: DatePipe },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    LstMandatosComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator,] }],
        sort: [{ type: ViewChild, args: [MatSort,] }]
    };
    return LstMandatosComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListSegDetallePeticion = /** @class */ (function () {
    function ListSegDetallePeticion() {
        this.idMandato = '-1';
        this.idMandante = '-1';
        this.idFacturador = '-1';
        this.nro_servicio = '-1';
    }
    return ListSegDetallePeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListSegPeticionReporte = /** @class */ (function () {
    function ListSegPeticionReporte() {
    }
    return ListSegPeticionReporte;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var listSegMedioPago = /** @class */ (function () {
    function listSegMedioPago() {
        this.idTipoMedioPago = "";
        this.codigoTipoMedioPago = "";
        this.tipoMedioPago = "";
        this.marcaMedioPago = "";
    }
    return listSegMedioPago;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SegmandatosComponent = /** @class */ (function () {
    function SegmandatosComponent(segmandatosService, loader, empresasService, globals, environment) {
        this.segmandatosService = segmandatosService;
        this.loader = loader;
        this.empresasService = empresasService;
        this.globals = globals;
        this.environment = environment;
        this.peticionReporte = new ListSegPeticionReporte();
        this.peticionDetalle = new ListSegDetallePeticion();
        this.peticionEmpresa = new EmpresasPeticion();
        this.resultadoEmpresa = [];
        this.ListMedioPagoPost = new ListMedioPagoPeticion();
        /* Vistas variables */
        this.size = 0;
        this.consulta = -1;
        this.vistaCantidad = 0;
        this.hashCaminoMiga = [];
        this.comboComercio = false;
        this.mensajeError = -1;
        this.isCollapsed = false;
        this.displayedColumns = ['icono'];
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idEmpresaPac = this.userPerfil.empresa.idEmpresaPac;
    }
    /**
     * @return {?}
     */
    SegmandatosComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.firstFormGroup = new FormGroup({
            idFacturador: new FormControl('-1' + ',' + '-1'),
            medioPago: new FormControl('-1'),
        });
        this.inicializa();
        this.postTipoMedioPagoServices();
        this.setInitialBreadcrumbs();
    };
    /**
     * @return {?}
     */
    SegmandatosComponent.prototype.setInitialBreadcrumbs = /**
     * @return {?}
     */
    function () {
        this.hashCaminoMiga[0] = { title: 'Tarjeta', text: 'Todas' };
        if (this.codTpoPortal != 'COMERCIO') {
            this.hashCaminoMiga[1] = { title: 'Empresa', text: 'Todas' };
        }
    };
    /**
     * @return {?}
     */
    SegmandatosComponent.prototype.inicializa = /**
     * @return {?}
     */
    function () {
        if (this.codTpoPortal == 'COMERCIO') {
            this.comboComercio = false;
            this.firstFormGroup.controls['idFacturador'].disable();
            this.peticionReporte.idFacturador = this.idEmpresaPac;
        }
        else {
            this.comboComercio = true;
            this.firstFormGroup.controls['idFacturador'].enable();
            this.peticionReporte.idFacturador = '-1';
            this.peticionEmpresa.codCliente = this.environment.codCliente;
            this.peticionEmpresa.codEstadoConvenio = 'HBL';
            //this.postSentEmpresaServices(this.peticionEmpresa);
            this.postSentEmpresaServices(this.peticionEmpresa);
        }
        this.peticionReporte.medioPago = '-1';
        this.peticionReporte.idMandante = '-1';
        this.peticionReporte.idConvenio = '-1';
        this.consulta = -1;
        //this.postSentReportServices(this.peticionReporte);
    };
    /**
     * @return {?}
     */
    SegmandatosComponent.prototype.postTipoMedioPagoServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.segmandatosService.postTipoMedioPago(this.ListMedioPagoPost).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var mp = new listSegMedioPago();
                mp.codigoTipoMedioPago = '-1';
                mp.marcaMedioPago = "Todas";
                data.resultado.splice(0, 0, mp);
                _this.resultadoTipoMedioPago = [];
                _this.resultadoTipoMedioPago.push(data);
            }
            else {
                console.error('Error postTipoMedioPago: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postTipoMedioPago: ', err);
        }));
    };
    // postSentSelectEmpresaServices(body: EmpresasPeticion) {
    //   this.empresasService.postListarSelectEmpresas(body).subscribe(data => {
    //     if (data.codret == '0') {
    //       let emp : EmpresaResult = new EmpresaResult();
    //       emp.idFacturador=-1;
    //       emp.nomFacturador="Todas";
    //       data.resultado.splice(0,0,emp);
    //       this.resultadoEmpresa = data.resultado;
    //     } else {
    //       console.error('Error postSentSelectEmpresaServices', data.descret);
    //     }
    //   }, err => {
    //     console.error('Error postSentSelectEmpresaServices', err);
    //   });
    // }
    // postSentSelectEmpresaServices(body: EmpresasPeticion) {
    //   this.empresasService.postListarSelectEmpresas(body).subscribe(data => {
    //     if (data.codret == '0') {
    //       let emp : EmpresaResult = new EmpresaResult();
    //       emp.idFacturador=-1;
    //       emp.nomFacturador="Todas";
    //       data.resultado.splice(0,0,emp);
    //       this.resultadoEmpresa = data.resultado;
    //     } else {
    //       console.error('Error postSentSelectEmpresaServices', data.descret);
    //     }
    //   }, err => {
    //     console.error('Error postSentSelectEmpresaServices', err);
    //   });
    // }
    /**
     * @param {?} body
     * @return {?}
     */
    SegmandatosComponent.prototype.postSentEmpresaServices = 
    // postSentSelectEmpresaServices(body: EmpresasPeticion) {
    //   this.empresasService.postListarSelectEmpresas(body).subscribe(data => {
    //     if (data.codret == '0') {
    //       let emp : EmpresaResult = new EmpresaResult();
    //       emp.idFacturador=-1;
    //       emp.nomFacturador="Todas";
    //       data.resultado.splice(0,0,emp);
    //       this.resultadoEmpresa = data.resultado;
    //     } else {
    //       console.error('Error postSentSelectEmpresaServices', data.descret);
    //     }
    //   }, err => {
    //     console.error('Error postSentSelectEmpresaServices', err);
    //   });
    // }
    /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.empresasService.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var emp = new EmpresaResult();
                emp.idFacturador = -1;
                emp.idConvenio = '-1';
                emp.nomFacturador = "Todas";
                data.resultado.splice(0, 0, emp);
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.error('Error postSentEmpresaServices', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postSentEmpresaServices', err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SegmandatosComponent.prototype.onComercioSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.selectTextEmpresa = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SegmandatosComponent.prototype.onMedioPagoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.selectTextMedioPago = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @return {?}
     */
    SegmandatosComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        this.consulta = 0;
        this.peticionReporte.idMandante = '-1';
        if (this.firstFormGroup.get('medioPago').value == '-1') {
            this.peticionReporte.medioPago = '-1';
            this.hashCaminoMiga[0] = { title: 'Tarjeta', text: 'Todos' };
        }
        else {
            this.peticionReporte.medioPago = this.firstFormGroup.get('medioPago').value;
            this.hashCaminoMiga[0] = { title: 'Tarjeta', text: this.selectTextMedioPago };
        }
        if (this.codTpoPortal == 'COMERCIO') {
            this.peticionReporte.idFacturador = this.idEmpresaPac;
        }
        else {
            /** @type {?} */
            var idFacturador = this.firstFormGroup.get('idFacturador').value.split(",")[0];
            if (idFacturador == null || idFacturador == '' || idFacturador == -1) {
                this.peticionReporte.idFacturador = '-1';
                this.peticionReporte.idConvenio = '-1';
                this.hashCaminoMiga[1] = { title: 'Empresa', text: 'Todas' };
            }
            else {
                this.peticionReporte.idFacturador = this.firstFormGroup.get('idFacturador').value.split(",")[0];
                this.peticionReporte.idConvenio = this.firstFormGroup.get('idFacturador').value.split(",")[1];
                this.hashCaminoMiga[1] = { title: 'Empresa', text: this.selectTextEmpresa };
            }
        }
        if (this.paginator != undefined) {
            this.paginator.pageIndex = 0;
        }
        this.postSentReportServices(this.peticionReporte);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    SegmandatosComponent.prototype.postSentReportServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.show = true;
        this.segmandatosService.postRespuestaReport(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoReporte = [];
                _this.resultadoReporte.push(data);
                _this.vistaCantidad = data.resultado.length;
                _this.dataSource = new MatTableDataSource$1(data.resultado);
                _this.dataSource.paginator = _this.paginator;
                if (_this.vistaCantidad == 0) {
                    _this.show = false;
                    _this.isCollapsed = false;
                }
                else {
                    _this.isCollapsed = true;
                }
                _this.mensajeError = 0;
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.mensajeError = 1;
                _this.loader.hide();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            _this.mensajeError = 1;
            _this.loader.hide();
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    SegmandatosComponent.prototype.postSentDetalleServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.segmandatosService.postRespuestaDetalle(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoDetalle = [];
                _this.resultadoDetalle.push(data);
                _this.size = data.resultado.length;
                _this.loader.hide();
            }
            else {
                console.error('Error postRespuestaDetalle: ', data.descret);
                _this.loader.hide();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postRespuestaDetalle: ', err);
            _this.loader.hide();
        }));
    };
    /**
     * @return {?}
     */
    SegmandatosComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.peticionReporte.medioPago = '-1';
        this.peticionReporte.idFacturador = '-1';
        this.peticionReporte.idConvenio = '-1';
        this.firstFormGroup.controls.medioPago.setValue('-1');
        this.firstFormGroup.controls.idFacturador.reset('-1' + ',' + '-1');
        this.setInitialBreadcrumbs();
        this.mensajeError = -1;
        this.vistaCantidad = 0;
        this.consulta = -1;
        this.show = false;
        this.dataSource = new MatTableDataSource$1([]);
    };
    /**
     * @param {?} nro_servicio
     * @param {?} idMandato
     * @param {?} idFacturador
     * @return {?}
     */
    SegmandatosComponent.prototype.detalle = /**
     * @param {?} nro_servicio
     * @param {?} idMandato
     * @param {?} idFacturador
     * @return {?}
     */
    function (nro_servicio, idMandato, idFacturador) {
        this.resultadoDetalle = [];
        this.peticionDetalle.nro_servicio = nro_servicio;
        this.peticionDetalle.idMandato = idMandato;
        this.peticionDetalle.idFacturador = idFacturador;
        this.peticionDetalle.idMandante = '-1';
        this.postSentDetalleServices(this.peticionDetalle);
    };
    /**
     * @return {?}
     */
    SegmandatosComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.firstFormGroup.valid) {
            this.onSubmit();
        }
    };
    /**
     * @param {?} codRubro
     * @return {?}
     */
    SegmandatosComponent.prototype.getClassRubroIcon = /**
     * @param {?} codRubro
     * @return {?}
     */
    function (codRubro) {
        return this.globals.getClassRubroIcon(codRubro);
    };
    /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    SegmandatosComponent.prototype.getEmpresaConvenio = /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    function (nomFacturador, descConvenio) {
        return descConvenio != "" ? nomFacturador + ": " + descConvenio : nomFacturador;
    };
    SegmandatosComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-segmandatos',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n\r\n    <!--h3 class=\"titulo-seccion\">Seguimiento de mandatos</h3-->\r\n    <div class=\"modulo-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n      </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"firstFormGroup\" (ngSubmit)=\"validarForm()\" autocomplete=\"off\">\r\n              <div class=\"form-row\">\r\n\r\n                <div class=\"col-md-6\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Tarjeta\" formControlName=\"medioPago\" (selectionChange)=\"onMedioPagoSelect($event)\">\r\n                      <section *ngFor=\"let resp of resultadoTipoMedioPago\">\r\n                        <mat-option *ngFor=\"let tipo of resp.resultado\" [value]=\"tipo.codigoTipoMedioPago\">{{tipo.marcaMedioPago}}</mat-option>\r\n                      </section>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-6\" *ngIf=\"comboComercio\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"idFacturador\" (selectionChange)=\"onComercioSelect($event)\">\r\n                      <mat-option class=\"multiline-mat-option\" *ngFor=\"let comercio of resultadoEmpresa\" [value]=\"comercio.idFacturador +','+ comercio.idConvenio\"> {{getEmpresaConvenio(comercio.nomFacturador, comercio.descConvenio)}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                  <!-- <div *ngFor=\"let resp of resultadoEmp\">\r\n                    <mat-form-field>\r\n                      <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"idFacturador\" (selectionChange)=\"onEmpresaSelect($event)\">\r\n                        <mat-option *ngFor=\"let fact of resp.facturador\" value=\"{{ fact.idFacturador }}\">{{fact.nombre}}\r\n                        </mat-option>\r\n                      </mat-select>\r\n                    </mat-form-field>\r\n                  </div> -->\r\n                </div>\r\n              </div>\r\n              <div class=\"actions\">\r\n                <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\">Buscar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"resultados-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-10\">\r\n          <div class=\"tags row\">\r\n            <div *ngFor=\"let entry of hashCaminoMiga\" class=\"item\">{{entry.title}}: {{entry.text}}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n          <div class=\"numero-resultados\">\r\n            <strong>{{ (vistaCantidad == 1) ? ( vistaCantidad + \" Resultado\") : vistaCantidad + \" Resultados\" }}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!--tabla con paginacion-->\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-responsive-md\">\r\n        <div class=\"accordion\" id=\"accordionExample\">\r\n          <table style=\"width: 100%;background-color:#f0f0f0;\" mat-table [dataSource]=\"dataSource\">\r\n            <ng-container matColumnDef=\"icono\">\r\n              <td *matCellDef=\"let resultado; let i = index\">\r\n\r\n                <div class=\"modulo-mandato proceso\" *ngIf=\"resultado.idEstado == '1' && resultado.ind_suspendido == '0'\">\r\n                  <div class=\"row\">\r\n                    <div class=\"col-2 order-1 order-md-1 col-md-1 icon\">\r\n                      <i [class]=\"getClassRubroIcon(resultado.codRubro)\"></i>\r\n                    </div>\r\n                    <div class=\"col-10 order-2 order-md-12 col-md-1 options text-right\">\r\n                      <a class=\"link-container\" data-toggle=\"collapse\" [attr.href]=\"'#mandatos'+i\" role=\"button\" aria-expanded=\"false\" aria-controls=\"i\">\r\n                        <i class=\"mdl-icon-toggle__label material-icons\" (click)=\"detalle(resultado.nro_servicio, resultado.mandato, resultado.id_facturador)\">keyboard_arrow_down</i>\r\n                      </a>\r\n                    </div>\r\n                    <div class=\"col-12 order-12 order-md-2 col-md-10 datos\">\r\n                      <div class=\"datos\">\r\n                        <div class=\"row\">\r\n                          <div class=\"item col-4 col-md-2\">\r\n                            <h5>Alias:</h5>\r\n                            <p class=\"text-breakword\">{{resultado.alias_mandato}}</p>\r\n                          </div>\r\n                          <div class=\"item col-4 col-md-3\" *ngIf=\"comboComercio\">\r\n                            <h5>Empresa:</h5>\r\n                            <p class=\"text-breakword\">{{resultado.nombre_facturador}}: {{resultado.descConvenio}}</p>\r\n                          </div>\r\n                          <div class=\"item col-4 col-md-2\">\r\n                            <h5>ID Servicio:</h5>\r\n                            <p class=\"text-breakword\">{{resultado.nro_servicio}}</p>\r\n                          </div>\r\n                          <div class=\"item col-4 col-md-3\">\r\n                            <h5>Medio de Pago:</h5>\r\n                            <p>{{resultado.medio_pago}}</p>\r\n                          </div>\r\n                          <div class=\"item col-4 col-md-2\">\r\n                            <h5>Estado:</h5>\r\n                            <p *ngIf=\"resultado.idEstado == '1' \" class=\"databar proceso\">{{resultado.estado_mandato}}</p>\r\n                            <p *ngIf=\"resultado.idEstado == '2' \" class=\"databar rechazado\">{{resultado.estado_mandato}}</p>\r\n                            <p *ngIf=\"resultado.idEstado == '4' \" class=\"databar eliminado\">{{resultado.estado_mandato}}</p>\r\n                            <p *ngIf=\"resultado.idEstado == '3' \" class=\"databar activo\">{{resultado.estado_mandato}}</p>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class=\"col\">\r\n                      <div class=\"collapse\" [attr.id]=\"'mandatos'+i\" data-parent=\"#accordionExample\">\r\n                        <div class=\"card card-body\">\r\n                          <div class=\"row info\">\r\n                            <div class=\"col-md-10 offset-md-1\">\r\n                              <div class=\"table-container detalle table-responsive-lg\">\r\n                                <table class=\"table\">\r\n                                  <thead>\r\n                                    <tr>\r\n                                      <th scope=\"col\">Fecha</th>\r\n                                      <th scope=\"col\">Movimiento</th>\r\n                                      <th scope=\"col\">Descripci\u00F3n</th>\r\n                                    </tr>\r\n                                  </thead>\r\n                                  <ng-container *ngIf=\"size == 0;else conDatos\">\r\n                                    <tbody>\r\n                                      <tr>\r\n                                        <td>Sin datos para Mostrar</td>\r\n                                      </tr>\r\n                                    </tbody>\r\n                                  </ng-container>\r\n                                  <ng-template #conDatos>\r\n                                    <tbody *ngFor=\"let detalles of resultadoDetalle\">\r\n                                      <tr *ngFor=\"let deta of detalles.resultado\">\r\n                                        <td>{{deta.movimiento_fecha | date:'dd/MM/yyyy'}}</td>\r\n                                        <td>{{deta.movimiento_titulo}}</td>\r\n                                        <td>{{deta.movimiento_descripcion}}</td>\r\n                                      </tr>\r\n                                    </tbody>\r\n                                  </ng-template>\r\n                                </table>\r\n                              </div>\r\n                            </div>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"modulo-mandato rechazado\" *ngIf=\"resultado.idEstado == '2' && resultado.ind_suspendido == '0'\">\r\n                  <div class=\"row\">\r\n                    <div class=\"col-2 order-1 order-md-1 col-md-1 icon\">\r\n                      <i [class]=\"getClassRubroIcon(resultado.codRubro)\"></i>\r\n                    </div>\r\n                    <div class=\"col-10 order-2 order-md-12 col-md-1 options text-right\">\r\n                      <a class=\"link-container\" data-toggle=\"collapse\" [attr.href]=\"'#mandatos'+i\" role=\"button\" aria-expanded=\"false\" aria-controls=\"i\">\r\n                        <i class=\"mdl-icon-toggle__label material-icons\" (click)=\"detalle(resultado.nro_servicio, resultado.mandato, resultado.id_facturador)\">keyboard_arrow_down</i>\r\n                      </a>\r\n                    </div>\r\n                    <div class=\"col-12 order-12 order-md-2 col-md-10 datos\">\r\n                      <div class=\"datos\">\r\n                        <div class=\"row\">\r\n                          <div class=\"item col-4 col-md-2\">\r\n                            <h5>Alias:</h5>\r\n                            <p class=\"text-breakword\">{{resultado.alias_mandato}}</p>\r\n                          </div>\r\n                          <div class=\"item col-4 col-md-3\" *ngIf=\"comboComercio\">\r\n                            <h5>Empresa:</h5>\r\n                            <p class=\"text-breakword\">{{resultado.nombre_facturador}}: {{resultado.descConvenio}}</p>\r\n                          </div>\r\n                          <div class=\"item col-4 col-md-2\">\r\n                            <h5>ID Servicio:</h5>\r\n                            <p class=\"text-breakword\">{{resultado.nro_servicio}}</p>\r\n                          </div>\r\n                          <div class=\"item col-4 col-md-3\">\r\n                            <h5>Medio de Pago:</h5>\r\n                            <p>{{resultado.medio_pago}}</p>\r\n                          </div>\r\n                          <div class=\"item col-4 col-md-2\">\r\n                            <h5>Estado:</h5>\r\n                            <p *ngIf=\"resultado.idEstado == '1' \" class=\"databar ingresado\">{{resultado.estado_mandato}}</p>\r\n                            <p *ngIf=\"resultado.idEstado == '2' \" class=\"databar rechazado\">{{resultado.estado_mandato}}</p>\r\n                            <p *ngIf=\"resultado.idEstado == '4' \" class=\"databar eliminado\">{{resultado.estado_mandato}}</p>\r\n                            <p *ngIf=\"resultado.idEstado == '3' \" class=\"databar activo\">{{resultado.estado_mandato}}</p>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class=\"col\">\r\n                      <div class=\"collapse\" [attr.id]=\"'mandatos'+i\" data-parent=\"#accordionExample\">\r\n                        <div class=\"card card-body\">\r\n                          <div class=\"row info\">\r\n                            <div class=\"col-md-10 offset-md-1\">\r\n                              <div class=\"table-container detalle table-responsive-lg\">\r\n                                <table class=\"table\">\r\n                                  <thead>\r\n                                    <tr>\r\n                                      <th scope=\"col\">Fecha</th>\r\n                                      <th scope=\"col\">Movimiento</th>\r\n                                      <th scope=\"col\">Descripci\u00F3n</th>\r\n                                    </tr>\r\n                                  </thead>\r\n                                  <ng-container *ngIf=\"size == 0;else conDatos\">\r\n                                    <tbody>\r\n                                      <tr>\r\n                                        <td>Sin datos para Mostrar</td>\r\n                                      </tr>\r\n                                    </tbody>\r\n                                  </ng-container>\r\n                                  <ng-template #conDatos>\r\n                                    <tbody *ngFor=\"let detalles of resultadoDetalle\">\r\n                                      <tr *ngFor=\"let deta of detalles.resultado\">\r\n                                        <td>{{deta.movimiento_fecha | date:'dd/MM/yyyy'}}</td>\r\n                                        <td>{{deta.movimiento_titulo}}</td>\r\n                                        <td>{{deta.movimiento_descripcion}}</td>\r\n                                      </tr>\r\n                                    </tbody>\r\n                                  </ng-template>\r\n                                </table>\r\n                              </div>\r\n                            </div>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <ng-container *ngIf=\"resultado.idEstado === '3' && resultado.ind_suspendido === '0'; else Suspendido\">\r\n                  <div class=\"modulo-mandato activo\">\r\n                    <div class=\"row\">\r\n                      <div class=\"col-2 order-1 order-md-1 col-md-1 icon\">\r\n                        <i [class]=\"getClassRubroIcon(resultado.codRubro)\"></i>\r\n                      </div>\r\n                      <div class=\"col-10 order-2 order-md-12 col-md-1 options text-right\">\r\n                        <a class=\"link-container\" data-toggle=\"collapse\" [attr.href]=\"'#mandatos'+i\" role=\"button\" aria-expanded=\"false\" aria-controls=\"i\">\r\n                          <i class=\"mdl-icon-toggle__label material-icons\" (click)=\"detalle(resultado.nro_servicio, resultado.mandato, resultado.id_facturador)\">keyboard_arrow_down</i>\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-12 order-12 order-md-2 col-md-10 datos\">\r\n                        <div class=\"datos\">\r\n                          <div class=\"row\">\r\n                            <div class=\"item col-4 col-md-2\">\r\n                              <h5>Alias:</h5>\r\n                              <p class=\"text-breakword\">{{resultado.alias_mandato}}</p>\r\n                            </div>\r\n                            <div class=\"item col-4 col-md-3\" *ngIf=\"comboComercio\">\r\n                              <h5>Empresa:</h5>\r\n                              <p class=\"text-breakword\">{{resultado.nombre_facturador}}: {{resultado.descConvenio}}</p>\r\n                            </div>\r\n                            <div class=\"item col-4 col-md-2\">\r\n                              <h5>ID Servicio:</h5>\r\n                              <p class=\"text-breakword\">{{resultado.nro_servicio}}</p>\r\n                            </div>\r\n                            <div class=\"item col-4 col-md-3\">\r\n                              <h5>Medio de Pago:</h5>\r\n                              <p>{{resultado.medio_pago}}</p>\r\n                            </div>\r\n                            <div class=\"item col-4 col-md-2\">\r\n                              <h5>Estado:</h5>\r\n                              <p *ngIf=\"resultado.idEstado == '1' \" class=\"databar ingresado\">{{resultado.estado_mandato}}</p>\r\n                              <p *ngIf=\"resultado.idEstado == '2' \" class=\"databar rechazado\">{{resultado.estado_mandato}}</p>\r\n                              <p *ngIf=\"resultado.idEstado == '4' \" class=\"databar eliminado\">{{resultado.estado_mandato}}</p>\r\n                              <p *ngIf=\"resultado.idEstado == '3' \" class=\"databar activo\">{{resultado.estado_mandato}}</p>\r\n                            </div>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                      <div class=\"col\">\r\n                        <div class=\"collapse\" [attr.id]=\"'mandatos'+i\" data-parent=\"#accordionExample\">\r\n                          <div class=\"card card-body\">\r\n                            <div class=\"row info\">\r\n                              <div class=\"col-md-10 offset-md-1\">\r\n                                <div class=\"table-container detalle table-responsive-lg\">\r\n                                  <table class=\"table\">\r\n                                    <thead>\r\n                                      <tr>\r\n                                        <th scope=\"col\">Fecha</th>\r\n                                        <th scope=\"col\">Movimiento</th>\r\n                                        <th scope=\"col\">Descripci\u00F3n</th>\r\n                                      </tr>\r\n                                    </thead>\r\n                                    <ng-container *ngIf=\"size == 0;else conDatos\">\r\n                                      <tbody>\r\n                                        <tr>\r\n                                          <td>Sin datos para Mostrar</td>\r\n                                        </tr>\r\n                                      </tbody>\r\n                                    </ng-container>\r\n                                    <ng-template #conDatos>\r\n                                      <tbody *ngFor=\"let detalles of resultadoDetalle\">\r\n                                        <tr *ngFor=\"let deta of detalles.resultado\">\r\n                                          <td>{{deta.movimiento_fecha | date:'dd/MM/yyyy'}}</td>\r\n                                          <td>{{deta.movimiento_titulo}}</td>\r\n                                          <td>{{deta.movimiento_descripcion}}</td>\r\n                                        </tr>\r\n                                      </tbody>\r\n                                    </ng-template>\r\n                                  </table>\r\n                                </div>\r\n                              </div>\r\n                            </div>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </ng-container>\r\n                <ng-template #Suspendido>\r\n                  <div class=\"modulo-mandato suspendido\" *ngIf=\"resultado.idEstado === '3' && resultado.ind_suspendido === '1'\">\r\n                    <div class=\"row\">\r\n                      <div class=\"col-2 order-1 order-md-1 col-md-1 icon\">\r\n                        <i [class]=\"getClassRubroIcon(resultado.codRubro)\"></i>\r\n                      </div>\r\n                      <div class=\"col-10 order-2 order-md-12 col-md-1 options text-right\">\r\n                        <a class=\"link-container\" data-toggle=\"collapse\" [attr.href]=\"'#mandatos'+i\" role=\"button\" aria-expanded=\"false\" aria-controls=\"i\">\r\n                          <i class=\"mdl-icon-toggle__label material-icons\" (click)=\"detalle(resultado.nro_servicio, resultado.mandato, resultado.id_facturador)\">keyboard_arrow_down</i>\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-12 order-12 order-md-2 col-md-10 datos\">\r\n                        <div class=\"datos\">\r\n                          <div class=\"row\">\r\n                            <div class=\"item col-4 col-md-2\">\r\n                              <h5>Alias:</h5>\r\n                              <p class=\"text-breakword\">{{resultado.alias_mandato}}</p>\r\n                            </div>\r\n                            <div class=\"item col-4 col-md-3\" *ngIf=\"comboComercio\">\r\n                              <h5>Empresa:</h5>\r\n                              <p class=\"text-breakword\">{{resultado.nombre_facturador}}: {{resultado.descConvenio}}</p>\r\n                            </div>\r\n                            <div class=\"item col-4 col-md-2\">\r\n                              <h5>ID Servicio:</h5>\r\n                              <p class=\"text-breakword\">{{resultado.nro_servicio}}</p>\r\n                            </div>\r\n                            <div class=\"item col-4 col-md-3\">\r\n                              <h5>Medio de Pago:</h5>\r\n                              <p>{{resultado.medio_pago}}</p>\r\n                            </div>\r\n                            <div class=\"item col-4 col-md-2\">\r\n                              <h5>Estado:</h5>\r\n                              <p class=\"databar suspendido\">Suspendido</p>\r\n                            </div>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                      <div class=\"col\">\r\n                        <div class=\"collapse\" [attr.id]=\"'mandatos'+i\" data-parent=\"#accordionExample\">\r\n                          <div class=\"card card-body\">\r\n                            <div class=\"row info\">\r\n                              <div class=\"col-md-10 offset-md-1\">\r\n                                <div class=\"table-container detalle table-responsive-lg\">\r\n                                  <table class=\"table\">\r\n                                    <thead>\r\n                                      <tr>\r\n                                        <th scope=\"col\">Fecha</th>\r\n                                        <th scope=\"col\">Movimiento</th>\r\n                                        <th scope=\"col\">Descripci\u00F3n</th>\r\n                                      </tr>\r\n                                    </thead>\r\n                                    <ng-container *ngIf=\"size == 0;else conDatos\">\r\n                                      <tbody>\r\n                                        <tr>\r\n                                          <td>Sin datos para Mostrar</td>\r\n                                        </tr>\r\n                                      </tbody>\r\n                                    </ng-container>\r\n                                    <ng-template #conDatos>\r\n                                      <tbody *ngFor=\"let detalles of resultadoDetalle\">\r\n                                        <tr *ngFor=\"let deta of detalles.resultado\">\r\n                                          <td>{{deta.movimiento_fecha | date:'dd/MM/yyyy'}}</td>\r\n                                          <td>{{deta.movimiento_titulo}}</td>\r\n                                          <td>{{deta.movimiento_descripcion}}</td>\r\n                                        </tr>\r\n                                      </tbody>\r\n                                    </ng-template>\r\n                                  </table>\r\n                                </div>\r\n                              </div>\r\n                            </div>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </ng-template>\r\n                <div class=\"modulo-mandato eliminado disabled\" *ngIf=\"resultado.idEstado === '4'\">\r\n                  <div class=\"row\">\r\n                    <div class=\"col-2 order-1 order-md-1 col-md-1 icon\">\r\n                      <i [class]=\"getClassRubroIcon(resultado.codRubro)\"></i>\r\n                    </div>\r\n                    <div class=\"col-10 order-2 order-md-12 col-md-1 options text-right\">\r\n                      <a class=\"link-container\" data-toggle=\"collapse\" [attr.href]=\"'#mandatos'+i\" role=\"button\" aria-expanded=\"false\" aria-controls=\"i\">\r\n                        <i class=\"mdl-icon-toggle__label material-icons\" (click)=\"detalle(resultado.nro_servicio, resultado.mandato, resultado.id_facturador)\">keyboard_arrow_down</i>\r\n                      </a>\r\n                    </div>\r\n                    <div class=\"col-12 order-12 order-md-2 col-md-10 datos\">\r\n                      <div class=\"datos\">\r\n                        <div class=\"row\">\r\n                          <div class=\"item col-4 col-md-2\">\r\n                            <h5>Alias:</h5>\r\n                            <p class=\"text-breakword\">{{resultado.alias_mandato}}</p>\r\n                          </div>\r\n                          <div class=\"item col-4 col-md-3\" *ngIf=\"comboComercio\">\r\n                            <h5>Empresa:</h5>\r\n                            <p class=\"text-breakword\">{{resultado.nombre_facturador}}: {{resultado.descConvenio}}</p>\r\n                          </div>\r\n                          <div class=\"item col-4 col-md-2\">\r\n                            <h5>ID Servicio:</h5>\r\n                            <p class=\"text-breakword\">{{resultado.nro_servicio}}</p>\r\n                          </div>\r\n                          <div class=\"item col-4 col-md-3\">\r\n                            <h5>Medio de Pago:</h5>\r\n                            <p>{{resultado.medio_pago}}</p>\r\n                          </div>\r\n                          <div class=\"item col-4 col-md-2\">\r\n                            <h5>Estado:</h5>\r\n                            <p *ngIf=\"resultado.idEstado == '1' \" class=\"databar ingresado\">{{resultado.estado_mandato}}</p>\r\n                            <p *ngIf=\"resultado.idEstado == '2' \" class=\"databar rechazado\">{{resultado.estado_mandato}}</p>\r\n                            <p *ngIf=\"resultado.idEstado == '4' \" class=\"databar eliminado\">{{resultado.estado_mandato}}</p>\r\n                            <p *ngIf=\"resultado.idEstado == '3' \" class=\"databar activo\">{{resultado.estado_mandato}}</p>\r\n\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class=\"col\">\r\n                      <div class=\"collapse\" [attr.id]=\"'mandatos'+i\" data-parent=\"#accordionExample\">\r\n                        <div class=\"card card-body\">\r\n                          <div class=\"row info\">\r\n                            <div class=\"col-md-10 offset-md-1\">\r\n                              <div class=\"table-container detalle table-responsive-lg\">\r\n                                <table class=\"table\">\r\n                                  <thead>\r\n                                    <tr>\r\n                                      <th scope=\"col\">Fecha</th>\r\n                                      <th scope=\"col\">Movimiento</th>\r\n                                      <th scope=\"col\">Descripci\u00F3n</th>\r\n                                    </tr>\r\n                                  </thead>\r\n                                  <ng-container *ngIf=\"size == 0;else conDatos\">\r\n                                    <tbody>\r\n                                      <tr>\r\n                                        <td>Sin datos para Mostrar</td>\r\n                                      </tr>\r\n                                    </tbody>\r\n                                  </ng-container>\r\n                                  <ng-template #conDatos>\r\n                                    <tbody *ngFor=\"let detalles of resultadoDetalle\">\r\n                                      <tr *ngFor=\"let deta of detalles.resultado\">\r\n                                        <td>{{deta.movimiento_fecha | date:'dd/MM/yyyy'}}</td>\r\n                                        <td>{{deta.movimiento_titulo}}</td>\r\n                                        <td>{{deta.movimiento_descripcion}}</td>\r\n                                      </tr>\r\n                                    </tbody>\r\n                                  </ng-template>\r\n                                </table>\r\n                              </div>\r\n                            </div>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n              </td>\r\n            </ng-container>\r\n            <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n          </table>\r\n        </div>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" showFirstLastButtons></mat-paginator>\r\n      </div>\r\n    </section>\r\n\r\n    <div class=\"modulo-cuentas\" *ngIf=\"mensajeError == 0 && vistaCantidad == 0\">\r\n      <span>\r\n        No se han encontrado registros para su consulta. Establezca sus criterios de b\u00FAsqueda e int\u00E9ntelo nuevamente.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"modulo-cuentas\" *ngIf=\"consulta == -1\">\r\n      <span>\r\n        Establezca sus criterios de b\u00FAsqueda.\r\n      </span>\r\n    </div>\r\n\r\n  </div>\r\n</section>\r\n\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div *ngIf=\"mensajeError == 1\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" id=\"modal-basic-title\" style=\"color:#ec0000;font-weight: bold\">Error</h3>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <p>Servicio temporalmente no disponible.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>"
                }] }
    ];
    /** @nocollapse */
    SegmandatosComponent.ctorParameters = function () { return [
        { type: SegmandatosService },
        { type: LoaderBaseService },
        { type: EmpresasService },
        { type: Globals },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    SegmandatosComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator$1,] }]
    };
    return SegmandatosComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListMandatoDetallePeticion = /** @class */ (function () {
    function ListMandatoDetallePeticion() {
        this.idMandato = "-1";
        this.idRecaudador = "-1";
        this.idServicio = "-1";
        this.idFacturador = "-1";
    }
    return ListMandatoDetallePeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TerminoCondicionesFinal = /** @class */ (function () {
    function TerminoCondicionesFinal() {
        this.idMandato = '';
        this.idUsuario = '';
        this.codTpoPortal = '';
        this.empresa = '';
    }
    TerminoCondicionesFinal.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ TerminoCondicionesFinal.ngInjectableDef = defineInjectable({ factory: function TerminoCondicionesFinal_Factory() { return new TerminoCondicionesFinal(); }, token: TerminoCondicionesFinal, providedIn: "root" });
    return TerminoCondicionesFinal;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var httpOptions$b = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};
var ListMandatoDetalleService = /** @class */ (function () {
    function ListMandatoDetalleService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlMandatosDetalle = this.environment.urlAmbiente + '/apiMandatosMT/listaMandatosDetalle';
    }
    /**
     * @param {?} _body
     * @return {?}
     */
    ListMandatoDetalleService.prototype.postListarManDetalle = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlMandatosDetalle, _body, httpOptions$b);
    };
    ListMandatoDetalleService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ListMandatoDetalleService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return ListMandatoDetalleService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CiudadesRespuesta = /** @class */ (function () {
    function CiudadesRespuesta() {
    }
    return CiudadesRespuesta;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var httpOptions$c = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};
var CiudadService = /** @class */ (function () {
    function CiudadService() {
    }
    /**
     * @return {?}
     */
    CiudadService.prototype.listCiudadesReport = /**
     * @return {?}
     */
    function () {
        //TODO Se debe actualizar con servicio real...
        /** @type {?} */
        var respuesta = new CiudadesRespuesta();
        /** @type {?} */
        var ciudades = [];
        ciudades.push({ codigo: '1', valor: 'Aisén del G. Carlos Ibáñez del Campo' });
        ciudades.push({ codigo: '2', valor: 'Antofagasta' });
        ciudades.push({ codigo: '3', valor: 'Arica y Parinacota' });
        ciudades.push({ codigo: '4', valor: 'Atacama' });
        ciudades.push({ codigo: '5', valor: 'Biobío' });
        ciudades.push({ codigo: '6', valor: 'Coquimbo' });
        ciudades.push({ codigo: '7', valor: 'La Araucanía' });
        ciudades.push({ codigo: '8', valor: 'Libertador General Bernardo O’Higgins' });
        ciudades.push({ codigo: '9', valor: 'Los Lagos' });
        ciudades.push({ codigo: '10', valor: 'Los Ríos' });
        ciudades.push({ codigo: '11', valor: 'Magallanes y de la Antártica Chilena' });
        ciudades.push({ codigo: '12', valor: 'Maule' });
        ciudades.push({ codigo: '13', valor: 'Metropolitana de Santiago' });
        ciudades.push({ codigo: '14', valor: 'Ñuble' });
        ciudades.push({ codigo: '15', valor: 'Tarapacá' });
        ciudades.push({ codigo: '16', valor: 'Valparaíso' });
        respuesta.resultado = ciudades;
        respuesta.codret = '0';
        respuesta.descret = 'Proceso exitoso';
        return of(respuesta);
    };
    CiudadService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CiudadService.ctorParameters = function () { return []; };
    return CiudadService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListMandatosDetallesComponent = /** @class */ (function () {
    function ListMandatosDetallesComponent(router, route, phttp, globals, dialog, ciudadService, http, loader) {
        this.router = router;
        this.route = route;
        this.phttp = phttp;
        this.globals = globals;
        this.dialog = dialog;
        this.ciudadService = ciudadService;
        this.http = http;
        this.loader = loader;
        this.peticionReport = new ListMandatoDetallePeticion();
        this.arrayCiudades = [];
        this.cnvDescricpcion = '';
    }
    /**
     * @return {?}
     */
    ListMandatosDetallesComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        sessionStorage.setItem('componenteHijo', 'listMandatosDetalles');
        this.sub = this.route.queryParams.subscribe((/**
         * @param {?} params
         * @return {?}
         */
        function (params) {
            _this.panelEstado = params['em'];
            _this.panelIndSuspendido = params['is'];
            _this.panelIdMandato = params['id'];
            _this.panelAlias = params['a'];
            _this.panelServicio = params['s'];
            _this.panelFacturador = params['f'];
            _this.panelUltimoPago = params['p'];
            _this.panelRubro = params['r'];
            _this.panelMontoCargo = params['mc'];
            _this.peticionReport.idMandato = params['id'];
            _this.peticionReport.idFacturador = params['if'];
            _this.peticionReport.idServicio = params['s'];
            // this.convenioDesc = params['convenioDesc'];
        }));
        this.setListCiudades();
        this.peticionReport.idRecaudador = '-1';
        this.postListarManDetalleServices(this.peticionReport);
    };
    /**
     * @return {?}
     */
    ListMandatosDetallesComponent.prototype.setListCiudades = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.ciudadService.listCiudadesReport().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.arrayCiudades = data.resultado;
        }));
    };
    /**
     * @return {?}
     */
    ListMandatosDetallesComponent.prototype.descargarTerminos = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var terminos = new TerminoCondicionesFinal();
        /** @type {?} */
        var preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        terminos.codTpoPortal = preLogin.codTpoPortal;
        terminos.idMandato = this.panelIdMandato;
        terminos.idUsuario = "0";
        /** @type {?} */
        var userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        terminos.empresa = userPerfil.empresa.docEmpresa;
        this.postDownloadReportFile(terminos);
    };
    /**
     * @param {?} filtro
     * @param {?} api
     * @return {?}
     */
    ListMandatosDetallesComponent.prototype.downloadReportService = /**
     * @param {?} filtro
     * @param {?} api
     * @return {?}
     */
    function (filtro, api) {
        return this.http.request(new HttpRequest('POST', api, filtro, {
            reportProgress: true,
            responseType: 'blob'
        }));
    };
    /**
     * @param {?} filtro
     * @return {?}
     */
    ListMandatosDetallesComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @return {?}
     */
    function (filtro) {
        /** @type {?} */
        var apiUrl = "/apiMandatosMT/condicionesGeneralesFinal/pdf";
        this.downloadReportService(filtro, apiUrl).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                downloadedFile = new Blob([data.body], { type: 'application/pdf;charset=utf-8' });
                a.download = 'Termino_Condiciones_' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.log(err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    ListMandatosDetallesComponent.prototype.postListarManDetalleServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.phttp.postListarManDetalle(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.cnvDescricpcion = data.resultado[0]['convenioDesc'];
                _this.resultadoReport = [];
                _this.resultadoReport.push(data);
                _this.resultadoReport[0].resultado[0]['ciudad'] = _this.getCiudadText(_this.resultadoReport[0].resultado[0]['ciudad']);
                _this.loader.hide();
            }
            else {
                _this.loader.hide();
                console.log('Error: ', data.descret);
                _this.showDialogFail('Error', 'Servicio temporalmente no disponible.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            console.log('Error: ', err);
            _this.showDialogFail('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @param {?} codCiudad
     * @return {?}
     */
    ListMandatosDetallesComponent.prototype.getCiudadText = /**
     * @param {?} codCiudad
     * @return {?}
     */
    function (codCiudad) {
        /** @type {?} */
        var resultado = '-';
        this.arrayCiudades.forEach((/**
         * @param {?} element
         * @return {?}
         */
        function (element) {
            if (element.codigo == codCiudad) {
                resultado = element.valor;
            }
        }));
        return resultado;
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ListMandatosDetallesComponent.prototype.showDialogFail = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            _this.router.navigate(['../mandatosList'], { relativeTo: _this.route });
        }));
    };
    /**
     * @param {?} monto
     * @param {?} moneda
     * @return {?}
     */
    ListMandatosDetallesComponent.prototype.formateandoMonto = /**
     * @param {?} monto
     * @param {?} moneda
     * @return {?}
     */
    function (monto, moneda) {
        return FormatoMonedaUtil.formatearMontoParam(parseInt(monto), moneda);
    };
    /**
     * @param {?} codRubro
     * @return {?}
     */
    ListMandatosDetallesComponent.prototype.getClassRubroIcon = /**
     * @param {?} codRubro
     * @return {?}
     */
    function (codRubro) {
        return this.globals.getClassRubroIcon(codRubro);
    };
    /**
     * @return {?}
     */
    ListMandatosDetallesComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.sub.unsubscribe();
    };
    ListMandatosDetallesComponent.decorators = [
        { type: Component, args: [{
                    selector: 'listMandatosDetalles',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"modulo-cuentas detalle\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a [routerLink]=\"['../mandatosList']\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n        <div class=\"buttons-container\" style=\"padding-right:10px\">\r\n          <a (click)=\"descargarTerminos()\" class=\"btn out float-right\">Descargar t\u00E9rminos y condiciones</a>\r\n        </div>\r\n      </div>\r\n      <div *ngFor=\"let reporte of resultadoReport\">\r\n        <div *ngFor=\"let full of reporte.resultado\">\r\n          <div class=\"row\">\r\n            <div class=\"col-2 order-1 order-md-1 col-md-1 icon\">\r\n              <i [class]=\"getClassRubroIcon(full.codRubro)\"></i>\r\n            </div>\r\n            <div class=\"col-12 order-12 order-md-2 col-md-10 datos\">\r\n              <div class=\"row\">\r\n                <div class=\"item col-4 col-md-3\">\r\n                  <h5>Alias:</h5>\r\n                  <p class=\"text-breakword\">{{panelAlias}}</p>\r\n                </div>\r\n                <div class=\"item col-4 col-md-3\">\r\n                  <h5>Servicio:</h5>\r\n                  <p class=\"text-breakword\">{{panelServicio}}</p>\r\n                </div>\r\n                <div class=\"item col-4 col-md-3\">\r\n                  <h5>Empresa:</h5>\r\n                  <p class=\"text-breakword\">{{panelFacturador}}: {{cnvDescricpcion}}</p>\r\n                </div>\r\n                <div class=\"item col-4 col-md-3\">\r\n                  <h5>\u00DAltimo Pago:</h5>\r\n                  <p>{{ (panelUltimoPago !== 'null') ? (panelUltimoPago | date: 'dd/MM/yyyy') : \"\" }} -\r\n                    {{ (panelMontoCargo !== 'null') ? (panelMontoCargo/100 | moneda) : \"\" }}</p>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class=\"col\">\r\n                  <h4>Detalle del Mandato</h4>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class=\"item col-4 col-md-3\">\r\n                  <h5>C\u00E9dula:</h5>\r\n                  <p>{{ (full.rut !== '') ? (full.rut | rut) : '-' }}</p>\r\n                </div>\r\n                <div class=\"item col-4 col-md-3\">\r\n                  <h5>Nombre:</h5>\r\n                  <p>{{full.nomMandante}}</p>\r\n                </div>\r\n                <div class=\"item col-4 col-md-3\">\r\n                  <h5>Primer Apellido:</h5>\r\n                  <p>{{full.primerApellido}}</p>\r\n                </div>\r\n                <div class=\"item col-4 col-md-3\">\r\n                  <h5>Segundo apellido:</h5>\r\n                  <p>{{ (full.segundoApellido !== '') ? (full.segundoApellido) : '-' }}</p>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class=\"item col-4 col-md-3\">\r\n                  <h5>Estado:</h5>\r\n                  <ng-container *ngIf=\"full.idEstado_mandato === '1' || full.idEstado_mandato === '2' || full.idEstado_mandato === '4'; else Ingresado_o_activo\">\r\n                    <p *ngIf=\"full.idEstado_mandato == '4' \" class=\"databar eliminado\">{{full.estadoMandato}}</p>\r\n                    <p *ngIf=\"full.idEstado_mandato == '2' \" class=\"databar rechazado\">{{full.estadoMandato}}</p>\r\n                    <p *ngIf=\"full.idEstado_mandato == '1' \" class=\"databar ingresado\">{{full.estadoMandato}}</p>\r\n                  </ng-container>\r\n                  <ng-template #Ingresado_o_activo>\r\n                    <ng-container *ngIf=\"full.ind_suspendido === '0'; else Suspendido\">\r\n                      <p *ngIf=\"full.idEstado_mandato == '3' \" class=\"databar activo\">{{full.estadoMandato}}</p>\r\n                    </ng-container>\r\n                    <ng-template #Suspendido>\r\n                      <p class=\"databar suspendido\">Suspendido</p>\r\n                    </ng-template>\r\n                  </ng-template>\r\n                </div>\r\n                <div class=\"item col-4 col-md-3\">\r\n                  <h5>ID Servicio:</h5>\r\n                  <p class=\"text-breakword\">{{full.idServicio}}</p>\r\n                </div>\r\n                <div class=\"item col-4 col-md-3\">\r\n                  <h5>Fecha suscripci\u00F3n:</h5>\r\n                  <p>{{full.suscripcion | date: 'dd/MM/yyyy'}}</p>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class=\"item col-4 col-md-3\">\r\n                  <h5>Medio de pago:</h5>\r\n                  <p>{{full.medioPago}}</p>\r\n                </div>\r\n                <div class=\"item col-4 col-md-3\" *ngIf=\"full.diaPago == 0\">\r\n                  <h5>Monto m&aacute;ximo a pagar:</h5>\r\n                  <span>{{formateandoMonto(full.limite, full.tipoMoneda)}}</span>\r\n                </div>\r\n                <div class=\"item col-4 col-md-3\" *ngIf=\"full.diaPago > 0\">\r\n                  <h5>Monto fijo a pagar:</h5>\r\n                  <span>{{formateandoMonto(full.montoFijo, full.tipoMoneda)}}</span>\r\n                  <!-- <span>{{full.tipoMoneda}} {{full.montoFijo/100 | moneda}}</span> -->\r\n                </div>\r\n                <div class=\"item col-4 col-md-3\" *ngIf=\"full.diaPago > 0\">\r\n                  <h5>D&iacute;a de pago:</h5>\r\n                  <span>{{full.diaPago}}</span>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class=\"col\">\r\n                  <h4>Datos de Contacto</h4>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class=\"item col-4 col-md-3\">\r\n                  <h5>Tel\u00E9fono celular:</h5>\r\n                  <p>{{ (full.movil !== '') ? (full.movil) : '-' }}</p>\r\n                </div>\r\n                <!-- <div class=\"item col-4 col-md-3\">\r\n                  <h5>Tel\u00E9fono fijo:</h5>\r\n                  <p>{{ (full.fijo !== '') ? (full.fijo) : '-' }}</p>\r\n                </div>\r\n                <div class=\"item col-4 col-md-3\">\r\n                  <h5>Direcci\u00F3n:</h5>\r\n                  <p>{{ (full.direccion !== '') ? (full.direccion) : '-' }}</p>\r\n                </div>\r\n                <div class=\"item col-4 col-md-3\">\r\n                  <h5>Ciudad:</h5>\r\n                  <p>{{ (full.ciudad !== '') ? (full.ciudad) : '-' }}</p>\r\n                </div> -->\r\n                <div class=\"item col-4 col-md-3\">\r\n                  <h5>Email:</h5>\r\n                  <p>{{ (full.email !== '') ? (full.email) : '-' }}</p>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [ListMandatoDetalleService]
                }] }
    ];
    /** @nocollapse */
    ListMandatosDetallesComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: ListMandatoDetalleService },
        { type: Globals },
        { type: MatDialog },
        { type: CiudadService },
        { type: HttpClient },
        { type: LoaderBaseService }
    ]; };
    return ListMandatosDetallesComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var Encoding$1 = require('encoding-japanese');
var ɵ0$f = MAT_MOMENT_DATE_FORMATS;
var MandatosComponent = /** @class */ (function () {
    function MandatosComponent(peticionAgregar, uploader, dialog, loader, datepipe, facturacionService, environment) {
        this.peticionAgregar = peticionAgregar;
        this.uploader = uploader;
        this.dialog = dialog;
        this.loader = loader;
        this.datepipe = datepipe;
        this.facturacionService = facturacionService;
        this.environment = environment;
        this.firstFormGroup = new FormGroup({
            archivo: new FormControl('', Validators.required),
            comercio: new FormControl('Todas:', Validators.required),
            convenio: new FormControl('', Validators.required)
        });
        this.count = 0;
        this.fileUploadParams = new FileUploadParams();
        this.colapse = 1;
        this.peticionEmpresa = new EmpresasPeticion();
        this.resultadoEmpresa = [];
        this.comercioValido = 0;
        this.comboComercio = false;
        this.mensajeError = -1;
        this.peticionCargaAddAuditoria = new FacturacionPeticion();
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.codEmpresaPac = this.userPerfil.empresa.codEmpresaPac;
        this.idUsuario = this.userPerfil.usuario.idUsuario;
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
        this.codCliente = this.environment.codCliente;
    }
    /**
     * @return {?}
     */
    MandatosComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.codTpoPortal == 'COMERCIO') {
            this.comercioValido = 1;
            this.comboComercio = false;
            this.firstFormGroup.controls['comercio'].disable();
            this.firstFormGroup.controls['convenio'].enable();
        }
        else {
            this.comboComercio = true;
            this.firstFormGroup.controls['comercio'].enable();
            this.firstFormGroup.controls['convenio'].disable();
        }
        this.peticionEmpresa.codCliente = this.environment.codCliente;
        this.peticionEmpresa.codEstadoConvenio = 'HBL';
        this.peticionEmpresa.tipoCobro = "V";
        this.postSentEmpresaServices(this.peticionEmpresa);
        //this.postSentSelectEmpresaServices(this.peticionEmpresa);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    MandatosComponent.prototype.postSentSelectEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.peticionAgregar.postListarSelectEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEmpresa = data.resultado;
                _this.show = true;
                _this.mensajeError = 0;
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.mensajeError = 1;
                _this.loader.hide();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            _this.mensajeError = 1;
            _this.loader.hide();
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    MandatosComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.peticionAgregar.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEmpresa = data.resultado;
                _this.show = true;
                _this.mensajeError = 0;
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.mensajeError = 1;
                _this.loader.hide();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            _this.mensajeError = 1;
            _this.loader.hide();
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MandatosComponent.prototype.onComercioSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.value != null) {
            this.comercioValido = 1;
        }
        this.idConvenioSelect = event.value.split(',')[1];
        this.docEmpresaSelect = event.value.split(',')[2];
        this.nomEmpresaCargo = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} files
     * @return {?}
     */
    MandatosComponent.prototype.addToQueue = /**
     * @param {?} files
     * @return {?}
     */
    function (files) {
        var _this = this;
        /** @type {?} */
        var type = files[0].type;
        /** @type {?} */
        var fileSize = files[0].size;
        console.log('File type', type);
        console.log('File size', fileSize);
        this.detectEncoding(files[0]).subscribe((/**
         * @param {?} encoding
         * @return {?}
         */
        function (encoding) {
            //Continuar con la validacion de datos del archivo
            console.log('Encoding del archivo', encoding);
            _this.addFile(files[0], encoding);
        }));
    };
    /**
     * @param {?} file
     * @param {?} encoding
     * @return {?}
     */
    MandatosComponent.prototype.addFile = /**
     * @param {?} file
     * @param {?} encoding
     * @return {?}
     */
    function (file, encoding) {
        console.log('Encoding a validar', encoding);
        if (encoding != 'UTF8') {
            this.showDialog('Error', 'La codificación del archivo debe ser UTF-8 y su archivo es ' + encoding + '.<br>Cámbie la codificación e intente nuevamente.', false);
            this.resetForm();
            return;
        }
        if (file.type == "text/plain" || file.type == "application/vnd.ms-excel" || file.type == 'text/csv') {
            this.fileUploadParams.tipoArchivo = 'RMAN';
            this.fileUploadParams.codCliente = this.codCliente;
            this.fileUploadParams.docEmpresa = this.docEmpresa;
            this.fileUploadParams.codTipoPortal = this.codTpoPortal;
            if (this.codTpoPortal == 'COMERCIO') {
                this.fileUploadParams.codEmpresa = this.codEmpresaPac;
                this.fileUploadParams.codConvenio = this.idConvenioSelect;
            }
            else {
                /** @type {?} */
                var comercioFormGroup = this.firstFormGroup.get('comercio').value;
                this.fileUploadParams.codEmpresa = comercioFormGroup.split(",")[0];
                this.fileUploadParams.codConvenio = this.firstFormGroup.get('comercio').value.split(',')[1];
            }
            this.fileUploadParams.file = file;
            this.fileUploadParams.fileName = file.name;
            this.colapse = 1;
        }
        else {
            this.showDialog('Error', 'El archivo no es válido.<br>Inténtelo con otro.', false);
            this.resetForm();
        }
    };
    /**
     * @return {?}
     */
    MandatosComponent.prototype.uploadAll = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.firstFormGroup.valid) {
            this.loader.show();
            this.fileUploadParams.codConvenio = this.idConvenioSelect;
            this.uploader.postFile(this.fileUploadParams).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                if (data.codret == '0') {
                    _this.loader.hide();
                    _this.colapse = 0;
                    _this.nombreArchivo = data.nombreArchivo;
                    /** @type {?} */
                    var hoy = new Date();
                    _this.fechaIngreso = _this.datepipe.transform(hoy, 'dd/MM/yyyy HH:mm', 'es');
                    if (_this.codTpoPortal != 'COMERCIO') {
                        _this.comercioValido = 0;
                    }
                    _this.peticionCargaAddAuditoria.codCliente = _this.codCliente;
                    _this.peticionCargaAddAuditoria.idUsuario = _this.idUsuario;
                    _this.peticionCargaAddAuditoria.docEmpresa = _this.docEmpresaSelect;
                    _this.peticionCargaAddAuditoria.codTpoPortal = _this.codTpoPortal;
                    _this.peticionCargaAddAuditoria.nombreArchivo = _this.nombreArchivo;
                    _this.peticionCargaAddAuditoria.nomEmpresaCargo = _this.nomEmpresaCargo;
                    _this.peticionCargaAddAuditoria.tipoCarga = 'MAN';
                    _this.postCargaAddAuditoriaServices(_this.peticionCargaAddAuditoria);
                    _this.showDialog('Información', data.descret, false);
                }
                else {
                    _this.loader.hide();
                    _this.colapse = 1;
                    _this.resetForm();
                    _this.showDialog('Error', data.descret + '<br>Inténtelo nuevamente.', false);
                }
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function (err) {
                _this.loader.hide();
                console.log('Error: ', err);
                _this.showDialog('Error', 'Ocurrió un error en servicio al subir archivo.<br>Inténtelo más tarde.', false);
            }));
        }
        else {
            if (this.codTpoPortal != 'COMERCIO') {
                this.showDialog('Error', 'Seleccione un comercio y agrege un archivo antes de cargar.', false);
            }
            else {
                this.showDialog('Error', 'Debe agregar archivo antes de cargar.', false);
            }
        }
    };
    /**
     * @param {?} body
     * @return {?}
     */
    MandatosComponent.prototype.postCargaAddAuditoriaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        this.facturacionService.postCargaAddAuditoria(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                console.log('Información: ', data.descret);
            }
            else {
                console.log('Error: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.log('Error: ', err);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    MandatosComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @return {?}
     */
    MandatosComponent.prototype.resetForm = /**
     * @return {?}
     */
    function () {
        this.firstFormGroup.get('archivo').reset();
        this.fileUploadParams = new FileUploadParams();
    };
    /**
     * @private
     * @param {?} file
     * @return {?}
     */
    MandatosComponent.prototype.detectEncoding = /**
     * @private
     * @param {?} file
     * @return {?}
     */
    function (file) {
        /** @type {?} */
        var result = new Subject();
        /** @type {?} */
        var reader = new FileReader();
        reader.onloadend = (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            /** @type {?} */
            var codes = new Uint8Array((/** @type {?} */ (reader.result)));
            /** @type {?} */
            var detectedEncoding = Encoding$1.detect(codes);
            result.next(detectedEncoding);
        });
        reader.readAsArrayBuffer(file);
        return result.asObservable();
    };
    MandatosComponent.decorators = [
        { type: Component, args: [{
                    selector: 'carga',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-main\" *ngIf=\"show\">\r\n      <form [formGroup]=\"firstFormGroup\" method=\"post\" autocomplete=\"off\">\r\n        <div class=\"form-row\">\r\n          <div class=\"col-md-6\">\r\n            <mat-form-field *ngIf=\"comboComercio\">\r\n              <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"comercio\" (selectionChange)=\"onComercioSelect($event)\">\r\n                <mat-option class=\"text-breakword\" *ngFor=\"let comercio of resultadoEmpresa\" [value]=\"comercio.codFacturador + ',' + comercio.idConvenio + ',' + comercio.docFacturador\">{{comercio.nomFacturador}}: {{comercio.descConvenio}}</mat-option>\r\n              </mat-select>\r\n              <mat-error *ngIf=\"firstFormGroup.get('comercio').invalid\">Este campo es requerido.</mat-error>\r\n            </mat-form-field>\r\n            <mat-form-field *ngIf=\"!comboComercio\">\r\n              <mat-select matNativeControl placeholder=\"Convenio\" formControlName=\"convenio\" (selectionChange)=\"onComercioSelect($event)\">\r\n                <mat-option class=\"text-breakword\" *ngFor=\"let comercio of resultadoEmpresa\" [value]=\"comercio.codFacturador + ',' + comercio.idConvenio + ',' + comercio.docFacturador\">{{comercio.nomFacturador}}: {{comercio.descConvenio}}</mat-option>\r\n              </mat-select>\r\n              <mat-error *ngIf=\"firstFormGroup.get('comercio').invalid\">Este campo es requerido.</mat-error>\r\n            </mat-form-field>\r\n          </div>\r\n          <div class=\"col-md-6 subir-archivos align-right\">\r\n            <button class=\"btn-small out\" (click)=\"fileInput.click()\"><i class=\"str-icon-nuevo-documento\"></i> Agregar archivo</button>\r\n            <input type=\"file\" style=\"display:none\" #fileInput (change)=\"addToQueue($event.target.files)\" formControlName=\"archivo\" accept=\".txt, .csv\" />\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"table-container table-responsive-md\">\r\n          <table class=\"table\">\r\n            <thead>\r\n              <tr>\r\n                <th scope=\"col\">Archivo de mandatos</th>\r\n                <th scope=\"col\"></th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <tr>\r\n                <td>{{ fileUploadParams.fileName }}</td>\r\n                <td class=\"text-right\">\r\n                  <a tooltip=\"Eliminar archivo\" (click)=\"resetForm()\">\r\n                    <i class=\"icon str-icon-trash\" style=\"cursor: pointer;\"></i>\r\n                  </a>\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col align-right\">\r\n            <button class=\"btn main\" type=\"button\" data-toggle=\"collapse\" data-target=\"#historiall\" (click)=\"uploadAll()\">Cargar Archivo</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n\r\n    <div *ngIf=\"colapse == 0\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"archivos-cargados\">\r\n        <div class=\"table-container table-responsive-md\">\r\n          <div class=\"mensaje-box\">\r\n            <div class=\"aviso-carga\">\r\n              <div class=\"row\">\r\n                <div class=\"col-md-8 align-left\">\r\n                  <i class=\"icon str-icon-ok\"></i>\r\n                  <span class=\"valign\" style=\"font-weight: bold;\">Archivo(s) agregado(s). Ver estado de procesamiento en pesta\u00F1a Historial.</span>\r\n                </div>\r\n                <div class=\"col-md-4 align-right\">\r\n                  <a [routerLink]=\"['../historial']\" [queryParams]=\"{busqueda:'true'}\" class=\"btn-small secundario\">Ir a Historial</a>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <table class=\"table\">\r\n            <thead>\r\n              <tr>\r\n                <th scope=\"col\">Estado</th>\r\n                <th scope=\"col\">Nombre</th>\r\n                <th scope=\"col\">Fecha de ingreso</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <tr>\r\n                <td><span class=\"databar ingresado\">Ingresado</span></td>\r\n                <td>{{nombreArchivo}}</td>\r\n                <td>{{fechaIngreso}}</td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div *ngIf=\"mensajeError == 1\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" id=\"modal-basic-title\" style=\"color:#ec0000;font-weight: bold\">Error</h3>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <p>Servicio temporalmente no disponible.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [{ provide: MAT_DATE_LOCALE$2, useValue: 'es' },
                        { provide: DateAdapter$2, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE$2] },
                        { provide: MAT_DATE_FORMATS$2, useValue: ɵ0$f }, DatePipe]
                }] }
    ];
    /** @nocollapse */
    MandatosComponent.ctorParameters = function () { return [
        { type: EmpresasService },
        { type: FileUploadService },
        { type: MatDialog },
        { type: LoaderBaseService },
        { type: DatePipe },
        { type: FacturacionHistorialService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return MandatosComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MandatosHistorialPeticion = /** @class */ (function () {
    function MandatosHistorialPeticion() {
        this.fechaInicioIngreso = '01/01/2000';
        this.fechaFinIngreso = '01/01/2000';
        this.fechaInicioProceso = '01/01/2000';
        this.fechaFinProceso = '01/01/2000';
        this.codEstadoArchivo = '-1';
        this.nomArchivo = '-1';
        this.idFacturador = '-1';
        this.codtipoArchivo = '-1';
        this.idConvenio = '-1';
        this.codCliente = '-1';
        this.codTpoPortal = '-1';
        this.filtros = [];
    }
    return MandatosHistorialPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$g = MAT_MOMENT_DATE_FORMATS;
var MandatosHistorialComponent = /** @class */ (function () {
    function MandatosHistorialComponent(segmandatosService, empresasService, facturacionHistorialService, descargaExcelPdfFileService, loader, dialog, formBuilder, datepipe, route, environment) {
        this.segmandatosService = segmandatosService;
        this.empresasService = empresasService;
        this.facturacionHistorialService = facturacionHistorialService;
        this.descargaExcelPdfFileService = descargaExcelPdfFileService;
        this.loader = loader;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.datepipe = datepipe;
        this.route = route;
        this.environment = environment;
        this.fechaInicioIngreso = '01/01/2000';
        this.fechaFinIngreso = '01/01/2000';
        this.fechaInicioProceso = '01/01/2000';
        this.fechaFinProceso = '01/01/2000';
        // Vistas variables
        this.vistaCantidad = 0;
        this.vistaEstado = 'Todos';
        this.vistaComercio = 'Todos';
        this.hashCaminoMiga = [];
        this.peticionMandatosHistorial = new MandatosHistorialPeticion();
        this.peticionEmpresa = new EmpresasPeticion();
        this.resultadoEmpresa = [];
        this.resultadoEstado = [];
        this.comboComercio = false;
        this.mensajeError = -1;
        this.isCollapsed = false;
        this.consulta = -1;
        /** @type {?} */
        var fecha = new Date();
        /** @type {?} */
        var mañana = fecha.setDate(fecha.getDate() + 1);
        /** @type {?} */
        var fechaFormat = this.datepipe.transform(mañana, 'yyyy-MM-dd');
        this.unavailabilityForm = this.formBuilder.group({
            endDate: [fechaFormat + 'T00:00:00.000Z']
        });
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        //this.codTpoPortal = 'ADQUIRENTE';
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idEmpresaPac = this.userPerfil.empresa.idEmpresaPac;
        //this.idEmpresaPac = 0;
    }
    /**
     * @return {?}
     */
    MandatosHistorialComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (sessionStorage.getItem('componenteHijo') != 'mandatosHistorialDetalle') {
            sessionStorage.removeItem('indice');
        }
        this.peticionMandatosHistorial.fechaInicioIngreso = '01/01/2000';
        this.peticionMandatosHistorial.fechaFinIngreso = '01/01/2000';
        this.peticionMandatosHistorial.fechaInicioProceso = '01/01/2000';
        this.peticionMandatosHistorial.fechaFinProceso = '01/01/2000';
        this.peticionMandatosHistorial.nomArchivo = '-1';
        this.peticionMandatosHistorial.codtipoArchivo = 'RMAN';
        this.peticionMandatosHistorial.idConvenio = '-1';
        this.formGroup = new FormGroup({
            nomArchivo: new FormControl(),
            estado: new FormControl('-1'),
            fechaIngreso: new FormControl(),
            fechaProceso: new FormControl(),
            comercio: new FormControl('-1' + ',' + '-1')
        });
        if (this.codTpoPortal == 'COMERCIO') {
            this.comboComercio = false;
            this.displayedColumns = ['fecIngreso', 'fecProceso', 'nomEstado', 'nomArchivo', 'cantRegistros', 'detalle'];
            this.formGroup.controls['comercio'].disable();
            this.peticionMandatosHistorial.idFacturador = this.idEmpresaPac;
        }
        else {
            this.comboComercio = true;
            this.displayedColumns = ['fecIngreso', 'fecProceso', 'nomEstado', 'nomArchivo', 'nomFacturador', 'cantRegistros', 'detalle'];
            this.formGroup.controls['comercio'].enable();
            this.peticionMandatosHistorial.idFacturador = '-1';
            this.peticionEmpresa.codCliente = this.environment.codCliente;
            this.peticionEmpresa.codEstadoConvenio = 'HBL';
            this.postSentEmpresaServices(this.peticionEmpresa);
            //this.postSentSelectEmpresaServices(this.peticionEmpresa);
        }
        this.postListarEstadoArchivosServices();
        this.consulta = -1;
        if (sessionStorage.getItem('componenteHijo') == 'mandatosHistorialDetalle') {
            this.consulta = 0;
            /** @type {?} */
            var llamadaPadre = JSON.parse(sessionStorage.getItem('llamadaPadre'));
            // Llena los filtros
            this.formGroup.controls['fechaIngreso'].setValue(llamadaPadre.filtroIngresoI);
            this.formGroup.controls['fechaProceso'].setValue(llamadaPadre.filtroProcesoD);
            this.fechaInicioIngreso = llamadaPadre.fechaInicioIngreso;
            this.fechaFinIngreso = llamadaPadre.fechaFinIngreso;
            this.fechaInicioProceso = llamadaPadre.fechaInicioProceso;
            this.fechaFinProceso = llamadaPadre.fechaFinProceso;
            this.formGroup.controls['estado'].setValue(llamadaPadre.codEstadoArchivo);
            this.formGroup.controls['nomArchivo'].setValue((llamadaPadre.nomArchivo != '-1' ? llamadaPadre.nomArchivo : ''));
            this.formGroup.controls['comercio'].setValue(llamadaPadre.idFacturador + ',' + llamadaPadre.idConvenio);
            // Llena camino de migas
            /** @type {?} */
            var migasPadre = JSON.parse(sessionStorage.getItem('migasPadre'));
            this.vistaEstado = migasPadre.codEstadoArchivo;
            this.hashCaminoMiga[0] = { title: 'Fecha Ingreso', text: migasPadre.fechaIngreso };
            this.hashCaminoMiga[1] = { title: 'Fecha Proceso', text: migasPadre.fechaProceso };
            this.hashCaminoMiga[2] = { title: 'Estado', text: migasPadre.codEstadoArchivo };
            this.hashCaminoMiga[3] = { title: 'Nombre', text: migasPadre.nomArchivo };
            if (this.codTpoPortal != 'COMERCIO') {
                this.vistaComercio = migasPadre.facturador;
                this.hashCaminoMiga[4] = { title: 'Empresa', text: migasPadre.facturador };
            }
            // Llama al servicio
            this.peticionMandatosHistorial.codTpoPortal = llamadaPadre.codTpoPortal;
            this.peticionMandatosHistorial.fechaInicioIngreso = llamadaPadre.fechaInicioIngreso;
            this.peticionMandatosHistorial.fechaFinIngreso = llamadaPadre.fechaFinIngreso;
            this.peticionMandatosHistorial.fechaInicioProceso = llamadaPadre.fechaInicioProceso;
            this.peticionMandatosHistorial.fechaFinProceso = llamadaPadre.fechaFinProceso;
            this.peticionMandatosHistorial.codEstadoArchivo = llamadaPadre.codEstadoArchivo;
            this.peticionMandatosHistorial.nomArchivo = llamadaPadre.nomArchivo;
            this.peticionMandatosHistorial.idFacturador = llamadaPadre.idFacturador;
            this.peticionMandatosHistorial.idConvenio = llamadaPadre.idConvenio;
            this.postMandatosHistorialServices(this.peticionMandatosHistorial);
        }
        else {
            this.setInitialBreadcrumbs();
        }
        //Busqueda del parametro para hacer una busqueda
        this.route.queryParams.subscribe((/**
         * @param {?} parametro
         * @return {?}
         */
        function (parametro) {
            if (parametro.busqueda == 'true') {
                _this.onSubmit('');
            }
        }));
    };
    /**
     * @return {?}
     */
    MandatosHistorialComponent.prototype.setInitialBreadcrumbs = /**
     * @return {?}
     */
    function () {
        this.hashCaminoMiga[0] = { title: 'Fecha Ingreso', text: 'Todos' };
        this.hashCaminoMiga[1] = { title: 'Fecha Proceso', text: 'Todos' };
        this.hashCaminoMiga[2] = { title: 'Estado', text: 'Todos' };
        this.hashCaminoMiga[3] = { title: 'Nombre', text: '' };
        if (this.codTpoPortal != 'COMERCIO') {
            this.hashCaminoMiga[4] = { title: 'Empresa', text: 'Todas' };
        }
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    MandatosHistorialComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.consulta = 0;
        this.peticionMandatosHistorial.codTpoPortal = this.codTpoPortal;
        this.filtroIngresoI = this.formGroup.get('fechaIngreso').value;
        if (this.formGroup.get('fechaIngreso').value != null) {
            this.peticionMandatosHistorial.fechaInicioIngreso = formatDate(this.filtroIngresoI.begin, 'dd/MM/yyyy', 'en-US');
            this.peticionMandatosHistorial.fechaFinIngreso = formatDate(this.filtroIngresoI.end, 'dd/MM/yyyy', 'en-US');
            this.hashCaminoMiga[0] = { title: 'Fecha Ingreso', text: this.fechaInicioIngreso + ' - ' + this.fechaFinIngreso };
        }
        else {
            this.hashCaminoMiga[0] = { title: 'Fecha Ingreso', text: 'Todos' };
            this.peticionMandatosHistorial.fechaInicioIngreso = this.fechaInicioIngreso;
            this.peticionMandatosHistorial.fechaFinIngreso = this.fechaFinIngreso;
        }
        this.filtroProcesoD = this.formGroup.get('fechaProceso').value;
        if (this.formGroup.get('fechaProceso').value != null) {
            this.peticionMandatosHistorial.fechaInicioProceso = formatDate(this.filtroProcesoD.begin, 'dd/MM/yyyy', 'en-US');
            this.peticionMandatosHistorial.fechaFinProceso = formatDate(this.filtroProcesoD.end, 'dd/MM/yyyy', 'en-US');
            this.hashCaminoMiga[1] = { title: 'Fecha Proceso', text: this.fechaInicioProceso + ' - ' + this.fechaFinProceso };
        }
        else {
            this.hashCaminoMiga[1] = { title: 'Fecha Proceso', text: 'Todos' };
            this.peticionMandatosHistorial.fechaInicioProceso = this.fechaInicioProceso;
            this.peticionMandatosHistorial.fechaFinProceso = this.fechaFinProceso;
        }
        if (this.formGroup.get('estado').value == null || this.formGroup.get('estado').value == '-1') {
            this.peticionMandatosHistorial.codEstadoArchivo = '-1';
            this.hashCaminoMiga[2] = { title: 'Estado', text: 'Todos' };
        }
        else {
            this.peticionMandatosHistorial.codEstadoArchivo = this.formGroup.get('estado').value;
            this.hashCaminoMiga[2] = { title: 'Estado', text: this.vistaEstado };
        }
        if (this.formGroup.get('nomArchivo').value == null) {
            this.peticionMandatosHistorial.nomArchivo = '-1';
            this.hashCaminoMiga[3] = { title: 'Nombre', text: '' };
        }
        else {
            this.peticionMandatosHistorial.nomArchivo = this.formGroup.get('nomArchivo').value;
            this.hashCaminoMiga[3] = { title: 'Nombre', text: this.formGroup.get('nomArchivo').value };
        }
        if (this.codTpoPortal == 'COMERCIO') {
            this.peticionMandatosHistorial.idFacturador = this.idEmpresaPac;
        }
        else {
            /** @type {?} */
            var idFacturador = this.formGroup.get('comercio').value.split(",")[0];
            if (idFacturador == null || idFacturador == '' || idFacturador == -1) {
                this.peticionMandatosHistorial.idFacturador = '-1';
                this.peticionMandatosHistorial.idConvenio = '-1';
                this.hashCaminoMiga[4] = { title: 'Empresa', text: 'Todas' };
            }
            else {
                this.peticionMandatosHistorial.idFacturador = this.formGroup.get('comercio').value.split(",")[0];
                this.peticionMandatosHistorial.idConvenio = this.formGroup.get('comercio').value.split(",")[1];
                this.hashCaminoMiga[4] = { title: 'Empresa', text: this.vistaComercio };
            }
        }
        sessionStorage.setItem('llamadaPadre', JSON.stringify({
            codTpoPortal: this.peticionMandatosHistorial.codTpoPortal,
            fechaInicioIngreso: this.peticionMandatosHistorial.fechaInicioIngreso,
            fechaFinIngreso: this.peticionMandatosHistorial.fechaFinIngreso,
            fechaInicioProceso: this.peticionMandatosHistorial.fechaInicioProceso,
            fechaFinProceso: this.peticionMandatosHistorial.fechaFinProceso,
            codEstadoArchivo: this.peticionMandatosHistorial.codEstadoArchivo,
            nomArchivo: this.peticionMandatosHistorial.nomArchivo,
            idFacturador: this.peticionMandatosHistorial.idFacturador,
            idConvenio: this.peticionMandatosHistorial.idConvenio,
            filtroIngresoI: this.filtroIngresoI,
            filtroProcesoD: this.filtroProcesoD
        }));
        sessionStorage.setItem('migasPadre', JSON.stringify({
            fechaIngreso: this.hashCaminoMiga[0].text,
            fechaProceso: this.hashCaminoMiga[1].text,
            codEstadoArchivo: this.hashCaminoMiga[2].text,
            nomArchivo: this.hashCaminoMiga[3].text,
            facturador: (this.codTpoPortal != 'COMERCIO' ? this.hashCaminoMiga[4].text : '')
        }));
        if (tipo == 'excel' || tipo == 'pdf') {
            this.peticionMandatosHistorial.filtros = this.hashCaminoMiga;
            this.peticionMandatosHistorial.codCliente = this.environment.codCliente;
            this.postDownloadReportFile(this.peticionMandatosHistorial, tipo);
        }
        else {
            this.postMandatosHistorialServices(this.peticionMandatosHistorial);
        }
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    MandatosHistorialComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiMandatosMT/listActivaMandatoHistorial/' + tipo;
        this.descargaExcelPdfFileService.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'activacionMandatosHistorial' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'activacionMandatosHistorial' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MandatosHistorialComponent.prototype.onPaginateChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var indice = this.paginator.pageIndex;
        sessionStorage.setItem('indice', indice);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    MandatosHistorialComponent.prototype.postMandatosHistorialServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.show = true;
        this.segmandatosService.postMandatosHistorial(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                console.log(data);
                _this.vistaCantidad = data.resultado.length;
                if (_this.paginator != undefined && sessionStorage.getItem('componenteHijo') == 'mandatosHistorialDetalle') {
                    _this.paginator.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indice')))));
                }
                else if (_this.paginator != undefined) {
                    _this.paginator.pageIndex = 0;
                    sessionStorage.removeItem("indice");
                }
                sessionStorage.removeItem('componenteHijo');
                _this.dataSource = new MatTableDataSource$1(data.resultado);
                _this.dataSource.paginator = _this.paginator;
                if (_this.vistaCantidad == 0) {
                    _this.show = false;
                    _this.isCollapsed = false;
                }
                else {
                    _this.isCollapsed = true;
                }
                _this.mensajeError = 0;
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.mensajeError = 1;
                _this.loader.hide();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            _this.mensajeError = 1;
            _this.loader.hide();
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    MandatosHistorialComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.empresasService.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var emp = new EmpresaResult();
                emp.docFacturador = '-1';
                emp.idFacturador = -1;
                emp.idConvenio = '-1';
                emp.nomFacturador = 'Todas';
                data.resultado.splice(0, 0, emp);
                _this.resultadoEmpresa = [];
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.log('Error postSentEmpresaServices: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.log('Error postSentEmpresaServices: ', err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    MandatosHistorialComponent.prototype.postSentSelectEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.empresasService.postListarSelectEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var emp = new EmpresaResult();
                emp.idFacturador = -1;
                emp.nomFacturador = "Todas";
                data.resultado.splice(0, 0, emp);
                _this.resultadoEmpresa = [];
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.log('Error postSentSelectEmpresaServices: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.log('Error postSentSelectEmpresaServices: ', err);
        }));
    };
    /**
     * @return {?}
     */
    MandatosHistorialComponent.prototype.postListarEstadoArchivosServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.facturacionHistorialService.postListarEstadoArchivos().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var estados = new EstadoArchivosResult();
                estados.codigo = "-1";
                estados.descripcion = "Todos";
                estados.idEstado = "-1";
                data.resultado.splice(0, 0, estados);
                for (var index = 0; index < data.resultado.length; index++) {
                    if (data.resultado[index]['codigo'] != 'COB' && data.resultado[index]['codigo'] != 'ANL') {
                        _this.resultadoEstado.push(data.resultado[index]);
                    }
                }
                //this.resultadoEstado = data.resultado;
            }
            else {
                console.error('Error postSentEstadoServices', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postSentEstadoServices', err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MandatosHistorialComponent.prototype.onEstadoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEstado = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MandatosHistorialComponent.prototype.onComercioSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaComercio = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @return {?}
     */
    MandatosHistorialComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        //Ingreso
        this.fechaInicioIngreso = '01/01/2000';
        this.fechaFinIngreso = '01/01/2000';
        //Proceso
        this.fechaInicioProceso = '01/01/2000';
        this.fechaFinProceso = '01/01/2000';
        this.peticionMandatosHistorial.codEstadoArchivo = '-1';
        this.peticionMandatosHistorial.nomArchivo = '-1';
        this.peticionMandatosHistorial.idConvenio = '-1';
        this.formGroup.controls.comercio.reset('-1' + ',' + '-1');
        this.formGroup.controls.estado.setValue('-1');
        this.filtroIngresoI = null;
        this.filtroProcesoD = null;
        this.formGroup.get('fechaIngreso').setValue(null);
        this.formGroup.get('fechaProceso').setValue(null);
        this.formGroup.get('nomArchivo').setValue('');
        this.setInitialBreadcrumbs();
        this.show = false;
        this.vistaCantidad = 0;
        this.mensajeError = -1;
        this.consulta = -1;
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    MandatosHistorialComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MandatosHistorialComponent.prototype.selectFechaIngreso = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.fechaInicioIngreso = formatDate(event.value.begin, 'dd/MM/yyyy', 'en-US');
        this.fechaFinIngreso = formatDate(event.value.end, 'dd/MM/yyyy', 'en-US');
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MandatosHistorialComponent.prototype.selectFechaProceso = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.fechaInicioProceso = formatDate(event.value.begin, 'dd/MM/yyyy', 'en-US');
        this.fechaFinProceso = formatDate(event.value.end, 'dd/MM/yyyy', 'en-US');
    };
    /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    MandatosHistorialComponent.prototype.getEmpresaConvenio = /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    function (nomFacturador, descConvenio) {
        return descConvenio != "" ? nomFacturador + ": " + descConvenio : nomFacturador;
    };
    /**
     * @return {?}
     */
    MandatosHistorialComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.onSubmit('');
        }
    };
    /**
     * @return {?}
     */
    MandatosHistorialComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('componenteHijo');
    };
    MandatosHistorialComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mandatosHistorial',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"modulo-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n      </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"formGroup\" autocomplete=\"off\">\r\n              <div class=\"form-row align-left\">\r\n                <div class=\"col-md-6\">\r\n                  <div class=\"filtro-fecha\">\r\n                    <button type=\"button\" class=\"btn fecha\" (click)=\"picker1.open()\"><i class=\"str-icon-calendario\"></i> Buscar por fecha de ingreso\r\n                      <ng-container *ngIf=\"this.formGroup.get('fechaIngreso').value != null && this.fechaInicioIngreso != '01/01/2000'\">\r\n                        <span>{{ this.fechaInicioIngreso + ' - ' + this.fechaFinIngreso }}</span>\r\n                      </ng-container>\r\n                    </button>\r\n                    <mat-form-field style=\"display: none;\">\r\n                      <input matInput placeholder=\"Fecha\" [max]=\"unavailabilityForm.controls.endDate.value\" [satDatepicker]=\"picker1\" formControlName=\"fechaIngreso\" (dateInput)=\"selectFechaIngreso($event)\">\r\n                      <sat-datepicker-toggle matSuffix [for]=\"picker1\"></sat-datepicker-toggle>\r\n                      <sat-datepicker touchUi #picker1 [rangeMode]=\"true\" [selectFirstDateOnClose]=\"true\"></sat-datepicker>\r\n                    </mat-form-field>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                  <div class=\"filtro-fecha\">\r\n                    <button type=\"button\" class=\"btn fecha\" (click)=\"picker2.open()\"><i class=\"str-icon-calendario\"></i> Buscar por fecha de proceso\r\n                      <ng-container *ngIf=\"this.formGroup.get('fechaProceso').value != null && this.fechaInicioProceso != '01/01/2000'\">\r\n                        <span>{{ this.fechaInicioProceso + ' - ' + this.fechaFinProceso }}</span>\r\n                      </ng-container>\r\n                    </button>\r\n                    <mat-form-field style=\"display: none;\">\r\n                      <input matInput placeholder=\"Fecha\" [max]=\"unavailabilityForm.controls.endDate.value\" [satDatepicker]=\"picker2\" formControlName=\"fechaProceso\" (dateInput)=\"selectFechaProceso($event)\">\r\n                      <sat-datepicker-toggle matSuffix [for]=\"picker2\"></sat-datepicker-toggle>\r\n                      <sat-datepicker touchUi #picker2 [rangeMode]=\"true\" [selectFirstDateOnClose]=\"true\"></sat-datepicker>\r\n                    </mat-form-field>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-row\">\r\n                <div class=\"form-group col-sm-3\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estado\" (selectionChange)=\"onEstadoSelect($event)\">\r\n                      <mat-option *ngFor=\"let estado of resultadoEstado\" [value]=\"estado.codigo\">{{estado.descripcion}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-sm-5\">\r\n                  <mat-form-field>\r\n                    <input noCaracEsp matInput maxlength=\"50\" placeholder=\"Nombre\" formControlName=\"nomArchivo\">\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-sm-4\" *ngIf=\"comboComercio\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"comercio\" (selectionChange)=\"onComercioSelect($event)\">\r\n                      <mat-option class=\"multiline-mat-option\" *ngFor=\"let empresa of resultadoEmpresa\" [value]=\"empresa.idFacturador + ',' + empresa.idConvenio\">{{getEmpresaConvenio(empresa.nomFacturador, empresa.descConvenio)}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"actions\">\r\n                <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\" (click)=\"validarForm()\">Filtrar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"resultados-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-10\">\r\n          <div class=\"tags row\">\r\n            <div *ngFor=\"let entry of hashCaminoMiga\" class=\"item\">{{entry.title}}: {{entry.text}}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n          <div class=\"numero-resultados\">\r\n            <strong>{{ (vistaCantidad == 1) ? ( vistaCantidad + \" Resultado\") : vistaCantidad + \" Resultados\" }}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-container table-responsive-md\">\r\n        <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n          <ng-container matColumnDef=\"nomEstado\">\r\n            <th mat-header-cell *matHeaderCellDef>Estado</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.codEstado == 'ING'\" class=\"databar ingresado\">{{resultado.nomEstado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'COB'\" class=\"databar encobro\">{{resultado.nomEstado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'PRO'\" class=\"databar procesado\">{{resultado.nomEstado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'RCH'\" class=\"databar rechazado\">{{resultado.nomEstado}}</span>\r\n              <span *ngIf=\"resultado.codEstado == 'ANL'\" class=\"databar eliminado\">{{resultado.nomEstado}}</span>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"nomArchivo\">\r\n            <th mat-header-cell *matHeaderCellDef>Nombre</th>\r\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\"> {{resultado.nomArchivo}} \r\n              <br>\r\n              <span *ngIf=\"resultado.codEstado == 'RCH' && resultado.idMotivo != ''\" style=\"font-size: smaller;font-weight: bold;\">Motivo rechazo: {{resultado.desMotivo}}</span>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"nomFacturador\" *ngIf=\"comboComercio\">\r\n            <th mat-header-cell *matHeaderCellDef>Empresa</th>\r\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\">{{resultado.nomFacturador}}: {{resultado.descConvenio}}</td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"cantRegistros\">\r\n            <th mat-header-cell *matHeaderCellDef>N\u00B0 de registros</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.cantRegistros | cantidad}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fecIngreso\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha de ingreso</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.fecIngreso == ''; else elseBlock\">(Pendiente)</span>\r\n              <ng-template #elseBlock>{{resultado.fecIngreso | date:'dd/MM/yyyy HH:mm'}}</ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fecProceso\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha de proceso</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.fecProceso == ''; else elseBlock\">(Pendiente)</span>\r\n              <ng-template #elseBlock>{{resultado.fecProceso | date:'dd/MM/yyyy'}}</ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"detalle\">\r\n            <th mat-header-cell *matHeaderCellDef>Detalle</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a *ngIf=\"resultado.codEstado == 'PRO'; else noPro\" [routerLink]=\"['../detalle']\" [queryParams]=\"{'a':resultado.idArchivo,'c':resultado.cantRegistros,'ca':resultado.idCarga,'fi':resultado.fecIngreso,'fp':resultado.fecProceso,'de':resultado.nomEstado,'cod':resultado.codEstado}\"><i class=\"str-icon-flecha-derecha\"></i></a>\r\n              <ng-template #noPro> - </ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n        </table>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" (page)=\"onPaginateChange($event)\" showFirstLastButtons></mat-paginator>\r\n      </div>\r\n      <div class=\"box-actions\" *ngIf=\"vistaCantidad > 0\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6 item\">\r\n            <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n          </div>\r\n          <div class=\"col-md-6 item-right\">\r\n            <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </section>\r\n\r\n    <div class=\"modulo-cuentas\" *ngIf=\"mensajeError == 0 && vistaCantidad == 0\">\r\n      <span>\r\n        No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"modulo-cuentas\" *ngIf=\"consulta == -1\">\r\n      <span>\r\n        Establezca sus criterios de b&uacute;squeda.\r\n      </span>\r\n    </div>\r\n\r\n  </div>\r\n</section>\r\n\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div *ngIf=\"mensajeError == 1\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" id=\"modal-basic-title\" style=\"color:#ec0000;font-weight: bold\">Error</h3>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <p>Servicio temporalmente no disponible.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [EmpresasService, DescargaExcelPdfFileService,
                        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
                        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
                        { provide: MAT_DATE_FORMATS, useValue: ɵ0$g }]
                }] }
    ];
    /** @nocollapse */
    MandatosHistorialComponent.ctorParameters = function () { return [
        { type: SegmandatosService },
        { type: EmpresasService },
        { type: FacturacionHistorialService },
        { type: DescargaExcelPdfFileService },
        { type: LoaderBaseService },
        { type: MatDialog },
        { type: FormBuilder },
        { type: DatePipe },
        { type: ActivatedRoute },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    MandatosHistorialComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator$1,] }]
    };
    return MandatosHistorialComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MandatosHistorialDetallePeticion = /** @class */ (function () {
    function MandatosHistorialDetallePeticion() {
        this.idArchivo = -1;
        this.idCarga = -1;
        this.idEstadoMandato = -1;
        this.idServicio = '-1';
        this.codCliente = '-1';
        this.filtros = [];
    }
    return MandatosHistorialDetallePeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MandatosHistorialDetalleComponent = /** @class */ (function () {
    function MandatosHistorialDetalleComponent(segmandatosService, router, route, phttpd, dialog, loader, environment) {
        this.segmandatosService = segmandatosService;
        this.router = router;
        this.route = route;
        this.phttpd = phttpd;
        this.dialog = dialog;
        this.loader = loader;
        this.environment = environment;
        this.peticionHistorialDetalle = new MandatosHistorialDetallePeticion();
        this.vistaCantidad = 0;
        this.hashCaminoMiga = [];
        this.vistaEstado = 'Todos';
        this.displayedColumns = ['fechaSuscripcion', 'idServicio', 'monto', 'estado'];
    }
    /**
     * @return {?}
     */
    MandatosHistorialDetalleComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        sessionStorage.setItem('componenteHijo', 'mandatosHistorialDetalle');
        this.route.queryParams.subscribe((/**
         * @param {?} params
         * @return {?}
         */
        function (params) {
            _this.peticionHistorialDetalle.idArchivo = Number(params['a']);
            _this.peticionHistorialDetalle.idCarga = Number(params['ca']);
            _this.idArchivo = params['a'],
                _this.cantidad = params['c'],
                _this.fechaIngreso = params['fi'],
                _this.fechaProceso = params['fp'],
                _this.descEstado = params['de'],
                _this.codEstado = params['cod'];
        }));
        this.peticionHistorialDetalle.idServicio = '-1';
        this.peticionHistorialDetalle.idEstadoMandato = -1;
        this.firstFormGroup = new FormGroup({
            idServicio: new FormControl(),
            estadoMandato: new FormControl('-1'),
        });
        this.postEstadoMandatoServices();
        this.postMandatosHistorialDetalleServices(this.peticionHistorialDetalle);
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    MandatosHistorialDetalleComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        if (this.firstFormGroup.get('idServicio').value == null) {
            this.peticionHistorialDetalle.idServicio = '-1';
            this.hashCaminoMiga[0] = { title: 'ID Servicio', text: '' };
        }
        else {
            /** @type {?} */
            var servicio = this.firstFormGroup.get('idServicio').value;
            this.peticionHistorialDetalle.idServicio = servicio;
            this.hashCaminoMiga[0] = { title: 'ID Servicio', text: servicio };
        }
        if (this.firstFormGroup.get('estadoMandato').value == '-1') {
            this.peticionHistorialDetalle.idEstadoMandato = -1;
            this.hashCaminoMiga[1] = { title: 'Estado', text: 'Todos' };
        }
        else {
            this.peticionHistorialDetalle.idEstadoMandato = this.firstFormGroup.get('estadoMandato').value;
            this.hashCaminoMiga[1] = { title: 'Estado', text: this.vistaEstado };
        }
        if (tipo == 'excel' || tipo == 'pdf') {
            this.peticionHistorialDetalle.filtros = this.hashCaminoMiga;
            this.peticionHistorialDetalle.codCliente = this.environment.codCliente;
            this.postDownloadReportFile(this.peticionHistorialDetalle, tipo);
        }
        else {
            if (this.paginator != undefined) {
                this.paginator.pageIndex = 0;
            }
            this.postMandatosHistorialDetalleServices(this.peticionHistorialDetalle);
        }
    };
    /**
     * @param {?} body
     * @return {?}
     */
    MandatosHistorialDetalleComponent.prototype.postMandatosHistorialDetalleServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.segmandatosService.postMandatosHistorialDetalle(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                console.log(data);
                _this.vistaCantidad = data.resultado.length;
                _this.dataSource = new MatTableDataSource$1(data.resultado);
                _this.dataSource.paginator = _this.paginator;
                _this.loader.hide();
            }
            else {
                _this.loader.hide();
                console.log('Error: ', data.descret);
                _this.showDialogFail('Error', 'Servicio temporalmente no disponible.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            console.log('Error: ', err);
            _this.showDialogFail('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @return {?}
     */
    MandatosHistorialDetalleComponent.prototype.postEstadoMandatoServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.segmandatosService.postEstadoMandato().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var estado = new FacturacionEstados();
                estado.idEstado = '-1';
                estado.descripcion = "Todos";
                data.resultado.splice(0, 0, estado);
                _this.resultadoEstadoMandato = [];
                _this.resultadoEstadoMandato.push(data);
            }
            else {
                console.error('Error postEstadoMandatoServices: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postEstadoMandatoServices: ', err);
        }));
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    MandatosHistorialDetalleComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        /** @type {?} */
        var url = '/apiMandatosMT/listActivaMandatoDetalle/' + tipo;
        this.phttpd.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'activacionMandatosHistorialDetalle' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'activacionMandatosHistorialDetalle' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) { console.log(err); }));
    };
    /**
     * @return {?}
     */
    MandatosHistorialDetalleComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.peticionHistorialDetalle.idServicio = '-1';
        this.peticionHistorialDetalle.idEstadoMandato = -1;
        this.firstFormGroup.controls.estadoMandato.setValue('-1');
        this.firstFormGroup.controls.idServicio.setValue('');
        this.onSubmit('');
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    MandatosHistorialDetalleComponent.prototype.showDialogFail = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            _this.router.navigate(['../historial'], { relativeTo: _this.route });
        }));
    };
    /**
     * @return {?}
     */
    MandatosHistorialDetalleComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.firstFormGroup.valid) {
            this.onSubmit('');
        }
    };
    // <!-- 
    // <span *ngIf="resultado.diaPago > 0; else elseBlock">{{formateandoMonto(resultado, true)}}{{resultado.montoFijo/100 | moneda}}</span>
    // <ng-template #elseBlock>{{resultado.montoMaximo/100 | moneda}}</ng-template> -->
    // <!-- 
    // <span *ngIf="resultado.diaPago > 0; else elseBlock">{{formateandoMonto(resultado, true)}}{{resultado.montoFijo/100 | moneda}}</span>
    // <ng-template #elseBlock>{{resultado.montoMaximo/100 | moneda}}</ng-template> -->
    /**
     * @param {?} resul
     * @param {?} valorB
     * @return {?}
     */
    MandatosHistorialDetalleComponent.prototype.formateandoMonto = 
    // <!-- 
    // <span *ngIf="resultado.diaPago > 0; else elseBlock">{{formateandoMonto(resultado, true)}}{{resultado.montoFijo/100 | moneda}}</span>
    // <ng-template #elseBlock>{{resultado.montoMaximo/100 | moneda}}</ng-template> -->
    /**
     * @param {?} resul
     * @param {?} valorB
     * @return {?}
     */
    function (resul, valorB) {
        /** @type {?} */
        var monto;
        valorB ? monto = resul.montoFijo : monto = resul.montoMaximo;
        return FormatoMonedaUtil.formatearMontoParam(monto, resul.tipoMoneda);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MandatosHistorialDetalleComponent.prototype.onEstadoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEstado = event.source.selected._element.nativeElement.innerText.trim();
    };
    MandatosHistorialDetalleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mandatosHistorialDetalle',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"modulo-cuentas detalle\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a [routerLink]=\"['../historial']\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-row\">\r\n        <div class=\"col-2 order-1 order-md-1 col-md-1 icon\">\r\n          <!-- <i class=\"str-icon-recargar\"></i> -->\r\n        </div>\r\n        <div class=\"col-12 order-12 order-md-2 col-md-10 datos\">\r\n          <div class=\"form-row\">\r\n            <div class=\"item col-sm-6 col-md-2\">\r\n              <h5>ID Proceso:</h5>\r\n              <p>{{idArchivo}}</p>\r\n            </div>\r\n            <div class=\"item col-sm-6 col-md-2\">\r\n              <h5>Cantidad:</h5>\r\n              <p>{{cantidad | cantidad}}</p>\r\n            </div>\r\n            <div class=\"item col-sm-6 col-md-3\">\r\n              <h5>Fecha de ingreso:</h5>\r\n              <p>{{fechaIngreso | date:'dd/MM/yyyy'}}</p>\r\n            </div>\r\n            <div class=\"item col-sm-6 col-md-3\">\r\n              <h5>Fecha de proceso:</h5>\r\n              <p>{{fechaProceso | date:'dd/MM/yyyy'}}</p>\r\n            </div>\r\n            <div class=\"item col-sm-6 col-md-2\">\r\n              <h5>Estado del proceso:</h5>\r\n              <span *ngIf=\"codEstado == 'ING'\" class=\"databar ingresado\">{{descEstado}}</span>\r\n              <span *ngIf=\"codEstado == 'COB'\" class=\"databar encobro\">{{descEstado}}</span>\r\n              <span *ngIf=\"codEstado == 'PRO'\" class=\"databar procesado\">{{descEstado}}</span>\r\n              <span *ngIf=\"codEstado == 'RCH'\" class=\"databar rechazado\">{{descEstado}}</span>\r\n              <span *ngIf=\"codEstado == 'ANL'\" class=\"databar eliminado\">{{descEstado}}</span>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"filtros-detalle\">\r\n            <div class=\"box-filtros\">\r\n              <form [formGroup]=\"firstFormGroup\" (ngSubmit)=\"validarForm()\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n                <div class=\"form-row d-flex align-items-center\">\r\n                  <div class=\"col-md-3\">\r\n                    <mat-form-field>\r\n                      <input noCaracEsp matInput maxlength=\"20\" placeholder=\"ID Servicio\" formControlName=\"idServicio\">\r\n                    </mat-form-field>\r\n                  </div>\r\n                  <div class=\"col-md-3\">\r\n                    <mat-form-field>\r\n                      <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estadoMandato\" (selectionChange)=\"onEstadoSelect($event)\">\r\n                        <section *ngFor=\"let resp of resultadoEstadoMandato\">\r\n                          <mat-option *ngFor=\"let estado of resp.resultado\" [value]=\"estado.idEstado\">{{estado.descripcion}}</mat-option>\r\n                        </section>\r\n                      </mat-select>\r\n                    </mat-form-field>\r\n                  </div>\r\n                  <div class=\"col-md-6 align-right\">\r\n                    <div class=\"actions\">\r\n                      <button type=\"button\" class=\"btn-small text\" (click)=\"limpiar()\">Limpiar</button>\r\n                      <button type=\"submit\" class=\"btn-small main\" >Filtrar</button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </form>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"table-container detalle table-responsive-lg\">\r\n            <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n              <ng-container matColumnDef=\"idServicio\">\r\n                <th mat-header-cell *matHeaderCellDef>ID Servicio</th>\r\n                <td mat-cell *matCellDef=\"let resultado\"> {{resultado.idServicio}} </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"monto\">\r\n                <th mat-header-cell *matHeaderCellDef>Monto</th>\r\n                <td mat-cell *matCellDef=\"let resultado\">\r\n                  <span *ngIf=\"resultado.diaPago > 0; else elseBlock\">{{formateandoMonto(resultado, true)}}</span>\r\n                  <ng-template #elseBlock>{{formateandoMonto(resultado, false)}}</ng-template>\r\n                </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"fechaSuscripcion\">\r\n                <th mat-header-cell *matHeaderCellDef>Fecha Suscripci&oacute;n</th>\r\n                <td mat-cell *matCellDef=\"let resultado\"> {{resultado.fecSuscripcion | date:'dd/MM/yyyy'}} </td>\r\n              </ng-container>\r\n              <ng-container matColumnDef=\"estado\">\r\n                <th mat-header-cell *matHeaderCellDef>Estado</th>\r\n                <td mat-cell *matCellDef=\"let resultado\">\r\n                  <span *ngIf=\"resultado.indSuspendido == '1' ; else elseBlock\">Suspendido</span>\r\n                  <ng-template #elseBlock>{{resultado.estadoMandato}}</ng-template>\r\n                </td>\r\n              </ng-container>\r\n              <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n              <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n            </table>\r\n            <mat-paginator [pageSizeOptions]=\"[10]\" showFirstLastButtons></mat-paginator>\r\n          </div>\r\n\r\n          <div class=\"box-actions\" *ngIf=\"vistaCantidad > 0\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-6 item\">\r\n                <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n              </div>\r\n              <div class=\"col-md-6 item-right\">\r\n                <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [DescargaExcelPdfFileService]
                }] }
    ];
    /** @nocollapse */
    MandatosHistorialDetalleComponent.ctorParameters = function () { return [
        { type: SegmandatosService },
        { type: Router },
        { type: ActivatedRoute },
        { type: DescargaExcelPdfFileService },
        { type: MatDialog },
        { type: LoaderBaseService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    MandatosHistorialDetalleComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator$1,] }]
    };
    return MandatosHistorialDetalleComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MandatosMenuComponent = /** @class */ (function () {
    function MandatosMenuComponent() {
    }
    /**
     * @return {?}
     */
    MandatosMenuComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    MandatosMenuComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mandatos-carga',
                    template: "<section id=\"portal-comercio\">\r\n    <div class=\"container\">\r\n        <!-- <h3 class=\"titulo-seccion\">Activaci\u00F3n de Mandatos</h3> -->\r\n        <div class=\"menu-pills\">\r\n            <div [routerLink]=\"['carga']\" [routerLinkActive]=\"['active']\" class=\"item first\">Carga de Mandatos</div>\r\n            <div [routerLink]=\"['historial']\" [routerLinkActive]=\"['active']\" class=\"item last\">Historial</div>\r\n        </div>\r\n    </div>\r\n</section>\r\n<router-outlet></router-outlet>"
                }] }
    ];
    /** @nocollapse */
    MandatosMenuComponent.ctorParameters = function () { return []; };
    return MandatosMenuComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PerfilesAddPeticion = /** @class */ (function () {
    function PerfilesAddPeticion() {
        this.codCliente = '-1';
        this.idUsuario = '-1';
        this.docEmpresa = '-1';
        this.codTpoPortal = '-1';
        this.descPerfil = '-1';
        this.codEstadoPerfil = '-1';
        this.idPolitica = '-1';
        this.listIdServEmp = [];
    }
    return PerfilesAddPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ServEmpresaPeticion = /** @class */ (function () {
    function ServEmpresaPeticion() {
        this.codCliente = '-1';
        this.docEmpresa = '-1';
    }
    return ServEmpresaPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PoliticaListPeticion = /** @class */ (function () {
    function PoliticaListPeticion() {
        this.codCliente = '-1';
        this.descPol = '-1';
        this.idPol = '-1';
    }
    return PoliticaListPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var httpOptions$d = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};
var PerfilesService = /** @class */ (function () {
    function PerfilesService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlPerfilesList = this.environment.urlAmbiente + '/apiPerfilesMT/perfilesList';
        this.urlPerfilesAdd = this.environment.urlAmbiente + '/apiPerfilesMT/perfilesAdd';
        this.urlPerfilesUpd = this.environment.urlAmbiente + '/apiPerfilesMT/perfilesUpd';
        this.urlPerfilesEstados = this.environment.urlAmbiente + '/apiPerfilesMT/perfilesEstadoList';
        this.urlListServEmp = this.environment.urlAmbiente + '/apiPerfilesMT/listServEmp';
        this.urlListServPerfil = this.environment.urlAmbiente + '/apiPerfilesMT/listServPerfil';
    }
    /**
     * @param {?} params
     * @return {?}
     */
    PerfilesService.prototype.postPerfilesList = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlPerfilesList, params, httpOptions$d);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    PerfilesService.prototype.postPerfilesAdd = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlPerfilesAdd, params, httpOptions$d);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    PerfilesService.prototype.postPerfilesUpd = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlPerfilesUpd, params, httpOptions$d);
    };
    /**
     * @return {?}
     */
    PerfilesService.prototype.postPerfilesEstados = /**
     * @return {?}
     */
    function () {
        return this.http.post(this.urlPerfilesEstados, null, httpOptions$d);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    PerfilesService.prototype.postListServEmp = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlListServEmp, params, httpOptions$d);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    PerfilesService.prototype.postListServPerfil = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlListServPerfil, params, httpOptions$d);
    };
    PerfilesService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    PerfilesService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    /** @nocollapse */ PerfilesService.ngInjectableDef = defineInjectable({ factory: function PerfilesService_Factory() { return new PerfilesService(inject(HttpClient), inject("env")); }, token: PerfilesService, providedIn: "root" });
    return PerfilesService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var httpOptions$e = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};
var PoliticaService = /** @class */ (function () {
    function PoliticaService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlPolitica = this.environment.urlAmbiente + '/apiUsuariosMT/traepolitica';
        this.urlPoliticaList = this.environment.urlAmbiente + '/apiPoliticaMT/politicaList';
        this.urlPoliticaAdd = this.environment.urlAmbiente + '/apiPoliticaMT/politicaAdd';
        this.urlPoliticaUpd = this.environment.urlAmbiente + '/apiPoliticaMT/politicaUpd';
    }
    /**
     * @param {?} _body
     * @return {?}
     */
    PoliticaService.prototype.doPolitica = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlPolitica, _body, httpOptions$e);
    };
    /**
     * @param {?} _body
     * @return {?}
     */
    PoliticaService.prototype.postPoliticaList = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlPoliticaList, _body, httpOptions$e);
    };
    /**
     * @param {?} _body
     * @return {?}
     */
    PoliticaService.prototype.postPoliticaAdd = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlPoliticaAdd, _body, httpOptions$e);
    };
    /**
     * @param {?} _body
     * @return {?}
     */
    PoliticaService.prototype.postPoliticaUpd = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlPoliticaUpd, _body, httpOptions$e);
    };
    PoliticaService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    PoliticaService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    /** @nocollapse */ PoliticaService.ngInjectableDef = defineInjectable({ factory: function PoliticaService_Factory() { return new PoliticaService(inject(HttpClient), inject("env")); }, token: PoliticaService, providedIn: "root" });
    return PoliticaService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* Nodo para tarea pendiente, contiene el ID Servicio Empresa */
var /* Nodo para tarea pendiente, contiene el ID Servicio Empresa */
TodoItemNode = /** @class */ (function () {
    function TodoItemNode() {
    }
    return TodoItemNode;
}());
/* Nodo de tarea plana con información ampliable y de nivel, contiene el ID Servicio Empresa*/
var /* Nodo de tarea plana con información ampliable y de nivel, contiene el ID Servicio Empresa*/
TodoItemFlatNode = /** @class */ (function () {
    function TodoItemFlatNode() {
    }
    return TodoItemFlatNode;
}());
var ɵ0$h = MAT_MOMENT_DATE_FORMATS;
var PerfilesAddComponent = /** @class */ (function () {
    function PerfilesAddComponent(perfilesService, politicaService, router, route, modalService, environment, dialog, loader) {
        var _this = this;
        this.perfilesService = perfilesService;
        this.politicaService = politicaService;
        this.router = router;
        this.route = route;
        this.modalService = modalService;
        this.environment = environment;
        this.dialog = dialog;
        this.loader = loader;
        this.peticionServEmp = new ServEmpresaPeticion();
        this.peticionPoliticaList = new PoliticaListPeticion();
        this.peticionPerfilesAdd = new PerfilesAddPeticion();
        /* Mapa del nodo plano al nodo anidado. Ayuda a encontrar el nodo anidado a modificar */
        this.flatNodeMap = new Map();
        /* Mapa del nodo anidado al nodo aplanado. Ayuda a mantener el mismo objeto para la selección */
        this.nestedNodeMap = new Map();
        /* La selección para la lista de verificación. Ayuda a determinar cuales nodos estan seleccionados */
        this.checklistSelection = new SelectionModel(true /* multiple */);
        this.dataChange = new BehaviorSubject([]);
        /* Código usado para pintar el arbol de servicios usando mat-tree */
        this.getLevel = (/**
         * @param {?} node
         * @return {?}
         */
        function (node) { return node.level; });
        this.isExpandable = (/**
         * @param {?} node
         * @return {?}
         */
        function (node) { return node.expandable; });
        this.idSerEmp = (/**
         * @param {?} node
         * @return {?}
         */
        function (node) { return node.idServEmpFlat; });
        this.url = (/**
         * @param {?} node
         * @return {?}
         */
        function (node) { return node.url; });
        this.getChildren = (/**
         * @param {?} node
         * @return {?}
         */
        function (node) { return node.children; });
        this.hasChild = (/**
         * @param {?} _
         * @param {?} _nodeData
         * @return {?}
         */
        function (_, _nodeData) { return _nodeData.expandable; });
        this.hasNoContent = (/**
         * @param {?} _
         * @param {?} _nodeData
         * @return {?}
         */
        function (_, _nodeData) { return _nodeData.item === ''; });
        /* Transformador para convertir el nodo anidado en nodo plano. Registre los nodos en los mapas para su uso posterior. */
        this.transformer = (/**
         * @param {?} node
         * @param {?} level
         * @return {?}
         */
        function (node, level) {
            /** @type {?} */
            var existingNode = _this.nestedNodeMap.get(node);
            /** @type {?} */
            var flatNode = existingNode && existingNode.item === node.item ? existingNode : new TodoItemFlatNode();
            flatNode.item = node.item;
            flatNode.level = level;
            flatNode.expandable = (node.children && node.children.length > 0);
            flatNode.idServEmpFlat = node.idServEmpNode;
            flatNode.url = node.url;
            _this.flatNodeMap.set(flatNode, node);
            _this.nestedNodeMap.set(node, flatNode);
            return flatNode;
        });
        this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel, this.isExpandable, this.getChildren);
        this.treeControl = new FlatTreeControl(this.getLevel, this.isExpandable);
        this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idUsuario = this.userPerfil.usuario.idUsuario;
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        /* this.idUsuario = '2';
        this.docEmpresa = '97036000K';
        this.codTpoPortal = 'ADQUIRENTE'; */
    }
    Object.defineProperty(PerfilesAddComponent.prototype, "data", {
        get: /**
         * @return {?}
         */
        function () { return this.dataChange.value; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    PerfilesAddComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formGroup = new FormGroup({
            descPerfil: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(95), CustomValidators.descriptionValidator])),
            idPolitica: new FormControl('', Validators.required)
        });
        if (sessionStorage.getItem('toCrearPerfilesEmp') != null) {
            this.toCrearPerfilesEmp = JSON.parse(sessionStorage.getItem('toCrearPerfilesEmp'));
            this.camino = this.toCrearPerfilesEmp.camino;
        }
        if (this.camino == 'perfilesEmp') {
            this.docEmpresa = this.toCrearPerfilesEmp.docEmpresa;
        }
        this.peticionPoliticaList.codCliente = this.environment.codCliente;
        this.postPoliticaListServices(this.peticionPoliticaList);
        this.peticionServEmp.codCliente = this.environment.codCliente;
        this.peticionServEmp.docEmpresa = this.docEmpresa;
        this.postListServEmpServices(this.peticionServEmp);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    PerfilesAddComponent.prototype.postPerfilesAddServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.perfilesService.postPerfilesAdd(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.loader.hide();
                _this.showDialog('Información', 'Perfil agregado de forma satisfactoria.', false);
            }
            else {
                _this.loader.hide();
                _this.showDialogFail('Error', 'No ha sido posible agregar el perfil.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            _this.showDialogFail('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    PerfilesAddComponent.prototype.postPoliticaListServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.politicaService.postPoliticaList(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.politicasResultado = [];
                _this.politicasResultado.push(data);
            }
            else {
                _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    PerfilesAddComponent.prototype.postListServEmpServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.perfilesService.postListServEmp(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret = '0') {
                console.log(data);
                /** @type {?} */
                var dataServEmp = _this.buildFileTree(data.servicios.modulos, 0);
                _this.dataChange.next(dataServEmp);
                _this.dataSource.data = [];
                _this.dataSource.data = dataServEmp;
                console.log(data);
                console.log(dataServEmp);
            }
            else {
                _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /* Estructura que se le pasa al dataSource */
    /* Estructura que se le pasa al dataSource */
    /**
     * @param {?} obj
     * @param {?} level
     * @return {?}
     */
    PerfilesAddComponent.prototype.buildFileTree = /* Estructura que se le pasa al dataSource */
    /**
     * @param {?} obj
     * @param {?} level
     * @return {?}
     */
    function (obj, level) {
        var _this = this;
        return Object.keys(obj).reduce((/**
         * @param {?} accumulator
         * @param {?} key
         * @return {?}
         */
        function (accumulator, key) {
            /** @type {?} */
            var value = obj[key];
            /** @type {?} */
            var node = new TodoItemNode();
            node.item = obj[key]['dsc'];
            node.idServEmpNode = obj[key]['idServEmp'];
            node.url = obj[key]['url'];
            if (value != null) {
                if (typeof value === 'object') {
                    /** @type {?} */
                    var temp = value['menus'];
                    value.data = [];
                    value.data = temp;
                    if (value.data != null) {
                        node.children = _this.buildFileTree(value.data, level + 1);
                    }
                }
                else {
                    node.item = obj[key]['dsc'];
                }
            }
            return accumulator.concat(node);
        }), []);
    };
    /**
     * @return {?}
     */
    PerfilesAddComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.peticionPerfilesAdd.codCliente = this.environment.codCliente;
        this.peticionPerfilesAdd.idUsuario = this.idUsuario;
        this.peticionPerfilesAdd.docEmpresa = this.docEmpresa;
        this.peticionPerfilesAdd.codTpoPortal = this.codTpoPortal;
        this.peticionPerfilesAdd.descPerfil = this.formGroup.get('descPerfil').value;
        this.peticionPerfilesAdd.codEstadoPerfil = 'ACTIVO';
        this.peticionPerfilesAdd.idPolitica = this.formGroup.get('idPolitica').value;
        this.peticionPerfilesAdd.listIdServEmp = [];
        this.checklistSelection.selected.forEach((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            _this.peticionPerfilesAdd.listIdServEmp.push(item['idServEmpFlat']);
        }));
        /*  if (this.treeControl.expansionModel.selected.length != 0) {
           this.treeControl.expansionModel.selected.forEach(item => {
             let id: number = this.peticionPerfilesAdd.listIdServEmp.find(id => id == item['idServEmpFlat']);
             if (id == null) {
               this.peticionPerfilesAdd.listIdServEmp.push(item['idServEmpFlat']);
             }
           });
         } */
        if (this.peticionPerfilesAdd.listIdServEmp.length != 0) {
            this.showDialogPre('Información', 'Si realiza esta acción, agregará un nuevo perfil.<br>¿Está seguro?', true);
        }
        else {
            this.showDialogFail('Información', 'Seleccione los servicios de acceso.', false);
        }
    };
    /**
     * @return {?}
     */
    PerfilesAddComponent.prototype.toPerfiles = /**
     * @return {?}
     */
    function () {
        if (this.camino == 'perfilesEmp') {
            this.router.navigate(['../perfilListEmp'], { relativeTo: this.route });
        }
        else {
            this.router.navigate(['../perfilList'], { relativeTo: this.route });
        }
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    PerfilesAddComponent.prototype.showDialogPre = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            if (result) {
                _this.postPerfilesAddServices(_this.peticionPerfilesAdd);
            }
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    PerfilesAddComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            _this.toPerfiles();
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    PerfilesAddComponent.prototype.showDialogFail = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
        }));
    };
    /* Si se seleccionan todos los descendientes del nodo */
    /* Si se seleccionan todos los descendientes del nodo */
    /**
     * @param {?} node
     * @return {?}
     */
    PerfilesAddComponent.prototype.descendantsAllSelected = /* Si se seleccionan todos los descendientes del nodo */
    /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        var _this = this;
        /** @type {?} */
        var descendants = this.treeControl.getDescendants(node);
        /** @type {?} */
        var descAllSelected = descendants.every((/**
         * @param {?} child
         * @return {?}
         */
        function (child) { return _this.checklistSelection.isSelected(child); }));
        return descAllSelected;
    };
    /* Si parte de los descendientes están seleccionados */
    /* Si parte de los descendientes están seleccionados */
    /**
     * @param {?} node
     * @return {?}
     */
    PerfilesAddComponent.prototype.descendantsPartiallySelected = /* Si parte de los descendientes están seleccionados */
    /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        var _this = this;
        /** @type {?} */
        var descendants = this.treeControl.getDescendants(node);
        /** @type {?} */
        var result = descendants.some((/**
         * @param {?} child
         * @return {?}
         */
        function (child) { return _this.checklistSelection.isSelected(child); }));
        return result && !this.descendantsAllSelected(node);
    };
    /* Alternar la selección de tareas pendientes. Seleccionar / deseleccionar todos los nodos descendientes */
    /* Alternar la selección de tareas pendientes. Seleccionar / deseleccionar todos los nodos descendientes */
    /**
     * @param {?} node
     * @return {?}
     */
    PerfilesAddComponent.prototype.todoItemSelectionToggle = /* Alternar la selección de tareas pendientes. Seleccionar / deseleccionar todos los nodos descendientes */
    /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        var _this = this;
        var _a, _b;
        //this.checklistSelection.toggle(node);
        /** @type {?} */
        var nodeSelected = this.checklistSelection.isSelected(node);
        /** @type {?} */
        var descendants = this.treeControl.getDescendants(node);
        /** @type {?} */
        var descAllSelected = descendants.every((/**
         * @param {?} child
         * @return {?}
         */
        function (child) { return _this.checklistSelection.isSelected(child); }));
        if (nodeSelected && descAllSelected) {
            this.checklistSelection.deselect(node);
        }
        if (!nodeSelected && !descAllSelected) {
            this.checklistSelection.select(node);
        }
        this.checklistSelection.isSelected(node) ? (_a = this.checklistSelection).select.apply(_a, __spread(descendants)) : (_b = this.checklistSelection).deselect.apply(_b, __spread(descendants));
        /* Forzar actualización para el padre */
        descendants.every((/**
         * @param {?} child
         * @return {?}
         */
        function (child) { return _this.checklistSelection.isSelected(child); }));
        this.checkAllParentsSelection(node);
    };
    /* Alternar una selección de elementos de tareas pendientes de hoja. Verifique a todos los padres para ver si cambiaron */
    /* Alternar una selección de elementos de tareas pendientes de hoja. Verifique a todos los padres para ver si cambiaron */
    /**
     * @param {?} node
     * @return {?}
     */
    PerfilesAddComponent.prototype.todoLeafItemSelectionToggle = /* Alternar una selección de elementos de tareas pendientes de hoja. Verifique a todos los padres para ver si cambiaron */
    /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        this.checklistSelection.toggle(node);
        /** @type {?} */
        var hermanos = this.getHermanoNode(node);
        if (node.url == 'reutilizarDetalle' || node.url == 'reutilizarBorradorDetalle' || node.url == 'usuariosList' || node.url == 'usuariosLst' || node.url == 'perfilList' || node.url == 'perfilListEmp' || node.url == 'politicaList' || node.url == 'empresasList') {
            if (!this.checklistSelection.isSelected(node)) {
                if (hermanos != null) {
                    for (var index = 0; index < hermanos.length; index++) {
                        this.checklistSelection.deselect(hermanos[index]);
                    }
                }
            }
            else {
                if (node.url == 'reutilizarDetalle' || node.url == 'reutilizarBorradorDetalle') {
                    if (hermanos != null) {
                        for (var index = 0; index < hermanos.length; index++) {
                            this.checklistSelection.select(hermanos[index]);
                        }
                    }
                }
            }
        }
        else {
            if (this.checklistSelection.isSelected(node)) {
                if (hermanos != null) {
                    for (var index = 0; index < hermanos.length; index++) {
                        if (hermanos[index].url == 'usuariosList' || hermanos[index].url == 'usuariosLst' || hermanos[index].url == 'perfilList' || hermanos[index].url == 'perfilListEmp' || hermanos[index].url == 'politicaList' || hermanos[index].url == 'empresasList') {
                            this.checklistSelection.select(hermanos[index]);
                        }
                    }
                }
            }
        }
        this.checkAllParentsSelection(node);
    };
    /**
     * @param {?} node
     * @return {?}
     */
    PerfilesAddComponent.prototype.getHermanoNode = /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        /** @type {?} */
        var nodes = [];
        /** @type {?} */
        var currentLevel = this.getLevel(node);
        if (currentLevel < 1) {
            return null;
        }
        /** @type {?} */
        var startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
        for (var i = startIndex; i >= 0; i--) {
            /** @type {?} */
            var currentNode = this.treeControl.dataNodes[i];
            if (this.getLevel(currentNode) == currentLevel) {
                nodes.push(currentNode);
            }
            else {
                /** @type {?} */
                var startIndex2 = this.treeControl.dataNodes.indexOf(node) + 1;
                for (var i_1 = startIndex2; i_1 >= 0; i_1++) {
                    /** @type {?} */
                    var currentNode_1 = this.treeControl.dataNodes[i_1];
                    if (this.getLevel(currentNode_1) == currentLevel) {
                        nodes.push(currentNode_1);
                    }
                    else {
                        return nodes;
                    }
                }
            }
        }
        return nodes;
    };
    /* Comprueba todos los padres cuando un nodo hoja está seleccionado / no seleccionado */
    /* Comprueba todos los padres cuando un nodo hoja está seleccionado / no seleccionado */
    /**
     * @param {?} node
     * @return {?}
     */
    PerfilesAddComponent.prototype.checkAllParentsSelection = /* Comprueba todos los padres cuando un nodo hoja está seleccionado / no seleccionado */
    /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        /** @type {?} */
        var parent = this.getParentNode(node);
        while (parent) {
            this.checkRootNodeSelection(parent);
            parent = this.getParentNode(parent);
        }
    };
    /**
     * @param {?} node
     * @return {?}
     */
    PerfilesAddComponent.prototype.checkRootNodeSelection = /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        var _this = this;
        /** @type {?} */
        var nodeSelected = this.checklistSelection.isSelected(node);
        /** @type {?} */
        var descendants = this.treeControl.getDescendants(node);
        /** @type {?} */
        var descAllSelected = descendants.every((/**
         * @param {?} child
         * @return {?}
         */
        function (child) { return _this.checklistSelection.isSelected(child); }));
        /** @type {?} */
        var descSomeSelected = descendants.some((/**
         * @param {?} child
         * @return {?}
         */
        function (child) { return _this.checklistSelection.isSelected(child); }));
        if (nodeSelected && !descAllSelected) {
            this.checklistSelection.deselect(node);
        }
        else if (!nodeSelected && descAllSelected) {
            this.checklistSelection.select(node);
        }
        if (descSomeSelected) {
            this.checklistSelection.select(node);
            /** @type {?} */
            var id = this.checklistSelection.selected.find((/**
             * @param {?} id
             * @return {?}
             */
            function (id) { return id == node; }));
            if (id == null) {
                this.checklistSelection.select(node);
            }
        }
    };
    /* Obtener el nodo padre de un nodo */
    /* Obtener el nodo padre de un nodo */
    /**
     * @param {?} node
     * @return {?}
     */
    PerfilesAddComponent.prototype.getParentNode = /* Obtener el nodo padre de un nodo */
    /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        /** @type {?} */
        var currentLevel = this.getLevel(node);
        if (currentLevel < 1) {
            return null;
        }
        /** @type {?} */
        var startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
        for (var i = startIndex; i >= 0; i--) {
            /** @type {?} */
            var currentNode = this.treeControl.dataNodes[i];
            if (this.getLevel(currentNode) < currentLevel) {
                return currentNode;
            }
        }
        return null;
    };
    PerfilesAddComponent.decorators = [
        { type: Component, args: [{
                    selector: 'perfiles-add',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <!-- <h3 class=\"titulo-seccion\">Administraci\u00F3n de pol\u00EDticas</h3> -->\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a (click)=\"toPerfiles()\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <form [formGroup]=\"formGroup\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n        <h3>Agregar nuevo perfil</h3>\r\n        <div class=\"form-section\">\r\n          <h5>Datos</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-8\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"95\" placeholder=\"Descripci\u00F3n\" formControlName=\"descPerfil\">\r\n                <mat-error *ngIf=\"formGroup.get('descPerfil').invalid\">Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Pol\u00EDtica\" formControlName=\"idPolitica\">\r\n                  <section *ngFor=\"let respPolitica of politicasResultado\">\r\n                    <mat-option *ngFor=\"let pol of respPolitica.resultado\" [value]=\"pol.idPol\">{{pol.dscPol}}</mat-option>\r\n                  </section>\r\n                </mat-select>\r\n                <mat-error *ngIf=\"formGroup.get('idPolitica').invalid\">Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-section\">\r\n          <h5>Seleccione los servicios de acceso</h5>\r\n          <br>\r\n          <mat-tree [dataSource]=\"dataSource\" [treeControl]=\"treeControl\">\r\n            <mat-tree-node style=\"margin-top: -18px\" *matTreeNodeDef=\"let node\" matTreeNodeToggle matTreeNodePadding>\r\n              <button mat-icon-button disabled></button>\r\n              <mat-checkbox class=\"checklist-leaf-node\" [checked]=\"checklistSelection.isSelected(node)\" (change)=\"todoLeafItemSelectionToggle(node)\">{{node.item}}</mat-checkbox>\r\n            </mat-tree-node>\r\n\r\n            <mat-tree-node style=\"margin-top: -18px\" *matTreeNodeDef=\"let node; when: hasChild\" matTreeNodePadding>\r\n              <button mat-icon-button matTreeNodeToggle [attr.aria-label]=\"'toggle ' + node.filename\">\r\n                <mat-icon class=\"mat-icon-rtl-mirror\">\r\n                  {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}\r\n                </mat-icon>\r\n              </button>\r\n              <mat-checkbox [checked]=\"descendantsAllSelected(node)\" [indeterminate]=\"descendantsPartiallySelected(node)\" (change)=\"todoItemSelectionToggle(node)\">{{node.item}}</mat-checkbox>\r\n            </mat-tree-node>\r\n          </mat-tree>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <!-- <div class=\"col align-left\">\r\n             <button class=\"btn text\" (click)=\"limpiar()\" type=\"reset\" [routerLink]=\"['../convenios']\"><i class=\"str-icon-flecha-izquierda\"></i>CANCELAR</button>\r\n          </div> -->\r\n          <div class=\"col align-right\">\r\n            <button *ngIf=\"formGroup.invalid\" class=\"btn main\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n            <button *ngIf=\"formGroup.valid\" class=\"btn main\" type=\"submit\" (click)=\"onSubmit()\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n\r\n  </div>\r\n</section>",
                    providers: [{ provide: MAT_DATE_LOCALE$1, useValue: 'es' },
                        { provide: DateAdapter$1, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE$1] },
                        { provide: MAT_DATE_FORMATS$1, useValue: ɵ0$h }, PoliticaService]
                }] }
    ];
    /** @nocollapse */
    PerfilesAddComponent.ctorParameters = function () { return [
        { type: PerfilesService },
        { type: PoliticaService },
        { type: Router },
        { type: ActivatedRoute },
        { type: NgbModal },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] },
        { type: MatDialog },
        { type: LoaderBaseService }
    ]; };
    return PerfilesAddComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PerfilesListPeticion = /** @class */ (function () {
    function PerfilesListPeticion() {
        this.idPerfil = '-1';
        this.descPerfil = '-1';
        this.codEstadoPerfil = '-1';
        this.docEmpresa = '-1';
        this.idPolitica = '-1';
        this.codCliente = '-1';
        this.muestraCliente = '-1';
        this.menuOption = '-1';
        this.codRubro = '-1';
        this.filtros = [];
    }
    return PerfilesListPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PerfilesListEmpComponent = /** @class */ (function () {
    function PerfilesListEmpComponent(perfilesService, politicaService, empresasService, serviceBaseService, phttpd, loader, environment, fb, dialog, router, route) {
        this.perfilesService = perfilesService;
        this.politicaService = politicaService;
        this.empresasService = empresasService;
        this.serviceBaseService = serviceBaseService;
        this.phttpd = phttpd;
        this.loader = loader;
        this.environment = environment;
        this.fb = fb;
        this.dialog = dialog;
        this.router = router;
        this.route = route;
        this.formGroup = new FormGroup({
            desPerfil: new FormControl(),
            estado: new FormControl('-1'),
            idPolitica: new FormControl('-1'),
            rubro: new FormControl('-1'),
            empresa: new FormControl({ value: '', disabled: false })
        });
        // Vistas variables
        this.vistaCantidad = 0;
        this.vistaEstado = 'Todos';
        this.vistaPol = 'Todos';
        this.vistaRubro = 'Todos';
        this.vistaEmpresa = 'Todos';
        this.hashCaminoMiga = [];
        this.perfilesListPeticion = new PerfilesListPeticion();
        this.mensajeError = -1;
        this.consulta = -1;
        this.isCollapsed = false;
        this.peticionPoliticaList = new PoliticaListPeticion();
        this.resultadoRubros = [];
        this.peticionEmpresa = new EmpresasPeticion();
        this.resultadoEmpresa = [];
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
        //this.docEmpresa = '761141430';
    }
    /**
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (sessionStorage.getItem('componenteHijo') != 'perfiles-upd-emp') {
            sessionStorage.removeItem('indice');
        }
        this.viewAgregar = this.serviceBaseService.validaAccesoMenu('perfilAdd');
        this.viewEditar = this.serviceBaseService.validaAccesoMenu('perfilUpd');
        if (this.viewEditar) {
            this.displayedColumns = ['desc', 'emp', 'politica', 'fechaAdd', 'fechaUpd', 'estado', 'editar'];
        }
        else {
            this.displayedColumns = ['desc', 'emp', 'politica', 'fechaAdd', 'fechaUpd', 'estado'];
        }
        sessionStorage.removeItem('toCrearPerfilesEmp');
        sessionStorage.setItem('toEditarPerfiles', JSON.stringify({
            camino: 'perfilesEmp'
        }));
        //this.formGroup.controls['empresa'].disable();
        this.consulta = -1;
        this.postPerfilesEstadosListServices();
        this.peticionPoliticaList.codCliente = this.environment.codCliente;
        this.postPoliticaListServices(this.peticionPoliticaList);
        this.postSentRubrosServices();
        this.postEmpresas();
        this.formGroup.controls.rubro.setValue("-1");
        this.formGroup.controls.empresa.reset('');
        this.formGroup.controls.estado.setValue('-1');
        this.formGroup.controls.idPolitica.setValue('-1');
        if (sessionStorage.getItem('componenteHijo') == 'perfiles-upd-emp') {
            this.consulta = 0;
            /** @type {?} */
            var llamadaPadre = JSON.parse(sessionStorage.getItem('llamadaPadre'));
            // Llena los filtros
            this.formGroup.controls['desPerfil'].setValue((llamadaPadre.descPerfil != '-1' ? llamadaPadre.descPerfil : ''));
            this.formGroup.controls['idPolitica'].setValue(llamadaPadre.idPolitica);
            this.formGroup.controls['estado'].setValue(llamadaPadre.codEstadoPerfil);
            this.formGroup.controls['rubro'].setValue(llamadaPadre.codRubro);
            if (this.formGroup.get('rubro').value != '-1') {
                this.peticionEmpresa.codRubro = llamadaPadre.codRubro;
                this.peticionEmpresa.codCliente = this.environment.codCliente;
                this.peticionEmpresa.codEstadoConvenio = 'HBL';
                this.formGroup.controls['empresa'].reset('');
                //this.postSentEmpresaServices(this.peticionEmpresa);
                this.postSentSelectEmpresaServices(this.peticionEmpresa);
                //this.formGroup.controls['empresa'].enable();
            }
            this.formGroup.controls['empresa'].setValue(llamadaPadre.docEmpresa);
            // Llena camino de migas
            /** @type {?} */
            var migasPadre = JSON.parse(sessionStorage.getItem('migasPadre'));
            this.vistaEstado = migasPadre.codEstadoPerfil;
            this.vistaPol = migasPadre.idPolitica;
            this.vistaRubro = migasPadre.codRubro;
            this.vistaEmpresa = migasPadre.docEmpresa;
            this.hashCaminoMiga[0] = { title: 'Descripción', text: migasPadre.descPerfil };
            this.hashCaminoMiga[1] = { title: 'Política', text: migasPadre.idPolitica };
            this.hashCaminoMiga[2] = { title: 'Estado', text: migasPadre.codEstadoPerfil };
            this.hashCaminoMiga[3] = { title: 'Rubro', text: migasPadre.codRubro };
            this.hashCaminoMiga[4] = { title: 'Empresa', text: migasPadre.docEmpresa };
            // Llama al servicio
            this.perfilesListPeticion.muestraCliente = llamadaPadre.muestraCliente;
            this.perfilesListPeticion.codCliente = llamadaPadre.codCliente;
            this.perfilesListPeticion.menuOption = llamadaPadre.menuOption;
            this.perfilesListPeticion.descPerfil = llamadaPadre.descPerfil;
            this.perfilesListPeticion.idPolitica = llamadaPadre.idPolitica;
            this.perfilesListPeticion.codEstadoPerfil = llamadaPadre.codEstadoPerfil;
            this.perfilesListPeticion.codRubro = llamadaPadre.codRubro;
            this.perfilesListPeticion.docEmpresa = llamadaPadre.docEmpresa;
            this.postPerfilesListServices(this.perfilesListPeticion);
        }
        else {
            this.setInitialBreadcrumbs();
        }
    };
    /**
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.setInitialBreadcrumbs = /**
     * @return {?}
     */
    function () {
        this.hashCaminoMiga[0] = { title: 'Descripción', text: '' };
        this.hashCaminoMiga[1] = { title: 'Política', text: 'Todos' };
        this.hashCaminoMiga[2] = { title: 'Estado', text: 'Todos' };
        this.hashCaminoMiga[3] = { title: 'Rubro', text: 'Todos' };
        this.hashCaminoMiga[4] = { title: 'Empresa', text: 'Todas' };
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.onPaginateChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var indice = this.paginator.pageIndex;
        sessionStorage.setItem('indice', indice);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.postPerfilesListServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.show = true;
        this.perfilesService.postPerfilesList(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.vistaCantidad = data.resultado.length;
                if (_this.paginator != undefined && sessionStorage.getItem('componenteHijo') == 'perfiles-upd-emp') {
                    _this.paginator.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indice')))));
                }
                else if (_this.paginator != undefined) {
                    _this.paginator.pageIndex = 0;
                    sessionStorage.removeItem("indice");
                }
                sessionStorage.removeItem('componenteHijo');
                _this.dataSource = new MatTableDataSource$1(data.resultado);
                _this.dataSource.paginator = _this.paginator;
                _this.dataSource.sort = _this.sort;
                if (_this.vistaCantidad == 0) {
                    _this.show = false;
                    _this.isCollapsed = false;
                }
                else {
                    _this.isCollapsed = true;
                }
                _this.mensajeError = 0;
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.mensajeError = 1;
                _this.loader.hide();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            _this.mensajeError = 1;
            _this.loader.hide();
        }));
    };
    /**
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.postPerfilesEstadosListServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.perfilesService.postPerfilesEstados().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var todos = JSON.parse('{"idEstadoPerfil":"-1","codEstadoPerfil":"-1","descEstadoPefil":"Todos"}');
                _this.perfilesEstadosResultados = [];
                data.resultado.splice(0, 0, todos);
                _this.perfilesEstadosResultados.push(data);
                console.log(data);
            }
            else {
                console.error('Error postPerfilesEstados: ' + data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postPerfilesEstados: ' + err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.postPoliticaListServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.politicaService.postPoliticaList(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.politicasResultado = [];
                /** @type {?} */
                var todos = JSON.parse('{"idPol":"-1","idClt":"1","dscPol":"Todas","accMulUsrPol":"","canCarMinPwdPol":"","canHstPwdPol":"","canLetMayPwdPol":"","canLetMinPwdPol":"","canMinBlqUsr":"","canMinExpSes":"","canNumMinPwdPol":"","diaExpPwdPol":"","lrgMaxPwdPol":"","lrgMinPwdPol":"","maxIntPwdPol":"","fecAddPol":"","fecUpdPol":"","codClt":"","docClt":"","razSocClt":""}');
                data.resultado.splice(0, 0, todos);
                _this.politicasResultado.push(data);
                console.log(data);
            }
            else {
                console.error('Error postPoliticaList: ' + data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postPoliticaList: ' + err);
        }));
    };
    /**
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.postSentRubrosServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var param = new RubroRequest();
        param.codEstadoConvenio = 'HBL';
        this.empresasService.postRubrosReport(param).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var rub = new RubroResult();
                rub.codigo = '-1';
                rub.descripcion = "Todos";
                data.resultado.splice(0, 0, rub);
                _this.resultadoRubros = data.resultado;
            }
            else {
                console.error('Error postRubrosReport: ' + data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postRubrosReport: ' + err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.onRubroSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event != null) {
            this.vistaRubro = event.source.selected._element.nativeElement.innerText.trim();
            this.peticionEmpresa.codRubro = event.value;
            this.peticionEmpresa.codCliente = this.environment.codCliente;
            this.peticionEmpresa.codEstadoConvenio = 'HBL';
            //this.postSentEmpresaServices(this.peticionEmpresa);
            this.postSentSelectEmpresaServices(this.peticionEmpresa);
            this.formGroup.controls['empresa'].reset('');
            //this.formGroup.controls['empresa'].enable();
        }
    };
    /**
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.postEmpresas = /**
     * @return {?}
     */
    function () {
        this.peticionEmpresa.codRubro = '-1';
        this.peticionEmpresa.codCliente = this.environment.codCliente;
        this.peticionEmpresa.codEstadoConvenio = 'HBL';
        //this.postSentEmpresaServices(this.peticionEmpresa);    
        this.postSentSelectEmpresaServices(this.peticionEmpresa);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.empresasService.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var empresaResult = new EmpresaResult();
                empresaResult.idFacturador = -1;
                empresaResult.nomFacturador = "Todas";
                data.resultado.splice(0, 0, empresaResult);
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.error('Error postListarEmpresas: ' + data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postListarEmpresas: ', err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.postSentSelectEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.empresasService.postListarSelectEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var empresaResult = new EmpresaResult();
                empresaResult.idFacturador = -1;
                empresaResult.nomFacturador = "Todas";
                data.resultado.splice(0, 0, empresaResult);
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.log('Error: ', 'postListarSelectEmpresas ' + data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error("Error postListarSelectEmpresas: ", err);
        }));
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.consulta = 0;
        this.perfilesListPeticion.muestraCliente = this.docEmpresa;
        this.perfilesListPeticion.codCliente = this.environment.codCliente;
        this.perfilesListPeticion.menuOption = 'perfilesEmp';
        if (this.formGroup.get('desPerfil').value == null || this.formGroup.get('desPerfil').value == '') {
            this.perfilesListPeticion.descPerfil = '-1';
            this.hashCaminoMiga[0] = { title: 'Descripción', text: '' };
        }
        else {
            this.perfilesListPeticion.descPerfil = this.formGroup.get('desPerfil').value;
            this.hashCaminoMiga[0] = { title: 'Descripción', text: this.formGroup.get('desPerfil').value };
        }
        if (this.formGroup.get('idPolitica').value == null || this.formGroup.get('idPolitica').value == '-1') {
            this.perfilesListPeticion.idPolitica = '-1';
            this.hashCaminoMiga[1] = { title: 'Política', text: 'Todos' };
        }
        else {
            this.perfilesListPeticion.idPolitica = this.formGroup.get('idPolitica').value;
            this.hashCaminoMiga[1] = { title: 'Política', text: this.vistaPol };
        }
        if (this.formGroup.get('estado').value == null || this.formGroup.get('estado').value == '-1') {
            this.perfilesListPeticion.codEstadoPerfil = '-1';
            this.hashCaminoMiga[2] = { title: 'Estado', text: 'Todos' };
        }
        else {
            this.perfilesListPeticion.codEstadoPerfil = this.formGroup.get('estado').value;
            this.hashCaminoMiga[2] = { title: 'Estado', text: this.vistaEstado };
        }
        if (this.formGroup.get('rubro').value == null || this.formGroup.get('rubro').value == '-1') {
            this.perfilesListPeticion.codRubro = '-1';
            this.hashCaminoMiga[3] = { title: 'Rubro', text: 'Todos' };
        }
        else {
            this.perfilesListPeticion.codRubro = this.formGroup.get('rubro').value;
            this.hashCaminoMiga[3] = { title: 'Rubro', text: this.vistaRubro };
        }
        if (this.formGroup.get('empresa').value == null || this.formGroup.get('empresa').value == '' || this.formGroup.get('empresa').value == -1) {
            this.perfilesListPeticion.docEmpresa = '-1';
            this.hashCaminoMiga[4] = { title: 'Empresa', text: 'Todas' };
        }
        else {
            this.perfilesListPeticion.docEmpresa = this.formGroup.get('empresa').value;
            this.hashCaminoMiga[4] = { title: 'Empresa', text: this.vistaEmpresa };
        }
        sessionStorage.setItem('llamadaPadre', JSON.stringify({
            muestraCliente: this.perfilesListPeticion.muestraCliente,
            codCliente: this.perfilesListPeticion.codCliente,
            menuOption: this.perfilesListPeticion.menuOption,
            descPerfil: this.perfilesListPeticion.descPerfil,
            idPolitica: this.perfilesListPeticion.idPolitica,
            codEstadoPerfil: this.perfilesListPeticion.codEstadoPerfil,
            codRubro: this.perfilesListPeticion.codRubro,
            docEmpresa: this.perfilesListPeticion.docEmpresa
        }));
        sessionStorage.setItem('migasPadre', JSON.stringify({
            descPerfil: this.hashCaminoMiga[0].text,
            idPolitica: this.hashCaminoMiga[1].text,
            codEstadoPerfil: this.hashCaminoMiga[2].text,
            codRubro: this.hashCaminoMiga[3].text,
            docEmpresa: this.hashCaminoMiga[4].text
        }));
        if (tipo == 'excel' || tipo == 'pdf') {
            this.perfilesListPeticion.filtros = this.hashCaminoMiga;
            this.postDownloadReportFile(this.perfilesListPeticion, tipo);
        }
        else {
            this.postPerfilesListServices(this.perfilesListPeticion);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.onEstadoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEstado = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.onPoliticaSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaPol = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.onEmpresaSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEmpresa = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.formGroup.get('rubro').setValue("-1");
        this.formGroup.get('empresa').reset('');
        this.formGroup.get('estado').setValue('-1');
        this.formGroup.get('idPolitica').setValue('-1');
        this.formGroup.get('desPerfil').setValue('');
        this.postEmpresas();
        this.perfilesListPeticion.descPerfil = '-1';
        this.perfilesListPeticion.codEstadoPerfil = '-1';
        this.perfilesListPeticion.idPolitica = '-1';
        this.perfilesListPeticion.docEmpresa = '-1';
        this.setInitialBreadcrumbs();
        this.consulta = -1;
        this.vistaCantidad = 0;
        this.show = false;
        this.isCollapsed = false;
        this.mensajeError = -1;
        this.dataSource = new MatTableDataSource$1([]);
    };
    /**
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.toCrearPerfiles = /**
     * @return {?}
     */
    function () {
        this.showDialogToEmp('Seleccione la Empresa', 'El perfil se crea para la empresa seleccionada.', true);
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.showDialogToEmp = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogToUserEmpComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            if (result) {
                sessionStorage.setItem('toCrearPerfilesEmp', JSON.stringify({
                    docEmpresa: dialogRef.componentInstance.formGroup.get('empresa').value,
                    camino: 'perfilesEmp'
                }));
                _this.router.navigate(['../perfilAdd'], { relativeTo: _this.route });
            }
        }));
    };
    /**
     * @param {?} filtro
     * @param {?} tipoReporte
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipoReporte
     * @return {?}
     */
    function (filtro, tipoReporte) {
        var _this = this;
        /** @type {?} */
        var url = '/apiPerfilesMT/perfilesList/' + tipoReporte;
        this.phttpd.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipoReporte == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'listadoPerfiles' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'listadoPerfiles' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
            console.log(err);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
        }));
    };
    /**
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.onSubmit('');
        }
    };
    /**
     * @return {?}
     */
    PerfilesListEmpComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('componenteHijo');
    };
    PerfilesListEmpComponent.decorators = [
        { type: Component, args: [{
                    selector: 'perfiles-list-emp',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"seccion-titulo-boton\">\r\n      <div class=\"row\">\r\n        <div class=\"col\" *ngIf=\"viewAgregar && mensajeError != 1\">\r\n          <a class=\"boton-seccion btn-small main\" (click)=\"toCrearPerfiles()\"><i class=\"str-icon-mas\"></i>Agregar perfil</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"modulo-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n      </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"formGroup\" (ngSubmit)=\"validarForm()\" autocomplete=\"off\">\r\n              <div class=\"form-row\">\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <input noCaracEsp matInput maxlength=\"40\" placeholder=\"Descripci\u00F3n\" formControlName=\"desPerfil\">\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Pol\u00EDtica\" formControlName=\"idPolitica\" (selectionChange)=\"onPoliticaSelect($event)\">\r\n                      <section *ngFor=\"let respPolitica of politicasResultado\">\r\n                        <mat-option *ngFor=\"let pol of respPolitica.resultado\" [value]=\"pol.idPol\">{{pol.dscPol}}</mat-option>\r\n                      </section>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estado\" (selectionChange)=\"onEstadoSelect($event)\">\r\n                      <section *ngFor=\"let perfilesEstados of perfilesEstadosResultados\">\r\n                        <mat-option *ngFor=\"let estados of perfilesEstados.resultado\" [value]=\"estados.codEstadoPerfil\">{{estados.descEstadoPefil}}\r\n                        </mat-option>\r\n                      </section>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-row\">\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Rubro\" formControlName=\"rubro\" (selectionChange)=\"onRubroSelect($event)\">\r\n                      <mat-option *ngFor=\"let rubro of resultadoRubros\" [value]=\"rubro.codigo\">{{rubro.descripcion}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"empresa\" (selectionChange)=\"onEmpresaSelect($event)\">\r\n                      <mat-option *ngFor=\"let empresa of resultadoEmpresa\" [value]=\"empresa.docFacturador\">{{empresa.nomFacturador}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"actions\">\r\n                <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\">Filtrar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"resultados-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-10\">\r\n          <div class=\"tags row\">\r\n            <div *ngFor=\"let entry of hashCaminoMiga\" class=\"item\">{{entry.title}}: {{entry.text}}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n          <div class=\"numero-resultados\">\r\n            <strong>{{ (vistaCantidad == 1) ? ( vistaCantidad + \" Resultado\") : vistaCantidad + \" Resultados\" }}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-container table-responsive-md\">\r\n        <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n          <ng-container matColumnDef=\"desc\">\r\n            <th mat-header-cell *matHeaderCellDef>Descripci\u00F3n</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.descPerfil}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"politica\">\r\n            <th mat-header-cell *matHeaderCellDef>Pol\u00EDtica</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.descPolitica}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"emp\">\r\n            <th mat-header-cell *matHeaderCellDef>Empresa</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.nomEmpresa}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fechaAdd\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha Ingreso</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.fecAdd | date: 'dd/MM/yyyy'}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fechaUpd\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha Actualizaci\u00F3n</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              {{(resultado.fecUpd !== 'null') ? (resultado.fecUpd | date: 'dd/MM/yyyy') : \"-\" }}\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"estado\">\r\n            <th mat-header-cell *matHeaderCellDef>Estado</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.descEstadoPerfil}} </td>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"viewEditar\" matColumnDef=\"editar\">\r\n            <th mat-header-cell *matHeaderCellDef>Editar</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a matTooltip=\"Editar perfil\" matTooltipPosition=\"above\" Style=\"cursor: pointer;\" [routerLink]=\"['../perfilUpd']\" [queryParams]=\"{'a':resultado.idPerfil,'b':resultado.docEmpresa}\"><i class=\"icon str-icon-lapiz\"></i></a>\r\n            </td>\r\n          </ng-container>\r\n\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n        </table>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" (page)=\"onPaginateChange($event)\" showFirstLastButtons></mat-paginator>\r\n      </div>\r\n\r\n      <div class=\"box-actions\" *ngIf=\"vistaCantidad > 0\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6 item\">\r\n            <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n          </div>\r\n          <div class=\"col-md-6 item-right\">\r\n            <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </section>\r\n\r\n    <div class=\"modulo-cuentas\" *ngIf=\"mensajeError == 0 && vistaCantidad == 0\">\r\n      <span>\r\n        No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.\r\n      </span>\r\n    </div>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"consulta == -1\">\r\n      <span>\r\n        Establezca sus criterios de b&uacute;squeda.\r\n      </span>\r\n    </div>\r\n\r\n  </div>\r\n</section>\r\n\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div *ngIf=\"mensajeError == 1\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" id=\"modal-basic-title\" style=\"color:#ec0000;font-weight: bold\">Error</h3>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <p>Servicio temporalmente no disponible.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [DescargaExcelPdfFileService, PoliticaService, EmpresasService]
                }] }
    ];
    /** @nocollapse */
    PerfilesListEmpComponent.ctorParameters = function () { return [
        { type: PerfilesService },
        { type: PoliticaService },
        { type: EmpresasService },
        { type: ServicesBaseService },
        { type: DescargaExcelPdfFileService },
        { type: LoaderBaseService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] },
        { type: FormBuilder },
        { type: MatDialog },
        { type: Router },
        { type: ActivatedRoute }
    ]; };
    PerfilesListEmpComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator$1,] }],
        sort: [{ type: ViewChild, args: [MatSort,] }]
    };
    return PerfilesListEmpComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PerfilesEstado = /** @class */ (function () {
    function PerfilesEstado() {
        this.idEstadoPerfil = "";
        this.codEstadoPerfil = "";
        this.descEstadoPefil = "";
    }
    return PerfilesEstado;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PoliticaEstado = /** @class */ (function () {
    function PoliticaEstado() {
        this.idPol = "";
        this.idClt = "";
        this.dscPol = "";
        this.accMulUsrPol = "";
        this.canCarMinPwdPol = "";
        this.canHstPwdPol = "";
        this.canLetMayPwdPol = "";
        this.canLetMinPwdPol = "";
        this.canMinBlqUsr = "";
        this.canMinExpSes = "";
        this.canNumMinPwdPol = "";
        this.diaExpPwdPol = "";
        this.lrgMaxPwdPol = "";
        this.lrgMinPwdPol = "";
        this.maxIntPwdPol = "";
        this.fecAddPol = "";
        this.fecUpdPol = "";
        this.codClt = "";
        this.docClt = "";
        this.razSocClt = "";
    }
    return PoliticaEstado;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PerfilesListComponent = /** @class */ (function () {
    function PerfilesListComponent(perfilesService, politicaService, serviceBaseService, phttpd, loader, environment, dialog) {
        this.perfilesService = perfilesService;
        this.politicaService = politicaService;
        this.serviceBaseService = serviceBaseService;
        this.phttpd = phttpd;
        this.loader = loader;
        this.environment = environment;
        this.dialog = dialog;
        // Vistas variables
        this.vistaCantidad = 0;
        this.vistaEstado = 'Todos';
        this.vistaPol = 'Todos';
        this.hashCaminoMiga = [];
        this.perfilesListPeticion = new PerfilesListPeticion();
        this.viewAgregar = true;
        this.viewEditar = true;
        this.mensajeError = -1;
        this.consulta = -1;
        this.isCollapsed = false;
        this.peticionPoliticaList = new PoliticaListPeticion();
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
        /* this.docEmpresa = '97036000K'; */
    }
    /**
     * @return {?}
     */
    PerfilesListComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (sessionStorage.getItem('componenteHijo') != 'perfiles-upd') {
            sessionStorage.removeItem('indice');
        }
        this.formGroup = new FormGroup({
            desPerfil: new FormControl(),
            estado: new FormControl('-1'),
            idPolitica: new FormControl('-1')
        });
        this.viewAgregar = this.serviceBaseService.validaAccesoMenu('perfilAdd');
        this.viewEditar = this.serviceBaseService.validaAccesoMenu('perfilUpd');
        if (this.viewEditar) {
            this.displayedColumns = ['desc', 'politica', 'fechaAdd', 'fechaUpd', 'estado', 'editar'];
        }
        else {
            this.displayedColumns = ['desc', 'politica', 'fechaAdd', 'fechaUpd', 'estado'];
        }
        sessionStorage.removeItem('toCrearPerfilesEmp');
        sessionStorage.setItem('toEditarPerfiles', JSON.stringify({
            camino: 'perfiles'
        }));
        this.consulta = -1;
        this.postPerfilesEstadosListServices();
        this.peticionPoliticaList.codCliente = this.environment.codCliente;
        this.postPoliticaListServices(this.peticionPoliticaList);
        if (sessionStorage.getItem('componenteHijo') == 'perfiles-upd') {
            this.consulta = 0;
            /** @type {?} */
            var llamadaPadre = JSON.parse(sessionStorage.getItem('llamadaPadre'));
            // Llena los filtros
            this.formGroup.controls['desPerfil'].setValue((llamadaPadre.descPerfil != '-1' ? llamadaPadre.descPerfil : ''));
            this.formGroup.controls['idPolitica'].setValue(llamadaPadre.idPolitica);
            this.formGroup.controls['estado'].setValue(llamadaPadre.codEstadoPerfil);
            // Llena camino de migas
            /** @type {?} */
            var migasPadre = JSON.parse(sessionStorage.getItem('migasPadre'));
            this.vistaPol = migasPadre.idPolitica;
            this.vistaEstado = migasPadre.codEstadoPerfil;
            this.hashCaminoMiga[0] = { title: 'Descripción', text: migasPadre.descPerfil };
            this.hashCaminoMiga[1] = { title: 'Política', text: migasPadre.idPolitica };
            this.hashCaminoMiga[2] = { title: 'Estado', text: migasPadre.codEstadoPerfil };
            // Llama al servicio
            this.perfilesListPeticion.docEmpresa = llamadaPadre.docEmpresa;
            this.perfilesListPeticion.codCliente = llamadaPadre.codCliente;
            this.perfilesListPeticion.muestraCliente = llamadaPadre.muestraCliente;
            this.perfilesListPeticion.menuOption = llamadaPadre.menuOption;
            this.perfilesListPeticion.descPerfil = llamadaPadre.descPerfil;
            this.perfilesListPeticion.idPolitica = llamadaPadre.idPolitica;
            this.perfilesListPeticion.codEstadoPerfil = llamadaPadre.codEstadoPerfil;
            this.postPerfilesListServices(this.perfilesListPeticion);
        }
        else {
            this.setInitialBreadcrumbs();
        }
    };
    /**
     * @return {?}
     */
    PerfilesListComponent.prototype.setInitialBreadcrumbs = /**
     * @return {?}
     */
    function () {
        this.hashCaminoMiga[0] = { title: 'Descripción', text: '' };
        this.hashCaminoMiga[1] = { title: 'Política', text: 'Todos' };
        this.hashCaminoMiga[2] = { title: 'Estado', text: 'Todos' };
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PerfilesListComponent.prototype.onPaginateChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var indice = this.paginator.pageIndex;
        sessionStorage.setItem('indice', indice);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    PerfilesListComponent.prototype.postPerfilesListServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.show = true;
        this.perfilesService.postPerfilesList(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.vistaCantidad = data.resultado.length;
                if (_this.paginator != undefined && sessionStorage.getItem('componenteHijo') == 'perfiles-upd') {
                    _this.paginator.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indice')))));
                }
                else if (_this.paginator != undefined) {
                    _this.paginator.pageIndex = 0;
                    sessionStorage.removeItem("indice");
                }
                sessionStorage.removeItem('componenteHijo');
                _this.dataSource = new MatTableDataSource$1(data.resultado);
                _this.dataSource.paginator = _this.paginator;
                _this.dataSource.sort = _this.sort;
                if (_this.vistaCantidad == 0) {
                    _this.show = false;
                    _this.isCollapsed = false;
                }
                else {
                    _this.isCollapsed = true;
                }
                _this.mensajeError = 0;
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.loader.hide();
                _this.mensajeError = 1;
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            _this.loader.hide();
            _this.mensajeError = 1;
        }));
    };
    /**
     * @return {?}
     */
    PerfilesListComponent.prototype.postPerfilesEstadosListServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.perfilesService.postPerfilesEstados().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var estados = new PerfilesEstado();
                estados.codEstadoPerfil = "-1";
                estados.descEstadoPefil = "Todos";
                estados.idEstadoPerfil = "Todos";
                data.resultado.splice(0, 0, estados);
                _this.perfilesEstadosResultados = [];
                _this.perfilesEstadosResultados.push(data);
            }
            else {
                console.error('Error postPerfilesEstados: ' + data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postPerfilesEstados: ' + err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    PerfilesListComponent.prototype.postPoliticaListServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.politicaService.postPoliticaList(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var politica = new PoliticaEstado();
                politica.dscPol = "Todas";
                politica.idPol = "-1";
                data.resultado.splice(0, 0, politica);
                _this.politicasResultado = [];
                _this.politicasResultado.push(data);
            }
            else {
                console.error('Error postPoliticaList: ' + data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postPoliticaList: ' + err);
        }));
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    PerfilesListComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.consulta = 0;
        this.perfilesListPeticion.docEmpresa = this.docEmpresa;
        this.perfilesListPeticion.codCliente = this.environment.codCliente;
        this.perfilesListPeticion.muestraCliente = '-1';
        this.perfilesListPeticion.menuOption = 'perfiles';
        if (this.formGroup.get('desPerfil').value == null || this.formGroup.get('desPerfil').value == '') {
            this.perfilesListPeticion.descPerfil = '-1';
            this.hashCaminoMiga[0] = { title: 'Descripción', text: '' };
        }
        else {
            this.perfilesListPeticion.descPerfil = this.formGroup.get('desPerfil').value;
            this.hashCaminoMiga[0] = { title: 'Descripción', text: this.formGroup.get('desPerfil').value };
        }
        if (this.formGroup.get('idPolitica').value == null) {
            this.perfilesListPeticion.idPolitica = '-1';
            this.hashCaminoMiga[1] = { title: 'Política', text: 'Todos' };
        }
        else {
            this.perfilesListPeticion.idPolitica = this.formGroup.get('idPolitica').value;
            this.hashCaminoMiga[1] = { title: 'Política', text: this.vistaPol };
        }
        if (this.formGroup.get('estado').value == null) {
            this.perfilesListPeticion.codEstadoPerfil = '-1';
            this.hashCaminoMiga[2] = { title: 'Estado', text: 'Todos' };
        }
        else {
            this.perfilesListPeticion.codEstadoPerfil = this.formGroup.get('estado').value;
            this.hashCaminoMiga[2] = { title: 'Estado', text: this.vistaEstado };
        }
        sessionStorage.setItem('llamadaPadre', JSON.stringify({
            docEmpresa: this.perfilesListPeticion.docEmpresa,
            codCliente: this.perfilesListPeticion.codCliente,
            muestraCliente: this.perfilesListPeticion.muestraCliente,
            menuOption: this.perfilesListPeticion.menuOption,
            descPerfil: this.perfilesListPeticion.descPerfil,
            idPolitica: this.perfilesListPeticion.idPolitica,
            codEstadoPerfil: this.perfilesListPeticion.codEstadoPerfil
        }));
        sessionStorage.setItem('migasPadre', JSON.stringify({
            descPerfil: this.hashCaminoMiga[0].text,
            idPolitica: this.hashCaminoMiga[1].text,
            codEstadoPerfil: this.hashCaminoMiga[2].text
        }));
        if (tipo == 'excel' || tipo == 'pdf') {
            this.perfilesListPeticion.filtros = this.hashCaminoMiga;
            this.postDownloadReportFile(this.perfilesListPeticion, tipo);
        }
        else {
            this.postPerfilesListServices(this.perfilesListPeticion);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PerfilesListComponent.prototype.onEstadoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEstado = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PerfilesListComponent.prototype.onPoliticaSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaPol = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @return {?}
     */
    PerfilesListComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.perfilesListPeticion.descPerfil = '-1';
        this.perfilesListPeticion.codEstadoPerfil = '-1';
        this.perfilesListPeticion.idPolitica = '-1';
        this.vistaCantidad = 0;
        this.mensajeError = -1;
        this.show = false;
        this.consulta = -1;
        this.formGroup.controls.estado.setValue('-1');
        this.formGroup.controls.idPolitica.setValue('-1');
        this.formGroup.controls.desPerfil.setValue('');
        this.dataSource = new MatTableDataSource$1([]);
        this.setInitialBreadcrumbs();
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    PerfilesListComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiPerfilesMT/perfilesList/' + tipo;
        this.phttpd.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'listadoPerfiles' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'listadoPerfiles' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
            console.log(err);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    PerfilesListComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
        }));
    };
    /**
     * @return {?}
     */
    PerfilesListComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.onSubmit('');
        }
    };
    /**
     * @return {?}
     */
    PerfilesListComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('componenteHijo');
    };
    PerfilesListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'perfiles-list',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"seccion-titulo-boton\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <!-- <h3 class=\"titulo-seccion\">Administraci\u00F3n de pol\u00EDticas</h3> -->\r\n        </div>\r\n        <div class=\"col\" *ngIf=\"viewAgregar && mensajeError != 1\">\r\n          <a class=\"boton-seccion btn-small main\" [routerLink]=\"['../perfilAdd']\"><i class=\"str-icon-mas\"></i>\r\n            Agregar perfil</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"modulo-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n      </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"formGroup\" (ngSubmit)=\"validarForm()\" autocomplete=\"off\">\r\n              <div class=\"form-row\">\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <input noCaracEsp matInput maxlength=\"40\" placeholder=\"Descripci\u00F3n\" formControlName=\"desPerfil\">\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Pol\u00EDtica\" formControlName=\"idPolitica\" (selectionChange)=\"onPoliticaSelect($event)\">\r\n                      <section *ngFor=\"let respPolitica of politicasResultado\">\r\n                        <mat-option *ngFor=\"let pol of respPolitica.resultado\" [value]=\"pol.idPol\">{{pol.dscPol}}</mat-option>\r\n                      </section>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estado\" (selectionChange)=\"onEstadoSelect($event)\">\r\n                      <section *ngFor=\"let perfilesEstados of perfilesEstadosResultados\">\r\n                        <mat-option *ngFor=\"let estados of perfilesEstados.resultado\" [value]=\"estados.codEstadoPerfil\">{{estados.descEstadoPefil}}\r\n                        </mat-option>\r\n                      </section>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"actions\">\r\n                <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\">Filtrar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"resultados-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-10\">\r\n          <div class=\"tags row\">\r\n            <div *ngFor=\"let entry of hashCaminoMiga\" class=\"item\">{{entry.title}}: {{entry.text}}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n          <div class=\"numero-resultados\">\r\n            <strong>{{ (vistaCantidad == 1) ? ( vistaCantidad + \" Resultado\") : vistaCantidad + \" Resultados\" }}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-container table-responsive-md\">\r\n        <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n          <ng-container matColumnDef=\"desc\">\r\n            <th mat-header-cell *matHeaderCellDef>Descripci\u00F3n</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.descPerfil}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"politica\">\r\n            <th mat-header-cell *matHeaderCellDef>Pol\u00EDtica</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.descPolitica}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fechaAdd\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha Ingreso</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.fecAdd | date: 'dd/MM/yyyy'}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fechaUpd\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha Actualizaci\u00F3n</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              {{(resultado.fecUpd !== 'null') ? (resultado.fecUpd | date: 'dd/MM/yyyy') : \"-\" }}\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"estado\">\r\n            <th mat-header-cell *matHeaderCellDef>Estado</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.descEstadoPerfil}} </td>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"viewEditar\" matColumnDef=\"editar\">\r\n            <th mat-header-cell *matHeaderCellDef>Editar</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a matTooltip=\"Editar perfil\" matTooltipPosition=\"above\" Style=\"cursor: pointer;\" [routerLink]=\"['../perfilUpd']\" [queryParams]=\"{'a':resultado.idPerfil,'b':resultado.docEmpresa}\"><i class=\"icon str-icon-lapiz\"></i></a>\r\n            </td>\r\n          </ng-container>\r\n\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n        </table>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" (page)=\"onPaginateChange($event)\" showFirstLastButtons></mat-paginator>\r\n      </div>\r\n\r\n      <div class=\"box-actions\" *ngIf=\"vistaCantidad > 0\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6 item\">\r\n            <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n          </div>\r\n          <div class=\"col-md-6 item-right\">\r\n            <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </section>\r\n\r\n    <div class=\"modulo-cuentas\" *ngIf=\"mensajeError == 0 && vistaCantidad == 0\">\r\n      <span>\r\n        No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.\r\n      </span>\r\n    </div>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"consulta == -1\">\r\n      <span>\r\n        Establezca sus criterios de b&uacute;squeda.\r\n      </span>\r\n    </div>\r\n\r\n  </div>\r\n</section>\r\n\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div *ngIf=\"mensajeError == 1\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" id=\"modal-basic-title\" style=\"color:#ec0000;font-weight: bold\">Error</h3>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <p>Servicio temporalmente no disponible.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [DescargaExcelPdfFileService, PoliticaService]
                }] }
    ];
    /** @nocollapse */
    PerfilesListComponent.ctorParameters = function () { return [
        { type: PerfilesService },
        { type: PoliticaService },
        { type: ServicesBaseService },
        { type: DescargaExcelPdfFileService },
        { type: LoaderBaseService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] },
        { type: MatDialog }
    ]; };
    PerfilesListComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator$1,] }],
        sort: [{ type: ViewChild, args: [MatSort,] }]
    };
    return PerfilesListComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PerfilesUpdPeticion = /** @class */ (function () {
    function PerfilesUpdPeticion() {
        this.codCliente = '-1';
        this.idUsuario = '-1';
        this.docEmpresa = '-1';
        this.codTpoPortal = '-1';
        this.idPerfil = -1;
        this.descPerfil = '-1';
        this.codEstadoPerfil = '-1';
        this.idPolitica = '-1';
        this.listIdServEmp = [];
    }
    return PerfilesUpdPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ServPerfilPeticion = /** @class */ (function () {
    function ServPerfilPeticion() {
        this.codCliente = '-1';
        this.docEmpresa = '-1';
        this.idPerfil = -1;
    }
    return ServPerfilPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PoliticaAddPeticion = /** @class */ (function () {
    function PoliticaAddPeticion() {
        this.codCliente = '-1';
        this.idUsuario = '-1';
        this.docEmpresa = '-1';
        this.codTpoPortal = '-1';
        this.dscPol = '-1';
        this.maxIntPwdPol = '-1';
        this.diaExpPwdPol = '-1';
        this.lrgMinPwdPol = '-1';
        this.lrgMaxPwdPol = '-1';
        this.canLetMayPwdPol = '-1';
        this.canLetMinPwdPol = '-1';
        this.canNumMinPwdPol = '-1';
        this.canCarMinPwdPol = '-1';
        this.canHstPwdPol = '-1';
        this.canMinBlqUsr = '-1';
        this.canMinExpSes = '-1';
        this.accMulUsrPol = '-1';
        this.canMaxGbalTokenSuscripcion = '-1';
        this.maxIntTokenSuscripcion = '-1';
    }
    return PoliticaAddPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* Nodo para tarea pendiente, contiene el ID Servicio Empresa */
var /* Nodo para tarea pendiente, contiene el ID Servicio Empresa */
TodoItemNode$1 = /** @class */ (function () {
    function TodoItemNode() {
    }
    return TodoItemNode;
}());
/* Nodo de tarea plana con información ampliable y de nivel, contiene el ID Servicio Empresa*/
var /* Nodo de tarea plana con información ampliable y de nivel, contiene el ID Servicio Empresa*/
TodoItemFlatNode$1 = /** @class */ (function () {
    function TodoItemFlatNode() {
    }
    return TodoItemFlatNode;
}());
var ɵ0$i = MAT_MOMENT_DATE_FORMATS;
var PerfilesUpdComponent = /** @class */ (function () {
    function PerfilesUpdComponent(perfilesService, politicaService, router, route, environment, dialog, loader) {
        var _this = this;
        this.perfilesService = perfilesService;
        this.politicaService = politicaService;
        this.router = router;
        this.route = route;
        this.environment = environment;
        this.dialog = dialog;
        this.loader = loader;
        this.peticionServEmp = new ServEmpresaPeticion();
        this.peticionServPerfil = new ServPerfilPeticion();
        this.peticionPoliticaAdd = new PoliticaAddPeticion();
        this.peticionPoliticaList = new PoliticaListPeticion();
        this.peticionPerfilesUpd = new PerfilesUpdPeticion();
        this.perfilesListPeticion = new PerfilesListPeticion();
        /* Mapa del nodo plano al nodo anidado. Ayuda a encontrar el nodo anidado a modificar */
        this.flatNodeMap = new Map();
        /* Mapa del nodo anidado al nodo aplanado. Ayuda a mantener el mismo objeto para la selección */
        this.nestedNodeMap = new Map();
        /* La selección para la lista de verificación. Ayuda a determinar cuales nodos estan seleccionados */
        this.checklistSelection = new SelectionModel(true /* multiple */);
        this.dataChange = new BehaviorSubject([]);
        this.items = [];
        /* Código usado para pintar el arbol de servicios usando mat-tree */
        this.getLevel = (/**
         * @param {?} node
         * @return {?}
         */
        function (node) { return node.level; });
        this.isExpandable = (/**
         * @param {?} node
         * @return {?}
         */
        function (node) { return node.expandable; });
        this.idSerEmp = (/**
         * @param {?} node
         * @return {?}
         */
        function (node) { return node.idServEmpFlat; });
        this.url = (/**
         * @param {?} node
         * @return {?}
         */
        function (node) { return node.url; });
        this.getChildren = (/**
         * @param {?} node
         * @return {?}
         */
        function (node) { return node.children; });
        this.hasChild = (/**
         * @param {?} _
         * @param {?} _nodeData
         * @return {?}
         */
        function (_, _nodeData) { return _nodeData.expandable; });
        this.hasNoContent = (/**
         * @param {?} _
         * @param {?} _nodeData
         * @return {?}
         */
        function (_, _nodeData) { return _nodeData.item === ''; });
        /* Transformador para convertir el nodo anidado en nodo plano. Registre los nodos en los mapas para su uso posterior. */
        this.transformer = (/**
         * @param {?} node
         * @param {?} level
         * @return {?}
         */
        function (node, level) {
            /** @type {?} */
            var existingNode = _this.nestedNodeMap.get(node);
            /** @type {?} */
            var flatNode = existingNode && existingNode.item === node.item ? existingNode : new TodoItemFlatNode$1();
            flatNode.item = node.item;
            flatNode.level = level;
            flatNode.expandable = (node.children && node.children.length > 0);
            flatNode.idServEmpFlat = node.idServEmpNode;
            flatNode.url = node.url;
            _this.flatNodeMap.set(flatNode, node);
            _this.nestedNodeMap.set(node, flatNode);
            return flatNode;
        });
        this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel, this.isExpandable, this.getChildren);
        this.treeControl = new FlatTreeControl(this.getLevel, this.isExpandable);
        this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idUsuario = this.userPerfil.usuario.idUsuario;
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        /* this.idUsuario = '1';
        this.docEmpresa = '968005707';
        this.codTpoPortal = 'COMERCIO'; */
    }
    Object.defineProperty(PerfilesUpdComponent.prototype, "data", {
        get: /**
         * @return {?}
         */
        function () { return this.dataChange.value; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    PerfilesUpdComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (sessionStorage.getItem('toEditarPerfiles') != null) {
            this.toEditarPerfiles = JSON.parse(sessionStorage.getItem('toEditarPerfiles'));
            this.camino = this.toEditarPerfiles.camino;
        }
        if (this.camino == 'perfiles') {
            sessionStorage.setItem('componenteHijo', 'perfiles-upd');
        }
        else {
            sessionStorage.setItem('componenteHijo', 'perfiles-upd-emp');
        }
        this.route.queryParams.subscribe((/**
         * @param {?} params
         * @return {?}
         */
        function (params) {
            _this.idPerfil = params['a'],
                _this.docEmpresa = params['b'];
        }));
        this.formGroup = new FormGroup({
            descPerfil: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(95), CustomValidators.descriptionValidator])),
            idPolitica: new FormControl('', Validators.required),
            codEstadoPerfil: new FormControl('', Validators.required)
        });
        this.postPerfilesEstadosListServices();
        this.peticionPoliticaList.codCliente = this.environment.codCliente;
        this.postPoliticaListServices(this.peticionPoliticaList);
        this.perfilesListPeticion.codCliente = this.environment.codCliente;
        this.perfilesListPeticion.docEmpresa = this.docEmpresa;
        this.perfilesListPeticion.idPerfil = this.idPerfil;
        this.postPerfilesListServices(this.perfilesListPeticion);
        /*    if (sessionStorage.getItem('toEditarPerfiles') != null) {
             this.toEditarPerfiles = JSON.parse(sessionStorage.getItem('toEditarPerfiles'));
             this.camino = this.toEditarPerfiles.camino;
           } */
        this.peticionServEmp.codCliente = this.environment.codCliente;
        this.peticionServEmp.docEmpresa = this.docEmpresa;
        this.postListServEmpServices(this.peticionServEmp);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    PerfilesUpdComponent.prototype.postPerfilesListServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.perfilesService.postPerfilesList(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            sessionStorage.setItem('perfilesListaToEditar', JSON.stringify(data));
            _this.perfilesListaToEditar = JSON.parse(sessionStorage.getItem('perfilesListaToEditar'));
            if (_this.perfilesListaToEditar.codret == '0') {
                _this.formGroup.controls['descPerfil'].setValue(_this.perfilesListaToEditar.resultado[0]['descPerfil']);
                _this.formGroup.controls['idPolitica'].setValue(_this.perfilesListaToEditar.resultado[0]['idPolitica']);
                _this.formGroup.controls['codEstadoPerfil'].setValue(_this.perfilesListaToEditar.resultado[0]['codEstadoPerfil']);
                _this.loader.hide();
            }
            else {
                _this.loader.hide();
                _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    PerfilesUpdComponent.prototype.postPerfilesUpdServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.perfilesService.postPerfilesUpd(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.loader.hide();
                _this.showDialog('Información', 'Perfil editado de forma satisfactoria.', false);
            }
            else {
                _this.loader.hide();
                _this.showDialogFail('Error', 'No ha sido posible editar el perfil.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            _this.showDialogFail('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    PerfilesUpdComponent.prototype.postPoliticaListServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.politicaService.postPoliticaList(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.politicasResultado = [];
                _this.politicasResultado.push(data);
            }
            else {
                console.log(data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @return {?}
     */
    PerfilesUpdComponent.prototype.postPerfilesEstadosListServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.perfilesService.postPerfilesEstados().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.perfilesEstadosResultados = [];
                _this.perfilesEstadosResultados.push(data);
            }
            else {
                console.log(data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    PerfilesUpdComponent.prototype.postListServEmpServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.perfilesService.postListServEmp(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret = '0') {
                /** @type {?} */
                var dataServEmp = _this.buildFileTree(data.servicios.modulos, 0);
                _this.dataChange.next(dataServEmp);
                _this.dataSource.data = [];
                _this.dataSource.data = dataServEmp;
                _this.peticionServPerfil.idPerfil = _this.idPerfil;
                _this.peticionServPerfil.codCliente = _this.environment.codCliente;
                _this.peticionServPerfil.docEmpresa = _this.docEmpresa;
                _this.postListServPerfilServices(_this.peticionServPerfil);
            }
            else {
                _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    PerfilesUpdComponent.prototype.postListServPerfilServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.perfilesService.postListServPerfil(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret = '0') {
                /** @type {?} */
                var dataServPerfil = _this.buildFileTree(data.servicios.modulos, 0);
                _this.dataChange.next(dataServPerfil);
                dataServPerfil.forEach((/**
                 * @param {?} item
                 * @return {?}
                 */
                function (item) {
                    _this.items.push(item);
                    /** @type {?} */
                    var padres = item.children;
                    if (padres != null) {
                        for (var index = 0; index < padres.length; index++) {
                            _this.items.push(padres[index]);
                            if (padres[index].children != null) {
                                _this.getHijos(padres[index].children);
                            }
                        }
                    }
                }));
                _this.items.forEach((/**
                 * @param {?} item
                 * @return {?}
                 */
                function (item) {
                    _this.treeControl.dataNodes.forEach((/**
                     * @param {?} node
                     * @return {?}
                     */
                    function (node) {
                        if (item['idServEmpNode'] == node['idServEmpFlat']) {
                            _this.checklistSelection.toggle(node);
                        }
                    }));
                }));
            }
            else {
                _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @param {?} padres
     * @return {?}
     */
    PerfilesUpdComponent.prototype.getHijos = /**
     * @param {?} padres
     * @return {?}
     */
    function (padres) {
        for (var index = 0; index < padres.length; index++) {
            this.items.push(padres[index]);
            if (padres[index].children != null) {
                this.getHijos(padres[index].children);
            }
        }
    };
    /* Estructura que se le pasa al dataSource */
    /* Estructura que se le pasa al dataSource */
    /**
     * @param {?} obj
     * @param {?} level
     * @return {?}
     */
    PerfilesUpdComponent.prototype.buildFileTree = /* Estructura que se le pasa al dataSource */
    /**
     * @param {?} obj
     * @param {?} level
     * @return {?}
     */
    function (obj, level) {
        var _this = this;
        return Object.keys(obj).reduce((/**
         * @param {?} accumulator
         * @param {?} key
         * @return {?}
         */
        function (accumulator, key) {
            /** @type {?} */
            var value = obj[key];
            /** @type {?} */
            var node = new TodoItemNode$1();
            node.item = obj[key]['dsc'];
            node.idServEmpNode = obj[key]['idServEmp'];
            node.url = obj[key]['url'];
            if (value != null) {
                if (typeof value === 'object') {
                    /** @type {?} */
                    var temp = value['menus'];
                    value.data = [];
                    value.data = temp;
                    if (value.data != null) {
                        node.children = _this.buildFileTree(value.data, level + 1);
                    }
                }
                else {
                    node.item = obj[key]['dsc'];
                }
            }
            return accumulator.concat(node);
        }), []);
    };
    /**
     * @return {?}
     */
    PerfilesUpdComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.peticionPerfilesUpd.codCliente = this.environment.codCliente;
        this.peticionPerfilesUpd.idUsuario = this.idUsuario;
        this.peticionPerfilesUpd.docEmpresa = this.docEmpresa;
        this.peticionPerfilesUpd.codTpoPortal = this.codTpoPortal;
        this.peticionPerfilesUpd.idPerfil = this.idPerfil;
        this.peticionPerfilesUpd.descPerfil = this.formGroup.get('descPerfil').value;
        /** @type {?} */
        var codEstadoPerfil = this.formGroup.get('codEstadoPerfil').value;
        this.peticionPerfilesUpd.codEstadoPerfil = codEstadoPerfil;
        this.peticionPerfilesUpd.idPolitica = this.formGroup.get('idPolitica').value;
        this.peticionPerfilesUpd.listIdServEmp = [];
        this.checklistSelection.selected.forEach((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            _this.peticionPerfilesUpd.listIdServEmp.push(item['idServEmpFlat']);
        }));
        if (this.peticionPerfilesUpd.listIdServEmp.length != 0) {
            if (codEstadoPerfil == 'SUSPENDIDO') {
                this.showDialogPre('Información', 'El perfil podría tener usuarios asociados y quedarán sin acceso al portal. ¿Desea continuar?', true);
            }
            else {
                this.showDialogPre('Información', 'Si realiza esta acción, editará el perfil.<br>¿Está seguro?', true);
            }
        }
        else {
            this.showDialogFail('Información', 'Seleccione los servicios de acceso.', false);
        }
    };
    /**
     * @return {?}
     */
    PerfilesUpdComponent.prototype.toPerfiles = /**
     * @return {?}
     */
    function () {
        if (this.camino == 'perfilesEmp') {
            this.router.navigate(['../perfilListEmp'], { relativeTo: this.route });
        }
        else {
            this.router.navigate(['../perfilList'], { relativeTo: this.route });
        }
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    PerfilesUpdComponent.prototype.showDialogPre = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            if (result) {
                _this.postPerfilesUpdServices(_this.peticionPerfilesUpd);
            }
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    PerfilesUpdComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            _this.toPerfiles();
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    PerfilesUpdComponent.prototype.showDialogFail = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /* Si se seleccionan todos los descendientes del nodo */
    /* Si se seleccionan todos los descendientes del nodo */
    /**
     * @param {?} node
     * @return {?}
     */
    PerfilesUpdComponent.prototype.descendantsAllSelected = /* Si se seleccionan todos los descendientes del nodo */
    /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        var _this = this;
        /** @type {?} */
        var descendants = this.treeControl.getDescendants(node);
        /** @type {?} */
        var descAllSelected = descendants.every((/**
         * @param {?} child
         * @return {?}
         */
        function (child) { return _this.checklistSelection.isSelected(child); }));
        return descAllSelected;
    };
    /* Si parte de los descendientes están seleccionados */
    /* Si parte de los descendientes están seleccionados */
    /**
     * @param {?} node
     * @return {?}
     */
    PerfilesUpdComponent.prototype.descendantsPartiallySelected = /* Si parte de los descendientes están seleccionados */
    /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        var _this = this;
        /** @type {?} */
        var descendants = this.treeControl.getDescendants(node);
        /** @type {?} */
        var result = descendants.some((/**
         * @param {?} child
         * @return {?}
         */
        function (child) { return _this.checklistSelection.isSelected(child); }));
        return result && !this.descendantsAllSelected(node);
    };
    /* Alternar la selección de tareas pendientes. Seleccionar / deseleccionar todos los nodos descendientes */
    /* Alternar la selección de tareas pendientes. Seleccionar / deseleccionar todos los nodos descendientes */
    /**
     * @param {?} node
     * @return {?}
     */
    PerfilesUpdComponent.prototype.todoItemSelectionToggle = /* Alternar la selección de tareas pendientes. Seleccionar / deseleccionar todos los nodos descendientes */
    /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        var _this = this;
        var _a, _b;
        //this.checklistSelection.toggle(node);
        /** @type {?} */
        var nodeSelected = this.checklistSelection.isSelected(node);
        /** @type {?} */
        var descendants = this.treeControl.getDescendants(node);
        /** @type {?} */
        var descAllSelected = descendants.every((/**
         * @param {?} child
         * @return {?}
         */
        function (child) { return _this.checklistSelection.isSelected(child); }));
        if (nodeSelected && descAllSelected) {
            this.checklistSelection.deselect(node);
        }
        if (!nodeSelected && !descAllSelected) {
            this.checklistSelection.select(node);
        }
        this.checklistSelection.isSelected(node) ? (_a = this.checklistSelection).select.apply(_a, __spread(descendants)) : (_b = this.checklistSelection).deselect.apply(_b, __spread(descendants));
        /* Forzar actualización para el padre */
        descendants.every((/**
         * @param {?} child
         * @return {?}
         */
        function (child) { return _this.checklistSelection.isSelected(child); }));
        this.checkAllParentsSelection(node);
    };
    /* Alternar una selección de elementos de tareas pendientes de hoja. Verifique a todos los padres para ver si cambiaron */
    /* Alternar una selección de elementos de tareas pendientes de hoja. Verifique a todos los padres para ver si cambiaron */
    /**
     * @param {?} node
     * @return {?}
     */
    PerfilesUpdComponent.prototype.todoLeafItemSelectionToggle = /* Alternar una selección de elementos de tareas pendientes de hoja. Verifique a todos los padres para ver si cambiaron */
    /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        this.checklistSelection.toggle(node);
        /** @type {?} */
        var hermanos = this.getHermanoNode(node);
        if (node.url == 'reutilizarDetalle' || node.url == 'reutilizarBorradorDetalle' || node.url == 'usuariosList' || node.url == 'usuariosLst' || node.url == 'perfilList' || node.url == 'perfilListEmp' || node.url == 'politicaList' || node.url == 'empresasList') {
            if (!this.checklistSelection.isSelected(node)) {
                if (hermanos != null) {
                    for (var index = 0; index < hermanos.length; index++) {
                        this.checklistSelection.deselect(hermanos[index]);
                    }
                }
            }
            else {
                if (node.url == 'reutilizarDetalle' || node.url == 'reutilizarBorradorDetalle') {
                    if (hermanos != null) {
                        for (var index = 0; index < hermanos.length; index++) {
                            this.checklistSelection.select(hermanos[index]);
                        }
                    }
                }
            }
        }
        else {
            if (this.checklistSelection.isSelected(node)) {
                if (hermanos != null) {
                    for (var index = 0; index < hermanos.length; index++) {
                        if (hermanos[index].url == 'usuariosList' || hermanos[index].url == 'usuariosLst' || hermanos[index].url == 'perfilList' || hermanos[index].url == 'perfilListEmp' || hermanos[index].url == 'politicaList' || hermanos[index].url == 'empresasList') {
                            this.checklistSelection.select(hermanos[index]);
                        }
                    }
                }
            }
        }
        this.checkAllParentsSelection(node);
    };
    /**
     * @param {?} node
     * @return {?}
     */
    PerfilesUpdComponent.prototype.getHermanoNode = /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        /** @type {?} */
        var nodes = [];
        /** @type {?} */
        var currentLevel = this.getLevel(node);
        if (currentLevel < 1) {
            return null;
        }
        /** @type {?} */
        var startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
        for (var i = startIndex; i >= 0; i--) {
            /** @type {?} */
            var currentNode = this.treeControl.dataNodes[i];
            if (this.getLevel(currentNode) == currentLevel) {
                nodes.push(currentNode);
            }
            else {
                /** @type {?} */
                var startIndex2 = this.treeControl.dataNodes.indexOf(node) + 1;
                for (var i_1 = startIndex2; i_1 >= 0; i_1++) {
                    /** @type {?} */
                    var currentNode_1 = this.treeControl.dataNodes[i_1];
                    if (this.getLevel(currentNode_1) == currentLevel) {
                        nodes.push(currentNode_1);
                    }
                    else {
                        return nodes;
                    }
                }
            }
        }
        return nodes;
    };
    /* Comprueba todos los padres cuando un nodo hoja está seleccionado / no seleccionado */
    /* Comprueba todos los padres cuando un nodo hoja está seleccionado / no seleccionado */
    /**
     * @param {?} node
     * @return {?}
     */
    PerfilesUpdComponent.prototype.checkAllParentsSelection = /* Comprueba todos los padres cuando un nodo hoja está seleccionado / no seleccionado */
    /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        /** @type {?} */
        var parent = this.getParentNode(node);
        while (parent) {
            this.checkRootNodeSelection(parent);
            parent = this.getParentNode(parent);
        }
    };
    /**
     * @param {?} node
     * @return {?}
     */
    PerfilesUpdComponent.prototype.checkRootNodeSelection = /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        var _this = this;
        /** @type {?} */
        var nodeSelected = this.checklistSelection.isSelected(node);
        /** @type {?} */
        var descendants = this.treeControl.getDescendants(node);
        /** @type {?} */
        var descAllSelected = descendants.every((/**
         * @param {?} child
         * @return {?}
         */
        function (child) { return _this.checklistSelection.isSelected(child); }));
        /** @type {?} */
        var descSomeSelected = descendants.some((/**
         * @param {?} child
         * @return {?}
         */
        function (child) { return _this.checklistSelection.isSelected(child); }));
        if (nodeSelected && !descAllSelected) {
            this.checklistSelection.deselect(node);
        }
        else if (!nodeSelected && descAllSelected) {
            this.checklistSelection.select(node);
        }
        if (descSomeSelected) {
            this.checklistSelection.select(node);
            /** @type {?} */
            var id = this.checklistSelection.selected.find((/**
             * @param {?} id
             * @return {?}
             */
            function (id) { return id == node; }));
            if (id == null) {
                this.checklistSelection.select(node);
            }
        }
    };
    /* Obtener el nodo padre de un nodo */
    /* Obtener el nodo padre de un nodo */
    /**
     * @param {?} node
     * @return {?}
     */
    PerfilesUpdComponent.prototype.getParentNode = /* Obtener el nodo padre de un nodo */
    /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        /** @type {?} */
        var currentLevel = this.getLevel(node);
        if (currentLevel < 1) {
            return null;
        }
        /** @type {?} */
        var startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
        for (var i = startIndex; i >= 0; i--) {
            /** @type {?} */
            var currentNode = this.treeControl.dataNodes[i];
            if (this.getLevel(currentNode) < currentLevel) {
                return currentNode;
            }
        }
        return null;
    };
    /**
     * @return {?}
     */
    PerfilesUpdComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('toEditarPerfiles');
    };
    PerfilesUpdComponent.decorators = [
        { type: Component, args: [{
                    selector: 'perfiles-upd',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <!-- <h3 class=\"titulo-seccion\">Administraci\u00F3n de pol\u00EDticas</h3> -->\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a (click)=\"toPerfiles()\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <form [formGroup]=\"formGroup\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n        <h3>Editar perfil</h3>\r\n        <div class=\"form-section\">\r\n          <h5>Datos</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-8\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"95\" placeholder=\"Descripci\u00F3n\" formControlName=\"descPerfil\">\r\n                <mat-error *ngIf=\"formGroup.get('descPerfil').invalid\">Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Pol\u00EDtica\" formControlName=\"idPolitica\">\r\n                  <section *ngFor=\"let respPolitica of politicasResultado\">\r\n                    <mat-option *ngFor=\"let pol of respPolitica.resultado\" [value]=\"pol.idPol\">{{pol.dscPol}}</mat-option>\r\n                  </section>\r\n                </mat-select>\r\n                <mat-error *ngIf=\"formGroup.get('idPolitica').invalid\">Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"codEstadoPerfil\">\r\n                  <section *ngFor=\"let respEstados of perfilesEstadosResultados\">\r\n                    <mat-option *ngFor=\"let est of respEstados.resultado\" [value]=\"est.codEstadoPerfil\">{{est.descEstadoPefil}}</mat-option>\r\n                  </section>\r\n                </mat-select>\r\n                <mat-error *ngIf=\"formGroup.get('codEstadoPerfil').invalid\">Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-section\">\r\n          <h5>Seleccione los servicios de acceso</h5>\r\n          <mat-tree [dataSource]=\"dataSource\" [treeControl]=\"treeControl\">\r\n            <mat-tree-node style=\"margin-top: -18px\" *matTreeNodeDef=\"let node\" matTreeNodeToggle matTreeNodePadding>\r\n              <button mat-icon-button disabled></button>\r\n              <mat-checkbox class=\"checklist-leaf-node\" [checked]=\"checklistSelection.isSelected(node)\" (change)=\"todoLeafItemSelectionToggle(node)\">{{node.item}}</mat-checkbox>\r\n            </mat-tree-node>\r\n\r\n            <mat-tree-node  style=\"margin-top: -18px\" *matTreeNodeDef=\"let node; when: hasChild\" matTreeNodePadding>\r\n              <button mat-icon-button matTreeNodeToggle [attr.aria-label]=\"'toggle ' + node.filename\">\r\n                <mat-icon class=\"mat-icon-rtl-mirror\">\r\n                  {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}\r\n                </mat-icon>\r\n              </button>\r\n              <mat-checkbox [checked]=\"descendantsAllSelected(node)\" [indeterminate]=\"descendantsPartiallySelected(node)\" (change)=\"todoItemSelectionToggle(node)\">{{node.item}}</mat-checkbox>\r\n            </mat-tree-node>\r\n          </mat-tree>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <!-- <div class=\"col align-left\">\r\n             <button class=\"btn text\" (click)=\"limpiar()\" type=\"reset\" [routerLink]=\"['../convenios']\"><i class=\"str-icon-flecha-izquierda\"></i>CANCELAR</button>\r\n          </div> -->\r\n          <div class=\"col align-right\">\r\n            <button *ngIf=\"formGroup.invalid\" class=\"btn main\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n            <button *ngIf=\"formGroup.valid\" class=\"btn main\" type=\"submit\" (click)=\"onSubmit()\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n\r\n  </div>\r\n</section>",
                    providers: [{ provide: MAT_DATE_LOCALE$1, useValue: 'es' },
                        { provide: DateAdapter$1, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE$1] },
                        { provide: MAT_DATE_FORMATS$1, useValue: ɵ0$i }, PoliticaService]
                }] }
    ];
    /** @nocollapse */
    PerfilesUpdComponent.ctorParameters = function () { return [
        { type: PerfilesService },
        { type: PoliticaService },
        { type: Router },
        { type: ActivatedRoute },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] },
        { type: MatDialog },
        { type: LoaderBaseService }
    ]; };
    return PerfilesUpdComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PoliticaAddComponent = /** @class */ (function () {
    function PoliticaAddComponent(phttp, router, route, modalService, environment, dialog, loader) {
        this.phttp = phttp;
        this.router = router;
        this.route = route;
        this.modalService = modalService;
        this.environment = environment;
        this.dialog = dialog;
        this.loader = loader;
        this.peticionPoliticaAdd = new PoliticaAddPeticion();
        this.accMulUsr = [
            { option: 'SI', value: 'S' },
            { option: 'NO', value: 'N' }
        ];
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idUsuario = this.userPerfil.usuario.idUsuario;
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        /* this.idUsuario = '1';
        this.codTpoPortal = 'ADQUIRENTE'; */
    }
    /**
     * @return {?}
     */
    PoliticaAddComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.FormGroup = new FormGroup({
            dscPol: new FormControl('', Validators.compose([CustomValidators.descriptionValidator, Validators.required])),
            maxIntPwdPol: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            diaExpPwdPol: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            lrgMinPwdPol: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            lrgMaxPwdPol: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            canLetMayPwdPol: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            canLetMinPwdPol: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            canNumMinPwdPol: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            canCarMinPwdPol: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            canHstPwdPol: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            canMinBlqUsr: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            canMinExpSes: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            accMulUsrPol: new FormControl('', Validators.required),
            canMaxGbalTokenSuscripcion: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            maxIntTokenSuscripcion: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required]))
        });
    };
    /**
     * @param {?} body
     * @return {?}
     */
    PoliticaAddComponent.prototype.postPoliticaAddServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.phttp.postPoliticaAdd(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            sessionStorage.setItem('politicaAdd', JSON.stringify(data));
            _this.politicaAdd = JSON.parse(sessionStorage.getItem('politicaAdd'));
            if (_this.politicaAdd.codret == '0') {
                _this.loader.hide();
                _this.showDialog('Información', 'Política agregada de forma satisfactoria.', false);
            }
            else {
                _this.loader.hide();
                _this.showDialogFail('Error', 'No ha sido posible agregar la política.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            _this.showDialogFail('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @return {?}
     */
    PoliticaAddComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        this.peticionPoliticaAdd.codCliente = this.environment.codCliente;
        this.peticionPoliticaAdd.idUsuario = this.idUsuario;
        if (this.codTpoPortal == 'ADQUIRENTE') {
            this.peticionPoliticaAdd.docEmpresa = this.environment.docEmpresa;
        }
        else {
            this.peticionPoliticaAdd.docEmpresa = this.docEmpresa;
        }
        this.peticionPoliticaAdd.codTpoPortal = this.codTpoPortal;
        this.peticionPoliticaAdd.dscPol = this.FormGroup.get('dscPol').value;
        this.peticionPoliticaAdd.maxIntPwdPol = this.FormGroup.get('maxIntPwdPol').value;
        this.peticionPoliticaAdd.diaExpPwdPol = this.FormGroup.get('diaExpPwdPol').value;
        this.peticionPoliticaAdd.lrgMinPwdPol = this.FormGroup.get('lrgMinPwdPol').value;
        this.peticionPoliticaAdd.lrgMaxPwdPol = this.FormGroup.get('lrgMaxPwdPol').value;
        this.peticionPoliticaAdd.canLetMayPwdPol = this.FormGroup.get('canLetMayPwdPol').value;
        this.peticionPoliticaAdd.canLetMinPwdPol = this.FormGroup.get('canLetMinPwdPol').value;
        this.peticionPoliticaAdd.canNumMinPwdPol = this.FormGroup.get('canNumMinPwdPol').value;
        this.peticionPoliticaAdd.canCarMinPwdPol = this.FormGroup.get('canCarMinPwdPol').value;
        this.peticionPoliticaAdd.canHstPwdPol = this.FormGroup.get('canHstPwdPol').value;
        this.peticionPoliticaAdd.canMinBlqUsr = this.FormGroup.get('canMinBlqUsr').value;
        this.peticionPoliticaAdd.canMinExpSes = this.FormGroup.get('canMinExpSes').value;
        this.peticionPoliticaAdd.accMulUsrPol = this.FormGroup.get('accMulUsrPol').value;
        this.peticionPoliticaAdd.canMaxGbalTokenSuscripcion = this.FormGroup.get('canMaxGbalTokenSuscripcion').value;
        this.peticionPoliticaAdd.maxIntTokenSuscripcion = this.FormGroup.get('maxIntTokenSuscripcion').value;
        //console.log(this.peticionPoliticaAdd);
        this.showDialogPre('Información', 'Si realiza esta acción, agregará una nueva política.<br>¿Está seguro?', true);
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    PoliticaAddComponent.prototype.showDialogPre = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            if (result) {
                _this.postPoliticaAddServices(_this.peticionPoliticaAdd);
            }
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    PoliticaAddComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            _this.router.navigate(['../politicaList'], { relativeTo: _this.route });
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    PoliticaAddComponent.prototype.showDialogFail = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    PoliticaAddComponent.decorators = [
        { type: Component, args: [{
                    selector: 'politica-add',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <!-- <h3 class=\"titulo-seccion\">Administraci\u00F3n de pol\u00EDticas</h3> -->\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a [routerLink]=\"['../politicaList']\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <form [formGroup]=\"FormGroup\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n       <h3>Agregar nueva pol&iacute;tica</h3>\r\n        <div class=\"form-section\">\r\n          <h5>Datos</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-12 col-md-12\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"95\" placeholder=\"Descripci&oacute;n\" formControlName=\"dscPol\">\r\n                <mat-error *ngIf=\"FormGroup.get('dscPol').invalid\">Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly formControlName=\"maxIntPwdPol\">\r\n                <mat-error *ngIf=\"FormGroup.get('maxIntPwdPol').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>M&aacute;ximo de intentos de error en acceso usuario</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"diaExpPwdPol\">\r\n                <mat-error *ngIf=\"FormGroup.get('diaExpPwdPol').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>D&iacute;as de expiraci&oacute;n de clave de usuarios</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"lrgMinPwdPol\">\r\n                <mat-error *ngIf=\"FormGroup.get('lrgMinPwdPol').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Largo m&iacute;nimo de una clave de usuario</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"lrgMaxPwdPol\">\r\n                <mat-error *ngIf=\"FormGroup.get('lrgMaxPwdPol').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Largo m&aacute;ximo de una clave de usuario</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"canLetMayPwdPol\">\r\n                <mat-error *ngIf=\"FormGroup.get('canLetMayPwdPol').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Cantidad m&iacute;nima de letras may&uacute;sculas en la clave</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"canLetMinPwdPol\">\r\n                <mat-error *ngIf=\"FormGroup.get('canLetMinPwdPol').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Cantidad m&iacute;nima de letras min&uacute;sculas en la clave</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"canNumMinPwdPol\">\r\n                <mat-error *ngIf=\"FormGroup.get('canNumMinPwdPol').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Cantidad m&iacute;nima de n&uacute;meros en la clave</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"canCarMinPwdPol\">\r\n                <mat-error *ngIf=\"FormGroup.get('canCarMinPwdPol').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Cantidad m&iacute;nima de caracteres raros en la clave</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"canHstPwdPol\">\r\n                <mat-error *ngIf=\"FormGroup.get('canHstPwdPol').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Cantidad de claves hist&oacute;ricas a validar</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"canMinBlqUsr\">\r\n                <mat-error *ngIf=\"FormGroup.get('canMinBlqUsr').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Cantidad de minutos m&iacute;nimo bloqueo usuario</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"canMinExpSes\">\r\n                <mat-error *ngIf=\"FormGroup.get('canMinExpSes').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Cantidad de minutos m&aacute;ximo de sesi&oacute;n</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl  formControlName=\"accMulUsrPol\">\r\n                  <mat-option *ngFor=\"let acc of accMulUsr\" [value]=\"acc.value\">{{acc.option}}</mat-option>\r\n                </mat-select>\r\n                <mat-hint>Acceso multiple de un usuario</mat-hint>\r\n                <mat-error *ngIf=\"FormGroup.get('accMulUsrPol').invalid\">Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"canMaxGbalTokenSuscripcion\">\r\n                <mat-error *ngIf=\"FormGroup.get('canMaxGbalTokenSuscripcion').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Cantidad de minutos m&aacute;ximo global token suscripci&oacute;n</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"maxIntTokenSuscripcion\">\r\n                <mat-error *ngIf=\"FormGroup.get('maxIntTokenSuscripcion').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Cantidad m&aacute;xima de intentos de error en validaci&oacute;n token suscripci&oacute;n</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <!-- <div class=\"col align-left\">\r\n             <button class=\"btn text\" (click)=\"limpiar()\" type=\"reset\" [routerLink]=\"['../convenios']\"><i class=\"str-icon-flecha-izquierda\"></i>CANCELAR</button>\r\n          </div> -->\r\n          <div class=\"col align-right\">\r\n            <button *ngIf=\"FormGroup.invalid\" class=\"btn main\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n            <button *ngIf=\"FormGroup.valid\" class=\"btn main\" type=\"submit\" (click)=\"onSubmit()\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n\r\n  </div>\r\n</section>",
                    providers: [PoliticaService]
                }] }
    ];
    /** @nocollapse */
    PoliticaAddComponent.ctorParameters = function () { return [
        { type: PoliticaService },
        { type: Router },
        { type: ActivatedRoute },
        { type: NgbModal },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] },
        { type: MatDialog },
        { type: LoaderBaseService }
    ]; };
    return PoliticaAddComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PoliticaListComponent = /** @class */ (function () {
    function PoliticaListComponent(phttp, serviceBaseService, loader, environment) {
        this.phttp = phttp;
        this.serviceBaseService = serviceBaseService;
        this.loader = loader;
        this.environment = environment;
        // Vistas variables
        this.vistaCantidad = 0;
        this.hashCaminoMiga = [];
        this.peticionPoliticaList = new PoliticaListPeticion();
        this.mensajeError = -1;
        this.consulta = -1;
        this.isCollapsed = false;
    }
    /**
     * @return {?}
     */
    PoliticaListComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (sessionStorage.getItem('componenteHijo') != 'perfiles-upd') {
            sessionStorage.removeItem('indice');
        }
        this.formGroup = new FormGroup({
            descripcion: new FormControl()
        });
        this.consulta = -1;
        this.viewAgregar = this.serviceBaseService.validaAccesoMenu('politicaAdd');
        this.viewEditar = this.serviceBaseService.validaAccesoMenu('politicaUpd');
        if (this.viewEditar) {
            this.displayedColumns = ['desc', 'cliente', 'fechaAdd', 'fechaUpd', 'editar'];
        }
        else {
            this.displayedColumns = ['desc', 'cliente', 'fechaAdd', 'fechaUpd'];
        }
        this.peticionPoliticaList.codCliente = this.environment.codCliente;
        this.peticionPoliticaList.descPol = '-1';
        this.peticionPoliticaList.idPol = '-1';
        if (sessionStorage.getItem('componenteHijo') == 'politica-upd') {
            this.consulta = 0;
            /** @type {?} */
            var llamadaPadre = JSON.parse(sessionStorage.getItem('llamadaPadre'));
            // Llena los filtros
            this.formGroup.controls['descripcion'].setValue((llamadaPadre.descPol != '-1' ? llamadaPadre.descPol : ''));
            // Llena camino de migas
            /** @type {?} */
            var migasPadre = JSON.parse(sessionStorage.getItem('migasPadre'));
            this.hashCaminoMiga[0] = { title: 'Descripción', text: migasPadre.descPol };
            // Llama al servicio
            this.peticionPoliticaList.codCliente = llamadaPadre.codCliente;
            this.peticionPoliticaList.idPol = llamadaPadre.idPol;
            this.peticionPoliticaList.descPol = llamadaPadre.descPol;
            this.postPoliticaListServices(this.peticionPoliticaList);
        }
        else {
            this.setInitialBreadcrumbs();
        }
    };
    /**
     * @return {?}
     */
    PoliticaListComponent.prototype.setInitialBreadcrumbs = /**
     * @return {?}
     */
    function () {
        this.hashCaminoMiga[0] = { title: 'Descripción', text: '' };
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PoliticaListComponent.prototype.onPaginateChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var indice = this.paginator.pageIndex;
        sessionStorage.setItem('indice', indice);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    PoliticaListComponent.prototype.postPoliticaListServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.show = true;
        this.phttp.postPoliticaList(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.vistaCantidad = data.resultado.length;
                if (_this.paginator != undefined && sessionStorage.getItem('componenteHijo') == 'perfiles-upd') {
                    _this.paginator.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indice')))));
                }
                else if (_this.paginator != undefined) {
                    _this.paginator.pageIndex = 0;
                    sessionStorage.removeItem("indice");
                }
                sessionStorage.removeItem('componenteHijo');
                _this.dataSource = new MatTableDataSource$1(data.resultado);
                _this.dataSource.paginator = _this.paginator;
                _this.dataSource.sort = _this.sort;
                if (_this.vistaCantidad == 0) {
                    _this.show = false;
                    _this.isCollapsed = false;
                }
                else {
                    _this.isCollapsed = true;
                }
                _this.mensajeError = 0;
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.loader.hide();
                _this.mensajeError = 1;
                console.log('Error: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            _this.loader.hide();
            _this.mensajeError = 1;
            console.log('Error: ', err);
        }));
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    PoliticaListComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.consulta = 0;
        this.peticionPoliticaList.codCliente = this.environment.codCliente;
        this.peticionPoliticaList.idPol = '-1';
        if (this.formGroup.get('descripcion').value == null || this.formGroup.get('descripcion').value == '') {
            this.peticionPoliticaList.descPol = '-1';
            this.hashCaminoMiga[0] = { title: 'Descripción', text: '' };
        }
        else {
            this.peticionPoliticaList.descPol = this.formGroup.get('descripcion').value;
            this.hashCaminoMiga[0] = { title: 'Descripción', text: this.formGroup.get('descripcion').value };
        }
        sessionStorage.setItem('llamadaPadre', JSON.stringify({
            codCliente: this.peticionPoliticaList.codCliente,
            idPol: this.peticionPoliticaList.idPol,
            descPol: this.peticionPoliticaList.descPol
        }));
        sessionStorage.setItem('migasPadre', JSON.stringify({
            descPol: this.hashCaminoMiga[0].text
        }));
        this.postPoliticaListServices(this.peticionPoliticaList);
        /* if (tipo == 'excel' || tipo == 'pdf') {
          if (tipo == 'excel') {
            this.url = '/apiPolitica/politicaList/excel';
          } else {
            this.url = '/apiPolitica/politicaList/pdf';
          }
          this.postDownloadReportFile(this.peticionPoliticaList, tipo, this.url);
        } else {
          this.postSentReportServices(this.peticionPoliticaList);
        } */
    };
    /**
     * @return {?}
     */
    PoliticaListComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.peticionPoliticaList.codCliente = this.environment.codCliente;
        this.peticionPoliticaList.descPol = '-1';
        this.peticionPoliticaList.idPol = '-1';
        this.setInitialBreadcrumbs();
    };
    /**
     * @return {?}
     */
    PoliticaListComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('componenteHijo');
    };
    PoliticaListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'politica-list',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"seccion-titulo-boton\">\r\n      <div class=\"row\">\r\n        <div class=\"col\"></div>\r\n        <div class=\"col\" *ngIf=\"viewAgregar && mensajeError != 1\">\r\n          <!--a class=\"boton-seccion btn-small main\" [routerLink]=\"['../politicaAdd']\"><i class=\"str-icon-mas\"></i> Agregar pol&iacute;tica</a-->\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"modulo-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n      </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"formGroup\" (ngSubmit)=\"onSubmit('');\" autocomplete=\"off\">\r\n              <div class=\"form-row\">\r\n                <div class=\"col-md-8\">\r\n                  <mat-form-field>\r\n                    <input noCaracEsp matInput maxlength=\"40\" placeholder=\"Descripci\u00F3n\" formControlName=\"descripcion\">\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"actions\">\r\n                <button type=\"reset\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\">Filtrar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"resultados-filtros\" *ngIf=\"mensajeError != 1\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-10\">\r\n          <div class=\"tags row\">\r\n            <div *ngFor=\"let entry of hashCaminoMiga\" class=\"item\">{{entry.title}}: {{entry.text}}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n          <div class=\"numero-resultados\">\r\n            <strong>{{ (vistaCantidad == 1) ? ( vistaCantidad + \" Resultado\") : vistaCantidad + \" Resultados\" }}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-container table-responsive-md\">\r\n        <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n          <ng-container matColumnDef=\"desc\">\r\n            <th mat-header-cell *matHeaderCellDef>Descripci&oacute;n</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.dscPol}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"cliente\">\r\n            <th mat-header-cell *matHeaderCellDef>Cliente</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.razSocClt}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fechaAdd\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha Ingreso</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.fecAddPol | date: 'dd/MM/yyyy'}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fechaUpd\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha Actualizaci&oacute;n</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              {{(resultado.fecUpdPol !== null) ? (resultado.fecUpdPol | date: 'dd/MM/yyyy') : \"-\" }}\r\n            </td>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"viewEditar\" matColumnDef=\"editar\">\r\n            <th mat-header-cell *matHeaderCellDef>Editar</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a matTooltip=\"Editar pol\u00EDtica\" matTooltipPosition=\"above\" Style=\"cursor: pointer;\" [routerLink]=\"['../politicaUpd']\" [queryParams]=\"{'a':resultado.idPol}\"><i class=\"icon str-icon-lapiz\"></i></a>\r\n            </td>\r\n          </ng-container>\r\n\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n        </table>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" (page)=\"onPaginateChange($event)\" showFirstLastButtons></mat-paginator>\r\n      </div>\r\n\r\n      <!-- <div class=\"box-actions\" *ngIf=\"vistaCantidad > 0\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6 item\">\r\n            <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n          </div>\r\n          <div class=\"col-md-6 item\">\r\n            <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n          </div>\r\n        </div>\r\n      </div> -->\r\n    </section>\r\n\r\n    <div class=\"modulo-cuentas\" *ngIf=\"mensajeError == 0 && vistaCantidad == 0\">\r\n      <span>\r\n        No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.\r\n      </span>\r\n    </div>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"consulta == -1\">\r\n      <span>\r\n        Establezca sus criterios de b&uacute;squeda.\r\n      </span>\r\n    </div>\r\n\r\n  </div>\r\n</section>\r\n\r\n<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div *ngIf=\"mensajeError == 1\" class=\"collapse show\" id=\"historial\">\r\n      <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" id=\"modal-basic-title\" style=\"color:#ec0000;font-weight: bold\">Error</h3>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <p>Servicio temporalmente no disponible.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [PoliticaService]
                }] }
    ];
    /** @nocollapse */
    PoliticaListComponent.ctorParameters = function () { return [
        { type: PoliticaService },
        { type: ServicesBaseService },
        { type: LoaderBaseService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    PoliticaListComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator$1,] }],
        sort: [{ type: ViewChild, args: [MatSort,] }]
    };
    return PoliticaListComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PoliticaUpdPeticion = /** @class */ (function () {
    function PoliticaUpdPeticion() {
        this.codCliente = '-1';
        this.idPol = '-1';
        this.idUsuario = '-1';
        this.docEmpresa = '-1';
        this.codTpoPortal = '-1';
        this.dscPol = '-1';
        this.maxIntPwdPol = '-1';
        this.diaExpPwdPol = '-1';
        this.lrgMinPwdPol = '-1';
        this.lrgMaxPwdPol = '-1';
        this.canLetMayPwdPol = '-1';
        this.canLetMinPwdPol = '-1';
        this.canNumMinPwdPol = '-1';
        this.canCarMinPwdPol = '-1';
        this.canHstPwdPol = '-1';
        this.canMinBlqUsr = '-1';
        this.canMinExpSes = '-1';
        this.accMulUsrPol = '-1';
        this.canMaxGbalTokenSuscripcion = '-1';
        this.maxIntTokenSuscripcion = '-1';
    }
    return PoliticaUpdPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PoliticaUpdComponent = /** @class */ (function () {
    function PoliticaUpdComponent(phttp, router, route, environment, dialog, loader) {
        this.phttp = phttp;
        this.router = router;
        this.route = route;
        this.environment = environment;
        this.dialog = dialog;
        this.loader = loader;
        this.peticionPoliticaUpd = new PoliticaUpdPeticion();
        this.peticionPoliticaList = new PoliticaListPeticion();
        this.accMulUsr = [
            { option: 'SI', value: 'S' },
            { option: 'NO', value: 'N' }
        ];
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idUsuario = this.userPerfil.usuario.idUsuario;
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        /*  this.idUsuario = '1';
         this.codTpoPortal = 'ADQUIRENTE'; */
    }
    /**
     * @return {?}
     */
    PoliticaUpdComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        sessionStorage.setItem('componenteHijo', 'politica-upd');
        this.route.queryParams.subscribe((/**
         * @param {?} params
         * @return {?}
         */
        function (params) {
            _this.idPol = params['a'];
        }));
        this.formGroup = new FormGroup({
            dscPol: new FormControl('', Validators.compose([CustomValidators.descriptionValidator, Validators.required])),
            maxIntPwdPol: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            diaExpPwdPol: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            lrgMinPwdPol: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            lrgMaxPwdPol: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            canLetMayPwdPol: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            canLetMinPwdPol: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            canNumMinPwdPol: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            canCarMinPwdPol: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            canHstPwdPol: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            canMinBlqUsr: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            canMinExpSes: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            accMulUsrPol: new FormControl('', Validators.required),
            canMaxGbalTokenSuscripcion: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required])),
            maxIntTokenSuscripcion: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{1,3}$'), Validators.required]))
        });
        this.peticionPoliticaList.codCliente = this.environment.codCliente;
        this.peticionPoliticaList.descPol = '-1';
        this.peticionPoliticaList.idPol = this.idPol;
        this.postPoliticaListServices(this.peticionPoliticaList);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    PoliticaUpdComponent.prototype.postPoliticaListServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.phttp.postPoliticaList(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            sessionStorage.setItem('politicaListaToEditar', JSON.stringify(data));
            _this.politicaListaToEditar = JSON.parse(sessionStorage.getItem('politicaListaToEditar'));
            if (_this.politicaListaToEditar.codret == '0') {
                _this.formGroup.controls['dscPol'].setValue(_this.politicaListaToEditar.resultado[0]['dscPol']);
                _this.formGroup.controls['maxIntPwdPol'].setValue(_this.politicaListaToEditar.resultado[0]['maxIntPwdPol']);
                _this.formGroup.controls['diaExpPwdPol'].setValue(_this.politicaListaToEditar.resultado[0]['diaExpPwdPol']);
                _this.formGroup.controls['lrgMinPwdPol'].setValue(_this.politicaListaToEditar.resultado[0]['lrgMinPwdPol']);
                _this.formGroup.controls['lrgMaxPwdPol'].setValue(_this.politicaListaToEditar.resultado[0]['lrgMaxPwdPol']);
                _this.formGroup.controls['canLetMayPwdPol'].setValue(_this.politicaListaToEditar.resultado[0]['canLetMayPwdPol']);
                _this.formGroup.controls['canLetMinPwdPol'].setValue(_this.politicaListaToEditar.resultado[0]['canLetMinPwdPol']);
                _this.formGroup.controls['canNumMinPwdPol'].setValue(_this.politicaListaToEditar.resultado[0]['canNumMinPwdPol']);
                _this.formGroup.controls['canCarMinPwdPol'].setValue(_this.politicaListaToEditar.resultado[0]['canCarMinPwdPol']);
                _this.formGroup.controls['canHstPwdPol'].setValue(_this.politicaListaToEditar.resultado[0]['canHstPwdPol']);
                _this.formGroup.controls['canMinBlqUsr'].setValue(_this.politicaListaToEditar.resultado[0]['canMinBlqUsr']);
                _this.formGroup.controls['canMinExpSes'].setValue(_this.politicaListaToEditar.resultado[0]['canMinExpSes']);
                _this.formGroup.controls['accMulUsrPol'].setValue(_this.politicaListaToEditar.resultado[0]['accMulUsrPol']);
                _this.formGroup.controls['canMaxGbalTokenSuscripcion'].setValue(_this.politicaListaToEditar.resultado[0]['canMaxGbalTokenSuscripcion']);
                _this.formGroup.controls['maxIntTokenSuscripcion'].setValue(_this.politicaListaToEditar.resultado[0]['maxIntTokenSuscripcion']);
                _this.loader.hide();
            }
            else {
                _this.loader.hide();
                _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
                console.log('Error: ', _this.politicaListaToEditar.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
            console.log('Error: ', _this.politicaListaToEditar.descret);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    PoliticaUpdComponent.prototype.postPoliticaUpdServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.phttp.postPoliticaUpd(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            sessionStorage.setItem('politicaUpd', JSON.stringify(data));
            _this.politicaUpd = JSON.parse(sessionStorage.getItem('politicaUpd'));
            if (_this.politicaUpd.codret == '0') {
                _this.loader.hide();
                _this.showDialog('Información', 'Política editada de forma satisfactoria.', false);
            }
            else {
                _this.loader.hide();
                _this.showDialogFail('Error', 'No ha sido posible editar la política.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            _this.showDialogFail('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @return {?}
     */
    PoliticaUpdComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        this.peticionPoliticaUpd.codCliente = this.environment.codCliente;
        this.peticionPoliticaUpd.idPol = this.idPol;
        this.peticionPoliticaUpd.idUsuario = this.idUsuario;
        if (this.codTpoPortal == 'ADQUIRENTE') {
            this.peticionPoliticaUpd.docEmpresa = this.environment.docEmpresa;
        }
        else {
            this.peticionPoliticaUpd.docEmpresa = this.docEmpresa;
        }
        this.peticionPoliticaUpd.codTpoPortal = this.codTpoPortal;
        this.peticionPoliticaUpd.dscPol = this.formGroup.get('dscPol').value;
        this.peticionPoliticaUpd.maxIntPwdPol = this.formGroup.get('maxIntPwdPol').value;
        this.peticionPoliticaUpd.diaExpPwdPol = this.formGroup.get('diaExpPwdPol').value;
        this.peticionPoliticaUpd.lrgMinPwdPol = this.formGroup.get('lrgMinPwdPol').value;
        this.peticionPoliticaUpd.lrgMaxPwdPol = this.formGroup.get('lrgMaxPwdPol').value;
        this.peticionPoliticaUpd.canLetMayPwdPol = this.formGroup.get('canLetMayPwdPol').value;
        this.peticionPoliticaUpd.canLetMinPwdPol = this.formGroup.get('canLetMinPwdPol').value;
        this.peticionPoliticaUpd.canNumMinPwdPol = this.formGroup.get('canNumMinPwdPol').value;
        this.peticionPoliticaUpd.canCarMinPwdPol = this.formGroup.get('canCarMinPwdPol').value;
        this.peticionPoliticaUpd.canHstPwdPol = this.formGroup.get('canHstPwdPol').value;
        this.peticionPoliticaUpd.canMinBlqUsr = this.formGroup.get('canMinBlqUsr').value;
        this.peticionPoliticaUpd.canMinExpSes = this.formGroup.get('canMinExpSes').value;
        this.peticionPoliticaUpd.accMulUsrPol = this.formGroup.get('accMulUsrPol').value;
        this.peticionPoliticaUpd.canMaxGbalTokenSuscripcion = this.formGroup.get('canMaxGbalTokenSuscripcion').value;
        this.peticionPoliticaUpd.maxIntTokenSuscripcion = this.formGroup.get('maxIntTokenSuscripcion').value;
        //console.log(this.peticionPoliticaUpd);
        this.showDialogPre('Información', 'Si realiza esta acción, editará la política.<br>¿Está seguro?', true);
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    PoliticaUpdComponent.prototype.showDialogPre = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            if (result) {
                _this.postPoliticaUpdServices(_this.peticionPoliticaUpd);
            }
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    PoliticaUpdComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            _this.router.navigate(['../politicaList'], { relativeTo: _this.route });
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    PoliticaUpdComponent.prototype.showDialogFail = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    PoliticaUpdComponent.decorators = [
        { type: Component, args: [{
                    selector: 'politica-upd',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <!-- <h3 class=\"titulo-seccion\">Administraci\u00F3n de pol\u00EDticas</h3> -->\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a [routerLink]=\"['../politicaList']\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <form [formGroup]=\"formGroup\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n        <h3>Editar pol&iacute;tica</h3>\r\n        <div class=\"form-section\">\r\n          <h5>Datos</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-sm-12 col-md-12\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"95\" placeholder=\"Descripci&oacute;n\" formControlName=\"dscPol\">\r\n                <mat-error *ngIf=\"formGroup.get('dscPol').invalid\">Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly formControlName=\"maxIntPwdPol\">\r\n                <mat-error *ngIf=\"formGroup.get('maxIntPwdPol').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>M&aacute;ximo de intentos de error en acceso usuario</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"diaExpPwdPol\">\r\n                <mat-error *ngIf=\"formGroup.get('diaExpPwdPol').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>D&iacute;as de expiraci&oacute;n de clave de usuarios</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"lrgMinPwdPol\">\r\n                <mat-error *ngIf=\"formGroup.get('lrgMinPwdPol').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Largo m&iacute;nimo de una clave de usuario</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"lrgMaxPwdPol\">\r\n                <mat-error *ngIf=\"formGroup.get('lrgMaxPwdPol').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Largo m&aacute;ximo de una clave de usuario</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"canLetMayPwdPol\">\r\n                <mat-error *ngIf=\"formGroup.get('canLetMayPwdPol').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Cantidad m&iacute;nima de letras may&uacute;sculas en la clave</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"canLetMinPwdPol\">\r\n                <mat-error *ngIf=\"formGroup.get('canLetMinPwdPol').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Cantidad m&iacute;nima de letras min&uacute;sculas en la clave</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"canNumMinPwdPol\">\r\n                <mat-error *ngIf=\"formGroup.get('canNumMinPwdPol').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Cantidad m&iacute;nima de n&uacute;meros en la clave</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"canCarMinPwdPol\">\r\n                <mat-error *ngIf=\"formGroup.get('canCarMinPwdPol').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Cantidad m&iacute;nima de caracteres raros en la clave</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"canHstPwdPol\">\r\n                <mat-error *ngIf=\"formGroup.get('canHstPwdPol').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Cantidad de claves hist&oacute;ricas a validar</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"canMinBlqUsr\">\r\n                <mat-error *ngIf=\"formGroup.get('canMinBlqUsr').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Cantidad de minutos m&iacute;nimo bloqueo usuario</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"canMinExpSes\">\r\n                <mat-error *ngIf=\"formGroup.get('canMinExpSes').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Cantidad de minutos m&aacute;ximo de sesi&oacute;n</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl  formControlName=\"accMulUsrPol\">\r\n                  <mat-option *ngFor=\"let acc of accMulUsr\" [value]=\"acc.value\">{{acc.option}}</mat-option>\r\n                </mat-select>\r\n                <mat-hint>Acceso multiple de un usuario</mat-hint>\r\n                <mat-error *ngIf=\"formGroup.get('accMulUsrPol').invalid\">Este campo es <strong>requerido</strong>.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"canMaxGbalTokenSuscripcion\">\r\n                <mat-error *ngIf=\"formGroup.get('canMaxGbalTokenSuscripcion').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Cantidad de minutos m&aacute;ximo global token suscripci&oacute;n</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"3\" digitOnly  formControlName=\"maxIntTokenSuscripcion\">\r\n                <mat-error *ngIf=\"formGroup.get('maxIntTokenSuscripcion').invalid\">Este campo no es <strong>v&aacute;lido</strong>.</mat-error>\r\n                <mat-hint>Cantidad m&aacute;xima de intentos de error en validaci&oacute;n token suscripci&oacute;n</mat-hint>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <!-- <div class=\"col align-left\">\r\n             <button class=\"btn text\" (click)=\"limpiar()\" type=\"reset\" [routerLink]=\"['../convenios']\"><i class=\"str-icon-flecha-izquierda\"></i>CANCELAR</button>\r\n          </div> -->\r\n          <div class=\"col align-right\">\r\n            <button *ngIf=\"formGroup.invalid\" class=\"btn main\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n            <button *ngIf=\"formGroup.valid\" class=\"btn main\" type=\"submit\" (click)=\"onSubmit()\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n\r\n  </div>\r\n</section>",
                    providers: [PoliticaService]
                }] }
    ];
    /** @nocollapse */
    PoliticaUpdComponent.ctorParameters = function () { return [
        { type: PoliticaService },
        { type: Router },
        { type: ActivatedRoute },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] },
        { type: MatDialog },
        { type: LoaderBaseService }
    ]; };
    return PoliticaUpdComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PeticionEmp = /** @class */ (function () {
    function PeticionEmp() {
        this.idMandante = '-1';
    }
    return PeticionEmp;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ReportePagosParameters = /** @class */ (function () {
    function ReportePagosParameters() {
        this.codTpoPortal = '-1';
        this.filtros = [];
        this.codCliente = '';
        this.idConvenio = '-1';
    }
    return ReportePagosParameters;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var httpOptions$f = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};
var ReportePagoService = /** @class */ (function () {
    function ReportePagoService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlServicio = this.environment.urlAmbiente + '/apiMandatosMT/reportepagos';
        this.urlEmpresa = this.environment.urlAmbiente + '/apiEmpresaMT/listarEmpresa';
        this.urlServicioReversaPago = this.environment.urlAmbiente + '/apiMandatosMT/reversarPago';
    }
    /**
     * @param {?} params
     * @return {?}
     */
    ReportePagoService.prototype.postReportePagos = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlServicio, params, httpOptions$f);
    };
    /**
     * @param {?} _body
     * @return {?}
     */
    ReportePagoService.prototype.postListarEmpresa = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlEmpresa, _body, httpOptions$f);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    ReportePagoService.prototype.postReportePagoReversar = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlServicioReversaPago, params, httpOptions$f);
    };
    ReportePagoService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ReportePagoService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return ReportePagoService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$j = MAT_MOMENT_DATE_FORMATS;
var ReportePagosComponent = /** @class */ (function () {
    function ReportePagosComponent(phttp, empresaservice, segmandatosService, phttpd, dialog, loader, serviceBase, fachisservice, fb, rutValidator, formBuilder, datepipe, environment) {
        this.phttp = phttp;
        this.empresaservice = empresaservice;
        this.segmandatosService = segmandatosService;
        this.phttpd = phttpd;
        this.dialog = dialog;
        this.loader = loader;
        this.serviceBase = serviceBase;
        this.fachisservice = fachisservice;
        this.fb = fb;
        this.rutValidator = rutValidator;
        this.formBuilder = formBuilder;
        this.datepipe = datepipe;
        this.environment = environment;
        this.fechaInicioPago = '01/01/2000';
        this.fechaFinPago = '01/01/2000';
        this.fechaInicioVencimiento = '01/01/2000';
        this.fechaFinVencimiento = '01/01/2000';
        this.pipeRut = new RutPipe();
        this.size = 0;
        this.vistaMedioPago = '';
        this.vistaEstado = '';
        this.vistaComercio = 'Todos';
        this.vistaRubro = 'Todos';
        this.hashCaminoMiga = [];
        this.peticionEmp = new PeticionEmp();
        this.peticionReport = new ReportePagosParameters();
        this.ListMedioPagoPost = new ListMedioPagoPeticion();
        this.isCollapsed = false;
        this.show = false;
        this.consulta = 0;
        this.resultadoRubros = [];
        this.resultadoEmpresa = [];
        this.peticionEmpresa = new EmpresasPeticion();
        this.comboComercio = false;
        this.displayedColumns = [];
        /** @type {?} */
        var fecha = new Date();
        /** @type {?} */
        var manhana = fecha.setDate(fecha.getDate() + 1);
        /** @type {?} */
        var fechaFormat = this.datepipe.transform(manhana, 'yyyy-MM-dd');
        this.unavailabilityForm = this.formBuilder.group({
            endDate: [fechaFormat + 'T00:00:00.000Z']
        });
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idEmpresaPac = this.userPerfil.empresa.idEmpresaPac;
        this.formGroup = fb.group({
            rut: [this.peticionReport.docMandante, Validators.compose([CustomValidators.validatorCedulaUY, Validators.required])]
        });
    }
    /**
     * @return {?}
     */
    ReportePagosComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formGroup = new FormGroup({
            keyWord: new FormControl(),
            estadoFacturacion: new FormControl(),
            idFacturador: new FormControl(),
            medioPago: new FormControl(),
            servicio: new FormControl(),
            idpago: new FormControl(),
            rut: new FormControl('', Validators.compose([CustomValidators.validatorCedulaUY])),
            idRubro: new FormControl(),
            fechaPago: new FormControl(),
            fechaVencimiento: new FormControl()
        });
        this.formGroup.get('idFacturador').setValue('-1' + ',' + '-1');
        this.formGroup.get('idRubro').setValue('-1');
        this.formGroup.get('medioPago').setValue('-1');
        this.formGroup.get('estadoFacturacion').setValue('-1');
        this.peticionEmp.idMandante = '-1';
        this.peticionReport.idEstadoFacturacion = -1;
        if (this.codTpoPortal == 'COMERCIO') {
            this.comboComercio = false;
            this.peticionReport.idFacturador = this.idEmpresaPac;
            this.displayedColumns = ['fecha_pago', 'id_pago', 'nro_servicio', 'monto_cargo', 'fecha_vencimiento', 'medio_pago', 'rut', 'suscriptor', 'estado'];
        }
        else {
            this.comboComercio = true;
            this.peticionReport.idFacturador = -1;
            if (this.serviceBase.validaAccesoMenu('reversarPagos')) {
                this.displayedColumns = ['fecha_pago', 'id_pago', 'nro_servicio', 'monto_cargo', 'fecha_vencimiento', 'medio_pago', 'rut', 'suscriptor', 'empresa', 'estado', 'reversar'];
            }
            else {
                this.displayedColumns = ['fecha_pago', 'id_pago', 'nro_servicio', 'monto_cargo', 'fecha_vencimiento', 'medio_pago', 'rut', 'suscriptor', 'empresa', 'estado'];
            }
            this.postSentRubrosServices();
        }
        this.peticionReport.codTipoMedioPago = '-1';
        this.peticionReport.idMandante = -1;
        //comercio
        this.peticionReport.idServicio = '-1';
        this.peticionReport.idFacturacion = -1;
        this.peticionReport.docMandante = '-1';
        this.peticionReport.idConvenio = '-1';
        //this.formGroup.controls['idFacturador'].disable();
        this.setInitialBreadcrumbs();
        this.postTipoMedioPagoServices();
        this.postListEstadoFacturacionServices();
        this.postEmpresas();
    };
    /**
     * @param {?} resultado
     * @param {?} codEstado
     * @return {?}
     */
    ReportePagosComponent.prototype.reversarPago = /**
     * @param {?} resultado
     * @param {?} codEstado
     * @return {?}
     */
    function (resultado, codEstado) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: 'Información', content: "Si realiza esta acci\u00F3n, el pago cambiar\u00E1 su estado.<br>\u00BFEst\u00E1 seguro de esta acci\u00F3n?", showBtnCancel: true },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            if (result) {
                _this.loader.show();
                /** @type {?} */
                var params = {
                    codCliente: _this.environment.codCliente,
                    idPago: parseInt(resultado.idPago),
                    idFacturador: parseInt(resultado.idFacturador),
                    codEstado: codEstado
                };
                _this.phttp.postReportePagoReversar(params).subscribe((/**
                 * @param {?} resp
                 * @return {?}
                 */
                function (resp) {
                    if (resp.codret == 0) {
                        _this.loader.hide();
                        _this.showDialog('Información', "Proceso realizado en forma satisfactoria.", false);
                        _this.postListReportePagosServices(_this.peticionReport);
                    }
                    else {
                        _this.loader.hide();
                        _this.showDialog('Error', 'Error al cambiar estado de pago.<br>Inténtelo nuevamente.', false);
                    }
                }));
            }
        }));
    };
    /**
     * @return {?}
     */
    ReportePagosComponent.prototype.setInitialBreadcrumbs = /**
     * @return {?}
     */
    function () {
        this.hashCaminoMiga[0] = { title: 'Fecha Pago', text: 'Todos' };
        this.hashCaminoMiga[1] = { title: 'Fecha Vencimiento', text: 'Todos' };
        this.hashCaminoMiga[2] = { title: 'ID Pago', text: '' };
        this.hashCaminoMiga[3] = { title: 'ID Servicio', text: '' };
        this.hashCaminoMiga[4] = { title: 'Medio Pago', text: 'Todos' };
        this.hashCaminoMiga[5] = { title: 'Cédula', text: '' };
        this.hashCaminoMiga[6] = { title: 'Estado', text: 'Todos' };
        if (this.codTpoPortal != 'COMERCIO') {
            this.hashCaminoMiga[7] = { title: 'Rubro', text: 'Todos' };
            this.hashCaminoMiga[8] = { title: 'Empresa', text: 'Todas' };
        }
    };
    /**
     * @return {?}
     */
    ReportePagosComponent.prototype.postTipoMedioPagoServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.segmandatosService.postTipoMedioPago(this.ListMedioPagoPost).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoTipoMedioPago = [];
                /** @type {?} */
                var dataString = JSON.parse('{"idTipoMedioPago":"-1","codigoTipoMedioPago":"-1","tipoMedioPago":"-1","marcaMedioPago":"Todos"}');
                data.resultado.splice(0, 0, dataString);
                _this.resultadoTipoMedioPago.push(data);
            }
            else {
                console.error('Error postTipoMedioPago: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postTipoMedioPago: ', err);
        }));
    };
    /**
     * @return {?}
     */
    ReportePagosComponent.prototype.postListEstadoFacturacionServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.fachisservice.postListarEstadoFacturacion().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEstado = [];
                /** @type {?} */
                var dataString = JSON.parse('{"idEstado":"-1","descripcion":"Todos"}');
                data.resultado.splice(0, 0, dataString);
                _this.resultadoEstado.push(data);
            }
            else {
                console.error('Error postListEstadoFacturacionServices', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postListEstadoFacturacionServices', err);
        }));
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    ReportePagosComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.peticionReport.codTpoPortal = this.codTpoPortal;
        this.peticionReport.idMandante = -1;
        this.filtroFechaPago = this.formGroup.get('fechaPago').value;
        if (this.filtroFechaPago != null && this.filtroFechaPago != '01/01/2000') {
            this.peticionReport.fechaInicioPago = formatDate(this.filtroFechaPago.begin, 'dd/MM/yyyy', 'en-US');
            this.peticionReport.fechaFinPago = formatDate(this.filtroFechaPago.end, 'dd/MM/yyyy', 'en-US');
            this.hashCaminoMiga[0] = { title: 'Fecha Pago', text: this.fechaInicioPago + ' - ' + this.fechaFinPago };
        }
        else {
            this.peticionReport.fechaInicioPago = this.fechaInicioPago;
            this.peticionReport.fechaFinPago = this.fechaFinPago;
            this.hashCaminoMiga[0] = { title: 'Fecha Pago', text: 'Todos' };
        }
        this.filtroFechaVencimiento = this.formGroup.get('fechaVencimiento').value;
        if (this.filtroFechaVencimiento != null && this.filtroFechaVencimiento != '01/01/2000') {
            this.peticionReport.fechaInicioVencimiento = formatDate(this.filtroFechaVencimiento.begin, 'dd/MM/yyyy', 'en-US');
            this.peticionReport.fechaFinVencimiento = formatDate(this.filtroFechaVencimiento.end, 'dd/MM/yyyy', 'en-US');
            this.hashCaminoMiga[1] = { title: 'Fecha Vencimiento', text: this.fechaInicioVencimiento + ' - ' + this.fechaFinVencimiento };
        }
        else {
            this.peticionReport.fechaInicioVencimiento = this.fechaInicioVencimiento;
            this.peticionReport.fechaFinVencimiento = this.fechaFinVencimiento;
            this.hashCaminoMiga[1] = { title: 'Fecha Vencimiento', text: 'Todos' };
        }
        if (this.codTpoPortal == 'COMERCIO') {
            this.peticionReport.idFacturador = this.idEmpresaPac;
        }
        else {
            if (this.formGroup.get('idRubro').value == null || this.formGroup.get('idRubro').value == '-1') {
                this.peticionReport.codRubro = '-1';
                this.hashCaminoMiga[7] = { title: 'Rubro', text: 'Todos' };
            }
            else {
                this.peticionReport.codRubro = this.formGroup.get('idRubro').value;
                this.hashCaminoMiga[7] = { title: 'Rubro', text: this.vistaRubro };
            }
            /** @type {?} */
            var idFacturador = this.formGroup.get('idFacturador').value.split(",")[0];
            if (idFacturador == null || idFacturador == '' || idFacturador == -1) {
                this.peticionReport.idFacturador = -1;
                this.peticionReport.idConvenio = '-1';
                this.hashCaminoMiga[8] = { title: 'Empresa', text: 'Todas' };
            }
            else {
                this.peticionReport.idFacturador = this.formGroup.get('idFacturador').value.split(",")[0];
                this.peticionReport.idConvenio = this.formGroup.get('idFacturador').value.split(",")[1];
                this.hashCaminoMiga[8] = { title: 'Empresa', text: this.vistaComercio };
            }
        }
        if (this.formGroup.get('medioPago').value == null || this.formGroup.get('medioPago').value == '-1') {
            this.peticionReport.codTipoMedioPago = '-1';
            this.hashCaminoMiga[4] = { title: 'Medio Pago', text: 'Todos' };
        }
        else {
            this.peticionReport.codTipoMedioPago = this.formGroup.get('medioPago').value;
            this.hashCaminoMiga[4] = { title: 'Medio Pago', text: this.vistaMedioPago };
        }
        if (this.formGroup.get('servicio').value == null || this.formGroup.get('servicio').value == '' || this.formGroup.get('servicio').value == '-1') {
            this.peticionReport.idServicio = '-1';
            this.hashCaminoMiga[3] = { title: 'ID Servicio', text: '' };
        }
        else {
            this.peticionReport.idServicio = this.formGroup.get('servicio').value;
            this.hashCaminoMiga[3] = { title: 'ID Servicio', text: this.formGroup.get('servicio').value };
        }
        if (this.formGroup.get('idpago').value == null || this.formGroup.get('idpago').value == '') {
            this.peticionReport.idFacturacion = -1;
            this.hashCaminoMiga[2] = { title: 'ID Pago', text: '' };
        }
        else {
            this.peticionReport.idFacturacion = this.formGroup.get('idpago').value;
            this.hashCaminoMiga[2] = { title: 'ID Pago', text: this.formGroup.get('idpago').value };
        }
        if (this.formGroup.get('rut').value == null || this.formGroup.get('rut').value == '') {
            this.peticionReport.docMandante = '-1';
            this.hashCaminoMiga[5] = { title: 'Cédula', text: '' };
        }
        else {
            this.peticionReport.docMandante = this.formGroup.get('rut').value;
            this.hashCaminoMiga[5] = { title: 'Cédula', text: this.formGroup.get('rut').value };
        }
        if (this.formGroup.get('estadoFacturacion').value == null || this.formGroup.get('estadoFacturacion').value == '-1') {
            this.peticionReport.idEstadoFacturacion = -1;
            this.hashCaminoMiga[6] = { title: 'Estado', text: 'Todos' };
        }
        else {
            this.peticionReport.idEstadoFacturacion = this.formGroup.get('estadoFacturacion').value;
            this.hashCaminoMiga[6] = { title: 'Estado', text: this.vistaEstado };
        }
        if (tipo == 'excel' || tipo == 'pdf') {
            this.peticionReport.filtros = this.hashCaminoMiga;
            this.postDownloadReportFile(this.peticionReport, tipo);
        }
        else {
            console.log(this.peticionReport);
            if (this.paginator != undefined) {
                this.paginator.pageIndex = 0;
            }
            this.postListReportePagosServices(this.peticionReport);
        }
    };
    /**
     * @param {?} params
     * @return {?}
     */
    ReportePagosComponent.prototype.postListReportePagosServices = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        var _this = this;
        this.loader.show();
        this.show = true;
        this.consulta = 1;
        this.size = 0;
        this.dataSource = new MatTableDataSource();
        params.codCliente = this.environment.codCliente;
        this.phttp.postReportePagos(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                if (data.resultado.length > 0) {
                    _this.dataSource = new MatTableDataSource(data.resultado);
                    _this.dataSource.paginator = _this.paginator;
                    _this.size = data.resultado.length;
                    _this.isCollapsed = true;
                    _this.show = true;
                }
                else {
                    console.error('Resultado sin pagos');
                    _this.isCollapsed = false;
                    _this.show = false;
                }
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.loader.hide();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en postRespuestaReport', err);
            _this.show = false;
            _this.loader.hide();
        }));
    };
    /**
     * @return {?}
     */
    ReportePagosComponent.prototype.postSentRubrosServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new RubroRequest();
        params.codEstadoConvenio = 'HBL';
        this.empresaservice.postRubrosReport(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var rub = new RubroResult();
                rub.codigo = '-1';
                rub.descripcion = "Todos";
                data.resultado.splice(0, 0, rub);
                _this.resultadoRubros = data.resultado;
            }
            else {
                console.log('Error: ', 'postRubrosReport ' + data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error :', 'postRubrosReport ' + err);
        }));
    };
    /**
     * @return {?}
     */
    ReportePagosComponent.prototype.postEmpresas = /**
     * @return {?}
     */
    function () {
        this.peticionEmpresa.codRubro = '-1';
        this.peticionEmpresa.codCliente = this.environment.codCliente;
        this.peticionEmpresa.codEstadoConvenio = 'HBL';
        this.postSentEmpresaServices(this.peticionEmpresa);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    ReportePagosComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.empresaservice.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var empresaResult = new EmpresaResult();
                empresaResult.idFacturador = -1;
                empresaResult.idConvenio = '-1';
                empresaResult.nomFacturador = 'Todas';
                data.resultado.splice(0, 0, empresaResult);
                _this.resultadoEmpresa = data.resultado;
                //this.formGroup.get('idFacturador').setValue(-1);
            }
            else {
                console.log('Error: ', 'postListarEmpresas ' + data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error :', 'postListarEmpresas ' + err);
        }));
    };
    // postSentSelectEmpresaServices(body: EmpresasPeticion) {
    //   this.empresaservice.postListarSelectEmpresas(body).subscribe(data => {
    //     if (data.codret == '0') {
    //       let empresaResult :EmpresaResult = new EmpresaResult();
    //       empresaResult.idFacturador=-1;
    //       empresaResult.nomFacturador="Todas";
    //       data.resultado.splice(0,0,empresaResult);
    //       this.resultadoEmpresa = data.resultado;
    //       this.formGroup.get('idFacturador').setValue(-1);
    //     } else {
    //       console.log('Error: ', 'postListarEmpresas ' + data.descret);
    //     }
    //   }, err => {
    //     console.error("Error postSentSelectempresaServices: ", err);
    //   });
    // }
    // postSentSelectEmpresaServices(body: EmpresasPeticion) {
    //   this.empresaservice.postListarSelectEmpresas(body).subscribe(data => {
    //     if (data.codret == '0') {
    //       let empresaResult :EmpresaResult = new EmpresaResult();
    //       empresaResult.idFacturador=-1;
    //       empresaResult.nomFacturador="Todas";
    //       data.resultado.splice(0,0,empresaResult);
    //       this.resultadoEmpresa = data.resultado;
    //       this.formGroup.get('idFacturador').setValue(-1);
    //     } else {
    //       console.log('Error: ', 'postListarEmpresas ' + data.descret);
    //     }
    //   }, err => {
    //     console.error("Error postSentSelectempresaServices: ", err);
    //   });
    // }
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    ReportePagosComponent.prototype.postDownloadReportFile = 
    // postSentSelectEmpresaServices(body: EmpresasPeticion) {
    //   this.empresaservice.postListarSelectEmpresas(body).subscribe(data => {
    //     if (data.codret == '0') {
    //       let empresaResult :EmpresaResult = new EmpresaResult();
    //       empresaResult.idFacturador=-1;
    //       empresaResult.nomFacturador="Todas";
    //       data.resultado.splice(0,0,empresaResult);
    //       this.resultadoEmpresa = data.resultado;
    //       this.formGroup.get('idFacturador').setValue(-1);
    //     } else {
    //       console.log('Error: ', 'postListarEmpresas ' + data.descret);
    //     }
    //   }, err => {
    //     console.error("Error postSentSelectempresaServices: ", err);
    //   });
    // }
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiMandatosMT/reportepagos/' + tipo;
        filtro.codCliente = this.environment.codCliente;
        this.phttpd.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'reportePagos' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'reportePagos' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ReportePagosComponent.prototype.onMedioPagoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaMedioPago = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ReportePagosComponent.prototype.onEstadoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEstado = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ReportePagosComponent.prototype.onRubroSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event != null) {
            this.vistaRubro = event.source.selected._element.nativeElement.innerText.trim();
            this.peticionEmpresa.codRubro = event.value;
            this.peticionEmpresa.codCliente = this.environment.codCliente;
            this.peticionEmpresa.codEstadoConvenio = 'HBL';
            this.formGroup.controls['idFacturador'].reset('-1' + ',' + '-1');
            this.postSentEmpresaServices(this.peticionEmpresa);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ReportePagosComponent.prototype.onComercioSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaComercio = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @return {?}
     */
    ReportePagosComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.peticionReport.idEstadoFacturacion = -1;
        this.peticionReport.idFacturador = -1;
        this.peticionReport.codTipoMedioPago = '-1';
        this.peticionReport.idServicio = '-1';
        this.peticionReport.idFacturacion = -1;
        this.peticionReport.docMandante = '-1';
        this.peticionReport.codRubro = '-1';
        this.peticionReport.idConvenio = '-1';
        this.postEmpresas();
        this.formGroup.controls.servicio.setValue('');
        this.formGroup.controls.rut.setValue('');
        this.formGroup.controls.idpago.setValue('');
        this.formGroup.get('idFacturador').setValue('-1' + ',' + '-1');
        this.formGroup.get('idRubro').setValue('-1');
        this.formGroup.get('medioPago').setValue('-1');
        this.formGroup.get('estadoFacturacion').setValue('-1');
        this.filtroFechaPago = null;
        this.filtroFechaVencimiento = null;
        this.formGroup.get('fechaPago').setValue(null);
        this.formGroup.get('fechaVencimiento').setValue(null);
        this.fechaInicioPago = '01/01/2000';
        this.fechaFinPago = '01/01/2000';
        this.fechaInicioVencimiento = '01/01/2000';
        this.fechaFinVencimiento = '01/01/2000';
        this.setInitialBreadcrumbs();
        this.size = 0;
        this.consulta = 0;
        this.show = false;
        this.isCollapsed = false;
        this.dataSource = new MatTableDataSource([]);
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    ReportePagosComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ReportePagosComponent.prototype.selectFechaPago = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.fechaInicioPago = formatDate(event.value.begin, 'dd/MM/yyyy', 'en-US');
        this.fechaFinPago = formatDate(event.value.end, 'dd/MM/yyyy', 'en-US');
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ReportePagosComponent.prototype.selectFechaVencimiento = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.fechaInicioVencimiento = formatDate(event.value.begin, 'dd/MM/yyyy', 'en-US');
        this.fechaFinVencimiento = formatDate(event.value.end, 'dd/MM/yyyy', 'en-US');
    };
    /**
     * @return {?}
     */
    ReportePagosComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.onSubmit('');
        }
    };
    /**
     * @param {?} resul
     * @return {?}
     */
    ReportePagosComponent.prototype.formateandoMonto = /**
     * @param {?} resul
     * @return {?}
     */
    function (resul) {
        return FormatoMonedaUtil.formatearMonto(resul);
    };
    /**
     * @return {?}
     */
    ReportePagosComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('componenteHijo');
    };
    /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    ReportePagosComponent.prototype.getEmpresaConvenio = /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    function (nomFacturador, descConvenio) {
        return descConvenio != "" ? nomFacturador + ": " + descConvenio : nomFacturador;
    };
    ReportePagosComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-reporte-pagos',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"modulo-filtros\">\r\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n      </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"formGroup\" autocomplete=\"off\">\r\n              <div class=\"form-row align-left\">\r\n                <div class=\"col-md-6\">\r\n                  <div class=\"filtro-fecha\">\r\n                    <button type=\"button\" class=\"btn fecha\" (click)=\"picker1.open()\"><i class=\"str-icon-calendario\"></i> Buscar por fecha de pago\r\n                      <ng-container *ngIf=\"this.formGroup.get('fechaPago').value != null && this.fechaInicioPago != '01/01/2000' && fechaFinPago != '01/01/2000'\">\r\n                        <span>{{ this.fechaInicioPago + ' - ' + this.fechaFinPago }}</span>\r\n                      </ng-container>\r\n                    </button>\r\n                    <mat-form-field style=\"display: none;\">\r\n                      <input matInput placeholder=\"Fecha\" [max]=\"unavailabilityForm.controls.endDate.value\" [satDatepicker]=\"picker1\" formControlName=\"fechaPago\" (dateInput)=\"selectFechaPago($event)\">\r\n                      <sat-datepicker-toggle matSuffix [for]=\"picker1\"></sat-datepicker-toggle>\r\n                      <sat-datepicker touchUi #picker1 [rangeMode]=\"true\" [selectFirstDateOnClose]=\"true\"></sat-datepicker>\r\n                    </mat-form-field>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                  <div class=\"filtro-fecha\">\r\n                    <button type=\"button\" class=\"btn fecha\" (click)=\"picker2.open()\"><i class=\"str-icon-calendario\"></i> Buscar por fecha de vencimiento\r\n                      <ng-container *ngIf=\"this.formGroup.get('fechaVencimiento').value != null && this.fechaInicioVencimiento != '01/01/2000' && this.fechaFinVencimiento != '01/01/2000'\">\r\n                        <span>{{ this.fechaInicioVencimiento + ' - ' + this.fechaFinVencimiento }}</span>\r\n                      </ng-container>\r\n                    </button>\r\n                    <mat-form-field style=\"display: none;\">\r\n                      <input matInput placeholder=\"Fecha\" [max]=\"unavailabilityForm.controls.endDate.value\" [satDatepicker]=\"picker2\" formControlName=\"fechaVencimiento\" (dateInput)=\"selectFechaVencimiento($event)\">\r\n                      <sat-datepicker-toggle matSuffix [for]=\"picker2\"></sat-datepicker-toggle>\r\n                      <sat-datepicker touchUi #picker2 [rangeMode]=\"true\" [selectFirstDateOnClose]=\"true\"></sat-datepicker>\r\n                    </mat-form-field>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-row\">\r\n                <div class=\"form-group col-md-3\">\r\n                  <mat-form-field>\r\n                    <input matInput placeholder=\"ID Pago\" maxlength=\"18\" inputmode=\"numeric\" pattern=\"[0-9]*\" digitOnly formControlName=\"idpago\">\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-md-3\">\r\n                  <mat-form-field>\r\n                    <input noCaracEsp matInput maxlength=\"20\" placeholder=\"ID Servicio\" formControlName=\"servicio\">\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-md-3\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Medio de Pago\" formControlName=\"medioPago\" (selectionChange)=\"onMedioPagoSelect($event)\">\r\n                      <section *ngFor=\"let resp of resultadoTipoMedioPago\">\r\n                        <mat-option *ngFor=\"let tipo of resp.resultado\" [value]=\"tipo.codigoTipoMedioPago\">{{tipo.marcaMedioPago}}</mat-option>\r\n                      </section>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-md-3\">\r\n                  <mat-form-field>\r\n                    <input matInput placeholder=\"C\u00E9dula\" maxlength=\"8\" formControlName=\"rut\" soloRutUY formatRut>\r\n                    <mat-error *ngIf=\"formGroup.get('rut').hasError('cedulaError')\">C\u00E9dula <strong>incorrecta</strong>.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-row\">\r\n                <div class=\"orm-group col-sm-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estadoFacturacion\" (selectionChange)=\"onEstadoSelect($event)\">\r\n                      <section *ngFor=\"let resp of resultadoEstado\">\r\n                        <mat-option *ngFor=\"let estado of resp.resultado\" [value]=\"estado.idEstado\">{{estado.descripcion}}</mat-option>\r\n                      </section>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-sm-4\" *ngIf=\"comboComercio\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Rubro\" formControlName=\"idRubro\" (selectionChange)=\"onRubroSelect($event)\">\r\n                      <mat-option *ngFor=\"let rubro of resultadoRubros\" [value]=\"rubro.codigo\">{{rubro.descripcion}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-sm-4\" *ngIf=\"comboComercio\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"idFacturador\" (selectionChange)=\"onComercioSelect($event)\">\r\n                      <mat-option class=\"multiline-mat-option\" *ngFor=\"let empresa of resultadoEmpresa\" [value]=\"empresa.idFacturador +','+ empresa.idConvenio\">{{getEmpresaConvenio(empresa.nomFacturador, empresa.descConvenio)}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"actions\">\r\n                <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\" (click)=\"validarForm()\">Filtrar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"resultados-filtros\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-10\">\r\n          <div class=\"tags row\">\r\n            <div *ngFor=\"let entry of hashCaminoMiga\" class=\"item\">{{entry.title}}: {{entry.text}}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n          <div class=\"numero-resultados\">\r\n            <strong>{{ (size == 1) ? ( size + \" Resultado\") : size + \" Resultados\" }}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-container table-responsive-md\">\r\n        <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n          <ng-container matColumnDef=\"fecha_pago\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha pago</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.fechaPago | date:'dd/MM/yyyy'}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"id_pago\">\r\n            <th mat-header-cell *matHeaderCellDef>ID Pago</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.idPago}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"nro_servicio\">\r\n            <th mat-header-cell *matHeaderCellDef>ID Servicio</th>\r\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\"> {{resultado.idServicio}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"monto_cargo\">\r\n            <th mat-header-cell *matHeaderCellDef>Monto pago</th>\r\n            <td mat-cell *matCellDef=\"let resultado\" style=\"text-align: right\">{{formateandoMonto(resultado)}}</td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"fecha_vencimiento\">\r\n            <th mat-header-cell *matHeaderCellDef>Fecha vencimiento</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.fechaVencimiento | date:'dd/MM/yyyy'}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"medio_pago\">\r\n            <th mat-header-cell *matHeaderCellDef>Medio de pago</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.medioPago == '-'; else elseBlockmedioPago\">Sin Informaci&oacute;n</span>\r\n              <ng-template #elseBlockmedioPago>{{resultado.medioPago}} </ng-template>\r\n              </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"rut\">\r\n            <th mat-header-cell *matHeaderCellDef>C\u00E9dula</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.documentoMandante == '-'; else elseBlockRut\">Sin Informaci&oacute;n</span>\r\n              <ng-template #elseBlockRut>{{pipeRut.transform(resultado.documentoMandante)}}</ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"suscriptor\">\r\n            <th mat-header-cell *matHeaderCellDef>Suscriptor</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.nombreSuscriptor == '-'; else elseBlockSuscriptor\">Sin Informaci&oacute;n</span>\r\n              <ng-template #elseBlockSuscriptor>{{resultado.nombreSuscriptor}} </ng-template>\r\n              </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"empresa\" *ngIf=\"comboComercio\">\r\n            <th mat-header-cell *matHeaderCellDef>Empresa</th>\r\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\"> {{resultado.razonSocial}}: {{resultado.descConvenio}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"estado\">\r\n            <th mat-header-cell *matHeaderCellDef>Estado</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.estadoPago}} \r\n              <span *ngIf=\"resultado.estadoPago == 'Reversada' || resultado.estadoPago == 'Rechazada'\" style=\"display: block; font-weight: bolder;\"> {{resultado.desCobro}} </span>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"reversar\">\r\n            <th mat-header-cell *matHeaderCellDef>Reversar</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> \r\n              <a matTooltip=\"Reversar\" matTooltipPosition=\"above\" Style=\"cursor: pointer;\" *ngIf=\"resultado.estadoPago === 'Pagada'\" (click)=\"reversarPago(resultado, 'rev')\"><i class=\"icon str-icon-renovar\"></i></a>\r\n              <a matTooltip=\"Reversar\" matTooltipPosition=\"above\" Style=\"cursor: pointer;\" *ngIf=\"resultado.estadoPago === 'Reversada'\" (click)=\"reversarPago(resultado, 'pag')\"><i class=\"icon str-icon-renovar\"></i></a>\r\n            </td>\r\n          </ng-container>\r\n\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n        </table>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" showFirstLastButtons></mat-paginator>\r\n      </div>\r\n      <div class=\"box-actions\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6 item\">\r\n            <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n          </div>\r\n          <div class=\"col-md-6 item-right\">\r\n            <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </section>\r\n\r\n    <div class=\"modulo-cuentas\" *ngIf=\"!show && consulta == 0\">\r\n      <span>Establezca sus criterios de b&uacute;squeda.</span>\r\n    </div>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"!show && consulta == 1 && size == 0\">\r\n      <span>No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.</span>\r\n    </div>\r\n  </div>\r\n</section>",
                    providers: [ReportePagoService, DescargaExcelPdfFileService, EmpresasService,
                        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
                        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
                        { provide: MAT_DATE_FORMATS, useValue: ɵ0$j }]
                }] }
    ];
    /** @nocollapse */
    ReportePagosComponent.ctorParameters = function () { return [
        { type: ReportePagoService },
        { type: EmpresasService },
        { type: SegmandatosService },
        { type: DescargaExcelPdfFileService },
        { type: MatDialog },
        { type: LoaderBaseService },
        { type: ServicesBaseService },
        { type: FacturacionHistorialService },
        { type: FormBuilder },
        { type: RutValidator },
        { type: FormBuilder },
        { type: DatePipe },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    ReportePagosComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator,] }],
        sort: [{ type: ViewChild, args: [MatSort,] }]
    };
    return ReportePagosComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UsuariosParams = /** @class */ (function () {
    function UsuariosParams() {
        this.docEmpresa = '';
        this.idUsuario = '';
        this.tipoListado = '';
    }
    /**
     * @return {?}
     */
    UsuariosParams.prototype.isNull = /**
     * @return {?}
     */
    function () {
        if (this.docEmpresa === '' && this.idUsuario === '' && this.tipoListado === '') {
            return true;
        }
        else {
            return false;
        }
    };
    return UsuariosParams;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UsuarioParamsService = /** @class */ (function () {
    function UsuarioParamsService() {
        this.usuario = new UsuariosParams();
    }
    /**
     * @return {?}
     */
    UsuarioParamsService.prototype.getUsuarioParams = /**
     * @return {?}
     */
    function () {
        Object.assign(this.usuario, JSON.parse(sessionStorage.getItem('UsuarioParams')));
        if (this.usuario.isNull()) {
            return null;
        }
        else {
            return this.usuario;
        }
    };
    /**
     * @param {?} usuario
     * @return {?}
     */
    UsuarioParamsService.prototype.setUsuarioParams = /**
     * @param {?} usuario
     * @return {?}
     */
    function (usuario) {
        if (usuario == null) {
            sessionStorage.removeItem('UsuarioParams');
        }
        else {
            sessionStorage.setItem('UsuarioParams', JSON.stringify(usuario));
        }
    };
    UsuarioParamsService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    UsuarioParamsService.ctorParameters = function () { return []; };
    /** @nocollapse */ UsuarioParamsService.ngInjectableDef = defineInjectable({ factory: function UsuarioParamsService_Factory() { return new UsuarioParamsService(); }, token: UsuarioParamsService, providedIn: "root" });
    return UsuarioParamsService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CrearCuentaDatosPeticion = /** @class */ (function () {
    function CrearCuentaDatosPeticion() {
    }
    return CrearCuentaDatosPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var httpOptions$g = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};
var UsuariosService = /** @class */ (function () {
    function UsuariosService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlApiListaUsuarios = this.environment.urlAmbiente + '/apiUsuariosMT/listaUsuarios';
        this.urlResetClave = this.environment.urlAmbiente + '/apiUsuariosMT/resetClave';
        this.urlListarEstadoUsuarios = this.environment.urlAmbiente + '/apiUsuariosMT/listEstadoUserEmp';
        this.urlCrearUsuarios = this.environment.urlAmbiente + '/apiUsuariosMT/crearusuario';
        this.urlEditarUsuarios = this.environment.urlAmbiente + '/apiUsuariosMT/usuarioEditar';
    }
    /**
     * @param {?} params
     * @return {?}
     */
    UsuariosService.prototype.doCrearUsuario = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlCrearUsuarios, params, httpOptions$g);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    UsuariosService.prototype.doEditarUsuario = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlEditarUsuarios, params, httpOptions$g);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    UsuariosService.prototype.doListarUsuarios = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlApiListaUsuarios, params, httpOptions$g);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    UsuariosService.prototype.doResetClave = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlResetClave, params, httpOptions$g);
    };
    /**
     * @return {?}
     */
    UsuariosService.prototype.doListarEstadoUsuarios = /**
     * @return {?}
     */
    function () {
        return this.http.post(this.urlListarEstadoUsuarios, null, httpOptions$g);
    };
    UsuariosService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    UsuariosService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    /** @nocollapse */ UsuariosService.ngInjectableDef = defineInjectable({ factory: function UsuariosService_Factory() { return new UsuariosService(inject(HttpClient), inject("env")); }, token: UsuariosService, providedIn: "root" });
    return UsuariosService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CrearCuentaDatosComponent = /** @class */ (function () {
    function CrearCuentaDatosComponent(router, route, usuarioservice, perfilesService, dialog, usuarioparams, empresaservice, fb, rutValidator, loader, environment) {
        this.router = router;
        this.route = route;
        this.usuarioservice = usuarioservice;
        this.perfilesService = perfilesService;
        this.dialog = dialog;
        this.usuarioparams = usuarioparams;
        this.empresaservice = empresaservice;
        this.fb = fb;
        this.rutValidator = rutValidator;
        this.loader = loader;
        this.environment = environment;
        this.crearCuentaDatosPeticion = new CrearCuentaDatosPeticion();
        this.peticionEmpresa = new EmpresasPeticion();
        this.resultadoEmpresa = [];
        this.perfilesPeticion = new PerfilesListPeticion();
        this.perfilesResultado = [];
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
        this.idUsuario = this.userPerfil.usuario.idUsuario;
    }
    /**
     * @return {?}
     */
    CrearCuentaDatosComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formGroup = new FormGroup({
            rubro: new FormControl(''),
            empresa: new FormControl('', Validators.required),
            perfil: new FormControl('', Validators.required),
            nombre: new FormControl('', Validators.compose([Validators.required, CustomValidators.nameValidator])),
            primerApellido: new FormControl('', Validators.compose([Validators.required, CustomValidators.nameValidator])),
            segundoApellido: new FormControl('', Validators.compose([CustomValidators.nameValidator])),
            rut: new FormControl('', Validators.compose([CustomValidators.validatorCedulaUY, Validators.required])),
            email: new FormControl('', Validators.compose([Validators.email, Validators.required])),
            repetirEmail: new FormControl('', Validators.compose([Validators.email, Validators.required])),
            // codfijo: new FormControl('', Validators.compose([CustomValidators.numberValidator, Validators.maxLength(3)])),
            // fijo: new FormControl('', Validators.compose([CustomValidators.numberValidator, Validators.maxLength(9), Validators.minLength(8)])),
            codmovil: new FormControl('', Validators.compose([CustomValidators.numberValidator, Validators.maxLength(3), Validators.required])),
            movil: new FormControl('', Validators.compose([CustomValidators.numberValidator, Validators.maxLength(9), Validators.minLength(8), Validators.required])),
            region: new FormControl(),
            comuna: new FormControl(),
            direccion: new FormControl('', Validators.compose([Validators.maxLength(250), , CustomValidators.descriptionValidator])),
            cargo: new FormControl('', Validators.compose([CustomValidators.nameValidator]))
        });
        this.usuarioParam = this.usuarioparams.getUsuarioParams();
        if (this.usuarioParam == null) {
            this.router.navigate(['../'], { relativeTo: this.route });
            return;
        }
        this.postSentRubrosServices();
        this.docEmpresa = this.usuarioParam.docEmpresa;
        if (this.usuarioParam.tipoListado == 'EMPRESAS') {
            this.codTpoPortal = 'COMERCIO';
        }
        else {
            /** @type {?} */
            var params = new EmpresasPeticion();
            params.codCliente = this.environment.codCliente;
            params.docEmpresa = this.docEmpresa;
            //this.postSentEmpresaServices(params);
            this.postSentSelectEmpresaServices(params);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    CrearCuentaDatosComponent.prototype.onPerfilSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.crearCuentaDatosPeticion.descPerfil = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @return {?}
     */
    CrearCuentaDatosComponent.prototype.doValidaDatos = /**
     * @return {?}
     */
    function () {
        //let params: CrearCuentaDatosPeticion = new CrearCuentaDatosPeticion();
        this.crearCuentaDatosPeticion.codCliente = this.environment.codCliente;
        this.crearCuentaDatosPeticion.codTpoPortal = (this.usuarioParam.tipoListado == 'EMPRESAS') ? 'COMERCIO' : this.codTpoPortal;
        this.crearCuentaDatosPeticion.docEmpresa = this.formGroup.get('empresa').value;
        this.crearCuentaDatosPeticion.nombre = this.formGroup.get('nombre').value;
        this.crearCuentaDatosPeticion.paterno = this.formGroup.get('primerApellido').value;
        this.crearCuentaDatosPeticion.materno = this.formGroup.get('segundoApellido').value;
        // let codFijo:string = this.formGroup.get('codfijo').value;
        // let fonofijo:string = this.formGroup.get('fijo').value;
        // this.numeroFijoCompleto = codFijo + fonofijo;
        // this.crearCuentaDatosPeticion.fonofijo = this.numeroFijoCompleto;
        this.crearCuentaDatosPeticion.fonofijo = "";
        /** @type {?} */
        var codmovil = this.formGroup.get('codmovil').value;
        /** @type {?} */
        var fonomovil = this.formGroup.get('movil').value;
        this.numeroMovilCompleto = codmovil + fonomovil;
        this.crearCuentaDatosPeticion.fonomovil = this.numeroMovilCompleto;
        this.crearCuentaDatosPeticion.direccion = this.formGroup.get('direccion').value;
        this.crearCuentaDatosPeticion.email = this.formGroup.get('email').value;
        this.crearCuentaDatosPeticion.cargo = this.formGroup.get('cargo').value;
        this.crearCuentaDatosPeticion.docUsrIde = this.formGroup.get('rut').value;
        this.crearCuentaDatosPeticion.docUsrEmp = this.formGroup.get('rut').value;
        this.crearCuentaDatosPeticion.claveUsuario = '-1';
        this.crearCuentaDatosPeticion.idUsuario = this.idUsuario;
        if (this.formGroup.get('email').value == this.formGroup.get('repetirEmail').value) {
            this.showDialogPre('Información', 'Si realiza esta acción, agregará un nuevo usuario.<br>¿Está seguro?', true);
        }
        else {
            this.showDialog('Error', 'Verifique los correos electrónicos.', false);
        }
    };
    /**
     * @param {?} body
     * @return {?}
     */
    CrearCuentaDatosComponent.prototype.postCrearUsuarioServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.usuarioservice.doCrearUsuario(this.crearCuentaDatosPeticion).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0' || data.codret == '1') {
                _this.loader.hide();
                if (data.codret == '1') {
                    _this.showDialogOk('Información', 'El usuario ha sido creado, pero no se pudo enviar una clave temporal por correo.', false);
                }
                else {
                    _this.showDialogOk('Información', 'Usuario agregado de forma satisfactoria.', false);
                }
            }
            else {
                _this.loader.hide();
                _this.showDialog('Error', 'No ha sido posible agregar el usuario.', false);
            }
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.loader.hide();
            _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @return {?}
     */
    CrearCuentaDatosComponent.prototype.postSentRubrosServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var param = new RubroRequest();
        param.codEstadoConvenio = 'HBL'; //Solo los activos
        this.empresaservice.postRubrosReport(param).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoRubros = data.resultado;
            }
            else {
                console.error('Error postRubrosReport: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postRubrosReport: ', err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    CrearCuentaDatosComponent.prototype.onRubroSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event != null) {
            this.peticionEmpresa.codRubro = event.value;
            this.peticionEmpresa.codCliente = this.environment.codCliente;
            this.peticionEmpresa.codEstadoConvenio = 'HBL';
            this.formGroup.get('empresa').reset();
            this.formGroup.get('perfil').reset('');
            //this.formGroup.get('perfil').disable();
            //this.postSentEmpresaServices(this.peticionEmpresa);      
            this.postSentSelectEmpresaServices(this.peticionEmpresa);
        }
        this.vistaRubro = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} body
     * @return {?}
     */
    CrearCuentaDatosComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.empresaservice.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0' && data.resultado.length > 0) {
                _this.resultadoEmpresa = data.resultado;
                if (_this.usuarioParam.tipoListado != 'EMPRESAS') {
                    _this.formGroup.get('rubro').setValue(data.resultado[0].codRubro);
                    _this.formGroup.get('rubro').disable();
                    _this.formGroup.get('empresa').setValue(_this.docEmpresa);
                    _this.formGroup.get('empresa').disable();
                    _this.postPerfilesListServices(_this.docEmpresa);
                }
                else {
                    _this.formGroup.get('empresa').enable();
                }
            }
            else {
                _this.formGroup.get('empresa').disable();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postListarEmpresas', err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    CrearCuentaDatosComponent.prototype.postSentSelectEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.empresaservice.postListarSelectEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0' && data.resultado.length > 0) {
                _this.resultadoEmpresa = data.resultado;
                if (_this.usuarioParam.tipoListado != 'EMPRESAS') {
                    _this.formGroup.get('rubro').setValue(data.resultado[0].codRubro);
                    _this.formGroup.get('rubro').disable();
                    _this.formGroup.get('empresa').setValue(_this.docEmpresa);
                    _this.formGroup.get('empresa').disable();
                    _this.postPerfilesListServices(_this.docEmpresa);
                }
                else {
                    _this.formGroup.get('empresa').enable();
                }
            }
            else {
                console.log('Error: ', 'postListarSelectEmpresas ' + data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error("Error postListarSelectEmpresas: ", err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    CrearCuentaDatosComponent.prototype.onEmpresaSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.postPerfilesListServices(event.value);
        this.vistaEmpresa = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} docEmpresa
     * @return {?}
     */
    CrearCuentaDatosComponent.prototype.postPerfilesListServices = /**
     * @param {?} docEmpresa
     * @return {?}
     */
    function (docEmpresa) {
        var _this = this;
        /** @type {?} */
        var params = new PerfilesListPeticion();
        params.codCliente = this.environment.codCliente;
        params.docEmpresa = docEmpresa;
        params.codEstadoPerfil = 'ACTIVO';
        this.perfilesService.postPerfilesList(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0' && data.resultado.length > 0) {
                _this.formGroup.get('perfil').reset('');
                _this.perfilesResultado = null;
                _this.perfilesResultado = data.resultado;
                _this.formGroup.get('perfil').enable();
            }
            else {
                _this.perfilesResultado = null;
                _this.formGroup.get('perfil').reset('');
                //this.formGroup.get('perfil').disable();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postPerfilesList', err);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    CrearCuentaDatosComponent.prototype.showDialogPre = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            if (result) {
                _this.postCrearUsuarioServices(_this.crearCuentaDatosPeticion);
            }
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    CrearCuentaDatosComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    CrearCuentaDatosComponent.prototype.showDialogOk = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            _this.callListarUsuarios();
        }));
    };
    /**
     * @return {?}
     */
    CrearCuentaDatosComponent.prototype.callListarUsuarios = /**
     * @return {?}
     */
    function () {
        this.router.navigate(['../'], { relativeTo: this.route });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    CrearCuentaDatosComponent.prototype.formatearTelefono = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var numero = event.target.value;
        numero = numero.trim();
        /** @type {?} */
        var sep = ' ';
        /** @type {?} */
        var len = numero.length;
        /** @type {?} */
        var numeroFormato = numero;
        if (len <= 10) {
            numeroFormato = numero.replace(/(\d{1,3})(\d{3})(\d{4})/, '$1' + sep + '$2' + sep + '$3');
        }
        else {
            numeroFormato = numero.replace(/(\d+)(\d{3})(\d{3})(\d{4})/, '$1' + sep + '$2' + sep + '$3' + sep + '$4');
        }
        this.formGroup.get('movil').setValue(numeroFormato);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    CrearCuentaDatosComponent.prototype.keyPress = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var inputChar = event.charCode;
        if ((inputChar <= '47' || inputChar >= '58') && (inputChar <= '64' || inputChar >= '91')
            && (inputChar <= '96' || inputChar >= '123') && (inputChar <= '31' || inputChar >= '33')) {
            event.preventDefault();
        }
    };
    CrearCuentaDatosComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-crear-cuenta-datos',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a (click)=\"callListarUsuarios()\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <form [formGroup]=\"formGroup\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n        <h3>Agregar nuevo usuario</h3>\r\n        <div class=\"form-section\">\r\n          <h5>Datos empresa</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Rubro\" formControlName=\"rubro\" (selectionChange)=\"onRubroSelect($event)\">\r\n                  <mat-option *ngFor=\"let rubro of resultadoRubros\" [value]=\"rubro.codigo\">{{rubro.descripcion}}</mat-option>\r\n                </mat-select>\r\n                <mat-error *ngIf=\"formGroup.get('rubro').invalid\">Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-8\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"empresa\" (selectionChange)=\"onEmpresaSelect($event)\">\r\n                  <mat-option *ngFor=\"let empresa of resultadoEmpresa\" [value]=\"empresa.docFacturador\">{{empresa.nomFacturador}}</mat-option>\r\n                </mat-select>\r\n                <mat-error *ngIf=\"formGroup.get('nombre').invalid\">Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-section\">\r\n            <h5>Datos usuario</h5>\r\n            <div class=\"form-row\">\r\n              <div class=\"col-md-4\">\r\n                <mat-form-field>\r\n                  <input matInput placeholder=\"C\u00E9dula\" maxlength=\"8\" soloRutUY formControlName=\"rut\" formatRut>\r\n                  <mat-hint>Ej. 9.999.999-9</mat-hint>\r\n                  <mat-error *ngIf=\"formGroup.get('rut').hasError('required')\">Este campo es requerido.</mat-error>\r\n                  <mat-error *ngIf=\"formGroup.get('rut').hasError('cedulaError')\">C\u00E9dula <strong>incorrecta</strong>.</mat-error>\r\n                </mat-form-field>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <mat-form-field>\r\n                  <mat-select matNativeControl placeholder=\"Perfil\" formControlName=\"perfil\" (selectionChange)=\"onPerfilSelect($event)\">\r\n                    <mat-option *ngFor=\"let perfil of perfilesResultado\" [value]=\"perfil.idPerfil\">{{perfil.descPerfil}}</mat-option>\r\n                  </mat-select>\r\n                  <mat-error *ngIf=\"formGroup.get('perfil').invalid\">Este campo es requerido.</mat-error>\r\n                </mat-form-field>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <mat-form-field>\r\n                  <input matInput maxlength=\"48\" placeholder=\"Cargo\" formControlName=\"cargo\" >\r\n                  <mat-error>Ingrese un cargo v&aacute;lido.</mat-error>\r\n                </mat-form-field>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-row\">\r\n              <div class=\"col-md-4\">\r\n                <mat-form-field>\r\n                  <input matInput maxlength=\"48\" placeholder=\"Nombre\" formControlName=\"nombre\" >\r\n                  <mat-error *ngIf=\"formGroup.get('nombre').hasError('nameError')\">Ingrese un nombre v&aacute;lido.</mat-error>\r\n                  <mat-error *ngIf=\"formGroup.get('nombre').hasError('required')\">Este campo es requerido.</mat-error>\r\n                </mat-form-field>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <mat-form-field>\r\n                  <input matInput maxlength=\"48\" placeholder=\"Primer apellido\" formControlName=\"primerApellido\" >\r\n                  <mat-error *ngIf=\"formGroup.get('primerApellido').hasError('nameError')\">Ingrese un apellido v&aacute;lido.</mat-error>\r\n                  <mat-error *ngIf=\"formGroup.get('primerApellido').hasError('required')\">Este campo es requerido.</mat-error>\r\n                </mat-form-field>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <mat-form-field>\r\n                  <input matInput maxlength=\"48\" placeholder=\"Segundo apellido\" formControlName=\"segundoApellido\" >\r\n                  <mat-error *ngIf=\"formGroup.get('segundoApellido').hasError('nameError')\">Ingrese un apellido v&aacute;lido.</mat-error>\r\n                </mat-form-field>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-row\">\r\n              <div class=\"col-md-6\">\r\n                <mat-form-field>\r\n                  <input matInput maxlength=\"48\" placeholder=\"Email\" formControlName=\"email\">\r\n                  <mat-error *ngIf=\"formGroup.get('email').invalid\">Este campo es requerido.</mat-error>\r\n                </mat-form-field>\r\n              </div>\r\n              <div class=\"col-md-6\">\r\n                <mat-form-field>\r\n                  <input matInput maxlength=\"48\" placeholder=\"Confirmar email\" formControlName=\"repetirEmail\">\r\n                  <mat-error *ngIf=\"formGroup.get('repetirEmail').invalid\">Este campo es requerido.</mat-error>\r\n                </mat-form-field>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-row\">\r\n              <!-- <div class=\"col-sm-6 col-md-2\">\r\n                <mat-form-field>\r\n                  <span matPrefix>+</span>\r\n                  <input matInput digitOnly size=\"4\" placeholder=\"C&oacute;digo Pa&iacute;s\" formControlName=\"codfijo\" maxlength=\"3\" >\r\n                </mat-form-field>\r\n              </div>\r\n              <div class=\"col-sm-6 col-md-4\">\r\n                <mat-form-field>\r\n                  <input matInput digitOnly placeholder=\"Tel&eacute;fono fijo\" formControlName=\"fijo\" maxlength=\"8\" >\r\n                </mat-form-field>\r\n              </div> -->\r\n              <div class=\"col-sm-6 col-md-2\">\r\n                <mat-form-field>\r\n                  <span matPrefix>+</span>\r\n                  <input matInput digitOnly size=\"4\" placeholder=\"C&oacute;digo Pa&iacute;s\" formControlName=\"codmovil\" maxlength=\"3\" >\r\n                  <mat-error>Este campo es requerido.</mat-error>\r\n                </mat-form-field>\r\n              </div>\r\n              <div class=\"col-sm-6 col-md-4\">\r\n                <mat-form-field>\r\n                  <input matInput digitOnly placeholder=\"Tel&eacute;fono m&oacute;vil\" formControlName=\"movil\" maxlength=\"8\" >\r\n                  <mat-error>Este campo es requerido.</mat-error>\r\n                </mat-form-field>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-row\">\r\n              <div class=\"col-md-6\">\r\n                <mat-form-field>\r\n                  <input matInput maxlength=\"250\" placeholder=\"Direcci&oacute;n\" formControlName=\"direccion\" >\r\n                  <mat-error>Ingrese una direcci&oacute;n v&aacute;lida.</mat-error>\r\n                </mat-form-field>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-row\">\r\n              <div class=\"col align-right\">\r\n                <button *ngIf=\"formGroup.invalid\" class=\"btn main\">Finalizar</button>\r\n                <button *ngIf=\"formGroup.valid\" class=\"btn main\" type=\"submit\" (click)=\"doValidaDatos()\">Finalizar</button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    CrearCuentaDatosComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: UsuariosService },
        { type: PerfilesService },
        { type: MatDialog },
        { type: UsuarioParamsService },
        { type: EmpresasService },
        { type: FormBuilder },
        { type: RutValidator },
        { type: LoaderBaseService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return CrearCuentaDatosComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EditarCuentaDatosPeticion = /** @class */ (function () {
    function EditarCuentaDatosPeticion() {
    }
    return EditarCuentaDatosPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListUsuariosPeticionReporte = /** @class */ (function () {
    function ListUsuariosPeticionReporte() {
        this.docEmpresa = '-1';
        this.idUsrEmp = '-1';
        this.codCliente = '-1';
        this.identificador = '-1';
        this.estadoUserEmp = '-1';
        this.idPerfil = '-1';
        this.menuOption = '-1';
        this.codTpoPortal = '-1';
        this.codRubro = '-1';
        this.filtros = [];
    }
    return ListUsuariosPeticionReporte;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EditarCuentaDatosComponent = /** @class */ (function () {
    function EditarCuentaDatosComponent(usuarioparams, usuarioservice, perfilesService, dialog, router, route, loader, environment) {
        this.usuarioparams = usuarioparams;
        this.usuarioservice = usuarioservice;
        this.perfilesService = perfilesService;
        this.dialog = dialog;
        this.router = router;
        this.route = route;
        this.loader = loader;
        this.environment = environment;
        this.formGroup = new FormGroup({
            documento: new FormControl({ value: '', disabled: true }, CustomValidators.validatorCedulaUY),
            perfil: new FormControl('', Validators.required),
            nombre: new FormControl('', Validators.compose([Validators.required, CustomValidators.nameValidator])),
            primerApellido: new FormControl('', Validators.compose([Validators.required, CustomValidators.nameValidator])),
            segundoApellido: new FormControl('', Validators.compose([CustomValidators.nameValidator])),
            email: new FormControl('', Validators.compose([Validators.email, Validators.maxLength(48), Validators.required])),
            estado: new FormControl('', Validators.required),
            // codfijo: new FormControl('', Validators.compose([CustomValidators.numberValidator, Validators.maxLength(3)])),
            // fijo: new FormControl('', Validators.compose([CustomValidators.numberValidator, Validators.maxLength(9), Validators.minLength(8)])),
            codmovil: new FormControl('', Validators.compose([CustomValidators.numberValidator, Validators.maxLength(3), Validators.required])),
            movil: new FormControl('', Validators.compose([CustomValidators.numberValidator, Validators.maxLength(9), Validators.minLength(8), Validators.required])),
            cargo: new FormControl('', Validators.compose([CustomValidators.nameValidator])),
            direccion: new FormControl('', Validators.compose([Validators.maxLength(250), CustomValidators.descriptionValidator]))
        });
        this.resultadoEstados = [];
        this.perfilesResultado = [];
        this.editarCuentaDatosPeticion = new EditarCuentaDatosPeticion();
        this.pipeRut = new RutPipe();
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idUsuario = this.userPerfil.usuario.idUsuario;
    }
    /**
     * @return {?}
     */
    EditarCuentaDatosComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.usuarioParam = this.usuarioparams.getUsuarioParams();
        if (this.usuarioParam.tipoListado == 'USUARIOS') {
            sessionStorage.setItem('componenteHijo', 'app-editar-cuenta-datos');
        }
        else {
            sessionStorage.setItem('componenteHijo', 'app-editar-cuenta-datos-emp');
        }
        if (this.usuarioParam == null) {
            this.router.navigate(['../'], { relativeTo: this.route });
            return;
        }
        this.docEmpresa = this.usuarioParam.docEmpresa;
        this.postSentEstadosServices();
        this.postPerfilesListServices();
        this.postListarUsuariosServices();
    };
    /**
     * @return {?}
     */
    EditarCuentaDatosComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        //Se elimina el usuario editado de la memoria...
        this.usuarioparams.setUsuarioParams(null);
    };
    /**
     * @return {?}
     */
    EditarCuentaDatosComponent.prototype.doEditarUsuario = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new EditarCuentaDatosPeticion();
        params.codCliente = this.environment.codCliente;
        params.codTpoPortal = (this.usuarioParam.tipoListado == 'EMPRESAS') ? 'COMERCIO' : this.codTpoPortal;
        params.docEmpresa = this.docEmpresa;
        params.docUsrEmp = this.rutResultado;
        params.nombre = this.formGroup.get('nombre').value;
        params.apellidoPaterno = this.formGroup.get('primerApellido').value;
        params.apellidoMaterno = this.formGroup.get('segundoApellido').value;
        // let codFijo: string = this.formGroup.get('codfijo').value;
        // let fonofijo: string = this.formGroup.get('fijo').value;
        // this.numeroFijoCompleto = codFijo + fonofijo;
        // params.fonoFijo = this.numeroFijoCompleto;
        params.fonoFijo = "";
        /** @type {?} */
        var codmovil = this.formGroup.get('codmovil').value;
        /** @type {?} */
        var fonomovil = this.formGroup.get('movil').value;
        this.numeroMovilCompleto = codmovil + fonomovil;
        params.fonoMovil = this.numeroMovilCompleto;
        params.direccion = this.formGroup.get('direccion').value;
        params.email = this.formGroup.get('email').value;
        params.cargo = this.formGroup.get('cargo').value;
        params.idUsuario = this.idUsuario;
        params.codEstadoUserEmp = this.formGroup.get('estado').value;
        params.idPerfil = this.formGroup.get('perfil').value;
        this.loader.show();
        this.usuarioservice.doEditarUsuario(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == "0") {
                _this.loader.hide();
                _this.showDialogOk('Información', 'Usuario editado de forma satisfactoria.', false);
            }
            else {
                _this.loader.hide();
                console.error('Error doEditarUsuario', data.descret);
                _this.showDialog('Error', 'No ha sido posible editar el usuario, intente nuevamente.', false);
            }
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.loader.hide();
            console.error('Error doEditarUsuario', error);
            _this.showDialog('Error', 'Error al editar el usuario, contáctese con el administrador de sistema.', false);
        }));
    };
    /**
     * @return {?}
     */
    EditarCuentaDatosComponent.prototype.validaDatos = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.showDialogPre('Información', 'Si realiza esta acción, editará el usuario.<br>¿Está seguro?', true);
        }
        else {
            this.showDialog('Error', 'Ingrese los datos requeridos.', false);
        }
    };
    /**
     * @return {?}
     */
    EditarCuentaDatosComponent.prototype.postSentEstadosServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.usuarioservice.doListarEstadoUsuarios().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEstados = data.resultado;
            }
            else {
                console.error('Error doListarEstadoUsuarios: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error doListarEstadoUsuarios: ', err);
        }));
    };
    /**
     * @param {?} cadena
     * @return {?}
     */
    EditarCuentaDatosComponent.prototype.cambiarNulo = /**
     * @param {?} cadena
     * @return {?}
     */
    function (cadena) {
        if (cadena == 'null') {
            cadena = '';
        }
        return cadena;
    };
    /**
     * @return {?}
     */
    EditarCuentaDatosComponent.prototype.postListarUsuariosServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.loader.show();
        /** @type {?} */
        var params = new ListUsuariosPeticionReporte();
        params.docEmpresa = this.usuarioParam.docEmpresa;
        params.codCliente = this.environment.codCliente;
        params.idUsrEmp = this.usuarioParam.idUsuario;
        this.usuarioservice.doListarUsuarios(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var resultadoReporte = data.resultado[0];
                _this.rutResultado = resultadoReporte.doc_usuario_emp;
                _this.formGroup.get('documento').setValue(_this.pipeRut.transform(_this.rutResultado));
                _this.formGroup.get('nombre').setValue(resultadoReporte.nom_usuario);
                _this.formGroup.get('primerApellido').setValue(resultadoReporte.pat_usuario);
                _this.formGroup.get('segundoApellido').setValue(_this.cambiarNulo(resultadoReporte.mat_usuario));
                _this.formGroup.get('perfil').setValue(resultadoReporte.idPerfil);
                _this.formGroup.get('email').setValue(resultadoReporte.email_usuario_emp);
                // this.formGroup.get('codfijo').setValue(this.cambiarNulo(this.setCodTelefono(resultadoReporte.fono_usuario)));
                // this.formGroup.get('fijo').setValue(this.cambiarNulo(this.setNumTelefono(resultadoReporte.fono_usuario)));
                _this.formGroup.get('codmovil').setValue(_this.cambiarNulo(_this.setCodTelefono(resultadoReporte.movil_usuario)));
                _this.formGroup.get('movil').setValue(_this.cambiarNulo(_this.setNumTelefono(resultadoReporte.movil_usuario)));
                _this.formGroup.get('direccion').setValue(_this.cambiarNulo(resultadoReporte.dir_usuario));
                _this.formGroup.get('cargo').setValue(_this.cambiarNulo(resultadoReporte.cargo_usuario));
                _this.formGroup.get('estado').setValue(resultadoReporte.codEstadoUserEmp);
                _this.loader.hide();
            }
            else {
                _this.loader.hide();
                _this.showDialogOk('Error: ', 'Servicio temporalmente no disponible.', false);
                console.error('Error doListarUsuarios', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            _this.showDialogOk('Error: ', 'Servicio temporalmente no disponible.', false);
            console.error('Error doListarUsuarios', err);
        }));
    };
    /**
     * @param {?} numero
     * @return {?}
     */
    EditarCuentaDatosComponent.prototype.setCodTelefono = /**
     * @param {?} numero
     * @return {?}
     */
    function (numero) {
        /** @type {?} */
        var codigo = '';
        if (numero != null) {
            if (numero.length != 0)
                codigo = (numero == 'null') ? '' : numero.substr(0, 3);
        }
        return codigo;
    };
    /**
     * @param {?} numero
     * @return {?}
     */
    EditarCuentaDatosComponent.prototype.setNumTelefono = /**
     * @param {?} numero
     * @return {?}
     */
    function (numero) {
        /** @type {?} */
        var numeroaparte = '';
        if (numero != null) {
            if (numero.length != 0)
                numeroaparte = (numero == 'null') ? '' : numero.substr(3);
        }
        return numeroaparte;
    };
    /**
     * @return {?}
     */
    EditarCuentaDatosComponent.prototype.postPerfilesListServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new PerfilesListPeticion();
        params.docEmpresa = this.docEmpresa;
        params.codEstadoPerfil = 'ACTIVO';
        params.codCliente = this.environment.codCliente;
        this.perfilesService.postPerfilesList(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.perfilesResultado = data.resultado;
            }
            else {
                console.error('Error postPerfilesList: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postPerfilesList', err);
        }));
    };
    /**
     * @return {?}
     */
    EditarCuentaDatosComponent.prototype.callListarUsuarios = /**
     * @return {?}
     */
    function () {
        this.router.navigate(['../'], { relativeTo: this.route });
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    EditarCuentaDatosComponent.prototype.showDialogPre = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            if (result) {
                _this.doEditarUsuario();
            }
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    EditarCuentaDatosComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    EditarCuentaDatosComponent.prototype.showDialogOk = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            _this.callListarUsuarios();
        }));
    };
    /**
     * @param {?} event
     * @param {?} campo
     * @return {?}
     */
    EditarCuentaDatosComponent.prototype.formatearTelefono = /**
     * @param {?} event
     * @param {?} campo
     * @return {?}
     */
    function (event, campo) {
        /** @type {?} */
        var numero = event.target.value;
        if (numero == '' || numero == 'null')
            return;
        numero = numero.trim();
        /** @type {?} */
        var sep = ' ';
        /** @type {?} */
        var len = numero.length;
        /** @type {?} */
        var numeroFormato = numero;
        if (len <= 10) {
            numeroFormato = numero.replace(/(\d{1,3})(\d{3})(\d{4})/, '$1' + sep + '$2' + sep + '$3');
        }
        else if (len > 10) {
            numeroFormato = numero.replace(/(\d+)(\d{3})(\d{3})(\d{4})/, '$1' + sep + '$2' + sep + '$3' + sep + '$4');
        }
        if (campo == 'movil')
            this.formGroup.get('movil').setValue(numeroFormato);
        else if (campo == 'fijo')
            this.formGroup.get('fijo').setValue(numeroFormato);
    };
    /**
     * @param {?} numero
     * @return {?}
     */
    EditarCuentaDatosComponent.prototype.setearTelefono = /**
     * @param {?} numero
     * @return {?}
     */
    function (numero) {
        if (numero == '' || numero == 'null')
            return numero;
        numero = numero.trim();
        /** @type {?} */
        var sep = ' ';
        /** @type {?} */
        var len = numero.length;
        /** @type {?} */
        var numeroFormato = numero;
        if (len <= 10) {
            numeroFormato = numero.replace(/(\d{1,3})(\d{3})(\d{4})/, '$1' + sep + '$2' + sep + '$3');
        }
        else if (len > 10) {
            numeroFormato = numero.replace(/(\d+)(\d{3})(\d{3})(\d{4})/, '$1' + sep + '$2' + sep + '$3' + sep + '$4');
        }
        return numeroFormato;
    };
    EditarCuentaDatosComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-editar-cuenta-datos',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a (click)=\"callListarUsuarios()\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <form [formGroup]=\"formGroup\" autocomplete=\"off\">\r\n        <h3>Editar usuario</h3>\r\n        <h5>Datos</h5>\r\n        <div class=\"form-row\">\r\n          <div class=\"col-md-4\">\r\n            <mat-form-field>\r\n              <input matInput placeholder=\"C\u00E9dula\" maxlength=\"8\" soloRutUY formControlName=\"documento\" formatRut>\r\n              <mat-error *ngIf=\"formGroup.get('documento').hasError('cedulaError')\">C\u00E9dula <strong>incorrecta</strong>.</mat-error>\r\n            </mat-form-field>\r\n          </div>\r\n          <div class=\"col-md-4\">\r\n            <mat-form-field>\r\n              <mat-select matNativeControl placeholder=\"Perfil\" formControlName=\"perfil\">\r\n                <mat-option *ngFor=\"let perfil of perfilesResultado\" [value]=\"perfil.idPerfil\">{{perfil.descPerfil}}</mat-option>\r\n              </mat-select>\r\n              <mat-error *ngIf=\"formGroup.get('perfil').invalid\">Este campo es requerido.</mat-error>\r\n            </mat-form-field>\r\n          </div>\r\n          <div class=\"col-md-4\">\r\n            <mat-form-field>\r\n              <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estado\">\r\n                <mat-option *ngFor=\"let estado of resultadoEstados\" [value]=\"estado.codigo\">{{estado.descripcion}}</mat-option>\r\n              </mat-select>\r\n              <mat-error *ngIf=\"formGroup.get('estado').invalid\">Este campo es requerido.</mat-error>\r\n            </mat-form-field>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-row\">\r\n          <div class=\"col-md-4\">\r\n            <mat-form-field>\r\n              <input matInput maxlength=\"48\" placeholder=\"Nombre\" formControlName=\"nombre\" >\r\n              <mat-error *ngIf=\"formGroup.get('nombre').hasError('nameError')\">Ingrese un nombre v&aacute;lido.</mat-error>\r\n              <mat-error *ngIf=\"formGroup.get('nombre').hasError('required')\">Este campo es requerido.</mat-error>\r\n            </mat-form-field>\r\n          </div>\r\n          <div class=\"col-md-4\">\r\n            <mat-form-field>\r\n              <input matInput maxlength=\"48\" placeholder=\"Primer apellido\" formControlName=\"primerApellido\" >\r\n              <mat-error *ngIf=\"formGroup.get('primerApellido').hasError('nameError')\">Ingrese un apellido v&aacute;lido.</mat-error>\r\n              <mat-error *ngIf=\"formGroup.get('primerApellido').hasError('required')\">Este campo es requerido.</mat-error>\r\n            </mat-form-field>\r\n          </div>\r\n          <div class=\"col-md-4\">\r\n            <mat-form-field>\r\n              <input matInput maxlength=\"48\"  placeholder=\"Segundo apellido\" formControlName=\"segundoApellido\" >\r\n              <mat-error *ngIf=\"formGroup.get('segundoApellido').hasError('nameError')\">Ingrese un apellido v&aacute;lido.</mat-error>\r\n            </mat-form-field>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-row\">\r\n          <div class=\"col-md-6\">\r\n            <mat-form-field>\r\n              <input matInput maxlength=\"48\" placeholder=\"Email\" formControlName=\"email\">\r\n              <mat-error *ngIf=\"formGroup.get('email').invalid\">Este campo es requerido.</mat-error>\r\n            </mat-form-field>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <mat-form-field>\r\n              <input matInput maxlength=\"48\" placeholder=\"Cargo\" formControlName=\"cargo\" >\r\n              <mat-error>Ingrese un cargo v&aacute;lido.</mat-error>\r\n            </mat-form-field>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-row\">\r\n          <!-- <div class=\"col-sm-6 col-md-2\">\r\n            <mat-form-field>\r\n              <span matPrefix>+</span>\r\n              <input matInput digitOnly placeholder=\"C&oacute;digo Pa&iacute;s\" formControlName=\"codfijo\" maxlength=\"3\" >\r\n            </mat-form-field>\r\n          </div>\r\n          <div class=\"col-sm-6 col-md-4\">\r\n            <mat-form-field>\r\n              <input matInput digitOnly placeholder=\"Tel&eacute;fono fijo\" formControlName=\"fijo\" maxlength=\"8\" >\r\n            </mat-form-field>\r\n          </div> -->\r\n          <div class=\"col-sm-6 col-md-2\">\r\n            <mat-form-field>\r\n              <span matPrefix>+</span>\r\n              <input matInput digitOnly placeholder=\"C&oacute;digo Pa&iacute;s\" formControlName=\"codmovil\" maxlength=\"3\" >\r\n              <mat-error>Este campo es requerido.</mat-error>\r\n            </mat-form-field>\r\n          </div>\r\n          <div class=\"col-sm-6 col-md-4\">\r\n            <mat-form-field>\r\n              <input matInput digitOnly placeholder=\"Tel&eacute;fono m&oacute;vil\" formControlName=\"movil\" maxlength=\"8\" >\r\n              <mat-error>Este campo es requerido.</mat-error>\r\n            </mat-form-field>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-row\">\r\n          <div class=\"col-md-6\">\r\n            <mat-form-field>\r\n              <input matInput maxlength=\"250\" placeholder=\"Direcci&oacute;n\" formControlName=\"direccion\" >\r\n              <mat-error>Ingrese una direcci&oacute;n v&aacute;lida.</mat-error>\r\n            </mat-form-field>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-row\">\r\n          <div class=\"col align-right\">\r\n            <button class=\"btn main\" type=\"submit\" (click)=\"validaDatos()\">Finalizar</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>"
                }] }
    ];
    /** @nocollapse */
    EditarCuentaDatosComponent.ctorParameters = function () { return [
        { type: UsuarioParamsService },
        { type: UsuariosService },
        { type: PerfilesService },
        { type: MatDialog },
        { type: Router },
        { type: ActivatedRoute },
        { type: LoaderBaseService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return EditarCuentaDatosComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PerfilesListResult = /** @class */ (function () {
    function PerfilesListResult() {
        this.idPerfil = '';
        this.descPerfil = '';
        this.fecAdd = '';
        this.fecUpd = '';
        this.idCliente = '';
        this.nomCliente = '';
        this.idEmpresa = '';
        this.docEmpresa = '';
        this.nomEmpresa = '';
        this.idEstadoPerfil = '';
        this.codEstadoPerfil = '';
        this.descEstadoPerfil = '';
        this.idPolitica = '';
        this.descPolitica = '';
    }
    return PerfilesListResult;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ResetClavePeticion = /** @class */ (function () {
    function ResetClavePeticion() {
    }
    return ResetClavePeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EstadoUsuarioResult = /** @class */ (function () {
    function EstadoUsuarioResult() {
        this.codigo = '';
        this.descripcion = '';
    }
    return EstadoUsuarioResult;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LstUsuariosEmpComponent = /** @class */ (function () {
    function LstUsuariosEmpComponent(phttp, phttpr, phttpd, dialog, router, route, perfilesService, usuarioparams, loader, fb, rutValidator, serviceBaseService, environment) {
        this.phttp = phttp;
        this.phttpr = phttpr;
        this.phttpd = phttpd;
        this.dialog = dialog;
        this.router = router;
        this.route = route;
        this.perfilesService = perfilesService;
        this.usuarioparams = usuarioparams;
        this.loader = loader;
        this.fb = fb;
        this.rutValidator = rutValidator;
        this.serviceBaseService = serviceBaseService;
        this.environment = environment;
        this.rutPipe = new RutPipe();
        this.formGroup = new FormGroup({
            identificadorUsuario: new FormControl('', CustomValidators.validatorCedulaUY),
            estado: new FormControl(),
            rubro: new FormControl(),
            empresa: new FormControl({ value: null, disabled: false }),
            perfil: new FormControl({ value: null, disabled: true })
        });
        /* Vistas variables */
        this.vistaCantidad = 0;
        this.vistaEstado = 'Todos';
        this.vistaRubro = 'Todos';
        this.vistaEmpresa = 'Todos';
        this.vistaPerfil = 'Todos';
        this.COD_STD_USER_ELIMINADO = 'ELIMINADO';
        this.resultadoEstados = [];
        this.resultadoRubros = [];
        this.peticionEmpresa = new EmpresasPeticion();
        this.resultadoEmpresa = [];
        this.resetClavePeticion = new ResetClavePeticion();
        this.params = new ListUsuariosPeticionReporte();
        this.perfilesResultado = [];
        this.isCollapsed = false;
        this.hashCaminoMiga = [];
        this.consulta = 0;
        this.viewAgregar = true;
        this.viewEditar = true;
        this.rutinvalido = false;
    }
    /**
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (sessionStorage.getItem('componenteHijo') != 'app-editar-cuenta-datos-emp' && sessionStorage.getItem('cclave') != 'true') {
            sessionStorage.removeItem('indice');
        }
        this.viewAgregar = this.serviceBaseService.validaAccesoMenu('usuariosEmpAgregar');
        this.viewEditar = this.serviceBaseService.validaAccesoMenu('usuariosEmpEditar');
        if (this.viewEditar) {
            this.displayedColumns = ['nom_usuario', 'pat_usuario', 'mat_usuario', 'doc_usuario_emp', 'empresa', 'email_usuario_emp', 'perfil', 'estado', 'reset', 'editar'];
        }
        else {
            this.displayedColumns = ['nom_usuario', 'pat_usuario', 'mat_usuario', 'doc_usuario_emp', 'empresa', 'email_usuario_emp', 'perfil', 'estado', 'reset'];
        }
        this.postSentRubrosServices();
        this.postSentEstadosServices();
        this.postEmpresas();
        this.formGroup.controls.rubro.setValue("-1");
        this.formGroup.controls.empresa.reset('');
        this.formGroup.controls.estado.setValue("-1");
        if (sessionStorage.getItem('componenteHijo') == 'app-editar-cuenta-datos-emp') {
            this.consulta = 0;
            /** @type {?} */
            var llamadaPadre = JSON.parse(sessionStorage.getItem('llamadaPadre'));
            // Llena los filtros
            this.formGroup.controls['identificadorUsuario'].setValue((llamadaPadre.identificador != '-1' ? llamadaPadre.identificador : ''));
            this.formGroup.controls['estado'].setValue(llamadaPadre.estadoUserEmp);
            this.formGroup.controls['rubro'].setValue(llamadaPadre.codRubro);
            if (this.formGroup.get('rubro').value != '-1') {
                this.peticionEmpresa.codRubro = llamadaPadre.codRubro;
                this.peticionEmpresa.codCliente = this.environment.codCliente;
                this.peticionEmpresa.codEstadoConvenio = 'HBL';
                this.formGroup.get('empresa').reset();
                this.formGroup.get('perfil').reset();
                this.formGroup.get('perfil').disable();
                this.postSentEmpresaServices(this.peticionEmpresa);
            }
            this.formGroup.controls['empresa'].setValue(llamadaPadre.docEmpresa);
            if (this.formGroup.get('empresa').value != '-1') {
                this.formGroup.get('perfil').reset();
                this.postPerfilesListServices(llamadaPadre.docEmpresa);
            }
            this.formGroup.controls['perfil'].setValue(llamadaPadre.idPerfil);
            // Llena camino de migas
            /** @type {?} */
            var migasPadre = JSON.parse(sessionStorage.getItem('migasPadre'));
            this.vistaEstado = migasPadre.estadoUserEmp;
            this.vistaRubro = migasPadre.codRubro;
            this.vistaEmpresa = migasPadre.docEmpresa;
            this.vistaPerfil = migasPadre.idPerfil;
            this.hashCaminoMiga[0] = { title: 'Cédula', text: migasPadre.identificador };
            this.hashCaminoMiga[1] = { title: 'Estado', text: migasPadre.estadoUserEmp };
            this.hashCaminoMiga[2] = { title: 'Rubro', text: migasPadre.codRubro };
            this.hashCaminoMiga[3] = { title: 'Empresa', text: migasPadre.docEmpresa };
            this.hashCaminoMiga[4] = { title: 'Perfil', text: migasPadre.idPerfil };
            // Llama al servicio
            this.params.codCliente = llamadaPadre.codCliente;
            this.params.idUsrEmp = llamadaPadre.idUsrEmp;
            this.params.menuOption = llamadaPadre.menuOption;
            this.params.codTpoPortal = llamadaPadre.codTpoPortal;
            this.params.identificador = llamadaPadre.identificador;
            this.params.estadoUserEmp = llamadaPadre.estadoUserEmp;
            this.params.codRubro = llamadaPadre.codRubro;
            this.params.docEmpresa = llamadaPadre.docEmpresa;
            this.params.idPerfil = llamadaPadre.idPerfil;
            this.postListarUsuariosServices(this.params);
        }
        else {
            this.setInitialBreadcrumbs();
        }
    };
    /**
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.setInitialBreadcrumbs = /**
     * @return {?}
     */
    function () {
        this.hashCaminoMiga[0] = { title: 'Cédula', text: '' };
        this.hashCaminoMiga[1] = { title: 'Estado', text: 'Todos' };
        this.hashCaminoMiga[2] = { title: 'Rubro', text: 'Todos' };
        this.hashCaminoMiga[3] = { title: 'Empresa', text: 'Todas' };
        this.hashCaminoMiga[4] = { title: 'Perfil', text: 'Todos' };
    };
    /**
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.postSentRubrosServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var param = new RubroRequest();
        param.codEstadoConvenio = 'HBL';
        this.phttpr.postRubrosReport(param).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            /** @type {?} */
            var rub = new RubroResult();
            rub.codigo = '-1';
            rub.descripcion = "Todos";
            data.resultado.splice(0, 0, rub);
            _this.resultadoRubros = data.resultado;
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postRubrosReport', err);
        }));
    };
    /**
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.postSentEstadosServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.phttp.doListarEstadoUsuarios().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEstados = data.resultado;
                //Se agregar el TODOS
                /** @type {?} */
                var estadoTodos = new EstadoUsuarioResult();
                estadoTodos.codigo = '-1';
                estadoTodos.descripcion = 'Todos';
                _this.resultadoEstados.splice(0, 0, estadoTodos);
            }
            else {
                console.error('Error doListarEstadoUsuarios: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postEstadosReport: ', err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.onPaginateChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var indice = this.paginator.pageIndex;
        sessionStorage.setItem('indice', indice);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.postListarUsuariosServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.show = true;
        this.phttp.doListarUsuarios(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.vistaCantidad = 0;
                if (_this.paginator != undefined && sessionStorage.getItem('componenteHijo') == 'app-editar-cuenta-datos-emp') {
                    _this.paginator.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indice')))));
                }
                else if (_this.paginator != undefined && sessionStorage.getItem('cclave') == 'true') {
                    _this.paginator.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indice')))));
                }
                else if (_this.paginator != undefined) {
                    _this.paginator.pageIndex = 0;
                    sessionStorage.removeItem("indice");
                }
                sessionStorage.removeItem('cclave');
                sessionStorage.removeItem('componenteHijo');
                /** @type {?} */
                var listUsuarios = data.resultado;
                _this.dataSource = new MatTableDataSource$1(listUsuarios);
                _this.dataSource.paginator = _this.paginator;
                _this.dataSource.sort = _this.sort;
                _this.vistaCantidad = listUsuarios.length;
                if (_this.vistaCantidad == 0) {
                    _this.show = false;
                    _this.isCollapsed = false;
                }
                else {
                    _this.isCollapsed = true;
                }
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.loader.hide();
                console.error('Error doListarUsuarios', data.descret);
                _this.showDialog('Error', 'Error al listar usuarios, intente nuevamente.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            _this.loader.hide();
            console.error('Error doListarUsuarios', err);
        }));
    };
    /**
     * @param {?} docEmpresa
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.postPerfilesListServices = /**
     * @param {?} docEmpresa
     * @return {?}
     */
    function (docEmpresa) {
        var _this = this;
        /** @type {?} */
        var params = new PerfilesListPeticion();
        params.docEmpresa = docEmpresa;
        this.perfilesService.postPerfilesList(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0' && data.resultado.length > 0) {
                _this.perfilesResultado = data.resultado;
                if (data.resultado.length > 1) {
                    /** @type {?} */
                    var perfilTodos = new PerfilesListResult();
                    perfilTodos.idPerfil = '-1';
                    perfilTodos.descPerfil = 'Todos';
                    _this.perfilesResultado.splice(0, 0, perfilTodos);
                }
                _this.formGroup.get('perfil').setValue(_this.perfilesResultado[0].idPerfil);
                _this.formGroup.get('perfil').enable();
            }
            else {
                _this.formGroup.get('perfil').disable();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postPerfilesList', err);
        }));
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.consulta = 1;
        this.params.codCliente = this.environment.codCliente;
        this.params.idUsrEmp = '-1';
        this.params.menuOption = 'usuarioEmp';
        this.params.codTpoPortal = 'COMERCIO';
        if (this.formGroup.get('identificadorUsuario').value == null || this.formGroup.get('identificadorUsuario').value == '') {
            this.params.identificador = '-1';
            this.hashCaminoMiga[0] = { title: 'Cédula', text: '' };
        }
        else {
            this.params.identificador = this.formGroup.get('identificadorUsuario').value;
            this.hashCaminoMiga[0] = { title: 'Cédula', text: this.rutPipe.transform(this.formGroup.get('identificadorUsuario').value) };
        }
        if (this.formGroup.get('estado').value == null || this.formGroup.get('estado').value == '' || this.formGroup.get('estado').value == '-1') {
            this.params.estadoUserEmp = '-1';
            this.hashCaminoMiga[1] = { title: 'Estado', text: 'Todos' };
        }
        else {
            this.params.estadoUserEmp = this.formGroup.get('estado').value;
            this.hashCaminoMiga[1] = { title: 'Estado', text: this.vistaEstado };
        }
        if (this.formGroup.get('rubro').value == null || this.formGroup.get('rubro').value == '' || this.formGroup.get('rubro').value == '-1') {
            this.params.codRubro = '-1';
            this.hashCaminoMiga[2] = { title: 'Rubro', text: 'Todos' };
        }
        else {
            this.params.codRubro = this.formGroup.get('rubro').value;
            this.hashCaminoMiga[2] = { title: 'Rubro', text: this.vistaRubro };
        }
        if (this.formGroup.get('empresa').value == null || this.formGroup.get('empresa').value == '' || this.formGroup.get('empresa').value == '-1') {
            this.params.docEmpresa = '-1';
            this.hashCaminoMiga[3] = { title: 'Empresa', text: 'Todas' };
        }
        else {
            this.params.docEmpresa = this.formGroup.get('empresa').value;
            this.hashCaminoMiga[3] = { title: 'Empresa', text: this.vistaEmpresa };
        }
        if (this.formGroup.get('perfil').value == null || this.formGroup.get('perfil').value == '' || this.formGroup.get('perfil').value == '-1') {
            this.params.idPerfil = '-1';
            this.hashCaminoMiga[4] = { title: 'Perfil', text: 'Todos' };
        }
        else {
            this.params.idPerfil = this.formGroup.get('perfil').value;
            this.hashCaminoMiga[4] = { title: 'Perfil', text: this.vistaPerfil };
        }
        sessionStorage.setItem('llamadaPadre', JSON.stringify({
            codCliente: this.params.codCliente,
            idUsrEmp: this.params.idUsrEmp,
            menuOption: this.params.menuOption,
            codTpoPortal: this.params.codTpoPortal,
            identificador: this.params.identificador,
            estadoUserEmp: this.params.estadoUserEmp,
            codRubro: this.params.codRubro,
            docEmpresa: this.params.docEmpresa,
            idPerfil: this.params.idPerfil
        }));
        sessionStorage.setItem('migasPadre', JSON.stringify({
            identificador: this.hashCaminoMiga[0].text,
            estadoUserEmp: this.hashCaminoMiga[1].text,
            codRubro: this.hashCaminoMiga[2].text,
            docEmpresa: this.hashCaminoMiga[3].text,
            idPerfil: this.hashCaminoMiga[4].text
        }));
        if (tipo == 'excel' || tipo == 'pdf') {
            this.params.filtros = this.hashCaminoMiga;
            this.postDownloadReportFile(this.params, tipo);
        }
        else {
            this.postListarUsuariosServices(this.params);
        }
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiUsuariosMT/listaUsuarios/' + tipo;
        this.phttpd.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'listadoUsuarios' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'listadoUsuarios' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error downloadReportService', err);
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.onRubroSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event != null) {
            this.vistaRubro = event.source.selected._element.nativeElement.innerText.trim();
            this.peticionEmpresa.codRubro = event.value;
            this.peticionEmpresa.codCliente = this.environment.codCliente;
            this.peticionEmpresa.codEstadoConvenio = 'HBL';
            this.formGroup.get('perfil').reset();
            this.formGroup.get('perfil').disable();
            //this.postSentEmpresaServices(this.peticionEmpresa);
            this.postSentSelectEmpresaServices(this.peticionEmpresa);
            this.formGroup.get('empresa').reset('');
        }
    };
    /**
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.postEmpresas = /**
     * @return {?}
     */
    function () {
        this.peticionEmpresa.codRubro = '-1';
        this.peticionEmpresa.codCliente = this.environment.codCliente;
        this.peticionEmpresa.codEstadoConvenio = 'HBL';
        //this.postSentEmpresaServices(this.peticionEmpresa);    
        this.postSentSelectEmpresaServices(this.peticionEmpresa);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.phttpr.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0' && data.resultado.length > 0) {
                /** @type {?} */
                var empresaResult = new EmpresaResult();
                empresaResult.idFacturador = -1;
                empresaResult.nomFacturador = "Todas";
                data.resultado.splice(0, 0, empresaResult);
                _this.resultadoEmpresa = data.resultado;
                //this.formGroup.get('empresa').enable();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postListarEmpresas', err);
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.postSentSelectEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.phttpr.postListarSelectEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0' && data.resultado.length > 0) {
                /** @type {?} */
                var empresaResult = new EmpresaResult();
                empresaResult.idFacturador = -1;
                empresaResult.nomFacturador = "Todas";
                data.resultado.splice(0, 0, empresaResult);
                _this.resultadoEmpresa = data.resultado;
                //this.formGroup.get('empresa').enable();
            }
            else {
                console.log('Error: ', 'postListarSelectEmpresas ' + data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error("Error postListarSelectEmpresas: ", err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.onEmpresaSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.formGroup.get('perfil').reset();
        this.postPerfilesListServices(event.value);
        this.vistaEmpresa = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.onEstadoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEstado = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.onPerfilSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaPerfil = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.postEmpresas();
        this.formGroup.get('identificadorUsuario').setValue('');
        this.formGroup.get('estado').reset('-1');
        this.formGroup.get('rubro').reset('-1');
        this.formGroup.get('empresa').reset('');
        this.formGroup.get('perfil').reset('');
        this.formGroup.get('perfil').disable();
        this.setInitialBreadcrumbs();
        this.dataSource = new MatTableDataSource$1([]);
        this.consulta = 0;
        this.show = false;
        this.vistaCantidad = 0;
        this.isCollapsed = false;
    };
    /**
     * @param {?} body
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.doResetClave = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.phttp.doResetClave(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.loader.hide();
                _this.showDialogReset('Información', 'Clave del usuario restablecida de forma satisfactoria.', false);
            }
            else {
                _this.loader.hide();
                console.log('Error: ', data.descret);
                _this.showDialog('Error', 'No ha sido posible restablecer la clave del usuario.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            console.error('Error doResetClave', err);
            _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @param {?} resultado
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.resetClave = /**
     * @param {?} resultado
     * @return {?}
     */
    function (resultado) {
        this.resetClavePeticion.docEmpresa = resultado.doc_com;
        this.resetClavePeticion.codCliente = this.environment.codCliente;
        this.resetClavePeticion.codTpoPortal = resultado.codTpoPortal;
        this.resetClavePeticion.docUsuario = resultado.doc_usuario_emp;
        this.showDialogPre('Información', 'Si realiza esta acción, restablecerá la clave del usuario.<br>¿Está seguro?', true);
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.showDialogPre = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            if (result) {
                sessionStorage.setItem("cclave", "true");
                _this.doResetClave(_this.resetClavePeticion);
            }
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.showDialogReset = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            _this.postListarUsuariosServices(_this.params);
        }));
    };
    /**
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.callAgregarUsuario = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var usuario = new UsuariosParams();
        usuario.docEmpresa = this.formGroup.get('empresa').value;
        usuario.tipoListado = 'EMPRESAS';
        this.usuarioparams.setUsuarioParams(usuario);
        this.router.navigate(['../usuariosEmpAgregar'], { relativeTo: this.route });
    };
    /**
     * @param {?} docEmpresa
     * @param {?} idUsuario
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.callEditarUsuario = /**
     * @param {?} docEmpresa
     * @param {?} idUsuario
     * @return {?}
     */
    function (docEmpresa, idUsuario) {
        /** @type {?} */
        var usuario = new UsuariosParams();
        usuario.docEmpresa = docEmpresa;
        usuario.idUsuario = idUsuario;
        usuario.tipoListado = 'EMPRESAS';
        this.usuarioparams.setUsuarioParams(usuario);
        this.router.navigate(['../usuariosEmpEditar'], { relativeTo: this.route });
    };
    /**
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.onSubmit('');
        }
    };
    /**
     * @return {?}
     */
    LstUsuariosEmpComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('componenteHijo');
    };
    LstUsuariosEmpComponent.decorators = [
        { type: Component, args: [{
                    selector: 'list-usuarios-emp',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"seccion-titulo-boton\">\r\n      <div class=\"row\">\r\n        <div class=\"col\" *ngIf=\"viewAgregar\">\r\n          <a class=\"boton-seccion btn-small main\" (click)=\"callAgregarUsuario()\"><i class=\"str-icon-mas\"></i>Agregar usuario</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"modulo-filtros\">\r\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n      </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"formGroup\" (ngSubmit)=\"validarForm()\" autocomplete=\"off\">\r\n              <div class=\"form-row\">\r\n                <div class=\"col-md-6\">\r\n                  <mat-form-field>\r\n                    <input matInput placeholder=\"C\u00E9dula\"  soloRutUY maxlength=\"8\" formControlName=\"identificadorUsuario\" formatRut>\r\n                    <mat-error *ngIf=\"formGroup.get('identificadorUsuario').hasError('cedulaError')\">C\u00E9dula <strong>incorrecta</strong>.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estado\" (selectionChange)=\"onEstadoSelect($event)\">\r\n                      <mat-option *ngFor=\"let estado of resultadoEstados\" [value]=\"estado.codigo\">{{estado.descripcion}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-row\">\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Rubro\" formControlName=\"rubro\" (selectionChange)=\"onRubroSelect($event)\">\r\n                      <mat-option *ngFor=\"let rubro of resultadoRubros\" [value]=\"rubro.codigo\">{{rubro.descripcion}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"empresa\" (selectionChange)=\"onEmpresaSelect($event)\">\r\n                      <mat-option *ngFor=\"let empresa of resultadoEmpresa\" [value]=\"empresa.docFacturador\">{{empresa.nomFacturador}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Perfil\" formControlName=\"perfil\" (selectionChange)=\"onPerfilSelect($event)\">\r\n                      <mat-option *ngFor=\"let perfil of perfilesResultado\" [value]=\"perfil.idPerfil\">{{perfil.descPerfil}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"actions\">\r\n                <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\">Filtrar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"resultados-filtros\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-10\">\r\n          <div class=\"tags row\">\r\n            <div *ngFor=\"let entry of hashCaminoMiga\" class=\"item\">{{entry.title}}: {{entry.text}}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n          <div class=\"numero-resultados\">\r\n            <strong>{{ (vistaCantidad == 1) ? ( vistaCantidad + \" Resultado\") : vistaCantidad + \" Resultados\" }}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-container table-responsive-lg\" style=\"width: 100%;\">\r\n        <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n          <ng-container matColumnDef=\"nom_usuario\">\r\n            <th mat-header-cell *matHeaderCellDef>Nombre</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.nom_usuario}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"pat_usuario\">\r\n            <th mat-header-cell *matHeaderCellDef>Primer Apellido</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.pat_usuario}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"mat_usuario\">\r\n            <th mat-header-cell *matHeaderCellDef>Segundo Apellido</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.mat_usuario == ''; else elseBlock\">-</span>\r\n              <ng-template #elseBlock>{{resultado.mat_usuario}}</ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"doc_usuario_emp\">\r\n            <th mat-header-cell *matHeaderCellDef>C\u00E9dula</th>\r\n            <td mat-cell style=\"width: 15% !important;\" *matCellDef=\"let resultado\"> {{ rutPipe.transform(resultado.doc_usuario_emp) }} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"empresa\">\r\n            <th mat-header-cell *matHeaderCellDef>Empresa</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.nombre_empresa}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"email_usuario_emp\">\r\n            <th mat-header-cell *matHeaderCellDef>Correo</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.email_usuario_emp}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"perfil\">\r\n            <th mat-header-cell *matHeaderCellDef>Perfil</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.descPerfil}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"estado\">\r\n            <th mat-header-cell *matHeaderCellDef>Estado</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.estadoUserEmp}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"reset\">\r\n            <th mat-header-cell *matHeaderCellDef>Reset Clave</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a matTooltip=\"Reset contrase\u00F1a\" matTooltipPosition=\"above\" Style=\"cursor: pointer;\" *ngIf=\"resultado.codEstadoUserEmp != COD_STD_USER_ELIMINADO\" (click)=\"resetClave(resultado)\"><i class=\"icon str-icon-renovar\"></i></a>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"viewEditar\" matColumnDef=\"editar\">\r\n            <th mat-header-cell *matHeaderCellDef>Editar</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a matTooltip=\"Editar usuario\" matTooltipPosition=\"above\" Style=\"cursor: pointer;\" *ngIf=\"resultado.codEstadoUserEmp != COD_STD_USER_ELIMINADO\" (click)=\"callEditarUsuario(resultado.doc_com, resultado.id_usuario)\"><i class=\"icon str-icon-lapiz\"></i></a>\r\n            </td>\r\n          </ng-container>\r\n\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n        </table>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" (page)=\"onPaginateChange($event)\" showFirstLastButtons></mat-paginator>\r\n      </div>\r\n    </section>\r\n\r\n    <div class=\"box-actions\" *ngIf=\"isCollapsed && vistaCantidad > 0\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6 item\">\r\n          <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n        </div>\r\n        <div class=\"col-md-6 item-right\">\r\n          <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"modulo-cuentas\" *ngIf=\"!isCollapsed && vistaCantidad == 0 && consulta == 1\">\r\n      <span>No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.</span>\r\n    </div>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"!isCollapsed && consulta == 0\">\r\n      <span>Establezca sus criterios de b&uacute;squeda.</span>\r\n    </div>\r\n\r\n  </div>\r\n</section>"
                }] }
    ];
    /** @nocollapse */
    LstUsuariosEmpComponent.ctorParameters = function () { return [
        { type: UsuariosService },
        { type: EmpresasService },
        { type: DescargaExcelPdfFileService },
        { type: MatDialog },
        { type: Router },
        { type: ActivatedRoute },
        { type: PerfilesService },
        { type: UsuarioParamsService },
        { type: LoaderBaseService },
        { type: FormBuilder },
        { type: RutValidator },
        { type: ServicesBaseService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    LstUsuariosEmpComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator$1,] }],
        sort: [{ type: ViewChild, args: [MatSort,] }]
    };
    return LstUsuariosEmpComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LstUsuariosComponent = /** @class */ (function () {
    function LstUsuariosComponent(phttp, phttpd, dialog, router, route, perfilesService, usuarioparams, loader, serviceBaseService, environment) {
        this.phttp = phttp;
        this.phttpd = phttpd;
        this.dialog = dialog;
        this.router = router;
        this.route = route;
        this.perfilesService = perfilesService;
        this.usuarioparams = usuarioparams;
        this.loader = loader;
        this.serviceBaseService = serviceBaseService;
        this.environment = environment;
        this.formGroup = new FormGroup({
            identificadorUsuario: new FormControl('', CustomValidators.validatorCedulaUY),
            estado: new FormControl('-1'),
            perfil: new FormControl('-1')
        });
        this.rutPipe = new RutPipe();
        /* Vistas variables */
        this.vistaCantidad = 0;
        this.vistaEstado = 'Todos';
        this.vistaPerfil = 'Todos';
        this.COD_STD_USER_ELIMINADO = 'ELIMINADO';
        this.resultadoEstados = [];
        this.peticionEmpresa = new EmpresasPeticion();
        this.resultadoEmpresa = [];
        this.resetClavePeticion = new ResetClavePeticion();
        this.params = new ListUsuariosPeticionReporte();
        this.perfilesResultado = [];
        this.isCollapsed = false;
        this.hashCaminoMiga = [];
        this.consulta = 0;
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idUsuario = this.userPerfil.usuario.idUsuario;
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
    }
    /**
     * @return {?}
     */
    LstUsuariosComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (sessionStorage.getItem('componenteHijo') != 'app-editar-cuenta-datos' && sessionStorage.getItem('cclave') != 'true') {
            sessionStorage.removeItem('indice');
        }
        this.viewAgregar = this.serviceBaseService.validaAccesoMenu('usuariosAgregar');
        this.viewEditar = this.serviceBaseService.validaAccesoMenu('usuariosEditar');
        if (this.viewEditar) {
            this.displayedColumns = ['nom_usuario', 'pat_usuario', 'mat_usuario', 'doc_usuario_emp', 'email_usuario_emp', 'perfil', 'estado', 'reset', 'editar'];
        }
        else {
            this.displayedColumns = ['nom_usuario', 'pat_usuario', 'mat_usuario', 'doc_usuario_emp', 'email_usuario_emp', 'perfil', 'estado', 'reset'];
        }
        this.postSentEstadosServices();
        this.postPerfilesListServices();
        if (sessionStorage.getItem('componenteHijo') == 'app-editar-cuenta-datos') {
            this.consulta = 0;
            /** @type {?} */
            var llamadaPadre = JSON.parse(sessionStorage.getItem('llamadaPadre'));
            // Llena los filtros
            this.formGroup.controls['identificadorUsuario'].setValue((llamadaPadre.identificador != '-1' ? llamadaPadre.identificador : ''));
            this.formGroup.controls['estado'].setValue(llamadaPadre.estadoUserEmp);
            this.formGroup.controls['perfil'].setValue(llamadaPadre.idPerfil);
            // Llena camino de migas
            /** @type {?} */
            var migasPadre = JSON.parse(sessionStorage.getItem('migasPadre'));
            this.vistaEstado = migasPadre.estadoUserEmp;
            this.vistaPerfil = migasPadre.idPerfil;
            this.hashCaminoMiga[0] = { title: 'Cédula', text: migasPadre.identificador };
            this.hashCaminoMiga[1] = { title: 'Estado', text: migasPadre.estadoUserEmp };
            this.hashCaminoMiga[2] = { title: 'Perfil', text: migasPadre.idPerfil };
            // Llama al servicio
            this.params.codCliente = llamadaPadre.codCliente;
            this.params.idUsrEmp = llamadaPadre.idUsrEmp;
            this.params.docEmpresa = llamadaPadre.docEmpresa;
            this.params.menuOption = llamadaPadre.menuOption;
            this.params.codTpoPortal = llamadaPadre.codTpoPortal;
            this.params.identificador = llamadaPadre.identificador;
            this.params.estadoUserEmp = llamadaPadre.estadoUserEmp;
            this.params.idPerfil = llamadaPadre.idPerfil;
            this.postListarUsuariosServices(this.params);
        }
        else {
            this.setInitialBreadcrumbs();
        }
    };
    /**
     * @return {?}
     */
    LstUsuariosComponent.prototype.setInitialBreadcrumbs = /**
     * @return {?}
     */
    function () {
        this.hashCaminoMiga[0] = { title: 'Cédula', text: '' };
        this.hashCaminoMiga[1] = { title: 'Estado', text: 'Todos' };
        this.hashCaminoMiga[2] = { title: 'Perfil', text: 'Todos' };
    };
    /**
     * @return {?}
     */
    LstUsuariosComponent.prototype.postSentEstadosServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.phttp.doListarEstadoUsuarios().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEstados = data.resultado;
                //Se agregar el TODOS
                /** @type {?} */
                var estadoTodos = new EstadoUsuarioResult();
                estadoTodos.codigo = '-1';
                estadoTodos.descripcion = 'Todos';
                _this.resultadoEstados.splice(0, 0, estadoTodos);
            }
            else {
                console.error('Error doListarEstadoUsuarios: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error doListarEstadoUsuarios: ', err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstUsuariosComponent.prototype.onPaginateChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var indice = this.paginator.pageIndex;
        sessionStorage.setItem('indice', indice);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    LstUsuariosComponent.prototype.postListarUsuariosServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.show = true;
        this.phttp.doListarUsuarios(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.vistaCantidad = 0;
                if (_this.paginator != undefined && sessionStorage.getItem('componenteHijo') == 'app-editar-cuenta-datos') {
                    _this.paginator.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indice')))));
                }
                else if (_this.paginator != undefined && sessionStorage.getItem('cclave') == 'true') {
                    _this.paginator.pageIndex = (/** @type {?} */ ((/** @type {?} */ (sessionStorage.getItem('indice')))));
                }
                else if (_this.paginator != undefined) {
                    _this.paginator.pageIndex = 0;
                    sessionStorage.removeItem("indice");
                }
                sessionStorage.removeItem('cclave');
                sessionStorage.removeItem('componenteHijo');
                /** @type {?} */
                var listUsuarios = data.resultado;
                _this.dataSource = new MatTableDataSource$1(listUsuarios);
                _this.dataSource.paginator = _this.paginator;
                _this.dataSource.sort = _this.sort;
                _this.vistaCantidad = listUsuarios.length;
                if (_this.vistaCantidad == 0) {
                    _this.show = false;
                    _this.isCollapsed = false;
                }
                else {
                    _this.isCollapsed = true;
                }
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.loader.hide();
                console.error('Error doListarUsuarios', data.descret);
                _this.showDialog('Error', 'Error al listar usuarios, intente nuevamente.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            _this.loader.hide();
            console.error('Error doListarUsuarios', err);
        }));
    };
    /**
     * @return {?}
     */
    LstUsuariosComponent.prototype.postPerfilesListServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new PerfilesListPeticion();
        params.docEmpresa = this.docEmpresa;
        params.codCliente = this.environment.codCliente;
        console.log("Lista Perfiles en Usuario " + params.codCliente);
        this.perfilesService.postPerfilesList(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0' && data.resultado.length > 0) {
                _this.perfilesResultado = data.resultado;
                //Se agregar el TODOS
                /** @type {?} */
                var perfilTodos = new PerfilesListResult();
                perfilTodos.idPerfil = '-1';
                perfilTodos.descPerfil = 'Todos';
                _this.perfilesResultado.splice(0, 0, perfilTodos);
                _this.formGroup.get('perfil').enable();
            }
            else {
                _this.formGroup.get('perfil').disable();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postPerfilesList', err);
        }));
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    LstUsuariosComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.consulta = 1;
        this.params.codCliente = this.environment.codCliente;
        this.params.idUsrEmp = '-1';
        this.params.docEmpresa = this.docEmpresa;
        this.params.menuOption = 'usuario';
        this.params.codTpoPortal = this.codTpoPortal;
        if (this.formGroup.get('identificadorUsuario').value == null || this.formGroup.get('identificadorUsuario').value == '') {
            this.params.identificador = '-1';
            this.hashCaminoMiga[0] = { title: 'Cédula', text: '' };
        }
        else {
            this.params.identificador = this.formGroup.get('identificadorUsuario').value;
            this.hashCaminoMiga[0] = { title: 'Cédula', text: this.rutPipe.transform(this.formGroup.get('identificadorUsuario').value) };
        }
        if (this.formGroup.get('estado').value == null || this.formGroup.get('estado').value == '') {
            this.params.estadoUserEmp = '-1';
            this.hashCaminoMiga[1] = { title: 'Estado', text: 'Todos' };
        }
        else {
            this.params.estadoUserEmp = this.formGroup.get('estado').value;
            this.hashCaminoMiga[1] = { title: 'Estado', text: this.vistaEstado };
        }
        if (this.formGroup.get('perfil').value == null || this.formGroup.get('perfil').value == '') {
            this.params.idPerfil = '-1';
            this.hashCaminoMiga[2] = { title: 'Perfil', text: 'Todos' };
        }
        else {
            this.params.idPerfil = this.formGroup.get('perfil').value;
            this.hashCaminoMiga[2] = { title: 'Perfil', text: this.vistaPerfil };
        }
        sessionStorage.setItem('llamadaPadre', JSON.stringify({
            codCliente: this.params.codCliente,
            idUsrEmp: this.params.idUsrEmp,
            docEmpresa: this.params.docEmpresa,
            menuOption: this.params.menuOption,
            codTpoPortal: this.params.codTpoPortal,
            identificador: this.params.identificador,
            estadoUserEmp: this.params.estadoUserEmp,
            idPerfil: this.params.idPerfil
        }));
        sessionStorage.setItem('migasPadre', JSON.stringify({
            identificador: this.hashCaminoMiga[0].text,
            estadoUserEmp: this.hashCaminoMiga[1].text,
            idPerfil: this.hashCaminoMiga[2].text
        }));
        if (tipo == 'excel' || tipo == 'pdf') {
            this.params.filtros = this.hashCaminoMiga;
            this.postDownloadReportFile(this.params, tipo);
        }
        else {
            this.postListarUsuariosServices(this.params);
        }
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    LstUsuariosComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiUsuariosMT/listaUsuarios/' + tipo;
        this.phttpd.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'listadoUsuarios' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'listadoUsuarios' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error downloadReportService', err);
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstUsuariosComponent.prototype.onEstadoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEstado = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LstUsuariosComponent.prototype.onPerfilSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaPerfil = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @return {?}
     */
    LstUsuariosComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.formGroup.get('identificadorUsuario').setValue('');
        this.formGroup.get('estado').setValue('-1');
        this.formGroup.get('perfil').setValue('-1');
        this.vistaEstado = 'Todos';
        this.vistaPerfil = 'Todos';
        this.dataSource = new MatTableDataSource$1([]);
        this.setInitialBreadcrumbs();
        this.isCollapsed = false;
        this.show = false;
        this.consulta = 0;
        this.vistaCantidad = 0;
    };
    /**
     * @param {?} body
     * @return {?}
     */
    LstUsuariosComponent.prototype.doResetClave = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.phttp.doResetClave(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.loader.hide();
                _this.showDialogReset('Información', 'Clave del usuario restablecida de forma satisfactoria.', false);
            }
            else {
                _this.loader.hide();
                _this.showDialog('Error', 'No ha sido posible restablecer la clave del usuario.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            console.error('Error doResetClave', err);
            _this.showDialog('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @param {?} resultado
     * @return {?}
     */
    LstUsuariosComponent.prototype.resetClave = /**
     * @param {?} resultado
     * @return {?}
     */
    function (resultado) {
        this.resetClavePeticion.docEmpresa = resultado.doc_com;
        this.resetClavePeticion.codCliente = this.environment.codCliente;
        this.resetClavePeticion.codTpoPortal = resultado.codTpoPortal;
        this.resetClavePeticion.docUsuario = resultado.doc_usuario_emp;
        this.showDialogPre('Información', 'Si realiza esta acción, restablecerá la clave del usuario.<br>¿Está seguro?', true);
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    LstUsuariosComponent.prototype.showDialogPre = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            if (result) {
                sessionStorage.setItem("cclave", "true");
                _this.doResetClave(_this.resetClavePeticion);
            }
        }));
    };
    /**
     * @return {?}
     */
    LstUsuariosComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.onSubmit('');
        }
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    LstUsuariosComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    LstUsuariosComponent.prototype.showDialogReset = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
            _this.postListarUsuariosServices(_this.params);
        }));
    };
    /**
     * @return {?}
     */
    LstUsuariosComponent.prototype.callAgregarUsuario = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var usuario = new UsuariosParams();
        usuario.docEmpresa = this.docEmpresa;
        usuario.tipoListado = 'USUARIOS';
        this.usuarioparams.setUsuarioParams(usuario);
        this.router.navigate(['../usuariosAgregar'], { relativeTo: this.route });
    };
    /**
     * @param {?} docEmpresa
     * @param {?} idUsuario
     * @return {?}
     */
    LstUsuariosComponent.prototype.callEditarUsuario = /**
     * @param {?} docEmpresa
     * @param {?} idUsuario
     * @return {?}
     */
    function (docEmpresa, idUsuario) {
        //    console.log('docEmpresa',docEmpresa,'idUsuario',idUsuario);
        /** @type {?} */
        var usuario = new UsuariosParams();
        usuario.docEmpresa = docEmpresa;
        usuario.idUsuario = idUsuario;
        usuario.tipoListado = 'USUARIOS';
        this.usuarioparams.setUsuarioParams(usuario);
        this.router.navigate(['../usuariosEditar'], { relativeTo: this.route });
    };
    /**
     * @return {?}
     */
    LstUsuariosComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        sessionStorage.removeItem('componenteHijo');
    };
    LstUsuariosComponent.decorators = [
        { type: Component, args: [{
                    selector: 'list-usuarios',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"seccion-titulo-boton\">\r\n      <div class=\"row\">\r\n        <div class=\"col\" *ngIf=\"viewAgregar\">\r\n          <a class=\"boton-seccion btn-small main\" (click)=\"callAgregarUsuario()\"><i class=\"str-icon-mas\"></i>Agregar usuario</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"modulo-filtros\">\r\n      <a class=\"link-container\"[attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n      </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"formGroup\" (ngSubmit)=\"validarForm()\" autocomplete=\"off\">\r\n              <div class=\"form-row\">\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <input matInput placeholder=\"C\u00E9dula\" soloRutUY maxlength=\"8\" formControlName=\"identificadorUsuario\" formatRut>\r\n                    <mat-error *ngIf=\"formGroup.get('identificadorUsuario').hasError('cedulaError')\">C\u00E9dula <strong>incorrecta</strong>.</mat-error>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estado\" (selectionChange)=\"onEstadoSelect($event)\">\r\n                      <mat-option *ngFor=\"let estado of resultadoEstados\" [value]=\"estado.codigo\">{{estado.descripcion}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Perfil\" formControlName=\"perfil\" (selectionChange)=\"onPerfilSelect($event)\">\r\n                      <mat-option *ngFor=\"let perfil of perfilesResultado\" [value]=\"perfil.idPerfil\">{{perfil.descPerfil}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"actions\">\r\n                <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\">Filtrar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"resultados-filtros\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-10\">\r\n          <div class=\"tags row\">\r\n            <div *ngFor=\"let entry of hashCaminoMiga\" class=\"item\">{{entry.title}}: {{entry.text}}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n          <div class=\"numero-resultados\">\r\n            <strong>{{ (vistaCantidad == 1) ? ( vistaCantidad + \" Resultado\") : vistaCantidad + \" Resultados\" }}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-container table-responsive-md\">\r\n        <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n          <ng-container matColumnDef=\"nom_usuario\">\r\n            <th mat-header-cell *matHeaderCellDef>Nombre</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.nom_usuario}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"pat_usuario\">\r\n            <th mat-header-cell *matHeaderCellDef>Primer Apellido</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.pat_usuario}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"mat_usuario\">\r\n            <th mat-header-cell *matHeaderCellDef>Segundo Apellido</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <span *ngIf=\"resultado.mat_usuario == ''; else elseBlock\">-</span>\r\n              <ng-template #elseBlock>{{resultado.mat_usuario}}</ng-template>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"doc_usuario_emp\">\r\n            <th mat-header-cell *matHeaderCellDef>C\u00E9dula</th>\r\n            <td mat-cell style=\"width: 15% !important;\" *matCellDef=\"let resultado\"> {{ rutPipe.transform(resultado.doc_usuario_emp) }} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"email_usuario_emp\">\r\n            <th mat-header-cell *matHeaderCellDef>Correo</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.email_usuario_emp}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"perfil\">\r\n            <th mat-header-cell *matHeaderCellDef>Perfil</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.descPerfil}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"estado\">\r\n            <th mat-header-cell *matHeaderCellDef>Estado</th>\r\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.estadoUserEmp}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"reset\">\r\n            <th mat-header-cell *matHeaderCellDef>Reset Clave</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a matTooltip=\"Reset contrase\u00F1a\" matTooltipPosition=\"above\" Style=\"cursor: pointer;\" *ngIf=\"resultado.codEstadoUserEmp != COD_STD_USER_ELIMINADO\" (click)=\"resetClave(resultado)\"><i class=\"icon str-icon-renovar\"></i></a>\r\n            </td>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"viewEditar\" matColumnDef=\"editar\">\r\n            <th mat-header-cell *matHeaderCellDef>Editar</th>\r\n            <td mat-cell *matCellDef=\"let resultado\">\r\n              <a matTooltip=\"Editar usuario\" matTooltipPosition=\"above\" Style=\"cursor: pointer;\" *ngIf=\"resultado.codEstadoUserEmp != COD_STD_USER_ELIMINADO\" (click)=\"callEditarUsuario(resultado.doc_com, resultado.id_usuario)\"><i class=\"icon str-icon-lapiz\"></i></a>\r\n            </td>\r\n          </ng-container>\r\n\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\r\n        </table>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" (page)=\"onPaginateChange($event)\" showFirstLastButtons></mat-paginator>\r\n      </div>\r\n    </section>\r\n\r\n    <div class=\"box-actions\" *ngIf=\"isCollapsed && vistaCantidad > 0\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6 item\">\r\n          <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n        </div>\r\n        <div class=\"col-md-6 item-right\">\r\n          <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"modulo-cuentas\" *ngIf=\"!isCollapsed && vistaCantidad == 0 && consulta == 1\">\r\n      <span>No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.</span>\r\n    </div>\r\n    <div class=\"modulo-cuentas\" *ngIf=\"!isCollapsed && consulta == 0\">\r\n      <span>Establezca sus criterios de b&uacute;squeda.</span>\r\n    </div>\r\n\r\n  </div>\r\n</section>"
                }] }
    ];
    /** @nocollapse */
    LstUsuariosComponent.ctorParameters = function () { return [
        { type: UsuariosService },
        { type: DescargaExcelPdfFileService },
        { type: MatDialog },
        { type: Router },
        { type: ActivatedRoute },
        { type: PerfilesService },
        { type: UsuarioParamsService },
        { type: LoaderBaseService },
        { type: ServicesBaseService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    LstUsuariosComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator$1,] }],
        sort: [{ type: ViewChild, args: [MatSort,] }]
    };
    return LstUsuariosComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var esRangeLabel = (/**
 * @param {?} page
 * @param {?} pageSize
 * @param {?} length
 * @return {?}
 */
function (page, pageSize, length) {
    if (length == 0 || pageSize == 0) {
        return "0 de " + length;
    }
    length = Math.max(length, 0);
    /** @type {?} */
    var startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    /** @type {?} */
    var endIndex = startIndex < length ?
        Math.min(startIndex + pageSize, length) :
        startIndex + pageSize;
    return startIndex + 1 + " - " + endIndex + " de " + length;
});
/**
 * @return {?}
 */
function getEsPaginatorIntl() {
    /** @type {?} */
    var paginatorIntl = new MatPaginatorIntl();
    paginatorIntl.itemsPerPageLabel = 'Elementos por página:';
    paginatorIntl.nextPageLabel = 'Página siguiente';
    paginatorIntl.previousPageLabel = 'Página anterior';
    paginatorIntl.firstPageLabel = 'Primera página';
    paginatorIntl.lastPageLabel = 'Última página';
    paginatorIntl.getRangeLabel = esRangeLabel;
    return paginatorIntl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NumberDirective = /** @class */ (function () {
    function NumberDirective(_el) {
        this._el = _el;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    NumberDirective.prototype.onInputChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var initalValue = this._el.nativeElement.value;
        this._el.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
        if (initalValue !== this._el.nativeElement.value) {
            event.stopPropagation();
        }
    };
    NumberDirective.decorators = [
        { type: Directive, args: [{
                    selector: 'input[numbersOnly]'
                },] }
    ];
    /** @nocollapse */
    NumberDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    NumberDirective.propDecorators = {
        onInputChange: [{ type: HostListener, args: ['input', ['$event'],] }]
    };
    return NumberDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EventosAutorizacionPeticion = /** @class */ (function () {
    function EventosAutorizacionPeticion() {
        this.codTipoPortal = "";
    }
    return EventosAutorizacionPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EventoAutorizacion = /** @class */ (function () {
    function EventoAutorizacion() {
        this.idEvento = 0;
        this.codEvento = "";
        this.dscEvento = "";
        this.codTipoPortal = "";
    }
    return EventoAutorizacion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConfiguracionParams = /** @class */ (function () {
    function ConfiguracionParams() {
        this.idConfig = 0;
        this.docEmpresa = '';
        this.docEmpresaLista = '';
        this.codTipoPortal = '';
        this.codEvento = '';
        this.codEstado = '';
        this.codEstadoLista = '';
        this.indexPaginacion = -1;
    }
    /**
     * @return {?}
     */
    ConfiguracionParams.prototype.isNull = /**
     * @return {?}
     */
    function () {
        if (this.idConfig === 0 && this.docEmpresa === '' && this.codTipoPortal === '' && this.codEvento === '' && this.codEstado === '' && this.indexPaginacion === -1 && this.codEstadoLista === '' && this.docEmpresaLista === '') {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * @return {?}
     */
    ConfiguracionParams.prototype.setNull = /**
     * @return {?}
     */
    function () {
        this.idConfig = 0;
        this.docEmpresa = '';
        this.codTipoPortal = '';
        this.codEvento = '';
        this.codEstado = '';
        this.codEstadoLista = '';
        this.indexPaginacion = -1;
        this.docEmpresaLista = '';
    };
    ConfiguracionParams.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ ConfiguracionParams.ngInjectableDef = defineInjectable({ factory: function ConfiguracionParams_Factory() { return new ConfiguracionParams(); }, token: ConfiguracionParams, providedIn: "root" });
    return ConfiguracionParams;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EstadoConfiguracion = /** @class */ (function () {
    function EstadoConfiguracion() {
        this.codEstado = "";
        this.dscEstado = "";
    }
    return EstadoConfiguracion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AutorizacionConfiguracionComponent = /** @class */ (function () {
    function AutorizacionConfiguracionComponent(service, serviceDescarga, serviceEmpresas, configuracionParams, dialog, router, route, serviceBaseService, environment) {
        this.service = service;
        this.serviceDescarga = serviceDescarga;
        this.serviceEmpresas = serviceEmpresas;
        this.configuracionParams = configuracionParams;
        this.dialog = dialog;
        this.router = router;
        this.route = route;
        this.serviceBaseService = serviceBaseService;
        this.environment = environment;
        this.firstFormGroup = new FormGroup({
            empresa: new FormControl('-1'),
            evento: new FormControl('-1'),
            estado: new FormControl('-1')
        });
        this.resultadoEmpresas = [];
        this.eventosAutorizacion = [];
        this.estadosConfiguracion = [];
        this.show = false;
        this.isCollapsed = false;
        this.codTpoPortal = '';
        this.viewEmpresa = true;
        this.empresaSelectedText = 'Todas';
        this.eventoSelectedText = 'Todos';
        this.estadoSelectedText = 'Todas';
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
    }
    /**
     * @return {?}
     */
    AutorizacionConfiguracionComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        console.log('configuracionParams lista configuraciones', this.configuracionParams);
        this.viewAgregar = this.serviceBaseService.validaAccesoMenu('configuracionAgregar');
        this.viewEditar = this.serviceBaseService.validaAccesoMenu('configuracionEditar');
        if (this.codTpoPortal == 'COMERCIO') {
            this.viewEmpresa = false;
        }
        this.displayedColumns = ['idAutCnf', 'razonSocialEmpresa', 'dscConfiguracion', 'dscEvento', 'dscEstado'];
        if (this.viewEditar) {
            this.displayedColumns.push('editar');
        }
        this.loadDataParameters();
    };
    /**
     * @return {?}
     */
    AutorizacionConfiguracionComponent.prototype.loadDataParameters = /**
     * @return {?}
     */
    function () {
        if (!this.configuracionParams.isNull()) {
            this.callListaEmpresas(this.configuracionParams.docEmpresaLista);
            this.callEventosAutorizacion(this.getTipoPortal(this.configuracionParams.docEmpresaLista), this.configuracionParams.codEvento);
            this.callListaEstadosConfiguracion(this.configuracionParams.codEstadoLista);
            this.callListaConfiguraciones(this.getTipoPortal(this.configuracionParams.docEmpresaLista), this.configuracionParams.codEvento, this.configuracionParams.docEmpresaLista, this.configuracionParams.codEstadoLista, 'form');
        }
        else {
            if (this.codTpoPortal == 'COMERCIO') {
                this.callEventosAutorizacion('COMERCIO', '-1');
            }
            else {
                //Trae todos los eventos para el adquirente
                this.callEventosAutorizacion('-1', '-1');
                this.callListaEmpresas('-1');
            }
            this.callListaEstadosConfiguracion('-1');
        }
    };
    /**
     * @param {?} docEmpresaSelected
     * @return {?}
     */
    AutorizacionConfiguracionComponent.prototype.callListaEmpresas = /**
     * @param {?} docEmpresaSelected
     * @return {?}
     */
    function (docEmpresaSelected) {
        var _this = this;
        /** @type {?} */
        var params = new EmpresasPeticion();
        params.codCliente = this.environment.codCliente;
        params.codEstadoConvenio = 'HBL';
        params.withCliente = "true";
        this.serviceEmpresas.postListarSelectEmpresas(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEmpresas = data.resultado;
                //Se agregar el TODAS
                /** @type {?} */
                var empresaTodas = new EmpresaResult();
                empresaTodas.docFacturador = '-1';
                empresaTodas.nomFacturador = 'Todas';
                _this.resultadoEmpresas.splice(0, 0, empresaTodas);
                _this.firstFormGroup.get('empresa').setValue(docEmpresaSelected);
                _this.setSelectedText('empresa', _this.resultadoEmpresas.find((/**
                 * @param {?} e
                 * @return {?}
                 */
                function (e) { return e.docFacturador === docEmpresaSelected; })).nomFacturador);
            }
            else {
                console.error('Error en servicio listar empresas.', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error al llamar servicio listar empresas', err);
        }));
        // this.serviceEmpresas.postListarEmpresas(params).subscribe(data => {
        //   if (data.codret == '0') {
        //     this.resultadoEmpresas = data.resultado;
        //     //Se agregar el TODAS
        //     let empresaTodas: EmpresaResult = new EmpresaResult();
        //     empresaTodas.docFacturador = '-1';
        //     empresaTodas.nomFacturador = 'Todas';
        //     this.resultadoEmpresas.splice(0, 0, empresaTodas);
        //     this.firstFormGroup.get('empresa').setValue(docEmpresaSelected);
        //     this.setSelectedText('empresa', this.resultadoEmpresas.find(e => e.docFacturador === docEmpresaSelected).nomFacturador);
        //   } else {
        //     console.error('Error en servicio listar empresas.', data.descret);
        //   }
        // }, err => {
        //   console.error('Error al llamar servicio listar empresas', err);
        // });
    };
    /**
     * @param {?} tipoPortal
     * @param {?} eventoSelected
     * @return {?}
     */
    AutorizacionConfiguracionComponent.prototype.callEventosAutorizacion = /**
     * @param {?} tipoPortal
     * @param {?} eventoSelected
     * @return {?}
     */
    function (tipoPortal, eventoSelected) {
        var _this = this;
        /** @type {?} */
        var params = new EventosAutorizacionPeticion();
        params.codTipoPortal = tipoPortal;
        this.service.postListaEventosAutorizacion(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.eventosAutorizacion = data.eventos;
                /** @type {?} */
                var eventoTodos = new EventoAutorizacion();
                eventoTodos.codEvento = '-1';
                eventoTodos.dscEvento = 'Todos';
                eventoTodos.codTipoPortal = 'Todos';
                _this.eventosAutorizacion.splice(0, 0, eventoTodos);
                _this.firstFormGroup.get('evento').setValue(eventoSelected);
                _this.setSelectedText('evento', _this.eventosAutorizacion.find((/**
                 * @param {?} e
                 * @return {?}
                 */
                function (e) { return e.codEvento === eventoSelected; })).dscEvento);
            }
            else {
                console.error('Error al buscar listado de eventos autorizacion', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en servicio listado de eventos autorizacion', err);
        }));
    };
    /**
     * @param {?} codEstadoSelected
     * @return {?}
     */
    AutorizacionConfiguracionComponent.prototype.callListaEstadosConfiguracion = /**
     * @param {?} codEstadoSelected
     * @return {?}
     */
    function (codEstadoSelected) {
        var _this = this;
        this.service.postListaEstadosConfiguraciones().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.estadosConfiguracion = data.estados;
                //Se agregar el TODOS
                /** @type {?} */
                var estadoTodos = new EstadoConfiguracion();
                estadoTodos.codEstado = '-1';
                estadoTodos.dscEstado = 'Todos';
                _this.estadosConfiguracion.splice(0, 0, estadoTodos);
                _this.firstFormGroup.get('estado').setValue(codEstadoSelected);
                _this.setSelectedText('estado', _this.estadosConfiguracion.find((/**
                 * @param {?} e
                 * @return {?}
                 */
                function (e) { return e.codEstado === codEstadoSelected; })).dscEstado);
            }
            else {
                console.error('Error en servicio listar estados.', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error al llamar servicio listar estados', err);
        }));
    };
    /**
     * @param {?} tipoPortal
     * @param {?} codEvento
     * @param {?} docEmpresa
     * @param {?} codEstado
     * @param {?} tipoReporte
     * @return {?}
     */
    AutorizacionConfiguracionComponent.prototype.callListaConfiguraciones = /**
     * @param {?} tipoPortal
     * @param {?} codEvento
     * @param {?} docEmpresa
     * @param {?} codEstado
     * @param {?} tipoReporte
     * @return {?}
     */
    function (tipoPortal, codEvento, docEmpresa, codEstado, tipoReporte) {
        var _this = this;
        /** @type {?} */
        var params = new ConfiguracionesAutorizacionPeticion();
        params.codCliente = this.environment.codCliente;
        params.docEmpresa = docEmpresa;
        params.codTipoPortal = tipoPortal;
        params.codEvento = codEvento;
        params.codEstado = codEstado;
        params.filtros = this.getFiltros();
        if (tipoReporte == 'excel' || tipoReporte == 'pdf') {
            this.postDownloadReportFile(params, tipoReporte);
        }
        else {
            this.show = true;
            this.service.postListaConfigAutorizaciones(params).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                if (data.codret == '0') {
                    if (data.configuraciones.length > 0) {
                        _this.dataSource = new MatTableDataSource(data.configuraciones);
                        _this.paginator.pageIndex = _this.configuracionParams.indexPaginacion;
                        _this.dataSource.paginator = _this.paginator;
                        _this.isCollapsed = true;
                    }
                    else {
                        console.error('Resultado sin configuraciones');
                        _this.isCollapsed = false;
                        _this.show = false;
                    }
                }
                else {
                    console.error('Error al buscar listado de configuraciones', data.descret);
                    _this.show = false;
                }
                _this.configuracionParams.setNull();
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function (err) {
                console.error('Error en servicio listado de configuraciones', err);
                _this.show = false;
            }));
        }
    };
    /**
     * @return {?}
     */
    AutorizacionConfiguracionComponent.prototype.getFiltros = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var filtros = [];
        filtros.push({ title: 'Empresa', text: this.empresaSelectedText });
        filtros.push({ title: 'Evento', text: this.eventoSelectedText });
        filtros.push({ title: 'Estado', text: this.estadoSelectedText });
        return filtros;
    };
    /**
     * @param {?} control
     * @param {?} texto
     * @return {?}
     */
    AutorizacionConfiguracionComponent.prototype.setSelectedText = /**
     * @param {?} control
     * @param {?} texto
     * @return {?}
     */
    function (control, texto) {
        if (control == 'empresa') {
            this.empresaSelectedText = texto;
        }
        if (control == 'estado') {
            this.estadoSelectedText = texto;
        }
        if (control == 'evento') {
            this.eventoSelectedText = texto;
        }
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    AutorizacionConfiguracionComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiAutorizacionesMT/listaConfigAutorizaciones/' + tipo;
        this.serviceDescarga.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'reporteConfiguraciones' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'reporteConfiguraciones' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    AutorizacionConfiguracionComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        /** @type {?} */
        var codEvento = this.firstFormGroup.get('evento').value;
        /** @type {?} */
        var docEmpresa = (this.codTpoPortal == 'COMERCIO') ? this.docEmpresa : this.firstFormGroup.get('empresa').value;
        /** @type {?} */
        var codEstado = this.firstFormGroup.get('estado').value;
        this.callListaConfiguraciones(this.getTipoPortal(this.firstFormGroup.get('empresa').value), codEvento, docEmpresa, codEstado, tipo);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AutorizacionConfiguracionComponent.prototype.changeEmpresaSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var tipoPortalSelected = this.getTipoPortal(event.source.value);
        this.callEventosAutorizacion(tipoPortalSelected, '-1');
    };
    /**
     * @param {?} docEmpresa
     * @return {?}
     */
    AutorizacionConfiguracionComponent.prototype.getTipoPortal = /**
     * @param {?} docEmpresa
     * @return {?}
     */
    function (docEmpresa) {
        if (docEmpresa == '-1') {
            return docEmpresa;
        }
        else {
            if (docEmpresa == this.docEmpresa && this.codTpoPortal == 'ADQUIRENTE') {
                return 'ADQUIRENTE';
            }
            else {
                return 'COMERCIO';
            }
        }
    };
    /**
     * @return {?}
     */
    AutorizacionConfiguracionComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.firstFormGroup.get('empresa').setValue('-1');
        this.firstFormGroup.get('evento').setValue('-1');
        this.firstFormGroup.get('estado').setValue('-1');
        this.setSelectedText('empresa', 'Todas');
        this.setSelectedText('evento', 'Todos');
        this.setSelectedText('estado', 'Todos');
        this.dataSource = new MatTableDataSource([]);
        this.isCollapsed = false;
        this.show = false;
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    AutorizacionConfiguracionComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @param {?} idConfig
     * @param {?} docEmpresa
     * @param {?} codEstado
     * @return {?}
     */
    AutorizacionConfiguracionComponent.prototype.callEditarConfiguracion = /**
     * @param {?} idConfig
     * @param {?} docEmpresa
     * @param {?} codEstado
     * @return {?}
     */
    function (idConfig, docEmpresa, codEstado) {
        this.configuracionParams.idConfig = idConfig;
        this.configuracionParams.docEmpresaLista = (this.codTpoPortal == 'COMERCIO') ? this.docEmpresa : this.firstFormGroup.get('empresa').value;
        this.configuracionParams.docEmpresa = docEmpresa;
        this.configuracionParams.codEvento = this.firstFormGroup.get('evento').value;
        this.configuracionParams.codTipoPortal = this.codTpoPortal;
        this.configuracionParams.indexPaginacion = (this.paginator) ? this.paginator.pageIndex : 0;
        this.configuracionParams.codEstado = codEstado;
        this.configuracionParams.codEstadoLista = this.firstFormGroup.get('estado').value;
        this.router.navigate(['../configuracionEditar'], { relativeTo: this.route });
    };
    /**
     * @return {?}
     */
    AutorizacionConfiguracionComponent.prototype.callAgregarConfiguracion = /**
     * @return {?}
     */
    function () {
        this.configuracionParams.docEmpresaLista = (this.codTpoPortal == 'COMERCIO') ? this.docEmpresa : this.firstFormGroup.get('empresa').value;
        this.configuracionParams.docEmpresa = (this.codTpoPortal == 'COMERCIO') ? this.docEmpresa : this.firstFormGroup.get('empresa').value;
        this.configuracionParams.codEvento = this.firstFormGroup.get('evento').value;
        this.configuracionParams.codTipoPortal = this.codTpoPortal;
        this.configuracionParams.indexPaginacion = (this.paginator) ? this.paginator.pageIndex : 0;
        this.configuracionParams.codEstadoLista = this.firstFormGroup.get('estado').value;
        this.router.navigate(['../configuracionAgregar'], { relativeTo: this.route });
    };
    /**
     * @param {?} idConfig
     * @return {?}
     */
    AutorizacionConfiguracionComponent.prototype.callEliminarConfiguracion = /**
     * @param {?} idConfig
     * @return {?}
     */
    function (idConfig) {
        console.log('Eliminar configuracion');
    };
    /**
     * @return {?}
     */
    AutorizacionConfiguracionComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.firstFormGroup.valid) {
            this.onSubmit('');
        }
    };
    AutorizacionConfiguracionComponent.decorators = [
        { type: Component, args: [{
                    selector: 'configuracion',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"seccion-titulo-boton\">\r\n      <div class=\"row\">\r\n        <div class=\"col align-right seccion-titulo-boton\" *ngIf=\"viewAgregar\">\r\n          <a class=\"boton-seccion btn-small main\" (click)=\"callAgregarConfiguracion()\"><i class=\"str-icon-mas\"></i>Agregar configuraci&oacute;n</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"modulo-filtros\">\r\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <i class=\"str-icon-filtros mr-2\"></i>\r\n            <strong>Filtros</strong>\r\n          </div>\r\n          <div class=\"col text-right\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n          </div>\r\n        </div>\r\n     </a>\r\n      <div class=\"col\">\r\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n          <div class=\"box-filtros card card-body\">\r\n            <form [formGroup]=\"firstFormGroup\" (ngSubmit)=\"validarForm()\" autocomplete=\"off\">\r\n              <div class=\"form-row\">\r\n                <div class=\"form-group col-md-4\" *ngIf=\"viewEmpresa\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"empresa\" (selectionChange)=\"changeEmpresaSelect($event)\">\r\n                      <mat-option *ngFor=\"let empresa of resultadoEmpresas\" [value]=\"empresa.docFacturador\" (click)=\"setSelectedText('empresa', empresa.nomFacturador)\">{{empresa.nomFacturador}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Eventos\" formControlName=\"evento\">\r\n                      <mat-option *ngFor=\"let evento of eventosAutorizacion; let i = index\" [value]=\"evento.codEvento\" (click)=\"setSelectedText('evento', (i == 0) ? 'Todos' : evento.dscEvento + ' - ' + evento.codTipoPortal)\">{{(i == 0) ? 'Todos' : evento.dscEvento + ' - ' + evento.codTipoPortal}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n                <div class=\"form-group col-md-4\">\r\n                  <mat-form-field>\r\n                    <mat-select matNativeControl placeholder=\"Estados\" formControlName=\"estado\">\r\n                      <mat-option *ngFor=\"let estado of estadosConfiguracion\" [value]=\"estado.codEstado\" (click)=\"setSelectedText('estado', estado.dscEstado)\">{{estado.dscEstado}}</mat-option>\r\n                    </mat-select>\r\n                  </mat-form-field>\r\n                </div>\r\n              </div>\r\n              <div class=\"actions\">\r\n                <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                <button type=\"submit\" class=\"btn main\">Filtrar</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section *ngIf=\"show\">\r\n      <div class=\"table-container table-responsive-md\">\r\n        <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n          <ng-container matColumnDef=\"idAutCnf\">\r\n            <th mat-header-cell *matHeaderCellDef>Id</th>\r\n            <td mat-cell *matCellDef=\"let element\"> {{element.idAutCnf}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"razonSocialEmpresa\">\r\n            <th mat-header-cell *matHeaderCellDef>Empresa</th>\r\n            <td mat-cell *matCellDef=\"let element\"> {{element.razonSocialEmpresa}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"dscConfiguracion\">\r\n            <th mat-header-cell *matHeaderCellDef>Descripci&oacute;n</th>\r\n            <td mat-cell *matCellDef=\"let element\"> {{element.dscConfiguracion}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"dscEvento\">\r\n            <th mat-header-cell *matHeaderCellDef>Evento</th>\r\n            <td mat-cell *matCellDef=\"let element\"> {{element.dscEvento}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"dscEstado\">\r\n            <th mat-header-cell *matHeaderCellDef>Estado</th>\r\n            <td mat-cell *matCellDef=\"let element\"> {{element.dscEstado}} </td>\r\n          </ng-container>\r\n          <ng-container matColumnDef=\"editar\">\r\n            <th mat-header-cell *matHeaderCellDef>Editar</th>\r\n            <td mat-cell *matCellDef=\"let element\"><span matTooltip=\"Editar\" matTooltipPosition=\"above\" (click)=\"callEditarConfiguracion(element.idAutCnf, element.docEmpresa, element.codEstado)\" class=\"material-icons\">edit</span></td>\r\n          </ng-container>\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\">\r\n          </tr>\r\n        </table>\r\n        <mat-paginator [pageSizeOptions]=\"[10]\" showFirstLastButtons ></mat-paginator>\r\n      </div>\r\n\r\n      <div class=\"box-actions\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6 item\">\r\n            <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n          </div>\r\n          <div class=\"col-md-6 item-right\">\r\n            <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </section>\r\n\r\n    <div class=\"modulo-cuentas\" *ngIf=\"!show\">\r\n      <span>No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.</span>\r\n    </div>\r\n\r\n  </div>\r\n</section>"
                }] }
    ];
    /** @nocollapse */
    AutorizacionConfiguracionComponent.ctorParameters = function () { return [
        { type: AutorizacionesService },
        { type: DescargaExcelPdfFileService },
        { type: EmpresasService },
        { type: ConfiguracionParams },
        { type: MatDialog },
        { type: Router },
        { type: ActivatedRoute },
        { type: ServicesBaseService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    AutorizacionConfiguracionComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator,] }]
    };
    return AutorizacionConfiguracionComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TipoAutorizador = /** @class */ (function () {
    function TipoAutorizador() {
        this.codTipoAtz = "";
        this.dscTipoAtz = "";
    }
    return TipoAutorizador;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AutorizadoresParams = /** @class */ (function () {
    function AutorizadoresParams() {
        this.idAtzAut = 0;
        this.docEmpresa = '-1';
        this.codTipoPortal = '';
        this.tipoAutorizador = '-1';
        this.indexPaginacion = -1;
        this.codEstadoListado = '-1';
        this.codEstado = '-1';
        this.docUsrEmp = '';
    }
    /**
     * @return {?}
     */
    AutorizadoresParams.prototype.isNull = /**
     * @return {?}
     */
    function () {
        if (this.idAtzAut === 0 && this.docEmpresa === '-1' && this.codTipoPortal === '' && this.tipoAutorizador === '-1' && this.indexPaginacion === -1 && this.codEstadoListado === '-1' && this.codEstado === '-1' && this.docUsrEmp === '') {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * @return {?}
     */
    AutorizadoresParams.prototype.setNull = /**
     * @return {?}
     */
    function () {
        this.idAtzAut = 0;
        this.docEmpresa = '-1';
        this.codTipoPortal = '';
        this.tipoAutorizador = '-1';
        this.indexPaginacion = -1;
        this.codEstadoListado = '-1';
        this.codEstado = '-1';
        this.docUsrEmp = '';
    };
    AutorizadoresParams.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ AutorizadoresParams.ngInjectableDef = defineInjectable({ factory: function AutorizadoresParams_Factory() { return new AutorizadoresParams(); }, token: AutorizadoresParams, providedIn: "root" });
    return AutorizadoresParams;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AutorizacionAutorizadoresComponent = /** @class */ (function () {
    function AutorizacionAutorizadoresComponent(service, serviceEmpresas, serviceDescarga, autorizadoresParams, dialog, router, route, serviceBaseService, environment) {
        this.service = service;
        this.serviceEmpresas = serviceEmpresas;
        this.serviceDescarga = serviceDescarga;
        this.autorizadoresParams = autorizadoresParams;
        this.dialog = dialog;
        this.router = router;
        this.route = route;
        this.serviceBaseService = serviceBaseService;
        this.environment = environment;
        this.firstFormGroup = new FormGroup({
            tipoAutorizador: new FormControl('-1'),
            empresa: new FormControl('-1'),
            estado: new FormControl('-1')
        });
        this.tiposAutorizador = [];
        this.resultadoEmpresas = [];
        this.resultadoAtz = [];
        this.estadosAutorizadores = [];
        this.show = false;
        this.isCollapsed = false;
        this.codTpoPortal = '';
        this.viewAgregar = false;
        this.viewEditar = false;
        this.viewEmpresa = true;
        this.empresaSelectedText = 'Todas';
        this.tipoAutorizadorSelectedText = 'Todos';
        this.estadoSelectedText = 'Todos';
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
    }
    /**
     * @return {?}
     */
    AutorizacionAutorizadoresComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.viewAgregar = this.serviceBaseService.validaAccesoMenu('autorizadoresAgregar');
        this.viewEditar = this.serviceBaseService.validaAccesoMenu('autorizadoresEditar');
        if (this.codTpoPortal == 'COMERCIO') {
            this.viewEmpresa = false;
        }
        this.displayedColumns = ['idAtz', 'razSocialEmpresa', 'nomUsrEmp', 'patUsrEmp', 'codStdUsrEmp', 'dscEstado', 'dscAtzTip'];
        if (this.viewEditar) {
            this.displayedColumns.push('editar');
        }
        this.loadDataParameters();
    };
    /**
     * @return {?}
     */
    AutorizacionAutorizadoresComponent.prototype.loadDataParameters = /**
     * @return {?}
     */
    function () {
        console.log('autorizadoresParams', this.autorizadoresParams);
        if (!this.autorizadoresParams.isNull()) {
            if (this.codTpoPortal != 'COMERCIO') {
                this.callListaEmpresas(this.autorizadoresParams.docEmpresa);
            }
            this.callTiposAutorizadores(this.autorizadoresParams.tipoAutorizador);
            this.callListaEstadosAutorizadores(this.autorizadoresParams.codEstadoListado);
            this.callListaAutorizadores('form', this.autorizadoresParams.docEmpresa, this.autorizadoresParams.tipoAutorizador, this.autorizadoresParams.codEstadoListado, this.autorizadoresParams.codTipoPortal);
        }
        else {
            if (this.codTpoPortal != 'COMERCIO') {
                this.callListaEmpresas('-1');
            }
            this.callTiposAutorizadores('-1');
            this.callListaEstadosAutorizadores('-1');
        }
    };
    /**
     * @param {?} docEmpresaSelected
     * @return {?}
     */
    AutorizacionAutorizadoresComponent.prototype.callListaEmpresas = /**
     * @param {?} docEmpresaSelected
     * @return {?}
     */
    function (docEmpresaSelected) {
        var _this = this;
        /** @type {?} */
        var params = new EmpresasPeticion();
        params.codCliente = this.environment.codCliente;
        params.codEstadoConvenio = 'HBL';
        params.withCliente = "true";
        this.serviceEmpresas.postListarSelectEmpresas(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEmpresas = data.resultado;
                //Se agregar el TODAS
                /** @type {?} */
                var empresaTodas = new EmpresaResult();
                empresaTodas.docFacturador = '-1';
                empresaTodas.nomFacturador = 'Todas';
                _this.resultadoEmpresas.splice(0, 0, empresaTodas);
                _this.firstFormGroup.get('empresa').setValue(docEmpresaSelected);
                _this.setSelectedText('empresa', _this.resultadoEmpresas.find((/**
                 * @param {?} e
                 * @return {?}
                 */
                function (e) { return e.docFacturador === docEmpresaSelected; })).nomFacturador);
            }
            else {
                console.error('Error en servicio listar empresas.', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error al llamar servicio listar empresas', err);
        }));
        // this.serviceEmpresas.postListarEmpresas(params).subscribe(data => {
        //   if (data.codret == '0') {
        //     this.resultadoEmpresas = data.resultado;
        //     //Se agregar el TODAS
        //     let empresaTodas: EmpresaResult = new EmpresaResult();
        //     empresaTodas.docFacturador = '-1';
        //     empresaTodas.nomFacturador = 'Todas';
        //     this.resultadoEmpresas.splice(0, 0, empresaTodas);
        //     this.firstFormGroup.get('empresa').setValue(docEmpresaSelected);
        //     this.setSelectedText('empresa', this.resultadoEmpresas.find(e => e.docFacturador === docEmpresaSelected).nomFacturador);
        //   } else {
        //     console.error('Error en servicio listar empresas.', data.descret);
        //   }
        // }, err => {
        //   console.error('Error al llamar servicio listar empresas', err);
        // });
    };
    /**
     * @param {?} codTipoAtzSelected
     * @return {?}
     */
    AutorizacionAutorizadoresComponent.prototype.callTiposAutorizadores = /**
     * @param {?} codTipoAtzSelected
     * @return {?}
     */
    function (codTipoAtzSelected) {
        var _this = this;
        this.service.postListaTiposAutorizador().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.tiposAutorizador = data.tipos;
                //Se agregar el TODOS
                /** @type {?} */
                var tipoTodos = new TipoAutorizador();
                tipoTodos.codTipoAtz = '-1';
                tipoTodos.dscTipoAtz = 'Todos';
                _this.tiposAutorizador.splice(0, 0, tipoTodos);
                _this.firstFormGroup.get('tipoAutorizador').setValue(codTipoAtzSelected);
                _this.setSelectedText('tipoAutorizador', _this.tiposAutorizador.find((/**
                 * @param {?} e
                 * @return {?}
                 */
                function (e) { return e.codTipoAtz === codTipoAtzSelected; })).dscTipoAtz);
            }
            else {
                console.error('Error al buscar listado de tipos de autorizadores', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en servicio listado de tipos de autorizadores', err);
        }));
    };
    /**
     * @param {?} codEstadoSelected
     * @return {?}
     */
    AutorizacionAutorizadoresComponent.prototype.callListaEstadosAutorizadores = /**
     * @param {?} codEstadoSelected
     * @return {?}
     */
    function (codEstadoSelected) {
        var _this = this;
        this.service.postListaEstadosAutorizadores().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.estadosAutorizadores = data.estados;
                //Se agregar el TODOS
                /** @type {?} */
                var estadoTodos = new EstadoConfiguracion();
                estadoTodos.codEstado = '-1';
                estadoTodos.dscEstado = 'Todos';
                _this.estadosAutorizadores.splice(0, 0, estadoTodos);
                _this.firstFormGroup.get('estado').setValue(codEstadoSelected);
                _this.setSelectedText('estado', _this.estadosAutorizadores.find((/**
                 * @param {?} e
                 * @return {?}
                 */
                function (e) { return e.codEstado === codEstadoSelected; })).dscEstado);
            }
            else {
                console.error('Error en servicio listar estados.', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error al llamar servicio listar estados', err);
        }));
    };
    /**
     * @param {?} tipoReporte
     * @param {?} docEmpresaSelected
     * @param {?} tipoAutorizadorSelected
     * @param {?} estadoSelected
     * @param {?} codTipoPortal
     * @return {?}
     */
    AutorizacionAutorizadoresComponent.prototype.callListaAutorizadores = /**
     * @param {?} tipoReporte
     * @param {?} docEmpresaSelected
     * @param {?} tipoAutorizadorSelected
     * @param {?} estadoSelected
     * @param {?} codTipoPortal
     * @return {?}
     */
    function (tipoReporte, docEmpresaSelected, tipoAutorizadorSelected, estadoSelected, codTipoPortal) {
        var _this = this;
        /** @type {?} */
        var params = new AutorizadoresPeticion();
        params.codCliente = this.environment.codCliente;
        params.docEmpresa = docEmpresaSelected;
        params.codTipoAutorizador = tipoAutorizadorSelected;
        params.codEstado = estadoSelected;
        params.docUsrEmp = '-1';
        params.codTipoPortal = codTipoPortal;
        params.filtros = this.getFiltros();
        if (tipoReporte == 'excel' || tipoReporte == 'pdf') {
            this.postDownloadReportFile(params, tipoReporte);
        }
        else {
            this.show = true;
            this.service.postListaAutorizadores(params).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                if (data.codret == '0') {
                    if (data.autorizadores.length > 0) {
                        _this.dataSource = new MatTableDataSource(data.autorizadores);
                        _this.paginator.pageIndex = _this.autorizadoresParams.indexPaginacion;
                        _this.dataSource.paginator = _this.paginator;
                        _this.isCollapsed = true;
                    }
                    else {
                        console.error('Resultado sin autorizadores');
                        _this.isCollapsed = false;
                        _this.show = false;
                    }
                }
                else {
                    console.error('Error al buscar listado de autorizadores', data.descret);
                    _this.show = false;
                }
                _this.autorizadoresParams.setNull();
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function (err) {
                console.error('Error en servicio listado de autorizaciones', err);
                _this.show = false;
            }));
        }
    };
    /**
     * @return {?}
     */
    AutorizacionAutorizadoresComponent.prototype.getFiltros = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var filtros = [];
        filtros.push({ title: 'Empresa', text: this.empresaSelectedText });
        filtros.push({ title: 'Tipo Autorizador', text: (this.codTpoPortal == 'COMERCIO') ? 'Comercio' : this.tipoAutorizadorSelectedText });
        filtros.push({ title: 'Estado', text: this.estadoSelectedText });
        return filtros;
    };
    /**
     * @param {?} control
     * @param {?} texto
     * @return {?}
     */
    AutorizacionAutorizadoresComponent.prototype.setSelectedText = /**
     * @param {?} control
     * @param {?} texto
     * @return {?}
     */
    function (control, texto) {
        if (control == 'empresa') {
            this.empresaSelectedText = texto;
        }
        if (control == 'estado') {
            this.estadoSelectedText = texto;
        }
        if (control == 'tipoautorizador') {
            this.tipoAutorizadorSelectedText = texto;
        }
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    AutorizacionAutorizadoresComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiAutorizacionesMT/listaAutorizadores/' + tipo;
        this.serviceDescarga.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'reporteAutorizadores' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'reporteAutorizadores' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error(err);
            _this.showDialog('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    AutorizacionAutorizadoresComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        /** @type {?} */
        var codEmpresa = (this.codTpoPortal == 'COMERCIO') ? this.docEmpresa : this.firstFormGroup.get('empresa').value;
        /** @type {?} */
        var codTipoAutorizador = (this.codTpoPortal == 'COMERCIO') ? 'NIVEL1' : this.firstFormGroup.get('tipoAutorizador').value;
        /** @type {?} */
        var codEstado = this.firstFormGroup.get('estado').value;
        /** @type {?} */
        var codTipoPortal = this.getTipoPortal(codEmpresa);
        this.callListaAutorizadores(tipo, codEmpresa, codTipoAutorizador, codEstado, codTipoPortal);
    };
    /**
     * @param {?} docEmpresa
     * @return {?}
     */
    AutorizacionAutorizadoresComponent.prototype.getTipoPortal = /**
     * @param {?} docEmpresa
     * @return {?}
     */
    function (docEmpresa) {
        if (docEmpresa == '-1') {
            return docEmpresa;
        }
        else {
            if (docEmpresa == this.docEmpresa && this.codTpoPortal == 'ADQUIRENTE') {
                return 'ADQUIRENTE';
            }
            else {
                return 'COMERCIO';
            }
        }
    };
    /**
     * @return {?}
     */
    AutorizacionAutorizadoresComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.firstFormGroup.get('tipoAutorizador').setValue('-1');
        this.firstFormGroup.get('empresa').setValue('-1');
        this.firstFormGroup.get('estado').setValue('-1');
        this.setSelectedText('tipoAutorizador', 'Todos');
        this.setSelectedText('empresa', 'Todas');
        this.setSelectedText('estado', 'Todos');
        this.dataSource = new MatTableDataSource([]);
        this.isCollapsed = false;
        this.show = false;
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    AutorizacionAutorizadoresComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('The dialog was closed ' + result);
        }));
    };
    /**
     * @return {?}
     */
    AutorizacionAutorizadoresComponent.prototype.callAgregarAutorizador = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var docEmpresa = (this.codTpoPortal == 'COMERCIO') ? this.docEmpresa : this.firstFormGroup.get('empresa').value;
        this.autorizadoresParams.idAtzAut = -1;
        this.autorizadoresParams.docEmpresa = docEmpresa;
        this.autorizadoresParams.tipoAutorizador = (this.codTpoPortal == 'COMERCIO') ? 'NIVEL1' : this.firstFormGroup.get('tipoAutorizador').value;
        this.autorizadoresParams.codTipoPortal = this.getTipoPortal(docEmpresa);
        this.autorizadoresParams.indexPaginacion = (this.paginator) ? this.paginator.pageIndex : 0;
        this.autorizadoresParams.codEstadoListado = this.firstFormGroup.get('estado').value;
        this.router.navigate(['../autorizadoresAgregar'], { relativeTo: this.route });
    };
    /**
     * @param {?} idAtz
     * @param {?} docUsrEmp
     * @param {?} codEstadoAtz
     * @return {?}
     */
    AutorizacionAutorizadoresComponent.prototype.callEditarAutorizador = /**
     * @param {?} idAtz
     * @param {?} docUsrEmp
     * @param {?} codEstadoAtz
     * @return {?}
     */
    function (idAtz, docUsrEmp, codEstadoAtz) {
        /** @type {?} */
        var docEmpresa = (this.codTpoPortal == 'COMERCIO') ? this.docEmpresa : this.firstFormGroup.get('empresa').value;
        this.autorizadoresParams.idAtzAut = idAtz;
        this.autorizadoresParams.docEmpresa = docEmpresa;
        this.autorizadoresParams.tipoAutorizador = (this.codTpoPortal == 'COMERCIO') ? 'NIVEL1' : this.firstFormGroup.get('tipoAutorizador').value;
        this.autorizadoresParams.codTipoPortal = this.getTipoPortal(docEmpresa);
        this.autorizadoresParams.indexPaginacion = (this.paginator) ? this.paginator.pageIndex : 0;
        this.autorizadoresParams.codEstadoListado = this.firstFormGroup.get('estado').value;
        this.autorizadoresParams.codEstado = codEstadoAtz;
        this.autorizadoresParams.docUsrEmp = docUsrEmp;
        this.router.navigate(['../autorizadoresEditar'], { relativeTo: this.route });
    };
    /**
     * @return {?}
     */
    AutorizacionAutorizadoresComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.firstFormGroup.valid) {
            this.onSubmit('');
        }
    };
    AutorizacionAutorizadoresComponent.decorators = [
        { type: Component, args: [{
                    selector: 'autorizadores',
                    template: "<section id=\"portal-comercio\">\r\n    <div class=\"container\">\r\n      <div class=\"seccion-titulo-boton\">\r\n        <div class=\"row\">\r\n          <div class=\"col align-right seccion-titulo-boton\" *ngIf=\"viewAgregar\">\r\n            <a class=\"boton-seccion btn-small main\" (click)=\"callAgregarAutorizador()\"><i class=\"str-icon-mas\"></i>Agregar autorizador</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"modulo-filtros\">\r\n        <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\r\n          <div class=\"row\">\r\n            <div class=\"col\">\r\n              <i class=\"str-icon-filtros mr-2\"></i>\r\n              <strong>Filtros</strong>\r\n            </div>\r\n            <div class=\"col text-right\">\r\n              <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\r\n            </div>\r\n          </div>\r\n       </a>\r\n        <div class=\"col\">\r\n          <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\r\n            <div class=\"box-filtros card card-body\">\r\n              <form [formGroup]=\"firstFormGroup\" (ngSubmit)=\"validarForm()\" autocomplete=\"off\">\r\n                <div class=\"form-row\">\r\n                  <div class=\"form-group col-md-4\" *ngIf=\"viewEmpresa\">\r\n                    <mat-form-field>\r\n                      <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"empresa\">\r\n                        <mat-option *ngFor=\"let empresa of resultadoEmpresas\" [value]=\"empresa.docFacturador\" (click)=\"setSelectedText('empresa', empresa.nomFacturador)\">{{empresa.nomFacturador}}</mat-option>\r\n                      </mat-select>\r\n                    </mat-form-field>\r\n                  </div>\r\n                  <div class=\"form-group col-md-4\" *ngIf=\"viewEmpresa\">\r\n                    <mat-form-field>\r\n                      <mat-select matNativeControl placeholder=\"Tipo Autorizador\" formControlName=\"tipoAutorizador\">\r\n                        <mat-option *ngFor=\"let atz of tiposAutorizador\" [value]=\"atz.codTipoAtz\" (click)=\"setSelectedText('tipoautorizador', atz.dscTipoAtz)\">{{atz.dscTipoAtz}}</mat-option>\r\n                      </mat-select>\r\n                    </mat-form-field>\r\n                  </div>\r\n                  <div class=\"form-group col-md-4\">\r\n                    <mat-form-field>\r\n                      <mat-select matNativeControl placeholder=\"Estados\" formControlName=\"estado\">\r\n                        <mat-option *ngFor=\"let estado of estadosAutorizadores\" [value]=\"estado.codEstado\" (click)=\"setSelectedText('estado', estado.dscEstado)\">{{estado.dscEstado}}</mat-option>\r\n                      </mat-select>\r\n                    </mat-form-field>\r\n                  </div>\r\n                </div>\r\n                <div class=\"actions\">\r\n                  <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\r\n                  <button type=\"submit\" class=\"btn main\">Filtrar</button>\r\n                </div>\r\n              </form>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n  \r\n      <section *ngIf=\"show\">\r\n        <div class=\"table-container table-responsive-md\">\r\n          <table class=\"table\" mat-table [dataSource]=\"dataSource\">\r\n            <ng-container matColumnDef=\"idAtz\">\r\n              <th mat-header-cell *matHeaderCellDef>Id</th>\r\n              <td mat-cell *matCellDef=\"let element\"> {{element.idAtz}} </td>\r\n            </ng-container>\r\n            <ng-container matColumnDef=\"razSocialEmpresa\">\r\n              <th mat-header-cell *matHeaderCellDef>Empresa</th>\r\n              <td mat-cell *matCellDef=\"let element\"> {{element.razSocialEmpresa}} </td>\r\n            </ng-container>\r\n            <ng-container matColumnDef=\"nomUsrEmp\">\r\n              <th mat-header-cell *matHeaderCellDef>Nombre</th>\r\n              <td mat-cell *matCellDef=\"let element\"> {{element.nomUsrEmp}} </td>\r\n            </ng-container>\r\n            <ng-container matColumnDef=\"patUsrEmp\">\r\n              <th mat-header-cell *matHeaderCellDef>Apellido</th>\r\n              <td mat-cell *matCellDef=\"let element\"> {{element.patUsrEmp}} </td>\r\n            </ng-container>\r\n            <ng-container matColumnDef=\"codStdUsrEmp\">\r\n              <th mat-header-cell *matHeaderCellDef>Estado Usuario</th>\r\n              <td mat-cell *matCellDef=\"let element\"> {{element.codStdUsrEmp}} </td>\r\n            </ng-container>\r\n            <ng-container matColumnDef=\"dscEstado\">\r\n              <th mat-header-cell *matHeaderCellDef>Estado Autorizador</th>\r\n              <td mat-cell *matCellDef=\"let element\"> {{element.dscEstado}} </td>\r\n            </ng-container>\r\n            <ng-container matColumnDef=\"dscAtzTip\">\r\n              <th mat-header-cell *matHeaderCellDef>Tipo Autorizador</th>\r\n              <td mat-cell *matCellDef=\"let element\"> {{element.dscAtzTip}} </td>\r\n            </ng-container>\r\n            <ng-container matColumnDef=\"editar\">\r\n              <th mat-header-cell *matHeaderCellDef>Editar</th>\r\n              <td mat-cell *matCellDef=\"let element\">\r\n                <a matTooltip=\"Editar autorizador\" matTooltipPosition=\"above\" Style=\"cursor: pointer;\" (click)=\"callEditarAutorizador(element.idAtz, element.docUsrEmp, element.codEstado)\" ><i class=\"icon str-icon-lapiz\"></i></a>\r\n              </td>\r\n            </ng-container>\r\n            <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n            <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\">\r\n            </tr>\r\n          </table>\r\n          <mat-paginator [pageSizeOptions]=\"[10]\" showFirstLastButtons></mat-paginator>\r\n        </div>\r\n  \r\n        <div class=\"box-actions\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-6 item\">\r\n              <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\r\n            </div>\r\n            <div class=\"col-md-6 item-right\">\r\n              <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </section>\r\n  \r\n      <div class=\"modulo-cuentas\" *ngIf=\"!show\">\r\n        <span>No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.</span>\r\n      </div>\r\n  \r\n    </div>\r\n  </section>",
                    providers: [AutorizacionesService]
                }] }
    ];
    /** @nocollapse */
    AutorizacionAutorizadoresComponent.ctorParameters = function () { return [
        { type: AutorizacionesService },
        { type: EmpresasService },
        { type: DescargaExcelPdfFileService },
        { type: AutorizadoresParams },
        { type: MatDialog },
        { type: Router },
        { type: ActivatedRoute },
        { type: ServicesBaseService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    AutorizacionAutorizadoresComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator,] }]
    };
    return AutorizacionAutorizadoresComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConfigAutorizacionPeticion = /** @class */ (function () {
    function ConfigAutorizacionPeticion() {
        this.codCliente = '';
        this.docEmpresa = '';
        this.idConfiguracion = -1;
        this.codEvento = '';
        this.dscConfiguracion = '';
        this.codTipoPortal = '';
        this.codEstado = '';
    }
    return ConfigAutorizacionPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AutorizacionesConfigAgregarComponent = /** @class */ (function () {
    function AutorizacionesConfigAgregarComponent(service, serviceEmpresas, configuracionParams, router, route, dialog, loader, environment) {
        this.service = service;
        this.serviceEmpresas = serviceEmpresas;
        this.configuracionParams = configuracionParams;
        this.router = router;
        this.route = route;
        this.dialog = dialog;
        this.loader = loader;
        this.environment = environment;
        this.formGroup = new FormGroup({
            empresa: new FormControl(''),
            descripcion: new FormControl('', Validators.compose([Validators.required, CustomValidators.descriptionValidator])),
            evento: new FormControl('', Validators.required)
        });
        this.resultadoEmpresas = [];
        this.eventosAutorizacion = [];
        this.codTpoPortal = '';
        this.viewEmpresa = false;
        this.codTpoPortal = this.configuracionParams.codTipoPortal;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
    }
    /**
     * @return {?}
     */
    AutorizacionesConfigAgregarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        console.log('Entro agregar configuracion');
        if (this.codTpoPortal == 'ADQUIRENTE') {
            this.viewEmpresa = true;
            this.callListaEmpresas();
            this.callEventosAutorizacion('-1');
        }
        else {
            this.callEventosAutorizacion('COMERCIO');
        }
    };
    /**
     * @return {?}
     */
    AutorizacionesConfigAgregarComponent.prototype.callListaEmpresas = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new EmpresasPeticion();
        params.codCliente = this.environment.codCliente;
        params.codEstadoConvenio = 'HBL';
        params.withCliente = 'true';
        this.serviceEmpresas.postListarEmpresas(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEmpresas = data.resultado;
            }
            else {
                console.error('Error en servicio listar empresas.', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error al llamar servicio listar empresas', err);
        }));
    };
    /**
     * @param {?} tipoPortal
     * @return {?}
     */
    AutorizacionesConfigAgregarComponent.prototype.callEventosAutorizacion = /**
     * @param {?} tipoPortal
     * @return {?}
     */
    function (tipoPortal) {
        var _this = this;
        /** @type {?} */
        var params = new EventosAutorizacionPeticion();
        params.codTipoPortal = tipoPortal;
        this.service.postListaEventosAutorizacion(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.eventosAutorizacion = data.eventos;
            }
            else {
                console.error('Error al buscar listado de eventos autorizacion', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en servicio listado de eventos autorizacion', err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AutorizacionesConfigAgregarComponent.prototype.changeEmpresaSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var tipoPortal = this.getTipoPortal(event.source.value);
        this.callEventosAutorizacion(tipoPortal);
    };
    /**
     * @param {?} docEmpresa
     * @return {?}
     */
    AutorizacionesConfigAgregarComponent.prototype.getTipoPortal = /**
     * @param {?} docEmpresa
     * @return {?}
     */
    function (docEmpresa) {
        if (docEmpresa == '-1') {
            return '-1';
        }
        else {
            if (docEmpresa == this.docEmpresa && this.codTpoPortal == 'ADQUIRENTE') {
                return 'ADQUIRENTE';
            }
            else {
                return 'COMERCIO';
            }
        }
    };
    /**
     * @return {?}
     */
    AutorizacionesConfigAgregarComponent.prototype.toConfiguraciones = /**
     * @return {?}
     */
    function () {
        this.router.navigate(['../configuracion'], { relativeTo: this.route });
    };
    /**
     * @return {?}
     */
    AutorizacionesConfigAgregarComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        console.log('onSubmit...');
        this.showDialogAprobar('Autorización', '¿Está seguro que desea generar la configuración?', true, true);
    };
    /**
     * @return {?}
     */
    AutorizacionesConfigAgregarComponent.prototype.callAgregaConfiguracionAutorizacion = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new ConfigAutorizacionPeticion();
        params.codCliente = this.environment.codCliente;
        if (this.codTpoPortal == 'COMERCIO') {
            params.docEmpresa = this.docEmpresa;
        }
        else {
            params.docEmpresa = this.formGroup.get('empresa').value;
        }
        params.codTipoPortal = this.codTpoPortal;
        params.codEvento = this.formGroup.get('evento').value;
        params.dscConfiguracion = this.formGroup.get('descripcion').value;
        params.codEstado = 'ACTIVA';
        this.service.postAgregaConfigAutorizacion(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.showDialogInformativo('Autorización', 'Configuración generada con éxito', false, true);
            }
            else {
                console.error('Error al agregar configuración', data.descret);
                _this.showDialogInformativo('Error', 'Error al generar la configuración.<br>' + data.descret, false, false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en servicio generar configuración', err);
            _this.showDialogInformativo('Autorización', 'Error al generar la configuración, contáctese con administrador de sistema.', false, false);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} isAprobar
     * @return {?}
     */
    AutorizacionesConfigAgregarComponent.prototype.showDialogAprobar = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} isAprobar
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel, isAprobar) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('Dialog generar configuración' + result);
            if (result) {
                if (isAprobar) {
                    console.log('Se genera la configuración');
                    _this.callAgregaConfiguracionAutorizacion();
                }
                else {
                    console.log('Se cancela la generación de configuración');
                }
            }
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} backToList
     * @return {?}
     */
    AutorizacionesConfigAgregarComponent.prototype.showDialogInformativo = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} backToList
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel, backToList) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('Dialog informativo', result);
            if (backToList) {
                _this.toConfiguraciones();
            }
        }));
    };
    AutorizacionesConfigAgregarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-autorizaciones-config-agregar',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a (click)=\"toConfiguraciones()\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <form [formGroup]=\"formGroup\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n        <h3>Agregar nueva configuraci&oacute;n</h3>\r\n        <div class=\"form-section\">\r\n          <h5>Datos</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-4\" *ngIf=\"viewEmpresa\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"empresa\" (selectionChange)=\"changeEmpresaSelect($event)\">\r\n                  <mat-option *ngFor=\"let empresa of resultadoEmpresas\" [value]=\"empresa.docFacturador\">{{empresa.nomFacturador}}</mat-option>\r\n                </mat-select>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"200\" placeholder=\"Descripci\u00F3n\" formControlName=\"descripcion\">\r\n                <mat-error>Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <mat-label>Seleccione</mat-label>\r\n                <mat-select matNativeControl placeholder=\"Eventos\" formControlName=\"evento\">\r\n                  <mat-option *ngFor=\"let evento of eventosAutorizacion\" [value]=\"evento.codEvento\">{{evento.dscEvento + ' - ' + evento.codTipoPortal}}</mat-option>\r\n                </mat-select>\r\n                <mat-error>Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col align-right\">\r\n            <button *ngIf=\"formGroup.invalid\" class=\"btn main\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n            <button *ngIf=\"formGroup.valid\" class=\"btn main\" type=\"submit\" (click)=\"onSubmit()\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>"
                }] }
    ];
    /** @nocollapse */
    AutorizacionesConfigAgregarComponent.ctorParameters = function () { return [
        { type: AutorizacionesService },
        { type: EmpresasService },
        { type: ConfiguracionParams },
        { type: Router },
        { type: ActivatedRoute },
        { type: MatDialog },
        { type: LoaderBaseService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return AutorizacionesConfigAgregarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConfiguracionAutorizacion = /** @class */ (function () {
    function ConfiguracionAutorizacion() {
        this.codCliente = '';
        this.docEmpresa = '';
        this.razonSocialEmpresa = '';
        this.idAutCnf = 0;
        this.idAutEve = 0;
        this.dscConfiguracion = '';
        this.codEvento = '';
        this.dscEvento = '';
        this.codTipoPortal = '';
        this.autQryEvento = '';
        this.autSchEvento = '';
        this.rchQryEvento = '';
        this.rchSchEvento = '';
    }
    return ConfiguracionAutorizacion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AutorizacionesConfigEditarComponent = /** @class */ (function () {
    function AutorizacionesConfigEditarComponent(service, configuracionParams, dialog, router, route, environment) {
        this.service = service;
        this.configuracionParams = configuracionParams;
        this.dialog = dialog;
        this.router = router;
        this.route = route;
        this.environment = environment;
        this.formGroup = new FormGroup({
            descripcion: new FormControl('', Validators.compose([Validators.required, CustomValidators.descriptionValidator])),
            evento: new FormControl(''),
            estado: new FormControl('')
        });
        this.codTpoPortal = '';
        this.configAutorizacion = new ConfiguracionAutorizacion();
        this.eventosAutorizacion = [];
        this.estadosConfiguracion = [];
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
    }
    /**
     * @return {?}
     */
    AutorizacionesConfigEditarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        console.log('Parametros configuracionParams', this.configuracionParams);
        this.callDetalleConfiguracion();
    };
    /**
     * @param {?} tipoPortal
     * @param {?} codEventoSelected
     * @return {?}
     */
    AutorizacionesConfigEditarComponent.prototype.callEventosAutorizacion = /**
     * @param {?} tipoPortal
     * @param {?} codEventoSelected
     * @return {?}
     */
    function (tipoPortal, codEventoSelected) {
        var _this = this;
        /** @type {?} */
        var params = new EventosAutorizacionPeticion();
        params.codTipoPortal = tipoPortal;
        this.service.postListaEventosAutorizacion(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.eventosAutorizacion = data.eventos;
                _this.formGroup.get('evento').setValue(codEventoSelected);
            }
            else {
                console.error('Error al buscar listado de eventos autorizacion', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en servicio listado de eventos autorizacion', err);
        }));
    };
    /**
     * @param {?} docEmpresa
     * @return {?}
     */
    AutorizacionesConfigEditarComponent.prototype.getTipoPortal = /**
     * @param {?} docEmpresa
     * @return {?}
     */
    function (docEmpresa) {
        if (docEmpresa == '-1') {
            return docEmpresa;
        }
        else {
            if (docEmpresa == this.docEmpresa && this.codTpoPortal == 'ADQUIRENTE') {
                return 'ADQUIRENTE';
            }
            else {
                return 'COMERCIO';
            }
        }
    };
    /**
     * @return {?}
     */
    AutorizacionesConfigEditarComponent.prototype.callDetalleConfiguracion = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new ConfiguracionesAutorizacionPeticion();
        params.codCliente = this.environment.codCliente;
        params.codEvento = this.configuracionParams.codEvento;
        params.docEmpresa = this.configuracionParams.docEmpresa;
        params.codTipoPortal = this.getTipoPortal(this.configuracionParams.docEmpresa);
        params.idConfig = this.configuracionParams.idConfig;
        params.codEstado = this.configuracionParams.codEstado;
        this.service.postListaConfigAutorizaciones(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                if (data.configuraciones.length == 1) {
                    _this.configAutorizacion = data.configuraciones[0];
                    _this.formGroup.get('descripcion').setValue(_this.configAutorizacion.dscConfiguracion);
                    _this.callEventosAutorizacion(_this.getTipoPortal(_this.configAutorizacion.docEmpresa), _this.configAutorizacion.codEvento);
                    _this.callEstadosConfiguracion(_this.configuracionParams.codEstado);
                }
                else {
                    console.error('Resultado sin configuración');
                    _this.showDialogInformativo('Error', 'No se encontró configuración para editar.', false, true);
                }
            }
            else {
                console.error('Error al buscar configuración', data.descret);
                _this.showDialogInformativo('Error', 'Error al buscar la configuración a editar.<br>' + data.descret, false, true);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en servicio buscar configuración', err);
            _this.showDialogInformativo('Error', 'Error en servicio para buscar la configuración', false, true);
        }));
    };
    /**
     * @param {?} codEstadoSelected
     * @return {?}
     */
    AutorizacionesConfigEditarComponent.prototype.callEstadosConfiguracion = /**
     * @param {?} codEstadoSelected
     * @return {?}
     */
    function (codEstadoSelected) {
        var _this = this;
        this.service.postListaEstadosConfiguraciones().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                if (data.estados.length > 0) {
                    _this.estadosConfiguracion = data.estados;
                    _this.formGroup.get('estado').setValue(codEstadoSelected);
                }
                else {
                    console.error('Resultado sin estados');
                }
            }
            else {
                console.error('Error al buscar estados', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en servicio buscar estados', err);
        }));
    };
    /**
     * @return {?}
     */
    AutorizacionesConfigEditarComponent.prototype.toConfiguraciones = /**
     * @return {?}
     */
    function () {
        this.router.navigate(['../configuracion'], { relativeTo: this.route });
    };
    /**
     * @return {?}
     */
    AutorizacionesConfigEditarComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        console.log('onSubmit');
        this.showDialogAprobar('Autorización', '¿Está seguro que desea modificar la configuración?', true, true);
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} isAprobar
     * @return {?}
     */
    AutorizacionesConfigEditarComponent.prototype.showDialogAprobar = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} isAprobar
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel, isAprobar) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('Dialog modificar configuración' + result);
            if (result) {
                if (isAprobar) {
                    console.log('Se modifica la configuración');
                    _this.callEditarConfiguracionAutorizacion();
                }
                else {
                    console.log('Se cancela la modificación de configuración');
                }
            }
        }));
    };
    /**
     * @return {?}
     */
    AutorizacionesConfigEditarComponent.prototype.callEditarConfiguracionAutorizacion = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new ConfigAutorizacionPeticion();
        params.codCliente = this.environment.codCliente;
        params.docEmpresa = this.configuracionParams.docEmpresa;
        params.codTipoPortal = this.getTipoPortal(this.configuracionParams.docEmpresa);
        params.idConfiguracion = this.configuracionParams.idConfig;
        params.codEvento = this.formGroup.get('evento').value;
        params.dscConfiguracion = this.formGroup.get('descripcion').value;
        params.codEstado = this.formGroup.get('estado').value;
        this.service.postCambiaConfigAutorizacion(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.showDialogInformativo('Autorización', 'Configuración modificada con éxito', false, true);
            }
            else {
                console.error('Error al modificar configuración', data.descret);
                _this.showDialogInformativo('Error', 'Error al modificar la configuración.<br>' + data.descret, false, false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en servicio modificar configuración', err);
            _this.showDialogInformativo('Autorización', 'Error al modificar la configuración, contáctese con administrador de sistema.', false, false);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} backToList
     * @return {?}
     */
    AutorizacionesConfigEditarComponent.prototype.showDialogInformativo = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} backToList
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel, backToList) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('Dialog informativo', result);
            if (backToList) {
                _this.toConfiguraciones();
            }
        }));
    };
    AutorizacionesConfigEditarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-autorizaciones-config-editar',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a (click)=\"toConfiguraciones()\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <form [formGroup]=\"formGroup\" autocomplete=\"off\">\r\n        <h3>Editar nueva configuraci&oacute;n</h3>\r\n        <div class=\"form-section\">\r\n          <h5>Datos</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <input matInput maxlength=\"200\" placeholder=\"Descripci\u00F3n\" formControlName=\"descripcion\" >\r\n                <mat-error>Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Evento\" formControlName=\"evento\">\r\n                  <mat-option *ngFor=\"let evento of eventosAutorizacion\" [value]=\"evento.codEvento\">{{evento.dscEvento + ' - ' + evento.codTipoPortal}}</mat-option>\r\n                </mat-select>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estado\">\r\n                  <mat-option *ngFor=\"let estado of estadosConfiguracion\" [value]=\"estado.codEstado\">{{estado.dscEstado}}</mat-option>\r\n                </mat-select>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col align-right\">\r\n            <button *ngIf=\"formGroup.invalid\" class=\"btn main\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n            <button *ngIf=\"formGroup.valid\" class=\"btn main\" type=\"submit\" (click)=\"onSubmit()\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>"
                }] }
    ];
    /** @nocollapse */
    AutorizacionesConfigEditarComponent.ctorParameters = function () { return [
        { type: AutorizacionesService },
        { type: ConfiguracionParams },
        { type: MatDialog },
        { type: Router },
        { type: ActivatedRoute },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return AutorizacionesConfigEditarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AutorizadorPeticion = /** @class */ (function () {
    function AutorizadorPeticion() {
        this.codCliente = '';
        this.docEmpresa = '';
        this.codTipoPortal = '';
        this.docUsrEmp = '';
        this.codEstado = '';
        this.idAtz = 0;
    }
    return AutorizadorPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UsuariosPeticion = /** @class */ (function () {
    function UsuariosPeticion() {
        this.codCliente = '';
        this.docEmpresa = '';
        this.codTipoPortal = '';
    }
    return UsuariosPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AutorizacionesAutorizadoresAgregarComponent = /** @class */ (function () {
    function AutorizacionesAutorizadoresAgregarComponent(autorizadoresParams, service, serviceEmpresas, router, route, dialog, loader, environment) {
        this.autorizadoresParams = autorizadoresParams;
        this.service = service;
        this.serviceEmpresas = serviceEmpresas;
        this.router = router;
        this.route = route;
        this.dialog = dialog;
        this.loader = loader;
        this.environment = environment;
        this.firstFormGroup = new FormGroup({
            empresa: new FormControl({ value: '', disabled: true }, Validators.required),
            usuario: new FormControl('', Validators.required),
            estado: new FormControl('', Validators.required)
        });
        this.usuariosAutorizadores = [];
        this.estadosAutorizadores = [];
        this.resultadoEmpresas = [];
        this.codTpoPortal = '';
        this.viewEmpresa = false;
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.docEmpresa = this.userPerfil.empresa.docEmpresa;
    }
    /**
     * @return {?}
     */
    AutorizacionesAutorizadoresAgregarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        console.log('Parameters agregar autorizador', this.autorizadoresParams);
        if (this.codTpoPortal == 'ADQUIRENTE') {
            this.viewEmpresa = true;
            this.callListaEmpresas(this.docEmpresa);
        }
        else {
            this.callListaUsuarios(this.docEmpresa);
        }
        this.callListaEstadosAutorizadores();
    };
    /**
     * @return {?}
     */
    AutorizacionesAutorizadoresAgregarComponent.prototype.toAutorizadores = /**
     * @return {?}
     */
    function () {
        this.router.navigate(['../autorizadores'], { relativeTo: this.route });
    };
    /**
     * @param {?} docEmpresa
     * @return {?}
     */
    AutorizacionesAutorizadoresAgregarComponent.prototype.callListaEmpresas = /**
     * @param {?} docEmpresa
     * @return {?}
     */
    function (docEmpresa) {
        var _this = this;
        /** @type {?} */
        var params = new EmpresasPeticion();
        params.codCliente = this.environment.codCliente;
        params.codEstadoConvenio = 'HBL';
        params.withCliente = 'true';
        this.serviceEmpresas.postListarEmpresas(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoEmpresas = data.resultado;
                _this.firstFormGroup.get('empresa').enable();
                _this.callListaUsuarios(docEmpresa);
            }
            else {
                console.error('Error en servicio listar empresas.', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error al llamar servicio listar empresas', err);
        }));
    };
    /**
     * @return {?}
     */
    AutorizacionesAutorizadoresAgregarComponent.prototype.callListaEstadosAutorizadores = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.service.postListaEstadosAutorizadores().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.estadosAutorizadores = data.estados;
            }
            else {
                console.error('Error en servicio listar estados.', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error al llamar servicio listar estados', err);
        }));
    };
    /**
     * @param {?} docEmpresa
     * @return {?}
     */
    AutorizacionesAutorizadoresAgregarComponent.prototype.callListaUsuarios = /**
     * @param {?} docEmpresa
     * @return {?}
     */
    function (docEmpresa) {
        var _this = this;
        /** @type {?} */
        var params = new UsuariosPeticion();
        params.codCliente = this.environment.codCliente;
        params.docEmpresa = docEmpresa;
        params.codTipoPortal = this.getTipoPortal(docEmpresa);
        this.service.postListaUsuarios(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.usuariosAutorizadores = data.usuarios;
            }
            else {
                console.error('Error al buscar listado de usuarios', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en servicio listado de usuarios', err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AutorizacionesAutorizadoresAgregarComponent.prototype.changeEmpresaSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var docEmpresa = event.source.value;
        this.callListaUsuarios(docEmpresa);
    };
    /**
     * @return {?}
     */
    AutorizacionesAutorizadoresAgregarComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        console.log('onSubmit...');
        this.showDialogAprobar('Autorización', '¿Está seguro que desea generar la configuración?', true, true);
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} isAprobar
     * @return {?}
     */
    AutorizacionesAutorizadoresAgregarComponent.prototype.showDialogAprobar = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} isAprobar
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel, isAprobar) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('Dialog generar configuración' + result);
            if (result) {
                if (isAprobar) {
                    console.log('Se agrega autorizador');
                    _this.callAgregaAutorizador();
                }
                else {
                    console.log('Se cancela el agregar autorizador');
                }
            }
        }));
    };
    /**
     * @param {?} docEmpresa
     * @return {?}
     */
    AutorizacionesAutorizadoresAgregarComponent.prototype.getTipoPortal = /**
     * @param {?} docEmpresa
     * @return {?}
     */
    function (docEmpresa) {
        if (docEmpresa == '-1') {
            return docEmpresa;
        }
        else {
            if (docEmpresa == this.docEmpresa && this.codTpoPortal == 'ADQUIRENTE') {
                return 'ADQUIRENTE';
            }
            else {
                return 'COMERCIO';
            }
        }
    };
    /**
     * @return {?}
     */
    AutorizacionesAutorizadoresAgregarComponent.prototype.callAgregaAutorizador = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var docEmpresa = (this.codTpoPortal == 'COMERCIO') ? this.docEmpresa : this.firstFormGroup.get('empresa').value;
        /** @type {?} */
        var params = new AutorizadorPeticion();
        params.codCliente = this.environment.codCliente;
        params.docEmpresa = docEmpresa;
        params.codTipoPortal = this.getTipoPortal(docEmpresa);
        params.docUsrEmp = this.firstFormGroup.get('usuario').value;
        params.codEstado = this.firstFormGroup.get('estado').value;
        this.service.postAgregarAutorizador(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.showDialogInformativo('Autorización', 'Autorizador creado con éxito', false, true);
            }
            else {
                console.error('Error al agregar autorizador', data.descret);
                _this.showDialogInformativo('Error', 'Error al crear autorizador.<br>' + data.descret, false, false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en servicio agregar autorizador', err);
            _this.showDialogInformativo('Error', 'Error al crear autorizador, contáctese con administrador de sistema.', false, false);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} backToList
     * @return {?}
     */
    AutorizacionesAutorizadoresAgregarComponent.prototype.showDialogInformativo = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} backToList
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel, backToList) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('Dialog informativo', result);
            if (backToList) {
                _this.toAutorizadores();
            }
        }));
    };
    AutorizacionesAutorizadoresAgregarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-autorizaciones-autorizadores-agregar',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a (click)=\"toAutorizadores()\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <form [formGroup]=\"firstFormGroup\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n        <h3>Agregar nuevo autorizador</h3>\r\n        <div class=\"form-section\">\r\n          <h5>Datos</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-4\" *ngIf=\"viewEmpresa\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"empresa\" (selectionChange)=\"changeEmpresaSelect($event)\">\r\n                  <mat-option *ngFor=\"let empresa of resultadoEmpresas\" [value]=\"empresa.docFacturador\">{{empresa.nomFacturador}}</mat-option>\r\n                </mat-select>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Usuario\" formControlName=\"usuario\">\r\n                  <mat-option *ngFor=\"let usuario of usuariosAutorizadores\" [value]=\"usuario.docUsrEmp\">{{usuario.nomUsrEmp + ' ' + usuario.patUsrEmp}}</mat-option>\r\n                </mat-select>\r\n                <mat-error>Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estado\">\r\n                  <mat-option *ngFor=\"let estado of estadosAutorizadores\" [value]=\"estado.codEstado\">{{estado.dscEstado}}</mat-option>\r\n                </mat-select>\r\n                <mat-error>Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col align-right\">\r\n            <button *ngIf=\"firstFormGroup.invalid\" class=\"btn main\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n            <button *ngIf=\"firstFormGroup.valid\" class=\"btn main\" type=\"submit\" (click)=\"onSubmit()\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>"
                }] }
    ];
    /** @nocollapse */
    AutorizacionesAutorizadoresAgregarComponent.ctorParameters = function () { return [
        { type: AutorizadoresParams },
        { type: AutorizacionesService },
        { type: EmpresasService },
        { type: Router },
        { type: ActivatedRoute },
        { type: MatDialog },
        { type: LoaderBaseService },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return AutorizacionesAutorizadoresAgregarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AutorizacionesAutorizadoresEditarComponent = /** @class */ (function () {
    function AutorizacionesAutorizadoresEditarComponent(service, autorizadoresParams, dialog, router, route, environment) {
        this.service = service;
        this.autorizadoresParams = autorizadoresParams;
        this.dialog = dialog;
        this.router = router;
        this.route = route;
        this.environment = environment;
        this.firstFormGroup = new FormGroup({
            empresa: new FormControl({ value: '', disabled: true }),
            nombre: new FormControl({ value: '', disabled: true }),
            apellido: new FormControl({ value: '', disabled: true }),
            estado: new FormControl('', Validators.required)
        });
        this.estadosAutorizadores = [];
    }
    /**
     * @return {?}
     */
    AutorizacionesAutorizadoresEditarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        console.log('Parametros autorizadores editar', this.autorizadoresParams);
        this.callListaAutorizadores();
    };
    /**
     * @param {?} codEstadoSelected
     * @return {?}
     */
    AutorizacionesAutorizadoresEditarComponent.prototype.callListaEstadosAutorizadores = /**
     * @param {?} codEstadoSelected
     * @return {?}
     */
    function (codEstadoSelected) {
        var _this = this;
        this.service.postListaEstadosAutorizadores().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.estadosAutorizadores = data.estados;
                _this.firstFormGroup.get('estado').setValue(codEstadoSelected);
            }
            else {
                console.error('Error en servicio listar estados.', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error al llamar servicio listar estados', err);
        }));
    };
    /**
     * @return {?}
     */
    AutorizacionesAutorizadoresEditarComponent.prototype.callListaAutorizadores = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new AutorizadoresPeticion();
        params.codCliente = this.environment.codCliente;
        params.docEmpresa = this.autorizadoresParams.docEmpresa;
        params.codTipoAutorizador = this.autorizadoresParams.tipoAutorizador;
        params.codEstado = this.autorizadoresParams.codEstado;
        params.docUsrEmp = this.autorizadoresParams.docUsrEmp;
        params.codTipoPortal = this.autorizadoresParams.codTipoPortal;
        this.service.postListaAutorizadores(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                if (data.autorizadores.length == 1) {
                    /** @type {?} */
                    var autorizador = data.autorizadores[0];
                    _this.firstFormGroup.get('empresa').setValue(autorizador.razSocialEmpresa);
                    _this.firstFormGroup.get('nombre').setValue(autorizador.nomUsrEmp);
                    _this.firstFormGroup.get('apellido').setValue(autorizador.patUsrEmp);
                    _this.callListaEstadosAutorizadores(autorizador.codEstado);
                }
                else {
                    console.error('Resultado sin autorizadores');
                    _this.showDialogInformativo('Error', 'Autorizador no existe', false, true);
                }
            }
            else {
                console.error('Error al buscar listado de autorizadores', data.descret);
                _this.showDialogInformativo('Error', 'Error al buscar el autorizador', false, true);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en servicio listado de autorizaciones', err);
            _this.showDialogInformativo('Error', 'Error en servicio para buscar el autorizador', false, true);
        }));
    };
    /**
     * @return {?}
     */
    AutorizacionesAutorizadoresEditarComponent.prototype.toAutorizadores = /**
     * @return {?}
     */
    function () {
        this.router.navigate(['../autorizadores'], { relativeTo: this.route });
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} backToList
     * @return {?}
     */
    AutorizacionesAutorizadoresEditarComponent.prototype.showDialogInformativo = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} backToList
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel, backToList) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('Dialog informativo', result);
            if (backToList) {
                _this.toAutorizadores();
            }
        }));
    };
    /**
     * @return {?}
     */
    AutorizacionesAutorizadoresEditarComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        console.log('onSubmit...');
        this.showDialogAprobar('Autorización', '¿Está seguro que desea editar el autorizador?', true, true);
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} isAprobar
     * @return {?}
     */
    AutorizacionesAutorizadoresEditarComponent.prototype.showDialogAprobar = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @param {?} isAprobar
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel, isAprobar) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            console.log('Dialog editar autorizador' + result);
            if (result) {
                if (isAprobar) {
                    console.log('Se edita autorizador');
                    _this.callEditarAutorizador();
                }
                else {
                    console.log('Se cancela el editar autorizador');
                }
            }
        }));
    };
    /**
     * @return {?}
     */
    AutorizacionesAutorizadoresEditarComponent.prototype.callEditarAutorizador = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new AutorizadorPeticion();
        params.codCliente = this.environment.codCliente;
        params.docEmpresa = this.autorizadoresParams.docEmpresa;
        params.codTipoPortal = this.autorizadoresParams.codTipoPortal;
        params.docUsrEmp = this.autorizadoresParams.docUsrEmp;
        params.codEstado = this.firstFormGroup.get('estado').value;
        params.idAtz = this.autorizadoresParams.idAtzAut;
        this.service.postCambiaAutorizador(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.showDialogInformativo('Información', 'Proceso exitoso', false, true);
            }
            else {
                console.error('Error al editar autorizador', data.descret);
                _this.showDialogInformativo('Error', 'Error al editar autorizador.<br>' + data.descret, false, false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en servicio editar autorizador', err);
            _this.showDialogInformativo('Error', 'Error en servicio para editar autorizador, intente nuevamente.', false, false);
        }));
    };
    AutorizacionesAutorizadoresEditarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-autorizaciones-autorizadores-editar',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"portal-main\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a (click)=\"toAutorizadores()\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <form [formGroup]=\"firstFormGroup\" #peticionForm=\"ngForm\" autocomplete=\"off\">\r\n        <h3>Editar autorizador</h3>\r\n        <div class=\"form-section\">\r\n          <h5>Datos</h5>\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-3\">\r\n              <mat-form-field>\r\n                <input matInput placeholder=\"Empresa\" formControlName=\"empresa\">\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-3\">\r\n              <mat-form-field>\r\n                <input matInput placeholder=\"Nombre\" formControlName=\"nombre\">\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-3\">\r\n              <mat-form-field>\r\n                <input matInput placeholder=\"Apellido\" formControlName=\"apellido\">\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-3\">\r\n              <mat-form-field>\r\n                <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estado\">\r\n                  <mat-option *ngFor=\"let estado of estadosAutorizadores\" [value]=\"estado.codEstado\">{{estado.dscEstado}}</mat-option>\r\n                </mat-select>\r\n                <mat-error>Este campo es requerido.</mat-error>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col align-right\">\r\n            <button *ngIf=\"firstFormGroup.invalid\" class=\"btn main\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n            <button *ngIf=\"firstFormGroup.valid\" class=\"btn main\" type=\"submit\" (click)=\"onSubmit()\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>"
                }] }
    ];
    /** @nocollapse */
    AutorizacionesAutorizadoresEditarComponent.ctorParameters = function () { return [
        { type: AutorizacionesService },
        { type: AutorizadoresParams },
        { type: MatDialog },
        { type: Router },
        { type: ActivatedRoute },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return AutorizacionesAutorizadoresEditarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GetAutorizacionDetallePeticion = /** @class */ (function () {
    function GetAutorizacionDetallePeticion() {
        this.codCliente = "";
        this.docEmpresa = "";
        this.idAut = 0;
    }
    return GetAutorizacionDetallePeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AutorizacionesDetallesComponent = /** @class */ (function () {
    function AutorizacionesDetallesComponent(router, route, sanitizer, autorizacionesService, autorizacionDetalle, environment) {
        this.router = router;
        this.route = route;
        this.sanitizer = sanitizer;
        this.autorizacionesService = autorizacionesService;
        this.autorizacionDetalle = autorizacionDetalle;
        this.environment = environment;
        this.detalle = "";
        this.res = "";
        this.res1 = "";
        this.idAutorizacion = 0;
        this.entidad = "";
        this.descripcion = "";
    }
    /**
     * @return {?}
     */
    AutorizacionesDetallesComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.autorizacionDetalle.idAuth == 0) {
            this.router.navigate(['../'], { relativeTo: this.route });
            return;
        }
        /** @type {?} */
        var peticion = new GetAutorizacionDetallePeticion();
        peticion.idAut = this.autorizacionDetalle.idAuth; //this.idAutorizacion;
        peticion.codCliente = this.autorizacionDetalle.CodCliente;
        peticion.docEmpresa = this.autorizacionDetalle.docEmpresa;
        this.autorizacionDetalle.hijo = true;
        this.callDetalleAuth(peticion);
        sessionStorage.setItem('componenteHijo', 'autorizaciones-detalles');
    };
    /**
     * @param {?} peticion
     * @return {?}
     */
    AutorizacionesDetallesComponent.prototype.callDetalleAuth = /**
     * @param {?} peticion
     * @return {?}
     */
    function (peticion) {
        var _this = this;
        this.autorizacionesService.postGetAutorizacionDetalle(peticion).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.descripcion = data.dscEntidad;
                _this.entidad = data.idEntidad;
                _this.detalle = "<table class=\"table\"><tr><th>Campo</th><th>Valor</th></tr>";
                _this.detalle = _this.detalle + _this.jsonTable(data.datosDetalle, 1);
                _this.detalle = _this.detalle + "</table>";
                _this.html = _this.sanitizer.bypassSecurityTrustHtml(_this.detalle.replace("undefined", ""));
            }
            else {
                console.error('Error en servicio detalle autorizacion.', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error al llamar servicio detalle autorizacion.', err);
        }));
    };
    /**
     * @param {?} obj
     * @param {?} tipo
     * @return {?}
     */
    AutorizacionesDetallesComponent.prototype.jsonTable = /**
     * @param {?} obj
     * @param {?} tipo
     * @return {?}
     */
    function (obj, tipo) {
        /** @type {?} */
        var preData = 0;
        for (var k in obj) {
            if (obj[k] instanceof Object) {
                this.jsonTable(obj[k], tipo);
            }
            else {
                if (tipo == 1) {
                    if (obj[k] != 'AUTHDATOS' && preData != 1) {
                        if (k == 'llave') {
                            this.res = this.res + "<tr><td>" + obj[k] + "</td>";
                        }
                        else if (k == 'valor') {
                            if (obj[k].indexOf("[") !== -1) {
                                this.res = this.res + "<td>" + this.jsonTableArr(obj[k]) + "</td></tr>";
                            }
                            else {
                                this.res = this.res + "<td>" + obj[k] + "</td></tr>";
                            }
                        }
                    }
                    else {
                        preData = 2;
                    }
                    preData = preData - 1;
                }
                else if (tipo == 0) {
                    this.res1 = this.res1 + "<tr><td>" + k + "</td>";
                    if (isNaN(obj[k]) && (obj[k]).indexOf("[") !== -1) {
                        this.res1 = this.res1 + "<td>" + this.jsonTableArr(obj[k]) + "</td></tr>";
                    }
                    else {
                        this.res1 = this.res1 + "<td>" + obj[k] + "</td></tr>";
                    }
                }
            }
        }
        if (tipo == 0) {
            return this.res1;
        }
        else if (tipo == 1) {
            return this.res;
        }
    };
    /**
     * @param {?} obj
     * @return {?}
     */
    AutorizacionesDetallesComponent.prototype.jsonTableArr = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        var e_1, _a;
        if ((obj).indexOf("{") !== -1) {
            this.res1 = "";
            /** @type {?} */
            var resultado = this.jsonTable(JSON.parse(obj), 0);
            resultado = "<table class=\"table\">" + resultado + "</table>";
            return resultado;
        }
        else {
            /** @type {?} */
            var contenido = obj.replace("[", "").replace("]", "");
            /** @type {?} */
            var cantidad = contenido.split(",");
            /** @type {?} */
            var resultado = "";
            try {
                for (var cantidad_1 = __values(cantidad), cantidad_1_1 = cantidad_1.next(); !cantidad_1_1.done; cantidad_1_1 = cantidad_1.next()) {
                    var valor = cantidad_1_1.value;
                    resultado = resultado + "<div class=\"d-inline bg-faded\">" + valor + "</div> &nbsp;";
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (cantidad_1_1 && !cantidad_1_1.done && (_a = cantidad_1.return)) _a.call(cantidad_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return resultado;
        }
    };
    AutorizacionesDetallesComponent.decorators = [
        { type: Component, args: [{
                    selector: 'detalle',
                    template: "<section id=\"portal-comercio\">\r\n  <div class=\"container\">\r\n    <div class=\"modulo-cuentas detalle\">\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <a [routerLink]=\"['../solicitudes']\" class=\"btn volver\"><i class=\"str-icon-flecha-izquierda\"></i>Volver</a>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col-2 order-1 order-md-1 col-md-1 icon\">\r\n        </div>\r\n        <div class=\"col-12 order-12 order-md-2 col-md-10 datos\">\r\n          <h3>Detalle Solicitud</h3>\r\n          <div class=\"row\">\r\n            <div class=\"col-6 col-sm-6 col-md-6\">\r\n              <h5>Entidad : </h5><p>{{entidad}}</p>\r\n            </div>\r\n            <div class=\"col-6 col-sm-6 col-md-6\">\r\n              <h5>Descripcion : </h5><p>{{descripcion}}</p>\r\n            </div>\r\n          </div>\r\n          <h5>Datos</h5>\r\n          <br>\r\n          <div class=\"table-container detalle table-responsive-lg\" [innerHtml]=\"html\">\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>"
                }] }
    ];
    /** @nocollapse */
    AutorizacionesDetallesComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: DomSanitizer },
        { type: AutorizacionesService },
        { type: AutorizacionDetalle },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return AutorizacionesDetallesComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RubroByEmpresaRequest = /** @class */ (function () {
    function RubroByEmpresaRequest() {
        this.docEmpresa = '-1';
    }
    return RubroByEmpresaRequest;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InicioSuscripcionPeticion = /** @class */ (function () {
    function InicioSuscripcionPeticion() {
    }
    return InicioSuscripcionPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var httpOptions$h = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};
var InicioSuscripcionService = /** @class */ (function () {
    function InicioSuscripcionService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlInicioSuscripcion = this.environment.urlAmbiente + '/apiSuscripcionComercioMT/suscripcionAdd';
    }
    /**
     * @param {?} _body
     * @return {?}
     */
    InicioSuscripcionService.prototype.postInsertarInicioSuscripcion = /**
     * @param {?} _body
     * @return {?}
     */
    function (_body) {
        return this.http.post(this.urlInicioSuscripcion, _body, httpOptions$h);
    };
    InicioSuscripcionService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    InicioSuscripcionService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return InicioSuscripcionService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InicioSuscripcionComponent = /** @class */ (function () {
    function InicioSuscripcionComponent(empresasService, conveniosAgregarService, conveniosService, domSanitizer, inicioSuscripcionService, dialog, loader, router, route, environment) {
        this.empresasService = empresasService;
        this.conveniosAgregarService = conveniosAgregarService;
        this.conveniosService = conveniosService;
        this.domSanitizer = domSanitizer;
        this.inicioSuscripcionService = inicioSuscripcionService;
        this.dialog = dialog;
        this.loader = loader;
        this.router = router;
        this.route = route;
        this.environment = environment;
        this.lengthMontoPorMoneda = 13;
        this.formGroup = new FormGroup({
            rutSuscriptor: new FormControl('', Validators.compose([CustomValidators.validatorCedulaUY, Validators.required])),
            nombreSuscriptor: new FormControl('', Validators.compose([Validators.required, CustomValidators.nameValidator])),
            apellidoA: new FormControl('', Validators.compose([Validators.required, CustomValidators.nameValidator])),
            apellidoB: new FormControl('', CustomValidators.nameValidator),
            idRubro: new FormControl({ value: '', disabled: true }, Validators.required),
            idEmpresa: new FormControl('', Validators.required),
            diaPago: new FormControl('', Validators.required),
            idServicio: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.required, CustomValidators.idServiceValidator])),
            servicioAlias: new FormControl('', Validators.compose([Validators.required, CustomValidators.descriptionValidator])),
            medioPagoMontoMax: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.maxLength(this.lengthMontoPorMoneda), CustomValidators.amountValidator])),
            montofijo: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.required, Validators.maxLength(this.lengthMontoPorMoneda), CustomValidators.amountValidator])),
            contactoEmail: new FormControl('', Validators.compose([Validators.required, CustomValidators.validaEmail])),
            codmovil: new FormControl('', Validators.compose([CustomValidators.numberValidator, Validators.maxLength(3)])),
            contactoMovil: new FormControl('', Validators.compose([CustomValidators.numberValidator, Validators.minLength(8)])),
            nomPromotor: new FormControl('', Validators.compose([CustomValidators.descriptionValidator, Validators.maxLength(300)]))
        });
        this.resultadoRubros = [];
        this.peticionEmpresa = new EmpresasPeticion();
        this.numberMonedaPipe = new NumberMonedasStr();
        this.peticionListPacParametro = new ConveniosListParametrosPeticion();
        this.conveniosBuscarImagen = new ConveniosBuscarImagen();
        this.inicioSuscripcionPeticion = new InicioSuscripcionPeticion();
        this.tipoCobro = 'V';
        this.tieneImagen = false;
        this.utilizaPromotor = false;
        this.etiquetaPromotor = "";
        this.placeHolderPromotor = "";
    }
    /**
     * @return {?}
     */
    InicioSuscripcionComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.utilizaPromotor = false;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.preLoginsLS = JSON.parse(sessionStorage.getItem('preLogin'));
        this.postSentRubrosByEmpresaServices();
    };
    /**
     * @return {?}
     */
    InicioSuscripcionComponent.prototype.postSentRubrosByEmpresaServices = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = new RubroByEmpresaRequest();
        params.docEmpresa = this.userPerfil.empresa.docEmpresa;
        this.empresasService.postRubrosByEmpresaReport(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.resultadoRubros = data.resultado;
                _this.formGroup.controls['idRubro'].setValue(_this.resultadoRubros[0].codigo);
                _this.listarEmpresaByRubro(_this.resultadoRubros[0].codigo);
            }
            else {
                console.error('Error en postSentRubrosServices', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error en postSentRubrosServices', err);
        }));
    };
    /**
     * @param {?} codigo
     * @return {?}
     */
    InicioSuscripcionComponent.prototype.listarEmpresaByRubro = /**
     * @param {?} codigo
     * @return {?}
     */
    function (codigo) {
        this.peticionEmpresa.codRubro = codigo;
        this.peticionEmpresa.codCliente = this.environment.codCliente;
        this.peticionEmpresa.codEstadoEmpresa = 'ACTIVO';
        this.peticionEmpresa.codEstadoConvenio = 'HBL';
        this.postSentEmpresaServices(this.peticionEmpresa);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    InicioSuscripcionComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.empresasService.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0' && data.resultado.length > 0) {
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.error('Error postListarEmpresas: ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error postListarEmpresas: ', err);
        }));
    };
    /**
     * @param {?} param1
     * @param {?} param2
     * @return {?}
     */
    InicioSuscripcionComponent.prototype.valorSelectEmpresa = /**
     * @param {?} param1
     * @param {?} param2
     * @return {?}
     */
    function (param1, param2) {
        return param2 == "" ? param1 : param1 + ": " + param2;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    InicioSuscripcionComponent.prototype.onEmpresaSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.utilizaPromotor = false;
        this.formGroup.controls['diaPago'].disable();
        /** @type {?} */
        var arSelect = event.value.split(",");
        this.peticionListPacParametro.idFacturador = arSelect[0];
        this.peticionListPacParametro.idConvenio = arSelect[2];
        this.postPacParametroListarServices(this.peticionListPacParametro);
        this.monedaPago = arSelect[3];
        this.buscarImagenes(arSelect[0], arSelect[2]);
        this.formGroup.get('medioPagoMontoMax').setValue('');
        this.formGroup.get('montofijo').setValue('');
        this.lengthMontoPorMoneda = this.monedaPago == "USD" ? 13 : 10;
        this.formGroup.controls['idServicio'].enable();
    };
    /**
     * @param {?} body
     * @return {?}
     */
    InicioSuscripcionComponent.prototype.postPacParametroListarServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.conveniosAgregarService.postPacParametroListar(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                for (var index = 0; index < data.resultado.length; index++) {
                    if (data.resultado[index]['codigoParametro'] == 'DIAS_CARGO') {
                        if (data.resultado[index]['valorParametro'] != '') {
                            _this.resultadoListPacParametro = [];
                            /** @type {?} */
                            var valorParametroString = data.resultado[index]['valorParametro'];
                            /** @type {?} */
                            var valorParametroLista = valorParametroString.split(",");
                            for (var index_1 = 0; index_1 < valorParametroLista.length; index_1++) {
                                _this.resultadoListPacParametro.push(valorParametroLista[index_1]);
                            }
                        }
                    }
                    if (data.resultado[index]['codigoParametro'] == 'TIPO_COBRO') {
                        if (data.resultado[index]['valorParametro'] == 'F') {
                            _this.tipoCobro = 'F';
                            _this.formGroup.controls['diaPago'].enable();
                            _this.formGroup.get('montofijo').enable();
                            _this.formGroup.get('medioPagoMontoMax').disable();
                            _this.formGroup.get('montofijo').setValidators(Validators.compose([Validators.required, Validators.maxLength(_this.lengthMontoPorMoneda), CustomValidators.amountValidator]));
                        }
                        else {
                            _this.tipoCobro = 'V';
                            _this.formGroup.get('medioPagoMontoMax').enable();
                            _this.formGroup.get('montofijo').disable();
                            _this.formGroup.get('medioPagoMontoMax').setValidators(Validators.compose([Validators.maxLength(_this.lengthMontoPorMoneda), CustomValidators.amountValidator]));
                        }
                    }
                    if (data.resultado[index]['codigoParametro'] == 'ETIQUETA_PROMOTOR') {
                        _this.utilizaPromotor = data.resultado[index]['valorParametro'] != "";
                        _this.etiquetaPromotor = data.resultado[index]['valorParametro'];
                        _this.placeHolderPromotor = "Nombre de " + _this.etiquetaPromotor;
                    }
                }
            }
            else {
                console.log('Ocurri&oacute; un error al listar los par&aacute;metros del convenio para la empresa selecionada. ', data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.log('Ocurri&oacute; un error al listar los par&aacute;metros del convenio para la empresa selecionada. ', err);
        }));
    };
    /**
     * @param {?} idFact
     * @param {?} idConvenio
     * @return {?}
     */
    InicioSuscripcionComponent.prototype.buscarImagenes = /**
     * @param {?} idFact
     * @param {?} idConvenio
     * @return {?}
     */
    function (idFact, idConvenio) {
        var _this = this;
        /** @type {?} */
        var docFacturador = this.resultadoEmpresa.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.idFacturador == Number.parseInt(idFact); })).docFacturador;
        this.conveniosBuscarImagen.imgTpo = "boleta";
        this.conveniosBuscarImagen.cnv = idConvenio;
        this.conveniosBuscarImagen.emp = docFacturador;
        this.conveniosBuscarImagen.clt = this.environment.codCliente;
        this.conveniosService.postConveniosBuscarImagen(this.conveniosBuscarImagen).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.tieneImagen = true;
                _this.imagenBoleta = data.img64;
                _this.formatoImagenBoleta = data.imgFormat;
                _this.base64Image = _this.domSanitizer.bypassSecurityTrustResourceUrl('data:' + _this.formatoImagenBoleta + ';base64,' + _this.imagenBoleta);
            }
            else {
                _this.tieneImagen = false;
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.log("error");
            console.log(err);
        }));
    };
    /**
     * @return {?}
     */
    InicioSuscripcionComponent.prototype.onMontoFijoSelect = /**
     * @return {?}
     */
    function () {
        this.formGroup.get('montofijo').updateValueAndValidity();
        /** @type {?} */
        var montofijo = this.formGroup.get('montofijo').value;
        montofijo = (montofijo != null && montofijo != '' && montofijo != undefined ? CustomValidators.validaMonto(montofijo) : '0');
        if (montofijo == '0') {
            this.formGroup.get('montofijo').setErrors({ 'amountError': true });
        }
    };
    /**
     * @return {?}
     */
    InicioSuscripcionComponent.prototype.onMovilSelect = /**
     * @return {?}
     */
    function () {
        this.formGroup.get('codmovil').updateValueAndValidity();
        this.formGroup.get('contactoMovil').updateValueAndValidity();
        /** @type {?} */
        var codmovil = this.formGroup.get('codmovil').value;
        /** @type {?} */
        var fonomovil = this.formGroup.get('contactoMovil').value;
        if (codmovil.length > 0 && fonomovil.length == 0) {
            this.formGroup.get('contactoMovil').markAsTouched();
            this.formGroup.get('contactoMovil').setErrors({ 'required': true });
        }
        else {
            if (codmovil.length == 0 && fonomovil.length > 0) {
                this.formGroup.get('codmovil').markAsTouched();
                this.formGroup.get('codmovil').setErrors({ 'required': true });
            }
        }
    };
    /**
     * @return {?}
     */
    InicioSuscripcionComponent.prototype.validarFormulario = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.agregarInicioSuscripcion();
        }
    };
    /**
     * @return {?}
     */
    InicioSuscripcionComponent.prototype.agregarInicioSuscripcion = /**
     * @return {?}
     */
    function () {
        this.inicioSuscripcionPeticion.idRecaudador = '1';
        this.inicioSuscripcionPeticion.idFacturador = this.formGroup.get('idEmpresa').value.split(',')[0];
        this.inicioSuscripcionPeticion.idConvenio = this.formGroup.get('idEmpresa').value.split(',')[2];
        this.inicioSuscripcionPeticion.documentoMandante = this.formGroup.get('rutSuscriptor').value;
        this.inicioSuscripcionPeticion.nomMandante = this.formGroup.get('nombreSuscriptor').value;
        this.inicioSuscripcionPeticion.priApellido = this.formGroup.get('apellidoA').value;
        this.inicioSuscripcionPeticion.segApellido = this.formGroup.get('apellidoB').value;
        this.inicioSuscripcionPeticion.idServicio = this.formGroup.get('idServicio').value;
        this.inicioSuscripcionPeticion.aliasMandato = this.formGroup.get('servicioAlias').value;
        if (this.tipoCobro == 'V') {
            /** @type {?} */
            var medioPagoMontoMax = this.formGroup.get('medioPagoMontoMax').value;
            medioPagoMontoMax = (medioPagoMontoMax != null && medioPagoMontoMax != '' && medioPagoMontoMax != undefined ? CustomValidators.validaMonto(medioPagoMontoMax) : '0');
            this.inicioSuscripcionPeticion.montoLimite = (this.monedaPago == 'UYU' ? (parseInt(medioPagoMontoMax) * 100).toString() : medioPagoMontoMax);
            this.formGroup.get('montofijo').disable();
            this.inicioSuscripcionPeticion.montoFijo = '0';
            this.inicioSuscripcionPeticion.diaPago = '0';
        }
        else {
            /** @type {?} */
            var montofijo = this.formGroup.get('montofijo').value;
            montofijo = (montofijo != null && montofijo != '' && montofijo != undefined ? CustomValidators.validaMonto(montofijo) : '0');
            this.inicioSuscripcionPeticion.montoFijo = (this.monedaPago == 'UYU' ? (parseInt(montofijo) * 100).toString() : montofijo);
            this.formGroup.get('medioPagoMontoMax').disable();
            this.inicioSuscripcionPeticion.montoLimite = '0';
            this.inicioSuscripcionPeticion.diaPago = this.formGroup.get('diaPago').value;
        }
        this.inicioSuscripcionPeticion.contactoEmail = this.formGroup.get('contactoEmail').value;
        /** @type {?} */
        var codmovil = this.formGroup.get('codmovil').value;
        /** @type {?} */
        var fonomovil = this.formGroup.get('contactoMovil').value;
        this.numeroMovilCompleto = codmovil + fonomovil;
        this.inicioSuscripcionPeticion.contactoMovil = this.numeroMovilCompleto;
        this.inicioSuscripcionPeticion.nomPromotor = this.formGroup.get('nomPromotor').value;
        this.inicioSuscripcionPeticion.codCliente = this.environment.codCliente;
        this.inicioSuscripcionPeticion.docEmpresa = this.userPerfil.empresa.docEmpresa;
        this.inicioSuscripcionPeticion.codTpoPortal = this.preLoginsLS.codTpoPortal;
        this.showDialogPre('Información', 'Si realiza esta acción, agregará un inicio de suscripción.<br>¿Está seguro?', true);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    InicioSuscripcionComponent.prototype.postAgregarInicioSuscripcionServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.loader.show();
        this.inicioSuscripcionService.postInsertarInicioSuscripcion(body).subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            if (result.codret == '0') {
                _this.loader.hide();
                _this.showDialog('Información', 'Inicio de suscripción agregado de forma satisfactoria.<br>El Token de suscripción generado es: <br>' + '<strong>' + result.tokenSuscripcion + '</strong>', false);
            }
            else {
                if (result.codret == '1') {
                    _this.loader.hide();
                    _this.showDialog('Información', 'Ya existe una suscripción vigente.', false);
                }
                else {
                    _this.loader.hide();
                    _this.showDialogFail('Error', 'No ha sido posible agregar el inicio de suscripción.', false);
                }
            }
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.loader.hide();
            _this.showDialogFail('Error', 'Servicio temporalmente no disponible.', false);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    InicioSuscripcionComponent.prototype.showDialogPre = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            if (result) {
                _this.postAgregarInicioSuscripcionServices(_this.inicioSuscripcionPeticion);
            }
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    InicioSuscripcionComponent.prototype.showDialog = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            _this.reiniciarComponente();
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    InicioSuscripcionComponent.prototype.showDialogFail = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
        }));
    };
    /**
     * @return {?}
     */
    InicioSuscripcionComponent.prototype.cancelar = /**
     * @return {?}
     */
    function () {
        this.reiniciarComponente();
    };
    /**
     * @return {?}
     */
    InicioSuscripcionComponent.prototype.reiniciarComponente = /**
     * @return {?}
     */
    function () {
        this.router.routeReuseStrategy.shouldReuseRoute = (/**
         * @return {?}
         */
        function () { return false; });
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['.'], { relativeTo: this.route });
    };
    InicioSuscripcionComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-inicio-suscripcion',
                    template: "<section id=\"portal-comercio\">\n  <div class=\"container\">\n    <div class=\"portal-main\">\n      <form [formGroup]=\"formGroup\" autocomplete=\"off\">\n        <h3>Inicio de suscripci&oacute;n</h3>\n        <div class=\"form-section\">\n          <h5>Suscriptor</h5>\n          <div class=\"form-row\">\n            <div class=\"col-sm-6\">\n              <mat-form-field>\n                <input matInput soloRut placeholder=\"C&eacute;dula\" maxlength=\"8\" autocomplete=\"off\" formControlName=\"rutSuscriptor\" formatRut>\n                <mat-error *ngIf=\"formGroup.get('rutSuscriptor').hasError('required')\">Este campo es requerido.</mat-error>\n                <mat-error *ngIf=\"formGroup.get('rutSuscriptor').hasError('cedulaError')\">C&eacute;dula incorrecta.</mat-error>\n              </mat-form-field>\n            </div>\n            <div class=\"col-sm-6\">\n              <mat-form-field>\n                <input matInput placeholder=\"Nombre\" maxlength=\"50\" autocomplete=\"off\" formControlName=\"nombreSuscriptor\" >\n                <mat-error *ngIf=\"formGroup.get('nombreSuscriptor').hasError('nameError')\">Ingrese un nombre v&aacute;lido.</mat-error>\n                <mat-error *ngIf=\"formGroup.get('nombreSuscriptor').hasError('required')\">Este campo es requerido.</mat-error>\n            </mat-form-field>\n            </div>\n          </div>\n          <div class=\"form-row\">\n            <div class=\"col-sm-6\">\n              <mat-form-field>\n                <input matInput placeholder=\"Primer apellido\" maxlength=\"50\" autocomplete=\"off\" formControlName=\"apellidoA\" >\n                <mat-error *ngIf=\"formGroup.get('apellidoA').hasError('nameError')\">Ingrese un apellido v&aacute;lido.</mat-error>\n                <mat-error *ngIf=\"formGroup.get('apellidoA').hasError('required')\">Este campo es requerido.</mat-error>\n              </mat-form-field>\n            </div>\n            <div class=\"col-sm-6\">\n              <mat-form-field>\n                <input matInput placeholder=\"Segundo apellido\" maxlength=\"50\" autocomplete=\"off\" formControlName=\"apellidoB\" >\n                <mat-error *ngIf=\"formGroup.get('apellidoB').hasError('nameError')\">Ingrese un apellido v&aacute;lido.</mat-error>\n              </mat-form-field>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-section\">\n          <h5>Informaci&oacute;n del Servicio</h5>\n          <div class=\"form-row\">\n            <div class=\"col-sm-4 col-md-3\">\n              <mat-form-field>\n                <mat-select matNativeControl placeholder=\"Servicio\" autocomplete=\"off\" formControlName=\"idRubro\">\n                  <mat-option *ngFor=\"let rubro of resultadoRubros\" [value]=\"rubro.codigo\">{{rubro.descripcion}}</mat-option>\n                </mat-select>\n                <mat-error>Este campo es requerido.</mat-error>\n              </mat-form-field>\n            </div>\n            <div class=\"col-sm-4 col-md-3\">\n              <mat-form-field>\n                <mat-select matNativeControl placeholder=\"Convenio\" autocomplete=\"off\" formControlName=\"idEmpresa\" (selectionChange)=\"onEmpresaSelect($event)\">\n                  <mat-option class=\"multiline-mat-option\" *ngFor=\"let empresa of resultadoEmpresa\" [value]=\"empresa.idFacturador + ',' + empresa.codFacturador + ',' + empresa.idConvenio + ','+ empresa.tipoMoneda\">{{valorSelectEmpresa(empresa.nomFacturador, empresa.descConvenio)}}</mat-option>\n                </mat-select>\n                <mat-error>Este campo es requerido.</mat-error>\n              </mat-form-field>\n            </div>\n            <div class=\"col-sm-2\" *ngIf=\"tipoCobro == 'F'\">\n              <mat-form-field>\n                <mat-select matNativeControl placeholder=\"D&iacute;a de Pago\" formControlName=\"diaPago\">\n                  <section>\n                    <mat-option *ngFor=\"let dia of resultadoListPacParametro\" [value]=\"dia\">{{dia}}</mat-option>\n                  </section>\n                </mat-select>\n                <mat-error>Este campo es requerido.</mat-error>\n              </mat-form-field>\n            </div>\n            <div class=\"col-sm-3 col-md-3 col-xs-11\">\n              <mat-form-field>\n                <input matInput placeholder=\"Id Servicio\" maxlength=\"20\" autocomplete=\"off\" formControlName=\"idServicio\">\n                <mat-error *ngIf=\"formGroup.get('idServicio').hasError('idServiceError')\">Ingrese un identificador v&aacute;lido.</mat-error>\n                <mat-error *ngIf=\"formGroup.get('idServicio').hasError('required')\">Este campo es requerido.</mat-error>\n              </mat-form-field>\n            </div>\n            <div class=\"col-sm-1 d-flex align-items-center tooltip-container\" *ngIf=\"tieneImagen\">\n              <ng-template #popContent><img width='100%' [src]=\"base64Image\"></ng-template>\n              <a tabindex=\"0\" class=\"\" container=\"body\" role=\"button\" data-toggle=\"popover\" data-html=\"true\" triggers=\"click\" placement=\"right\" [ngbPopover]=\"popContent\"><i class=\"icono-ayuda str-icon-info\"></i></a>\n            </div>\n            <div class=\"col-sm-1 d-flex align-items-center tooltip-container\" *ngIf=\"tieneImagen == false\">\n              <i class=\"icono-ayuda str-icon-info\" style=\"background-color: grey;\"></i>\n            </div>\n          </div>\n          <div class=\"form-row\">\n            <div class=\"col-sm-6\">\n              <mat-form-field hintLabel=\"Recomendamos un nombre f&aacute;cil de recordar. Ej: Internet Departamento\">\n                <input matInput placeholder=\"Descripci&oacute;n\" maxlength=\"50\" autocomplete=\"off\" formControlName=\"servicioAlias\" >\n                <mat-error *ngIf=\"formGroup.get('servicioAlias').hasError('descriptionError')\">Ingrese una descripci&oacute;n v&aacute;lida.</mat-error>\n                <mat-error *ngIf=\"formGroup.get('servicioAlias').hasError('required')\">Este campo es requerido.</mat-error>\n              </mat-form-field>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-section\">\n          <h5>Informaci&oacute;n de Pago</h5>\n          <div class=\"form-row\">\n            <div class=\"col-sm-4\" *ngIf=\"tipoCobro == 'V'\">\n              <mat-form-field>\n                <span matPrefix>{{monedaPago}} $&nbsp;</span>\n                <input matInput digitOnly placeholder=\"Monto m&aacute;ximo a pagar\" autocomplete=\"off\" formControlName=\"medioPagoMontoMax\" [maxlength]=\"lengthMontoPorMoneda\" [value]=\"numberMonedaPipe.transform(formGroup.get('medioPagoMontoMax').value, monedaPago)\">\n                <mat-error *ngIf=\"formGroup.get('medioPagoMontoMax').hasError('amountError')\">Ingrese un monto v&aacute;lido.</mat-error>\n              </mat-form-field>\n            </div>\n            <div class=\"col-sm-4\" *ngIf=\"tipoCobro == 'F'\">\n              <mat-form-field>\n                <span matPrefix>{{monedaPago}} $&nbsp;</span>\n                <input matInput digitOnly placeholder=\"Monto fijo a pagar\" autocomplete=\"cc-number\" formControlName=\"montofijo\" [maxlength]=\"lengthMontoPorMoneda\" [value]=\"numberMonedaPipe.transform(formGroup.get('montofijo').value, monedaPago)\" (change)=\"onMontoFijoSelect()\">\n                <mat-error *ngIf=\"formGroup.get('montofijo').hasError('amountError')\">Ingrese un monto v&aacute;lido.</mat-error>\n                <mat-error *ngIf=\"formGroup.get('montofijo').hasError('required')\">Este campo es requerido.</mat-error>\n              </mat-form-field>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-section\">\n          <h5>Informaci&oacute;n de Contacto</h5>\n          <div class=\"form-row\">\n            <div class=\"form-group col-sm-6\">\n              <mat-form-field>\n                <input matInput placeholder=\"Correo electr&oacute;nico\" maxlength=\"100\" autocomplete=\"off\" formControlName=\"contactoEmail\">\n                <mat-error *ngIf=\"formGroup.get('contactoEmail').hasError('email')\">Ingrese un correo v&aacute;lido.</mat-error>\n                <mat-error *ngIf=\"formGroup.get('contactoEmail').hasError('required')\">Este campo es requerido.</mat-error>\n              </mat-form-field>\n            </div>\n          </div>\n          <div class=\"form-row\">\n            <div class=\"col-sm-6 col-md-2\">\n              <mat-form-field>\n                <span matPrefix>+</span>\n                <input matInput digitOnly size=\"4\" placeholder=\"C&oacute;digo Pa&iacute;s\" autocomplete=\"off\" formControlName=\"codmovil\" maxlength=\"3\" (change)=\"onMovilSelect()\">\n                  <mat-error *ngIf=\"formGroup.get('codmovil').hasError('required')\">Este campo es requerido.</mat-error>\n                  <mat-error *ngIf=\"formGroup.get('codmovil').hasError('numberError')\">Ingrese un valor v&aacute;lido.</mat-error>\n                </mat-form-field>\n            </div>\n            <div class=\"col-sm-6 col-md-4\">\n              <mat-form-field>\n                <input matInput digitOnly placeholder=\"Tel&eacute;fono m&oacute;vil\" autocomplete=\"off\" formControlName=\"contactoMovil\" maxlength=\"8\" (change)=\"onMovilSelect()\">\n                <mat-error *ngIf=\"formGroup.get('contactoMovil').hasError('minlength')\">Este campo requiere 8 d&iacute;gitos.</mat-error>\n                <mat-error *ngIf=\"formGroup.get('contactoMovil').hasError('numberError')\">Ingrese un valor v&aacute;lido.</mat-error>\n                <mat-error *ngIf=\"formGroup.get('contactoMovil').hasError('required')\">Este campo es requerido.</mat-error>\n              </mat-form-field>\n            </div>\n          </div>\n        </div>\n        <div *ngIf=\"utilizaPromotor\" class=\"form-section\">\n          <h5>Informaci&oacute;n de {{etiquetaPromotor}}</h5>\n          <div class=\"form-row\">\n            <div class=\"form-group col-sm-6\">\n              <mat-form-field>\n                <mat-label>{{etiquetaPromotor}}</mat-label>\n                <input matInput [placeholder]=\"placeHolderPromotor\" maxlength=\"300\" autocomplete=\"off\" formControlName=\"nomPromotor\">\n                <mat-error *ngIf=\"formGroup.get('nomPromotor').hasError('descriptionError')\">Ingrese un nombre de {{etiquetaPromotor}} v&aacute;lido.</mat-error>\n              </mat-form-field>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col align-right\">\n            <button type=\"button\" class=\"btn text\" (click)=\"cancelar()\">Cancelar</button>\n            <button class=\"btn main\" type=\"submit\" (click)=\"validarFormulario()\">Finalizar<i class=\"str-icon-flecha-derecha\"></i></button>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n</section>\n",
                    providers: [InicioSuscripcionService, ConveniosAgregarService, ConveniosService],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    InicioSuscripcionComponent.ctorParameters = function () { return [
        { type: EmpresasService },
        { type: ConveniosAgregarService },
        { type: ConveniosService },
        { type: DomSanitizer },
        { type: InicioSuscripcionService },
        { type: MatDialog },
        { type: LoaderBaseService },
        { type: Router },
        { type: ActivatedRoute },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return InicioSuscripcionComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TokenSuscripcionExtenderPeticion = /** @class */ (function () {
    function TokenSuscripcionExtenderPeticion() {
        this.idTokenSuscripcion = -1;
        this.idFacturador = -1;
        this.idConvenio = -1;
        this.idServicio = '-1';
    }
    return TokenSuscripcionExtenderPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TokenSuscripcionListPeticion = /** @class */ (function () {
    function TokenSuscripcionListPeticion() {
        this.idFacturador = -1;
        this.idConvenio = -1;
        this.tokenSuscripcion = '-1';
        this.estado = '-1'; //VIG o EXP
        //VIG o EXP
        this.idServicio = '-1';
        this.usoToken = -1; //0=NO FINALIZADO, 1=FINALIZADO
        //0=NO FINALIZADO, 1=FINALIZADO
        this.fechaInicioVigencia = '01/01/2000';
        this.fechaFinVigencia = '01/01/2000';
        this.filtros = [];
    }
    return TokenSuscripcionListPeticion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var httpOptions$i = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Origin': '*'
    })
};
var TokenSuscripcionService = /** @class */ (function () {
    function TokenSuscripcionService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.urlSuscripcionList = this.environment.urlAmbiente + '/apiSuscripcionComercioMT/suscripcionList';
        this.urlExtenderVigenciaToken = this.environment.urlAmbiente + '/apiSuscripcionComercioMT/extenderVigenciaToken';
    }
    /**
     * @param {?} params
     * @return {?}
     */
    TokenSuscripcionService.prototype.postSuscripcionList = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlSuscripcionList, params, httpOptions$i);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    TokenSuscripcionService.prototype.postExtenderVigenciaToken = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return this.http.post(this.urlExtenderVigenciaToken, params, httpOptions$i);
    };
    TokenSuscripcionService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TokenSuscripcionService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    return TokenSuscripcionService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$l = MAT_MOMENT_DATE_FORMATS;
var TokenSuscripcionComponent = /** @class */ (function () {
    function TokenSuscripcionComponent(tokenSuscripcionService, loader, dialog, descargaExcelPdfFileService, empresaService, formBuilder, datepipe, environment) {
        this.tokenSuscripcionService = tokenSuscripcionService;
        this.loader = loader;
        this.dialog = dialog;
        this.descargaExcelPdfFileService = descargaExcelPdfFileService;
        this.empresaService = empresaService;
        this.formBuilder = formBuilder;
        this.datepipe = datepipe;
        this.environment = environment;
        //filtroFechaPago
        this.fechaInicioVigencia = '01/01/2000';
        this.fechaFinVigencia = '01/01/2000';
        this.listEstado = [
            { key: '-1', value: 'Todos' },
            { key: 'VIG', value: 'Vigente' },
            { key: 'EXP', value: 'Expirado' }
        ];
        this.listUso = [
            { key: '-1', value: 'Todos' },
            { key: '0', value: 'Token no utilizado' },
            { key: '1', value: 'Token utilizado' }
        ];
        this.size = 0;
        this.vistaEstado = 'Todos';
        this.vistaComercio = 'Todos';
        this.vistaUsoToken = 'Todos';
        this.hashCaminoMiga = [];
        this.comboComercio = false;
        this.isCollapsed = false;
        this.show = false;
        this.consulta = 0;
        this.fecha = new Date();
        this.manhana = this.fecha.setDate(this.fecha.getDate() + 1);
        this.fechaFormat = this.datepipe.transform(this.manhana, 'yyyy-MM-dd');
        this.peticionEmpresa = new EmpresasPeticion();
        this.resultadoEmpresa = [];
        this.tokenSuscripcionListPeticion = new TokenSuscripcionListPeticion();
        this.tokenSuscripcionExtenderPeticion = new TokenSuscripcionExtenderPeticion();
        this.formGroup = new FormGroup({
            idFacturador: new FormControl(),
            tokenSuscripcion: new FormControl((''), Validators.maxLength(20)),
            estado: new FormControl(),
            idServicio: new FormControl((''), Validators.maxLength(30)),
            usoToken: new FormControl(),
            fechaVigencia: new FormControl()
        });
        this.unavailabilityForm = this.formBuilder.group({
            endDate: [this.fechaFormat + 'T00:00:00.000Z']
        });
        this.displayedColumns = [];
        this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));
        this.codTpoPortal = this.preLogin.codTpoPortal;
        this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
        this.idEmpresaPac = this.userPerfil.empresa.idEmpresaPac;
    }
    /**
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.codTpoPortal == 'COMERCIO') {
            this.comboComercio = false;
            this.displayedColumns = ['tokenSuscripcion', 'estado', 'idServicio', 'usoToken', 'fechaInicioVigencia', 'fechaFinVigencia', 'extenderVigencia'];
        }
        else {
            this.comboComercio = true;
            this.displayedColumns = ['empresa', 'tokenSuscripcion', 'estado', 'idServicio', 'usoToken', 'fechaInicioVigencia', 'fechaFinVigencia', 'extenderVigencia'];
        }
        this.formGroup.get('idFacturador').setValue('-1' + ',' + '-1');
        this.formGroup.get('tokenSuscripcion').setValue('');
        this.formGroup.get('estado').setValue('-1');
        this.formGroup.get('idServicio').setValue('');
        this.formGroup.get('usoToken').setValue('-1');
        this.setInitialBreadcrumbs();
        this.postEmpresas();
        console.log('codTpoPortal: ', this.codTpoPortal);
    };
    /**
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.setInitialBreadcrumbs = /**
     * @return {?}
     */
    function () {
        if (this.comboComercio) {
            this.hashCaminoMiga[0] = { title: 'Empresa', text: 'Todas' };
        }
        this.hashCaminoMiga[(this.comboComercio ? 1 : 0)] = { title: 'Token suscripción', text: '' };
        this.hashCaminoMiga[(this.comboComercio ? 2 : 1)] = { title: 'Estado', text: 'Todas' };
        this.hashCaminoMiga[(this.comboComercio ? 3 : 2)] = { title: 'ID Servicio', text: '' };
        this.hashCaminoMiga[(this.comboComercio ? 4 : 3)] = { title: 'Uso', text: 'Todas' };
        this.hashCaminoMiga[(this.comboComercio ? 5 : 4)] = { title: 'Fecha creación', text: 'Todas' };
    };
    /**
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.postEmpresas = /**
     * @return {?}
     */
    function () {
        this.peticionEmpresa.codRubro = '-1';
        this.peticionEmpresa.codCliente = this.environment.codCliente;
        this.peticionEmpresa.codEstadoConvenio = 'HBL';
        this.postSentEmpresaServices(this.peticionEmpresa);
    };
    /**
     * @param {?} body
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.postSentEmpresaServices = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.empresaService.postListarEmpresas(body).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                /** @type {?} */
                var empresaResult = new EmpresaResult();
                empresaResult.idFacturador = -1;
                empresaResult.idConvenio = '-1';
                empresaResult.nomFacturador = 'Todas';
                data.resultado.splice(0, 0, empresaResult);
                _this.resultadoEmpresa = data.resultado;
            }
            else {
                console.log('Error: ', 'postListarEmpresas ' + data.descret);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.error('Error :', 'postListarEmpresas ' + err);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.selectFechaVigencia = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.fechaInicioVigencia = formatDate(event.value.begin, 'dd/MM/yyyy', 'en-US');
        this.fechaFinVigencia = formatDate(event.value.end, 'dd/MM/yyyy', 'en-US');
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.onComercioSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaComercio = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.onEstadoSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaEstado = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.onUsoTokenSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.vistaUsoToken = event.source.selected._element.nativeElement.innerText.trim();
    };
    /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.getEmpresaConvenio = /**
     * @param {?} nomFacturador
     * @param {?} descConvenio
     * @return {?}
     */
    function (nomFacturador, descConvenio) {
        return (descConvenio != '' ? nomFacturador + ': ' + descConvenio : nomFacturador);
    };
    /**
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.limpiar = /**
     * @return {?}
     */
    function () {
        this.tokenSuscripcionListPeticion = new TokenSuscripcionListPeticion();
        this.postEmpresas();
        this.formGroup.controls.tokenSuscripcion.setValue('');
        this.formGroup.controls.idServicio.setValue('');
        this.formGroup.get('idFacturador').setValue('-1' + ',' + '-1');
        this.formGroup.get('estado').setValue('-1');
        this.formGroup.get('usoToken').setValue('-1');
        this.formGroup.get('fechaVigencia').setValue(null);
        this.filtroFechaVigencia = null;
        this.fechaInicioVigencia = '01/01/2000';
        this.fechaFinVigencia = '01/01/2000';
        this.setInitialBreadcrumbs();
        this.size = 0;
        this.consulta = 0;
        this.show = false;
        this.isCollapsed = false;
        this.dataSource = new MatTableDataSource([]);
    };
    /**
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.validarForm = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.onSubmit('');
        }
    };
    /**
     * @param {?} tipo
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.onSubmit = /**
     * @param {?} tipo
     * @return {?}
     */
    function (tipo) {
        this.tokenSuscripcionListPeticion.codCliente = this.environment.codCliente;
        this.tokenSuscripcionListPeticion.codTpoPortal = this.codTpoPortal;
        if (!this.comboComercio) {
            this.tokenSuscripcionListPeticion.idFacturador = this.idEmpresaPac;
            this.tokenSuscripcionListPeticion.idConvenio = -1;
        }
        else {
            /** @type {?} */
            var idFacturador = this.formGroup.get('idFacturador').value.split(',')[0];
            if (idFacturador == null || idFacturador == '' || idFacturador == -1) {
                this.tokenSuscripcionListPeticion.idFacturador = -1;
                this.tokenSuscripcionListPeticion.idConvenio = -1;
                this.hashCaminoMiga[0] = { title: 'Empresa', text: 'Todas' };
            }
            else {
                this.tokenSuscripcionListPeticion.idFacturador = parseInt(this.formGroup.get('idFacturador').value.split(',')[0]);
                this.tokenSuscripcionListPeticion.idConvenio = parseInt(this.formGroup.get('idFacturador').value.split(',')[1]);
                this.hashCaminoMiga[0] = { title: 'Empresa', text: this.vistaComercio };
            }
        }
        if (this.formGroup.get('tokenSuscripcion').value == null || this.formGroup.get('tokenSuscripcion').value.trim() == '') {
            this.tokenSuscripcionListPeticion.tokenSuscripcion = '-1';
            this.hashCaminoMiga[(this.comboComercio ? 1 : 0)] = { title: 'Token suscripción', text: '' };
        }
        else {
            this.tokenSuscripcionListPeticion.tokenSuscripcion = this.formGroup.get('tokenSuscripcion').value.trim();
            this.hashCaminoMiga[(this.comboComercio ? 1 : 0)] = { title: 'Token suscripción', text: this.formGroup.get('tokenSuscripcion').value.trim() };
        }
        if (this.formGroup.get('estado').value == null || this.formGroup.get('estado').value == '-1') {
            this.tokenSuscripcionListPeticion.estado = '-1';
            this.hashCaminoMiga[(this.comboComercio ? 2 : 1)] = { title: 'Estado', text: 'Todos' };
        }
        else {
            this.tokenSuscripcionListPeticion.estado = this.formGroup.get('estado').value;
            this.hashCaminoMiga[(this.comboComercio ? 2 : 1)] = { title: 'Estado', text: this.vistaEstado };
        }
        if (this.formGroup.get('idServicio').value == null || this.formGroup.get('idServicio').value.trim() == '') {
            this.tokenSuscripcionListPeticion.idServicio = '-1';
            this.hashCaminoMiga[(this.comboComercio ? 3 : 2)] = { title: 'ID Servicio', text: '' };
        }
        else {
            this.tokenSuscripcionListPeticion.idServicio = this.formGroup.get('idServicio').value.trim();
            this.hashCaminoMiga[(this.comboComercio ? 3 : 2)] = { title: 'ID Servicio', text: this.formGroup.get('idServicio').value.trim() };
        }
        if (this.formGroup.get('usoToken').value == null || this.formGroup.get('usoToken').value == '-1') {
            this.tokenSuscripcionListPeticion.usoToken = -1;
            this.hashCaminoMiga[(this.comboComercio ? 4 : 3)] = { title: 'Uso', text: 'Todos' };
        }
        else {
            this.tokenSuscripcionListPeticion.usoToken = parseInt(this.formGroup.get('usoToken').value);
            this.hashCaminoMiga[(this.comboComercio ? 4 : 3)] = { title: 'Uso', text: this.vistaUsoToken };
        }
        this.filtroFechaVigencia = this.formGroup.get('fechaVigencia').value;
        if (this.filtroFechaVigencia != null && this.filtroFechaVigencia != '01/01/2000') {
            this.tokenSuscripcionListPeticion.fechaInicioVigencia = formatDate(this.filtroFechaVigencia.begin, 'dd/MM/yyyy', 'en-US');
            this.tokenSuscripcionListPeticion.fechaFinVigencia = formatDate(this.filtroFechaVigencia.end, 'dd/MM/yyyy', 'en-US');
            this.hashCaminoMiga[(this.comboComercio ? 5 : 4)] = { title: 'Fecha creación', text: this.fechaInicioVigencia + ' - ' + this.fechaFinVigencia };
        }
        else {
            this.tokenSuscripcionListPeticion.fechaInicioVigencia = this.fechaInicioVigencia;
            this.tokenSuscripcionListPeticion.fechaFinVigencia = this.fechaFinVigencia;
            this.hashCaminoMiga[(this.comboComercio ? 5 : 4)] = { title: 'Fecha creación', text: 'Todos' };
        }
        if (tipo == 'excel' || tipo == 'pdf') {
            this.tokenSuscripcionListPeticion.filtros = this.hashCaminoMiga;
            this.postDownloadReportFile(this.tokenSuscripcionListPeticion, tipo);
        }
        else {
            if (this.paginator != undefined) {
                this.paginator.pageIndex = 0;
            }
            this.postListSuscripcionServices(this.tokenSuscripcionListPeticion);
        }
    };
    /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.postDownloadReportFile = /**
     * @param {?} filtro
     * @param {?} tipo
     * @return {?}
     */
    function (filtro, tipo) {
        var _this = this;
        /** @type {?} */
        var url = '/apiSuscripcionComercioMT/suscripcionList/' + tipo;
        filtro.codCliente = this.environment.codCliente;
        this.descargaExcelPdfFileService.downloadReportService(filtro, url).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.type == HttpEventType.Response) {
                /** @type {?} */
                var downloadedFile = void 0;
                /** @type {?} */
                var a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                if (tipo == 'excel') {
                    downloadedFile = new Blob([data.body], { type: 'application/vnd.ms-excel' });
                    a.download = 'reporteTokenSuscripcion' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.xls';
                }
                else {
                    downloadedFile = new Blob([data.body], { type: 'application/pdf' });
                    a.download = 'reporteTokenSuscripcion' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
                }
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.showDialogError('Error', 'Ha ocurrido un error al descargar el archivo.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @param {?} params
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.postListSuscripcionServices = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        var _this = this;
        this.loader.show();
        this.show = true;
        this.consulta = 1;
        this.size = 0;
        this.dataSource = new MatTableDataSource();
        this.tokenSuscripcionService.postSuscripcionList(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                if (data.resultado.length > 0) {
                    _this.dataSource = new MatTableDataSource(data.resultado);
                    _this.dataSource.paginator = _this.paginator;
                    _this.size = data.resultado.length;
                    _this.isCollapsed = true;
                    _this.show = true;
                }
                else {
                    _this.isCollapsed = false;
                    _this.show = false;
                }
                _this.loader.hide();
            }
            else {
                _this.show = false;
                _this.loader.hide();
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.show = false;
            _this.loader.hide();
        }));
    };
    /**
     * @param {?} tokenSuscripcion
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.extenderVigenciaToken = /**
     * @param {?} tokenSuscripcion
     * @return {?}
     */
    function (tokenSuscripcion) {
        this.tokenSuscripcionExtenderPeticion.codCliente = this.environment.codCliente;
        this.tokenSuscripcionExtenderPeticion.codTpoPortal = this.codTpoPortal;
        this.tokenSuscripcionExtenderPeticion.idTokenSuscripcion = tokenSuscripcion.idTokenSuscripcion;
        this.tokenSuscripcionExtenderPeticion.idFacturador = tokenSuscripcion.idFacturador;
        this.tokenSuscripcionExtenderPeticion.idConvenio = tokenSuscripcion.idConvenio;
        this.tokenSuscripcionExtenderPeticion.idServicio = tokenSuscripcion.idServicio;
        this.tokenSuscripcionExtenderPeticion.docEmpresa = tokenSuscripcion.docEmpresa;
        this.showDialogPreExtender('Información', 'Si realiza esta acción, extenderá la vigencia del token de inicio de suscripción.<br>¿Está seguro?', true);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.postExtenderVigenciaTokenServices = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        var _this = this;
        this.loader.show();
        this.tokenSuscripcionService.postExtenderVigenciaToken(params).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.codret == '0') {
                _this.loader.hide();
                _this.showDialogPosExtender('Información', 'Vigencia del token de inicio de suscripción extendido de forma satisfactoria.', false);
            }
            else {
                _this.loader.hide();
                _this.showDialogPosExtender('Error', 'No ha sido posible extender la vigencia del token de suscripción.', false);
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.loader.hide();
            _this.showDialogError('Error', 'Ha ocurrido un error al extender la vigencia del token de suscripción.<br>Inténtelo nuevamente.', false);
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.showDialogError = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.showDialogPreExtender = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            if (result) {
                _this.postExtenderVigenciaTokenServices(_this.tokenSuscripcionExtenderPeticion);
            }
        }));
    };
    /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    TokenSuscripcionComponent.prototype.showDialogPosExtender = /**
     * @param {?} pTitle
     * @param {?} pContent
     * @param {?} pShowBtnCancel
     * @return {?}
     */
    function (pTitle, pContent, pShowBtnCancel) {
        var _this = this;
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogBaseComponent, {
            data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            if (result) {
                _this.postListSuscripcionServices(_this.tokenSuscripcionListPeticion);
            }
        }));
    };
    TokenSuscripcionComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-token-suscripcion',
                    template: "<section id=\"portal-comercio\">\n  <div class=\"container\">\n    <div class=\"modulo-filtros\">\n      <a class=\"link-container\" [attr.aria-expanded]=\"!isCollapsed\" aria-controls=\"moduloFiltros\" (click)=\"isCollapsed = !isCollapsed\">\n        <div class=\"row\">\n          <div class=\"col\">\n            <i class=\"str-icon-filtros mr-2\"></i>\n            <strong>Filtros</strong>\n          </div>\n          <div class=\"col text-right\">\n            <i class=\"mdl-icon-toggle__label material-icons\">keyboard_arrow_down</i>\n          </div>\n        </div>\n      </a>\n      <div class=\"col\">\n        <div id=\"moduloFiltros\" [ngbCollapse]=\"isCollapsed\">\n          <div class=\"box-filtros card card-body\">\n            <form [formGroup]=\"formGroup\" autocomplete=\"off\">\n              <div class=\"form-row align-left\">\n                <div class=\"col-md-6\">\n                  <div class=\"filtro-fecha\">\n                    <button type=\"button\" class=\"btn fecha\" (click)=\"picker1.open()\"><i class=\"str-icon-calendario\"></i> Buscar por fecha de creaci&oacute;n\n                      <ng-container *ngIf=\"this.formGroup.get('fechaVigencia').value != null && this.fechaInicioVigencia != '01/01/2000' && fechaFinVigencia != '01/01/2000'\">\n                        <span>{{ this.fechaInicioVigencia + ' - ' + this.fechaFinVigencia }}</span>\n                      </ng-container>\n                    </button>\n                    <mat-form-field style=\"display: none;\">\n                      <input matInput placeholder=\"Fecha\" [max]=\"unavailabilityForm.controls.endDate.value\" [satDatepicker]=\"picker1\" formControlName=\"fechaVigencia\" (dateInput)=\"selectFechaVigencia($event)\">\n                      <sat-datepicker-toggle matSuffix [for]=\"picker1\"></sat-datepicker-toggle>\n                      <sat-datepicker touchUi #picker1 [rangeMode]=\"true\" [selectFirstDateOnClose]=\"true\"></sat-datepicker>\n                    </mat-form-field>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"form-row\">\n                <div class=\"form-group col-sm-4\" *ngIf=\"comboComercio\">\n                  <mat-form-field>\n                    <mat-select matNativeControl placeholder=\"Empresa\" formControlName=\"idFacturador\" (selectionChange)=\"onComercioSelect($event)\">\n                      <mat-option class=\"multiline-mat-option\" *ngFor=\"let empresa of resultadoEmpresa\" [value]=\"empresa.idFacturador +','+ empresa.idConvenio\">{{getEmpresaConvenio(empresa.nomFacturador, empresa.descConvenio)}}</mat-option>\n                    </mat-select>\n                  </mat-form-field>\n                </div>\n                <div class=\"form-group col-md-3\">\n                  <mat-form-field>\n                    <input matInput maxlength=\"20\" placeholder=\"Token suscripci&oacute;n\" formControlName=\"tokenSuscripcion\">\n                  </mat-form-field>\n                </div>\n                <div class=\"form-group col-sm-4\">\n                  <mat-form-field>\n                    <mat-select matNativeControl placeholder=\"Estado\" formControlName=\"estado\" (selectionChange)=\"onEstadoSelect($event)\">\n                      <mat-option class=\"multiline-mat-option\" *ngFor=\"let estado of listEstado\" [value]=\"estado.key\">{{estado.value}}</mat-option>\n                    </mat-select>\n                  </mat-form-field>\n                </div>\n              </div>\n              <div class=\"form-row\">\n                <div class=\"form-group col-md-3\">\n                  <mat-form-field>\n                    <input matInput maxlength=\"30\" placeholder=\"ID Servicio\" formControlName=\"idServicio\">\n                  </mat-form-field>\n                </div>\n                <div class=\"form-group col-sm-4\">\n                  <mat-form-field>\n                    <mat-select matNativeControl placeholder=\"Uso\" formControlName=\"usoToken\" (selectionChange)=\"onUsoTokenSelect($event)\">\n                      <mat-option class=\"multiline-mat-option\" *ngFor=\"let uso of listUso\" [value]=\"uso.key\">{{uso.value}}</mat-option>\n                    </mat-select>\n                  </mat-form-field>\n                </div>\n              </div>\n              <div class=\"actions\">\n                <button type=\"button\" class=\"btn text\" (click)=\"limpiar()\">Limpiar</button>\n                <button type=\"submit\" class=\"btn main\" (click)=\"validarForm()\">Filtrar</button>\n              </div>\n            </form>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"resultados-filtros\">\n      <div class=\"row\">\n        <div class=\"col-md-10\">\n          <div class=\"tags row\">\n            <div *ngFor=\"let entry of hashCaminoMiga\" class=\"item\">{{entry.title}}: {{entry.text}}</div>\n          </div>\n        </div>\n        <div class=\"col-md-2\">\n          <div class=\"numero-resultados\">\n            <strong>{{ (size == 1) ? ( size + \" Resultado\") : size + \" Resultados\" }}</strong>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <section *ngIf=\"show\">\n      <div class=\"table-container table-responsive-md\">\n        <table class=\"table\" mat-table [dataSource]=\"dataSource\">\n          <ng-container matColumnDef=\"empresa\" *ngIf=\"comboComercio\">\n            <th mat-header-cell *matHeaderCellDef>Empresa</th>\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\"> {{resultado.nomFacturador}}: {{resultado.nomConvenio}}</td>\n          </ng-container>\n          <ng-container matColumnDef=\"tokenSuscripcion\">\n            <th mat-header-cell *matHeaderCellDef>Token suscripci&oacute;n</th>\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\"> {{resultado.tokenSuscripcion}}</td>\n          </ng-container>\n          <ng-container matColumnDef=\"estado\">\n            <th mat-header-cell *matHeaderCellDef>Estado</th>\n            <td mat-cell *matCellDef=\"let resultado\">\n              <span *ngIf=\"resultado.estado == 'VIG'; else elseBlockEstado\">Vigente</span>\n              <ng-template #elseBlockEstado>Expirado</ng-template>\n            </td>\n          </ng-container>\n          <ng-container matColumnDef=\"idServicio\">\n            <th mat-header-cell *matHeaderCellDef>ID Servicio</th>\n            <td class=\"text-breakword\" mat-cell *matCellDef=\"let resultado\"> {{resultado.idServicio}}</td>\n          </ng-container>\n          <ng-container matColumnDef=\"usoToken\">\n            <th mat-header-cell *matHeaderCellDef>Uso</th>\n            <td mat-cell *matCellDef=\"let resultado\">\n              <span *ngIf=\"resultado.usoToken == '0'; else elseBlockUsoToken\">No utilizado</span>\n              <ng-template #elseBlockUsoToken>Utilizado</ng-template>\n            </td>\n          </ng-container>\n          <ng-container matColumnDef=\"fechaInicioVigencia\">\n            <th mat-header-cell *matHeaderCellDef>Fecha de creaci&oacute;n</th>\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.fechaInicioVigencia | date:'dd/MM/yyyy HH:mm:ss'}} </td>\n          </ng-container>\n          <ng-container matColumnDef=\"fechaFinVigencia\">\n            <th mat-header-cell *matHeaderCellDef>Fin de Vigencia</th>\n            <td mat-cell *matCellDef=\"let resultado\"> {{resultado.fechaFinVigencia | date:'dd/MM/yyyy HH:mm:ss'}} </td>\n          </ng-container>\n          <ng-container matColumnDef=\"extenderVigencia\">\n            <th mat-header-cell *matHeaderCellDef>Extender vigencia</th>\n            <td mat-cell *matCellDef=\"let resultado\">\n              <a matTooltipPosition=\"above\" Style=\"cursor: pointer;\" *ngIf=\"(resultado.extender == 'EXT'); else noExtender\" (click)=\"extenderVigenciaToken(resultado)\" matTooltip=\"Extender vigencia de token de suscripci&oacute;n\"><i class=\"icon str-icon-renovar\"></i></a>\n              <ng-template #noExtender> - </ng-template>\n            </td>\n          </ng-container>\n\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted}\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"></tr>\n        </table>\n        <mat-paginator [pageSizeOptions]=\"[10]\" showFirstLastButtons></mat-paginator>\n      </div>\n      <div class=\"box-actions\">\n        <div class=\"row\">\n          <div class=\"col-md-6 item\">\n            <a (click)=\"onSubmit('excel')\" style=\"cursor: pointer;\"><i class=\"str-icon-excel\"></i> Descargar Excel</a>\n          </div>\n          <div class=\"col-md-6 item-right\">\n            <a (click)=\"onSubmit('pdf')\" style=\"cursor: pointer;\"><i class=\"str-icon-pdf\"></i> Descargar PDF</a>\n          </div>\n        </div>\n      </div>\n    </section>\n\n    <div class=\"modulo-cuentas\" *ngIf=\"!show && consulta == 0\">\n      <span>Establezca sus criterios de b&uacute;squeda.</span>\n    </div>\n    <div class=\"modulo-cuentas\" *ngIf=\"!show && consulta == 1 && size == 0\">\n      <span>No se han encontrado registros para su consulta. Establezca sus criterios de b&uacute;squeda e int&eacute;ntelo nuevamente.</span>\n    </div>\n  </div>\n</section>",
                    providers: [TokenSuscripcionService, DescargaExcelPdfFileService, EmpresasService,
                        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
                        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
                        { provide: MAT_DATE_FORMATS, useValue: ɵ0$l }],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    TokenSuscripcionComponent.ctorParameters = function () { return [
        { type: TokenSuscripcionService },
        { type: LoaderBaseService },
        { type: MatDialog },
        { type: DescargaExcelPdfFileService },
        { type: EmpresasService },
        { type: FormBuilder },
        { type: DatePipe },
        { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
    ]; };
    TokenSuscripcionComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator,] }],
        sort: [{ type: ViewChild, args: [MatSort,] }]
    };
    return TokenSuscripcionComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var adquirienteRoutes = [
    {
        path: 'adminProcesos',
        children: [
            { path: 'adminProcesos', component: AdminProcesosComponent },
            { path: 'adminProcesosDetalles', component: AdminProcesosDetallesComponent },
            { path: '', redirectTo: 'adminProcesos', pathMatch: 'full' }
        ]
    },
    {
        path: 'reportePagos',
        children: [
            { path: 'listarPagos', component: ReportePagosComponent },
            { path: 'reversarPagos', component: ReportePagosComponent },
            { path: '', redirectTo: 'listarPagos', pathMatch: 'full' }
        ]
    },
    {
        path: 'cobrosList',
        children: [
            { path: 'cobrosList', component: LstCobrosComponent },
            { path: 'cobrosDetalle', component: ListCobrosDetallesComponent },
            { path: '', redirectTo: 'cobrosList', pathMatch: 'full' }
        ]
    },
    {
        path: 'facturacion', component: FacturacionMenuComponent,
        children: [
            { path: 'carga', component: FacturacionComponent },
            {
                path: 'historial',
                children: [
                    { path: 'historial', component: FacturacionHistorialComponent },
                    { path: 'detalle', component: FacturacionHistorialDetalleComponent },
                    { path: '', redirectTo: 'historial', pathMatch: 'full' }
                ]
            },
            {
                path: 'reutilizar',
                children: [
                    { path: 'reutilizar', component: FacturacionReutilizarComponent },
                    { path: 'reutilizarDetalle', component: FacturacionReutilizarDetalleComponent },
                    { path: '', redirectTo: 'reutilizar', pathMatch: 'full' }
                ]
            },
            { path: '', redirectTo: 'carga', pathMatch: 'full' }
        ]
    },
    {
        path: 'activaMandatos', component: MandatosMenuComponent,
        children: [
            { path: 'carga', component: MandatosComponent },
            {
                path: 'historial',
                children: [
                    { path: 'historial', component: MandatosHistorialComponent },
                    { path: 'detalle', component: MandatosHistorialDetalleComponent },
                    { path: '', redirectTo: 'historial', pathMatch: 'full' }
                ]
            },
            { path: '', redirectTo: 'carga', pathMatch: 'full' }
        ]
    },
    {
        path: 'usuarios',
        children: [
            { path: 'usuariosList', component: LstUsuariosComponent },
            { path: 'usuariosAgregar', component: CrearCuentaDatosComponent },
            { path: 'usuariosEditar', component: EditarCuentaDatosComponent },
            { path: '', redirectTo: 'usuariosList', pathMatch: 'full' }
        ]
    },
    {
        path: 'usuariosEmp',
        children: [
            { path: 'usuariosEmpList', component: LstUsuariosEmpComponent },
            { path: 'usuariosEmpAgregar', component: CrearCuentaDatosComponent },
            { path: 'usuariosEmpEditar', component: EditarCuentaDatosComponent },
            { path: '', redirectTo: 'usuariosEmpList', pathMatch: 'full' }
        ]
    },
    {
        path: 'autorizaciones', component: AutorizacionMenuComponent,
        children: [
            { path: 'solicitudes',
                children: [
                    { path: 'solicitudes', component: AutorizacionesComponent },
                    { path: 'detalle', component: AutorizacionesDetallesComponent },
                    { path: '', redirectTo: 'solicitudes', pathMatch: 'full' }
                ] },
            { path: 'configuracion',
                children: [
                    { path: 'configuracion', component: AutorizacionConfiguracionComponent },
                    { path: 'configuracionAgregar', component: AutorizacionesConfigAgregarComponent },
                    { path: 'configuracionEditar', component: AutorizacionesConfigEditarComponent },
                    { path: '', redirectTo: 'configuracion', pathMatch: 'full' }
                ] },
            { path: 'autorizadores',
                children: [
                    { path: 'autorizadores', component: AutorizacionAutorizadoresComponent },
                    { path: 'autorizadoresAgregar', component: AutorizacionesAutorizadoresAgregarComponent },
                    { path: 'autorizadoresEditar', component: AutorizacionesAutorizadoresEditarComponent },
                    { path: '', redirectTo: 'autorizadores', pathMatch: 'full' }
                ] },
            { path: '', redirectTo: 'solicitudes', pathMatch: 'full' }
        ]
    },
    { path: 'descargasList', component: LstDescargaComponent },
    {
        path: 'convenios',
        children: [
            { path: 'convenios', component: ConveniosComponent },
            { path: 'conveniosAgregar', component: ConveniosAgregarComponent },
            { path: 'conveniosPago', component: ConveniosPagoComponent },
            { path: 'conveniosIntercambio', component: ConveniosIntercambioComponent },
            { path: 'conveniosGrafica', component: ConveniosGraficaComponent },
            { path: 'conveniosEditarAgregar', component: ConveniosEditarAgregarComponent },
            { path: 'conveniosEditarPago', component: ConveniosEditarPagoComponent },
            { path: 'conveniosEditarIntercambio', component: ConveniosEditarIntercambioComponent },
            { path: 'conveniosEditarGrafica', component: ConveniosEditarGraficaComponent },
            { path: '', redirectTo: 'convenios', pathMatch: 'full' }
        ]
    },
    {
        path: 'empresas',
        children: [
            { path: 'empresasList', component: EmpresasListarComponent },
            { path: 'empresasAgregar', component: EmpresasAgregarComponent },
            { path: 'empresasEditar', component: EmpresasEditarComponent },
            { path: '', redirectTo: 'empresasList', pathMatch: 'full' }
        ]
    },
    { path: 'dashboard', component: DashboardComponent },
    { path: 'dashboardAdquirente', component: DashboardAdquirenteComponent },
    {
        path: 'mandatosList',
        children: [
            { path: 'mandatosList', component: LstMandatosComponent },
            { path: 'mandatoDetalle', component: ListMandatosDetallesComponent },
            { path: '', redirectTo: 'mandatosList', pathMatch: 'full' }
        ]
    },
    { path: 'segList', component: SegmandatosComponent },
    {
        path: 'auditoria',
        children: [
            { path: 'auditoria', component: AuditoriaComponent },
            { path: 'detalle', component: AuditoriaDetalleComponent },
            { path: '', redirectTo: 'auditoria', pathMatch: 'full' }
        ]
    },
    {
        path: 'politica',
        children: [
            { path: 'politicaList', component: PoliticaListComponent },
            { path: 'politicaAdd', component: PoliticaAddComponent },
            { path: 'politicaUpd', component: PoliticaUpdComponent },
            { path: '', redirectTo: 'politicaList', pathMatch: 'full' }
        ]
    },
    {
        path: 'perfil',
        children: [
            { path: 'perfilList', component: PerfilesListComponent },
            { path: 'perfilAdd', component: PerfilesAddComponent },
            { path: 'perfilUpd', component: PerfilesUpdComponent },
            { path: '', redirectTo: 'perfilList', pathMatch: 'full' }
        ]
    },
    {
        path: 'perfilEmp',
        children: [
            { path: 'perfilListEmp', component: PerfilesListEmpComponent },
            { path: 'perfilAdd', component: PerfilesAddComponent },
            { path: 'perfilUpd', component: PerfilesUpdComponent },
            { path: '', redirectTo: 'perfilListEmp', pathMatch: 'full' }
        ]
    },
    {
        path: 'susComercio',
        children: [
            { path: 'inicioSusc', component: InicioSuscripcionComponent },
            { path: '', redirectTo: 'inicioSusc', pathMatch: 'full' }
        ]
    },
    { path: 'listTokenSusCom', component: TokenSuscripcionComponent }
];
var AdquirienteWebRoutingModule = /** @class */ (function () {
    function AdquirienteWebRoutingModule() {
    }
    AdquirienteWebRoutingModule.decorators = [
        { type: NgModule, args: [{
                    imports: [RouterModule.forChild(adquirienteRoutes)],
                    exports: [RouterModule]
                },] }
    ];
    return AdquirienteWebRoutingModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NoCaracEspDirective = /** @class */ (function () {
    function NoCaracEspDirective(_el) {
        this._el = _el;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    NoCaracEspDirective.prototype.onInputChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var initalValue = this._el.nativeElement.value;
        this._el.nativeElement.value = initalValue.replace(/[^a-zA-Z0-9À-ÿ\._ ]*/g, '');
        if (initalValue !== this._el.nativeElement.value) {
            event.stopPropagation();
        }
    };
    NoCaracEspDirective.decorators = [
        { type: Directive, args: [{
                    selector: 'input[noCaracEsp]'
                },] }
    ];
    /** @nocollapse */
    NoCaracEspDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    NoCaracEspDirective.propDecorators = {
        onInputChange: [{ type: HostListener, args: ['input', ['$event'],] }]
    };
    return NoCaracEspDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SoloRutDirective = /** @class */ (function () {
    function SoloRutDirective(elem) {
        this.elem = elem;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    SoloRutDirective.prototype.onInputChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var initalValue = this.elem.nativeElement.value;
        this.elem.nativeElement.value = initalValue.replace(/[^0-9kK]*/g, '');
        if (initalValue !== this.elem.nativeElement.value) {
            event.stopPropagation();
        }
    };
    SoloRutDirective.decorators = [
        { type: Directive, args: [{
                    selector: 'input[soloRut]'
                },] }
    ];
    /** @nocollapse */
    SoloRutDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    SoloRutDirective.propDecorators = {
        onInputChange: [{ type: HostListener, args: ['input', ['$event'],] }]
    };
    return SoloRutDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DemoMaterialModule = /** @class */ (function () {
    function DemoMaterialModule() {
    }
    DemoMaterialModule.decorators = [
        { type: NgModule, args: [{
                    exports: [
                        CdkTableModule,
                        MatAutocompleteModule,
                        MatButtonModule,
                        MatButtonToggleModule,
                        MatCardModule,
                        MatCheckboxModule,
                        MatChipsModule,
                        MatStepperModule,
                        MatDatepickerModule,
                        MatDialogModule,
                        MatDividerModule,
                        MatExpansionModule,
                        MatGridListModule,
                        MatIconModule,
                        MatInputModule,
                        MatListModule,
                        MatMenuModule,
                        MatNativeDateModule,
                        MatPaginatorModule,
                        MatProgressBarModule,
                        MatProgressSpinnerModule,
                        MatRadioModule,
                        MatRippleModule,
                        MatSelectModule,
                        MatSidenavModule,
                        MatSliderModule,
                        MatSlideToggleModule,
                        MatSnackBarModule,
                        MatSortModule,
                        MatTableModule,
                        MatTabsModule,
                        MatToolbarModule,
                        MatTooltipModule,
                        MatFormFieldModule,
                        MatTreeModule,
                        Ng2Rut
                    ],
                    declarations: []
                },] }
    ];
    return DemoMaterialModule;
}());
var ModuloAdquirienteWebModule = /** @class */ (function () {
    function ModuloAdquirienteWebModule() {
    }
    /**
     * @param {?} environment
     * @return {?}
     */
    ModuloAdquirienteWebModule.forRoot = /**
     * @param {?} environment
     * @return {?}
     */
    function (environment) {
        return {
            ngModule: ModuloAdquirienteWebModule,
            providers: [
                {
                    provide: 'env',
                    useValue: environment
                },
                ConveniosAgregarService,
                ServicesBaseService,
                PerfilesService,
                CiudadService,
                EmpresasService,
                { provide: MatPaginatorIntl, useValue: getEsPaginatorIntl() }
            ]
        };
    };
    ModuloAdquirienteWebModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ModuloAdquirienteWebComponent,
                        MonedaStr,
                        CantidadStr,
                        ReportePagosComponent,
                        AdminProcesosComponent,
                        AdminProcesosDetallesComponent,
                        FacturacionComponent,
                        FacturacionHistorialComponent,
                        LstCobrosComponent,
                        ListCobrosDetallesComponent,
                        LstDescargaComponent,
                        FacturacionHistorialDetalleComponent,
                        FacturacionMenuComponent,
                        MandatosComponent,
                        MandatosHistorialComponent,
                        MandatosHistorialDetalleComponent,
                        MandatosMenuComponent,
                        ConveniosComponent,
                        ConveniosAgregarComponent,
                        ConveniosPagoComponent,
                        ConveniosIntercambioComponent,
                        ConveniosGraficaComponent,
                        ConveniosEditarAgregarComponent,
                        ConveniosEditarPagoComponent,
                        ConveniosEditarIntercambioComponent,
                        ConveniosEditarGraficaComponent,
                        AutorizacionesComponent,
                        AutorizacionConfiguracionComponent,
                        AutorizacionMenuComponent,
                        AutorizacionAutorizadoresComponent,
                        LstMandatosComponent,
                        ListMandatosDetallesComponent,
                        SegmandatosComponent,
                        DashboardComponent,
                        DashboardAdquirenteComponent,
                        EmpresasAgregarComponent,
                        EmpresasEditarComponent,
                        NumberDirective,
                        AuditoriaComponent,
                        AuditoriaDetalleComponent,
                        LstUsuariosComponent,
                        CrearCuentaDatosComponent,
                        EditarCuentaDatosComponent,
                        FacturacionReutilizarComponent,
                        FacturacionReutilizarDetalleComponent,
                        PoliticaListComponent,
                        PoliticaAddComponent,
                        PoliticaUpdComponent,
                        DialogBaseComponent,
                        DialogReutilizarFacturaComponent,
                        LoadingBaseComponent,
                        PerfilesListComponent,
                        PerfilesListEmpComponent,
                        PerfilesAddComponent,
                        PerfilesUpdComponent,
                        LstUsuariosEmpComponent,
                        DialogToUserEmpComponent,
                        EmpresasListarComponent,
                        DialogImagenComponent,
                        NoCaracEspDirective,
                        AutorizacionesConfigAgregarComponent,
                        AutorizacionesConfigEditarComponent,
                        AutorizacionesAutorizadoresEditarComponent,
                        AutorizacionesAutorizadoresAgregarComponent,
                        AutorizacionesDetallesComponent,
                        SoloRutDirective,
                        NumberMonedasStr,
                        InicioSuscripcionComponent,
                        TokenSuscripcionComponent
                    ],
                    imports: [
                        CommonModule,
                        NgbModule,
                        DigitOnlyModule,
                        FormsModule,
                        DemoMaterialModule,
                        MatNativeDateModule,
                        ReactiveFormsModule,
                        AdquirienteWebRoutingModule,
                        NgxChartsWebModule,
                        NgxChartsModule,
                        Ng2Rut,
                        SatDatepickerModule, SatNativeDateModule,
                        NgxDaterangepickerMd.forRoot()
                    ],
                    exports: [ModuloAdquirienteWebComponent],
                    providers: [Globals, EmpresaParams, UsuarioParamsService],
                    entryComponents: [DialogBaseComponent, LoadingBaseComponent, DialogImagenComponent, DialogToUserEmpComponent, DialogReutilizarFacturaComponent],
                },] }
    ];
    return ModuloAdquirienteWebModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ModuloAdquirienteWebComponent, DemoMaterialModule, ModuloAdquirienteWebModule, MandatosComponent as ɵz, MandatosHistorialComponent as ɵba, MandatosHistorialDetalleComponent as ɵbb, MandatosMenuComponent as ɵbc, AuditoriaComponent as ɵcj, AuditoriaDetalleComponent as ɵcl, AutorizacionMenuComponent as ɵbt, AutorizacionesAutorizadoresAgregarComponent as ɵdp, AutorizacionesAutorizadoresEditarComponent as ɵdo, AutorizacionAutorizadoresComponent as ɵbu, AutorizacionesConfigAgregarComponent as ɵdm, AutorizacionesConfigEditarComponent as ɵdn, AutorizacionConfiguracionComponent as ɵbr, AutorizacionesDetallesComponent as ɵdq, AutorizacionesComponent as ɵbp, ListCobrosDetallesComponent as ɵt, LstCobrosComponent as ɵs, ConveniosAgregarComponent as ɵbg, ConveniosEditarAgregarComponent as ɵbl, ConveniosEditarGraficaComponent as ɵbo, ConveniosEditarIntercambioComponent as ɵbn, ConveniosEditarPagoComponent as ɵbm, ConveniosGraficaComponent as ɵbk, ConveniosIntercambioComponent as ɵbj, ConveniosPagoComponent as ɵbi, ConveniosComponent as ɵbd, DashboardComponent as ɵcc, DashboardAdquirenteComponent as ɵce, LstDescargaComponent as ɵv, DialogBaseComponent as ɵda, DialogImagenComponent as ɵdk, DialogReutilizarFacturaComponent as ɵdb, DialogToUserEmpComponent as ɵdi, LoadingBaseComponent as ɵdc, EmpresasAgregarComponent as ɵcf, EmpresasEditarComponent as ɵch, EmpresasListarComponent as ɵdj, FacturacionComponent as ɵp, FacturacionHistorialComponent as ɵr, FacturacionHistorialDetalleComponent as ɵx, FacturacionMenuComponent as ɵy, FacturacionReutilizarComponent as ɵcs, FacturacionReutilizarDetalleComponent as ɵcu, InicioSuscripcionComponent as ɵds, LstMandatosComponent as ɵbw, ListMandatosDetallesComponent as ɵby, PerfilesAddComponent as ɵdf, PerfilesListEmpComponent as ɵde, PerfilesListComponent as ɵdd, PerfilesUpdComponent as ɵdg, PoliticaAddComponent as ɵcy, PoliticaListComponent as ɵcw, PoliticaUpdComponent as ɵcz, AdminProcesosComponent as ɵl, AdminProcesosDetallesComponent as ɵo, ReportePagosComponent as ɵd, SegmandatosComponent as ɵcb, TokenSuscripcionComponent as ɵdu, CrearCuentaDatosComponent as ɵcq, EditarCuentaDatosComponent as ɵcr, LstUsuariosEmpComponent as ɵdh, LstUsuariosComponent as ɵcm, CantidadStr as ɵb, MonedaStr as ɵa, NumberMonedasStr as ɵc, getEsPaginatorIntl as ɵdx, Globals as ɵn, MY_FORMATS as ɵcv, NoCaracEspDirective as ɵdl, NumberDirective as ɵci, SoloRutDirective as ɵdr, AutorizacionDetalle as ɵbq, AutorizadoresParams as ɵbv, ConfiguracionParams as ɵbs, EmpresaParams as ɵcg, FacturacionReutilizarParams as ɵct, UsuarioParamsService as ɵcp, AdquirienteWebRoutingModule as ɵdw, AuditoriaService as ɵck, AutorizacionesService as ɵbh, listCobroDetalleService as ɵu, ConveniosAgregarService as ɵbf, ConveniosService as ɵbe, DashboardService as ɵcd, DescargaExcelPdfFileService as ɵf, listDescargaService as ɵw, EmpresasService as ɵg, FacturacionHistorialService as ɵk, FileUploadService as ɵq, InicioSuscripcionService as ɵdt, listMandatoService as ɵbx, ListMandatoDetalleService as ɵbz, PerfilesService as ɵco, PoliticaService as ɵcx, AdminProcesosService as ɵm, ReportePagoService as ɵe, SegmandatosService as ɵh, CiudadService as ɵca, LoaderBaseService as ɵi, ServicesBaseService as ɵj, TokenSuscripcionService as ɵdv, UsuariosService as ɵcn };

//# sourceMappingURL=modulo-adquiriente-web.js.map